import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export { PrivateKey, PublicKey } from "@textile/crypto";
import { Client } from "@textile/threads-client";
export { Client } from "@textile/threads-client";
import ThreadID from "@textile/threads-id";
export { ThreadID } from "@textile/threads-id";
import { defaultHost, Context } from "@textile/context";
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function getAugmentedNamespace(e) {
  if (e.__esModule) return e;
  var t = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(e).forEach(function (r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, o.get ? o : {
      enumerable: !0,
      get: function get() {
        return e[r];
      }
    });
  }), t;
}
function createCommonjsModule(e) {
  var t = {
    exports: {}
  };
  return e(t, t.exports), t.exports;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(e, t) {
  var r = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var n = 0;
    for (o = Object.getOwnPropertySymbols(e); n < o.length; n++) t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (r[o[n]] = e[o[n]]);
  }
  return r;
}
function __awaiter(e, t, r, o) {
  return new (r || (r = Promise))(function (n, a) {
    function i(e) {
      try {
        u(o.next(e));
      } catch (e) {
        a(e);
      }
    }
    function s(e) {
      try {
        u(o.throw(e));
      } catch (e) {
        a(e);
      }
    }
    function u(e) {
      var t;
      e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(i, s);
    }
    u((o = o.apply(e, t || [])).next());
  });
}
function createError(e) {
  var t = new Error(e);
  return t.source = "ulid", t;
}
createCommonjsModule(function (e) {
  var t = function (e) {
    var t,
      r = Object.prototype,
      o = r.hasOwnProperty,
      n = "function" == typeof Symbol ? Symbol : {},
      a = n.iterator || "@@iterator",
      i = n.asyncIterator || "@@asyncIterator",
      s = n.toStringTag || "@@toStringTag";
    function u(e, t, r) {
      return Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }
    try {
      u({}, "");
    } catch (e) {
      u = function u(e, t, r) {
        return e[t] = r;
      };
    }
    function l(e, t, r, o) {
      var n = t && t.prototype instanceof y ? t : y,
        a = Object.create(n.prototype),
        i = new D(o || []);
      return a._invoke = function (e, t, r) {
        var o = p;
        return function (n, a) {
          if (o === d) throw new Error("Generator is already running");
          if (o === f) {
            if ("throw" === n) throw a;
            return I();
          }
          for (r.method = n, r.arg = a;;) {
            var i = r.delegate;
            if (i) {
              var s = T(i, r);
              if (s) {
                if (s === h) continue;
                return s;
              }
            }
            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (o === p) throw o = f, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            o = d;
            var u = c(e, t, r);
            if ("normal" === u.type) {
              if (o = r.done ? f : g, u.arg === h) continue;
              return {
                value: u.arg,
                done: r.done
              };
            }
            "throw" === u.type && (o = f, r.method = "throw", r.arg = u.arg);
          }
        };
      }(e, r, i), a;
    }
    function c(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }
    e.wrap = l;
    var p = "suspendedStart",
      g = "suspendedYield",
      d = "executing",
      f = "completed",
      h = {};
    function y() {}
    function b() {}
    function m() {}
    var _ = {};
    _[a] = function () {
      return this;
    };
    var v = Object.getPrototypeOf,
      E = v && v(v(O([])));
    E && E !== r && o.call(E, a) && (_ = E);
    var S = m.prototype = y.prototype = Object.create(_);
    function R(e) {
      ["next", "throw", "return"].forEach(function (t) {
        u(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }
    function w(e, t) {
      function r(n, a, i, s) {
        var u = c(e[n], e, a);
        if ("throw" !== u.type) {
          var l = u.arg,
            p = l.value;
          return p && "object" == typeof p && o.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
            r("next", e, i, s);
          }, function (e) {
            r("throw", e, i, s);
          }) : t.resolve(p).then(function (e) {
            l.value = e, i(l);
          }, function (e) {
            return r("throw", e, i, s);
          });
        }
        s(u.arg);
      }
      var n;
      this._invoke = function (e, o) {
        function a() {
          return new t(function (t, n) {
            r(e, o, t, n);
          });
        }
        return n = n ? n.then(a, a) : a();
      };
    }
    function T(e, r) {
      var o = e.iterator[r.method];
      if (o === t) {
        if (r.delegate = null, "throw" === r.method) {
          if (e.iterator.return && (r.method = "return", r.arg = t, T(e, r), "throw" === r.method)) return h;
          r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return h;
      }
      var n = c(o, e.iterator, r.arg);
      if ("throw" === n.type) return r.method = "throw", r.arg = n.arg, r.delegate = null, h;
      var a = n.arg;
      return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, h) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, h);
    }
    function P(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }
    function A(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }
    function D(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(P, this), this.reset(!0);
    }
    function O(e) {
      if (e) {
        var r = e[a];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var n = -1,
            i = function r() {
              for (; ++n < e.length;) if (o.call(e, n)) return r.value = e[n], r.done = !1, r;
              return r.value = t, r.done = !0, r;
            };
          return i.next = i;
        }
      }
      return {
        next: I
      };
    }
    function I() {
      return {
        value: t,
        done: !0
      };
    }
    return b.prototype = S.constructor = m, m.constructor = b, b.displayName = u(m, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : (e.__proto__ = m, u(e, s, "GeneratorFunction")), e.prototype = Object.create(S), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, R(w.prototype), w.prototype[i] = function () {
      return this;
    }, e.AsyncIterator = w, e.async = function (t, r, o, n, a) {
      void 0 === a && (a = Promise);
      var i = new w(l(t, r, o, n), a);
      return e.isGeneratorFunction(r) ? i : i.next().then(function (e) {
        return e.done ? e.value : i.next();
      });
    }, R(S), u(S, s, "Generator"), S[a] = function () {
      return this;
    }, S.toString = function () {
      return "[object Generator]";
    }, e.keys = function (e) {
      var t = [];
      for (var r in e) t.push(r);
      return t.reverse(), function r() {
        for (; t.length;) {
          var o = t.pop();
          if (o in e) return r.value = o, r.done = !1, r;
        }
        return r.done = !0, r;
      };
    }, e.values = O, D.prototype = {
      constructor: D,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(A), !e) for (var r in this) "t" === r.charAt(0) && o.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var r = this;
        function n(o, n) {
          return s.type = "throw", s.arg = e, r.next = o, n && (r.method = "next", r.arg = t), !!n;
        }
        for (var a = this.tryEntries.length - 1; a >= 0; --a) {
          var i = this.tryEntries[a],
            s = i.completion;
          if ("root" === i.tryLoc) return n("end");
          if (i.tryLoc <= this.prev) {
            var u = o.call(i, "catchLoc"),
              l = o.call(i, "finallyLoc");
            if (u && l) {
              if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return n(i.finallyLoc);
            } else if (u) {
              if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
            } else {
              if (!l) throw new Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return n(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var n = this.tryEntries[r];
          if (n.tryLoc <= this.prev && o.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
            var a = n;
            break;
          }
        }
        a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
        var i = a ? a.completion : {};
        return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, h) : this.complete(i);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), A(r), h;
        }
      },
      catch: function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.tryLoc === e) {
            var o = r.completion;
            if ("throw" === o.type) {
              var n = o.arg;
              A(r);
            }
            return n;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, r, o) {
        return this.delegate = {
          iterator: O(e),
          resultName: r,
          nextLoc: o
        }, "next" === this.method && (this.arg = t), h;
      }
    }, e;
  }(e.exports);
  try {
    regeneratorRuntime = t;
  } catch (e) {
    Function("r", "regeneratorRuntime = r")(t);
  }
});
var ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ",
  ENCODING_LEN = ENCODING.length,
  TIME_MAX = Math.pow(2, 48) - 1,
  TIME_LEN = 10,
  RANDOM_LEN = 16;
function randomChar(e) {
  var t = Math.floor(e() * ENCODING_LEN);
  return t === ENCODING_LEN && (t = ENCODING_LEN - 1), ENCODING.charAt(t);
}
function encodeTime(e, t) {
  if (isNaN(e)) throw new Error(e + " must be a number");
  if (e > TIME_MAX) throw createError("cannot encode time greater than " + TIME_MAX);
  if (e < 0) throw createError("time must be positive");
  if (!1 === Number.isInteger(e)) throw createError("time must be an integer");
  for (var r = void 0, o = ""; t > 0; t--) r = e % ENCODING_LEN, o = ENCODING.charAt(r) + o, e = (e - r) / ENCODING_LEN;
  return o;
}
function encodeRandom(e, t) {
  for (var r = ""; e > 0; e--) r = randomChar(t) + r;
  return r;
}
function detectPrng() {
  var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
    t = arguments[1];
  t || (t = "undefined" != typeof window ? window : null);
  var r = t && (t.crypto || t.msCrypto);
  if (r) return function () {
    var e = new Uint8Array(1);
    return r.getRandomValues(e), e[0] / 255;
  };
  try {
    var o = require("crypto");
    return function () {
      return o.randomBytes(1).readUInt8() / 255;
    };
  } catch (e) {}
  if (e) {
    try {
      console.error("secure crypto unusable, falling back to insecure Math.random()!");
    } catch (e) {}
    return function () {
      return Math.random();
    };
  }
  throw createError("secure crypto unusable, insecure Math.random not allowed");
}
function factory(e) {
  return e || (e = detectPrng()), function (t) {
    return isNaN(t) && (t = Date.now()), encodeTime(t, TIME_LEN) + encodeRandom(RANDOM_LEN, e);
  };
}
var ulid = factory();
function DocumentInstanceClassFactory(e) {
  return /*#__PURE__*/function () {
    function _class() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, _class);
      return Object.assign(this, Object.assign({
        _id: ulid()
      }, e));
    }
    _createClass(_class, [{
      key: "save",
      value: function save() {
        return e.put(Object.assign({}, this));
      }
    }, {
      key: "remove",
      value: function remove() {
        return e.delete(this._id);
      }
    }, {
      key: "exists",
      value: function exists() {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = void 0;
                _context.next = 3;
                return e.get(this._id);
              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt("return", _context.t0 !== _context.t1);
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return Object.assign({}, this);
      }
    }]);
    return _class;
  }();
}
var Collection = /*#__PURE__*/function () {
  function Collection(e) {
    _classCallCheck(this, Collection);
    this.table = e, this.table.mapToClass(DocumentInstanceClassFactory(e));
  }
  _createClass(Collection, [{
    key: "name",
    get: function get() {
      return this.table.name;
    }
  }, {
    key: "clear",
    value: function clear() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$this$table$dro, e;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.table.drop();
            case 2:
              _yield$this$table$dro = _context2.sent;
              e = _yield$this$table$dro.result;
              return _context2.abrupt("return", e.ok > 0);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "readTransaction",
    value: function readTransaction(e) {
      return this.table.db.transaction("readonly", [this.table], e);
    }
  }, {
    key: "writeTransaction",
    value: function writeTransaction(e) {
      return this.table.db.transaction("readwrite", [this.table], e);
    }
  }, {
    key: "findById",
    value: function findById(e) {
      return this.table.get(e);
    }
  }, {
    key: "insert",
    value: function insert() {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.table.bulkAdd(e, {
                allKeys: !0
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "create",
    value: function create(e) {
      return new (0, this.table.schema.mappedClass)(e);
    }
  }, {
    key: "delete",
    value: function _delete() {
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.table.bulkDelete(e);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "save",
    value: function save() {
      for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        e[_key3] = arguments[_key3];
      }
      return this.table.bulkPut(e, {
        allKeys: !0
      });
    }
  }, {
    key: "has",
    value: function has() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var t;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.table.bulkGet(e);
            case 2:
              t = _context5.sent;
              return _context5.abrupt("return", Boolean(t.length) && void 0 !== t[0]);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "find",
    value: function find(e) {
      return this.table.find(e);
    }
  }, {
    key: "findOne",
    value: function findOne(e) {
      return this.table.findOne(e);
    }
  }, {
    key: "count",
    value: function count(e) {
      return this.table.count(e);
    }
  }]);
  return Collection;
}();
var grpcWebClient_umd = createCommonjsModule(function (e, t) {
    e.exports = function () {
      return e = {
        84: function _(e) {
          var t;
          t = function t() {
            return function (e) {
              var t = {};
              function r(o) {
                if (t[o]) return t[o].exports;
                var n = t[o] = {
                  i: o,
                  l: !1,
                  exports: {}
                };
                return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
              }
              return r.m = e, r.c = t, r.i = function (e) {
                return e;
              }, r.d = function (e, t, o) {
                r.o(e, t) || Object.defineProperty(e, t, {
                  configurable: !1,
                  enumerable: !0,
                  get: o
                });
              }, r.n = function (e) {
                var t = e && e.__esModule ? function () {
                  return e.default;
                } : function () {
                  return e;
                };
                return r.d(t, "a", t), t;
              }, r.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              }, r.p = "", r(r.s = 1);
            }([function (e, t, r) {
              Object.defineProperty(t, "__esModule", {
                value: !0
              });
              var o = r(3),
                n = function () {
                  function e(e, t) {
                    void 0 === e && (e = {}), void 0 === t && (t = {
                      splitValues: !1
                    });
                    var r,
                      n = this;
                    this.headersMap = {}, e && ("undefined" != typeof Headers && e instanceof Headers ? o.getHeaderKeys(e).forEach(function (r) {
                      o.getHeaderValues(e, r).forEach(function (e) {
                        t.splitValues ? n.append(r, o.splitHeaderValue(e)) : n.append(r, e);
                      });
                    }) : "object" == typeof (r = e) && "object" == typeof r.headersMap && "function" == typeof r.forEach ? e.forEach(function (e, t) {
                      n.append(e, t);
                    }) : "undefined" != typeof Map && e instanceof Map ? e.forEach(function (e, t) {
                      n.append(t, e);
                    }) : "string" == typeof e ? this.appendFromString(e) : "object" == typeof e && Object.getOwnPropertyNames(e).forEach(function (t) {
                      var r = e[t];
                      Array.isArray(r) ? r.forEach(function (e) {
                        n.append(t, e);
                      }) : n.append(t, r);
                    }));
                  }
                  return e.prototype.appendFromString = function (e) {
                    for (var t = e.split("\r\n"), r = 0; r < t.length; r++) {
                      var o = t[r],
                        n = o.indexOf(":");
                      if (n > 0) {
                        var a = o.substring(0, n).trim(),
                          i = o.substring(n + 1).trim();
                        this.append(a, i);
                      }
                    }
                  }, e.prototype.delete = function (e, t) {
                    var r = o.normalizeName(e);
                    if (void 0 === t) delete this.headersMap[r];else {
                      var n = this.headersMap[r];
                      if (n) {
                        var a = n.indexOf(t);
                        a >= 0 && n.splice(a, 1), 0 === n.length && delete this.headersMap[r];
                      }
                    }
                  }, e.prototype.append = function (e, t) {
                    var r = this,
                      n = o.normalizeName(e);
                    Array.isArray(this.headersMap[n]) || (this.headersMap[n] = []), Array.isArray(t) ? t.forEach(function (e) {
                      r.headersMap[n].push(o.normalizeValue(e));
                    }) : this.headersMap[n].push(o.normalizeValue(t));
                  }, e.prototype.set = function (e, t) {
                    var r = o.normalizeName(e);
                    if (Array.isArray(t)) {
                      var n = [];
                      t.forEach(function (e) {
                        n.push(o.normalizeValue(e));
                      }), this.headersMap[r] = n;
                    } else this.headersMap[r] = [o.normalizeValue(t)];
                  }, e.prototype.has = function (e, t) {
                    var r = this.headersMap[o.normalizeName(e)];
                    if (!Array.isArray(r)) return !1;
                    if (void 0 !== t) {
                      var n = o.normalizeValue(t);
                      return r.indexOf(n) >= 0;
                    }
                    return !0;
                  }, e.prototype.get = function (e) {
                    var t = this.headersMap[o.normalizeName(e)];
                    return void 0 !== t ? t.concat() : [];
                  }, e.prototype.forEach = function (e) {
                    var t = this;
                    Object.getOwnPropertyNames(this.headersMap).forEach(function (r) {
                      e(r, t.headersMap[r]);
                    }, this);
                  }, e.prototype.toHeaders = function () {
                    if ("undefined" != typeof Headers) {
                      var e = new Headers();
                      return this.forEach(function (t, r) {
                        r.forEach(function (r) {
                          e.append(t, r);
                        });
                      }), e;
                    }
                    throw new Error("Headers class is not defined");
                  }, e;
                }();
              t.BrowserHeaders = n;
            }, function (e, t, r) {
              Object.defineProperty(t, "__esModule", {
                value: !0
              });
              var o = r(0);
              t.BrowserHeaders = o.BrowserHeaders;
            }, function (e, t, r) {
              Object.defineProperty(t, "__esModule", {
                value: !0
              }), t.iterateHeaders = function (e, t) {
                for (var r = e[Symbol.iterator](), o = r.next(); !o.done;) t(o.value[0]), o = r.next();
              }, t.iterateHeadersKeys = function (e, t) {
                for (var r = e.keys(), o = r.next(); !o.done;) t(o.value), o = r.next();
              };
            }, function (e, t, r) {
              Object.defineProperty(t, "__esModule", {
                value: !0
              });
              var o = r(2);
              t.normalizeName = function (e) {
                if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
                return e.toLowerCase();
              }, t.normalizeValue = function (e) {
                return "string" != typeof e && (e = String(e)), e;
              }, t.getHeaderValues = function (e, t) {
                var r = e;
                if (r instanceof Headers && r.getAll) return r.getAll(t);
                var o = r.get(t);
                return o && "string" == typeof o ? [o] : o;
              }, t.getHeaderKeys = function (e) {
                var t = e,
                  r = {},
                  n = [];
                return t.keys ? o.iterateHeadersKeys(t, function (e) {
                  r[e] || (r[e] = !0, n.push(e));
                }) : t.forEach ? t.forEach(function (e, t) {
                  r[t] || (r[t] = !0, n.push(t));
                }) : o.iterateHeaders(t, function (e) {
                  var t = e[0];
                  r[t] || (r[t] = !0, n.push(t));
                }), n;
              }, t.splitHeaderValue = function (e) {
                var t = [];
                return e.split(", ").forEach(function (e) {
                  e.split(",").forEach(function (e) {
                    t.push(e);
                  });
                }), t;
              };
            }]);
          }, e.exports = t();
        },
        617: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.ChunkParser = t.ChunkType = t.encodeASCII = t.decodeASCII = void 0;
          var o,
            n = r(65);
          function a(e) {
            return 9 === (t = e) || 10 === t || 13 === t || e >= 32 && e <= 126;
            var t;
          }
          function i(e) {
            for (var t = 0; t !== e.length; ++t) if (!a(e[t])) throw new Error("Metadata is not valid (printable) ASCII");
            return String.fromCharCode.apply(String, Array.prototype.slice.call(e));
          }
          function s(e) {
            return 128 == (128 & e.getUint8(0));
          }
          function u(e) {
            return e.getUint32(1, !1);
          }
          function l(e, t, r) {
            return e.byteLength - t >= r;
          }
          function c(e, t, r) {
            if (e.slice) return e.slice(t, r);
            var o = e.length;
            void 0 !== r && (o = r);
            for (var n = new Uint8Array(o - t), a = 0, i = t; i < o; i++) n[a++] = e[i];
            return n;
          }
          t.decodeASCII = i, t.encodeASCII = function (e) {
            for (var t = new Uint8Array(e.length), r = 0; r !== e.length; ++r) {
              var o = e.charCodeAt(r);
              if (!a(o)) throw new Error("Metadata contains invalid ASCII");
              t[r] = o;
            }
            return t;
          }, function (e) {
            e[e.MESSAGE = 1] = "MESSAGE", e[e.TRAILERS = 2] = "TRAILERS";
          }(o = t.ChunkType || (t.ChunkType = {}));
          var p = function () {
            function e() {
              this.buffer = null, this.position = 0;
            }
            return e.prototype.parse = function (e, t) {
              if (0 === e.length && t) return [];
              var r,
                a = [];
              if (null == this.buffer) this.buffer = e, this.position = 0;else if (this.position === this.buffer.byteLength) this.buffer = e, this.position = 0;else {
                var p = this.buffer.byteLength - this.position,
                  g = new Uint8Array(p + e.byteLength),
                  d = c(this.buffer, this.position);
                g.set(d, 0);
                var f = new Uint8Array(e);
                g.set(f, p), this.buffer = g, this.position = 0;
              }
              for (;;) {
                if (!l(this.buffer, this.position, 5)) return a;
                var h = c(this.buffer, this.position, this.position + 5),
                  y = new DataView(h.buffer, h.byteOffset, h.byteLength),
                  b = u(y);
                if (!l(this.buffer, this.position, 5 + b)) return a;
                var m = c(this.buffer, this.position + 5, this.position + 5 + b);
                if (this.position += 5 + b, s(y)) return a.push({
                  chunkType: o.TRAILERS,
                  trailers: (r = m, new n.Metadata(i(r)))
                }), a;
                a.push({
                  chunkType: o.MESSAGE,
                  data: m
                });
              }
            }, e;
          }();
          t.ChunkParser = p;
        },
        8: function _(e, t) {
          var r;
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.httpStatusToCode = t.Code = void 0, function (e) {
            e[e.OK = 0] = "OK", e[e.Canceled = 1] = "Canceled", e[e.Unknown = 2] = "Unknown", e[e.InvalidArgument = 3] = "InvalidArgument", e[e.DeadlineExceeded = 4] = "DeadlineExceeded", e[e.NotFound = 5] = "NotFound", e[e.AlreadyExists = 6] = "AlreadyExists", e[e.PermissionDenied = 7] = "PermissionDenied", e[e.ResourceExhausted = 8] = "ResourceExhausted", e[e.FailedPrecondition = 9] = "FailedPrecondition", e[e.Aborted = 10] = "Aborted", e[e.OutOfRange = 11] = "OutOfRange", e[e.Unimplemented = 12] = "Unimplemented", e[e.Internal = 13] = "Internal", e[e.Unavailable = 14] = "Unavailable", e[e.DataLoss = 15] = "DataLoss", e[e.Unauthenticated = 16] = "Unauthenticated";
          }(r = t.Code || (t.Code = {})), t.httpStatusToCode = function (e) {
            switch (e) {
              case 0:
                return r.Internal;
              case 200:
                return r.OK;
              case 400:
                return r.InvalidArgument;
              case 401:
                return r.Unauthenticated;
              case 403:
                return r.PermissionDenied;
              case 404:
                return r.NotFound;
              case 409:
                return r.Aborted;
              case 412:
                return r.FailedPrecondition;
              case 429:
                return r.ResourceExhausted;
              case 499:
                return r.Canceled;
              case 500:
                return r.Unknown;
              case 501:
                return r.Unimplemented;
              case 503:
                return r.Unavailable;
              case 504:
                return r.DeadlineExceeded;
              default:
                return r.Unknown;
            }
          };
        },
        934: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.client = void 0;
          var o = r(65),
            n = r(617),
            a = r(8),
            i = r(346),
            s = r(57),
            u = r(882);
          t.client = function (e, t) {
            return new l(e, t);
          };
          var l = function () {
            function e(e, t) {
              this.started = !1, this.sentFirstMessage = !1, this.completed = !1, this.closed = !1, this.finishedSending = !1, this.onHeadersCallbacks = [], this.onMessageCallbacks = [], this.onEndCallbacks = [], this.parser = new n.ChunkParser(), this.methodDefinition = e, this.props = t, this.createTransport();
            }
            return e.prototype.createTransport = function () {
              var e = this.props.host + "/" + this.methodDefinition.service.serviceName + "/" + this.methodDefinition.methodName,
                t = {
                  methodDefinition: this.methodDefinition,
                  debug: this.props.debug || !1,
                  url: e,
                  onHeaders: this.onTransportHeaders.bind(this),
                  onChunk: this.onTransportChunk.bind(this),
                  onEnd: this.onTransportEnd.bind(this)
                };
              this.props.transport ? this.transport = this.props.transport(t) : this.transport = s.makeDefaultTransport(t);
            }, e.prototype.onTransportHeaders = function (e, t) {
              if (this.props.debug && i.debug("onHeaders", e, t), this.closed) this.props.debug && i.debug("grpc.onHeaders received after request was closed - ignoring");else if (0 === t) ;else {
                this.responseHeaders = e, this.props.debug && i.debug("onHeaders.responseHeaders", JSON.stringify(this.responseHeaders, null, 2));
                var r = c(e);
                this.props.debug && i.debug("onHeaders.gRPCStatus", r);
                var o = r && r >= 0 ? r : a.httpStatusToCode(t);
                this.props.debug && i.debug("onHeaders.code", o);
                var n = e.get("grpc-message") || [];
                if (this.props.debug && i.debug("onHeaders.gRPCMessage", n), this.rawOnHeaders(e), o !== a.Code.OK) {
                  var s = this.decodeGRPCStatus(n[0]);
                  this.rawOnError(o, s, e);
                }
              }
            }, e.prototype.onTransportChunk = function (e) {
              var t = this;
              if (this.closed) this.props.debug && i.debug("grpc.onChunk received after request was closed - ignoring");else {
                var r = [];
                try {
                  r = this.parser.parse(e);
                } catch (e) {
                  return this.props.debug && i.debug("onChunk.parsing error", e, e.message), void this.rawOnError(a.Code.Internal, "parsing error: " + e.message);
                }
                r.forEach(function (e) {
                  if (e.chunkType === n.ChunkType.MESSAGE) {
                    var r = t.methodDefinition.responseType.deserializeBinary(e.data);
                    t.rawOnMessage(r);
                  } else e.chunkType === n.ChunkType.TRAILERS && (t.responseHeaders ? (t.responseTrailers = new o.Metadata(e.trailers), t.props.debug && i.debug("onChunk.trailers", t.responseTrailers)) : (t.responseHeaders = new o.Metadata(e.trailers), t.rawOnHeaders(t.responseHeaders)));
                });
              }
            }, e.prototype.onTransportEnd = function () {
              if (this.props.debug && i.debug("grpc.onEnd"), this.closed) this.props.debug && i.debug("grpc.onEnd received after request was closed - ignoring");else if (void 0 !== this.responseTrailers) {
                var e = c(this.responseTrailers);
                if (null !== e) {
                  var t = this.responseTrailers.get("grpc-message"),
                    r = this.decodeGRPCStatus(t[0]);
                  this.rawOnEnd(e, r, this.responseTrailers);
                } else this.rawOnError(a.Code.Internal, "Response closed without grpc-status (Trailers provided)");
              } else {
                if (void 0 === this.responseHeaders) return void this.rawOnError(a.Code.Unknown, "Response closed without headers");
                var o = c(this.responseHeaders),
                  n = this.responseHeaders.get("grpc-message");
                if (this.props.debug && i.debug("grpc.headers only response ", o, n), null === o) return void this.rawOnEnd(a.Code.Unknown, "Response closed without grpc-status (Headers only)", this.responseHeaders);
                var s = this.decodeGRPCStatus(n[0]);
                this.rawOnEnd(o, s, this.responseHeaders);
              }
            }, e.prototype.decodeGRPCStatus = function (e) {
              if (!e) return "";
              try {
                return decodeURIComponent(e);
              } catch (t) {
                return e;
              }
            }, e.prototype.rawOnEnd = function (e, t, r) {
              var o = this;
              this.props.debug && i.debug("rawOnEnd", e, t, r), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (n) {
                if (!o.closed) try {
                  n(e, t, r);
                } catch (e) {
                  setTimeout(function () {
                    throw e;
                  });
                }
              }));
            }, e.prototype.rawOnHeaders = function (e) {
              this.props.debug && i.debug("rawOnHeaders", e), this.completed || this.onHeadersCallbacks.forEach(function (t) {
                try {
                  t(e);
                } catch (e) {
                  setTimeout(function () {
                    throw e;
                  });
                }
              });
            }, e.prototype.rawOnError = function (e, t, r) {
              var n = this;
              void 0 === r && (r = new o.Metadata()), this.props.debug && i.debug("rawOnError", e, t), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (o) {
                if (!n.closed) try {
                  o(e, t, r);
                } catch (e) {
                  setTimeout(function () {
                    throw e;
                  });
                }
              }));
            }, e.prototype.rawOnMessage = function (e) {
              var t = this;
              this.props.debug && i.debug("rawOnMessage", e.toObject()), this.completed || this.closed || this.onMessageCallbacks.forEach(function (r) {
                if (!t.closed) try {
                  r(e);
                } catch (e) {
                  setTimeout(function () {
                    throw e;
                  });
                }
              });
            }, e.prototype.onHeaders = function (e) {
              this.onHeadersCallbacks.push(e);
            }, e.prototype.onMessage = function (e) {
              this.onMessageCallbacks.push(e);
            }, e.prototype.onEnd = function (e) {
              this.onEndCallbacks.push(e);
            }, e.prototype.start = function (e) {
              if (this.started) throw new Error("Client already started - cannot .start()");
              this.started = !0;
              var t = new o.Metadata(e || {});
              t.set("content-type", "application/grpc-web+proto"), t.set("x-grpc-web", "1"), this.transport.start(t);
            }, e.prototype.send = function (e) {
              if (!this.started) throw new Error("Client not started - .start() must be called before .send()");
              if (this.closed) throw new Error("Client already closed - cannot .send()");
              if (this.finishedSending) throw new Error("Client already finished sending - cannot .send()");
              if (!this.methodDefinition.requestStream && this.sentFirstMessage) throw new Error("Message already sent for non-client-streaming method - cannot .send()");
              this.sentFirstMessage = !0;
              var t = u.frameRequest(e);
              this.transport.sendMessage(t);
            }, e.prototype.finishSend = function () {
              if (!this.started) throw new Error("Client not started - .finishSend() must be called before .close()");
              if (this.closed) throw new Error("Client already closed - cannot .send()");
              if (this.finishedSending) throw new Error("Client already finished sending - cannot .finishSend()");
              this.finishedSending = !0, this.transport.finishSend();
            }, e.prototype.close = function () {
              if (!this.started) throw new Error("Client not started - .start() must be called before .close()");
              if (this.closed) throw new Error("Client already closed - cannot .close()");
              this.closed = !0, this.props.debug && i.debug("request.abort aborting request"), this.transport.cancel();
            }, e;
          }();
          function c(e) {
            var t = e.get("grpc-status") || [];
            if (t.length > 0) try {
              var r = t[0];
              return parseInt(r, 10);
            } catch (e) {
              return null;
            }
            return null;
          }
        },
        346: function _(e, t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.debug = void 0, t.debug = function () {
            for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
            console.debug ? console.debug.apply(null, e) : console.log.apply(null, e);
          };
        },
        607: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.grpc = void 0;
          var o,
            n = r(84),
            a = r(57),
            i = r(229),
            s = r(540),
            u = r(210),
            l = r(859),
            c = r(8),
            p = r(938),
            g = r(35),
            d = r(934);
          (o = t.grpc || (t.grpc = {})).setDefaultTransport = a.setDefaultTransportFactory, o.CrossBrowserHttpTransport = l.CrossBrowserHttpTransport, o.FetchReadableStreamTransport = i.FetchReadableStreamTransport, o.XhrTransport = u.XhrTransport, o.WebsocketTransport = s.WebsocketTransport, o.Code = c.Code, o.Metadata = n.BrowserHeaders, o.client = function (e, t) {
            return d.client(e, t);
          }, o.invoke = p.invoke, o.unary = g.unary;
        },
        938: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.invoke = void 0;
          var o = r(934);
          t.invoke = function (e, t) {
            if (e.requestStream) throw new Error(".invoke cannot be used with client-streaming methods. Use .client instead.");
            var r = o.client(e, {
              host: t.host,
              transport: t.transport,
              debug: t.debug
            });
            return t.onHeaders && r.onHeaders(t.onHeaders), t.onMessage && r.onMessage(t.onMessage), t.onEnd && r.onEnd(t.onEnd), r.start(t.metadata), r.send(t.request), r.finishSend(), {
              close: function close() {
                r.close();
              }
            };
          };
        },
        65: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Metadata = void 0;
          var o = r(84);
          Object.defineProperty(t, "Metadata", {
            enumerable: !0,
            get: function get() {
              return o.BrowserHeaders;
            }
          });
        },
        57: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.makeDefaultTransport = t.setDefaultTransportFactory = void 0;
          var o = r(859),
            n = function n(e) {
              return o.CrossBrowserHttpTransport({
                withCredentials: !1
              })(e);
            };
          t.setDefaultTransportFactory = function (e) {
            n = e;
          }, t.makeDefaultTransport = function (e) {
            return n(e);
          };
        },
        229: function _(e, t, r) {
          var o = this && this.__assign || function () {
            return (o = Object.assign || function (e) {
              for (var t, r = 1, o = arguments.length; r < o; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
              return e;
            }).apply(this, arguments);
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.detectFetchSupport = t.FetchReadableStreamTransport = void 0;
          var n = r(65),
            a = r(346);
          t.FetchReadableStreamTransport = function (e) {
            return function (t) {
              return function (e, t) {
                return e.debug && a.debug("fetchRequest", e), new i(e, t);
              }(t, e);
            };
          };
          var i = function () {
            function e(e, t) {
              this.cancelled = !1, this.controller = self.AbortController && new AbortController(), this.options = e, this.init = t;
            }
            return e.prototype.pump = function (e, t) {
              var r = this;
              if (this.reader = e, this.cancelled) return this.options.debug && a.debug("Fetch.pump.cancel at first pump"), void this.reader.cancel().catch(function (e) {
                r.options.debug && a.debug("Fetch.pump.reader.cancel exception", e);
              });
              this.reader.read().then(function (e) {
                if (e.done) return r.options.onEnd(), t;
                r.options.onChunk(e.value), r.pump(r.reader, t);
              }).catch(function (e) {
                r.cancelled ? r.options.debug && a.debug("Fetch.catch - request cancelled") : (r.cancelled = !0, r.options.debug && a.debug("Fetch.catch", e.message), r.options.onEnd(e));
              });
            }, e.prototype.send = function (e) {
              var t = this;
              fetch(this.options.url, o(o({}, this.init), {
                headers: this.metadata.toHeaders(),
                method: "POST",
                body: e,
                signal: this.controller && this.controller.signal
              })).then(function (e) {
                if (t.options.debug && a.debug("Fetch.response", e), t.options.onHeaders(new n.Metadata(e.headers), e.status), !e.body) return e;
                t.pump(e.body.getReader(), e);
              }).catch(function (e) {
                t.cancelled ? t.options.debug && a.debug("Fetch.catch - request cancelled") : (t.cancelled = !0, t.options.debug && a.debug("Fetch.catch", e.message), t.options.onEnd(e));
              });
            }, e.prototype.sendMessage = function (e) {
              this.send(e);
            }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
              this.metadata = e;
            }, e.prototype.cancel = function () {
              var e = this;
              this.cancelled ? this.options.debug && a.debug("Fetch.cancel already cancelled") : (this.cancelled = !0, this.controller ? (this.options.debug && a.debug("Fetch.cancel.controller.abort"), this.controller.abort()) : this.options.debug && a.debug("Fetch.cancel.missing abort controller"), this.reader ? (this.options.debug && a.debug("Fetch.cancel.reader.cancel"), this.reader.cancel().catch(function (t) {
                e.options.debug && a.debug("Fetch.cancel.reader.cancel exception", t);
              })) : this.options.debug && a.debug("Fetch.cancel before reader"));
            }, e;
          }();
          t.detectFetchSupport = function () {
            return "undefined" != typeof Response && Response.prototype.hasOwnProperty("body") && "function" == typeof Headers;
          };
        },
        859: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.CrossBrowserHttpTransport = void 0;
          var o = r(229),
            n = r(210);
          t.CrossBrowserHttpTransport = function (e) {
            if (o.detectFetchSupport()) {
              var t = {
                credentials: e.withCredentials ? "include" : "same-origin"
              };
              return o.FetchReadableStreamTransport(t);
            }
            return n.XhrTransport({
              withCredentials: e.withCredentials
            });
          };
        },
        210: function _(e, t, r) {
          var _o2,
            n = this && this.__extends || (_o2 = function o(e, t) {
              return (_o2 = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (e, t) {
                e.__proto__ = t;
              } || function (e, t) {
                for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
              })(e, t);
            }, function (e, t) {
              function r() {
                this.constructor = e;
              }
              _o2(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
            });
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.stringToArrayBuffer = t.MozChunkedArrayBufferXHR = t.XHR = t.XhrTransport = void 0;
          var a = r(65),
            i = r(346),
            s = r(849);
          t.XhrTransport = function (e) {
            return function (t) {
              if (s.detectMozXHRSupport()) return new l(t, e);
              if (s.detectXHROverrideMimeTypeSupport()) return new u(t, e);
              throw new Error("This environment's XHR implementation cannot support binary transfer.");
            };
          };
          var u = function () {
            function e(e, t) {
              this.options = e, this.init = t;
            }
            return e.prototype.onProgressEvent = function () {
              this.options.debug && i.debug("XHR.onProgressEvent.length: ", this.xhr.response.length);
              var e = this.xhr.response.substr(this.index);
              this.index = this.xhr.response.length;
              var t = p(e);
              this.options.onChunk(t);
            }, e.prototype.onLoadEvent = function () {
              this.options.debug && i.debug("XHR.onLoadEvent"), this.options.onEnd();
            }, e.prototype.onStateChange = function () {
              this.options.debug && i.debug("XHR.onStateChange", this.xhr.readyState), this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && this.options.onHeaders(new a.Metadata(this.xhr.getAllResponseHeaders()), this.xhr.status);
            }, e.prototype.sendMessage = function (e) {
              this.xhr.send(e);
            }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
              var t = this;
              this.metadata = e;
              var r = new XMLHttpRequest();
              this.xhr = r, r.open("POST", this.options.url), this.configureXhr(), this.metadata.forEach(function (e, t) {
                r.setRequestHeader(e, t.join(", "));
              }), r.withCredentials = Boolean(this.init.withCredentials), r.addEventListener("readystatechange", this.onStateChange.bind(this)), r.addEventListener("progress", this.onProgressEvent.bind(this)), r.addEventListener("loadend", this.onLoadEvent.bind(this)), r.addEventListener("error", function (e) {
                t.options.debug && i.debug("XHR.error", e), t.options.onEnd(e.error);
              });
            }, e.prototype.configureXhr = function () {
              this.xhr.responseType = "text", this.xhr.overrideMimeType("text/plain; charset=x-user-defined");
            }, e.prototype.cancel = function () {
              this.options.debug && i.debug("XHR.abort"), this.xhr.abort();
            }, e;
          }();
          t.XHR = u;
          var l = function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }
            return n(t, e), t.prototype.configureXhr = function () {
              this.options.debug && i.debug("MozXHR.configureXhr: setting responseType to 'moz-chunked-arraybuffer'"), this.xhr.responseType = "moz-chunked-arraybuffer";
            }, t.prototype.onProgressEvent = function () {
              var e = this.xhr.response;
              this.options.debug && i.debug("MozXHR.onProgressEvent: ", new Uint8Array(e)), this.options.onChunk(new Uint8Array(e));
            }, t;
          }(u);
          function c(e, t) {
            var r = e.charCodeAt(t);
            if (r >= 55296 && r <= 56319) {
              var o = e.charCodeAt(t + 1);
              o >= 56320 && o <= 57343 && (r = 65536 + (r - 55296 << 10) + (o - 56320));
            }
            return r;
          }
          function p(e) {
            for (var t = new Uint8Array(e.length), r = 0, o = 0; o < e.length; o++) {
              var n = String.prototype.codePointAt ? e.codePointAt(o) : c(e, o);
              t[r++] = 255 & n;
            }
            return t;
          }
          t.MozChunkedArrayBufferXHR = l, t.stringToArrayBuffer = p;
        },
        849: function _(e, t) {
          var r;
          function o() {
            if (void 0 !== r) return r;
            if (XMLHttpRequest) {
              r = new XMLHttpRequest();
              try {
                r.open("GET", "https://localhost");
              } catch (e) {}
            }
            return r;
          }
          function n(e) {
            var t = o();
            if (!t) return !1;
            try {
              return t.responseType = e, t.responseType === e;
            } catch (e) {}
            return !1;
          }
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.detectXHROverrideMimeTypeSupport = t.detectMozXHRSupport = t.xhrSupportsResponseType = void 0, t.xhrSupportsResponseType = n, t.detectMozXHRSupport = function () {
            return "undefined" != typeof XMLHttpRequest && n("moz-chunked-arraybuffer");
          }, t.detectXHROverrideMimeTypeSupport = function () {
            return "undefined" != typeof XMLHttpRequest && XMLHttpRequest.prototype.hasOwnProperty("overrideMimeType");
          };
        },
        540: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.WebsocketTransport = void 0;
          var o,
            n = r(346),
            a = r(617);
          !function (e) {
            e[e.FINISH_SEND = 1] = "FINISH_SEND";
          }(o || (o = {}));
          var i = new Uint8Array([1]);
          t.WebsocketTransport = function () {
            return function (e) {
              return function (e) {
                e.debug && n.debug("websocketRequest", e);
                var t,
                  r = function (e) {
                    if ("https://" === e.substr(0, 8)) return "wss://" + e.substr(8);
                    if ("http://" === e.substr(0, 7)) return "ws://" + e.substr(7);
                    throw new Error("Websocket transport constructed with non-https:// or http:// host.");
                  }(e.url),
                  s = [];
                function u(e) {
                  if (e === o.FINISH_SEND) t.send(i);else {
                    var r = e,
                      n = new Int8Array(r.byteLength + 1);
                    n.set(new Uint8Array([0])), n.set(r, 1), t.send(n);
                  }
                }
                return {
                  sendMessage: function sendMessage(e) {
                    t && t.readyState !== t.CONNECTING ? u(e) : s.push(e);
                  },
                  finishSend: function finishSend() {
                    t && t.readyState !== t.CONNECTING ? u(o.FINISH_SEND) : s.push(o.FINISH_SEND);
                  },
                  start: function start(o) {
                    (t = new WebSocket(r, ["grpc-websockets"])).binaryType = "arraybuffer", t.onopen = function () {
                      var r;
                      e.debug && n.debug("websocketRequest.onopen"), t.send((r = "", o.forEach(function (e, t) {
                        r += e + ": " + t.join(", ") + "\r\n";
                      }), a.encodeASCII(r))), s.forEach(function (e) {
                        u(e);
                      });
                    }, t.onclose = function (t) {
                      e.debug && n.debug("websocketRequest.onclose", t), e.onEnd();
                    }, t.onerror = function (t) {
                      e.debug && n.debug("websocketRequest.onerror", t);
                    }, t.onmessage = function (t) {
                      e.onChunk(new Uint8Array(t.data));
                    };
                  },
                  cancel: function cancel() {
                    e.debug && n.debug("websocket.abort"), t.close();
                  }
                };
              }(e);
            };
          };
        },
        35: function _(e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.unary = void 0;
          var o = r(65),
            n = r(934);
          t.unary = function (e, t) {
            if (e.responseStream) throw new Error(".unary cannot be used with server-streaming methods. Use .invoke or .client instead.");
            if (e.requestStream) throw new Error(".unary cannot be used with client-streaming methods. Use .client instead.");
            var r = null,
              a = null,
              i = n.client(e, {
                host: t.host,
                transport: t.transport,
                debug: t.debug
              });
            return i.onHeaders(function (e) {
              r = e;
            }), i.onMessage(function (e) {
              a = e;
            }), i.onEnd(function (e, n, i) {
              t.onEnd({
                status: e,
                statusMessage: n,
                headers: r || new o.Metadata(),
                message: a,
                trailers: i
              });
            }), i.start(t.metadata), i.send(t.request), i.finishSend(), {
              close: function close() {
                i.close();
              }
            };
          };
        },
        882: function _(e, t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.frameRequest = void 0, t.frameRequest = function (e) {
            var t = e.serializeBinary(),
              r = new ArrayBuffer(t.byteLength + 5);
            return new DataView(r, 1, 4).setUint32(0, t.length, !1), new Uint8Array(r, 5).set(t), new Uint8Array(r);
          };
        }
      }, t = {}, function r(o) {
        if (t[o]) return t[o].exports;
        var n = t[o] = {
          exports: {}
        };
        return e[o].call(n.exports, n, n.exports, r), n.exports;
      }(607);
      var e, t;
    }();
  }),
  __extends = (_extendStatics = function extendStatics(e, t) {
    return (_extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
    })(e, t);
  }, function (e, t) {
    function r() {
      this.constructor = e;
    }
    _extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  }),
  _extendStatics,
  _hasOwnProperty = Object.prototype.hasOwnProperty;
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017 Joachim Wester
 * MIT license
 */
function hasOwnProperty(e, t) {
  return _hasOwnProperty.call(e, t);
}
function _objectKeys(e) {
  if (Array.isArray(e)) {
    for (var t = new Array(e.length), r = 0; r < t.length; r++) t[r] = "" + r;
    return t;
  }
  if (Object.keys) return Object.keys(e);
  t = [];
  for (var o in e) hasOwnProperty(e, o) && t.push(o);
  return t;
}
function _deepClone(e) {
  switch (typeof e) {
    case "object":
      return JSON.parse(JSON.stringify(e));
    case "undefined":
      return null;
    default:
      return e;
  }
}
function isInteger(e) {
  for (var t, r = 0, o = e.length; r < o;) {
    if (!((t = e.charCodeAt(r)) >= 48 && t <= 57)) return !1;
    r++;
  }
  return !0;
}
function escapePathComponent(e) {
  return -1 === e.indexOf("/") && -1 === e.indexOf("~") ? e : e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function unescapePathComponent(e) {
  return e.replace(/~1/g, "/").replace(/~0/g, "~");
}
function hasUndefined(e) {
  if (void 0 === e) return !0;
  if (e) if (Array.isArray(e)) {
    for (var t = 0, r = e.length; t < r; t++) if (hasUndefined(e[t])) return !0;
  } else if ("object" == typeof e) {
    var o = _objectKeys(e),
      n = o.length;
    for (t = 0; t < n; t++) if (hasUndefined(e[o[t]])) return !0;
  }
  return !1;
}
function patchErrorMessageFormatter(e, t) {
  var r = [e];
  for (var o in t) {
    var n = "object" == typeof t[o] ? JSON.stringify(t[o], null, 2) : t[o];
    void 0 !== n && r.push(o + ": " + n);
  }
  return r.join("\n");
}
var PatchError = function (e) {
    function t(t, r, o, n, a) {
      var i = this.constructor,
        s = e.call(this, patchErrorMessageFormatter(t, {
          name: r,
          index: o,
          operation: n,
          tree: a
        })) || this;
      return s.name = r, s.index = o, s.operation = n, s.tree = a, Object.setPrototypeOf(s, i.prototype), s.message = patchErrorMessageFormatter(t, {
        name: r,
        index: o,
        operation: n,
        tree: a
      }), s;
    }
    return __extends(t, e), t;
  }(Error),
  JsonPatchError = PatchError,
  deepClone = _deepClone,
  objOps = {
    add: function add(e, t, r) {
      return e[t] = this.value, {
        newDocument: r
      };
    },
    remove: function remove(e, t, r) {
      var o = e[t];
      return delete e[t], {
        newDocument: r,
        removed: o
      };
    },
    replace: function replace(e, t, r) {
      var o = e[t];
      return e[t] = this.value, {
        newDocument: r,
        removed: o
      };
    },
    move: function move(e, t, r) {
      var o = getValueByPointer(r, this.path);
      o && (o = _deepClone(o));
      var n = applyOperation(r, {
        op: "remove",
        path: this.from
      }).removed;
      return applyOperation(r, {
        op: "add",
        path: this.path,
        value: n
      }), {
        newDocument: r,
        removed: o
      };
    },
    copy: function copy(e, t, r) {
      var o = getValueByPointer(r, this.from);
      return applyOperation(r, {
        op: "add",
        path: this.path,
        value: _deepClone(o)
      }), {
        newDocument: r
      };
    },
    test: function test(e, t, r) {
      return {
        newDocument: r,
        test: _areEquals(e[t], this.value)
      };
    },
    _get: function _get(e, t, r) {
      return this.value = e[t], {
        newDocument: r
      };
    }
  },
  arrOps = {
    add: function add(e, t, r) {
      return isInteger(t) ? e.splice(t, 0, this.value) : e[t] = this.value, {
        newDocument: r,
        index: t
      };
    },
    remove: function remove(e, t, r) {
      return {
        newDocument: r,
        removed: e.splice(t, 1)[0]
      };
    },
    replace: function replace(e, t, r) {
      var o = e[t];
      return e[t] = this.value, {
        newDocument: r,
        removed: o
      };
    },
    move: objOps.move,
    copy: objOps.copy,
    test: objOps.test,
    _get: objOps._get
  };
function getValueByPointer(e, t) {
  if ("" == t) return e;
  var r = {
    op: "_get",
    path: t
  };
  return applyOperation(e, r), r.value;
}
function applyOperation(e, t, r, o, n, a) {
  if (void 0 === r && (r = !1), void 0 === o && (o = !0), void 0 === n && (n = !0), void 0 === a && (a = 0), r && ("function" == typeof r ? r(t, 0, e, t.path) : validator(t, 0)), "" === t.path) {
    var i = {
      newDocument: e
    };
    if ("add" === t.op) return i.newDocument = t.value, i;
    if ("replace" === t.op) return i.newDocument = t.value, i.removed = e, i;
    if ("move" === t.op || "copy" === t.op) return i.newDocument = getValueByPointer(e, t.from), "move" === t.op && (i.removed = e), i;
    if ("test" === t.op) {
      if (i.test = _areEquals(e, t.value), !1 === i.test) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", a, t, e);
      return i.newDocument = e, i;
    }
    if ("remove" === t.op) return i.removed = e, i.newDocument = null, i;
    if ("_get" === t.op) return t.value = e, i;
    if (r) throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", a, t, e);
    return i;
  }
  o || (e = _deepClone(e));
  var s = (t.path || "").split("/"),
    u = e,
    l = 1,
    c = s.length,
    p = void 0,
    g = void 0,
    d = void 0;
  for (d = "function" == typeof r ? r : validator;;) {
    if (g = s[l], n && "__proto__" == g) throw new TypeError("JSON-Patch: modifying `__proto__` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
    if (r && void 0 === p && (void 0 === u[g] ? p = s.slice(0, l).join("/") : l == c - 1 && (p = t.path), void 0 !== p && d(t, 0, e, p)), l++, Array.isArray(u)) {
      if ("-" === g) g = u.length;else {
        if (r && !isInteger(g)) throw new JsonPatchError("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", a, t, e);
        isInteger(g) && (g = ~~g);
      }
      if (l >= c) {
        if (r && "add" === t.op && g > u.length) throw new JsonPatchError("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", a, t, e);
        if (!1 === (i = arrOps[t.op].call(t, u, g, e)).test) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", a, t, e);
        return i;
      }
    } else if (g && -1 != g.indexOf("~") && (g = unescapePathComponent(g)), l >= c) {
      if (!1 === (i = objOps[t.op].call(t, u, g, e)).test) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", a, t, e);
      return i;
    }
    u = u[g];
  }
}
function applyPatch(e, t, r, o, n) {
  if (void 0 === o && (o = !0), void 0 === n && (n = !0), r && !Array.isArray(t)) throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
  o || (e = _deepClone(e));
  for (var a = new Array(t.length), i = 0, s = t.length; i < s; i++) a[i] = applyOperation(e, t[i], r, !0, n, i), e = a[i].newDocument;
  return a.newDocument = e, a;
}
function applyReducer(e, t, r) {
  var o = applyOperation(e, t);
  if (!1 === o.test) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", r, t, e);
  return o.newDocument;
}
function validator(e, t, r, o) {
  if ("object" != typeof e || null === e || Array.isArray(e)) throw new JsonPatchError("Operation is not an object", "OPERATION_NOT_AN_OBJECT", t, e, r);
  if (!objOps[e.op]) throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", t, e, r);
  if ("string" != typeof e.path) throw new JsonPatchError("Operation `path` property is not a string", "OPERATION_PATH_INVALID", t, e, r);
  if (0 !== e.path.indexOf("/") && e.path.length > 0) throw new JsonPatchError('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", t, e, r);
  if (("move" === e.op || "copy" === e.op) && "string" != typeof e.from) throw new JsonPatchError("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", t, e, r);
  if (("add" === e.op || "replace" === e.op || "test" === e.op) && void 0 === e.value) throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", t, e, r);
  if (("add" === e.op || "replace" === e.op || "test" === e.op) && hasUndefined(e.value)) throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", t, e, r);
  if (r) if ("add" == e.op) {
    var n = e.path.split("/").length,
      a = o.split("/").length;
    if (n !== a + 1 && n !== a) throw new JsonPatchError("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", t, e, r);
  } else if ("replace" === e.op || "remove" === e.op || "_get" === e.op) {
    if (e.path !== o) throw new JsonPatchError("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", t, e, r);
  } else if ("move" === e.op || "copy" === e.op) {
    var i = validate([{
      op: "_get",
      path: e.from,
      value: void 0
    }], r);
    if (i && "OPERATION_PATH_UNRESOLVABLE" === i.name) throw new JsonPatchError("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", t, e, r);
  }
}
function validate(e, t, r) {
  try {
    if (!Array.isArray(e)) throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    if (t) applyPatch(_deepClone(t), _deepClone(e), r || !0);else {
      r = r || validator;
      for (var o = 0; o < e.length; o++) r(e[o], o, t, void 0);
    }
  } catch (e) {
    if (e instanceof JsonPatchError) return e;
    throw e;
  }
}
function _areEquals(e, t) {
  if (e === t) return !0;
  if (e && t && "object" == typeof e && "object" == typeof t) {
    var r,
      o,
      n,
      a = Array.isArray(e),
      i = Array.isArray(t);
    if (a && i) {
      if ((o = e.length) != t.length) return !1;
      for (r = o; 0 != r--;) if (!_areEquals(e[r], t[r])) return !1;
      return !0;
    }
    if (a != i) return !1;
    var s = Object.keys(e);
    if ((o = s.length) !== Object.keys(t).length) return !1;
    for (r = o; 0 != r--;) if (!t.hasOwnProperty(s[r])) return !1;
    for (r = o; 0 != r--;) if (!_areEquals(e[n = s[r]], t[n])) return !1;
    return !0;
  }
  return e != e && t != t;
}
var core = Object.freeze({
    __proto__: null,
    JsonPatchError: JsonPatchError,
    deepClone: deepClone,
    getValueByPointer: getValueByPointer,
    applyOperation: applyOperation,
    applyPatch: applyPatch,
    applyReducer: applyReducer,
    validator: validator,
    validate: validate,
    _areEquals: _areEquals
  }),
  beforeDict = new WeakMap(),
  Mirror = function Mirror(e) {
    this.observers = new Map(), this.obj = e;
  },
  ObserverInfo = function ObserverInfo(e, t) {
    this.callback = e, this.observer = t;
  };
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017 Joachim Wester
 * MIT license
 */
function getMirror(e) {
  return beforeDict.get(e);
}
function getObserverFromMirror(e, t) {
  return e.observers.get(t);
}
function removeObserverFromMirror(e, t) {
  e.observers.delete(t.callback);
}
function unobserve(e, t) {
  t.unobserve();
}
function observe(e, t) {
  var r,
    o = getMirror(e);
  if (o) {
    var n = getObserverFromMirror(o, t);
    r = n && n.observer;
  } else o = new Mirror(e), beforeDict.set(e, o);
  if (r) return r;
  if (r = {}, o.value = _deepClone(e), t) {
    r.callback = t, r.next = null;
    var a = function a() {
        generate(r);
      },
      i = function i() {
        clearTimeout(r.next), r.next = setTimeout(a);
      };
    "undefined" != typeof window && (window.addEventListener("mouseup", i), window.addEventListener("keyup", i), window.addEventListener("mousedown", i), window.addEventListener("keydown", i), window.addEventListener("change", i));
  }
  return r.patches = [], r.object = e, r.unobserve = function () {
    generate(r), clearTimeout(r.next), removeObserverFromMirror(o, r), "undefined" != typeof window && (window.removeEventListener("mouseup", i), window.removeEventListener("keyup", i), window.removeEventListener("mousedown", i), window.removeEventListener("keydown", i), window.removeEventListener("change", i));
  }, o.observers.set(t, new ObserverInfo(t, r)), r;
}
function generate(e, t) {
  void 0 === t && (t = !1);
  var r = beforeDict.get(e.object);
  _generate(r.value, e.object, e.patches, "", t), e.patches.length && applyPatch(r.value, e.patches);
  var o = e.patches;
  return o.length > 0 && (e.patches = [], e.callback && e.callback(o)), o;
}
function _generate(e, t, r, o, n) {
  if (t !== e) {
    "function" == typeof t.toJSON && (t = t.toJSON());
    for (var a = _objectKeys(t), i = _objectKeys(e), s = !1, u = i.length - 1; u >= 0; u--) {
      var l = e[p = i[u]];
      if (!hasOwnProperty(t, p) || void 0 === t[p] && void 0 !== l && !1 === Array.isArray(t)) Array.isArray(e) === Array.isArray(t) ? (n && r.push({
        op: "test",
        path: o + "/" + escapePathComponent(p),
        value: _deepClone(l)
      }), r.push({
        op: "remove",
        path: o + "/" + escapePathComponent(p)
      }), s = !0) : (n && r.push({
        op: "test",
        path: o,
        value: e
      }), r.push({
        op: "replace",
        path: o,
        value: t
      }));else {
        var c = t[p];
        "object" == typeof l && null != l && "object" == typeof c && null != c ? _generate(l, c, r, o + "/" + escapePathComponent(p), n) : l !== c && (n && r.push({
          op: "test",
          path: o + "/" + escapePathComponent(p),
          value: _deepClone(l)
        }), r.push({
          op: "replace",
          path: o + "/" + escapePathComponent(p),
          value: _deepClone(c)
        }));
      }
    }
    if (s || a.length != i.length) for (u = 0; u < a.length; u++) {
      var p;
      hasOwnProperty(e, p = a[u]) || void 0 === t[p] || r.push({
        op: "add",
        path: o + "/" + escapePathComponent(p),
        value: _deepClone(t[p])
      });
    }
  }
}
function compare(e, t, r) {
  void 0 === r && (r = !1);
  var o = [];
  return _generate(e, t, o, "", r), o;
}
var duplex = Object.freeze({
    __proto__: null,
    unobserve: unobserve,
    observe: observe,
    generate: generate,
    compare: compare
  }),
  jsonpatch = Object.assign({}, core, duplex, {
    JsonPatchError: PatchError,
    deepClone: _deepClone,
    escapePathComponent: escapePathComponent,
    unescapePathComponent: unescapePathComponent
  }),
  _assign = function __assign() {
    return (_assign = Object.assign || function (e) {
      for (var t, r = 1, o = arguments.length; r < o; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      return e;
    }).apply(this, arguments);
  };
function __spreadArrays() {
  for (var e = 0, t = 0, r = arguments.length; t < r; t++) e += arguments[t].length;
  var o = Array(e),
    n = 0;
  for (t = 0; t < r; t++) for (var a = arguments[t], i = 0, s = a.length; i < s; i++, n++) o[n] = a[i];
  return o;
}
var keys = Object.keys,
  isArray = Array.isArray,
  _global = "undefined" != typeof self ? self : "undefined" != typeof window ? window : global;
function extend(e, t) {
  return "object" != typeof t || keys(t).forEach(function (r) {
    e[r] = t[r];
  }), e;
}
"undefined" == typeof Promise || _global.Promise || (_global.Promise = Promise);
var getProto = Object.getPrototypeOf,
  _hasOwn = {}.hasOwnProperty;
function hasOwn(e, t) {
  return _hasOwn.call(e, t);
}
function props(e, t) {
  "function" == typeof t && (t = t(getProto(e))), keys(t).forEach(function (r) {
    setProp(e, r, t[r]);
  });
}
var defineProperty = Object.defineProperty;
function setProp(e, t, r, o) {
  defineProperty(e, t, extend(r && hasOwn(r, "get") && "function" == typeof r.get ? {
    get: r.get,
    set: r.set,
    configurable: !0
  } : {
    value: r,
    configurable: !0,
    writable: !0
  }, o));
}
function derive(e) {
  return {
    from: function from(t) {
      return e.prototype = Object.create(t.prototype), setProp(e.prototype, "constructor", e), {
        extend: props.bind(null, e.prototype)
      };
    }
  };
}
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function getPropertyDescriptor(e, t) {
  var r;
  return getOwnPropertyDescriptor(e, t) || (r = getProto(e)) && getPropertyDescriptor(r, t);
}
var _slice = [].slice;
function slice(e, t, r) {
  return _slice.call(e, t, r);
}
function override(e, t) {
  return t(e);
}
function assert(e) {
  if (!e) throw new Error("Assertion Failed");
}
function asap(e) {
  _global.setImmediate ? setImmediate(e) : setTimeout(e, 0);
}
function arrayToObject(e, t) {
  return e.reduce(function (e, r, o) {
    var n = t(r, o);
    return n && (e[n[0]] = n[1]), e;
  }, {});
}
function tryCatch(e, t, r) {
  try {
    e.apply(null, r);
  } catch (e) {
    t && t(e);
  }
}
function getByKeyPath(e, t) {
  if (hasOwn(e, t)) return e[t];
  if (!t) return e;
  if ("string" != typeof t) {
    for (var r = [], o = 0, n = t.length; o < n; ++o) {
      var a = getByKeyPath(e, t[o]);
      r.push(a);
    }
    return r;
  }
  var i = t.indexOf(".");
  if (-1 !== i) {
    var s = e[t.substr(0, i)];
    return void 0 === s ? void 0 : getByKeyPath(s, t.substr(i + 1));
  }
}
function setByKeyPath(e, t, r) {
  if (e && void 0 !== t && (!("isFrozen" in Object) || !Object.isFrozen(e))) if ("string" != typeof t && "length" in t) {
    assert("string" != typeof r && "length" in r);
    for (var o = 0, n = t.length; o < n; ++o) setByKeyPath(e, t[o], r[o]);
  } else {
    var a = t.indexOf(".");
    if (-1 !== a) {
      var i = t.substr(0, a),
        s = t.substr(a + 1);
      if ("" === s) void 0 === r ? isArray(e) && !isNaN(parseInt(i)) ? e.splice(i, 1) : delete e[i] : e[i] = r;else {
        var u = e[i];
        u || (u = e[i] = {}), setByKeyPath(u, s, r);
      }
    } else void 0 === r ? isArray(e) && !isNaN(parseInt(t)) ? e.splice(t, 1) : delete e[t] : e[t] = r;
  }
}
function delByKeyPath(e, t) {
  "string" == typeof t ? setByKeyPath(e, t, void 0) : "length" in t && [].map.call(t, function (t) {
    setByKeyPath(e, t, void 0);
  });
}
function shallowClone(e) {
  var t = {};
  for (var r in e) hasOwn(e, r) && (t[r] = e[r]);
  return t;
}
var concat = [].concat;
function flatten(e) {
  return concat.apply([], e);
}
var intrinsicTypeNames = "Boolean,String,Date,RegExp,Blob,File,FileList,ArrayBuffer,DataView,Uint8ClampedArray,ImageData,Map,Set".split(",").concat(flatten([8, 16, 32, 64].map(function (e) {
    return ["Int", "Uint", "Float"].map(function (t) {
      return t + e + "Array";
    });
  }))).filter(function (e) {
    return _global[e];
  }),
  intrinsicTypes = intrinsicTypeNames.map(function (e) {
    return _global[e];
  }),
  intrinsicTypeNameSet = arrayToObject(intrinsicTypeNames, function (e) {
    return [e, !0];
  });
function deepClone$1(e) {
  if (!e || "object" != typeof e) return e;
  var t;
  if (isArray(e)) {
    t = [];
    for (var r = 0, o = e.length; r < o; ++r) t.push(deepClone$1(e[r]));
  } else if (intrinsicTypes.indexOf(e.constructor) >= 0) t = e;else for (var n in t = e.constructor ? Object.create(e.constructor.prototype) : {}, e) hasOwn(e, n) && (t[n] = deepClone$1(e[n]));
  return t;
}
var toString = {}.toString;
function toStringTag(e) {
  return toString.call(e).slice(8, -1);
}
var getValueOf = function getValueOf(e, t) {
  return "Array" === t ? "" + e.map(function (e) {
    return getValueOf(e, toStringTag(e));
  }) : "ArrayBuffer" === t ? "" + new Uint8Array(e) : "Date" === t ? e.getTime() : ArrayBuffer.isView(e) ? "" + new Uint8Array(e.buffer) : e;
};
function getObjectDiff(e, t, r, o) {
  return r = r || {}, o = o || "", keys(e).forEach(function (n) {
    if (hasOwn(t, n)) {
      var a = e[n],
        i = t[n];
      if ("object" == typeof a && "object" == typeof i && a && i) {
        var s = toStringTag(a),
          u = toStringTag(i);
        s === u ? intrinsicTypeNameSet[s] ? getValueOf(a, s) !== getValueOf(i, u) && (r[o + n] = t[n]) : getObjectDiff(a, i, r, o + n + ".") : r[o + n] = t[n];
      } else a !== i && (r[o + n] = t[n]);
    } else r[o + n] = void 0;
  }), keys(t).forEach(function (n) {
    hasOwn(e, n) || (r[o + n] = t[n]);
  }), r;
}
var iteratorSymbol = "undefined" != typeof Symbol && Symbol.iterator,
  getIteratorOf = iteratorSymbol ? function (e) {
    var t;
    return null != e && (t = e[iteratorSymbol]) && t.apply(e);
  } : function () {
    return null;
  },
  NO_CHAR_ARRAY = {};
function getArrayOf(e) {
  var t, r, o, n;
  if (1 === arguments.length) {
    if (isArray(e)) return e.slice();
    if (this === NO_CHAR_ARRAY && "string" == typeof e) return [e];
    if (n = getIteratorOf(e)) {
      for (r = []; !(o = n.next()).done;) r.push(o.value);
      return r;
    }
    if (null == e) return [e];
    if ("number" == typeof (t = e.length)) {
      for (r = new Array(t); t--;) r[t] = e[t];
      return r;
    }
    return [e];
  }
  for (t = arguments.length, r = new Array(t); t--;) r[t] = arguments[t];
  return r;
}
var isAsyncFunction = "undefined" != typeof Symbol ? function (e) {
    return "AsyncFunction" === e[Symbol.toStringTag];
  } : function () {
    return !1;
  },
  debug = "undefined" != typeof location && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function setDebug(e, t) {
  debug = e, libraryFilter = t;
}
var libraryFilter = function libraryFilter() {
    return !0;
  },
  NEEDS_THROW_FOR_STACK = !new Error("").stack;
function getErrorWithStack() {
  if (NEEDS_THROW_FOR_STACK) try {
    throw new Error();
  } catch (e) {
    return e;
  }
  return new Error();
}
function prettyStack(e, t) {
  var r = e.stack;
  return r ? (t = t || 0, 0 === r.indexOf(e.name) && (t += (e.name + e.message).split("\n").length), r.split("\n").slice(t).filter(libraryFilter).map(function (e) {
    return "\n" + e;
  }).join("")) : "";
}
var dexieErrorNames = ["Modify", "Bulk", "OpenFailed", "VersionChange", "Schema", "Upgrade", "InvalidTable", "MissingAPI", "NoSuchDatabase", "InvalidArgument", "SubTransaction", "Unsupported", "Internal", "DatabaseClosed", "PrematureCommit", "ForeignAwait"],
  idbDomErrorNames = ["Unknown", "Constraint", "Data", "TransactionInactive", "ReadOnly", "Version", "NotFound", "InvalidState", "InvalidAccess", "Abort", "Timeout", "QuotaExceeded", "Syntax", "DataClone"],
  errorList = dexieErrorNames.concat(idbDomErrorNames),
  defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed"
  };
function DexieError(e, t) {
  this._e = getErrorWithStack(), this.name = e, this.message = t;
}
function getMultiErrorMessage(e, t) {
  return e + ". Errors: " + Object.keys(t).map(function (e) {
    return t[e].toString();
  }).filter(function (e, t, r) {
    return r.indexOf(e) === t;
  }).join("\n");
}
function ModifyError(e, t, r, o) {
  this._e = getErrorWithStack(), this.failures = t, this.failedKeys = o, this.successCount = r, this.message = getMultiErrorMessage(e, t);
}
function BulkError(e, t) {
  this._e = getErrorWithStack(), this.name = "BulkError", this.failures = t, this.message = getMultiErrorMessage(e, t);
}
derive(DexieError).from(Error).extend({
  stack: {
    get: function get() {
      return this._stack || (this._stack = this.name + ": " + this.message + prettyStack(this._e, 2));
    }
  },
  toString: function toString() {
    return this.name + ": " + this.message;
  }
}), derive(ModifyError).from(DexieError), derive(BulkError).from(DexieError);
var errnames = errorList.reduce(function (e, t) {
    return e[t] = t + "Error", e;
  }, {}),
  BaseException = DexieError,
  exceptions = errorList.reduce(function (e, t) {
    var r = t + "Error";
    function o(e, o) {
      this._e = getErrorWithStack(), this.name = r, e ? "string" == typeof e ? (this.message = e + (o ? "\n " + o : ""), this.inner = o || null) : "object" == typeof e && (this.message = e.name + " " + e.message, this.inner = e) : (this.message = defaultTexts[t] || r, this.inner = null);
    }
    return derive(o).from(BaseException), e[t] = o, e;
  }, {});
exceptions.Syntax = SyntaxError, exceptions.Type = TypeError, exceptions.Range = RangeError;
var exceptionMap = idbDomErrorNames.reduce(function (e, t) {
  return e[t + "Error"] = exceptions[t], e;
}, {});
function mapError(e, t) {
  if (!e || e instanceof DexieError || e instanceof TypeError || e instanceof SyntaxError || !e.name || !exceptionMap[e.name]) return e;
  var r = new exceptionMap[e.name](t || e.message, e);
  return "stack" in e && setProp(r, "stack", {
    get: function get() {
      return this.inner.stack;
    }
  }), r;
}
var fullNameExceptions = errorList.reduce(function (e, t) {
  return -1 === ["Syntax", "Type", "Range"].indexOf(t) && (e[t + "Error"] = exceptions[t]), e;
}, {});
function nop() {}
function mirror(e) {
  return e;
}
function pureFunctionChain(e, t) {
  return null == e || e === mirror ? t : function (r) {
    return t(e(r));
  };
}
function callBoth(e, t) {
  return function () {
    e.apply(this, arguments), t.apply(this, arguments);
  };
}
function hookCreatingChain(e, t) {
  return e === nop ? t : function () {
    var r = e.apply(this, arguments);
    void 0 !== r && (arguments[0] = r);
    var o = this.onsuccess,
      n = this.onerror;
    this.onsuccess = null, this.onerror = null;
    var a = t.apply(this, arguments);
    return o && (this.onsuccess = this.onsuccess ? callBoth(o, this.onsuccess) : o), n && (this.onerror = this.onerror ? callBoth(n, this.onerror) : n), void 0 !== a ? a : r;
  };
}
function hookDeletingChain(e, t) {
  return e === nop ? t : function () {
    e.apply(this, arguments);
    var r = this.onsuccess,
      o = this.onerror;
    this.onsuccess = this.onerror = null, t.apply(this, arguments), r && (this.onsuccess = this.onsuccess ? callBoth(r, this.onsuccess) : r), o && (this.onerror = this.onerror ? callBoth(o, this.onerror) : o);
  };
}
function hookUpdatingChain(e, t) {
  return e === nop ? t : function (r) {
    var o = e.apply(this, arguments);
    extend(r, o);
    var n = this.onsuccess,
      a = this.onerror;
    this.onsuccess = null, this.onerror = null;
    var i = t.apply(this, arguments);
    return n && (this.onsuccess = this.onsuccess ? callBoth(n, this.onsuccess) : n), a && (this.onerror = this.onerror ? callBoth(a, this.onerror) : a), void 0 === o ? void 0 === i ? void 0 : i : extend(o, i);
  };
}
function reverseStoppableEventChain(e, t) {
  return e === nop ? t : function () {
    return !1 !== t.apply(this, arguments) && e.apply(this, arguments);
  };
}
function promisableChain(e, t) {
  return e === nop ? t : function () {
    var r = e.apply(this, arguments);
    if (r && "function" == typeof r.then) {
      for (var o = this, n = arguments.length, a = new Array(n); n--;) a[n] = arguments[n];
      return r.then(function () {
        return t.apply(o, a);
      });
    }
    return t.apply(this, arguments);
  };
}
fullNameExceptions.ModifyError = ModifyError, fullNameExceptions.DexieError = DexieError, fullNameExceptions.BulkError = BulkError;
var INTERNAL = {},
  LONG_STACKS_CLIP_LIMIT = 100,
  MAX_LONG_STACKS = 20,
  ZONE_ECHO_LIMIT = 100,
  _a = "undefined" == typeof Promise ? [] : function () {
    var e = Promise.resolve();
    if ("undefined" == typeof crypto || !crypto.subtle) return [e, e.__proto__, e];
    var t = crypto.subtle.digest("SHA-512", new Uint8Array([0]));
    return [t, t.__proto__, e];
  }(),
  resolvedNativePromise = _a[0],
  nativePromiseProto = _a[1],
  resolvedGlobalPromise = _a[2],
  nativePromiseThen = nativePromiseProto && nativePromiseProto.then,
  NativePromise = resolvedNativePromise && resolvedNativePromise.constructor,
  patchGlobalPromise = !!resolvedGlobalPromise,
  stack_being_generated = !1,
  schedulePhysicalTick = resolvedGlobalPromise ? function () {
    resolvedGlobalPromise.then(physicalTick);
  } : _global.setImmediate ? setImmediate.bind(null, physicalTick) : _global.MutationObserver ? function () {
    var e = document.createElement("div");
    new MutationObserver(function () {
      physicalTick(), e = null;
    }).observe(e, {
      attributes: !0
    }), e.setAttribute("i", "1");
  } : function () {
    setTimeout(physicalTick, 0);
  },
  asap$1 = function asap$1(e, t) {
    microtickQueue.push([e, t]), needsNewPhysicalTick && (schedulePhysicalTick(), needsNewPhysicalTick = !1);
  },
  isOutsideMicroTick = !0,
  needsNewPhysicalTick = !0,
  unhandledErrors = [],
  rejectingErrors = [],
  currentFulfiller = null,
  rejectionMapper = mirror,
  globalPSD = {
    id: "global",
    global: !0,
    ref: 0,
    unhandleds: [],
    onunhandled: globalError,
    pgp: !1,
    env: {},
    finalize: function finalize() {
      this.unhandleds.forEach(function (e) {
        try {
          globalError(e[0], e[1]);
        } catch (e) {}
      });
    }
  },
  PSD = globalPSD,
  microtickQueue = [],
  numScheduledCalls = 0,
  tickFinalizers = [];
function DexiePromise(e) {
  if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
  this._listeners = [], this.onuncatched = nop, this._lib = !1;
  var t = this._PSD = PSD;
  if (debug && (this._stackHolder = getErrorWithStack(), this._prev = null, this._numPrev = 0), "function" != typeof e) {
    if (e !== INTERNAL) throw new TypeError("Not a function");
    return this._state = arguments[1], this._value = arguments[2], void (!1 === this._state && handleRejection(this, this._value));
  }
  this._state = null, this._value = null, ++t.ref, executePromiseTask(this, e);
}
var thenProp = {
  get: function get() {
    var e = PSD,
      t = totalEchoes;
    function r(r, o) {
      var n = this,
        a = !e.global && (e !== PSD || t !== totalEchoes);
      a && decrementExpectedAwaits();
      var i = new DexiePromise(function (t, i) {
        propagateToListener(n, new Listener(nativeAwaitCompatibleWrap(r, e, a), nativeAwaitCompatibleWrap(o, e, a), t, i, e));
      });
      return debug && linkToPreviousPromise(i, this), i;
    }
    return r.prototype = INTERNAL, r;
  },
  set: function set(e) {
    setProp(this, "then", e && e.prototype === INTERNAL ? thenProp : {
      get: function get() {
        return e;
      },
      set: thenProp.set
    });
  }
};
function Listener(e, t, r, o, n) {
  this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.resolve = r, this.reject = o, this.psd = n;
}
function executePromiseTask(e, t) {
  try {
    t(function (t) {
      if (null === e._state) {
        if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
        var r = e._lib && beginMicroTickScope();
        t && "function" == typeof t.then ? executePromiseTask(e, function (e, r) {
          t instanceof DexiePromise ? t._then(e, r) : t.then(e, r);
        }) : (e._state = !0, e._value = t, propagateAllListeners(e)), r && endMicroTickScope();
      }
    }, handleRejection.bind(null, e));
  } catch (t) {
    handleRejection(e, t);
  }
}
function handleRejection(e, t) {
  if (rejectingErrors.push(t), null === e._state) {
    var r = e._lib && beginMicroTickScope();
    t = rejectionMapper(t), e._state = !1, e._value = t, debug && null !== t && "object" == typeof t && !t._promise && tryCatch(function () {
      var r = getPropertyDescriptor(t, "stack");
      t._promise = e, setProp(t, "stack", {
        get: function get() {
          return stack_being_generated ? r && (r.get ? r.get.apply(t) : r.value) : e.stack;
        }
      });
    }), addPossiblyUnhandledError(e), propagateAllListeners(e), r && endMicroTickScope();
  }
}
function propagateAllListeners(e) {
  var t = e._listeners;
  e._listeners = [];
  for (var r = 0, o = t.length; r < o; ++r) propagateToListener(e, t[r]);
  var n = e._PSD;
  --n.ref || n.finalize(), 0 === numScheduledCalls && (++numScheduledCalls, asap$1(function () {
    0 == --numScheduledCalls && finalizePhysicalTick();
  }, []));
}
function propagateToListener(e, t) {
  if (null !== e._state) {
    var r = e._state ? t.onFulfilled : t.onRejected;
    if (null === r) return (e._state ? t.resolve : t.reject)(e._value);
    ++t.psd.ref, ++numScheduledCalls, asap$1(callListener, [r, e, t]);
  } else e._listeners.push(t);
}
function callListener(e, t, r) {
  try {
    currentFulfiller = t;
    var o,
      n = t._value;
    t._state ? o = e(n) : (rejectingErrors.length && (rejectingErrors = []), o = e(n), -1 === rejectingErrors.indexOf(n) && markErrorAsHandled(t)), r.resolve(o);
  } catch (e) {
    r.reject(e);
  } finally {
    currentFulfiller = null, 0 == --numScheduledCalls && finalizePhysicalTick(), --r.psd.ref || r.psd.finalize();
  }
}
function getStack(e, t, r) {
  if (t.length === r) return t;
  var o = "";
  if (!1 === e._state) {
    var n,
      a,
      i = e._value;
    null != i ? (n = i.name || "Error", a = i.message || i, o = prettyStack(i, 0)) : (n = i, a = ""), t.push(n + (a ? ": " + a : "") + o);
  }
  return debug && ((o = prettyStack(e._stackHolder, 2)) && -1 === t.indexOf(o) && t.push(o), e._prev && getStack(e._prev, t, r)), t;
}
function linkToPreviousPromise(e, t) {
  var r = t ? t._numPrev + 1 : 0;
  r < LONG_STACKS_CLIP_LIMIT && (e._prev = t, e._numPrev = r);
}
function physicalTick() {
  beginMicroTickScope() && endMicroTickScope();
}
function beginMicroTickScope() {
  var e = isOutsideMicroTick;
  return isOutsideMicroTick = !1, needsNewPhysicalTick = !1, e;
}
function endMicroTickScope() {
  var e, t, r;
  do {
    for (; microtickQueue.length > 0;) for (e = microtickQueue, microtickQueue = [], r = e.length, t = 0; t < r; ++t) {
      var o = e[t];
      o[0].apply(null, o[1]);
    }
  } while (microtickQueue.length > 0);
  isOutsideMicroTick = !0, needsNewPhysicalTick = !0;
}
function finalizePhysicalTick() {
  var e = unhandledErrors;
  unhandledErrors = [], e.forEach(function (e) {
    e._PSD.onunhandled.call(null, e._value, e);
  });
  for (var t = tickFinalizers.slice(0), r = t.length; r;) t[--r]();
}
function run_at_end_of_this_or_next_physical_tick(e) {
  tickFinalizers.push(function t() {
    e(), tickFinalizers.splice(tickFinalizers.indexOf(t), 1);
  }), ++numScheduledCalls, asap$1(function () {
    0 == --numScheduledCalls && finalizePhysicalTick();
  }, []);
}
function addPossiblyUnhandledError(e) {
  unhandledErrors.some(function (t) {
    return t._value === e._value;
  }) || unhandledErrors.push(e);
}
function markErrorAsHandled(e) {
  for (var t = unhandledErrors.length; t;) if (unhandledErrors[--t]._value === e._value) return void unhandledErrors.splice(t, 1);
}
function PromiseReject(e) {
  return new DexiePromise(INTERNAL, !1, e);
}
function wrap(e, t) {
  var r = PSD;
  return function () {
    var o = beginMicroTickScope(),
      n = PSD;
    try {
      return switchToZone(r, !0), e.apply(this, arguments);
    } catch (e) {
      t && t(e);
    } finally {
      switchToZone(n, !1), o && endMicroTickScope();
    }
  };
}
props(DexiePromise.prototype, {
  then: thenProp,
  _then: function _then(e, t) {
    propagateToListener(this, new Listener(null, null, e, t, PSD));
  },
  catch: function _catch(e) {
    if (1 === arguments.length) return this.then(null, e);
    var t = arguments[0],
      r = arguments[1];
    return "function" == typeof t ? this.then(null, function (e) {
      return e instanceof t ? r(e) : PromiseReject(e);
    }) : this.then(null, function (e) {
      return e && e.name === t ? r(e) : PromiseReject(e);
    });
  },
  finally: function _finally(e) {
    return this.then(function (t) {
      return e(), t;
    }, function (t) {
      return e(), PromiseReject(t);
    });
  },
  stack: {
    get: function get() {
      if (this._stack) return this._stack;
      try {
        stack_being_generated = !0;
        var e = getStack(this, [], MAX_LONG_STACKS).join("\nFrom previous: ");
        return null !== this._state && (this._stack = e), e;
      } finally {
        stack_being_generated = !1;
      }
    }
  },
  timeout: function timeout(e, t) {
    var r = this;
    return e < 1 / 0 ? new DexiePromise(function (o, n) {
      var a = setTimeout(function () {
        return n(new exceptions.Timeout(t));
      }, e);
      r.then(o, n).finally(clearTimeout.bind(null, a));
    }) : this;
  }
}), "undefined" != typeof Symbol && Symbol.toStringTag && setProp(DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise"), globalPSD.env = snapShot(), props(DexiePromise, {
  all: function all() {
    var e = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
    return new DexiePromise(function (t, r) {
      0 === e.length && t([]);
      var o = e.length;
      e.forEach(function (n, a) {
        return DexiePromise.resolve(n).then(function (r) {
          e[a] = r, --o || t(e);
        }, r);
      });
    });
  },
  resolve: function resolve(e) {
    if (e instanceof DexiePromise) return e;
    if (e && "function" == typeof e.then) return new DexiePromise(function (t, r) {
      e.then(t, r);
    });
    var t = new DexiePromise(INTERNAL, !0, e);
    return linkToPreviousPromise(t, currentFulfiller), t;
  },
  reject: PromiseReject,
  race: function race() {
    var e = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
    return new DexiePromise(function (t, r) {
      e.map(function (e) {
        return DexiePromise.resolve(e).then(t, r);
      });
    });
  },
  PSD: {
    get: function get() {
      return PSD;
    },
    set: function set(e) {
      return PSD = e;
    }
  },
  newPSD: newScope,
  usePSD: usePSD,
  scheduler: {
    get: function get() {
      return asap$1;
    },
    set: function set(e) {
      asap$1 = e;
    }
  },
  rejectionMapper: {
    get: function get() {
      return rejectionMapper;
    },
    set: function set(e) {
      rejectionMapper = e;
    }
  },
  follow: function follow(e, t) {
    return new DexiePromise(function (r, o) {
      return newScope(function (t, r) {
        var o = PSD;
        o.unhandleds = [], o.onunhandled = r, o.finalize = callBoth(function () {
          var e = this;
          run_at_end_of_this_or_next_physical_tick(function () {
            0 === e.unhandleds.length ? t() : r(e.unhandleds[0]);
          });
        }, o.finalize), e();
      }, t, r, o);
    });
  }
}), NativePromise && (NativePromise.allSettled && setProp(DexiePromise, "allSettled", function () {
  var e = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
  return new DexiePromise(function (t) {
    0 === e.length && t([]);
    var r = e.length,
      o = new Array(r);
    e.forEach(function (e, n) {
      return DexiePromise.resolve(e).then(function (e) {
        return o[n] = {
          status: "fulfilled",
          value: e
        };
      }, function (e) {
        return o[n] = {
          status: "rejected",
          reason: e
        };
      }).then(function () {
        return --r || t(o);
      });
    });
  });
}), NativePromise.any && "undefined" != typeof AggregateError && setProp(DexiePromise, "any", function () {
  var e = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
  return new DexiePromise(function (t, r) {
    0 === e.length && r(new AggregateError([]));
    var o = e.length,
      n = new Array(o);
    e.forEach(function (e, a) {
      return DexiePromise.resolve(e).then(function (e) {
        return t(e);
      }, function (e) {
        n[a] = e, --o || r(new AggregateError(n));
      });
    });
  });
}));
var task = {
    awaits: 0,
    echoes: 0,
    id: 0
  },
  taskCounter = 0,
  zoneStack = [],
  zoneEchoes = 0,
  totalEchoes = 0,
  zone_id_counter = 0;
function newScope(e, t, r, o) {
  var n = PSD,
    a = Object.create(n);
  a.parent = n, a.ref = 0, a.global = !1, a.id = ++zone_id_counter;
  var i = globalPSD.env;
  a.env = patchGlobalPromise ? {
    Promise: DexiePromise,
    PromiseProp: {
      value: DexiePromise,
      configurable: !0,
      writable: !0
    },
    all: DexiePromise.all,
    race: DexiePromise.race,
    allSettled: DexiePromise.allSettled,
    any: DexiePromise.any,
    resolve: DexiePromise.resolve,
    reject: DexiePromise.reject,
    nthen: getPatchedPromiseThen(i.nthen, a),
    gthen: getPatchedPromiseThen(i.gthen, a)
  } : {}, t && extend(a, t), ++n.ref, a.finalize = function () {
    --this.parent.ref || this.parent.finalize();
  };
  var s = usePSD(a, e, r, o);
  return 0 === a.ref && a.finalize(), s;
}
function incrementExpectedAwaits() {
  return task.id || (task.id = ++taskCounter), ++task.awaits, task.echoes += ZONE_ECHO_LIMIT, task.id;
}
function decrementExpectedAwaits(e) {
  !task.awaits || e && e !== task.id || (0 == --task.awaits && (task.id = 0), task.echoes = task.awaits * ZONE_ECHO_LIMIT);
}
function onPossibleParallellAsync(e) {
  return task.echoes && e && e.constructor === NativePromise ? (incrementExpectedAwaits(), e.then(function (e) {
    return decrementExpectedAwaits(), e;
  }, function (e) {
    return decrementExpectedAwaits(), rejection(e);
  })) : e;
}
function zoneEnterEcho(e) {
  ++totalEchoes, task.echoes && 0 != --task.echoes || (task.echoes = task.id = 0), zoneStack.push(PSD), switchToZone(e, !0);
}
function zoneLeaveEcho() {
  var e = zoneStack[zoneStack.length - 1];
  zoneStack.pop(), switchToZone(e, !1);
}
function switchToZone(e, t) {
  var r = PSD;
  if ((t ? !task.echoes || zoneEchoes++ && e === PSD : !zoneEchoes || --zoneEchoes && e === PSD) || enqueueNativeMicroTask(t ? zoneEnterEcho.bind(null, e) : zoneLeaveEcho), e !== PSD && (PSD = e, r === globalPSD && (globalPSD.env = snapShot()), patchGlobalPromise)) {
    var o = globalPSD.env.Promise,
      n = e.env;
    nativePromiseProto.then = n.nthen, o.prototype.then = n.gthen, (r.global || e.global) && (Object.defineProperty(_global, "Promise", n.PromiseProp), o.all = n.all, o.race = n.race, o.resolve = n.resolve, o.reject = n.reject, n.allSettled && (o.allSettled = n.allSettled), n.any && (o.any = n.any));
  }
}
function snapShot() {
  var e = _global.Promise;
  return patchGlobalPromise ? {
    Promise: e,
    PromiseProp: Object.getOwnPropertyDescriptor(_global, "Promise"),
    all: e.all,
    race: e.race,
    allSettled: e.allSettled,
    any: e.any,
    resolve: e.resolve,
    reject: e.reject,
    nthen: nativePromiseProto.then,
    gthen: e.prototype.then
  } : {};
}
function usePSD(e, t, r, o, n) {
  var a = PSD;
  try {
    return switchToZone(e, !0), t(r, o, n);
  } finally {
    switchToZone(a, !1);
  }
}
function enqueueNativeMicroTask(e) {
  nativePromiseThen.call(resolvedNativePromise, e);
}
function nativeAwaitCompatibleWrap(e, t, r) {
  return "function" != typeof e ? e : function () {
    var o = PSD;
    r && incrementExpectedAwaits(), switchToZone(t, !0);
    try {
      return e.apply(this, arguments);
    } finally {
      switchToZone(o, !1);
    }
  };
}
function getPatchedPromiseThen(e, t) {
  return function (r, o) {
    return e.call(this, nativeAwaitCompatibleWrap(r, t, !1), nativeAwaitCompatibleWrap(o, t, !1));
  };
}
-1 === ("" + nativePromiseThen).indexOf("[native code]") && (incrementExpectedAwaits = decrementExpectedAwaits = nop);
var UNHANDLEDREJECTION = "unhandledrejection";
function globalError(e, t) {
  var r;
  try {
    r = t.onuncatched(e);
  } catch (e) {}
  if (!1 !== r) try {
    var o,
      n = {
        promise: t,
        reason: e
      };
    if (_global.document && document.createEvent ? ((o = document.createEvent("Event")).initEvent(UNHANDLEDREJECTION, !0, !0), extend(o, n)) : _global.CustomEvent && extend(o = new CustomEvent(UNHANDLEDREJECTION, {
      detail: n
    }), n), o && _global.dispatchEvent && (dispatchEvent(o), !_global.PromiseRejectionEvent && _global.onunhandledrejection)) try {
      _global.onunhandledrejection(o);
    } catch (e) {}
    debug && o && !o.defaultPrevented && console.warn("Unhandled rejection: " + (e.stack || e));
  } catch (e) {}
}
var rejection = DexiePromise.reject;
function tempTransaction(e, t, r, o) {
  if (e._state.openComplete || PSD.letThrough) {
    var n = e._createTransaction(t, r, e._dbSchema);
    try {
      n.create();
    } catch (e) {
      return rejection(e);
    }
    return n._promise(t, function (e, t) {
      return newScope(function () {
        return PSD.trans = n, o(e, t, n);
      });
    }).then(function (e) {
      return n._completion.then(function () {
        return e;
      });
    });
  }
  if (!e._state.isBeingOpened) {
    if (!e._options.autoOpen) return rejection(new exceptions.DatabaseClosed());
    e.open().catch(nop);
  }
  return e._state.dbReadyPromise.then(function () {
    return tempTransaction(e, t, r, o);
  });
}
var DEXIE_VERSION = "3.0.2",
  maxString = String.fromCharCode(65535),
  minKey = -1 / 0,
  INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.",
  STRING_EXPECTED = "String expected.",
  connections = [],
  isIEOrEdge = "undefined" != typeof navigator && /(MSIE|Trident|Edge)/.test(navigator.userAgent),
  hasIEDeleteObjectStoreBug = isIEOrEdge,
  hangsOnDeleteLargeKeyRange = isIEOrEdge,
  dexieStackFrameFilter = function dexieStackFrameFilter(e) {
    return !/(dexie\.js|dexie\.min\.js)/.test(e);
  },
  DBNAMES_DB = "__dbnames",
  READONLY = "readonly",
  READWRITE = "readwrite";
function combine(e, t) {
  return e ? t ? function () {
    return e.apply(this, arguments) && t.apply(this, arguments);
  } : e : t;
}
var AnyRange = {
    type: 3,
    lower: -1 / 0,
    lowerOpen: !1,
    upper: [[]],
    upperOpen: !1
  },
  Table = function () {
    function e() {}
    return e.prototype._trans = function (e, t, r) {
      var o = this._tx || PSD.trans,
        n = this.name;
      function a(e, r, o) {
        if (!o.schema[n]) throw new exceptions.NotFound("Table " + n + " not part of transaction");
        return t(o.idbtrans, o);
      }
      var i = beginMicroTickScope();
      try {
        return o && o.db === this.db ? o === PSD.trans ? o._promise(e, a, r) : newScope(function () {
          return o._promise(e, a, r);
        }, {
          trans: o,
          transless: PSD.transless || PSD
        }) : tempTransaction(this.db, e, [this.name], a);
      } finally {
        i && endMicroTickScope();
      }
    }, e.prototype.get = function (e, t) {
      var r = this;
      return e && e.constructor === Object ? this.where(e).first(t) : this._trans("readonly", function (t) {
        return r.core.get({
          trans: t,
          key: e
        }).then(function (e) {
          return r.hook.reading.fire(e);
        });
      }).then(t);
    }, e.prototype.where = function (e) {
      if ("string" == typeof e) return new this.db.WhereClause(this, e);
      if (isArray(e)) return new this.db.WhereClause(this, "[" + e.join("+") + "]");
      var t = keys(e);
      if (1 === t.length) return this.where(t[0]).equals(e[t[0]]);
      var r = this.schema.indexes.concat(this.schema.primKey).filter(function (e) {
        return e.compound && t.every(function (t) {
          return e.keyPath.indexOf(t) >= 0;
        }) && e.keyPath.every(function (e) {
          return t.indexOf(e) >= 0;
        });
      })[0];
      if (r && this.db._maxKey !== maxString) return this.where(r.name).equals(r.keyPath.map(function (t) {
        return e[t];
      }));
      !r && debug && console.warn("The query " + JSON.stringify(e) + " on " + this.name + " would benefit of a compound index [" + t.join("+") + "]");
      var o = this.schema.idxByName,
        n = this.db._deps.indexedDB;
      function a(e, t) {
        try {
          return 0 === n.cmp(e, t);
        } catch (e) {
          return !1;
        }
      }
      var i = t.reduce(function (t, r) {
          var n = t[0],
            i = t[1],
            s = o[r],
            u = e[r];
          return [n || s, n || !s ? combine(i, s && s.multi ? function (e) {
            var t = getByKeyPath(e, r);
            return isArray(t) && t.some(function (e) {
              return a(u, e);
            });
          } : function (e) {
            return a(u, getByKeyPath(e, r));
          }) : i];
        }, [null, null]),
        s = i[0],
        u = i[1];
      return s ? this.where(s.name).equals(e[s.keyPath]).filter(u) : r ? this.filter(u) : this.where(t).equals("");
    }, e.prototype.filter = function (e) {
      return this.toCollection().and(e);
    }, e.prototype.count = function (e) {
      return this.toCollection().count(e);
    }, e.prototype.offset = function (e) {
      return this.toCollection().offset(e);
    }, e.prototype.limit = function (e) {
      return this.toCollection().limit(e);
    }, e.prototype.each = function (e) {
      return this.toCollection().each(e);
    }, e.prototype.toArray = function (e) {
      return this.toCollection().toArray(e);
    }, e.prototype.toCollection = function () {
      return new this.db.Collection(new this.db.WhereClause(this));
    }, e.prototype.orderBy = function (e) {
      return new this.db.Collection(new this.db.WhereClause(this, isArray(e) ? "[" + e.join("+") + "]" : e));
    }, e.prototype.reverse = function () {
      return this.toCollection().reverse();
    }, e.prototype.mapToClass = function (e) {
      this.schema.mappedClass = e;
      var t = function t(_t2) {
        if (!_t2) return _t2;
        var r = Object.create(e.prototype);
        for (var o in _t2) if (hasOwn(_t2, o)) try {
          r[o] = _t2[o];
        } catch (e) {}
        return r;
      };
      return this.schema.readHook && this.hook.reading.unsubscribe(this.schema.readHook), this.schema.readHook = t, this.hook("reading", t), e;
    }, e.prototype.defineClass = function () {
      return this.mapToClass(function (e) {
        extend(this, e);
      });
    }, e.prototype.add = function (e, t) {
      var r = this;
      return this._trans("readwrite", function (o) {
        return r.core.mutate({
          trans: o,
          type: "add",
          keys: null != t ? [t] : null,
          values: [e]
        });
      }).then(function (e) {
        return e.numFailures ? DexiePromise.reject(e.failures[0]) : e.lastResult;
      }).then(function (t) {
        if (!r.core.schema.primaryKey.outbound) try {
          setByKeyPath(e, r.core.schema.primaryKey.keyPath, t);
        } catch (e) {}
        return t;
      });
    }, e.prototype.update = function (e, t) {
      if ("object" != typeof t || isArray(t)) throw new exceptions.InvalidArgument("Modifications must be an object.");
      if ("object" != typeof e || isArray(e)) return this.where(":id").equals(e).modify(t);
      keys(t).forEach(function (r) {
        setByKeyPath(e, r, t[r]);
      });
      var r = getByKeyPath(e, this.schema.primKey.keyPath);
      return void 0 === r ? rejection(new exceptions.InvalidArgument("Given object does not contain its primary key")) : this.where(":id").equals(r).modify(t);
    }, e.prototype.put = function (e, t) {
      var r = this;
      return this._trans("readwrite", function (o) {
        return r.core.mutate({
          trans: o,
          type: "put",
          values: [e],
          keys: null != t ? [t] : null
        });
      }).then(function (e) {
        return e.numFailures ? DexiePromise.reject(e.failures[0]) : e.lastResult;
      }).then(function (t) {
        if (!r.core.schema.primaryKey.outbound) try {
          setByKeyPath(e, r.core.schema.primaryKey.keyPath, t);
        } catch (e) {}
        return t;
      });
    }, e.prototype.delete = function (e) {
      var t = this;
      return this._trans("readwrite", function (r) {
        return t.core.mutate({
          trans: r,
          type: "delete",
          keys: [e]
        });
      }).then(function (e) {
        return e.numFailures ? DexiePromise.reject(e.failures[0]) : void 0;
      });
    }, e.prototype.clear = function () {
      var e = this;
      return this._trans("readwrite", function (t) {
        return e.core.mutate({
          trans: t,
          type: "deleteRange",
          range: AnyRange
        });
      }).then(function (e) {
        return e.numFailures ? DexiePromise.reject(e.failures[0]) : void 0;
      });
    }, e.prototype.bulkGet = function (e) {
      var t = this;
      return this._trans("readonly", function (r) {
        return t.core.getMany({
          keys: e,
          trans: r
        }).then(function (e) {
          return e.map(function (e) {
            return t.hook.reading.fire(e);
          });
        });
      });
    }, e.prototype.bulkAdd = function (e, t, r) {
      var o = this,
        n = Array.isArray(t) ? t : void 0,
        a = (r = r || (n ? void 0 : t)) ? r.allKeys : void 0;
      return this._trans("readwrite", function (t) {
        if (!o.core.schema.primaryKey.outbound && n) throw new exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
        if (n && n.length !== e.length) throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
        var r = e.length;
        return o.core.mutate({
          trans: t,
          type: "add",
          keys: n,
          values: e,
          wantResults: a
        }).then(function (e) {
          var t = e.numFailures,
            n = e.results,
            i = e.lastResult,
            s = e.failures;
          if (0 === t) return a ? n : i;
          throw new BulkError(o.name + ".bulkAdd(): " + t + " of " + r + " operations failed", Object.keys(s).map(function (e) {
            return s[e];
          }));
        });
      });
    }, e.prototype.bulkPut = function (e, t, r) {
      var o = this,
        n = Array.isArray(t) ? t : void 0,
        a = (r = r || (n ? void 0 : t)) ? r.allKeys : void 0;
      return this._trans("readwrite", function (t) {
        if (!o.core.schema.primaryKey.outbound && n) throw new exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
        if (n && n.length !== e.length) throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
        var r = e.length;
        return o.core.mutate({
          trans: t,
          type: "put",
          keys: n,
          values: e,
          wantResults: a
        }).then(function (e) {
          var t = e.numFailures,
            n = e.results,
            i = e.lastResult,
            s = e.failures;
          if (0 === t) return a ? n : i;
          throw new BulkError(o.name + ".bulkPut(): " + t + " of " + r + " operations failed", Object.keys(s).map(function (e) {
            return s[e];
          }));
        });
      });
    }, e.prototype.bulkDelete = function (e) {
      var t = this,
        r = e.length;
      return this._trans("readwrite", function (r) {
        return t.core.mutate({
          trans: r,
          type: "delete",
          keys: e
        });
      }).then(function (e) {
        var o = e.numFailures,
          n = e.lastResult,
          a = e.failures;
        if (0 === o) return n;
        throw new BulkError(t.name + ".bulkDelete(): " + o + " of " + r + " operations failed", a);
      });
    }, e;
  }();
function Events(e) {
  var t = {},
    r = function r(_r2, o) {
      if (o) {
        for (var n = arguments.length, a = new Array(n - 1); --n;) a[n - 1] = arguments[n];
        return t[_r2].subscribe.apply(null, a), e;
      }
      if ("string" == typeof _r2) return t[_r2];
    };
  r.addEventType = a;
  for (var o = 1, n = arguments.length; o < n; ++o) a(arguments[o]);
  return r;
  function a(e, o, n) {
    if ("object" == typeof e) return i(e);
    o || (o = reverseStoppableEventChain), n || (n = nop);
    var a = {
      subscribers: [],
      fire: n,
      subscribe: function subscribe(e) {
        -1 === a.subscribers.indexOf(e) && (a.subscribers.push(e), a.fire = o(a.fire, e));
      },
      unsubscribe: function unsubscribe(e) {
        a.subscribers = a.subscribers.filter(function (t) {
          return t !== e;
        }), a.fire = a.subscribers.reduce(o, n);
      }
    };
    return t[e] = r[e] = a, a;
  }
  function i(e) {
    keys(e).forEach(function (t) {
      var r = e[t];
      if (isArray(r)) a(t, e[t][0], e[t][1]);else {
        if ("asap" !== r) throw new exceptions.InvalidArgument("Invalid event config");
        var o = a(t, mirror, function () {
          for (var e = arguments.length, t = new Array(e); e--;) t[e] = arguments[e];
          o.subscribers.forEach(function (e) {
            asap(function () {
              e.apply(null, t);
            });
          });
        });
      }
    });
  }
}
function makeClassConstructor(e, t) {
  return derive(t).from({
    prototype: e
  }), t;
}
function createTableConstructor(e) {
  return makeClassConstructor(Table.prototype, function (t, r, o) {
    this.db = e, this._tx = o, this.name = t, this.schema = r, this.hook = e._allTables[t] ? e._allTables[t].hook : Events(null, {
      creating: [hookCreatingChain, nop],
      reading: [pureFunctionChain, mirror],
      updating: [hookUpdatingChain, nop],
      deleting: [hookDeletingChain, nop]
    });
  });
}
function isPlainKeyRange(e, t) {
  return !(e.filter || e.algorithm || e.or) && (t ? e.justLimit : !e.replayFilter);
}
function addFilter(e, t) {
  e.filter = combine(e.filter, t);
}
function addReplayFilter(e, t, r) {
  var o = e.replayFilter;
  e.replayFilter = o ? function () {
    return combine(o(), t());
  } : t, e.justLimit = r && !o;
}
function addMatchFilter(e, t) {
  e.isMatch = combine(e.isMatch, t);
}
function getIndexOrStore(e, t) {
  if (e.isPrimKey) return t.primaryKey;
  var r = t.getIndexByKeyPath(e.index);
  if (!r) throw new exceptions.Schema("KeyPath " + e.index + " on object store " + t.name + " is not indexed");
  return r;
}
function openCursor(e, t, r) {
  var o = getIndexOrStore(e, t.schema);
  return t.openCursor({
    trans: r,
    values: !e.keysOnly,
    reverse: "prev" === e.dir,
    unique: !!e.unique,
    query: {
      index: o,
      range: e.range
    }
  });
}
function iter(e, t, r, o) {
  var n = e.replayFilter ? combine(e.filter, e.replayFilter()) : e.filter;
  if (e.or) {
    var a = {},
      i = function i(e, r, o) {
        if (!n || n(r, o, function (e) {
          return r.stop(e);
        }, function (e) {
          return r.fail(e);
        })) {
          var i = r.primaryKey,
            s = "" + i;
          "[object ArrayBuffer]" === s && (s = "" + new Uint8Array(i)), hasOwn(a, s) || (a[s] = !0, t(e, r, o));
        }
      };
    return Promise.all([e.or._iterate(i, r), iterate(openCursor(e, o, r), e.algorithm, i, !e.keysOnly && e.valueMapper)]);
  }
  return iterate(openCursor(e, o, r), combine(e.algorithm, n), t, !e.keysOnly && e.valueMapper);
}
function iterate(e, t, r, o) {
  var n = wrap(o ? function (e, t, n) {
    return r(o(e), t, n);
  } : r);
  return e.then(function (e) {
    if (e) return e.start(function () {
      var r = function r() {
        return e.continue();
      };
      t && !t(e, function (e) {
        return r = e;
      }, function (t) {
        e.stop(t), r = nop;
      }, function (t) {
        e.fail(t), r = nop;
      }) || n(e.value, e, function (e) {
        return r = e;
      }), r();
    });
  });
}
var Collection$1 = function () {
  function e() {}
  return e.prototype._read = function (e, t) {
    var r = this._ctx;
    return r.error ? r.table._trans(null, rejection.bind(null, r.error)) : r.table._trans("readonly", e).then(t);
  }, e.prototype._write = function (e) {
    var t = this._ctx;
    return t.error ? t.table._trans(null, rejection.bind(null, t.error)) : t.table._trans("readwrite", e, "locked");
  }, e.prototype._addAlgorithm = function (e) {
    var t = this._ctx;
    t.algorithm = combine(t.algorithm, e);
  }, e.prototype._iterate = function (e, t) {
    return iter(this._ctx, e, t, this._ctx.table.core);
  }, e.prototype.clone = function (e) {
    var t = Object.create(this.constructor.prototype),
      r = Object.create(this._ctx);
    return e && extend(r, e), t._ctx = r, t;
  }, e.prototype.raw = function () {
    return this._ctx.valueMapper = null, this;
  }, e.prototype.each = function (e) {
    var t = this._ctx;
    return this._read(function (r) {
      return iter(t, e, r, t.table.core);
    });
  }, e.prototype.count = function (e) {
    var t = this;
    return this._read(function (e) {
      var r = t._ctx,
        o = r.table.core;
      if (isPlainKeyRange(r, !0)) return o.count({
        trans: e,
        query: {
          index: getIndexOrStore(r, o.schema),
          range: r.range
        }
      }).then(function (e) {
        return Math.min(e, r.limit);
      });
      var n = 0;
      return iter(r, function () {
        return ++n, !1;
      }, e, o).then(function () {
        return n;
      });
    }).then(e);
  }, e.prototype.sortBy = function (e, t) {
    var r = e.split(".").reverse(),
      o = r[0],
      n = r.length - 1;
    function a(e, t) {
      return t ? a(e[r[t]], t - 1) : e[o];
    }
    var i = "next" === this._ctx.dir ? 1 : -1;
    function s(e, t) {
      var r = a(e, n),
        o = a(t, n);
      return r < o ? -i : r > o ? i : 0;
    }
    return this.toArray(function (e) {
      return e.sort(s);
    }).then(t);
  }, e.prototype.toArray = function (e) {
    var t = this;
    return this._read(function (e) {
      var r = t._ctx;
      if ("next" === r.dir && isPlainKeyRange(r, !0) && r.limit > 0) {
        var o = r.valueMapper,
          n = getIndexOrStore(r, r.table.core.schema);
        return r.table.core.query({
          trans: e,
          limit: r.limit,
          values: !0,
          query: {
            index: n,
            range: r.range
          }
        }).then(function (e) {
          var t = e.result;
          return o ? t.map(o) : t;
        });
      }
      var a = [];
      return iter(r, function (e) {
        return a.push(e);
      }, e, r.table.core).then(function () {
        return a;
      });
    }, e);
  }, e.prototype.offset = function (e) {
    var t = this._ctx;
    return e <= 0 || (t.offset += e, isPlainKeyRange(t) ? addReplayFilter(t, function () {
      var t = e;
      return function (e, r) {
        return 0 === t || (1 === t ? (--t, !1) : (r(function () {
          e.advance(t), t = 0;
        }), !1));
      };
    }) : addReplayFilter(t, function () {
      var t = e;
      return function () {
        return --t < 0;
      };
    })), this;
  }, e.prototype.limit = function (e) {
    return this._ctx.limit = Math.min(this._ctx.limit, e), addReplayFilter(this._ctx, function () {
      var t = e;
      return function (e, r, o) {
        return --t <= 0 && r(o), t >= 0;
      };
    }, !0), this;
  }, e.prototype.until = function (e, t) {
    return addFilter(this._ctx, function (r, o, n) {
      return !e(r.value) || (o(n), t);
    }), this;
  }, e.prototype.first = function (e) {
    return this.limit(1).toArray(function (e) {
      return e[0];
    }).then(e);
  }, e.prototype.last = function (e) {
    return this.reverse().first(e);
  }, e.prototype.filter = function (e) {
    return addFilter(this._ctx, function (t) {
      return e(t.value);
    }), addMatchFilter(this._ctx, e), this;
  }, e.prototype.and = function (e) {
    return this.filter(e);
  }, e.prototype.or = function (e) {
    return new this.db.WhereClause(this._ctx.table, e, this);
  }, e.prototype.reverse = function () {
    return this._ctx.dir = "prev" === this._ctx.dir ? "next" : "prev", this._ondirectionchange && this._ondirectionchange(this._ctx.dir), this;
  }, e.prototype.desc = function () {
    return this.reverse();
  }, e.prototype.eachKey = function (e) {
    var t = this._ctx;
    return t.keysOnly = !t.isMatch, this.each(function (t, r) {
      e(r.key, r);
    });
  }, e.prototype.eachUniqueKey = function (e) {
    return this._ctx.unique = "unique", this.eachKey(e);
  }, e.prototype.eachPrimaryKey = function (e) {
    var t = this._ctx;
    return t.keysOnly = !t.isMatch, this.each(function (t, r) {
      e(r.primaryKey, r);
    });
  }, e.prototype.keys = function (e) {
    var t = this._ctx;
    t.keysOnly = !t.isMatch;
    var r = [];
    return this.each(function (e, t) {
      r.push(t.key);
    }).then(function () {
      return r;
    }).then(e);
  }, e.prototype.primaryKeys = function (e) {
    var t = this._ctx;
    if ("next" === t.dir && isPlainKeyRange(t, !0) && t.limit > 0) return this._read(function (e) {
      var r = getIndexOrStore(t, t.table.core.schema);
      return t.table.core.query({
        trans: e,
        values: !1,
        limit: t.limit,
        query: {
          index: r,
          range: t.range
        }
      });
    }).then(function (e) {
      return e.result;
    }).then(e);
    t.keysOnly = !t.isMatch;
    var r = [];
    return this.each(function (e, t) {
      r.push(t.primaryKey);
    }).then(function () {
      return r;
    }).then(e);
  }, e.prototype.uniqueKeys = function (e) {
    return this._ctx.unique = "unique", this.keys(e);
  }, e.prototype.firstKey = function (e) {
    return this.limit(1).keys(function (e) {
      return e[0];
    }).then(e);
  }, e.prototype.lastKey = function (e) {
    return this.reverse().firstKey(e);
  }, e.prototype.distinct = function () {
    var e = this._ctx,
      t = e.index && e.table.schema.idxByName[e.index];
    if (!t || !t.multi) return this;
    var r = {};
    return addFilter(this._ctx, function (e) {
      var t = e.primaryKey.toString(),
        o = hasOwn(r, t);
      return r[t] = !0, !o;
    }), this;
  }, e.prototype.modify = function (e) {
    var t = this,
      r = this._ctx;
    return this._write(function (o) {
      var n;
      if ("function" == typeof e) n = e;else {
        var a = keys(e),
          i = a.length;
        n = function n(t) {
          for (var r = !1, o = 0; o < i; ++o) {
            var n = a[o],
              s = e[n];
            getByKeyPath(t, n) !== s && (setByKeyPath(t, n, s), r = !0);
          }
          return r;
        };
      }
      var s = r.table.core,
        u = s.schema.primaryKey,
        l = u.outbound,
        c = u.extractKey,
        p = "testmode" in Dexie ? 1 : 2e3,
        g = t.db.core.cmp,
        d = [],
        f = 0,
        h = [],
        y = function y(e, t) {
          var r = t.failures,
            o = t.numFailures;
          f += e - o;
          for (var n = 0, a = keys(r); n < a.length; n++) {
            var i = a[n];
            d.push(r[i]);
          }
        };
      return t.clone().primaryKeys().then(function (e) {
        var t = function t(r) {
          var a = Math.min(p, e.length - r);
          return s.getMany({
            trans: o,
            keys: e.slice(r, r + a)
          }).then(function (i) {
            for (var u = [], d = [], f = l ? [] : null, h = [], b = 0; b < a; ++b) {
              var m = i[b],
                _ = {
                  value: deepClone$1(m),
                  primKey: e[r + b]
                };
              !1 !== n.call(_, _.value, _) && (null == _.value ? h.push(e[r + b]) : l || 0 === g(c(m), c(_.value)) ? (d.push(_.value), l && f.push(e[r + b])) : (h.push(e[r + b]), u.push(_.value)));
            }
            return Promise.resolve(u.length > 0 && s.mutate({
              trans: o,
              type: "add",
              values: u
            }).then(function (e) {
              for (var t in e.failures) h.splice(parseInt(t), 1);
              y(u.length, e);
            })).then(function (e) {
              return d.length > 0 && s.mutate({
                trans: o,
                type: "put",
                keys: f,
                values: d
              }).then(function (e) {
                return y(d.length, e);
              });
            }).then(function () {
              return h.length > 0 && s.mutate({
                trans: o,
                type: "delete",
                keys: h
              }).then(function (e) {
                return y(h.length, e);
              });
            }).then(function () {
              return e.length > r + a && t(r + p);
            });
          });
        };
        return t(0).then(function () {
          if (d.length > 0) throw new ModifyError("Error modifying one or more objects", d, f, h);
          return e.length;
        });
      });
    });
  }, e.prototype.delete = function () {
    var e = this._ctx,
      t = e.range;
    return isPlainKeyRange(e) && (e.isPrimKey && !hangsOnDeleteLargeKeyRange || 3 === t.type) ? this._write(function (r) {
      var o = e.table.core.schema.primaryKey,
        n = t;
      return e.table.core.count({
        trans: r,
        query: {
          index: o,
          range: n
        }
      }).then(function (t) {
        return e.table.core.mutate({
          trans: r,
          type: "deleteRange",
          range: n
        }).then(function (e) {
          var r = e.failures;
          e.lastResult, e.results;
          var o = e.numFailures;
          if (o) throw new ModifyError("Could not delete some values", Object.keys(r).map(function (e) {
            return r[e];
          }), t - o);
          return t - o;
        });
      });
    }) : this.modify(function (e, t) {
      return t.value = null;
    });
  }, e;
}();
function createCollectionConstructor(e) {
  return makeClassConstructor(Collection$1.prototype, function (t, r) {
    this.db = e;
    var o = AnyRange,
      n = null;
    if (r) try {
      o = r();
    } catch (e) {
      n = e;
    }
    var a = t._ctx,
      i = a.table,
      s = i.hook.reading.fire;
    this._ctx = {
      table: i,
      index: a.index,
      isPrimKey: !a.index || i.schema.primKey.keyPath && a.index === i.schema.primKey.name,
      range: o,
      keysOnly: !1,
      dir: "next",
      unique: "",
      algorithm: null,
      filter: null,
      replayFilter: null,
      justLimit: !0,
      isMatch: null,
      offset: 0,
      limit: 1 / 0,
      error: n,
      or: a.or,
      valueMapper: s !== mirror ? s : null
    };
  });
}
function simpleCompare(e, t) {
  return e < t ? -1 : e === t ? 0 : 1;
}
function simpleCompareReverse(e, t) {
  return e > t ? -1 : e === t ? 0 : 1;
}
function fail(e, t, r) {
  var o = e instanceof WhereClause ? new e.Collection(e) : e;
  return o._ctx.error = r ? new r(t) : new TypeError(t), o;
}
function emptyCollection(e) {
  return new e.Collection(e, function () {
    return rangeEqual("");
  }).limit(0);
}
function upperFactory(e) {
  return "next" === e ? function (e) {
    return e.toUpperCase();
  } : function (e) {
    return e.toLowerCase();
  };
}
function lowerFactory(e) {
  return "next" === e ? function (e) {
    return e.toLowerCase();
  } : function (e) {
    return e.toUpperCase();
  };
}
function nextCasing(e, t, r, o, n, a) {
  for (var i = Math.min(e.length, o.length), s = -1, u = 0; u < i; ++u) {
    var l = t[u];
    if (l !== o[u]) return n(e[u], r[u]) < 0 ? e.substr(0, u) + r[u] + r.substr(u + 1) : n(e[u], o[u]) < 0 ? e.substr(0, u) + o[u] + r.substr(u + 1) : s >= 0 ? e.substr(0, s) + t[s] + r.substr(s + 1) : null;
    n(e[u], l) < 0 && (s = u);
  }
  return i < o.length && "next" === a ? e + r.substr(e.length) : i < e.length && "prev" === a ? e.substr(0, r.length) : s < 0 ? null : e.substr(0, s) + o[s] + r.substr(s + 1);
}
function addIgnoreCaseAlgorithm(e, t, r, o) {
  var n,
    a,
    i,
    s,
    u,
    l,
    c,
    p = r.length;
  if (!r.every(function (e) {
    return "string" == typeof e;
  })) return fail(e, STRING_EXPECTED);
  function g(e) {
    n = upperFactory(e), a = lowerFactory(e), i = "next" === e ? simpleCompare : simpleCompareReverse;
    var t = r.map(function (e) {
      return {
        lower: a(e),
        upper: n(e)
      };
    }).sort(function (e, t) {
      return i(e.lower, t.lower);
    });
    s = t.map(function (e) {
      return e.upper;
    }), u = t.map(function (e) {
      return e.lower;
    }), l = e, c = "next" === e ? "" : o;
  }
  g("next");
  var d = new e.Collection(e, function () {
    return createRange(s[0], u[p - 1] + o);
  });
  d._ondirectionchange = function (e) {
    g(e);
  };
  var f = 0;
  return d._addAlgorithm(function (e, r, o) {
    var n = e.key;
    if ("string" != typeof n) return !1;
    var g = a(n);
    if (t(g, u, f)) return !0;
    for (var d = null, h = f; h < p; ++h) {
      var y = nextCasing(n, g, s[h], u[h], i, l);
      null === y && null === d ? f = h + 1 : (null === d || i(d, y) > 0) && (d = y);
    }
    return r(null !== d ? function () {
      e.continue(d + c);
    } : o), !1;
  }), d;
}
function createRange(e, t, r, o) {
  return {
    type: 2,
    lower: e,
    upper: t,
    lowerOpen: r,
    upperOpen: o
  };
}
function rangeEqual(e) {
  return {
    type: 1,
    lower: e,
    upper: e
  };
}
var WhereClause = function () {
  function e() {}
  return Object.defineProperty(e.prototype, "Collection", {
    get: function get() {
      return this._ctx.table.db.Collection;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.between = function (e, t, r, o) {
    r = !1 !== r, o = !0 === o;
    try {
      return this._cmp(e, t) > 0 || 0 === this._cmp(e, t) && (r || o) && (!r || !o) ? emptyCollection(this) : new this.Collection(this, function () {
        return createRange(e, t, !r, !o);
      });
    } catch (e) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
  }, e.prototype.equals = function (e) {
    return new this.Collection(this, function () {
      return rangeEqual(e);
    });
  }, e.prototype.above = function (e) {
    return null == e ? fail(this, INVALID_KEY_ARGUMENT) : new this.Collection(this, function () {
      return createRange(e, void 0, !0);
    });
  }, e.prototype.aboveOrEqual = function (e) {
    return null == e ? fail(this, INVALID_KEY_ARGUMENT) : new this.Collection(this, function () {
      return createRange(e, void 0, !1);
    });
  }, e.prototype.below = function (e) {
    return null == e ? fail(this, INVALID_KEY_ARGUMENT) : new this.Collection(this, function () {
      return createRange(void 0, e, !1, !0);
    });
  }, e.prototype.belowOrEqual = function (e) {
    return null == e ? fail(this, INVALID_KEY_ARGUMENT) : new this.Collection(this, function () {
      return createRange(void 0, e);
    });
  }, e.prototype.startsWith = function (e) {
    return "string" != typeof e ? fail(this, STRING_EXPECTED) : this.between(e, e + maxString, !0, !0);
  }, e.prototype.startsWithIgnoreCase = function (e) {
    return "" === e ? this.startsWith(e) : addIgnoreCaseAlgorithm(this, function (e, t) {
      return 0 === e.indexOf(t[0]);
    }, [e], maxString);
  }, e.prototype.equalsIgnoreCase = function (e) {
    return addIgnoreCaseAlgorithm(this, function (e, t) {
      return e === t[0];
    }, [e], "");
  }, e.prototype.anyOfIgnoreCase = function () {
    var e = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    return 0 === e.length ? emptyCollection(this) : addIgnoreCaseAlgorithm(this, function (e, t) {
      return -1 !== t.indexOf(e);
    }, e, "");
  }, e.prototype.startsWithAnyOfIgnoreCase = function () {
    var e = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    return 0 === e.length ? emptyCollection(this) : addIgnoreCaseAlgorithm(this, function (e, t) {
      return t.some(function (t) {
        return 0 === e.indexOf(t);
      });
    }, e, maxString);
  }, e.prototype.anyOf = function () {
    var e = this,
      t = getArrayOf.apply(NO_CHAR_ARRAY, arguments),
      r = this._cmp;
    try {
      t.sort(r);
    } catch (e) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
    if (0 === t.length) return emptyCollection(this);
    var o = new this.Collection(this, function () {
      return createRange(t[0], t[t.length - 1]);
    });
    o._ondirectionchange = function (o) {
      r = "next" === o ? e._ascending : e._descending, t.sort(r);
    };
    var n = 0;
    return o._addAlgorithm(function (e, o, a) {
      for (var i = e.key; r(i, t[n]) > 0;) if (++n === t.length) return o(a), !1;
      return 0 === r(i, t[n]) || (o(function () {
        e.continue(t[n]);
      }), !1);
    }), o;
  }, e.prototype.notEqual = function (e) {
    return this.inAnyRange([[minKey, e], [e, this.db._maxKey]], {
      includeLowers: !1,
      includeUppers: !1
    });
  }, e.prototype.noneOf = function () {
    var e = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    if (0 === e.length) return new this.Collection(this);
    try {
      e.sort(this._ascending);
    } catch (e) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
    var t = e.reduce(function (e, t) {
      return e ? e.concat([[e[e.length - 1][1], t]]) : [[minKey, t]];
    }, null);
    return t.push([e[e.length - 1], this.db._maxKey]), this.inAnyRange(t, {
      includeLowers: !1,
      includeUppers: !1
    });
  }, e.prototype.inAnyRange = function (e, t) {
    var r = this,
      o = this._cmp,
      n = this._ascending,
      a = this._descending,
      i = this._min,
      s = this._max;
    if (0 === e.length) return emptyCollection(this);
    if (!e.every(function (e) {
      return void 0 !== e[0] && void 0 !== e[1] && n(e[0], e[1]) <= 0;
    })) return fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", exceptions.InvalidArgument);
    var u = !t || !1 !== t.includeLowers,
      l = t && !0 === t.includeUppers;
    var c,
      p = n;
    function g(e, t) {
      return p(e[0], t[0]);
    }
    try {
      (c = e.reduce(function (e, t) {
        for (var r = 0, n = e.length; r < n; ++r) {
          var a = e[r];
          if (o(t[0], a[1]) < 0 && o(t[1], a[0]) > 0) {
            a[0] = i(a[0], t[0]), a[1] = s(a[1], t[1]);
            break;
          }
        }
        return r === n && e.push(t), e;
      }, [])).sort(g);
    } catch (e) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
    var d = 0,
      f = l ? function (e) {
        return n(e, c[d][1]) > 0;
      } : function (e) {
        return n(e, c[d][1]) >= 0;
      },
      h = u ? function (e) {
        return a(e, c[d][0]) > 0;
      } : function (e) {
        return a(e, c[d][0]) >= 0;
      };
    var y = f,
      b = new this.Collection(this, function () {
        return createRange(c[0][0], c[c.length - 1][1], !u, !l);
      });
    return b._ondirectionchange = function (e) {
      "next" === e ? (y = f, p = n) : (y = h, p = a), c.sort(g);
    }, b._addAlgorithm(function (e, t, o) {
      for (var a = e.key; y(a);) if (++d === c.length) return t(o), !1;
      return !!function (e) {
        return !f(e) && !h(e);
      }(a) || (0 === r._cmp(a, c[d][1]) || 0 === r._cmp(a, c[d][0]) || t(function () {
        p === n ? e.continue(c[d][0]) : e.continue(c[d][1]);
      }), !1);
    }), b;
  }, e.prototype.startsWithAnyOf = function () {
    var e = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    return e.every(function (e) {
      return "string" == typeof e;
    }) ? 0 === e.length ? emptyCollection(this) : this.inAnyRange(e.map(function (e) {
      return [e, e + maxString];
    })) : fail(this, "startsWithAnyOf() only works with strings");
  }, e;
}();
function createWhereClauseConstructor(e) {
  return makeClassConstructor(WhereClause.prototype, function (t, r, o) {
    this.db = e, this._ctx = {
      table: t,
      index: ":id" === r ? null : r,
      or: o
    };
    var n = e._deps.indexedDB;
    if (!n) throw new exceptions.MissingAPI("indexedDB API missing");
    this._cmp = this._ascending = n.cmp.bind(n), this._descending = function (e, t) {
      return n.cmp(t, e);
    }, this._max = function (e, t) {
      return n.cmp(e, t) > 0 ? e : t;
    }, this._min = function (e, t) {
      return n.cmp(e, t) < 0 ? e : t;
    }, this._IDBKeyRange = e._deps.IDBKeyRange;
  });
}
function safariMultiStoreFix(e) {
  return 1 === e.length ? e[0] : e;
}
function getMaxKey(e) {
  try {
    return e.only([[]]), [[]];
  } catch (e) {
    return maxString;
  }
}
function eventRejectHandler(e) {
  return wrap(function (t) {
    return preventDefault(t), e(t.target.error), !1;
  });
}
function preventDefault(e) {
  e.stopPropagation && e.stopPropagation(), e.preventDefault && e.preventDefault();
}
var Transaction = function () {
  function e() {}
  return e.prototype._lock = function () {
    return assert(!PSD.global), ++this._reculock, 1 !== this._reculock || PSD.global || (PSD.lockOwnerFor = this), this;
  }, e.prototype._unlock = function () {
    if (assert(!PSD.global), 0 == --this._reculock) for (PSD.global || (PSD.lockOwnerFor = null); this._blockedFuncs.length > 0 && !this._locked();) {
      var e = this._blockedFuncs.shift();
      try {
        usePSD(e[1], e[0]);
      } catch (e) {}
    }
    return this;
  }, e.prototype._locked = function () {
    return this._reculock && PSD.lockOwnerFor !== this;
  }, e.prototype.create = function (e) {
    var t = this;
    if (!this.mode) return this;
    var r = this.db.idbdb,
      o = this.db._state.dbOpenError;
    if (assert(!this.idbtrans), !e && !r) switch (o && o.name) {
      case "DatabaseClosedError":
        throw new exceptions.DatabaseClosed(o);
      case "MissingAPIError":
        throw new exceptions.MissingAPI(o.message, o);
      default:
        throw new exceptions.OpenFailed(o);
    }
    if (!this.active) throw new exceptions.TransactionInactive();
    return assert(null === this._completion._state), (e = this.idbtrans = e || r.transaction(safariMultiStoreFix(this.storeNames), this.mode)).onerror = wrap(function (r) {
      preventDefault(r), t._reject(e.error);
    }), e.onabort = wrap(function (r) {
      preventDefault(r), t.active && t._reject(new exceptions.Abort(e.error)), t.active = !1, t.on("abort").fire(r);
    }), e.oncomplete = wrap(function () {
      t.active = !1, t._resolve();
    }), this;
  }, e.prototype._promise = function (e, t, r) {
    var o = this;
    if ("readwrite" === e && "readwrite" !== this.mode) return rejection(new exceptions.ReadOnly("Transaction is readonly"));
    if (!this.active) return rejection(new exceptions.TransactionInactive());
    if (this._locked()) return new DexiePromise(function (n, a) {
      o._blockedFuncs.push([function () {
        o._promise(e, t, r).then(n, a);
      }, PSD]);
    });
    if (r) return newScope(function () {
      var e = new DexiePromise(function (e, r) {
        o._lock();
        var n = t(e, r, o);
        n && n.then && n.then(e, r);
      });
      return e.finally(function () {
        return o._unlock();
      }), e._lib = !0, e;
    });
    var n = new DexiePromise(function (e, r) {
      var n = t(e, r, o);
      n && n.then && n.then(e, r);
    });
    return n._lib = !0, n;
  }, e.prototype._root = function () {
    return this.parent ? this.parent._root() : this;
  }, e.prototype.waitFor = function (e) {
    var t = this._root(),
      r = DexiePromise.resolve(e);
    if (t._waitingFor) t._waitingFor = t._waitingFor.then(function () {
      return r;
    });else {
      t._waitingFor = r, t._waitingQueue = [];
      var o = t.idbtrans.objectStore(t.storeNames[0]);
      !function e() {
        for (++t._spinCount; t._waitingQueue.length;) t._waitingQueue.shift()();
        t._waitingFor && (o.get(-1 / 0).onsuccess = e);
      }();
    }
    var n = t._waitingFor;
    return new DexiePromise(function (e, o) {
      r.then(function (r) {
        return t._waitingQueue.push(wrap(e.bind(null, r)));
      }, function (e) {
        return t._waitingQueue.push(wrap(o.bind(null, e)));
      }).finally(function () {
        t._waitingFor === n && (t._waitingFor = null);
      });
    });
  }, e.prototype.abort = function () {
    this.active && this._reject(new exceptions.Abort()), this.active = !1;
  }, e.prototype.table = function (e) {
    var t = this._memoizedTables || (this._memoizedTables = {});
    if (hasOwn(t, e)) return t[e];
    var r = this.schema[e];
    if (!r) throw new exceptions.NotFound("Table " + e + " not part of transaction");
    var o = new this.db.Table(e, r, this);
    return o.core = this.db.core.table(e), t[e] = o, o;
  }, e;
}();
function createTransactionConstructor(e) {
  return makeClassConstructor(Transaction.prototype, function (t, r, o, n) {
    var a = this;
    this.db = e, this.mode = t, this.storeNames = r, this.schema = o, this.idbtrans = null, this.on = Events(this, "complete", "error", "abort"), this.parent = n || null, this.active = !0, this._reculock = 0, this._blockedFuncs = [], this._resolve = null, this._reject = null, this._waitingFor = null, this._waitingQueue = null, this._spinCount = 0, this._completion = new DexiePromise(function (e, t) {
      a._resolve = e, a._reject = t;
    }), this._completion.then(function () {
      a.active = !1, a.on.complete.fire();
    }, function (e) {
      var t = a.active;
      return a.active = !1, a.on.error.fire(e), a.parent ? a.parent._reject(e) : t && a.idbtrans && a.idbtrans.abort(), rejection(e);
    });
  });
}
function createIndexSpec(e, t, r, o, n, a, i) {
  return {
    name: e,
    keyPath: t,
    unique: r,
    multi: o,
    auto: n,
    compound: a,
    src: (r && !i ? "&" : "") + (o ? "*" : "") + (n ? "++" : "") + nameFromKeyPath(t)
  };
}
function nameFromKeyPath(e) {
  return "string" == typeof e ? e : e ? "[" + [].join.call(e, "+") + "]" : "";
}
function createTableSchema(e, t, r) {
  return {
    name: e,
    primKey: t,
    indexes: r,
    mappedClass: null,
    idxByName: arrayToObject(r, function (e) {
      return [e.name, e];
    })
  };
}
function getKeyExtractor(e) {
  return null == e ? function () {} : "string" == typeof e ? getSinglePathKeyExtractor(e) : function (t) {
    return getByKeyPath(t, e);
  };
}
function getSinglePathKeyExtractor(e) {
  return 1 === e.split(".").length ? function (t) {
    return t[e];
  } : function (t) {
    return getByKeyPath(t, e);
  };
}
function getEffectiveKeys(e, t) {
  return "delete" === t.type ? t.keys : t.keys || t.values.map(e.extractKey);
}
function getExistingValues(e, t, r) {
  return "add" === t.type ? Promise.resolve(new Array(t.values.length)) : e.getMany({
    trans: t.trans,
    keys: r
  });
}
function arrayify(e) {
  return [].slice.call(e);
}
var _id_counter = 0;
function getKeyPathAlias(e) {
  return null == e ? ":id" : "string" == typeof e ? e : "[" + e.join("+") + "]";
}
function createDBCore(e, t, r, o) {
  var n = t.cmp.bind(t);
  function a(e) {
    if (3 === e.type) return null;
    if (4 === e.type) throw new Error("Cannot convert never type to IDBKeyRange");
    var t = e.lower,
      o = e.upper,
      n = e.lowerOpen,
      a = e.upperOpen;
    return void 0 === t ? void 0 === o ? null : r.upperBound(o, !!a) : void 0 === o ? r.lowerBound(t, !!n) : r.bound(t, o, !!n, !!a);
  }
  var i = function (e, t) {
      var r = arrayify(e.objectStoreNames);
      return {
        schema: {
          name: e.name,
          tables: r.map(function (e) {
            return t.objectStore(e);
          }).map(function (e) {
            var t = e.keyPath,
              r = e.autoIncrement,
              o = isArray(t),
              n = null == t,
              a = {},
              i = {
                name: e.name,
                primaryKey: {
                  name: null,
                  isPrimaryKey: !0,
                  outbound: n,
                  compound: o,
                  keyPath: t,
                  autoIncrement: r,
                  unique: !0,
                  extractKey: getKeyExtractor(t)
                },
                indexes: arrayify(e.indexNames).map(function (t) {
                  return e.index(t);
                }).map(function (e) {
                  var t = e.name,
                    r = e.unique,
                    o = e.multiEntry,
                    n = e.keyPath,
                    i = {
                      name: t,
                      compound: isArray(n),
                      keyPath: n,
                      unique: r,
                      multiEntry: o,
                      extractKey: getKeyExtractor(n)
                    };
                  return a[getKeyPathAlias(n)] = i, i;
                }),
                getIndexByKeyPath: function getIndexByKeyPath(e) {
                  return a[getKeyPathAlias(e)];
                }
              };
            return a[":id"] = i.primaryKey, null != t && (a[getKeyPathAlias(t)] = i.primaryKey), i;
          })
        },
        hasGetAll: r.length > 0 && "getAll" in t.objectStore(r[0]) && !("undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
      };
    }(e, o),
    s = i.schema,
    u = i.hasGetAll,
    l = s.tables.map(function (e) {
      return function (e) {
        var t = e.name;
        return {
          name: t,
          schema: e,
          mutate: function mutate(r) {
            var o = r.trans,
              n = r.type,
              i = r.keys,
              s = r.values,
              u = r.range,
              l = r.wantResults;
            return new Promise(function (r, c) {
              r = wrap(r);
              var p = o.objectStore(t),
                g = null == p.keyPath,
                d = "put" === n || "add" === n;
              if (!d && "delete" !== n && "deleteRange" !== n) throw new Error("Invalid operation type: " + n);
              var f = (i || s || {
                length: 1
              }).length;
              if (i && s && i.length !== s.length) throw new Error("Given keys array must have same length as given values array.");
              if (0 === f) return r({
                numFailures: 0,
                failures: {},
                results: [],
                lastResult: void 0
              });
              var h,
                y = l && __spreadArrays(i || getEffectiveKeys(e.primaryKey, {
                  type: n,
                  keys: i,
                  values: s
                })),
                b = [],
                m = 0,
                _ = function _(e) {
                  ++m, preventDefault(e), y && (y[e.target._reqno] = void 0), b[e.target._reqno] = e.target.error;
                },
                v = function v(e) {
                  var t = e.target;
                  y[t._reqno] = t.result;
                };
              if ("deleteRange" === n) {
                if (4 === u.type) return r({
                  numFailures: m,
                  failures: b,
                  results: y,
                  lastResult: void 0
                });
                h = 3 === u.type ? p.clear() : p.delete(a(u));
              } else {
                var E = d ? g ? [s, i] : [s, null] : [i, null],
                  S = E[0],
                  R = E[1];
                if (d) for (var w = 0; w < f; ++w) (h = R && void 0 !== R[w] ? p[n](S[w], R[w]) : p[n](S[w]))._reqno = w, y && void 0 === y[w] && (h.onsuccess = v), h.onerror = _;else for (w = 0; w < f; ++w) (h = p[n](S[w]))._reqno = w, h.onerror = _;
              }
              var T = function T(e) {
                var t = e.target.result;
                y && (y[f - 1] = t), r({
                  numFailures: m,
                  failures: b,
                  results: y,
                  lastResult: t
                });
              };
              h.onerror = function (e) {
                _(e), T(e);
              }, h.onsuccess = T;
            });
          },
          getMany: function getMany(e) {
            var r = e.trans,
              o = e.keys;
            return new Promise(function (e, n) {
              e = wrap(e);
              for (var a, i = r.objectStore(t), s = o.length, u = new Array(s), l = 0, c = 0, p = function p(t) {
                  var r = t.target;
                  u[r._pos] = r.result, ++c === l && e(u);
                }, g = eventRejectHandler(n), d = 0; d < s; ++d) null != o[d] && ((a = i.get(o[d]))._pos = d, a.onsuccess = p, a.onerror = g, ++l);
              0 === l && e(u);
            });
          },
          get: function get(e) {
            var r = e.trans,
              o = e.key;
            return new Promise(function (e, n) {
              e = wrap(e);
              var a = r.objectStore(t).get(o);
              a.onsuccess = function (t) {
                return e(t.target.result);
              }, a.onerror = eventRejectHandler(n);
            });
          },
          query: function (e) {
            return function (r) {
              return new Promise(function (o, n) {
                o = wrap(o);
                var i = r.trans,
                  s = r.values,
                  u = r.limit,
                  l = r.query,
                  c = u === 1 / 0 ? void 0 : u,
                  p = l.index,
                  g = l.range,
                  d = i.objectStore(t),
                  f = p.isPrimaryKey ? d : d.index(p.name),
                  h = a(g);
                if (0 === u) return o({
                  result: []
                });
                if (e) {
                  var y = s ? f.getAll(h, c) : f.getAllKeys(h, c);
                  y.onsuccess = function (e) {
                    return o({
                      result: e.target.result
                    });
                  }, y.onerror = eventRejectHandler(n);
                } else {
                  var b = 0,
                    m = s || !("openKeyCursor" in f) ? f.openCursor(h) : f.openKeyCursor(h),
                    _ = [];
                  m.onsuccess = function (e) {
                    var t = m.result;
                    return t ? (_.push(s ? t.value : t.primaryKey), ++b === u ? o({
                      result: _
                    }) : void t.continue()) : o({
                      result: _
                    });
                  }, m.onerror = eventRejectHandler(n);
                }
              });
            };
          }(u),
          openCursor: function openCursor(e) {
            var r = e.trans,
              o = e.values,
              n = e.query,
              i = e.reverse,
              s = e.unique;
            return new Promise(function (e, u) {
              e = wrap(e);
              var l = n.index,
                c = n.range,
                p = r.objectStore(t),
                g = l.isPrimaryKey ? p : p.index(l.name),
                d = i ? s ? "prevunique" : "prev" : s ? "nextunique" : "next",
                f = o || !("openKeyCursor" in g) ? g.openCursor(a(c), d) : g.openKeyCursor(a(c), d);
              f.onerror = eventRejectHandler(u), f.onsuccess = wrap(function (t) {
                var o = f.result;
                if (o) {
                  o.___id = ++_id_counter, o.done = !1;
                  var n = o.continue.bind(o),
                    a = o.continuePrimaryKey;
                  a && (a = a.bind(o));
                  var i = o.advance.bind(o),
                    s = function s() {
                      throw new Error("Cursor not stopped");
                    };
                  o.trans = r, o.stop = o.continue = o.continuePrimaryKey = o.advance = function () {
                    throw new Error("Cursor not started");
                  }, o.fail = wrap(u), o.next = function () {
                    var e = this,
                      t = 1;
                    return this.start(function () {
                      return t-- ? e.continue() : e.stop();
                    }).then(function () {
                      return e;
                    });
                  }, o.start = function (e) {
                    var t = new Promise(function (e, t) {
                        e = wrap(e), f.onerror = eventRejectHandler(t), o.fail = t, o.stop = function (t) {
                          o.stop = o.continue = o.continuePrimaryKey = o.advance = s, e(t);
                        };
                      }),
                      r = function r() {
                        if (f.result) try {
                          e();
                        } catch (e) {
                          o.fail(e);
                        } else o.done = !0, o.start = function () {
                          throw new Error("Cursor behind last entry");
                        }, o.stop();
                      };
                    return f.onsuccess = wrap(function (e) {
                      f.onsuccess = r, r();
                    }), o.continue = n, o.continuePrimaryKey = a, o.advance = i, r(), t;
                  }, e(o);
                } else e(null);
              }, u);
            });
          },
          count: function count(e) {
            var r = e.query,
              o = e.trans,
              n = r.index,
              i = r.range;
            return new Promise(function (e, r) {
              var s = o.objectStore(t),
                u = n.isPrimaryKey ? s : s.index(n.name),
                l = a(i),
                c = l ? u.count(l) : u.count();
              c.onsuccess = wrap(function (t) {
                return e(t.target.result);
              }), c.onerror = eventRejectHandler(r);
            });
          }
        };
      }(e);
    }),
    c = {};
  return l.forEach(function (e) {
    return c[e.name] = e;
  }), {
    stack: "dbcore",
    transaction: e.transaction.bind(e),
    table: function table(e) {
      if (!c[e]) throw new Error("Table '" + e + "' not found");
      return c[e];
    },
    cmp: n,
    MIN_KEY: -1 / 0,
    MAX_KEY: getMaxKey(r),
    schema: s
  };
}
function createMiddlewareStack(e, t) {
  return t.reduce(function (e, t) {
    var r = t.create;
    return _assign(_assign({}, e), r(e));
  }, e);
}
function createMiddlewareStacks(e, t, r, o) {
  var n = r.IDBKeyRange;
  return {
    dbcore: createMiddlewareStack(createDBCore(t, r.indexedDB, n, o), e.dbcore)
  };
}
function generateMiddlewareStacks(e, t) {
  var r = t.db,
    o = createMiddlewareStacks(e._middlewares, r, e._deps, t);
  e.core = o.dbcore, e.tables.forEach(function (t) {
    var r = t.name;
    e.core.schema.tables.some(function (e) {
      return e.name === r;
    }) && (t.core = e.core.table(r), e[r] instanceof e.Table && (e[r].core = t.core));
  });
}
function setApiOnPlace(e, t, r, o) {
  r.forEach(function (r) {
    var n = o[r];
    t.forEach(function (t) {
      r in t || (t === e.Transaction.prototype || t instanceof e.Transaction ? setProp(t, r, {
        get: function get() {
          return this.table(r);
        },
        set: function set(e) {
          defineProperty(this, r, {
            value: e,
            writable: !0,
            configurable: !0,
            enumerable: !0
          });
        }
      }) : t[r] = new e.Table(r, n));
    });
  });
}
function removeTablesApi(e, t) {
  t.forEach(function (t) {
    for (var r in t) t[r] instanceof e.Table && delete t[r];
  });
}
function lowerVersionFirst(e, t) {
  return e._cfg.version - t._cfg.version;
}
function runUpgraders(e, t, r, o) {
  var n = e._dbSchema,
    a = e._createTransaction("readwrite", e._storeNames, n);
  a.create(r), a._completion.catch(o);
  var i = a._reject.bind(a),
    s = PSD.transless || PSD;
  newScope(function () {
    PSD.trans = a, PSD.transless = s, 0 === t ? (keys(n).forEach(function (e) {
      createTable(r, e, n[e].primKey, n[e].indexes);
    }), generateMiddlewareStacks(e, r), DexiePromise.follow(function () {
      return e.on.populate.fire(a);
    }).catch(i)) : updateTablesAndIndexes(e, t, a, r).catch(i);
  });
}
function updateTablesAndIndexes(e, t, r, o) {
  var n = [],
    a = e._versions,
    i = e._dbSchema = buildGlobalSchema(e, e.idbdb, o),
    s = !1;
  return a.filter(function (e) {
    return e._cfg.version >= t;
  }).forEach(function (a) {
    n.push(function () {
      var n = i,
        u = a._cfg.dbschema;
      adjustToExistingIndexNames(e, n, o), adjustToExistingIndexNames(e, u, o), i = e._dbSchema = u;
      var l = getSchemaDiff(n, u);
      l.add.forEach(function (e) {
        createTable(o, e[0], e[1].primKey, e[1].indexes);
      }), l.change.forEach(function (e) {
        if (e.recreate) throw new exceptions.Upgrade("Not yet support for changing primary key");
        var t = o.objectStore(e.name);
        e.add.forEach(function (e) {
          return addIndex(t, e);
        }), e.change.forEach(function (e) {
          t.deleteIndex(e.name), addIndex(t, e);
        }), e.del.forEach(function (e) {
          return t.deleteIndex(e);
        });
      });
      var c = a._cfg.contentUpgrade;
      if (c && a._cfg.version > t) {
        generateMiddlewareStacks(e, o), s = !0;
        var p = shallowClone(u);
        l.del.forEach(function (e) {
          p[e] = n[e];
        }), removeTablesApi(e, [e.Transaction.prototype]), setApiOnPlace(e, [e.Transaction.prototype], keys(p), p), r.schema = p;
        var g,
          d = isAsyncFunction(c);
        d && incrementExpectedAwaits();
        var f = DexiePromise.follow(function () {
          if ((g = c(r)) && d) {
            var e = decrementExpectedAwaits.bind(null, null);
            g.then(e, e);
          }
        });
        return g && "function" == typeof g.then ? DexiePromise.resolve(g) : f.then(function () {
          return g;
        });
      }
    }), n.push(function (t) {
      s && hasIEDeleteObjectStoreBug || deleteRemovedTables(a._cfg.dbschema, t);
      removeTablesApi(e, [e.Transaction.prototype]), setApiOnPlace(e, [e.Transaction.prototype], e._storeNames, e._dbSchema), r.schema = e._dbSchema;
    });
  }), function e() {
    return n.length ? DexiePromise.resolve(n.shift()(r.idbtrans)).then(e) : DexiePromise.resolve();
  }().then(function () {
    createMissingTables(i, o);
  });
}
function getSchemaDiff(e, t) {
  var r,
    o = {
      del: [],
      add: [],
      change: []
    };
  for (r in e) t[r] || o.del.push(r);
  for (r in t) {
    var n = e[r],
      a = t[r];
    if (n) {
      var i = {
        name: r,
        def: a,
        recreate: !1,
        del: [],
        add: [],
        change: []
      };
      if (n.primKey.src === a.primKey.src || isIEOrEdge) {
        var s = n.idxByName,
          u = a.idxByName,
          l = void 0;
        for (l in s) u[l] || i.del.push(l);
        for (l in u) {
          var c = s[l],
            p = u[l];
          c ? c.src !== p.src && i.change.push(p) : i.add.push(p);
        }
        (i.del.length > 0 || i.add.length > 0 || i.change.length > 0) && o.change.push(i);
      } else i.recreate = !0, o.change.push(i);
    } else o.add.push([r, a]);
  }
  return o;
}
function createTable(e, t, r, o) {
  var n = e.db.createObjectStore(t, r.keyPath ? {
    keyPath: r.keyPath,
    autoIncrement: r.auto
  } : {
    autoIncrement: r.auto
  });
  return o.forEach(function (e) {
    return addIndex(n, e);
  }), n;
}
function createMissingTables(e, t) {
  keys(e).forEach(function (r) {
    t.db.objectStoreNames.contains(r) || createTable(t, r, e[r].primKey, e[r].indexes);
  });
}
function deleteRemovedTables(e, t) {
  for (var r = 0; r < t.db.objectStoreNames.length; ++r) {
    var o = t.db.objectStoreNames[r];
    null == e[o] && t.db.deleteObjectStore(o);
  }
}
function addIndex(e, t) {
  e.createIndex(t.name, t.keyPath, {
    unique: t.unique,
    multiEntry: t.multi
  });
}
function buildGlobalSchema(e, t, r) {
  var o = {};
  return slice(t.objectStoreNames, 0).forEach(function (e) {
    for (var t = r.objectStore(e), n = t.keyPath, a = createIndexSpec(nameFromKeyPath(n), n || "", !1, !1, !!t.autoIncrement, n && "string" != typeof n, !0), i = [], s = 0; s < t.indexNames.length; ++s) {
      var u = t.index(t.indexNames[s]);
      n = u.keyPath;
      var l = createIndexSpec(u.name, n, !!u.unique, !!u.multiEntry, !1, n && "string" != typeof n, !1);
      i.push(l);
    }
    o[e] = createTableSchema(e, a, i);
  }), o;
}
function readGlobalSchema(e, t, r) {
  e.verno = t.version / 10;
  var o = e._dbSchema = buildGlobalSchema(e, t, r);
  e._storeNames = slice(t.objectStoreNames, 0), setApiOnPlace(e, [e._allTables], keys(o), o);
}
function adjustToExistingIndexNames(e, t, r) {
  for (var o = r.db.objectStoreNames, n = 0; n < o.length; ++n) {
    var a = o[n],
      i = r.objectStore(a);
    e._hasGetAll = "getAll" in i;
    for (var s = 0; s < i.indexNames.length; ++s) {
      var u = i.indexNames[s],
        l = i.index(u).keyPath,
        c = "string" == typeof l ? l : "[" + slice(l).join("+") + "]";
      if (t[a]) {
        var p = t[a].idxByName[c];
        p && (p.name = u, delete t[a].idxByName[c], t[a].idxByName[u] = p);
      }
    }
  }
  "undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && _global.WorkerGlobalScope && _global instanceof _global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604 && (e._hasGetAll = !1);
}
function parseIndexSyntax(e) {
  return e.split(",").map(function (e, t) {
    var r = (e = e.trim()).replace(/([&*]|\+\+)/g, ""),
      o = /^\[/.test(r) ? r.match(/^\[(.*)\]$/)[1].split("+") : r;
    return createIndexSpec(r, o || null, /\&/.test(e), /\*/.test(e), /\+\+/.test(e), isArray(o), 0 === t);
  });
}
var Version = function () {
    function e() {}
    return e.prototype._parseStoresSpec = function (e, t) {
      keys(e).forEach(function (r) {
        if (null !== e[r]) {
          var o = parseIndexSyntax(e[r]),
            n = o.shift();
          if (n.multi) throw new exceptions.Schema("Primary key cannot be multi-valued");
          o.forEach(function (e) {
            if (e.auto) throw new exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
            if (!e.keyPath) throw new exceptions.Schema("Index must have a name and cannot be an empty string");
          }), t[r] = createTableSchema(r, n, o);
        }
      });
    }, e.prototype.stores = function (e) {
      var t = this.db;
      this._cfg.storesSource = this._cfg.storesSource ? extend(this._cfg.storesSource, e) : e;
      var r = t._versions,
        o = {},
        n = {};
      return r.forEach(function (e) {
        extend(o, e._cfg.storesSource), n = e._cfg.dbschema = {}, e._parseStoresSpec(o, n);
      }), t._dbSchema = n, removeTablesApi(t, [t._allTables, t, t.Transaction.prototype]), setApiOnPlace(t, [t._allTables, t, t.Transaction.prototype, this._cfg.tables], keys(n), n), t._storeNames = keys(n), this;
    }, e.prototype.upgrade = function (e) {
      return this._cfg.contentUpgrade = e, this;
    }, e;
  }(),
  databaseEnumerator;
function createVersionConstructor(e) {
  return makeClassConstructor(Version.prototype, function (t) {
    this.db = e, this._cfg = {
      version: t,
      storesSource: null,
      dbschema: {},
      tables: {},
      contentUpgrade: null
    };
  });
}
function DatabaseEnumerator(e) {
  var t,
    r = e && "function" == typeof e.databases;
  if (!r) {
    var o = new Dexie(DBNAMES_DB, {
      addons: []
    });
    o.version(1).stores({
      dbnames: "name"
    }), t = o.table("dbnames");
  }
  return {
    getDatabaseNames: function getDatabaseNames() {
      return r ? DexiePromise.resolve(e.databases()).then(function (e) {
        return e.map(function (e) {
          return e.name;
        }).filter(function (e) {
          return e !== DBNAMES_DB;
        });
      }) : t.toCollection().primaryKeys();
    },
    add: function add(e) {
      return !r && e !== DBNAMES_DB && t.put({
        name: e
      }).catch(nop);
    },
    remove: function remove(e) {
      return !r && e !== DBNAMES_DB && t.delete(e).catch(nop);
    }
  };
}
function initDatabaseEnumerator(e) {
  try {
    databaseEnumerator = DatabaseEnumerator(e);
  } catch (e) {}
}
function vip(e) {
  return newScope(function () {
    return PSD.letThrough = !0, e();
  });
}
function dexieOpen(e) {
  var t = e._state,
    r = e._deps.indexedDB;
  if (t.isBeingOpened || e.idbdb) return t.dbReadyPromise.then(function () {
    return t.dbOpenError ? rejection(t.dbOpenError) : e;
  });
  debug && (t.openCanceller._stackHolder = getErrorWithStack()), t.isBeingOpened = !0, t.dbOpenError = null, t.openComplete = !1;
  var o = t.dbReadyResolve,
    n = null;
  return DexiePromise.race([t.openCanceller, new DexiePromise(function (o, a) {
    if (!r) throw new exceptions.MissingAPI("indexedDB API not found. If using IE10+, make sure to run your code on a server URL (not locally). If using old Safari versions, make sure to include indexedDB polyfill.");
    var i = e.name,
      s = t.autoSchema ? r.open(i) : r.open(i, Math.round(10 * e.verno));
    if (!s) throw new exceptions.MissingAPI("IndexedDB API not available");
    s.onerror = eventRejectHandler(a), s.onblocked = wrap(e._fireOnBlocked), s.onupgradeneeded = wrap(function (o) {
      if (n = s.transaction, t.autoSchema && !e._options.allowEmptyDB) {
        s.onerror = preventDefault, n.abort(), s.result.close();
        var u = r.deleteDatabase(i);
        u.onsuccess = u.onerror = wrap(function () {
          a(new exceptions.NoSuchDatabase("Database " + i + " doesnt exist"));
        });
      } else {
        n.onerror = eventRejectHandler(a);
        var l = o.oldVersion > Math.pow(2, 62) ? 0 : o.oldVersion;
        e.idbdb = s.result, runUpgraders(e, l / 10, n, a);
      }
    }, a), s.onsuccess = wrap(function () {
      n = null;
      var r = e.idbdb = s.result,
        a = slice(r.objectStoreNames);
      if (a.length > 0) try {
        var u = r.transaction(safariMultiStoreFix(a), "readonly");
        t.autoSchema ? readGlobalSchema(e, r, u) : adjustToExistingIndexNames(e, e._dbSchema, u), generateMiddlewareStacks(e, u);
      } catch (e) {}
      connections.push(e), r.onversionchange = wrap(function (r) {
        t.vcFired = !0, e.on("versionchange").fire(r);
      }), databaseEnumerator.add(i), o();
    }, a);
  })]).then(function () {
    return t.onReadyBeingFired = [], DexiePromise.resolve(vip(e.on.ready.fire)).then(function e() {
      if (t.onReadyBeingFired.length > 0) {
        var r = t.onReadyBeingFired.reduce(promisableChain, nop);
        return t.onReadyBeingFired = [], DexiePromise.resolve(vip(r)).then(e);
      }
    });
  }).finally(function () {
    t.onReadyBeingFired = null;
  }).then(function () {
    return t.isBeingOpened = !1, e;
  }).catch(function (r) {
    try {
      n && n.abort();
    } catch (e) {}
    return t.isBeingOpened = !1, e.close(), t.dbOpenError = r, rejection(t.dbOpenError);
  }).finally(function () {
    t.openComplete = !0, o();
  });
}
function awaitIterator(e) {
  var t = function t(_t3) {
      return e.next(_t3);
    },
    r = n(t),
    o = n(function (t) {
      return e.throw(t);
    });
  function n(e) {
    return function (t) {
      var n = e(t),
        a = n.value;
      return n.done ? a : a && "function" == typeof a.then ? a.then(r, o) : isArray(a) ? Promise.all(a).then(r, o) : r(a);
    };
  }
  return n(t)();
}
function extractTransactionArgs(e, t, r) {
  var o = arguments.length;
  if (o < 2) throw new exceptions.InvalidArgument("Too few arguments");
  for (var n = new Array(o - 1); --o;) n[o - 1] = arguments[o];
  r = n.pop();
  var a = flatten(n);
  return [e, a, r];
}
function enterTransactionScope(e, t, r, o, n) {
  return DexiePromise.resolve().then(function () {
    var a = PSD.transless || PSD,
      i = e._createTransaction(t, r, e._dbSchema, o),
      s = {
        trans: i,
        transless: a
      };
    o ? i.idbtrans = o.idbtrans : i.create();
    var u,
      l = isAsyncFunction(n);
    l && incrementExpectedAwaits();
    var c = DexiePromise.follow(function () {
      if (u = n.call(i, i)) if (l) {
        var e = decrementExpectedAwaits.bind(null, null);
        u.then(e, e);
      } else "function" == typeof u.next && "function" == typeof u.throw && (u = awaitIterator(u));
    }, s);
    return (u && "function" == typeof u.then ? DexiePromise.resolve(u).then(function (e) {
      return i.active ? e : rejection(new exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
    }) : c.then(function () {
      return u;
    })).then(function (e) {
      return o && i._resolve(), i._completion.then(function () {
        return e;
      });
    }).catch(function (e) {
      return i._reject(e), rejection(e);
    });
  });
}
function pad(e, t, r) {
  for (var o = isArray(e) ? e.slice() : [e], n = 0; n < r; ++n) o.push(t);
  return o;
}
function createVirtualIndexMiddleware(e) {
  return _assign(_assign({}, e), {
    table: function table(t) {
      var r = e.table(t),
        o = r.schema,
        n = {},
        a = [];
      function i(e, t, r) {
        var o = getKeyPathAlias(e),
          s = n[o] = n[o] || [],
          u = null == e ? 0 : "string" == typeof e ? 1 : e.length,
          l = t > 0,
          c = _assign(_assign({}, r), {
            isVirtual: l,
            isPrimaryKey: !l && r.isPrimaryKey,
            keyTail: t,
            keyLength: u,
            extractKey: getKeyExtractor(e),
            unique: !l && r.unique
          });
        (s.push(c), c.isPrimaryKey || a.push(c), u > 1) && i(2 === u ? e[0] : e.slice(0, u - 1), t + 1, r);
        return s.sort(function (e, t) {
          return e.keyTail - t.keyTail;
        }), c;
      }
      var s = i(o.primaryKey.keyPath, 0, o.primaryKey);
      n[":id"] = [s];
      for (var u = 0, l = o.indexes; u < l.length; u++) {
        var c = l[u];
        i(c.keyPath, 0, c);
      }
      function p(t) {
        var r,
          o,
          n = t.query.index;
        return n.isVirtual ? _assign(_assign({}, t), {
          query: {
            index: n,
            range: (r = t.query.range, o = n.keyTail, {
              type: 1 === r.type ? 2 : r.type,
              lower: pad(r.lower, r.lowerOpen ? e.MAX_KEY : e.MIN_KEY, o),
              lowerOpen: !0,
              upper: pad(r.upper, r.upperOpen ? e.MIN_KEY : e.MAX_KEY, o),
              upperOpen: !0
            })
          }
        }) : t;
      }
      return _assign(_assign({}, r), {
        schema: _assign(_assign({}, o), {
          primaryKey: s,
          indexes: a,
          getIndexByKeyPath: function getIndexByKeyPath(e) {
            var t = n[getKeyPathAlias(e)];
            return t && t[0];
          }
        }),
        count: function count(e) {
          return r.count(p(e));
        },
        query: function query(e) {
          return r.query(p(e));
        },
        openCursor: function openCursor(t) {
          var o = t.query.index,
            n = o.keyTail,
            a = o.isVirtual,
            i = o.keyLength;
          if (!a) return r.openCursor(t);
          return r.openCursor(p(t)).then(function (r) {
            return r && function (r) {
              return Object.create(r, {
                continue: {
                  value: function value(o) {
                    null != o ? r.continue(pad(o, t.reverse ? e.MAX_KEY : e.MIN_KEY, n)) : t.unique ? r.continue(pad(r.key, t.reverse ? e.MIN_KEY : e.MAX_KEY, n)) : r.continue();
                  }
                },
                continuePrimaryKey: {
                  value: function value(t, o) {
                    r.continuePrimaryKey(pad(t, e.MAX_KEY, n), o);
                  }
                },
                key: {
                  get: function get() {
                    var e = r.key;
                    return 1 === i ? e[0] : e.slice(0, i);
                  }
                },
                value: {
                  get: function get() {
                    return r.value;
                  }
                }
              });
            }(r);
          });
        }
      });
    }
  });
}
var virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: createVirtualIndexMiddleware
  },
  hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function create(e) {
      return _assign(_assign({}, e), {
        table: function table(t) {
          var r = e.table(t),
            o = r.schema.primaryKey;
          return _assign(_assign({}, r), {
            mutate: function mutate(e) {
              var n = PSD.trans,
                a = n.table(t).hook,
                i = a.deleting,
                s = a.creating,
                u = a.updating;
              switch (e.type) {
                case "add":
                  if (s.fire === nop) break;
                  return n._promise("readwrite", function () {
                    return l(e);
                  }, !0);
                case "put":
                  if (s.fire === nop && u.fire === nop) break;
                  return n._promise("readwrite", function () {
                    return l(e);
                  }, !0);
                case "delete":
                  if (i.fire === nop) break;
                  return n._promise("readwrite", function () {
                    return l(e);
                  }, !0);
                case "deleteRange":
                  if (i.fire === nop) break;
                  return n._promise("readwrite", function () {
                    return function (e) {
                      return c(e.trans, e.range, 1e4);
                    }(e);
                  }, !0);
              }
              return r.mutate(e);
              function l(e) {
                var t = PSD.trans,
                  n = e.keys || getEffectiveKeys(o, e);
                if (!n) throw new Error("Keys missing");
                return "delete" !== (e = "add" === e.type || "put" === e.type ? _assign(_assign({}, e), {
                  keys: n,
                  wantResults: !0
                }) : _assign({}, e)).type && (e.values = __spreadArrays(e.values)), e.keys && (e.keys = __spreadArrays(e.keys)), getExistingValues(r, e, n).then(function (a) {
                  var l = n.map(function (r, n) {
                    var l = a[n],
                      c = {
                        onerror: null,
                        onsuccess: null
                      };
                    if ("delete" === e.type) i.fire.call(c, r, l, t);else if ("add" === e.type || void 0 === l) {
                      var p = s.fire.call(c, r, e.values[n], t);
                      null == r && null != p && (r = p, e.keys[n] = r, o.outbound || setByKeyPath(e.values[n], o.keyPath, r));
                    } else {
                      var g = getObjectDiff(l, e.values[n]),
                        d = u.fire.call(c, g, r, l, t);
                      if (d) {
                        var f = e.values[n];
                        Object.keys(d).forEach(function (e) {
                          setByKeyPath(f, e, d[e]);
                        });
                      }
                    }
                    return c;
                  });
                  return r.mutate(e).then(function (t) {
                    for (var r = t.failures, o = t.results, i = t.numFailures, s = t.lastResult, u = 0; u < n.length; ++u) {
                      var c = o ? o[u] : n[u],
                        p = l[u];
                      null == c ? p.onerror && p.onerror(r[u]) : p.onsuccess && p.onsuccess("put" === e.type && a[u] ? e.values[u] : c);
                    }
                    return {
                      failures: r,
                      results: o,
                      numFailures: i,
                      lastResult: s
                    };
                  }).catch(function (e) {
                    return l.forEach(function (t) {
                      return t.onerror && t.onerror(e);
                    }), Promise.reject(e);
                  });
                });
              }
              function c(e, t, n) {
                return r.query({
                  trans: e,
                  values: !1,
                  query: {
                    index: o,
                    range: t
                  },
                  limit: n
                }).then(function (r) {
                  var o = r.result;
                  return l({
                    type: "delete",
                    keys: o,
                    trans: e
                  }).then(function (r) {
                    return r.numFailures > 0 ? Promise.reject(r.failures[0]) : o.length < n ? {
                      failures: [],
                      numFailures: 0,
                      lastResult: void 0
                    } : c(e, _assign(_assign({}, t), {
                      lower: o[o.length - 1],
                      lowerOpen: !0
                    }), n);
                  });
                });
              }
            }
          });
        }
      });
    }
  },
  Dexie = function () {
    function e(t, r) {
      var o = this;
      this._middlewares = {}, this.verno = 0;
      var n = e.dependencies;
      this._options = r = _assign({
        addons: e.addons,
        autoOpen: !0,
        indexedDB: n.indexedDB,
        IDBKeyRange: n.IDBKeyRange
      }, r), this._deps = {
        indexedDB: r.indexedDB,
        IDBKeyRange: r.IDBKeyRange
      };
      var a = r.addons;
      this._dbSchema = {}, this._versions = [], this._storeNames = [], this._allTables = {}, this.idbdb = null;
      var i = {
        dbOpenError: null,
        isBeingOpened: !1,
        onReadyBeingFired: null,
        openComplete: !1,
        dbReadyResolve: nop,
        dbReadyPromise: null,
        cancelOpen: nop,
        openCanceller: null,
        autoSchema: !0
      };
      i.dbReadyPromise = new DexiePromise(function (e) {
        i.dbReadyResolve = e;
      }), i.openCanceller = new DexiePromise(function (e, t) {
        i.cancelOpen = t;
      }), this._state = i, this.name = t, this.on = Events(this, "populate", "blocked", "versionchange", {
        ready: [promisableChain, nop]
      }), this.on.ready.subscribe = override(this.on.ready.subscribe, function (t) {
        return function (r, n) {
          e.vip(function () {
            var e = o._state;
            if (e.openComplete) e.dbOpenError || DexiePromise.resolve().then(r), n && t(r);else if (e.onReadyBeingFired) e.onReadyBeingFired.push(r), n && t(r);else {
              t(r);
              var a = o;
              n || t(function e() {
                a.on.ready.unsubscribe(r), a.on.ready.unsubscribe(e);
              });
            }
          });
        };
      }), this.Collection = createCollectionConstructor(this), this.Table = createTableConstructor(this), this.Transaction = createTransactionConstructor(this), this.Version = createVersionConstructor(this), this.WhereClause = createWhereClauseConstructor(this), this.on("versionchange", function (e) {
        e.newVersion > 0 ? console.warn("Another connection wants to upgrade database '" + o.name + "'. Closing db now to resume the upgrade.") : console.warn("Another connection wants to delete database '" + o.name + "'. Closing db now to resume the delete request."), o.close();
      }), this.on("blocked", function (e) {
        !e.newVersion || e.newVersion < e.oldVersion ? console.warn("Dexie.delete('" + o.name + "') was blocked") : console.warn("Upgrade '" + o.name + "' blocked by other connection holding version " + e.oldVersion / 10);
      }), this._maxKey = getMaxKey(r.IDBKeyRange), this._createTransaction = function (e, t, r, n) {
        return new o.Transaction(e, t, r, n);
      }, this._fireOnBlocked = function (e) {
        o.on("blocked").fire(e), connections.filter(function (e) {
          return e.name === o.name && e !== o && !e._state.vcFired;
        }).map(function (t) {
          return t.on("versionchange").fire(e);
        });
      }, this.use(virtualIndexMiddleware), this.use(hooksMiddleware), a.forEach(function (e) {
        return e(o);
      });
    }
    return e.prototype.version = function (e) {
      if (isNaN(e) || e < .1) throw new exceptions.Type("Given version is not a positive number");
      if (e = Math.round(10 * e) / 10, this.idbdb || this._state.isBeingOpened) throw new exceptions.Schema("Cannot add version when database is open");
      this.verno = Math.max(this.verno, e);
      var t = this._versions,
        r = t.filter(function (t) {
          return t._cfg.version === e;
        })[0];
      return r || (r = new this.Version(e), t.push(r), t.sort(lowerVersionFirst), r.stores({}), this._state.autoSchema = !1, r);
    }, e.prototype._whenReady = function (e) {
      var t = this;
      return this._state.openComplete || PSD.letThrough ? e() : new DexiePromise(function (e, r) {
        if (!t._state.isBeingOpened) {
          if (!t._options.autoOpen) return void r(new exceptions.DatabaseClosed());
          t.open().catch(nop);
        }
        t._state.dbReadyPromise.then(e, r);
      }).then(e);
    }, e.prototype.use = function (e) {
      var t = e.stack,
        r = e.create,
        o = e.level,
        n = e.name;
      n && this.unuse({
        stack: t,
        name: n
      });
      var a = this._middlewares[t] || (this._middlewares[t] = []);
      return a.push({
        stack: t,
        create: r,
        level: null == o ? 10 : o,
        name: n
      }), a.sort(function (e, t) {
        return e.level - t.level;
      }), this;
    }, e.prototype.unuse = function (e) {
      var t = e.stack,
        r = e.name,
        o = e.create;
      return t && this._middlewares[t] && (this._middlewares[t] = this._middlewares[t].filter(function (e) {
        return o ? e.create !== o : !!r && e.name !== r;
      })), this;
    }, e.prototype.open = function () {
      return dexieOpen(this);
    }, e.prototype.close = function () {
      var e = connections.indexOf(this),
        t = this._state;
      if (e >= 0 && connections.splice(e, 1), this.idbdb) {
        try {
          this.idbdb.close();
        } catch (e) {}
        this.idbdb = null;
      }
      this._options.autoOpen = !1, t.dbOpenError = new exceptions.DatabaseClosed(), t.isBeingOpened && t.cancelOpen(t.dbOpenError), t.dbReadyPromise = new DexiePromise(function (e) {
        t.dbReadyResolve = e;
      }), t.openCanceller = new DexiePromise(function (e, r) {
        t.cancelOpen = r;
      });
    }, e.prototype.delete = function () {
      var e = this,
        t = arguments.length > 0,
        r = this._state;
      return new DexiePromise(function (o, n) {
        var a = function a() {
          e.close();
          var t = e._deps.indexedDB.deleteDatabase(e.name);
          t.onsuccess = wrap(function () {
            databaseEnumerator.remove(e.name), o();
          }), t.onerror = eventRejectHandler(n), t.onblocked = e._fireOnBlocked;
        };
        if (t) throw new exceptions.InvalidArgument("Arguments not allowed in db.delete()");
        r.isBeingOpened ? r.dbReadyPromise.then(a) : a();
      });
    }, e.prototype.backendDB = function () {
      return this.idbdb;
    }, e.prototype.isOpen = function () {
      return null !== this.idbdb;
    }, e.prototype.hasBeenClosed = function () {
      var e = this._state.dbOpenError;
      return e && "DatabaseClosed" === e.name;
    }, e.prototype.hasFailed = function () {
      return null !== this._state.dbOpenError;
    }, e.prototype.dynamicallyOpened = function () {
      return this._state.autoSchema;
    }, Object.defineProperty(e.prototype, "tables", {
      get: function get() {
        var e = this;
        return keys(this._allTables).map(function (t) {
          return e._allTables[t];
        });
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.transaction = function () {
      var e = extractTransactionArgs.apply(this, arguments);
      return this._transaction.apply(this, e);
    }, e.prototype._transaction = function (e, t, r) {
      var o = this,
        n = PSD.trans;
      n && n.db === this && -1 === e.indexOf("!") || (n = null);
      var a,
        i,
        s = -1 !== e.indexOf("?");
      e = e.replace("!", "").replace("?", "");
      try {
        if (i = t.map(function (e) {
          var t = e instanceof o.Table ? e.name : e;
          if ("string" != typeof t) throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
          return t;
        }), "r" == e || e === READONLY) a = READONLY;else {
          if ("rw" != e && e != READWRITE) throw new exceptions.InvalidArgument("Invalid transaction mode: " + e);
          a = READWRITE;
        }
        if (n) {
          if (n.mode === READONLY && a === READWRITE) {
            if (!s) throw new exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
            n = null;
          }
          n && i.forEach(function (e) {
            if (n && -1 === n.storeNames.indexOf(e)) {
              if (!s) throw new exceptions.SubTransaction("Table " + e + " not included in parent transaction.");
              n = null;
            }
          }), s && n && !n.active && (n = null);
        }
      } catch (e) {
        return n ? n._promise(null, function (t, r) {
          r(e);
        }) : rejection(e);
      }
      var u = enterTransactionScope.bind(null, this, a, i, n, r);
      return n ? n._promise(a, u, "lock") : PSD.trans ? usePSD(PSD.transless, function () {
        return o._whenReady(u);
      }) : this._whenReady(u);
    }, e.prototype.table = function (e) {
      if (!hasOwn(this._allTables, e)) throw new exceptions.InvalidTable("Table " + e + " does not exist");
      return this._allTables[e];
    }, e;
  }(),
  Dexie$1 = Dexie;
props(Dexie$1, _assign(_assign({}, fullNameExceptions), {
  delete: function _delete(e) {
    return new Dexie$1(e).delete();
  },
  exists: function exists(e) {
    return new Dexie$1(e, {
      addons: []
    }).open().then(function (e) {
      return e.close(), !0;
    }).catch("NoSuchDatabaseError", function () {
      return !1;
    });
  },
  getDatabaseNames: function getDatabaseNames(e) {
    return databaseEnumerator ? databaseEnumerator.getDatabaseNames().then(e) : DexiePromise.resolve([]);
  },
  defineClass: function defineClass() {
    return function (e) {
      extend(this, e);
    };
  },
  ignoreTransaction: function ignoreTransaction(e) {
    return PSD.trans ? usePSD(PSD.transless, e) : e();
  },
  vip: vip,
  async: function async(e) {
    return function () {
      try {
        var t = awaitIterator(e.apply(this, arguments));
        return t && "function" == typeof t.then ? t : DexiePromise.resolve(t);
      } catch (e) {
        return rejection(e);
      }
    };
  },
  spawn: function spawn(e, t, r) {
    try {
      var o = awaitIterator(e.apply(r, t || []));
      return o && "function" == typeof o.then ? o : DexiePromise.resolve(o);
    } catch (e) {
      return rejection(e);
    }
  },
  currentTransaction: {
    get: function get() {
      return PSD.trans || null;
    }
  },
  waitFor: function waitFor(e, t) {
    var r = DexiePromise.resolve("function" == typeof e ? Dexie$1.ignoreTransaction(e) : e).timeout(t || 6e4);
    return PSD.trans ? PSD.trans.waitFor(r) : r;
  },
  Promise: DexiePromise,
  debug: {
    get: function get() {
      return debug;
    },
    set: function set(e) {
      setDebug(e, "dexie" === e ? function () {
        return !0;
      } : dexieStackFrameFilter);
    }
  },
  derive: derive,
  extend: extend,
  props: props,
  override: override,
  Events: Events,
  getByKeyPath: getByKeyPath,
  setByKeyPath: setByKeyPath,
  delByKeyPath: delByKeyPath,
  shallowClone: shallowClone,
  deepClone: deepClone$1,
  getObjectDiff: getObjectDiff,
  asap: asap,
  minKey: minKey,
  addons: [],
  connections: connections,
  errnames: errnames,
  dependencies: function () {
    try {
      return {
        indexedDB: _global.indexedDB || _global.mozIndexedDB || _global.webkitIndexedDB || _global.msIndexedDB,
        IDBKeyRange: _global.IDBKeyRange || _global.webkitIDBKeyRange
      };
    } catch (e) {
      return {
        indexedDB: null,
        IDBKeyRange: null
      };
    }
  }(),
  semVer: DEXIE_VERSION,
  version: DEXIE_VERSION.split(".").map(function (e) {
    return parseInt(e);
  }).reduce(function (e, t, r) {
    return e + t / Math.pow(10, 2 * r);
  }),
  default: Dexie$1,
  Dexie: Dexie$1
})), Dexie$1.maxKey = getMaxKey(Dexie$1.dependencies.IDBKeyRange), initDatabaseEnumerator(Dexie.dependencies.indexedDB), DexiePromise.rejectionMapper = mapError, setDebug(debug, dexieStackFrameFilter);
var dexie = Object.freeze({
  __proto__: null,
  default: Dexie
});
function initOverrideCreateTransaction(e) {
  for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    t[_key5 - 1] = arguments[_key5];
  }
  return function (r) {
    return function (o, n, a, i) {
      if (e.dynamicallyOpened()) return r.apply(this, arguments);
      if ("readwrite" === o && n.some(function (e) {
        return !e.startsWith("_");
      })) {
        n = n.slice(0);
        for (var _i = 0, _t4 = t; _i < _t4.length; _i++) {
          var _e2 = _t4[_i];
          -1 === n.indexOf("name") && n.push(_e2);
        }
      }
      var s = r.call(this, o, n, a, i);
      return s;
    };
  };
}
function initOverrideParseStoreSpec(e) {
  return function (t) {
    return function (r, o) {
      r = Object.assign(Object.assign({}, r), e), t.call(this, r, o);
    };
  };
}
var ChangeTableName = "_changes",
  StashTableName = "_stash",
  MetaTableName = "_meta",
  isEmpty = function isEmpty(e) {
    return 0 === Object.keys(e).length && e.constructor === Object;
  },
  zip = function zip(e, t, r) {
    return e.map(function (e, o) {
      var n;
      return [e, null !== (n = t[o]) && void 0 !== n ? n : r];
    });
  };
function createTrackedChangesMiddleware(e) {
  return Object.assign(Object.assign({}, e), {
    table: function table(t) {
      var r = e.table(t);
      return t.startsWith("_") ? r : Object.assign(Object.assign({}, r), {
        mutate: function mutate(o) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
            var n, a, i, s, u, l, c, p, g, _r3, _e3, _n, _a2, _n2, _a3;
            return _regeneratorRuntime().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  if (!t.startsWith("_")) {
                    _context6.next = 2;
                    break;
                  }
                  return _context6.abrupt("return", r.mutate(o));
                case 2:
                  if (!("deleteRange" === o.type)) {
                    _context6.next = 4;
                    break;
                  }
                  return _context6.abrupt("return", r.mutate(o));
                case 4:
                  n = r.schema.primaryKey, a = Boolean(n.autoIncrement);
                  i = o.keys || getEffectiveKeys$1(n, o);
                  _context6.next = 8;
                  return getExistingValues$1(r, o, i);
                case 8:
                  s = _context6.sent;
                  !a || "add" !== o.type && "put" !== o.type || (o = Object.assign(Object.assign({}, o), {
                    wantResults: !0
                  }));
                  _context6.next = 12;
                  return r.mutate(o);
                case 12:
                  u = _context6.sent;
                  if (!(a && ("add" === o.type || "put" === o.type))) {
                    _context6.next = 17;
                    break;
                  }
                  if (!(void 0 === u.results)) {
                    _context6.next = 16;
                    break;
                  }
                  throw new Error("autoIncrement keys not returned from ".concat(o.type, " mutation"));
                case 16:
                  i = u.results;
                case 17:
                  _context6.next = 19;
                  return r.getMany({
                    trans: o.trans,
                    keys: i
                  });
                case 19:
                  l = _context6.sent;
                  c = zip(s, "delete" === o.type ? [] : o.values, {}).map(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                      e = _ref2[0],
                      t = _ref2[1];
                    return jsonpatch.compare(e, t);
                  });
                  p = u.failures, g = u.numFailures;
                  if (!(g > 0 && (s = s.filter(function (e, t) {
                    return !p[t];
                  }), i = i.filter(function (e, t) {
                    return !p[t];
                  }), c = c.filter(function (e, t) {
                    return !p[t];
                  }), l = l.filter(function (e, t) {
                    return !p[t];
                  })), i.length > 0)) {
                    _context6.next = 28;
                    break;
                  }
                  _r3 = [];
                  for (_e3 = 0; _e3 < i.length; _e3++) {
                    _n = s[0], _a2 = "put" === o.type && isEmpty(_n) ? "add" : o.type;
                    _r3.push({
                      name: t,
                      type: _a2,
                      key: i[_e3],
                      before: _n,
                      ops: c[_e3],
                      after: l[_e3]
                    });
                  }
                  _n2 = e.table(ChangeTableName), _a3 = {
                    type: "add",
                    trans: o.trans,
                    values: _r3
                  };
                  _context6.next = 28;
                  return _n2.mutate(_a3);
                case 28:
                  return _context6.abrupt("return", u);
                case 29:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
        }
      });
    }
  });
}
function getEffectiveKeys$1(e, t) {
  return "delete" === t.type ? t.keys : t.keys || t.values.map(e.extractKey);
}
function getExistingValues$1(e, t, r) {
  return "add" === t.type ? Promise.resolve(new Array(t.values.length).fill({})) : e.getMany({
    trans: t.trans,
    keys: r
  }).then(function (e) {
    return e.map(function (e) {
      return void 0 === e ? {} : e;
    });
  });
}
var changesMiddleware = {
  stack: "dbcore",
  name: "ChangesMiddleware",
  create: createTrackedChangesMiddleware
};
function changesAddon(e) {
  var _initOverrideParseSto;
  var t = initOverrideCreateTransaction(e, ChangeTableName);
  e._createTransaction = Dexie.override(e._createTransaction, t);
  var r = initOverrideParseStoreSpec((_initOverrideParseSto = {}, _defineProperty(_initOverrideParseSto, ChangeTableName, "++id,name"), _defineProperty(_initOverrideParseSto, StashTableName, "++id,name"), _defineProperty(_initOverrideParseSto, MetaTableName, "&key"), _initOverrideParseSto));
  e.Version.prototype._parseStoresSpec = Dexie.override(e.Version.prototype._parseStoresSpec, r), e.use(changesMiddleware);
}
var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  o = null;
"undefined" != typeof WebSocket ? o = WebSocket : "undefined" != typeof MozWebSocket ? o = MozWebSocket : void 0 !== e ? o = e.WebSocket || e.MozWebSocket : "undefined" != typeof window ? o = window.WebSocket || window.MozWebSocket : "undefined" != typeof self && (o = self.WebSocket || self.MozWebSocket);
var n,
  t = o,
  r = (function (t) {
    var r, o;
    r = e, o = function o() {
      var e = function e() {},
        t = "undefined",
        r = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent),
        o = ["trace", "debug", "info", "warn", "error"];
      function n(e, t) {
        var r = e[t];
        if ("function" == typeof r.bind) return r.bind(e);
        try {
          return Function.prototype.bind.call(r, e);
        } catch (t) {
          return function () {
            return Function.prototype.apply.apply(r, [e, arguments]);
          };
        }
      }
      function a() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function i(o) {
        return "debug" === o && (o = "log"), typeof console !== t && ("trace" === o && r ? a : void 0 !== console[o] ? n(console, o) : void 0 !== console.log ? n(console, "log") : e);
      }
      function s(t, r) {
        for (var n = 0; n < o.length; n++) {
          var a = o[n];
          this[a] = n < t ? e : this.methodFactory(a, t, r);
        }
        this.log = this.debug;
      }
      function u(e, r, o) {
        return function () {
          typeof console !== t && (s.call(this, r, o), this[e].apply(this, arguments));
        };
      }
      function l(e, t, r) {
        return i(e) || u.apply(this, arguments);
      }
      function c(e, r, n) {
        var a,
          i = this,
          u = "loglevel";
        function c() {
          var e;
          if (typeof window !== t && u) {
            try {
              e = window.localStorage[u];
            } catch (e) {}
            if (typeof e === t) try {
              var r = window.document.cookie,
                o = r.indexOf(encodeURIComponent(u) + "=");
              -1 !== o && (e = /^([^;]+)/.exec(r.slice(o))[1]);
            } catch (e) {}
            return void 0 === i.levels[e] && (e = void 0), e;
          }
        }
        "string" == typeof e ? u += ":" + e : "symbol" == typeof e && (u = void 0), i.name = e, i.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, i.methodFactory = n || l, i.getLevel = function () {
          return a;
        }, i.setLevel = function (r, n) {
          if ("string" == typeof r && void 0 !== i.levels[r.toUpperCase()] && (r = i.levels[r.toUpperCase()]), !("number" == typeof r && r >= 0 && r <= i.levels.SILENT)) throw "log.setLevel() called with invalid level: " + r;
          if (a = r, !1 !== n && function (e) {
            var r = (o[e] || "silent").toUpperCase();
            if (typeof window !== t && u) {
              try {
                return void (window.localStorage[u] = r);
              } catch (e) {}
              try {
                window.document.cookie = encodeURIComponent(u) + "=" + r + ";";
              } catch (e) {}
            }
          }(r), s.call(i, r, e), typeof console === t && r < i.levels.SILENT) return "No console available for logging";
        }, i.setDefaultLevel = function (e) {
          c() || i.setLevel(e, !1);
        }, i.enableAll = function (e) {
          i.setLevel(i.levels.TRACE, e);
        }, i.disableAll = function (e) {
          i.setLevel(i.levels.SILENT, e);
        };
        var p = c();
        null == p && (p = null == r ? "WARN" : r), i.setLevel(p, !1);
      }
      var p = new c(),
        g = {};
      p.getLogger = function (e) {
        if ("symbol" != typeof e && "string" != typeof e || "" === e) throw new TypeError("You must supply a name when creating a logger.");
        var t = g[e];
        return t || (t = g[e] = new c(e, p.getLevel(), p.methodFactory)), t;
      };
      var d = typeof window !== t ? window.log : void 0;
      return p.noConflict = function () {
        return typeof window !== t && window.log === p && (window.log = d), p;
      }, p.getLoggers = function () {
        return g;
      }, p.default = p, p;
    }, t.exports ? t.exports = o() : r.log = o();
  }(n = {
    exports: {}
  }, n.exports), n.exports);
var _r$getLogger = r.getLogger("grpc-transport"),
  i = _r$getLogger.debug;
var l;
!function (e) {
  e[e.FINISH_SEND = 1] = "FINISH_SEND";
}(l || (l = {}));
var c = new Uint8Array([1]);
function s(e) {
  var t = "";
  return e.forEach(function (e, r) {
    t += "".concat(e, ": ").concat(r.join(", "), "\r\n");
  }), function (e) {
    var t = new Uint8Array(e.length);
    for (var _n3 = 0; _n3 !== e.length; ++_n3) {
      var _a4 = e.charCodeAt(_n3);
      if (void 0, !(9 === (o = r = _a4) || 10 === o || 13 === o || r >= 32 && r <= 126)) throw new Error("Metadata contains invalid ASCII");
      t[_n3] = _a4;
    }
    var r, o;
    return t;
  }(t);
}
function u(e) {
  e.debug && i("websocketRequest", e);
  var r = function (e) {
      if ("https://" === e.substr(0, 8)) return "wss://".concat(e.substr(8));
      if ("http://" === e.substr(0, 7)) return "ws://".concat(e.substr(7));
      throw new Error("Websocket transport constructed with non-https:// or http:// host.");
    }(e.url),
    o = [];
  var n;
  function a(e) {
    if (e === l.FINISH_SEND) n.send(c);else {
      var _t5 = e,
        _r4 = new Int8Array(_t5.byteLength + 1);
      _r4.set(new Uint8Array([0])), _r4.set(_t5, 1), n.send(_r4);
    }
  }
  return {
    sendMessage: function sendMessage(e) {
      n && n.readyState !== n.CONNECTING ? a(e) : o.push(e);
    },
    finishSend: function finishSend() {
      n && n.readyState !== n.CONNECTING ? a(l.FINISH_SEND) : o.push(l.FINISH_SEND);
    },
    start: function start(u) {
      n = new t(r, ["grpc-websockets"]), n.binaryType = "arraybuffer", n.onopen = function () {
        e.debug && i("websocketRequest.onopen"), n.send(s(u)), o.forEach(function (e) {
          a(e);
        });
      }, n.onclose = function (t) {
        e.debug && i("websocketRequest.onclose", t), e.onEnd();
      }, n.onerror = function (t) {
        e.debug && i("websocketRequest.onerror", t);
      }, n.onmessage = function (t) {
        e.onChunk(new Uint8Array(t.data));
      };
    },
    cancel: function cancel() {
      e.debug && i("websocket.abort"), n.close();
    }
  };
}
function a() {
  return function (e) {
    return u(e);
  };
}
var $jscomp = $jscomp || {};
$jscomp.scope = {}, $jscomp.findInternal = function (e, t, r) {
  e instanceof String && (e = String(e));
  for (var o = e.length, n = 0; n < o; n++) {
    var a = e[n];
    if (t.call(r, a, n, e)) return {
      i: n,
      v: a
    };
  }
  return {
    i: -1,
    v: void 0
  };
}, $jscomp.ASSUME_ES5 = !1, $jscomp.ASSUME_NO_NATIVE_MAP = !1, $jscomp.ASSUME_NO_NATIVE_SET = !1, $jscomp.SIMPLE_FROUND_POLYFILL = !1, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, t, r) {
  e != Array.prototype && e != Object.prototype && (e[t] = r.value);
}, $jscomp.getGlobal = function (e) {
  return "undefined" != typeof window && window === e ? e : void 0 !== commonjsGlobal && null != commonjsGlobal ? commonjsGlobal : e;
}, $jscomp.global = $jscomp.getGlobal(commonjsGlobal), $jscomp.polyfill = function (e, t, r, o) {
  if (t) {
    for (r = $jscomp.global, e = e.split("."), o = 0; o < e.length - 1; o++) {
      var n = e[o];
      n in r || (r[n] = {}), r = r[n];
    }
    (t = t(o = r[e = e[e.length - 1]])) != o && null != t && $jscomp.defineProperty(r, e, {
      configurable: !0,
      writable: !0,
      value: t
    });
  }
}, $jscomp.polyfill("Array.prototype.findIndex", function (e) {
  return e || function (e, t) {
    return $jscomp.findInternal(this, e, t).i;
  };
}, "es6", "es3"), $jscomp.checkStringArgs = function (e, t, r) {
  if (null == e) throw new TypeError("The 'this' value for String.prototype." + r + " must not be null or undefined");
  if (t instanceof RegExp) throw new TypeError("First argument to String.prototype." + r + " must not be a regular expression");
  return e + "";
}, $jscomp.polyfill("String.prototype.endsWith", function (e) {
  return e || function (e, t) {
    var r = $jscomp.checkStringArgs(this, e, "endsWith");
    e += "", void 0 === t && (t = r.length), t = Math.max(0, Math.min(0 | t, r.length));
    for (var o = e.length; 0 < o && 0 < t;) if (r[--t] != e[--o]) return !1;
    return 0 >= o;
  };
}, "es6", "es3"), $jscomp.polyfill("Array.prototype.find", function (e) {
  return e || function (e, t) {
    return $jscomp.findInternal(this, e, t).v;
  };
}, "es6", "es3"), $jscomp.polyfill("String.prototype.startsWith", function (e) {
  return e || function (e, t) {
    var r = $jscomp.checkStringArgs(this, e, "startsWith");
    e += "";
    var o = r.length,
      n = e.length;
    t = Math.max(0, Math.min(0 | t, r.length));
    for (var a = 0; a < n && t < o;) if (r[t++] != e[a++]) return !1;
    return a >= n;
  };
}, "es6", "es3"), $jscomp.polyfill("String.prototype.repeat", function (e) {
  return e || function (e) {
    var t = $jscomp.checkStringArgs(this, null, "repeat");
    if (0 > e || 1342177279 < e) throw new RangeError("Invalid count value");
    e |= 0;
    for (var r = ""; e;) 1 & e && (r += t), (e >>>= 1) && (t += t);
    return r;
  };
}, "es6", "es3");
var COMPILED$1 = !0,
  goog = goog || {};
goog.global = commonjsGlobal || self, goog.isDef = function (e) {
  return void 0 !== e;
}, goog.isString = function (e) {
  return "string" == typeof e;
}, goog.isBoolean = function (e) {
  return "boolean" == typeof e;
}, goog.isNumber = function (e) {
  return "number" == typeof e;
}, goog.exportPath_ = function (e, t, r) {
  e = e.split("."), r = r || goog.global, e[0] in r || void 0 === r.execScript || r.execScript("var " + e[0]);
  for (var o; e.length && (o = e.shift());) !e.length && goog.isDef(t) ? r[o] = t : r = r[o] && r[o] !== Object.prototype[o] ? r[o] : r[o] = {};
}, goog.define = function (e, t) {
  return t;
}, goog.FEATURESET_YEAR = 2012, goog.DEBUG = !0, goog.LOCALE = "en", goog.TRUSTED_SITE = !0, goog.STRICT_MODE_COMPATIBLE = !1, goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1, goog.provide = function (e) {
  if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
  goog.constructNamespace_(e);
}, goog.constructNamespace_ = function (e, t) {
  goog.exportPath_(e, t);
}, goog.getScriptNonce = function (e) {
  return e && e != goog.global ? goog.getScriptNonce_(e.document) : (null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
}, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function (e) {
  return (e = e.querySelector && e.querySelector("script[nonce]")) && (e = e.nonce || e.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(e) ? e : "";
}, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function (e) {
  if (!goog.isString(e) || !e || -1 == e.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
  if (!goog.isInGoogModuleLoader_()) throw Error("Module " + e + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
  if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
  goog.moduleLoaderState_.moduleName = e;
}, goog.module.get = function (e) {
  return goog.module.getInternal_(e);
}, goog.module.getInternal_ = function (e) {
  return null;
}, goog.ModuleType = {
  ES6: "es6",
  GOOG: "goog"
}, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function () {
  return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
}, goog.isInGoogModuleLoader_ = function () {
  return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
}, goog.isInEs6ModuleLoader_ = function () {
  if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
  var e = goog.global.$jscomp;
  return !!e && "function" == typeof e.getCurrentModulePath && !!e.getCurrentModulePath();
}, goog.module.declareLegacyNamespace = function () {
  goog.moduleLoaderState_.declareLegacyNamespace = !0;
}, goog.declareModuleId = function (e) {
  if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = e;else {
    var t = goog.global.$jscomp;
    if (!t || "function" != typeof t.getCurrentModulePath) throw Error('Module with namespace "' + e + '" has been loaded incorrectly.');
    t = t.require(t.getCurrentModulePath()), goog.loadedModules_[e] = {
      exports: t,
      type: goog.ModuleType.ES6,
      moduleId: e
    };
  }
}, goog.setTestOnly = function (e) {
  if (goog.DISALLOW_TEST_ONLY_CODE) throw e = e || "", Error("Importing test-only code into non-debug environment" + (e ? ": " + e : "."));
}, goog.forwardDeclare = function (e) {}, goog.getObjectByName = function (e, t) {
  e = e.split("."), t = t || goog.global;
  for (var r = 0; r < e.length; r++) if (t = t[e[r]], !goog.isDefAndNotNull(t)) return null;
  return t;
}, goog.globalize = function (e, t) {
  for (var r in t = t || goog.global, e) t[r] = e[r];
}, goog.addDependency = function (e, t, r, o) {}, goog.ENABLE_DEBUG_LOADER = !0, goog.logToConsole_ = function (e) {
  goog.global.console && goog.global.console.error(e);
}, goog.require = function (e) {}, goog.requireType = function (e) {
  return {};
}, goog.basePath = "", goog.nullFunction = function () {}, goog.abstractMethod = function () {
  throw Error("unimplemented abstract method");
}, goog.addSingletonGetter = function (e) {
  e.instance_ = void 0, e.getInstance = function () {
    return e.instance_ ? e.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = e), e.instance_ = new e());
  };
}, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = !0, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !COMPILED$1, goog.TRANSPILE = "detect", goog.ASSUME_ES_MODULES_TRANSPILED = !1, goog.TRANSPILE_TO_LANGUAGE = "", goog.TRANSPILER = "transpile.js", goog.hasBadLetScoping = null, goog.useSafari10Workaround = function () {
  if (null == goog.hasBadLetScoping) {
    try {
      var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
    } catch (e) {
      a = !1;
    }
    goog.hasBadLetScoping = a;
  }
  return goog.hasBadLetScoping;
}, goog.workaroundSafari10EvalBug = function (e) {
  return "(function(){" + e + "\n;})();\n";
}, goog.loadModule = function (e) {
  var t = goog.moduleLoaderState_;
  try {
    if (goog.moduleLoaderState_ = {
      moduleName: "",
      declareLegacyNamespace: !1,
      type: goog.ModuleType.GOOG
    }, goog.isFunction(e)) var r = e.call(void 0, {});else {
      if (!goog.isString(e)) throw Error("Invalid module definition");
      goog.useSafari10Workaround() && (e = goog.workaroundSafari10EvalBug(e)), r = goog.loadModuleFromSource_.call(void 0, e);
    }
    var o = goog.moduleLoaderState_.moduleName;
    if (!goog.isString(o) || !o) throw Error('Invalid module name "' + o + '"');
    goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(o, r) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof r && null != r && Object.seal(r), goog.loadedModules_[o] = {
      exports: r,
      type: goog.ModuleType.GOOG,
      moduleId: goog.moduleLoaderState_.moduleName
    };
  } finally {
    goog.moduleLoaderState_ = t;
  }
}, goog.loadModuleFromSource_ = function (a) {
  return eval(a), {};
}, goog.normalizePath_ = function (e) {
  e = e.split("/");
  for (var t = 0; t < e.length;) "." == e[t] ? e.splice(t, 1) : t && ".." == e[t] && e[t - 1] && ".." != e[t - 1] ? e.splice(--t, 2) : t++;
  return e.join("/");
}, goog.loadFileSync_ = function (e) {
  if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(e);
  try {
    var t = new goog.global.XMLHttpRequest();
    return t.open("get", e, !1), t.send(), 0 == t.status || 200 == t.status ? t.responseText : null;
  } catch (e) {
    return null;
  }
}, goog.transpile_ = function (e, t, r) {
  var o = goog.global.$jscomp;
  o || (goog.global.$jscomp = o = {});
  var n = o.transpile;
  if (!n) {
    var a = goog.basePath + goog.TRANSPILER,
      i = goog.loadFileSync_(a);
    if (i) {
      if (function () {
        (0, eval)(i + "\n//# sourceURL=" + a);
      }.call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
      goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, n = (o = goog.global.$jscomp).transpile;
    }
  }
  return n || (n = o.transpile = function (e, t) {
    return goog.logToConsole_(t + " requires transpilation but no transpiler was found."), e;
  }), n(e, t, r);
}, goog.typeOf = function (e) {
  var t = typeof e;
  if ("object" == t) {
    if (!e) return "null";
    if (e instanceof Array) return "array";
    if (e instanceof Object) return t;
    var r = Object.prototype.toString.call(e);
    if ("[object Window]" == r) return "object";
    if ("[object Array]" == r || "number" == typeof e.length && void 0 !== e.splice && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("splice")) return "array";
    if ("[object Function]" == r || void 0 !== e.call && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("call")) return "function";
  } else if ("function" == t && void 0 === e.call) return "object";
  return t;
}, goog.isNull = function (e) {
  return null === e;
}, goog.isDefAndNotNull = function (e) {
  return null != e;
}, goog.isArray = function (e) {
  return "array" == goog.typeOf(e);
}, goog.isArrayLike = function (e) {
  var t = goog.typeOf(e);
  return "array" == t || "object" == t && "number" == typeof e.length;
}, goog.isDateLike = function (e) {
  return goog.isObject(e) && "function" == typeof e.getFullYear;
}, goog.isFunction = function (e) {
  return "function" == goog.typeOf(e);
}, goog.isObject = function (e) {
  var t = typeof e;
  return "object" == t && null != e || "function" == t;
}, goog.getUid = function (e) {
  return e[goog.UID_PROPERTY_] || (e[goog.UID_PROPERTY_] = ++goog.uidCounter_);
}, goog.hasUid = function (e) {
  return !!e[goog.UID_PROPERTY_];
}, goog.removeUid = function (e) {
  null !== e && "removeAttribute" in e && e.removeAttribute(goog.UID_PROPERTY_);
  try {
    delete e[goog.UID_PROPERTY_];
  } catch (e) {}
}, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.getHashCode = goog.getUid, goog.removeHashCode = goog.removeUid, goog.cloneObject = function (e) {
  var t = goog.typeOf(e);
  if ("object" == t || "array" == t) {
    if ("function" == typeof e.clone) return e.clone();
    for (var r in t = "array" == t ? [] : {}, e) t[r] = goog.cloneObject(e[r]);
    return t;
  }
  return e;
}, goog.bindNative_ = function (e, t, r) {
  return e.call.apply(e.bind, arguments);
}, goog.bindJs_ = function (e, t, r) {
  if (!e) throw Error();
  if (2 < arguments.length) {
    var o = Array.prototype.slice.call(arguments, 2);
    return function () {
      var r = Array.prototype.slice.call(arguments);
      return Array.prototype.unshift.apply(r, o), e.apply(t, r);
    };
  }
  return function () {
    return e.apply(t, arguments);
  };
}, goog.bind = function (e, t, r) {
  return Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
}, goog.partial = function (e, t) {
  var r = Array.prototype.slice.call(arguments, 1);
  return function () {
    var t = r.slice();
    return t.push.apply(t, arguments), e.apply(this, t);
  };
}, goog.mixin = function (e, t) {
  for (var r in t) e[r] = t[r];
}, goog.now = goog.TRUSTED_SITE && Date.now || function () {
  return +new Date();
}, goog.globalEval = function (e) {
  if (goog.global.execScript) goog.global.execScript(e, "JavaScript");else {
    if (!goog.global.eval) throw Error("goog.globalEval not available");
    if (null == goog.evalWorksForGlobals_) {
      try {
        goog.global.eval("var _evalTest_ = 1;");
      } catch (e) {}
      if (void 0 !== goog.global._evalTest_) {
        try {
          delete goog.global._evalTest_;
        } catch (e) {}
        goog.evalWorksForGlobals_ = !0;
      } else goog.evalWorksForGlobals_ = !1;
    }
    if (goog.evalWorksForGlobals_) goog.global.eval(e);else {
      var t = goog.global.document,
        r = t.createElement("SCRIPT");
      r.type = "text/javascript", r.defer = !1, r.appendChild(t.createTextNode(e)), t.head.appendChild(r), t.head.removeChild(r);
    }
  }
}, goog.evalWorksForGlobals_ = null, goog.getCssName = function (e, t) {
  if ("." == String(e).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + e);
  var r = function r(e) {
      return goog.cssNameMapping_[e] || e;
    },
    o = function o(e) {
      e = e.split("-");
      for (var t = [], o = 0; o < e.length; o++) t.push(r(e[o]));
      return t.join("-");
    };
  return o = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? r : o : function (e) {
    return e;
  }, e = t ? e + "-" + o(t) : o(e), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(e) : e;
}, goog.setCssNameMapping = function (e, t) {
  goog.cssNameMapping_ = e, goog.cssNameMappingStyle_ = t;
}, goog.getMsg = function (e, t, r) {
  return r && r.html && (e = e.replace(/</g, "&lt;")), t && (e = e.replace(/\{\$([^}]+)}/g, function (e, r) {
    return null != t && r in t ? t[r] : e;
  })), e;
}, goog.getMsgWithFallback = function (e, t) {
  return e;
}, goog.exportSymbol = function (e, t, r) {
  goog.exportPath_(e, t, r);
}, goog.exportProperty = function (e, t, r) {
  e[t] = r;
}, goog.inherits = function (e, t) {
  function r() {}
  r.prototype = t.prototype, e.superClass_ = t.prototype, e.prototype = new r(), e.prototype.constructor = e, e.base = function (e, r, o) {
    for (var n = Array(arguments.length - 2), a = 2; a < arguments.length; a++) n[a - 2] = arguments[a];
    return t.prototype[r].apply(e, n);
  };
}, goog.base = function (e, t, r) {
  var o = arguments.callee.caller;
  if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !o) throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
  if (void 0 !== o.superClass_) {
    for (var n = Array(arguments.length - 1), a = 1; a < arguments.length; a++) n[a - 1] = arguments[a];
    return o.superClass_.constructor.apply(e, n);
  }
  if ("string" != typeof t && "symbol" != typeof t) throw Error("method names provided to goog.base must be a string or a symbol");
  for (n = Array(arguments.length - 2), a = 2; a < arguments.length; a++) n[a - 2] = arguments[a];
  a = !1;
  for (var i = e.constructor.prototype; i; i = Object.getPrototypeOf(i)) if (i[t] === o) a = !0;else if (a) return i[t].apply(e, n);
  if (e[t] === o) return e.constructor.prototype[t].apply(e, n);
  throw Error("goog.base called from a method of one name to a method of a different name");
}, goog.scope = function (e) {
  if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
  e.call(goog.global);
}, goog.defineClass = function (e, t) {
  var r = t.constructor,
    o = t.statics;
  return r && r != Object.prototype.constructor || (r = function r() {
    throw Error("cannot instantiate an interface (no constructor defined).");
  }), r = goog.defineClass.createSealingConstructor_(r, e), e && goog.inherits(r, e), delete t.constructor, delete t.statics, goog.defineClass.applyProperties_(r.prototype, t), null != o && (o instanceof Function ? o(r) : goog.defineClass.applyProperties_(r, o)), r;
}, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function (e, t) {
  if (!goog.defineClass.SEAL_CLASS_INSTANCES) return e;
  var r = !goog.defineClass.isUnsealable_(t),
    o = function o() {
      var t = e.apply(this, arguments) || this;
      return t[goog.UID_PROPERTY_] = t[goog.UID_PROPERTY_], this.constructor === o && r && Object.seal instanceof Function && Object.seal(t), t;
    };
  return o;
}, goog.defineClass.isUnsealable_ = function (e) {
  return e && e.prototype && e.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
}, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function (e, t) {
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  for (var o = 0; o < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; o++) r = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[o], Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
}, goog.tagUnsealableClass = function (e) {}, goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable", goog.TRUSTED_TYPES_POLICY_NAME = "", goog.identity_ = function (e) {
  return e;
}, goog.createTrustedTypesPolicy = function (e) {
  var t = null;
  if ("undefined" == typeof TrustedTypes || !TrustedTypes.createPolicy) return t;
  try {
    t = TrustedTypes.createPolicy(e, {
      createHTML: goog.identity_,
      createScript: goog.identity_,
      createScriptURL: goog.identity_,
      createURL: goog.identity_
    });
  } catch (e) {
    goog.logToConsole_(e.message);
  }
  return t;
}, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null;
var jspb = {
  BinaryConstants: {},
  ConstBinaryMessage: function ConstBinaryMessage() {},
  BinaryMessage: function BinaryMessage() {}
};
jspb.BinaryConstants.FieldType = {
  INVALID: -1,
  DOUBLE: 1,
  FLOAT: 2,
  INT64: 3,
  UINT64: 4,
  INT32: 5,
  FIXED64: 6,
  FIXED32: 7,
  BOOL: 8,
  STRING: 9,
  GROUP: 10,
  MESSAGE: 11,
  BYTES: 12,
  UINT32: 13,
  ENUM: 14,
  SFIXED32: 15,
  SFIXED64: 16,
  SINT32: 17,
  SINT64: 18,
  FHASH64: 30,
  VHASH64: 31
}, jspb.BinaryConstants.WireType = {
  INVALID: -1,
  VARINT: 0,
  FIXED64: 1,
  DELIMITED: 2,
  START_GROUP: 3,
  END_GROUP: 4,
  FIXED32: 5
}, jspb.BinaryConstants.FieldTypeToWireType = function (e) {
  var t = jspb.BinaryConstants.FieldType,
    r = jspb.BinaryConstants.WireType;
  switch (e) {
    case t.INT32:
    case t.INT64:
    case t.UINT32:
    case t.UINT64:
    case t.SINT32:
    case t.SINT64:
    case t.BOOL:
    case t.ENUM:
    case t.VHASH64:
      return r.VARINT;
    case t.DOUBLE:
    case t.FIXED64:
    case t.SFIXED64:
    case t.FHASH64:
      return r.FIXED64;
    case t.STRING:
    case t.MESSAGE:
    case t.BYTES:
      return r.DELIMITED;
    case t.FLOAT:
    case t.FIXED32:
    case t.SFIXED32:
      return r.FIXED32;
    default:
      return r.INVALID;
  }
}, jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1, jspb.BinaryConstants.FLOAT32_EPS = 1401298464324817e-60, jspb.BinaryConstants.FLOAT32_MIN = 11754943508222875e-54, jspb.BinaryConstants.FLOAT32_MAX = 34028234663852886e22, jspb.BinaryConstants.FLOAT64_EPS = 5e-324, jspb.BinaryConstants.FLOAT64_MIN = 22250738585072014e-324, jspb.BinaryConstants.FLOAT64_MAX = 17976931348623157e292, jspb.BinaryConstants.TWO_TO_20 = 1048576, jspb.BinaryConstants.TWO_TO_23 = 8388608, jspb.BinaryConstants.TWO_TO_31 = 2147483648, jspb.BinaryConstants.TWO_TO_32 = 4294967296, jspb.BinaryConstants.TWO_TO_52 = 4503599627370496, jspb.BinaryConstants.TWO_TO_63 = 0x8000000000000000, jspb.BinaryConstants.TWO_TO_64 = 0x10000000000000000, jspb.BinaryConstants.ZERO_HASH = "\0\0\0\0\0\0\0\0", goog.dom = {}, goog.dom.NodeType = {
  ELEMENT: 1,
  ATTRIBUTE: 2,
  TEXT: 3,
  CDATA_SECTION: 4,
  ENTITY_REFERENCE: 5,
  ENTITY: 6,
  PROCESSING_INSTRUCTION: 7,
  COMMENT: 8,
  DOCUMENT: 9,
  DOCUMENT_TYPE: 10,
  DOCUMENT_FRAGMENT: 11,
  NOTATION: 12
}, goog.debug = {}, goog.debug.Error = function (e) {
  if (Error.captureStackTrace) Error.captureStackTrace(this, goog.debug.Error);else {
    var t = Error().stack;
    t && (this.stack = t);
  }
  e && (this.message = String(e)), this.reportErrorToServer = !0;
}, goog.inherits(goog.debug.Error, Error), goog.debug.Error.prototype.name = "CustomError", goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function (e, t) {
  goog.debug.Error.call(this, goog.asserts.subs_(e, t)), this.messagePattern = e;
}, goog.inherits(goog.asserts.AssertionError, goog.debug.Error), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function (e) {
  throw e;
}, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function (e, t) {
  for (var r = "", o = (e = e.split("%s")).length - 1, n = 0; n < o; n++) r += e[n] + (n < t.length ? t[n] : "%s");
  return r + e[o];
}, goog.asserts.doAssertFailure_ = function (e, t, r, o) {
  var n = "Assertion failed";
  if (r) {
    n += ": " + r;
    var a = o;
  } else e && (n += ": " + e, a = t);
  e = new goog.asserts.AssertionError("" + n, a || []), goog.asserts.errorHandler_(e);
}, goog.asserts.setErrorHandler = function (e) {
  goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = e);
}, goog.asserts.assert = function (e, t, r) {
  return goog.asserts.ENABLE_ASSERTS && !e && goog.asserts.doAssertFailure_("", null, t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertExists = function (e, t, r) {
  return goog.asserts.ENABLE_ASSERTS && null == e && goog.asserts.doAssertFailure_("Expected to exist: %s.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.fail = function (e, t) {
  goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (e ? ": " + e : ""), Array.prototype.slice.call(arguments, 1)));
}, goog.asserts.assertNumber = function (e, t, r) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isNumber(e) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertString = function (e, t, r) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isString(e) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertFunction = function (e, t, r) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isFunction(e) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertObject = function (e, t, r) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isObject(e) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertArray = function (e, t, r) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isArray(e) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertBoolean = function (e, t, r) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(e) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertElement = function (e, t, r) {
  return !goog.asserts.ENABLE_ASSERTS || goog.isObject(e) && e.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertInstanceof = function (e, t, r, o) {
  return !goog.asserts.ENABLE_ASSERTS || e instanceof t || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(t), goog.asserts.getType_(e)], r, Array.prototype.slice.call(arguments, 3)), e;
}, goog.asserts.assertFinite = function (e, t, r) {
  return !goog.asserts.ENABLE_ASSERTS || "number" == typeof e && isFinite(e) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertObjectPrototypeIsIntact = function () {
  for (var e in Object.prototype) goog.asserts.fail(e + " should not be enumerable in Object.prototype.");
}, goog.asserts.getType_ = function (e) {
  return e instanceof Function ? e.displayName || e.name || "unknown type name" : e instanceof Object ? e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e) : null === e ? "null" : typeof e;
}, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE, goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR, goog.array.peek = function (e) {
  return e[e.length - 1];
}, goog.array.last = goog.array.peek, goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function (e, t, r) {
  return goog.asserts.assert(null != e.length), Array.prototype.indexOf.call(e, t, r);
} : function (e, t, r) {
  if (r = null == r ? 0 : 0 > r ? Math.max(0, e.length + r) : r, goog.isString(e)) return goog.isString(t) && 1 == t.length ? e.indexOf(t, r) : -1;
  for (; r < e.length; r++) if (r in e && e[r] === t) return r;
  return -1;
}, goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function (e, t, r) {
  return goog.asserts.assert(null != e.length), Array.prototype.lastIndexOf.call(e, t, null == r ? e.length - 1 : r);
} : function (e, t, r) {
  if (0 > (r = null == r ? e.length - 1 : r) && (r = Math.max(0, e.length + r)), goog.isString(e)) return goog.isString(t) && 1 == t.length ? e.lastIndexOf(t, r) : -1;
  for (; 0 <= r; r--) if (r in e && e[r] === t) return r;
  return -1;
}, goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function (e, t, r) {
  goog.asserts.assert(null != e.length), Array.prototype.forEach.call(e, t, r);
} : function (e, t, r) {
  for (var o = e.length, n = goog.isString(e) ? e.split("") : e, a = 0; a < o; a++) a in n && t.call(r, n[a], a, e);
}, goog.array.forEachRight = function (e, t, r) {
  var o = e.length,
    n = goog.isString(e) ? e.split("") : e;
  for (--o; 0 <= o; --o) o in n && t.call(r, n[o], o, e);
}, goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function (e, t, r) {
  return goog.asserts.assert(null != e.length), Array.prototype.filter.call(e, t, r);
} : function (e, t, r) {
  for (var o = e.length, n = [], a = 0, i = goog.isString(e) ? e.split("") : e, s = 0; s < o; s++) if (s in i) {
    var u = i[s];
    t.call(r, u, s, e) && (n[a++] = u);
  }
  return n;
}, goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function (e, t, r) {
  return goog.asserts.assert(null != e.length), Array.prototype.map.call(e, t, r);
} : function (e, t, r) {
  for (var o = e.length, n = Array(o), a = goog.isString(e) ? e.split("") : e, i = 0; i < o; i++) i in a && (n[i] = t.call(r, a[i], i, e));
  return n;
}, goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function (e, t, r, o) {
  return goog.asserts.assert(null != e.length), o && (t = goog.bind(t, o)), Array.prototype.reduce.call(e, t, r);
} : function (e, t, r, o) {
  var n = r;
  return goog.array.forEach(e, function (r, a) {
    n = t.call(o, n, r, a, e);
  }), n;
}, goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function (e, t, r, o) {
  return goog.asserts.assert(null != e.length), goog.asserts.assert(null != t), o && (t = goog.bind(t, o)), Array.prototype.reduceRight.call(e, t, r);
} : function (e, t, r, o) {
  var n = r;
  return goog.array.forEachRight(e, function (r, a) {
    n = t.call(o, n, r, a, e);
  }), n;
}, goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function (e, t, r) {
  return goog.asserts.assert(null != e.length), Array.prototype.some.call(e, t, r);
} : function (e, t, r) {
  for (var o = e.length, n = goog.isString(e) ? e.split("") : e, a = 0; a < o; a++) if (a in n && t.call(r, n[a], a, e)) return !0;
  return !1;
}, goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function (e, t, r) {
  return goog.asserts.assert(null != e.length), Array.prototype.every.call(e, t, r);
} : function (e, t, r) {
  for (var o = e.length, n = goog.isString(e) ? e.split("") : e, a = 0; a < o; a++) if (a in n && !t.call(r, n[a], a, e)) return !1;
  return !0;
}, goog.array.count = function (e, t, r) {
  var o = 0;
  return goog.array.forEach(e, function (e, n, a) {
    t.call(r, e, n, a) && ++o;
  }, r), o;
}, goog.array.find = function (e, t, r) {
  return 0 > (t = goog.array.findIndex(e, t, r)) ? null : goog.isString(e) ? e.charAt(t) : e[t];
}, goog.array.findIndex = function (e, t, r) {
  for (var o = e.length, n = goog.isString(e) ? e.split("") : e, a = 0; a < o; a++) if (a in n && t.call(r, n[a], a, e)) return a;
  return -1;
}, goog.array.findRight = function (e, t, r) {
  return 0 > (t = goog.array.findIndexRight(e, t, r)) ? null : goog.isString(e) ? e.charAt(t) : e[t];
}, goog.array.findIndexRight = function (e, t, r) {
  var o = e.length,
    n = goog.isString(e) ? e.split("") : e;
  for (--o; 0 <= o; o--) if (o in n && t.call(r, n[o], o, e)) return o;
  return -1;
}, goog.array.contains = function (e, t) {
  return 0 <= goog.array.indexOf(e, t);
}, goog.array.isEmpty = function (e) {
  return 0 == e.length;
}, goog.array.clear = function (e) {
  if (!goog.isArray(e)) for (var t = e.length - 1; 0 <= t; t--) delete e[t];
  e.length = 0;
}, goog.array.insert = function (e, t) {
  goog.array.contains(e, t) || e.push(t);
}, goog.array.insertAt = function (e, t, r) {
  goog.array.splice(e, r, 0, t);
}, goog.array.insertArrayAt = function (e, t, r) {
  goog.partial(goog.array.splice, e, r, 0).apply(null, t);
}, goog.array.insertBefore = function (e, t, r) {
  var o;
  2 == arguments.length || 0 > (o = goog.array.indexOf(e, r)) ? e.push(t) : goog.array.insertAt(e, t, o);
}, goog.array.remove = function (e, t) {
  var r;
  return (r = 0 <= (t = goog.array.indexOf(e, t))) && goog.array.removeAt(e, t), r;
}, goog.array.removeLast = function (e, t) {
  return 0 <= (t = goog.array.lastIndexOf(e, t)) && (goog.array.removeAt(e, t), !0);
}, goog.array.removeAt = function (e, t) {
  return goog.asserts.assert(null != e.length), 1 == Array.prototype.splice.call(e, t, 1).length;
}, goog.array.removeIf = function (e, t, r) {
  return 0 <= (t = goog.array.findIndex(e, t, r)) && (goog.array.removeAt(e, t), !0);
}, goog.array.removeAllIf = function (e, t, r) {
  var o = 0;
  return goog.array.forEachRight(e, function (n, a) {
    t.call(r, n, a, e) && goog.array.removeAt(e, a) && o++;
  }), o;
}, goog.array.concat = function (e) {
  return Array.prototype.concat.apply([], arguments);
}, goog.array.join = function (e) {
  return Array.prototype.concat.apply([], arguments);
}, goog.array.toArray = function (e) {
  var t = e.length;
  if (0 < t) {
    for (var r = Array(t), o = 0; o < t; o++) r[o] = e[o];
    return r;
  }
  return [];
}, goog.array.clone = goog.array.toArray, goog.array.extend = function (e, t) {
  for (var r = 1; r < arguments.length; r++) {
    var o = arguments[r];
    if (goog.isArrayLike(o)) {
      var n = e.length || 0,
        a = o.length || 0;
      e.length = n + a;
      for (var i = 0; i < a; i++) e[n + i] = o[i];
    } else e.push(o);
  }
}, goog.array.splice = function (e, t, r, o) {
  return goog.asserts.assert(null != e.length), Array.prototype.splice.apply(e, goog.array.slice(arguments, 1));
}, goog.array.slice = function (e, t, r) {
  return goog.asserts.assert(null != e.length), 2 >= arguments.length ? Array.prototype.slice.call(e, t) : Array.prototype.slice.call(e, t, r);
}, goog.array.removeDuplicates = function (e, t, r) {
  t = t || e;
  var o = function o(e) {
    return goog.isObject(e) ? "o" + goog.getUid(e) : (typeof e).charAt(0) + e;
  };
  r = r || o, o = {};
  for (var n = 0, a = 0; a < e.length;) {
    var i = e[a++],
      s = r(i);
    Object.prototype.hasOwnProperty.call(o, s) || (o[s] = !0, t[n++] = i);
  }
  t.length = n;
}, goog.array.binarySearch = function (e, t, r) {
  return goog.array.binarySearch_(e, r || goog.array.defaultCompare, !1, t);
}, goog.array.binarySelect = function (e, t, r) {
  return goog.array.binarySearch_(e, t, !0, void 0, r);
}, goog.array.binarySearch_ = function (e, t, r, o, n) {
  for (var a, i = 0, s = e.length; i < s;) {
    var u = i + s >> 1,
      l = r ? t.call(n, e[u], u, e) : t(o, e[u]);
    0 < l ? i = u + 1 : (s = u, a = !l);
  }
  return a ? i : ~i;
}, goog.array.sort = function (e, t) {
  e.sort(t || goog.array.defaultCompare);
}, goog.array.stableSort = function (e, t) {
  for (var r = Array(e.length), o = 0; o < e.length; o++) r[o] = {
    index: o,
    value: e[o]
  };
  var n = t || goog.array.defaultCompare;
  for (goog.array.sort(r, function (e, t) {
    return n(e.value, t.value) || e.index - t.index;
  }), o = 0; o < e.length; o++) e[o] = r[o].value;
}, goog.array.sortByKey = function (e, t, r) {
  var o = r || goog.array.defaultCompare;
  goog.array.sort(e, function (e, r) {
    return o(t(e), t(r));
  });
}, goog.array.sortObjectsByKey = function (e, t, r) {
  goog.array.sortByKey(e, function (e) {
    return e[t];
  }, r);
}, goog.array.isSorted = function (e, t, r) {
  t = t || goog.array.defaultCompare;
  for (var o = 1; o < e.length; o++) {
    var n = t(e[o - 1], e[o]);
    if (0 < n || 0 == n && r) return !1;
  }
  return !0;
}, goog.array.equals = function (e, t, r) {
  if (!goog.isArrayLike(e) || !goog.isArrayLike(t) || e.length != t.length) return !1;
  var o = e.length;
  r = r || goog.array.defaultCompareEquality;
  for (var n = 0; n < o; n++) if (!r(e[n], t[n])) return !1;
  return !0;
}, goog.array.compare3 = function (e, t, r) {
  r = r || goog.array.defaultCompare;
  for (var o = Math.min(e.length, t.length), n = 0; n < o; n++) {
    var a = r(e[n], t[n]);
    if (0 != a) return a;
  }
  return goog.array.defaultCompare(e.length, t.length);
}, goog.array.defaultCompare = function (e, t) {
  return e > t ? 1 : e < t ? -1 : 0;
}, goog.array.inverseDefaultCompare = function (e, t) {
  return -goog.array.defaultCompare(e, t);
}, goog.array.defaultCompareEquality = function (e, t) {
  return e === t;
}, goog.array.binaryInsert = function (e, t, r) {
  return 0 > (r = goog.array.binarySearch(e, t, r)) && (goog.array.insertAt(e, t, -(r + 1)), !0);
}, goog.array.binaryRemove = function (e, t, r) {
  return 0 <= (t = goog.array.binarySearch(e, t, r)) && goog.array.removeAt(e, t);
}, goog.array.bucket = function (e, t, r) {
  for (var o = {}, n = 0; n < e.length; n++) {
    var a = e[n],
      i = t.call(r, a, n, e);
    goog.isDef(i) && (o[i] || (o[i] = [])).push(a);
  }
  return o;
}, goog.array.toObject = function (e, t, r) {
  var o = {};
  return goog.array.forEach(e, function (n, a) {
    o[t.call(r, n, a, e)] = n;
  }), o;
}, goog.array.range = function (e, t, r) {
  var o = [],
    n = 0,
    a = e;
  if (void 0 !== t && (n = e, a = t), 0 > (r = r || 1) * (a - n)) return [];
  if (0 < r) for (e = n; e < a; e += r) o.push(e);else for (e = n; e > a; e += r) o.push(e);
  return o;
}, goog.array.repeat = function (e, t) {
  for (var r = [], o = 0; o < t; o++) r[o] = e;
  return r;
}, goog.array.flatten = function (e) {
  for (var t = [], r = 0; r < arguments.length; r++) {
    var o = arguments[r];
    if (goog.isArray(o)) for (var n = 0; n < o.length; n += 8192) {
      var a = goog.array.slice(o, n, n + 8192);
      a = goog.array.flatten.apply(null, a);
      for (var i = 0; i < a.length; i++) t.push(a[i]);
    } else t.push(o);
  }
  return t;
}, goog.array.rotate = function (e, t) {
  return goog.asserts.assert(null != e.length), e.length && (0 < (t %= e.length) ? Array.prototype.unshift.apply(e, e.splice(-t, t)) : 0 > t && Array.prototype.push.apply(e, e.splice(0, -t))), e;
}, goog.array.moveItem = function (e, t, r) {
  goog.asserts.assert(0 <= t && t < e.length), goog.asserts.assert(0 <= r && r < e.length), t = Array.prototype.splice.call(e, t, 1), Array.prototype.splice.call(e, r, 0, t[0]);
}, goog.array.zip = function (e) {
  if (!arguments.length) return [];
  for (var t = [], r = arguments[0].length, o = 1; o < arguments.length; o++) arguments[o].length < r && (r = arguments[o].length);
  for (o = 0; o < r; o++) {
    for (var n = [], a = 0; a < arguments.length; a++) n.push(arguments[a][o]);
    t.push(n);
  }
  return t;
}, goog.array.shuffle = function (e, t) {
  t = t || Math.random;
  for (var r = e.length - 1; 0 < r; r--) {
    var o = Math.floor(t() * (r + 1)),
      n = e[r];
    e[r] = e[o], e[o] = n;
  }
}, goog.array.copyByIndex = function (e, t) {
  var r = [];
  return goog.array.forEach(t, function (t) {
    r.push(e[t]);
  }), r;
}, goog.array.concatMap = function (e, t, r) {
  return goog.array.concat.apply([], goog.array.map(e, t, r));
}, goog.crypt = {}, goog.crypt.stringToByteArray = function (e) {
  for (var t = [], r = 0, o = 0; o < e.length; o++) {
    var n = e.charCodeAt(o);
    255 < n && (t[r++] = 255 & n, n >>= 8), t[r++] = n;
  }
  return t;
}, goog.crypt.byteArrayToString = function (e) {
  if (8192 >= e.length) return String.fromCharCode.apply(null, e);
  for (var t = "", r = 0; r < e.length; r += 8192) {
    var o = goog.array.slice(e, r, r + 8192);
    t += String.fromCharCode.apply(null, o);
  }
  return t;
}, goog.crypt.byteArrayToHex = function (e, t) {
  return goog.array.map(e, function (e) {
    return 1 < (e = e.toString(16)).length ? e : "0" + e;
  }).join(t || "");
}, goog.crypt.hexToByteArray = function (e) {
  goog.asserts.assert(0 == e.length % 2, "Key string length must be multiple of 2");
  for (var t = [], r = 0; r < e.length; r += 2) t.push(parseInt(e.substring(r, r + 2), 16));
  return t;
}, goog.crypt.stringToUtf8ByteArray = function (e) {
  for (var t = [], r = 0, o = 0; o < e.length; o++) {
    var n = e.charCodeAt(o);
    128 > n ? t[r++] = n : (2048 > n ? t[r++] = n >> 6 | 192 : (55296 == (64512 & n) && o + 1 < e.length && 56320 == (64512 & e.charCodeAt(o + 1)) ? (n = 65536 + ((1023 & n) << 10) + (1023 & e.charCodeAt(++o)), t[r++] = n >> 18 | 240, t[r++] = n >> 12 & 63 | 128) : t[r++] = n >> 12 | 224, t[r++] = n >> 6 & 63 | 128), t[r++] = 63 & n | 128);
  }
  return t;
}, goog.crypt.utf8ByteArrayToString = function (e) {
  for (var t = [], r = 0, o = 0; r < e.length;) {
    var n = e[r++];
    if (128 > n) t[o++] = String.fromCharCode(n);else if (191 < n && 224 > n) {
      var a = e[r++];
      t[o++] = String.fromCharCode((31 & n) << 6 | 63 & a);
    } else if (239 < n && 365 > n) {
      a = e[r++];
      var i = e[r++];
      n = ((7 & n) << 18 | (63 & a) << 12 | (63 & i) << 6 | 63 & e[r++]) - 65536, t[o++] = String.fromCharCode(55296 + (n >> 10)), t[o++] = String.fromCharCode(56320 + (1023 & n));
    } else a = e[r++], i = e[r++], t[o++] = String.fromCharCode((15 & n) << 12 | (63 & a) << 6 | 63 & i);
  }
  return t.join("");
}, goog.crypt.xorByteArray = function (e, t) {
  goog.asserts.assert(e.length == t.length, "XOR array lengths must match");
  for (var r = [], o = 0; o < e.length; o++) r.push(e[o] ^ t[o]);
  return r;
}, goog.string = {}, goog.string.internal = {}, goog.string.internal.startsWith = function (e, t) {
  return 0 == e.lastIndexOf(t, 0);
}, goog.string.internal.endsWith = function (e, t) {
  var r = e.length - t.length;
  return 0 <= r && e.indexOf(t, r) == r;
}, goog.string.internal.caseInsensitiveStartsWith = function (e, t) {
  return 0 == goog.string.internal.caseInsensitiveCompare(t, e.substr(0, t.length));
}, goog.string.internal.caseInsensitiveEndsWith = function (e, t) {
  return 0 == goog.string.internal.caseInsensitiveCompare(t, e.substr(e.length - t.length, t.length));
}, goog.string.internal.caseInsensitiveEquals = function (e, t) {
  return e.toLowerCase() == t.toLowerCase();
}, goog.string.internal.isEmptyOrWhitespace = function (e) {
  return /^[\s\xa0]*$/.test(e);
}, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function (e) {
  return e.trim();
} : function (e) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e)[1];
}, goog.string.internal.caseInsensitiveCompare = function (e, t) {
  return (e = String(e).toLowerCase()) < (t = String(t).toLowerCase()) ? -1 : e == t ? 0 : 1;
}, goog.string.internal.newLineToBr = function (e, t) {
  return e.replace(/(\r\n|\r|\n)/g, t ? "<br />" : "<br>");
}, goog.string.internal.htmlEscape = function (e, t) {
  if (t) e = e.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");else {
    if (!goog.string.internal.ALL_RE_.test(e)) return e;
    -1 != e.indexOf("&") && (e = e.replace(goog.string.internal.AMP_RE_, "&amp;")), -1 != e.indexOf("<") && (e = e.replace(goog.string.internal.LT_RE_, "&lt;")), -1 != e.indexOf(">") && (e = e.replace(goog.string.internal.GT_RE_, "&gt;")), -1 != e.indexOf('"') && (e = e.replace(goog.string.internal.QUOT_RE_, "&quot;")), -1 != e.indexOf("'") && (e = e.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;")), -1 != e.indexOf("\0") && (e = e.replace(goog.string.internal.NULL_RE_, "&#0;"));
  }
  return e;
}, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function (e, t) {
  return goog.string.internal.newLineToBr(e.replace(/  /g, " &#160;"), t);
}, goog.string.internal.contains = function (e, t) {
  return -1 != e.indexOf(t);
}, goog.string.internal.caseInsensitiveContains = function (e, t) {
  return goog.string.internal.contains(e.toLowerCase(), t.toLowerCase());
}, goog.string.internal.compareVersions = function (e, t) {
  var r = 0;
  e = goog.string.internal.trim(String(e)).split("."), t = goog.string.internal.trim(String(t)).split(".");
  for (var o = Math.max(e.length, t.length), n = 0; 0 == r && n < o; n++) {
    var a = e[n] || "",
      i = t[n] || "";
    do {
      if (a = /(\d*)(\D*)(.*)/.exec(a) || ["", "", "", ""], i = /(\d*)(\D*)(.*)/.exec(i) || ["", "", "", ""], 0 == a[0].length && 0 == i[0].length) break;
      r = 0 == a[1].length ? 0 : parseInt(a[1], 10);
      var s = 0 == i[1].length ? 0 : parseInt(i[1], 10);
      r = goog.string.internal.compareElements_(r, s) || goog.string.internal.compareElements_(0 == a[2].length, 0 == i[2].length) || goog.string.internal.compareElements_(a[2], i[2]), a = a[3], i = i[3];
    } while (0 == r);
  }
  return r;
}, goog.string.internal.compareElements_ = function (e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}, goog.string.TypedString = function () {}, goog.string.Const = function (e, t) {
  this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = e === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && t || "", this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
}, goog.string.Const.prototype.implementsGoogStringTypedString = !0, goog.string.Const.prototype.getTypedStringValue = function () {
  return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
}, goog.string.Const.prototype.toString = function () {
  return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
}, goog.string.Const.unwrap = function (e) {
  return e instanceof goog.string.Const && e.constructor === goog.string.Const && e.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? e.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail("expected object of type Const, got '" + e + "'"), "type_error:Const");
}, goog.string.Const.from = function (e) {
  return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, e);
}, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(""), goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function (e) {
  return goog.fs.url.getUrlObject_().createObjectURL(e);
}, goog.fs.url.revokeObjectUrl = function (e) {
  goog.fs.url.getUrlObject_().revokeObjectURL(e);
}, goog.fs.url.getUrlObject_ = function () {
  var e = goog.fs.url.findUrlObject_();
  if (null != e) return e;
  throw Error("This browser doesn't seem to support blob URLs");
}, goog.fs.url.findUrlObject_ = function () {
  return goog.isDef(goog.global.URL) && goog.isDef(goog.global.URL.createObjectURL) ? goog.global.URL : goog.isDef(goog.global.webkitURL) && goog.isDef(goog.global.webkitURL.createObjectURL) ? goog.global.webkitURL : goog.isDef(goog.global.createObjectURL) ? goog.global : null;
}, goog.fs.url.browserSupportsObjectUrls = function () {
  return null != goog.fs.url.findUrlObject_();
}, goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = !1, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || "nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase()), goog.i18n.bidi.Format = {
  LRE: "‪",
  RLE: "‫",
  PDF: "‬",
  LRM: "‎",
  RLM: "‏"
}, goog.i18n.bidi.Dir = {
  LTR: 1,
  RTL: -1,
  NEUTRAL: 0
}, goog.i18n.bidi.RIGHT = "right", goog.i18n.bidi.LEFT = "left", goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function (e, t) {
  return "number" == typeof e ? 0 < e ? goog.i18n.bidi.Dir.LTR : 0 > e ? goog.i18n.bidi.Dir.RTL : t ? null : goog.i18n.bidi.Dir.NEUTRAL : null == e ? null : e ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
}, goog.i18n.bidi.ltrChars_ = "A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0900-\u1FFF\u200E\u2C00-\uD801\uD804-\uD839\uD83C-\uDBFF\uF900-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF", goog.i18n.bidi.rtlChars_ = "\u0591-\u06EF\u06FA-\u08FF\u200F\uD802-\uD803\uD83A-\uD83B\uFB1D-\uFDFF\uFE70-\uFEFC", goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function (e, t) {
  return t ? e.replace(goog.i18n.bidi.htmlSkipReg_, "") : e;
}, goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.hasAnyRtl = function (e, t) {
  return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function (e, t) {
  return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.isRtlChar = function (e) {
  return goog.i18n.bidi.rtlRe_.test(e);
}, goog.i18n.bidi.isLtrChar = function (e) {
  return goog.i18n.bidi.ltrRe_.test(e);
}, goog.i18n.bidi.isNeutralChar = function (e) {
  return !goog.i18n.bidi.isLtrChar(e) && !goog.i18n.bidi.isRtlChar(e);
}, goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.startsWithRtl = function (e, t) {
  return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function (e, t) {
  return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function (e, t) {
  return e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t), goog.i18n.bidi.isRequiredLtrRe_.test(e) || !goog.i18n.bidi.hasAnyLtr(e) && !goog.i18n.bidi.hasAnyRtl(e);
}, goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$"), goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$"), goog.i18n.bidi.endsWithLtr = function (e, t) {
  return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function (e, t) {
  return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function (e) {
  return goog.i18n.bidi.rtlLocalesRe_.test(e);
}, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function (e, t) {
  return t = (void 0 === t ? goog.i18n.bidi.hasAnyRtl(e) : t) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, e.replace(goog.i18n.bidi.bracketGuardTextRe_, t + "$&" + t);
}, goog.i18n.bidi.enforceRtlInHtml = function (e) {
  return "<" == e.charAt(0) ? e.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + e + "</span>";
}, goog.i18n.bidi.enforceRtlInText = function (e) {
  return goog.i18n.bidi.Format.RLE + e + goog.i18n.bidi.Format.PDF;
}, goog.i18n.bidi.enforceLtrInHtml = function (e) {
  return "<" == e.charAt(0) ? e.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + e + "</span>";
}, goog.i18n.bidi.enforceLtrInText = function (e) {
  return goog.i18n.bidi.Format.LRE + e + goog.i18n.bidi.Format.PDF;
}, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function (e) {
  return e.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
}, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function (e) {
  return e.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1״").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1׳");
}, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = .4, goog.i18n.bidi.estimateDirection = function (e, t) {
  var r = 0,
    o = 0,
    n = !1;
  for (e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t).split(goog.i18n.bidi.wordSeparatorRe_), t = 0; t < e.length; t++) {
    var a = e[t];
    goog.i18n.bidi.startsWithRtl(a) ? (r++, o++) : goog.i18n.bidi.isRequiredLtrRe_.test(a) ? n = !0 : goog.i18n.bidi.hasAnyLtr(a) ? o++ : goog.i18n.bidi.hasNumeralsRe_.test(a) && (n = !0);
  }
  return 0 == o ? n ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : r / o > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
}, goog.i18n.bidi.detectRtlDirectionality = function (e, t) {
  return goog.i18n.bidi.estimateDirection(e, t) == goog.i18n.bidi.Dir.RTL;
}, goog.i18n.bidi.setElementDirAndAlign = function (e, t) {
  e && (t = goog.i18n.bidi.toDir(t)) && (e.style.textAlign = t == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, e.dir = t == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
}, goog.i18n.bidi.setElementDirByTextDirectionality = function (e, t) {
  switch (goog.i18n.bidi.estimateDirection(t)) {
    case goog.i18n.bidi.Dir.LTR:
      e.dir = "ltr";
      break;
    case goog.i18n.bidi.Dir.RTL:
      e.dir = "rtl";
      break;
    default:
      e.removeAttribute("dir");
  }
}, goog.i18n.bidi.DirectionalString = function () {}, goog.html.TrustedResourceUrl = function () {
  this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = "", this.trustedURL_ = null, this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
}, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.TrustedResourceUrl.prototype.getDirection = function () {
  return goog.i18n.bidi.Dir.LTR;
}, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function (e, t) {
  var r = goog.html.TrustedResourceUrl.unwrap(this),
    o = (r = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(r))[3] || "";
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(r[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", r[2] || "", e) + goog.html.TrustedResourceUrl.stringifyParams_("#", o, t));
}, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function () {
  return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
}), goog.html.TrustedResourceUrl.unwrap = function (e) {
  return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(e).toString();
}, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function (e) {
  return e instanceof goog.html.TrustedResourceUrl && e.constructor === goog.html.TrustedResourceUrl && e.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:TrustedResourceUrl");
}, goog.html.TrustedResourceUrl.unwrapTrustedURL = function (e) {
  return e.trustedURL_ ? e.trustedURL_ : goog.html.TrustedResourceUrl.unwrap(e);
}, goog.html.TrustedResourceUrl.format = function (e, t) {
  var r = goog.string.Const.unwrap(e);
  if (!goog.html.TrustedResourceUrl.BASE_URL_.test(r)) throw Error("Invalid TrustedResourceUrl format: " + r);
  return e = r.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function (e, o) {
    if (!Object.prototype.hasOwnProperty.call(t, o)) throw Error('Found marker, "' + o + '", in format string, "' + r + '", but no valid label mapping found in args: ' + JSON.stringify(t));
    return (e = t[o]) instanceof goog.string.Const ? goog.string.Const.unwrap(e) : encodeURIComponent(String(e));
  }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function (e, t, r, o) {
  return goog.html.TrustedResourceUrl.format(e, t).cloneWithParams(r, o);
}, goog.html.TrustedResourceUrl.fromConstant = function (e) {
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
}, goog.html.TrustedResourceUrl.fromConstants = function (e) {
  for (var t = "", r = 0; r < e.length; r++) t += goog.string.Const.unwrap(e[r]);
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function (e) {
  var t = new goog.html.TrustedResourceUrl();
  return t.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(e) : e, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY && (t.trustedURL_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(e)), t;
}, goog.html.TrustedResourceUrl.stringifyParams_ = function (e, t, r) {
  if (null == r) return t;
  if (goog.isString(r)) return r ? e + encodeURIComponent(r) : "";
  for (var o in r) {
    var n = r[o];
    n = goog.isArray(n) ? n : [n];
    for (var a = 0; a < n.length; a++) {
      var i = n[a];
      null != i && (t || (t = e), t += (t.length > e.length ? "&" : "") + encodeURIComponent(o) + "=" + encodeURIComponent(String(i)));
    }
  }
  return t;
}, goog.html.SafeUrl = function () {
  this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = "", this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez", goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0, goog.html.SafeUrl.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
}, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeUrl.prototype.getDirection = function () {
  return goog.i18n.bidi.Dir.LTR;
}, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function () {
  return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
}), goog.html.SafeUrl.unwrap = function (e) {
  return goog.html.SafeUrl.unwrapTrustedURL(e).toString();
}, goog.html.SafeUrl.unwrapTrustedURL = function (e) {
  return e instanceof goog.html.SafeUrl && e.constructor === goog.html.SafeUrl && e.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail("expected object of type SafeUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeUrl");
}, goog.html.SafeUrl.fromConstant = function (e) {
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
}, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime))(?:;\w+=(?:\w+|"[\w;=]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function (e) {
  return goog.html.SAFE_MIME_TYPE_PATTERN_.test(e);
}, goog.html.SafeUrl.fromBlob = function (e) {
  return e = goog.html.SAFE_MIME_TYPE_PATTERN_.test(e.type) ? goog.fs.url.createObjectUrl(e) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.DATA_URL_PATTERN_ = /^data:([^,]*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.fromDataUrl = function (e) {
  var t = (e = e.replace(/(%0A|%0D)/g, "")).match(goog.html.DATA_URL_PATTERN_);
  return t = t && goog.html.SAFE_MIME_TYPE_PATTERN_.test(t[1]), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t ? e : goog.html.SafeUrl.INNOCUOUS_STRING);
}, goog.html.SafeUrl.fromTelUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "tel:") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function (e) {
  return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(e)) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.fromFacebookMessengerUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "fb-messenger://share") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.fromWhatsAppUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "whatsapp://send") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.fromSmsUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.isSmsUrlBodyValid_ = function (e) {
  var t = e.indexOf("#");
  if (0 < t && (e = e.substring(0, t)), !(t = e.match(/[?&]body=/gi))) return !0;
  if (1 < t.length) return !1;
  if (!(e = e.match(/[?&]body=([^&]*)/)[1])) return !0;
  try {
    decodeURIComponent(e);
  } catch (e) {
    return !1;
  }
  return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(e);
}, goog.html.SafeUrl.fromSshUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "ssh://") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function (e, t) {
  return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, e, t);
}, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function (e, t) {
  return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, e, t);
}, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function (e, t) {
  return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, e, t);
}, goog.html.SafeUrl.sanitizeExtensionUrl_ = function (e, t, r) {
  return (e = e.exec(t)) ? (e = e[1], -1 == (r instanceof goog.string.Const ? [goog.string.Const.unwrap(r)] : r.map(function (e) {
    return goog.string.Const.unwrap(e);
  })).indexOf(e) && (t = goog.html.SafeUrl.INNOCUOUS_STRING)) : t = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.SafeUrl.fromTrustedResourceUrl = function (e) {
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(e));
}, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.sanitize = function (e) {
  return e instanceof goog.html.SafeUrl ? e : (e = "object" == typeof e && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SAFE_URL_PATTERN_.test(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e));
}, goog.html.SafeUrl.sanitizeAssertUnchanged = function (e, t) {
  return e instanceof goog.html.SafeUrl ? e : (e = "object" == typeof e && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), t && /^data:/i.test(e) && (t = goog.html.SafeUrl.fromDataUrl(e)).getTypedStringValue() == e ? t : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(e), "%s does not match the safe URL pattern", e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e)));
}, goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function (e) {
  var t = new goog.html.SafeUrl();
  return t.privateDoNotAccessOrElseSafeUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(e) : e, t;
}, goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank"), goog.html.SafeStyle = function () {
  this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "", this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyle.fromConstant = function (e) {
  return 0 === (e = goog.string.Const.unwrap(e)).length ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(e, ";"), "Last character of style string is not ';': " + e), goog.asserts.assert(goog.string.internal.contains(e, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + e), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(e));
}, goog.html.SafeStyle.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
}, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function () {
  return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
}), goog.html.SafeStyle.unwrap = function (e) {
  return e instanceof goog.html.SafeStyle && e.constructor === goog.html.SafeStyle && e.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyle, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyle");
}, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function (e) {
  return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(e);
}, goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e) {
  return this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = e, this;
}, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez", goog.html.SafeStyle.create = function (e) {
  var t,
    r = "";
  for (t in e) {
    if (!/^[-_a-zA-Z0-9]+$/.test(t)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + t);
    var o = e[t];
    null != o && (r += t + ":" + (o = goog.isArray(o) ? goog.array.map(o, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(o)) + ";");
  }
  return r ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(r) : goog.html.SafeStyle.EMPTY;
}, goog.html.SafeStyle.sanitizePropertyValue_ = function (e) {
  if (e instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(e).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
  if (e = e instanceof goog.string.Const ? goog.string.Const.unwrap(e) : goog.html.SafeStyle.sanitizePropertyValueString_(String(e)), /[{;}]/.test(e)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [e]);
  return e;
}, goog.html.SafeStyle.sanitizePropertyValueString_ = function (e) {
  var t = e.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
  return goog.html.SafeStyle.VALUE_RE_.test(t) ? goog.html.SafeStyle.COMMENT_RE_.test(e) ? (goog.asserts.fail("String value disallows comments, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING) : goog.html.SafeStyle.hasBalancedQuotes_(e) ? goog.html.SafeStyle.hasBalancedSquareBrackets_(e) ? goog.html.SafeStyle.sanitizeUrl_(e) : (goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING) : (goog.asserts.fail("String value requires balanced quotes, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING) : (goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING);
}, goog.html.SafeStyle.hasBalancedQuotes_ = function (e) {
  for (var t = !0, r = !0, o = 0; o < e.length; o++) {
    var n = e.charAt(o);
    "'" == n && r ? t = !t : '"' == n && t && (r = !r);
  }
  return t && r;
}, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function (e) {
  for (var t = !0, r = /^[-_a-zA-Z0-9]$/, o = 0; o < e.length; o++) {
    var n = e.charAt(o);
    if ("]" == n) {
      if (t) return !1;
      t = !0;
    } else if ("[" == n) {
      if (!t) return !1;
      t = !1;
    } else if (!t && !r.test(n)) return !1;
  }
  return t;
}, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]", goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$"), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.FUNCTIONS_RE_ = /\b(hsl|hsla|rgb|rgba|matrix|calc|minmax|fit-content|repeat|(rotate|scale|translate)(X|Y|Z|3d)?)\([-+*/0-9a-z.%\[\], ]+\)/g, goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function (e) {
  return e.replace(goog.html.SafeStyle.URL_RE_, function (e, t, r, o) {
    var n = "";
    return r = r.replace(/^(['"])(.*)\1$/, function (e, t, r) {
      return n = t, r;
    }), e = goog.html.SafeUrl.sanitize(r).getTypedStringValue(), t + n + e + n + o;
  });
}, goog.html.SafeStyle.concat = function (e) {
  var t = "",
    r = function r(e) {
      goog.isArray(e) ? goog.array.forEach(e, r) : t += goog.html.SafeStyle.unwrap(e);
    };
  return goog.array.forEach(arguments, r), t ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t) : goog.html.SafeStyle.EMPTY;
}, goog.html.SafeScript = function () {
  this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "", this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.SafeScript.prototype.implementsGoogStringTypedString = !0, goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeScript.fromConstant = function (e) {
  return 0 === (e = goog.string.Const.unwrap(e)).length ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeScript.fromConstantAndArgs = function (e, t) {
  for (var r = [], o = 1; o < arguments.length; o++) r.push(goog.html.SafeScript.stringify_(arguments[o]));
  return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(e) + ")(" + r.join(", ") + ");");
}, goog.html.SafeScript.fromJson = function (e) {
  return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(e));
}, goog.html.SafeScript.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
}, goog.DEBUG && (goog.html.SafeScript.prototype.toString = function () {
  return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
}), goog.html.SafeScript.unwrap = function (e) {
  return goog.html.SafeScript.unwrapTrustedScript(e).toString();
}, goog.html.SafeScript.unwrapTrustedScript = function (e) {
  return e instanceof goog.html.SafeScript && e.constructor === goog.html.SafeScript && e.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeScriptWrappedValue_ : (goog.asserts.fail("expected object of type SafeScript, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeScript");
}, goog.html.SafeScript.stringify_ = function (e) {
  return JSON.stringify(e).replace(/</g, "\\x3c");
}, goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function (e) {
  return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(e);
}, goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e) {
  return this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(e) : e, this;
}, goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(""), goog.object = {}, goog.object.is = function (e, t) {
  return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
}, goog.object.forEach = function (e, t, r) {
  for (var o in e) t.call(r, e[o], o, e);
}, goog.object.filter = function (e, t, r) {
  var o,
    n = {};
  for (o in e) t.call(r, e[o], o, e) && (n[o] = e[o]);
  return n;
}, goog.object.map = function (e, t, r) {
  var o,
    n = {};
  for (o in e) n[o] = t.call(r, e[o], o, e);
  return n;
}, goog.object.some = function (e, t, r) {
  for (var o in e) if (t.call(r, e[o], o, e)) return !0;
  return !1;
}, goog.object.every = function (e, t, r) {
  for (var o in e) if (!t.call(r, e[o], o, e)) return !1;
  return !0;
}, goog.object.getCount = function (e) {
  var t,
    r = 0;
  for (t in e) r++;
  return r;
}, goog.object.getAnyKey = function (e) {
  for (var t in e) return t;
}, goog.object.getAnyValue = function (e) {
  for (var t in e) return e[t];
}, goog.object.contains = function (e, t) {
  return goog.object.containsValue(e, t);
}, goog.object.getValues = function (e) {
  var t,
    r = [],
    o = 0;
  for (t in e) r[o++] = e[t];
  return r;
}, goog.object.getKeys = function (e) {
  var t,
    r = [],
    o = 0;
  for (t in e) r[o++] = t;
  return r;
}, goog.object.getValueByKeys = function (e, t) {
  var r = goog.isArrayLike(t),
    o = r ? t : arguments;
  for (r = r ? 0 : 1; r < o.length; r++) {
    if (null == e) return;
    e = e[o[r]];
  }
  return e;
}, goog.object.containsKey = function (e, t) {
  return null !== e && t in e;
}, goog.object.containsValue = function (e, t) {
  for (var r in e) if (e[r] == t) return !0;
  return !1;
}, goog.object.findKey = function (e, t, r) {
  for (var o in e) if (t.call(r, e[o], o, e)) return o;
}, goog.object.findValue = function (e, t, r) {
  return (t = goog.object.findKey(e, t, r)) && e[t];
}, goog.object.isEmpty = function (e) {
  for (var t in e) return !1;
  return !0;
}, goog.object.clear = function (e) {
  for (var t in e) delete e[t];
}, goog.object.remove = function (e, t) {
  var r;
  return (r = t in e) && delete e[t], r;
}, goog.object.add = function (e, t, r) {
  if (null !== e && t in e) throw Error('The object already contains the key "' + t + '"');
  goog.object.set(e, t, r);
}, goog.object.get = function (e, t, r) {
  return null !== e && t in e ? e[t] : r;
}, goog.object.set = function (e, t, r) {
  e[t] = r;
}, goog.object.setIfUndefined = function (e, t, r) {
  return t in e ? e[t] : e[t] = r;
}, goog.object.setWithReturnValueIfNotSet = function (e, t, r) {
  return t in e ? e[t] : (r = r(), e[t] = r);
}, goog.object.equals = function (e, t) {
  for (var r in e) if (!(r in t) || e[r] !== t[r]) return !1;
  for (var o in t) if (!(o in e)) return !1;
  return !0;
}, goog.object.clone = function (e) {
  var t,
    r = {};
  for (t in e) r[t] = e[t];
  return r;
}, goog.object.unsafeClone = function (e) {
  var t = goog.typeOf(e);
  if ("object" == t || "array" == t) {
    if (goog.isFunction(e.clone)) return e.clone();
    for (var r in t = "array" == t ? [] : {}, e) t[r] = goog.object.unsafeClone(e[r]);
    return t;
  }
  return e;
}, goog.object.transpose = function (e) {
  var t,
    r = {};
  for (t in e) r[e[t]] = t;
  return r;
}, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function (e, t) {
  for (var r, o, n = 1; n < arguments.length; n++) {
    for (r in o = arguments[n]) e[r] = o[r];
    for (var a = 0; a < goog.object.PROTOTYPE_FIELDS_.length; a++) r = goog.object.PROTOTYPE_FIELDS_[a], Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
  }
}, goog.object.create = function (e) {
  var t = arguments.length;
  if (1 == t && goog.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
  if (t % 2) throw Error("Uneven number of arguments");
  for (var r = {}, o = 0; o < t; o += 2) r[arguments[o]] = arguments[o + 1];
  return r;
}, goog.object.createSet = function (e) {
  var t = arguments.length;
  if (1 == t && goog.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
  for (var r = {}, o = 0; o < t; o++) r[arguments[o]] = !0;
  return r;
}, goog.object.createImmutableView = function (e) {
  var t = e;
  return Object.isFrozen && !Object.isFrozen(e) && (t = Object.create(e), Object.freeze(t)), t;
}, goog.object.isImmutableView = function (e) {
  return !!Object.isFrozen && Object.isFrozen(e);
}, goog.object.getAllPropertyNames = function (e, t, r) {
  if (!e) return [];
  if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(e);
  for (var o = {}; e && (e !== Object.prototype || t) && (e !== Function.prototype || r);) {
    for (var n = Object.getOwnPropertyNames(e), a = 0; a < n.length; a++) o[n[a]] = !0;
    e = Object.getPrototypeOf(e);
  }
  return goog.object.getKeys(o);
}, goog.object.getSuperClass = function (e) {
  return (e = Object.getPrototypeOf(e.prototype)) && e.constructor;
}, goog.html.SafeStyleSheet = function () {
  this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "", this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyleSheet.createRule = function (e, t) {
  if (goog.string.internal.contains(e, "<")) throw Error("Selector does not allow '<', got: " + e);
  var r = e.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
  if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(r)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + e);
  if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(r)) throw Error("() and [] in selector must be balanced, got: " + e);
  return t instanceof goog.html.SafeStyle || (t = goog.html.SafeStyle.create(t)), e = e + "{" + goog.html.SafeStyle.unwrap(t).replace(/</g, "\\3C ") + "}", goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeStyleSheet.hasBalancedBrackets_ = function (e) {
  for (var t = {
      "(": ")",
      "[": "]"
    }, r = [], o = 0; o < e.length; o++) {
    var n = e[o];
    if (t[n]) r.push(t[n]);else if (goog.object.contains(t, n) && r.pop() != n) return !1;
  }
  return 0 == r.length;
}, goog.html.SafeStyleSheet.concat = function (e) {
  var t = "",
    r = function r(e) {
      goog.isArray(e) ? goog.array.forEach(e, r) : t += goog.html.SafeStyleSheet.unwrap(e);
    };
  return goog.array.forEach(arguments, r), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.SafeStyleSheet.fromConstant = function (e) {
  return 0 === (e = goog.string.Const.unwrap(e)).length ? goog.html.SafeStyleSheet.EMPTY : (goog.asserts.assert(!goog.string.internal.contains(e, "<"), "Forbidden '<' character in style sheet string: " + e), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e));
}, goog.html.SafeStyleSheet.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
}, goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function () {
  return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
}), goog.html.SafeStyleSheet.unwrap = function (e) {
  return e instanceof goog.html.SafeStyleSheet && e.constructor === goog.html.SafeStyleSheet && e.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyleSheet, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyleSheet");
}, goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function (e) {
  return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(e);
}, goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e) {
  return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = e, this;
}, goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(""), goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  command: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
}, goog.dom.tags.isVoidTag = function (e) {
  return !0 === goog.dom.tags.VOID_TAGS_[e];
}, goog.dom.HtmlElement = function () {}, goog.dom.TagName = function (e) {
  this.tagName_ = e;
}, goog.dom.TagName.prototype.toString = function () {
  return this.tagName_;
}, goog.dom.TagName.A = new goog.dom.TagName("A"), goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR"), goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM"), goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS"), goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET"), goog.dom.TagName.AREA = new goog.dom.TagName("AREA"), goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE"), goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE"), goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO"), goog.dom.TagName.B = new goog.dom.TagName("B"), goog.dom.TagName.BASE = new goog.dom.TagName("BASE"), goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT"), goog.dom.TagName.BDI = new goog.dom.TagName("BDI"), goog.dom.TagName.BDO = new goog.dom.TagName("BDO"), goog.dom.TagName.BIG = new goog.dom.TagName("BIG"), goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE"), goog.dom.TagName.BODY = new goog.dom.TagName("BODY"), goog.dom.TagName.BR = new goog.dom.TagName("BR"), goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON"), goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS"), goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION"), goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER"), goog.dom.TagName.CITE = new goog.dom.TagName("CITE"), goog.dom.TagName.CODE = new goog.dom.TagName("CODE"), goog.dom.TagName.COL = new goog.dom.TagName("COL"), goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP"), goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND"), goog.dom.TagName.DATA = new goog.dom.TagName("DATA"), goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST"), goog.dom.TagName.DD = new goog.dom.TagName("DD"), goog.dom.TagName.DEL = new goog.dom.TagName("DEL"), goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS"), goog.dom.TagName.DFN = new goog.dom.TagName("DFN"), goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG"), goog.dom.TagName.DIR = new goog.dom.TagName("DIR"), goog.dom.TagName.DIV = new goog.dom.TagName("DIV"), goog.dom.TagName.DL = new goog.dom.TagName("DL"), goog.dom.TagName.DT = new goog.dom.TagName("DT"), goog.dom.TagName.EM = new goog.dom.TagName("EM"), goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED"), goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET"), goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION"), goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE"), goog.dom.TagName.FONT = new goog.dom.TagName("FONT"), goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER"), goog.dom.TagName.FORM = new goog.dom.TagName("FORM"), goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME"), goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET"), goog.dom.TagName.H1 = new goog.dom.TagName("H1"), goog.dom.TagName.H2 = new goog.dom.TagName("H2"), goog.dom.TagName.H3 = new goog.dom.TagName("H3"), goog.dom.TagName.H4 = new goog.dom.TagName("H4"), goog.dom.TagName.H5 = new goog.dom.TagName("H5"), goog.dom.TagName.H6 = new goog.dom.TagName("H6"), goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD"), goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER"), goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP"), goog.dom.TagName.HR = new goog.dom.TagName("HR"), goog.dom.TagName.HTML = new goog.dom.TagName("HTML"), goog.dom.TagName.I = new goog.dom.TagName("I"), goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME"), goog.dom.TagName.IMG = new goog.dom.TagName("IMG"), goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT"), goog.dom.TagName.INS = new goog.dom.TagName("INS"), goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX"), goog.dom.TagName.KBD = new goog.dom.TagName("KBD"), goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN"), goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL"), goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND"), goog.dom.TagName.LI = new goog.dom.TagName("LI"), goog.dom.TagName.LINK = new goog.dom.TagName("LINK"), goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN"), goog.dom.TagName.MAP = new goog.dom.TagName("MAP"), goog.dom.TagName.MARK = new goog.dom.TagName("MARK"), goog.dom.TagName.MATH = new goog.dom.TagName("MATH"), goog.dom.TagName.MENU = new goog.dom.TagName("MENU"), goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM"), goog.dom.TagName.META = new goog.dom.TagName("META"), goog.dom.TagName.METER = new goog.dom.TagName("METER"), goog.dom.TagName.NAV = new goog.dom.TagName("NAV"), goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES"), goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT"), goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT"), goog.dom.TagName.OL = new goog.dom.TagName("OL"), goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP"), goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION"), goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT"), goog.dom.TagName.P = new goog.dom.TagName("P"), goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM"), goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE"), goog.dom.TagName.PRE = new goog.dom.TagName("PRE"), goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS"), goog.dom.TagName.Q = new goog.dom.TagName("Q"), goog.dom.TagName.RP = new goog.dom.TagName("RP"), goog.dom.TagName.RT = new goog.dom.TagName("RT"), goog.dom.TagName.RTC = new goog.dom.TagName("RTC"), goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY"), goog.dom.TagName.S = new goog.dom.TagName("S"), goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP"), goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT"), goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION"), goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT"), goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL"), goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE"), goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN"), goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE"), goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG"), goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE"), goog.dom.TagName.SUB = new goog.dom.TagName("SUB"), goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY"), goog.dom.TagName.SUP = new goog.dom.TagName("SUP"), goog.dom.TagName.SVG = new goog.dom.TagName("SVG"), goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE"), goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY"), goog.dom.TagName.TD = new goog.dom.TagName("TD"), goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE"), goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA"), goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT"), goog.dom.TagName.TH = new goog.dom.TagName("TH"), goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD"), goog.dom.TagName.TIME = new goog.dom.TagName("TIME"), goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE"), goog.dom.TagName.TR = new goog.dom.TagName("TR"), goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK"), goog.dom.TagName.TT = new goog.dom.TagName("TT"), goog.dom.TagName.U = new goog.dom.TagName("U"), goog.dom.TagName.UL = new goog.dom.TagName("UL"), goog.dom.TagName.VAR = new goog.dom.TagName("VAR"), goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO"), goog.dom.TagName.WBR = new goog.dom.TagName("WBR"), goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function () {
  var e = goog.labs.userAgent.util.getNavigator_();
  return e && (e = e.userAgent) ? e : "";
}, goog.labs.userAgent.util.getNavigator_ = function () {
  return goog.global.navigator;
}, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function (e) {
  goog.labs.userAgent.util.userAgent_ = e || goog.labs.userAgent.util.getNativeUserAgentString_();
}, goog.labs.userAgent.util.getUserAgent = function () {
  return goog.labs.userAgent.util.userAgent_;
}, goog.labs.userAgent.util.matchUserAgent = function (e) {
  var t = goog.labs.userAgent.util.getUserAgent();
  return goog.string.internal.contains(t, e);
}, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function (e) {
  var t = goog.labs.userAgent.util.getUserAgent();
  return goog.string.internal.caseInsensitiveContains(t, e);
}, goog.labs.userAgent.util.extractVersionTuples = function (e) {
  for (var t, r = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, o = []; t = r.exec(e);) o.push([t[1], t[2], t[3] || void 0]);
  return o;
}, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Opera");
}, goog.labs.userAgent.browser.matchIE_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
}, goog.labs.userAgent.browser.matchEdgeHtml_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Edge");
}, goog.labs.userAgent.browser.matchEdgeChromium_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Edg/");
}, goog.labs.userAgent.browser.matchOperaChromium_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("OPR");
}, goog.labs.userAgent.browser.matchFirefox_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
}, goog.labs.userAgent.browser.matchSafari_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
}, goog.labs.userAgent.browser.matchCoast_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Coast");
}, goog.labs.userAgent.browser.matchIosWebview_ = function () {
  return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
}, goog.labs.userAgent.browser.matchChrome_ = function () {
  return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
}, goog.labs.userAgent.browser.matchAndroidBrowser_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
}, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function () {
  return goog.labs.userAgent.util.matchUserAgent("Silk");
}, goog.labs.userAgent.browser.getVersion = function () {
  function e(e) {
    return e = goog.array.find(e, o), r[e] || "";
  }
  var t = goog.labs.userAgent.util.getUserAgent();
  if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(t);
  t = goog.labs.userAgent.util.extractVersionTuples(t);
  var r = {};
  goog.array.forEach(t, function (e) {
    r[e[0]] = e[1];
  });
  var o = goog.partial(goog.object.containsKey, r);
  return goog.labs.userAgent.browser.isOpera() ? e(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? e(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? e(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? e(["Chrome", "CriOS"]) : (t = t[2]) && t[1] || "";
}, goog.labs.userAgent.browser.isVersionOrHigher = function (e) {
  return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), e);
}, goog.labs.userAgent.browser.getIEVersion_ = function (e) {
  var t = /rv: *([\d\.]*)/.exec(e);
  if (t && t[1]) return t[1];
  t = "";
  var r = /MSIE +([\d\.]+)/.exec(e);
  if (r && r[1]) if (e = /Trident\/(\d.\d)/.exec(e), "7.0" == r[1]) {
    if (e && e[1]) switch (e[1]) {
      case "4.0":
        t = "8.0";
        break;
      case "5.0":
        t = "9.0";
        break;
      case "6.0":
        t = "10.0";
        break;
      case "7.0":
        t = "11.0";
    } else t = "7.0";
  } else t = r[1];
  return t;
}, goog.html.SafeHtml = function () {
  this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "", this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_, this.dir_ = null;
}, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeHtml.prototype.getDirection = function () {
  return this.dir_;
}, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0, goog.html.SafeHtml.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
}, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function () {
  return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
}), goog.html.SafeHtml.unwrap = function (e) {
  return goog.html.SafeHtml.unwrapTrustedHTML(e).toString();
}, goog.html.SafeHtml.unwrapTrustedHTML = function (e) {
  return e instanceof goog.html.SafeHtml && e.constructor === goog.html.SafeHtml && e.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail("expected object of type SafeHtml, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeHtml");
}, goog.html.SafeHtml.htmlEscape = function (e) {
  if (e instanceof goog.html.SafeHtml) return e;
  var t = "object" == typeof e,
    r = null;
  return t && e.implementsGoogI18nBidiDirectionalString && (r = e.getDirection()), e = t && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(e), r);
}, goog.html.SafeHtml.htmlEscapePreservingNewlines = function (e) {
  return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
}, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function (e) {
  return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
}, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = {
  action: !0,
  cite: !0,
  data: !0,
  formaction: !0,
  href: !0,
  manifest: !0,
  poster: !0,
  src: !0
}, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = {
  APPLET: !0,
  BASE: !0,
  EMBED: !0,
  IFRAME: !0,
  LINK: !0,
  MATH: !0,
  META: !0,
  OBJECT: !0,
  SCRIPT: !0,
  STYLE: !0,
  SVG: !0,
  TEMPLATE: !0
}, goog.html.SafeHtml.create = function (e, t, r) {
  return goog.html.SafeHtml.verifyTagName(String(e)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(e), t, r);
}, goog.html.SafeHtml.verifyTagName = function (e) {
  if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(e)) throw Error("Invalid tag name <" + e + ">.");
  if (e.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error("Tag name <" + e + "> is not allowed for SafeHtml.");
}, goog.html.SafeHtml.createIframe = function (e, t, r, o) {
  e && goog.html.TrustedResourceUrl.unwrap(e);
  var n = {};
  return n.src = e || null, n.srcdoc = t && goog.html.SafeHtml.unwrap(t), e = goog.html.SafeHtml.combineAttributes(n, {
    sandbox: ""
  }, r), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, o);
}, goog.html.SafeHtml.createSandboxIframe = function (e, t, r, o) {
  if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error("The browser does not support sandboxed iframes.");
  var n = {};
  return n.src = e ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)) : null, n.srcdoc = t || null, n.sandbox = "", e = goog.html.SafeHtml.combineAttributes(n, {}, r), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, o);
}, goog.html.SafeHtml.canUseSandboxIframe = function () {
  return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
}, goog.html.SafeHtml.createScriptSrc = function (e, t) {
  return goog.html.TrustedResourceUrl.unwrap(e), e = goog.html.SafeHtml.combineAttributes({
    src: e
  }, {}, t), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", e);
}, goog.html.SafeHtml.createScript = function (e, t) {
  for (var r in t) {
    var o = r.toLowerCase();
    if ("language" == o || "src" == o || "text" == o || "type" == o) throw Error('Cannot set "' + o + '" attribute');
  }
  for (r = "", e = goog.array.concat(e), o = 0; o < e.length; o++) r += goog.html.SafeScript.unwrap(e[o]);
  return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(r, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", t, e);
}, goog.html.SafeHtml.createStyle = function (e, t) {
  t = goog.html.SafeHtml.combineAttributes({
    type: "text/css"
  }, {}, t);
  var r = "";
  e = goog.array.concat(e);
  for (var o = 0; o < e.length; o++) r += goog.html.SafeStyleSheet.unwrap(e[o]);
  return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(r, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", t, e);
}, goog.html.SafeHtml.createMetaRefresh = function (e, t) {
  return e = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(e, ";") && (e = "'" + e.replace(/'/g, "%27") + "'"), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
    "http-equiv": "refresh",
    content: (t || 0) + "; url=" + e
  });
}, goog.html.SafeHtml.getAttrNameAndValue_ = function (e, t, r) {
  if (r instanceof goog.string.Const) r = goog.string.Const.unwrap(r);else if ("style" == t.toLowerCase()) r = goog.html.SafeHtml.getStyleValue_(r);else {
    if (/^on/i.test(t)) throw Error('Attribute "' + t + '" requires goog.string.Const value, "' + r + '" given.');
    if (t.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) if (r instanceof goog.html.TrustedResourceUrl) r = goog.html.TrustedResourceUrl.unwrap(r);else if (r instanceof goog.html.SafeUrl) r = goog.html.SafeUrl.unwrap(r);else {
      if (!goog.isString(r)) throw Error('Attribute "' + t + '" on tag "' + e + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + r + '" given.');
      r = goog.html.SafeUrl.sanitize(r).getTypedStringValue();
    }
  }
  return r.implementsGoogStringTypedString && (r = r.getTypedStringValue()), goog.asserts.assert(goog.isString(r) || goog.isNumber(r), "String or number value expected, got " + typeof r + " with value: " + r), t + '="' + goog.string.internal.htmlEscape(String(r)) + '"';
}, goog.html.SafeHtml.getStyleValue_ = function (e) {
  if (!goog.isObject(e)) throw Error('The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof e + " given: " + e);
  return e instanceof goog.html.SafeStyle || (e = goog.html.SafeStyle.create(e)), goog.html.SafeStyle.unwrap(e);
}, goog.html.SafeHtml.createWithDir = function (e, t, r, o) {
  return (t = goog.html.SafeHtml.create(t, r, o)).dir_ = e, t;
}, goog.html.SafeHtml.join = function (e, t) {
  var r = (e = goog.html.SafeHtml.htmlEscape(e)).getDirection(),
    o = [],
    n = function n(e) {
      goog.isArray(e) ? goog.array.forEach(e, n) : (e = goog.html.SafeHtml.htmlEscape(e), o.push(goog.html.SafeHtml.unwrap(e)), e = e.getDirection(), r == goog.i18n.bidi.Dir.NEUTRAL ? r = e : e != goog.i18n.bidi.Dir.NEUTRAL && r != e && (r = null));
    };
  return goog.array.forEach(t, n), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o.join(goog.html.SafeHtml.unwrap(e)), r);
}, goog.html.SafeHtml.concat = function (e) {
  return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
}, goog.html.SafeHtml.concatWithDir = function (e, t) {
  var r = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
  return r.dir_ = e, r;
}, goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function (e, t) {
  return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(e, t);
}, goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e, t) {
  return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(e) : e, this.dir_ = t, this;
}, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function (e, t, r) {
  var o = null,
    n = "<" + e + goog.html.SafeHtml.stringifyAttributes(e, t);
  return goog.isDefAndNotNull(r) ? goog.isArray(r) || (r = [r]) : r = [], goog.dom.tags.isVoidTag(e.toLowerCase()) ? (goog.asserts.assert(!r.length, "Void tag <" + e + "> does not allow content."), n += ">") : (o = goog.html.SafeHtml.concat(r), n += ">" + goog.html.SafeHtml.unwrap(o) + "</" + e + ">", o = o.getDirection()), (e = t && t.dir) && (o = /^(ltr|rtl|auto)$/i.test(e) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(n, o);
}, goog.html.SafeHtml.stringifyAttributes = function (e, t) {
  var r = "";
  if (t) for (var o in t) {
    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(o)) throw Error('Invalid attribute name "' + o + '".');
    var n = t[o];
    goog.isDefAndNotNull(n) && (r += " " + goog.html.SafeHtml.getAttrNameAndValue_(e, o, n));
  }
  return r;
}, goog.html.SafeHtml.combineAttributes = function (e, t, r) {
  var o,
    n = {};
  for (o in e) goog.asserts.assert(o.toLowerCase() == o, "Must be lower case"), n[o] = e[o];
  for (o in t) goog.asserts.assert(o.toLowerCase() == o, "Must be lower case"), n[o] = t[o];
  for (o in r) {
    var a = o.toLowerCase();
    if (a in e) throw Error('Cannot override "' + a + '" attribute, got "' + o + '" with value "' + r[o] + '"');
    a in t && delete n[a], n[o] = r[o];
  }
  return n;
}, goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function (e, t, r) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(t, r || null);
}, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
}, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function (e) {
  if (goog.asserts.ENABLE_ASSERTS) {
    var t = goog.dom.asserts.getWindow_(e);
    t && (!e || !(e instanceof t.Location) && e instanceof t.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(e));
  }
  return e;
}, goog.dom.asserts.assertIsElementType_ = function (e, t) {
  if (goog.asserts.ENABLE_ASSERTS) {
    var r = goog.dom.asserts.getWindow_(e);
    r && void 0 !== r[t] && (e && (e instanceof r[t] || !(e instanceof r.Location || e instanceof r.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", t, goog.dom.asserts.debugStringForType_(e)));
  }
  return e;
}, goog.dom.asserts.assertIsHTMLAnchorElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLAnchorElement");
}, goog.dom.asserts.assertIsHTMLButtonElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLButtonElement");
}, goog.dom.asserts.assertIsHTMLLinkElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLLinkElement");
}, goog.dom.asserts.assertIsHTMLImageElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLImageElement");
}, goog.dom.asserts.assertIsHTMLAudioElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLAudioElement");
}, goog.dom.asserts.assertIsHTMLVideoElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLVideoElement");
}, goog.dom.asserts.assertIsHTMLInputElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLInputElement");
}, goog.dom.asserts.assertIsHTMLTextAreaElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLTextAreaElement");
}, goog.dom.asserts.assertIsHTMLCanvasElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLCanvasElement");
}, goog.dom.asserts.assertIsHTMLEmbedElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLEmbedElement");
}, goog.dom.asserts.assertIsHTMLFormElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLFormElement");
}, goog.dom.asserts.assertIsHTMLFrameElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLFrameElement");
}, goog.dom.asserts.assertIsHTMLIFrameElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLIFrameElement");
}, goog.dom.asserts.assertIsHTMLObjectElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLObjectElement");
}, goog.dom.asserts.assertIsHTMLScriptElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLScriptElement");
}, goog.dom.asserts.debugStringForType_ = function (e) {
  if (!goog.isObject(e)) return void 0 === e ? "undefined" : null === e ? "null" : typeof e;
  try {
    return e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e);
  } catch (e) {
    return "<object could not be stringified>";
  }
}, goog.dom.asserts.getWindow_ = function (e) {
  try {
    var t = e && e.ownerDocument,
      r = t && (t.defaultView || t.parentWindow);
    if ((r = r || goog.global).Element && r.Location) return r;
  } catch (e) {}
  return null;
}, goog.functions = {}, goog.functions.constant = function (e) {
  return function () {
    return e;
  };
}, goog.functions.FALSE = function () {
  return !1;
}, goog.functions.TRUE = function () {
  return !0;
}, goog.functions.NULL = function () {
  return null;
}, goog.functions.identity = function (e, t) {
  return e;
}, goog.functions.error = function (e) {
  return function () {
    throw Error(e);
  };
}, goog.functions.fail = function (e) {
  return function () {
    throw e;
  };
}, goog.functions.lock = function (e, t) {
  return t = t || 0, function () {
    return e.apply(this, Array.prototype.slice.call(arguments, 0, t));
  };
}, goog.functions.nth = function (e) {
  return function () {
    return arguments[e];
  };
}, goog.functions.partialRight = function (e, t) {
  var r = Array.prototype.slice.call(arguments, 1);
  return function () {
    var t = Array.prototype.slice.call(arguments);
    return t.push.apply(t, r), e.apply(this, t);
  };
}, goog.functions.withReturnValue = function (e, t) {
  return goog.functions.sequence(e, goog.functions.constant(t));
}, goog.functions.equalTo = function (e, t) {
  return function (r) {
    return t ? e == r : e === r;
  };
}, goog.functions.compose = function (e, t) {
  var r = arguments,
    o = r.length;
  return function () {
    var e;
    o && (e = r[o - 1].apply(this, arguments));
    for (var t = o - 2; 0 <= t; t--) e = r[t].call(this, e);
    return e;
  };
}, goog.functions.sequence = function (e) {
  var t = arguments,
    r = t.length;
  return function () {
    for (var e, o = 0; o < r; o++) e = t[o].apply(this, arguments);
    return e;
  };
}, goog.functions.and = function (e) {
  var t = arguments,
    r = t.length;
  return function () {
    for (var e = 0; e < r; e++) if (!t[e].apply(this, arguments)) return !1;
    return !0;
  };
}, goog.functions.or = function (e) {
  var t = arguments,
    r = t.length;
  return function () {
    for (var e = 0; e < r; e++) if (t[e].apply(this, arguments)) return !0;
    return !1;
  };
}, goog.functions.not = function (e) {
  return function () {
    return !e.apply(this, arguments);
  };
}, goog.functions.create = function (e, t) {
  var r = function r() {};
  return r.prototype = e.prototype, r = new r(), e.apply(r, Array.prototype.slice.call(arguments, 1)), r;
}, goog.functions.CACHE_RETURN_VALUE = !0, goog.functions.cacheReturnValue = function (e) {
  var t,
    r = !1;
  return function () {
    return goog.functions.CACHE_RETURN_VALUE ? (r || (t = e(), r = !0), t) : e();
  };
}, goog.functions.once = function (e) {
  var t = e;
  return function () {
    if (t) {
      var e = t;
      t = null, e();
    }
  };
}, goog.functions.debounce = function (e, t, r) {
  var o = 0;
  return function (n) {
    goog.global.clearTimeout(o);
    var a = arguments;
    o = goog.global.setTimeout(function () {
      e.apply(r, a);
    }, t);
  };
}, goog.functions.throttle = function (e, t, r) {
  var o = 0,
    n = !1,
    a = [],
    i = function i() {
      o = 0, n && (n = !1, s());
    },
    s = function s() {
      o = goog.global.setTimeout(i, t), e.apply(r, a);
    };
  return function (e) {
    a = arguments, o ? n = !0 : s();
  };
}, goog.functions.rateLimit = function (e, t, r) {
  var o = 0,
    n = function n() {
      o = 0;
    };
  return function (a) {
    o || (o = goog.global.setTimeout(n, t), e.apply(r, arguments));
  };
}, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = {
  AFTERBEGIN: "afterbegin",
  AFTEREND: "afterend",
  BEFOREBEGIN: "beforebegin",
  BEFOREEND: "beforeend"
}, goog.dom.safe.insertAdjacentHtml = function (e, t, r) {
  e.insertAdjacentHTML(t, goog.html.SafeHtml.unwrapTrustedHTML(r));
}, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
  MATH: !0,
  SCRIPT: !0,
  STYLE: !0,
  SVG: !0,
  TEMPLATE: !0
}, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function () {
  if (goog.DEBUG && "undefined" == typeof document) return !1;
  var e = document.createElement("div"),
    t = document.createElement("div");
  return t.appendChild(document.createElement("div")), e.appendChild(t), !(goog.DEBUG && !e.firstChild) && (t = e.firstChild.firstChild, e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !t.parentElement);
}), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function (e, t) {
  if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for (; e.lastChild;) e.removeChild(e.lastChild);
  e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
}, goog.dom.safe.setInnerHtml = function (e, t) {
  if (goog.asserts.ENABLE_ASSERTS) {
    var r = e.tagName.toUpperCase();
    if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[r]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + e.tagName + ".");
  }
  goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(e, t);
}, goog.dom.safe.setOuterHtml = function (e, t) {
  e.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
}, goog.dom.safe.setFormElementAction = function (e, t) {
  t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLFormElement(e).action = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setButtonFormAction = function (e, t) {
  t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLButtonElement(e).formAction = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setInputFormAction = function (e, t) {
  t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLInputElement(e).formAction = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setStyle = function (e, t) {
  e.style.cssText = goog.html.SafeStyle.unwrap(t);
}, goog.dom.safe.documentWrite = function (e, t) {
  e.write(goog.html.SafeHtml.unwrapTrustedHTML(t));
}, goog.dom.safe.setAnchorHref = function (e, t) {
  goog.dom.asserts.assertIsHTMLAnchorElement(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setImageSrc = function (e, t) {
  if (goog.dom.asserts.assertIsHTMLImageElement(e), !(t instanceof goog.html.SafeUrl)) {
    var r = /^data:image\//i.test(t);
    t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, r);
  }
  e.src = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setAudioSrc = function (e, t) {
  if (goog.dom.asserts.assertIsHTMLAudioElement(e), !(t instanceof goog.html.SafeUrl)) {
    var r = /^data:audio\//i.test(t);
    t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, r);
  }
  e.src = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setVideoSrc = function (e, t) {
  if (goog.dom.asserts.assertIsHTMLVideoElement(e), !(t instanceof goog.html.SafeUrl)) {
    var r = /^data:video\//i.test(t);
    t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, r);
  }
  e.src = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setEmbedSrc = function (e, t) {
  goog.dom.asserts.assertIsHTMLEmbedElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
}, goog.dom.safe.setFrameSrc = function (e, t) {
  goog.dom.asserts.assertIsHTMLFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setIframeSrc = function (e, t) {
  goog.dom.asserts.assertIsHTMLIFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setIframeSrcdoc = function (e, t) {
  goog.dom.asserts.assertIsHTMLIFrameElement(e), e.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(t);
}, goog.dom.safe.setLinkHrefAndRel = function (e, t, r) {
  goog.dom.asserts.assertIsHTMLLinkElement(e), e.rel = r, goog.string.internal.caseInsensitiveContains(r, "stylesheet") ? (goog.asserts.assert(t instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), e.href = goog.html.TrustedResourceUrl.unwrapTrustedURL(t)) : e.href = t instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrapTrustedURL(t) : t instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrapTrustedURL(t) : goog.html.SafeUrl.unwrapTrustedURL(goog.html.SafeUrl.sanitizeAssertUnchanged(t));
}, goog.dom.safe.setObjectData = function (e, t) {
  goog.dom.asserts.assertIsHTMLObjectElement(e), e.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
}, goog.dom.safe.setScriptSrc = function (e, t) {
  goog.dom.asserts.assertIsHTMLScriptElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t), (t = goog.getScriptNonce()) && e.setAttribute("nonce", t);
}, goog.dom.safe.setScriptContent = function (e, t) {
  goog.dom.asserts.assertIsHTMLScriptElement(e), e.text = goog.html.SafeScript.unwrapTrustedScript(t), (t = goog.getScriptNonce()) && e.setAttribute("nonce", t);
}, goog.dom.safe.setLocationHref = function (e, t) {
  goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.assignLocation = function (e, t) {
  goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.assign(goog.html.SafeUrl.unwrapTrustedURL(t));
}, goog.dom.safe.replaceLocation = function (e, t) {
  goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.replace(goog.html.SafeUrl.unwrapTrustedURL(t));
}, goog.dom.safe.openInWindow = function (e, t, r, o, n) {
  return e = e instanceof goog.html.SafeUrl ? e : goog.html.SafeUrl.sanitizeAssertUnchanged(e), (t || goog.global).open(goog.html.SafeUrl.unwrapTrustedURL(e), r ? goog.string.Const.unwrap(r) : "", o, n);
}, goog.dom.safe.parseFromStringHtml = function (e, t) {
  return goog.dom.safe.parseFromString(e, t, "text/html");
}, goog.dom.safe.parseFromString = function (e, t, r) {
  return e.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(t), r);
}, goog.dom.safe.createImageFromBlob = function (e) {
  if (!/^image\/.*/g.test(e.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
  var t = goog.global.URL.createObjectURL(e);
  return (e = new goog.global.Image()).onload = function () {
    goog.global.URL.revokeObjectURL(t);
  }, goog.dom.safe.setImageSrc(e, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), t)), e;
}, goog.string.DETECT_DOUBLE_ESCAPING = !1, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1, goog.string.Unicode = {
  NBSP: " "
}, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function (e, t) {
  for (var r = e.split("%s"), o = "", n = Array.prototype.slice.call(arguments, 1); n.length && 1 < r.length;) o += r.shift() + n.shift();
  return o + r.join("%s");
}, goog.string.collapseWhitespace = function (e) {
  return e.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
}, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function (e) {
  return 0 == e.length;
}, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function (e) {
  return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(e));
}, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function (e) {
  return !/[^\t\n\r ]/.test(e);
}, goog.string.isAlpha = function (e) {
  return !/[^a-zA-Z]/.test(e);
}, goog.string.isNumeric = function (e) {
  return !/[^0-9]/.test(e);
}, goog.string.isAlphaNumeric = function (e) {
  return !/[^a-zA-Z0-9]/.test(e);
}, goog.string.isSpace = function (e) {
  return " " == e;
}, goog.string.isUnicodeChar = function (e) {
  return 1 == e.length && " " <= e && "~" >= e || "" <= e && "�" >= e;
}, goog.string.stripNewlines = function (e) {
  return e.replace(/(\r\n|\r|\n)+/g, " ");
}, goog.string.canonicalizeNewlines = function (e) {
  return e.replace(/(\r\n|\r|\n)/g, "\n");
}, goog.string.normalizeWhitespace = function (e) {
  return e.replace(/\xa0|\s/g, " ");
}, goog.string.normalizeSpaces = function (e) {
  return e.replace(/\xa0|[ \t]+/g, " ");
}, goog.string.collapseBreakingSpaces = function (e) {
  return e.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
}, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function (e) {
  return e.replace(/^[\s\xa0]+/, "");
}, goog.string.trimRight = function (e) {
  return e.replace(/[\s\xa0]+$/, "");
}, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function (e, t, r) {
  if (e == t) return 0;
  if (!e) return -1;
  if (!t) return 1;
  for (var o = e.toLowerCase().match(r), n = t.toLowerCase().match(r), a = Math.min(o.length, n.length), i = 0; i < a; i++) {
    r = o[i];
    var s = n[i];
    if (r != s) return e = parseInt(r, 10), !isNaN(e) && (t = parseInt(s, 10), !isNaN(t) && e - t) ? e - t : r < s ? -1 : 1;
  }
  return o.length != n.length ? o.length - n.length : e < t ? -1 : 1;
}, goog.string.intAwareCompare = function (e, t) {
  return goog.string.numberAwareCompare_(e, t, /\d+|\D+/g);
}, goog.string.floatAwareCompare = function (e, t) {
  return goog.string.numberAwareCompare_(e, t, /\d+|\.\d+|\D+/g);
}, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function (e) {
  return encodeURIComponent(String(e));
}, goog.string.urlDecode = function (e) {
  return decodeURIComponent(e.replace(/\+/g, " "));
}, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function (e, t) {
  return e = goog.string.internal.htmlEscape(e, t), goog.string.DETECT_DOUBLE_ESCAPING && (e = e.replace(goog.string.E_RE_, "&#101;")), e;
}, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function (e) {
  return goog.string.contains(e, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(e) : goog.string.unescapePureXmlEntities_(e) : e;
}, goog.string.unescapeEntitiesWithDocument = function (e, t) {
  return goog.string.contains(e, "&") ? goog.string.unescapeEntitiesUsingDom_(e, t) : e;
}, goog.string.unescapeEntitiesUsingDom_ = function (e, t) {
  var r = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"'
    },
    o = t ? t.createElement("div") : goog.global.document.createElement("div");
  return e.replace(goog.string.HTML_ENTITY_PATTERN_, function (e, t) {
    var n = r[e];
    return n || ("#" == t.charAt(0) && (t = Number("0" + t.substr(1)), isNaN(t) || (n = String.fromCharCode(t))), n || (goog.dom.safe.setInnerHtml(o, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), e + " ")), n = o.firstChild.nodeValue.slice(0, -1)), r[e] = n);
  });
}, goog.string.unescapePureXmlEntities_ = function (e) {
  return e.replace(/&([^;]+);/g, function (e, t) {
    switch (t) {
      case "amp":
        return "&";
      case "lt":
        return "<";
      case "gt":
        return ">";
      case "quot":
        return '"';
      default:
        return "#" != t.charAt(0) || (t = Number("0" + t.substr(1)), isNaN(t)) ? e : String.fromCharCode(t);
    }
  });
}, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function (e, t) {
  return goog.string.newLineToBr(e.replace(/  /g, " &#160;"), t);
}, goog.string.preserveSpaces = function (e) {
  return e.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
}, goog.string.stripQuotes = function (e, t) {
  for (var r = t.length, o = 0; o < r; o++) {
    var n = 1 == r ? t : t.charAt(o);
    if (e.charAt(0) == n && e.charAt(e.length - 1) == n) return e.substring(1, e.length - 1);
  }
  return e;
}, goog.string.truncate = function (e, t, r) {
  return r && (e = goog.string.unescapeEntities(e)), e.length > t && (e = e.substring(0, t - 3) + "..."), r && (e = goog.string.htmlEscape(e)), e;
}, goog.string.truncateMiddle = function (e, t, r, o) {
  if (r && (e = goog.string.unescapeEntities(e)), o && e.length > t) {
    o > t && (o = t);
    var n = e.length - o;
    e = e.substring(0, t - o) + "..." + e.substring(n);
  } else e.length > t && (o = Math.floor(t / 2), n = e.length - o, e = e.substring(0, o + t % 2) + "..." + e.substring(n));
  return r && (e = goog.string.htmlEscape(e)), e;
}, goog.string.specialEscapeChars_ = {
  "\0": "\\0",
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "\t": "\\t",
  "\v": "\\x0B",
  '"': '\\"',
  "\\": "\\\\",
  "<": "\\u003C"
}, goog.string.jsEscapeCache_ = {
  "'": "\\'"
}, goog.string.quote = function (e) {
  e = String(e);
  for (var t = ['"'], r = 0; r < e.length; r++) {
    var o = e.charAt(r),
      n = o.charCodeAt(0);
    t[r + 1] = goog.string.specialEscapeChars_[o] || (31 < n && 127 > n ? o : goog.string.escapeChar(o));
  }
  return t.push('"'), t.join("");
}, goog.string.escapeString = function (e) {
  for (var t = [], r = 0; r < e.length; r++) t[r] = goog.string.escapeChar(e.charAt(r));
  return t.join("");
}, goog.string.escapeChar = function (e) {
  if (e in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[e];
  if (e in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[e] = goog.string.specialEscapeChars_[e];
  var t = e.charCodeAt(0);
  if (31 < t && 127 > t) var r = e;else 256 > t ? (r = "\\x", (16 > t || 256 < t) && (r += "0")) : (r = "\\u", 4096 > t && (r += "0")), r += t.toString(16).toUpperCase();
  return goog.string.jsEscapeCache_[e] = r;
}, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function (e, t) {
  return e && t ? e.split(t).length - 1 : 0;
}, goog.string.removeAt = function (e, t, r) {
  var o = e;
  return 0 <= t && t < e.length && 0 < r && (o = e.substr(0, t) + e.substr(t + r, e.length - t - r)), o;
}, goog.string.remove = function (e, t) {
  return e.replace(t, "");
}, goog.string.removeAll = function (e, t) {
  return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, "");
}, goog.string.replaceAll = function (e, t, r) {
  return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, r.replace(/\$/g, "$$$$"));
}, goog.string.regExpEscape = function (e) {
  return String(e).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
}, goog.string.repeat = String.prototype.repeat ? function (e, t) {
  return e.repeat(t);
} : function (e, t) {
  return Array(t + 1).join(e);
}, goog.string.padNumber = function (e, t, r) {
  return -1 == (r = (e = goog.isDef(r) ? e.toFixed(r) : String(e)).indexOf(".")) && (r = e.length), goog.string.repeat("0", Math.max(0, t - r)) + e;
}, goog.string.makeSafe = function (e) {
  return null == e ? "" : String(e);
}, goog.string.buildString = function (e) {
  return Array.prototype.join.call(arguments, "");
}, goog.string.getRandomString = function () {
  return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
}, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function (e) {
  for (var t = 0, r = 0; r < e.length; ++r) t = 31 * t + e.charCodeAt(r) >>> 0;
  return t;
}, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function () {
  return "goog_" + goog.string.uniqueStringCounter_++;
}, goog.string.toNumber = function (e) {
  var t = Number(e);
  return 0 == t && goog.string.isEmptyOrWhitespace(e) ? NaN : t;
}, goog.string.isLowerCamelCase = function (e) {
  return /^[a-z]+([A-Z][a-z]*)*$/.test(e);
}, goog.string.isUpperCamelCase = function (e) {
  return /^([A-Z][a-z]*)+$/.test(e);
}, goog.string.toCamelCase = function (e) {
  return String(e).replace(/\-([a-z])/g, function (e, t) {
    return t.toUpperCase();
  });
}, goog.string.toSelectorCase = function (e) {
  return String(e).replace(/([A-Z])/g, "-$1").toLowerCase();
}, goog.string.toTitleCase = function (e, t) {
  return t = goog.isString(t) ? goog.string.regExpEscape(t) : "\\s", e.replace(new RegExp("(^" + (t ? "|[" + t + "]+" : "") + ")([a-z])", "g"), function (e, t, r) {
    return t + r.toUpperCase();
  });
}, goog.string.capitalize = function (e) {
  return String(e.charAt(0)).toUpperCase() + String(e.substr(1)).toLowerCase();
}, goog.string.parseInt = function (e) {
  return isFinite(e) && (e = String(e)), goog.isString(e) ? /^\s*-?0x/i.test(e) ? parseInt(e, 16) : parseInt(e, 10) : NaN;
}, goog.string.splitLimit = function (e, t, r) {
  e = e.split(t);
  for (var o = []; 0 < r && e.length;) o.push(e.shift()), r--;
  return e.length && o.push(e.join(t)), o;
}, goog.string.lastComponent = function (e, t) {
  if (!t) return e;
  "string" == typeof t && (t = [t]);
  for (var r = -1, o = 0; o < t.length; o++) if ("" != t[o]) {
    var n = e.lastIndexOf(t[o]);
    n > r && (r = n);
  }
  return -1 == r ? e : e.slice(r + 1);
}, goog.string.editDistance = function (e, t) {
  var r = [],
    o = [];
  if (e == t) return 0;
  if (!e.length || !t.length) return Math.max(e.length, t.length);
  for (var n = 0; n < t.length + 1; n++) r[n] = n;
  for (n = 0; n < e.length; n++) {
    o[0] = n + 1;
    for (var a = 0; a < t.length; a++) o[a + 1] = Math.min(o[a] + 1, r[a + 1] + 1, r[a] + Number(e[n] != t[a]));
    for (a = 0; a < r.length; a++) r[a] = o[a];
  }
  return o[t.length];
}, goog.labs.userAgent.platform = {}, goog.labs.userAgent.platform.isAndroid = function () {
  return goog.labs.userAgent.util.matchUserAgent("Android");
}, goog.labs.userAgent.platform.isIpod = function () {
  return goog.labs.userAgent.util.matchUserAgent("iPod");
}, goog.labs.userAgent.platform.isIphone = function () {
  return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
}, goog.labs.userAgent.platform.isIpad = function () {
  return goog.labs.userAgent.util.matchUserAgent("iPad");
}, goog.labs.userAgent.platform.isIos = function () {
  return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
}, goog.labs.userAgent.platform.isMacintosh = function () {
  return goog.labs.userAgent.util.matchUserAgent("Macintosh");
}, goog.labs.userAgent.platform.isLinux = function () {
  return goog.labs.userAgent.util.matchUserAgent("Linux");
}, goog.labs.userAgent.platform.isWindows = function () {
  return goog.labs.userAgent.util.matchUserAgent("Windows");
}, goog.labs.userAgent.platform.isChromeOS = function () {
  return goog.labs.userAgent.util.matchUserAgent("CrOS");
}, goog.labs.userAgent.platform.isChromecast = function () {
  return goog.labs.userAgent.util.matchUserAgent("CrKey");
}, goog.labs.userAgent.platform.isKaiOS = function () {
  return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
}, goog.labs.userAgent.platform.isGo2Phone = function () {
  return goog.labs.userAgent.util.matchUserAgentIgnoreCase("GAFP");
}, goog.labs.userAgent.platform.getVersion = function () {
  var e = goog.labs.userAgent.util.getUserAgent(),
    t = "";
  return goog.labs.userAgent.platform.isWindows() ? t = (e = (t = /Windows (?:NT|Phone) ([0-9.]+)/).exec(e)) ? e[1] : "0.0" : goog.labs.userAgent.platform.isIos() ? t = (e = (t = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/).exec(e)) && e[1].replace(/_/g, ".") : goog.labs.userAgent.platform.isMacintosh() ? t = (e = (t = /Mac OS X ([0-9_.]+)/).exec(e)) ? e[1].replace(/_/g, ".") : "10" : goog.labs.userAgent.platform.isKaiOS() ? t = (e = (t = /(?:KaiOS)\/(\S+)/i).exec(e)) && e[1] : goog.labs.userAgent.platform.isAndroid() ? t = (e = (t = /Android\s+([^\);]+)(\)|;)/).exec(e)) && e[1] : goog.labs.userAgent.platform.isChromeOS() && (t = (e = (t = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/).exec(e)) && e[1]), t || "";
}, goog.labs.userAgent.platform.isVersionOrHigher = function (e) {
  return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), e);
}, goog.reflect = {}, goog.reflect.object = function (e, t) {
  return t;
}, goog.reflect.objectProperty = function (e, t) {
  return e;
}, goog.reflect.sinkValue = function (e) {
  return goog.reflect.sinkValue[" "](e), e;
}, goog.reflect.sinkValue[" "] = goog.nullFunction, goog.reflect.canAccessProperty = function (e, t) {
  try {
    return goog.reflect.sinkValue(e[t]), !0;
  } catch (e) {}
  return !1;
}, goog.reflect.cache = function (e, t, r, o) {
  return o = o ? o(t) : t, Object.prototype.hasOwnProperty.call(e, o) ? e[o] : e[o] = r(t);
}, goog.labs.userAgent.engine = {}, goog.labs.userAgent.engine.isPresto = function () {
  return goog.labs.userAgent.util.matchUserAgent("Presto");
}, goog.labs.userAgent.engine.isTrident = function () {
  return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
}, goog.labs.userAgent.engine.isEdge = function () {
  return goog.labs.userAgent.util.matchUserAgent("Edge");
}, goog.labs.userAgent.engine.isWebKit = function () {
  return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
}, goog.labs.userAgent.engine.isGecko = function () {
  return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
}, goog.labs.userAgent.engine.getVersion = function () {
  var e = goog.labs.userAgent.util.getUserAgent();
  if (e) {
    e = goog.labs.userAgent.util.extractVersionTuples(e);
    var t,
      r = goog.labs.userAgent.engine.getEngineTuple_(e);
    if (r) return "Gecko" == r[0] ? goog.labs.userAgent.engine.getVersionForKey_(e, "Firefox") : r[1];
    if ((e = e[0]) && (t = e[2]) && (t = /Trident\/([^\s;]+)/.exec(t))) return t[1];
  }
  return "";
}, goog.labs.userAgent.engine.getEngineTuple_ = function (e) {
  if (!goog.labs.userAgent.engine.isEdge()) return e[1];
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    if ("Edge" == r[0]) return r;
  }
}, goog.labs.userAgent.engine.isVersionOrHigher = function (e) {
  return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), e);
}, goog.labs.userAgent.engine.getVersionForKey_ = function (e, t) {
  return (e = goog.array.find(e, function (e) {
    return t == e[0];
  })) && e[1] || "";
}, goog.userAgent = {}, goog.userAgent.ASSUME_IE = !1, goog.userAgent.ASSUME_EDGE = !1, goog.userAgent.ASSUME_GECKO = !1, goog.userAgent.ASSUME_WEBKIT = !1, goog.userAgent.ASSUME_MOBILE_WEBKIT = !1, goog.userAgent.ASSUME_OPERA = !1, goog.userAgent.ASSUME_ANY_VERSION = !1, goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA, goog.userAgent.getUserAgentString = function () {
  return goog.labs.userAgent.util.getUserAgent();
}, goog.userAgent.getNavigatorTyped = function () {
  return goog.global.navigator || null;
}, goog.userAgent.getNavigator = function () {
  return goog.userAgent.getNavigatorTyped();
}, goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera(), goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE(), goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge(), goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE, goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko();
goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit(), goog.userAgent.isMobile_ = function () {
  return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
}, goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_(), goog.userAgent.SAFARI = goog.userAgent.WEBKIT, goog.userAgent.determinePlatform_ = function () {
  var e = goog.userAgent.getNavigatorTyped();
  return e && e.platform || "";
}, goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_(), goog.userAgent.ASSUME_MAC = !1, goog.userAgent.ASSUME_WINDOWS = !1, goog.userAgent.ASSUME_LINUX = !1, goog.userAgent.ASSUME_X11 = !1, goog.userAgent.ASSUME_ANDROID = !1, goog.userAgent.ASSUME_IPHONE = !1, goog.userAgent.ASSUME_IPAD = !1, goog.userAgent.ASSUME_IPOD = !1, goog.userAgent.ASSUME_KAIOS = !1, goog.userAgent.ASSUME_GO2PHONE = !1, goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD, goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh(), goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows(), goog.userAgent.isLegacyLinux_ = function () {
  return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
}, goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_(), goog.userAgent.isX11_ = function () {
  var e = goog.userAgent.getNavigatorTyped();
  return !!e && goog.string.contains(e.appVersion || "", "X11");
}, goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_(), goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid(), goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone(), goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod(), goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos(), goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS(), goog.userAgent.GO2PHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_GO2PHONE : goog.labs.userAgent.platform.isGo2Phone(), goog.userAgent.determineVersion_ = function () {
  var e = "",
    t = goog.userAgent.getVersionRegexResult_();
  return t && (e = t ? t[1] : ""), goog.userAgent.IE && null != (t = goog.userAgent.getDocumentMode_()) && t > parseFloat(e) ? String(t) : e;
}, goog.userAgent.getVersionRegexResult_ = function () {
  var e = goog.userAgent.getUserAgentString();
  return goog.userAgent.GECKO ? /rv:([^\);]+)(\)|;)/.exec(e) : goog.userAgent.EDGE ? /Edge\/([\d\.]+)/.exec(e) : goog.userAgent.IE ? /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(e) : goog.userAgent.WEBKIT ? /WebKit\/(\S+)/.exec(e) : goog.userAgent.OPERA ? /(?:Version)[ \/]?(\S+)/.exec(e) : void 0;
}, goog.userAgent.getDocumentMode_ = function () {
  var e = goog.global.document;
  return e ? e.documentMode : void 0;
}, goog.userAgent.VERSION = goog.userAgent.determineVersion_(), goog.userAgent.compare = function (e, t) {
  return goog.string.compareVersions(e, t);
}, goog.userAgent.isVersionOrHigherCache_ = {}, goog.userAgent.isVersionOrHigher = function (e) {
  return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, e, function () {
    return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, e);
  });
}, goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher, goog.userAgent.isDocumentModeOrHigher = function (e) {
  return Number(goog.userAgent.DOCUMENT_MODE) >= e;
}, goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher, goog.userAgent.DOCUMENT_MODE = function () {
  if (goog.global.document && goog.userAgent.IE) return goog.userAgent.getDocumentMode_();
}(), goog.userAgent.product = {}, goog.userAgent.product.ASSUME_FIREFOX = !1, goog.userAgent.product.ASSUME_IPHONE = !1, goog.userAgent.product.ASSUME_IPAD = !1, goog.userAgent.product.ASSUME_ANDROID = !1, goog.userAgent.product.ASSUME_CHROME = !1, goog.userAgent.product.ASSUME_SAFARI = !1, goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI, goog.userAgent.product.OPERA = goog.userAgent.OPERA, goog.userAgent.product.IE = goog.userAgent.IE, goog.userAgent.product.EDGE = goog.userAgent.EDGE, goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox(), goog.userAgent.product.isIphoneOrIpod_ = function () {
  return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
}, goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_(), goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser(), goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome(), goog.userAgent.product.isSafariDesktop_ = function () {
  return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
}, goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_(), goog.crypt.base64 = {}, goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=", goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.", goog.crypt.base64.Alphabet = {
  DEFAULT: 0,
  NO_PADDING: 1,
  WEBSAFE: 2,
  WEBSAFE_DOT_PADDING: 3,
  WEBSAFE_NO_PADDING: 4
}, goog.crypt.base64.paddingChars_ = "=.", goog.crypt.base64.isPadding_ = function (e) {
  return goog.string.contains(goog.crypt.base64.paddingChars_, e);
}, goog.crypt.base64.byteToCharMaps_ = {}, goog.crypt.base64.charToByteMap_ = null, goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA, goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || "function" == typeof goog.global.btoa, goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && "function" == typeof goog.global.atob, goog.crypt.base64.encodeByteArray = function (e, t) {
  goog.asserts.assert(goog.isArrayLike(e), "encodeByteArray takes an array as a parameter"), void 0 === t && (t = goog.crypt.base64.Alphabet.DEFAULT), goog.crypt.base64.init_(), t = goog.crypt.base64.byteToCharMaps_[t];
  for (var r = [], o = 0; o < e.length; o += 3) {
    var n = e[o],
      a = o + 1 < e.length,
      i = a ? e[o + 1] : 0,
      s = o + 2 < e.length,
      u = s ? e[o + 2] : 0,
      l = n >> 2;
    n = (3 & n) << 4 | i >> 4, i = (15 & i) << 2 | u >> 6, u &= 63, s || (u = 64, a || (i = 64)), r.push(t[l], t[n], t[i] || "", t[u] || "");
  }
  return r.join("");
}, goog.crypt.base64.encodeString = function (e, t) {
  return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !t ? goog.global.btoa(e) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(e), t);
}, goog.crypt.base64.decodeString = function (e, t) {
  if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !t) return goog.global.atob(e);
  var r = "";
  return goog.crypt.base64.decodeStringInternal_(e, function (e) {
    r += String.fromCharCode(e);
  }), r;
}, goog.crypt.base64.decodeStringToByteArray = function (e, t) {
  var r = [];
  return goog.crypt.base64.decodeStringInternal_(e, function (e) {
    r.push(e);
  }), r;
}, goog.crypt.base64.decodeStringToUint8Array = function (e) {
  goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
  var t = e.length,
    r = 3 * t / 4;
  r % 3 ? r = Math.floor(r) : goog.crypt.base64.isPadding_(e[t - 1]) && (r = goog.crypt.base64.isPadding_(e[t - 2]) ? r - 2 : r - 1);
  var o = new Uint8Array(r),
    n = 0;
  return goog.crypt.base64.decodeStringInternal_(e, function (e) {
    o[n++] = e;
  }), o.subarray(0, n);
}, goog.crypt.base64.decodeStringInternal_ = function (e, t) {
  function r(t) {
    for (; o < e.length;) {
      var r = e.charAt(o++),
        n = goog.crypt.base64.charToByteMap_[r];
      if (null != n) return n;
      if (!goog.string.isEmptyOrWhitespace(r)) throw Error("Unknown base64 encoding at char: " + r);
    }
    return t;
  }
  goog.crypt.base64.init_();
  for (var o = 0;;) {
    var n = r(-1),
      a = r(0),
      i = r(64),
      s = r(64);
    if (64 === s && -1 === n) break;
    t(n << 2 | a >> 4), 64 != i && (t(a << 4 & 240 | i >> 2), 64 != s && t(i << 6 & 192 | s));
  }
}, goog.crypt.base64.init_ = function () {
  if (!goog.crypt.base64.charToByteMap_) {
    goog.crypt.base64.charToByteMap_ = {};
    for (var e = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), t = ["+/=", "+/", "-_=", "-_.", "-_"], r = 0; 5 > r; r++) {
      var o = e.concat(t[r].split(""));
      goog.crypt.base64.byteToCharMaps_[r] = o;
      for (var n = 0; n < o.length; n++) {
        var a = o[n],
          i = goog.crypt.base64.charToByteMap_[a];
        void 0 === i ? goog.crypt.base64.charToByteMap_[a] = n : goog.asserts.assert(i === n);
      }
    }
  }
}, jspb.utils = {}, jspb.utils.split64Low = 0, jspb.utils.split64High = 0, jspb.utils.splitUint64 = function (e) {
  var t = e >>> 0;
  e = Math.floor((e - t) / jspb.BinaryConstants.TWO_TO_32) >>> 0, jspb.utils.split64Low = t, jspb.utils.split64High = e;
}, jspb.utils.splitInt64 = function (e) {
  var t = 0 > e,
    r = (e = Math.abs(e)) >>> 0;
  e = Math.floor((e - r) / jspb.BinaryConstants.TWO_TO_32), e >>>= 0, t && (e = ~e >>> 0, 4294967295 < (r = 1 + (~r >>> 0)) && (r = 0, 4294967295 < ++e && (e = 0))), jspb.utils.split64Low = r, jspb.utils.split64High = e;
}, jspb.utils.splitZigzag64 = function (e) {
  var t = 0 > e;
  e = 2 * Math.abs(e), jspb.utils.splitUint64(e), e = jspb.utils.split64Low;
  var r = jspb.utils.split64High;
  t && (0 == e ? 0 == r ? r = e = 4294967295 : (r--, e = 4294967295) : e--), jspb.utils.split64Low = e, jspb.utils.split64High = r;
}, jspb.utils.splitFloat32 = function (e) {
  var t = 0 > e ? 1 : 0;
  if (0 === (e = t ? -e : e)) 0 < 1 / e ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);else if (isNaN(e)) jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;else if (e > jspb.BinaryConstants.FLOAT32_MAX) jspb.utils.split64High = 0, jspb.utils.split64Low = (t << 31 | 2139095040) >>> 0;else if (e < jspb.BinaryConstants.FLOAT32_MIN) e = Math.round(e / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (t << 31 | e) >>> 0;else {
    var r = Math.floor(Math.log(e) / Math.LN2);
    e *= Math.pow(2, -r), e = 8388607 & Math.round(e * jspb.BinaryConstants.TWO_TO_23), jspb.utils.split64High = 0, jspb.utils.split64Low = (t << 31 | r + 127 << 23 | e) >>> 0;
  }
}, jspb.utils.splitFloat64 = function (e) {
  var t = 0 > e ? 1 : 0;
  if (0 === (e = t ? -e : e)) jspb.utils.split64High = 0 < 1 / e ? 0 : 2147483648, jspb.utils.split64Low = 0;else if (isNaN(e)) jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;else if (e > jspb.BinaryConstants.FLOAT64_MAX) jspb.utils.split64High = (t << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;else if (e < jspb.BinaryConstants.FLOAT64_MIN) {
    var r = e / Math.pow(2, -1074);
    e = r / jspb.BinaryConstants.TWO_TO_32, jspb.utils.split64High = (t << 31 | e) >>> 0, jspb.utils.split64Low = r >>> 0;
  } else {
    var o = 0;
    if (2 <= (r = e)) for (; 2 <= r && 1023 > o;) o++, r /= 2;else for (; 1 > r && -1022 < o;) r *= 2, o--;
    e = (r = e * Math.pow(2, -o)) * jspb.BinaryConstants.TWO_TO_20 & 1048575, r = r * jspb.BinaryConstants.TWO_TO_52 >>> 0, jspb.utils.split64High = (t << 31 | o + 1023 << 20 | e) >>> 0, jspb.utils.split64Low = r;
  }
}, jspb.utils.splitHash64 = function (e) {
  var t = e.charCodeAt(0),
    r = e.charCodeAt(1),
    o = e.charCodeAt(2),
    n = e.charCodeAt(3),
    a = e.charCodeAt(4),
    i = e.charCodeAt(5),
    s = e.charCodeAt(6);
  e = e.charCodeAt(7), jspb.utils.split64Low = t + (r << 8) + (o << 16) + (n << 24) >>> 0, jspb.utils.split64High = a + (i << 8) + (s << 16) + (e << 24) >>> 0;
}, jspb.utils.joinUint64 = function (e, t) {
  return t * jspb.BinaryConstants.TWO_TO_32 + (e >>> 0);
}, jspb.utils.joinInt64 = function (e, t) {
  var r = 2147483648 & t;
  return r && (t = ~t >>> 0, 0 == (e = 1 + ~e >>> 0) && (t = t + 1 >>> 0)), e = jspb.utils.joinUint64(e, t), r ? -e : e;
}, jspb.utils.toZigzag64 = function (e, t, r) {
  var o = t >> 31;
  return r(e << 1 ^ o, (t << 1 | e >>> 31) ^ o);
}, jspb.utils.joinZigzag64 = function (e, t) {
  return jspb.utils.fromZigzag64(e, t, jspb.utils.joinInt64);
}, jspb.utils.fromZigzag64 = function (e, t, r) {
  var o = -(1 & e);
  return r((e >>> 1 | t << 31) ^ o, t >>> 1 ^ o);
}, jspb.utils.joinFloat32 = function (e, t) {
  t = 2 * (e >> 31) + 1;
  var r = e >>> 23 & 255;
  return e &= 8388607, 255 == r ? e ? NaN : 1 / 0 * t : 0 == r ? t * Math.pow(2, -149) * e : t * Math.pow(2, r - 150) * (e + Math.pow(2, 23));
}, jspb.utils.joinFloat64 = function (e, t) {
  var r = 2 * (t >> 31) + 1,
    o = t >>> 20 & 2047;
  return e = jspb.BinaryConstants.TWO_TO_32 * (1048575 & t) + e, 2047 == o ? e ? NaN : 1 / 0 * r : 0 == o ? r * Math.pow(2, -1074) * e : r * Math.pow(2, o - 1075) * (e + jspb.BinaryConstants.TWO_TO_52);
}, jspb.utils.joinHash64 = function (e, t) {
  return String.fromCharCode(e >>> 0 & 255, e >>> 8 & 255, e >>> 16 & 255, e >>> 24 & 255, t >>> 0 & 255, t >>> 8 & 255, t >>> 16 & 255, t >>> 24 & 255);
}, jspb.utils.DIGITS = "0123456789abcdef".split(""), jspb.utils.ZERO_CHAR_CODE_ = 48, jspb.utils.A_CHAR_CODE_ = 97, jspb.utils.joinUnsignedDecimalString = function (e, t) {
  function r(e, t) {
    return e = e ? String(e) : "", t ? "0000000".slice(e.length) + e : e;
  }
  if (2097151 >= t) return "" + (jspb.BinaryConstants.TWO_TO_32 * t + e);
  var o = (e >>> 24 | t << 8) >>> 0 & 16777215;
  return e = (16777215 & e) + 6777216 * o + 6710656 * (t = t >> 16 & 65535), o += 8147497 * t, t *= 2, 1e7 <= e && (o += Math.floor(e / 1e7), e %= 1e7), 1e7 <= o && (t += Math.floor(o / 1e7), o %= 1e7), r(t, 0) + r(o, t) + r(e, 1);
}, jspb.utils.joinSignedDecimalString = function (e, t) {
  var r = 2147483648 & t;
  return r && (t = ~t + (0 == (e = 1 + ~e >>> 0) ? 1 : 0) >>> 0), e = jspb.utils.joinUnsignedDecimalString(e, t), r ? "-" + e : e;
}, jspb.utils.hash64ToDecimalString = function (e, t) {
  jspb.utils.splitHash64(e), e = jspb.utils.split64Low;
  var r = jspb.utils.split64High;
  return t ? jspb.utils.joinSignedDecimalString(e, r) : jspb.utils.joinUnsignedDecimalString(e, r);
}, jspb.utils.hash64ArrayToDecimalStrings = function (e, t) {
  for (var r = Array(e.length), o = 0; o < e.length; o++) r[o] = jspb.utils.hash64ToDecimalString(e[o], t);
  return r;
}, jspb.utils.decimalStringToHash64 = function (e) {
  function t(e, t) {
    for (var r = 0; 8 > r && (1 !== e || 0 < t); r++) t = e * o[r] + t, o[r] = 255 & t, t >>>= 8;
  }
  goog.asserts.assert(0 < e.length);
  var r = !1;
  "-" === e[0] && (r = !0, e = e.slice(1));
  for (var o = [0, 0, 0, 0, 0, 0, 0, 0], n = 0; n < e.length; n++) t(10, e.charCodeAt(n) - jspb.utils.ZERO_CHAR_CODE_);
  return r && (function () {
    for (var e = 0; 8 > e; e++) o[e] = 255 & ~o[e];
  }(), t(1, 1)), goog.crypt.byteArrayToString(o);
}, jspb.utils.splitDecimalString = function (e) {
  jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e));
}, jspb.utils.toHexDigit_ = function (e) {
  return String.fromCharCode(10 > e ? jspb.utils.ZERO_CHAR_CODE_ + e : jspb.utils.A_CHAR_CODE_ - 10 + e);
}, jspb.utils.fromHexCharCode_ = function (e) {
  return e >= jspb.utils.A_CHAR_CODE_ ? e - jspb.utils.A_CHAR_CODE_ + 10 : e - jspb.utils.ZERO_CHAR_CODE_;
}, jspb.utils.hash64ToHexString = function (e) {
  var t = Array(18);
  t[0] = "0", t[1] = "x";
  for (var r = 0; 8 > r; r++) {
    var o = e.charCodeAt(7 - r);
    t[2 * r + 2] = jspb.utils.toHexDigit_(o >> 4), t[2 * r + 3] = jspb.utils.toHexDigit_(15 & o);
  }
  return t.join("");
}, jspb.utils.hexStringToHash64 = function (e) {
  e = e.toLowerCase(), goog.asserts.assert(18 == e.length), goog.asserts.assert("0" == e[0]), goog.asserts.assert("x" == e[1]);
  for (var t = "", r = 0; 8 > r; r++) {
    var o = jspb.utils.fromHexCharCode_(e.charCodeAt(2 * r + 2)),
      n = jspb.utils.fromHexCharCode_(e.charCodeAt(2 * r + 3));
    t = String.fromCharCode(16 * o + n) + t;
  }
  return t;
}, jspb.utils.hash64ToNumber = function (e, t) {
  jspb.utils.splitHash64(e), e = jspb.utils.split64Low;
  var r = jspb.utils.split64High;
  return t ? jspb.utils.joinInt64(e, r) : jspb.utils.joinUint64(e, r);
}, jspb.utils.numberToHash64 = function (e) {
  return jspb.utils.splitInt64(e), jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.utils.countVarints = function (e, t, r) {
  for (var o = 0, n = t; n < r; n++) o += e[n] >> 7;
  return r - t - o;
}, jspb.utils.countVarintFields = function (e, t, r, o) {
  var n = 0;
  if (128 > (o = 8 * o + jspb.BinaryConstants.WireType.VARINT)) for (; t < r && e[t++] == o;) for (n++;;) {
    var a = e[t++];
    if (0 == (128 & a)) break;
  } else for (; t < r;) {
    for (a = o; 128 < a;) {
      if (e[t] != (127 & a | 128)) return n;
      t++, a >>= 7;
    }
    if (e[t++] != a) break;
    for (n++; 0 != (128 & (a = e[t++])););
  }
  return n;
}, jspb.utils.countFixedFields_ = function (e, t, r, o, n) {
  var a = 0;
  if (128 > o) for (; t < r && e[t++] == o;) a++, t += n;else for (; t < r;) {
    for (var i = o; 128 < i;) {
      if (e[t++] != (127 & i | 128)) return a;
      i >>= 7;
    }
    if (e[t++] != i) break;
    a++, t += n;
  }
  return a;
}, jspb.utils.countFixed32Fields = function (e, t, r, o) {
  return jspb.utils.countFixedFields_(e, t, r, 8 * o + jspb.BinaryConstants.WireType.FIXED32, 4);
}, jspb.utils.countFixed64Fields = function (e, t, r, o) {
  return jspb.utils.countFixedFields_(e, t, r, 8 * o + jspb.BinaryConstants.WireType.FIXED64, 8);
}, jspb.utils.countDelimitedFields = function (e, t, r, o) {
  var n = 0;
  for (o = 8 * o + jspb.BinaryConstants.WireType.DELIMITED; t < r;) {
    for (var a = o; 128 < a;) {
      if (e[t++] != (127 & a | 128)) return n;
      a >>= 7;
    }
    if (e[t++] != a) break;
    n++;
    for (var i = 0, s = 1; i += (127 & (a = e[t++])) * s, s *= 128, 0 != (128 & a););
    t += i;
  }
  return n;
}, jspb.utils.debugBytesToTextFormat = function (e) {
  var t = '"';
  if (e) {
    e = jspb.utils.byteSourceToUint8Array(e);
    for (var r = 0; r < e.length; r++) t += "\\x", 16 > e[r] && (t += "0"), t += e[r].toString(16);
  }
  return t + '"';
}, jspb.utils.debugScalarToTextFormat = function (e) {
  return "string" == typeof e ? goog.string.quote(e) : e.toString();
}, jspb.utils.stringToByteArray = function (e) {
  for (var t = new Uint8Array(e.length), r = 0; r < e.length; r++) {
    var o = e.charCodeAt(r);
    if (255 < o) throw Error("Conversion error: string contains codepoint outside of byte range");
    t[r] = o;
  }
  return t;
}, jspb.utils.byteSourceToUint8Array = function (e) {
  return e.constructor === Uint8Array ? e : e.constructor === ArrayBuffer || "undefined" != typeof Buffer && e.constructor === Buffer || e.constructor === Array ? new Uint8Array(e) : e.constructor === String ? goog.crypt.base64.decodeStringToUint8Array(e) : (goog.asserts.fail("Type not convertible to Uint8Array."), new Uint8Array(0));
}, jspb.BinaryDecoder = function (e, t, r) {
  this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1, e && this.setBlock(e, t, r);
}, jspb.BinaryDecoder.instanceCache_ = [], jspb.BinaryDecoder.alloc = function (e, t, r) {
  if (jspb.BinaryDecoder.instanceCache_.length) {
    var o = jspb.BinaryDecoder.instanceCache_.pop();
    return e && o.setBlock(e, t, r), o;
  }
  return new jspb.BinaryDecoder(e, t, r);
}, jspb.BinaryDecoder.prototype.free = function () {
  this.clear(), 100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
}, jspb.BinaryDecoder.prototype.clone = function () {
  return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
}, jspb.BinaryDecoder.prototype.clear = function () {
  this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1;
}, jspb.BinaryDecoder.prototype.getBuffer = function () {
  return this.bytes_;
}, jspb.BinaryDecoder.prototype.setBlock = function (e, t, r) {
  this.bytes_ = jspb.utils.byteSourceToUint8Array(e), this.start_ = void 0 !== t ? t : 0, this.end_ = void 0 !== r ? this.start_ + r : this.bytes_.length, this.cursor_ = this.start_;
}, jspb.BinaryDecoder.prototype.getEnd = function () {
  return this.end_;
}, jspb.BinaryDecoder.prototype.setEnd = function (e) {
  this.end_ = e;
}, jspb.BinaryDecoder.prototype.reset = function () {
  this.cursor_ = this.start_;
}, jspb.BinaryDecoder.prototype.getCursor = function () {
  return this.cursor_;
}, jspb.BinaryDecoder.prototype.setCursor = function (e) {
  this.cursor_ = e;
}, jspb.BinaryDecoder.prototype.advance = function (e) {
  this.cursor_ += e, goog.asserts.assert(this.cursor_ <= this.end_);
}, jspb.BinaryDecoder.prototype.atEnd = function () {
  return this.cursor_ == this.end_;
}, jspb.BinaryDecoder.prototype.pastEnd = function () {
  return this.cursor_ > this.end_;
}, jspb.BinaryDecoder.prototype.getError = function () {
  return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
}, jspb.BinaryDecoder.prototype.readSplitVarint64 = function (e) {
  for (var t = 128, r = 0, o = 0, n = 0; 4 > n && 128 <= t; n++) r |= (127 & (t = this.bytes_[this.cursor_++])) << 7 * n;
  if (128 <= t && (r |= (127 & (t = this.bytes_[this.cursor_++])) << 28, o |= (127 & t) >> 4), 128 <= t) for (n = 0; 5 > n && 128 <= t; n++) o |= (127 & (t = this.bytes_[this.cursor_++])) << 7 * n + 3;
  if (128 > t) return e(r >>> 0, o >>> 0);
  goog.asserts.fail("Failed to read varint, encoding is invalid."), this.error_ = !0;
}, jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function (e) {
  return this.readSplitVarint64(function (t, r) {
    return jspb.utils.fromZigzag64(t, r, e);
  });
}, jspb.BinaryDecoder.prototype.readSplitFixed64 = function (e) {
  var t = this.bytes_,
    r = this.cursor_;
  this.cursor_ += 8;
  for (var o = 0, n = 0, a = r + 7; a >= r; a--) o = o << 8 | t[a], n = n << 8 | t[a + 4];
  return e(o, n);
}, jspb.BinaryDecoder.prototype.skipVarint = function () {
  for (; 128 & this.bytes_[this.cursor_];) this.cursor_++;
  this.cursor_++;
}, jspb.BinaryDecoder.prototype.unskipVarint = function (e) {
  for (; 128 < e;) this.cursor_--, e >>>= 7;
  this.cursor_--;
}, jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function () {
  var e = this.bytes_,
    t = e[this.cursor_ + 0],
    r = 127 & t;
  return 128 > t ? (this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), r) : (r |= (127 & (t = e[this.cursor_ + 1])) << 7, 128 > t ? (this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), r) : (r |= (127 & (t = e[this.cursor_ + 2])) << 14, 128 > t ? (this.cursor_ += 3, goog.asserts.assert(this.cursor_ <= this.end_), r) : (r |= (127 & (t = e[this.cursor_ + 3])) << 21, 128 > t ? (this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), r) : (r |= (15 & (t = e[this.cursor_ + 4])) << 28, 128 > t ? (this.cursor_ += 5, goog.asserts.assert(this.cursor_ <= this.end_), r >>> 0) : (this.cursor_ += 5, 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && goog.asserts.assert(!1), goog.asserts.assert(this.cursor_ <= this.end_), r)))));
}, jspb.BinaryDecoder.prototype.readSignedVarint32 = jspb.BinaryDecoder.prototype.readUnsignedVarint32, jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function () {
  return this.readUnsignedVarint32().toString();
}, jspb.BinaryDecoder.prototype.readSignedVarint32String = function () {
  return this.readSignedVarint32().toString();
}, jspb.BinaryDecoder.prototype.readZigzagVarint32 = function () {
  var e = this.readUnsignedVarint32();
  return e >>> 1 ^ -(1 & e);
}, jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function () {
  return this.readSplitVarint64(jspb.utils.joinUint64);
}, jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function () {
  return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
}, jspb.BinaryDecoder.prototype.readSignedVarint64 = function () {
  return this.readSplitVarint64(jspb.utils.joinInt64);
}, jspb.BinaryDecoder.prototype.readSignedVarint64String = function () {
  return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
}, jspb.BinaryDecoder.prototype.readZigzagVarint64 = function () {
  return this.readSplitVarint64(jspb.utils.joinZigzag64);
}, jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function () {
  return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
}, jspb.BinaryDecoder.prototype.readZigzagVarint64String = function () {
  return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
}, jspb.BinaryDecoder.prototype.readUint8 = function () {
  var e = this.bytes_[this.cursor_ + 0];
  return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), e;
}, jspb.BinaryDecoder.prototype.readUint16 = function () {
  var e = this.bytes_[this.cursor_ + 0],
    t = this.bytes_[this.cursor_ + 1];
  return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), e << 0 | t << 8;
}, jspb.BinaryDecoder.prototype.readUint32 = function () {
  var e = this.bytes_[this.cursor_ + 0],
    t = this.bytes_[this.cursor_ + 1],
    r = this.bytes_[this.cursor_ + 2],
    o = this.bytes_[this.cursor_ + 3];
  return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), (e << 0 | t << 8 | r << 16 | o << 24) >>> 0;
}, jspb.BinaryDecoder.prototype.readUint64 = function () {
  var e = this.readUint32(),
    t = this.readUint32();
  return jspb.utils.joinUint64(e, t);
}, jspb.BinaryDecoder.prototype.readUint64String = function () {
  var e = this.readUint32(),
    t = this.readUint32();
  return jspb.utils.joinUnsignedDecimalString(e, t);
}, jspb.BinaryDecoder.prototype.readInt8 = function () {
  var e = this.bytes_[this.cursor_ + 0];
  return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), e << 24 >> 24;
}, jspb.BinaryDecoder.prototype.readInt16 = function () {
  var e = this.bytes_[this.cursor_ + 0],
    t = this.bytes_[this.cursor_ + 1];
  return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), (e << 0 | t << 8) << 16 >> 16;
}, jspb.BinaryDecoder.prototype.readInt32 = function () {
  var e = this.bytes_[this.cursor_ + 0],
    t = this.bytes_[this.cursor_ + 1],
    r = this.bytes_[this.cursor_ + 2],
    o = this.bytes_[this.cursor_ + 3];
  return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), e << 0 | t << 8 | r << 16 | o << 24;
}, jspb.BinaryDecoder.prototype.readInt64 = function () {
  var e = this.readUint32(),
    t = this.readUint32();
  return jspb.utils.joinInt64(e, t);
}, jspb.BinaryDecoder.prototype.readInt64String = function () {
  var e = this.readUint32(),
    t = this.readUint32();
  return jspb.utils.joinSignedDecimalString(e, t);
}, jspb.BinaryDecoder.prototype.readFloat = function () {
  var e = this.readUint32();
  return jspb.utils.joinFloat32(e, 0);
}, jspb.BinaryDecoder.prototype.readDouble = function () {
  var e = this.readUint32(),
    t = this.readUint32();
  return jspb.utils.joinFloat64(e, t);
}, jspb.BinaryDecoder.prototype.readBool = function () {
  return !!this.bytes_[this.cursor_++];
}, jspb.BinaryDecoder.prototype.readEnum = function () {
  return this.readSignedVarint32();
}, jspb.BinaryDecoder.prototype.readString = function (e) {
  var t = this.bytes_,
    r = this.cursor_;
  e = r + e;
  for (var o = [], n = ""; r < e;) {
    var a = t[r++];
    if (128 > a) o.push(a);else {
      if (192 > a) continue;
      if (224 > a) {
        var i = t[r++];
        o.push((31 & a) << 6 | 63 & i);
      } else if (240 > a) {
        i = t[r++];
        var s = t[r++];
        o.push((15 & a) << 12 | (63 & i) << 6 | 63 & s);
      } else if (248 > a) {
        a = (7 & a) << 18 | (63 & (i = t[r++])) << 12 | (63 & (s = t[r++])) << 6 | 63 & t[r++], a -= 65536, o.push(55296 + (a >> 10 & 1023), 56320 + (1023 & a));
      }
    }
    8192 <= o.length && (n += String.fromCharCode.apply(null, o), o.length = 0);
  }
  return n += goog.crypt.byteArrayToString(o), this.cursor_ = r, n;
}, jspb.BinaryDecoder.prototype.readStringWithLength = function () {
  var e = this.readUnsignedVarint32();
  return this.readString(e);
}, jspb.BinaryDecoder.prototype.readBytes = function (e) {
  if (0 > e || this.cursor_ + e > this.bytes_.length) return this.error_ = !0, goog.asserts.fail("Invalid byte length!"), new Uint8Array(0);
  var t = this.bytes_.subarray(this.cursor_, this.cursor_ + e);
  return this.cursor_ += e, goog.asserts.assert(this.cursor_ <= this.end_), t;
}, jspb.BinaryDecoder.prototype.readVarintHash64 = function () {
  return this.readSplitVarint64(jspb.utils.joinHash64);
}, jspb.BinaryDecoder.prototype.readFixedHash64 = function () {
  var e = this.bytes_,
    t = this.cursor_,
    r = e[t + 0],
    o = e[t + 1],
    n = e[t + 2],
    a = e[t + 3],
    i = e[t + 4],
    s = e[t + 5],
    u = e[t + 6];
  return e = e[t + 7], this.cursor_ += 8, String.fromCharCode(r, o, n, a, i, s, u, e);
}, jspb.BinaryReader = function (e, t, r) {
  this.decoder_ = jspb.BinaryDecoder.alloc(e, t, r), this.fieldCursor_ = this.decoder_.getCursor(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null;
}, jspb.BinaryReader.instanceCache_ = [], jspb.BinaryReader.alloc = function (e, t, r) {
  if (jspb.BinaryReader.instanceCache_.length) {
    var o = jspb.BinaryReader.instanceCache_.pop();
    return e && o.decoder_.setBlock(e, t, r), o;
  }
  return new jspb.BinaryReader(e, t, r);
}, jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc, jspb.BinaryReader.prototype.free = function () {
  this.decoder_.clear(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null, 100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
}, jspb.BinaryReader.prototype.getFieldCursor = function () {
  return this.fieldCursor_;
}, jspb.BinaryReader.prototype.getCursor = function () {
  return this.decoder_.getCursor();
}, jspb.BinaryReader.prototype.getBuffer = function () {
  return this.decoder_.getBuffer();
}, jspb.BinaryReader.prototype.getFieldNumber = function () {
  return this.nextField_;
}, jspb.BinaryReader.prototype.getWireType = function () {
  return this.nextWireType_;
}, jspb.BinaryReader.prototype.isDelimited = function () {
  return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
}, jspb.BinaryReader.prototype.isEndGroup = function () {
  return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
}, jspb.BinaryReader.prototype.getError = function () {
  return this.error_ || this.decoder_.getError();
}, jspb.BinaryReader.prototype.setBlock = function (e, t, r) {
  this.decoder_.setBlock(e, t, r), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
}, jspb.BinaryReader.prototype.reset = function () {
  this.decoder_.reset(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
}, jspb.BinaryReader.prototype.advance = function (e) {
  this.decoder_.advance(e);
}, jspb.BinaryReader.prototype.nextField = function () {
  if (this.decoder_.atEnd()) return !1;
  if (this.getError()) return goog.asserts.fail("Decoder hit an error"), !1;
  this.fieldCursor_ = this.decoder_.getCursor();
  var e = this.decoder_.readUnsignedVarint32(),
    t = e >>> 3;
  return (e &= 7) != jspb.BinaryConstants.WireType.VARINT && e != jspb.BinaryConstants.WireType.FIXED32 && e != jspb.BinaryConstants.WireType.FIXED64 && e != jspb.BinaryConstants.WireType.DELIMITED && e != jspb.BinaryConstants.WireType.START_GROUP && e != jspb.BinaryConstants.WireType.END_GROUP ? (goog.asserts.fail("Invalid wire type: %s (at position %s)", e, this.fieldCursor_), this.error_ = !0, !1) : (this.nextField_ = t, this.nextWireType_ = e, !0);
}, jspb.BinaryReader.prototype.unskipHeader = function () {
  this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
}, jspb.BinaryReader.prototype.skipMatchingFields = function () {
  var e = this.nextField_;
  for (this.unskipHeader(); this.nextField() && this.getFieldNumber() == e;) this.skipField();
  this.decoder_.atEnd() || this.unskipHeader();
}, jspb.BinaryReader.prototype.skipVarintField = function () {
  this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (goog.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
}, jspb.BinaryReader.prototype.skipDelimitedField = function () {
  if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED) goog.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();else {
    var e = this.decoder_.readUnsignedVarint32();
    this.decoder_.advance(e);
  }
}, jspb.BinaryReader.prototype.skipFixed32Field = function () {
  this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (goog.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
}, jspb.BinaryReader.prototype.skipFixed64Field = function () {
  this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (goog.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
}, jspb.BinaryReader.prototype.skipGroup = function () {
  for (var e = this.nextField_;;) {
    if (!this.nextField()) {
      goog.asserts.fail("Unmatched start-group tag: stream EOF"), this.error_ = !0;
      break;
    }
    if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
      this.nextField_ != e && (goog.asserts.fail("Unmatched end-group tag"), this.error_ = !0);
      break;
    }
    this.skipField();
  }
}, jspb.BinaryReader.prototype.skipField = function () {
  switch (this.nextWireType_) {
    case jspb.BinaryConstants.WireType.VARINT:
      this.skipVarintField();
      break;
    case jspb.BinaryConstants.WireType.FIXED64:
      this.skipFixed64Field();
      break;
    case jspb.BinaryConstants.WireType.DELIMITED:
      this.skipDelimitedField();
      break;
    case jspb.BinaryConstants.WireType.FIXED32:
      this.skipFixed32Field();
      break;
    case jspb.BinaryConstants.WireType.START_GROUP:
      this.skipGroup();
      break;
    default:
      goog.asserts.fail("Invalid wire encoding for field.");
  }
}, jspb.BinaryReader.prototype.registerReadCallback = function (e, t) {
  null === this.readCallbacks_ && (this.readCallbacks_ = {}), goog.asserts.assert(!this.readCallbacks_[e]), this.readCallbacks_[e] = t;
}, jspb.BinaryReader.prototype.runReadCallback = function (e) {
  return goog.asserts.assert(null !== this.readCallbacks_), e = this.readCallbacks_[e], goog.asserts.assert(e), e(this);
}, jspb.BinaryReader.prototype.readAny = function (e) {
  this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(e);
  var t = jspb.BinaryConstants.FieldType;
  switch (e) {
    case t.DOUBLE:
      return this.readDouble();
    case t.FLOAT:
      return this.readFloat();
    case t.INT64:
      return this.readInt64();
    case t.UINT64:
      return this.readUint64();
    case t.INT32:
      return this.readInt32();
    case t.FIXED64:
      return this.readFixed64();
    case t.FIXED32:
      return this.readFixed32();
    case t.BOOL:
      return this.readBool();
    case t.STRING:
      return this.readString();
    case t.GROUP:
      goog.asserts.fail("Group field type not supported in readAny()");
    case t.MESSAGE:
      goog.asserts.fail("Message field type not supported in readAny()");
    case t.BYTES:
      return this.readBytes();
    case t.UINT32:
      return this.readUint32();
    case t.ENUM:
      return this.readEnum();
    case t.SFIXED32:
      return this.readSfixed32();
    case t.SFIXED64:
      return this.readSfixed64();
    case t.SINT32:
      return this.readSint32();
    case t.SINT64:
      return this.readSint64();
    case t.FHASH64:
      return this.readFixedHash64();
    case t.VHASH64:
      return this.readVarintHash64();
    default:
      goog.asserts.fail("Invalid field type in readAny()");
  }
  return 0;
}, jspb.BinaryReader.prototype.readMessage = function (e, t) {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var r = this.decoder_.getEnd(),
    o = this.decoder_.readUnsignedVarint32();
  o = this.decoder_.getCursor() + o, this.decoder_.setEnd(o), t(e, this), this.decoder_.setCursor(o), this.decoder_.setEnd(r);
}, jspb.BinaryReader.prototype.readGroup = function (e, t, r) {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP), goog.asserts.assert(this.nextField_ == e), r(t, this), this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (goog.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = !0);
}, jspb.BinaryReader.prototype.getFieldDecoder = function () {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var e = this.decoder_.readUnsignedVarint32(),
    t = this.decoder_.getCursor(),
    r = t + e;
  return e = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), t, e), this.decoder_.setCursor(r), e;
}, jspb.BinaryReader.prototype.readInt32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32();
}, jspb.BinaryReader.prototype.readInt32String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32String();
}, jspb.BinaryReader.prototype.readInt64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
}, jspb.BinaryReader.prototype.readInt64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64String();
}, jspb.BinaryReader.prototype.readUint32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32();
}, jspb.BinaryReader.prototype.readUint32String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32String();
}, jspb.BinaryReader.prototype.readUint64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64();
}, jspb.BinaryReader.prototype.readUint64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64String();
}, jspb.BinaryReader.prototype.readSint32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint32();
}, jspb.BinaryReader.prototype.readSint64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64();
}, jspb.BinaryReader.prototype.readSint64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64String();
}, jspb.BinaryReader.prototype.readFixed32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readUint32();
}, jspb.BinaryReader.prototype.readFixed64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64();
}, jspb.BinaryReader.prototype.readFixed64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64String();
}, jspb.BinaryReader.prototype.readSfixed32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32();
}, jspb.BinaryReader.prototype.readSfixed32String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32().toString();
}, jspb.BinaryReader.prototype.readSfixed64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64();
}, jspb.BinaryReader.prototype.readSfixed64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64String();
}, jspb.BinaryReader.prototype.readFloat = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readFloat();
}, jspb.BinaryReader.prototype.readDouble = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readDouble();
}, jspb.BinaryReader.prototype.readBool = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), !!this.decoder_.readUnsignedVarint32();
}, jspb.BinaryReader.prototype.readEnum = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
}, jspb.BinaryReader.prototype.readString = function () {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var e = this.decoder_.readUnsignedVarint32();
  return this.decoder_.readString(e);
}, jspb.BinaryReader.prototype.readBytes = function () {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var e = this.decoder_.readUnsignedVarint32();
  return this.decoder_.readBytes(e);
}, jspb.BinaryReader.prototype.readVarintHash64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readVarintHash64();
}, jspb.BinaryReader.prototype.readSintHash64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarintHash64();
}, jspb.BinaryReader.prototype.readSplitVarint64 = function (e) {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(e);
}, jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function (e) {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(function (t, r) {
    return jspb.utils.fromZigzag64(t, r, e);
  });
}, jspb.BinaryReader.prototype.readFixedHash64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readFixedHash64();
}, jspb.BinaryReader.prototype.readSplitFixed64 = function (e) {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readSplitFixed64(e);
}, jspb.BinaryReader.prototype.readPackedField_ = function (e) {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var t = this.decoder_.readUnsignedVarint32();
  t = this.decoder_.getCursor() + t;
  for (var r = []; this.decoder_.getCursor() < t;) r.push(e.call(this.decoder_));
  return r;
}, jspb.BinaryReader.prototype.readPackedInt32 = function () {
  return this.readPackedField_(this.decoder_.readSignedVarint32);
}, jspb.BinaryReader.prototype.readPackedInt32String = function () {
  return this.readPackedField_(this.decoder_.readSignedVarint32String);
}, jspb.BinaryReader.prototype.readPackedInt64 = function () {
  return this.readPackedField_(this.decoder_.readSignedVarint64);
}, jspb.BinaryReader.prototype.readPackedInt64String = function () {
  return this.readPackedField_(this.decoder_.readSignedVarint64String);
}, jspb.BinaryReader.prototype.readPackedUint32 = function () {
  return this.readPackedField_(this.decoder_.readUnsignedVarint32);
}, jspb.BinaryReader.prototype.readPackedUint32String = function () {
  return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
}, jspb.BinaryReader.prototype.readPackedUint64 = function () {
  return this.readPackedField_(this.decoder_.readUnsignedVarint64);
}, jspb.BinaryReader.prototype.readPackedUint64String = function () {
  return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
}, jspb.BinaryReader.prototype.readPackedSint32 = function () {
  return this.readPackedField_(this.decoder_.readZigzagVarint32);
}, jspb.BinaryReader.prototype.readPackedSint64 = function () {
  return this.readPackedField_(this.decoder_.readZigzagVarint64);
}, jspb.BinaryReader.prototype.readPackedSint64String = function () {
  return this.readPackedField_(this.decoder_.readZigzagVarint64String);
}, jspb.BinaryReader.prototype.readPackedFixed32 = function () {
  return this.readPackedField_(this.decoder_.readUint32);
}, jspb.BinaryReader.prototype.readPackedFixed64 = function () {
  return this.readPackedField_(this.decoder_.readUint64);
}, jspb.BinaryReader.prototype.readPackedFixed64String = function () {
  return this.readPackedField_(this.decoder_.readUint64String);
}, jspb.BinaryReader.prototype.readPackedSfixed32 = function () {
  return this.readPackedField_(this.decoder_.readInt32);
}, jspb.BinaryReader.prototype.readPackedSfixed64 = function () {
  return this.readPackedField_(this.decoder_.readInt64);
}, jspb.BinaryReader.prototype.readPackedSfixed64String = function () {
  return this.readPackedField_(this.decoder_.readInt64String);
}, jspb.BinaryReader.prototype.readPackedFloat = function () {
  return this.readPackedField_(this.decoder_.readFloat);
}, jspb.BinaryReader.prototype.readPackedDouble = function () {
  return this.readPackedField_(this.decoder_.readDouble);
}, jspb.BinaryReader.prototype.readPackedBool = function () {
  return this.readPackedField_(this.decoder_.readBool);
}, jspb.BinaryReader.prototype.readPackedEnum = function () {
  return this.readPackedField_(this.decoder_.readEnum);
}, jspb.BinaryReader.prototype.readPackedVarintHash64 = function () {
  return this.readPackedField_(this.decoder_.readVarintHash64);
}, jspb.BinaryReader.prototype.readPackedFixedHash64 = function () {
  return this.readPackedField_(this.decoder_.readFixedHash64);
}, jspb.Map = function (e, t) {
  this.arr_ = e, this.valueCtor_ = t, this.map_ = {}, this.arrClean = !0, 0 < this.arr_.length && this.loadFromArray_();
}, jspb.Map.prototype.loadFromArray_ = function () {
  for (var e = 0; e < this.arr_.length; e++) {
    var t = this.arr_[e],
      r = t[0];
    this.map_[r.toString()] = new jspb.Map.Entry_(r, t[1]);
  }
  this.arrClean = !0;
}, jspb.Map.prototype.toArray = function () {
  if (this.arrClean) {
    if (this.valueCtor_) {
      var e,
        t = this.map_;
      for (e in t) if (Object.prototype.hasOwnProperty.call(t, e)) {
        var r = t[e].valueWrapper;
        r && r.toArray();
      }
    }
  } else {
    for (this.arr_.length = 0, (t = this.stringKeys_()).sort(), e = 0; e < t.length; e++) {
      var o = this.map_[t[e]];
      (r = o.valueWrapper) && r.toArray(), this.arr_.push([o.key, o.value]);
    }
    this.arrClean = !0;
  }
  return this.arr_;
}, jspb.Map.prototype.toObject = function (e, t) {
  for (var r = this.toArray(), o = [], n = 0; n < r.length; n++) {
    var a = this.map_[r[n][0].toString()];
    this.wrapEntry_(a);
    var i = a.valueWrapper;
    i ? (goog.asserts.assert(t), o.push([a.key, t(e, i)])) : o.push([a.key, a.value]);
  }
  return o;
}, jspb.Map.fromObject = function (e, t, r) {
  t = new jspb.Map([], t);
  for (var o = 0; o < e.length; o++) {
    var n = e[o][0],
      a = r(e[o][1]);
    t.set(n, a);
  }
  return t;
}, jspb.Map.ArrayIteratorIterable_ = function (e) {
  this.idx_ = 0, this.arr_ = e;
}, jspb.Map.ArrayIteratorIterable_.prototype.next = function () {
  return this.idx_ < this.arr_.length ? {
    done: !1,
    value: this.arr_[this.idx_++]
  } : {
    done: !0,
    value: void 0
  };
}, "undefined" != typeof Symbol && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function () {
  return this;
}), jspb.Map.prototype.getLength = function () {
  return this.stringKeys_().length;
}, jspb.Map.prototype.clear = function () {
  this.map_ = {}, this.arrClean = !1;
}, jspb.Map.prototype.del = function (e) {
  e = e.toString();
  var t = this.map_.hasOwnProperty(e);
  return delete this.map_[e], this.arrClean = !1, t;
}, jspb.Map.prototype.getEntryList = function () {
  var e = [],
    t = this.stringKeys_();
  t.sort();
  for (var r = 0; r < t.length; r++) {
    var o = this.map_[t[r]];
    e.push([o.key, o.value]);
  }
  return e;
}, jspb.Map.prototype.entries = function () {
  var e = [],
    t = this.stringKeys_();
  t.sort();
  for (var r = 0; r < t.length; r++) {
    var o = this.map_[t[r]];
    e.push([o.key, this.wrapEntry_(o)]);
  }
  return new jspb.Map.ArrayIteratorIterable_(e);
}, jspb.Map.prototype.keys = function () {
  var e = [],
    t = this.stringKeys_();
  t.sort();
  for (var r = 0; r < t.length; r++) e.push(this.map_[t[r]].key);
  return new jspb.Map.ArrayIteratorIterable_(e);
}, jspb.Map.prototype.values = function () {
  var e = [],
    t = this.stringKeys_();
  t.sort();
  for (var r = 0; r < t.length; r++) e.push(this.wrapEntry_(this.map_[t[r]]));
  return new jspb.Map.ArrayIteratorIterable_(e);
}, jspb.Map.prototype.forEach = function (e, t) {
  var r = this.stringKeys_();
  r.sort();
  for (var o = 0; o < r.length; o++) {
    var n = this.map_[r[o]];
    e.call(t, this.wrapEntry_(n), n.key, this);
  }
}, jspb.Map.prototype.set = function (e, t) {
  var r = new jspb.Map.Entry_(e);
  return this.valueCtor_ ? (r.valueWrapper = t, r.value = t.toArray()) : r.value = t, this.map_[e.toString()] = r, this.arrClean = !1, this;
}, jspb.Map.prototype.wrapEntry_ = function (e) {
  return this.valueCtor_ ? (e.valueWrapper || (e.valueWrapper = new this.valueCtor_(e.value)), e.valueWrapper) : e.value;
}, jspb.Map.prototype.get = function (e) {
  if (e = this.map_[e.toString()]) return this.wrapEntry_(e);
}, jspb.Map.prototype.has = function (e) {
  return e.toString() in this.map_;
}, jspb.Map.prototype.serializeBinary = function (e, t, r, o, n) {
  var a = this.stringKeys_();
  a.sort();
  for (var i = 0; i < a.length; i++) {
    var s = this.map_[a[i]];
    t.beginSubMessage(e), r.call(t, 1, s.key), this.valueCtor_ ? o.call(t, 2, this.wrapEntry_(s), n) : o.call(t, 2, s.value), t.endSubMessage();
  }
}, jspb.Map.deserializeBinary = function (e, t, r, o, n, a, i) {
  for (; t.nextField() && !t.isEndGroup();) {
    var s = t.getFieldNumber();
    1 == s ? a = r.call(t) : 2 == s && (e.valueCtor_ ? (goog.asserts.assert(n), i || (i = new e.valueCtor_()), o.call(t, i, n)) : i = o.call(t));
  }
  goog.asserts.assert(null != a), goog.asserts.assert(null != i), e.set(a, i);
}, jspb.Map.prototype.stringKeys_ = function () {
  var e,
    t = this.map_,
    r = [];
  for (e in t) Object.prototype.hasOwnProperty.call(t, e) && r.push(e);
  return r;
}, jspb.Map.Entry_ = function (e, t) {
  this.key = e, this.value = t, this.valueWrapper = void 0;
}, jspb.ExtensionFieldInfo = function (e, t, r, o, n) {
  this.fieldIndex = e, this.fieldName = t, this.ctor = r, this.toObjectFn = o, this.isRepeated = n;
}, jspb.ExtensionFieldBinaryInfo = function (e, t, r, o, n, a) {
  this.fieldInfo = e, this.binaryReaderFn = t, this.binaryWriterFn = r, this.binaryMessageSerializeFn = o, this.binaryMessageDeserializeFn = n, this.isPacked = a;
}, jspb.ExtensionFieldInfo.prototype.isMessageType = function () {
  return !!this.ctor;
}, jspb.Message = function () {}, jspb.Message.GENERATE_TO_OBJECT = !0, jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE, jspb.Message.GENERATE_TO_STRING = !0, jspb.Message.ASSUME_LOCAL_ARRAYS = !1, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = !0, jspb.Message.SUPPORTS_UINT8ARRAY_ = "function" == typeof Uint8Array, jspb.Message.prototype.getJsPbMessageId = function () {
  return this.messageId_;
}, jspb.Message.getIndex_ = function (e, t) {
  return t + e.arrayIndexOffset_;
}, jspb.Message.hiddenES6Property_ = function () {}, jspb.Message.getFieldNumber_ = function (e, t) {
  return t - e.arrayIndexOffset_;
}, jspb.Message.initialize = function (e, t, r, o, n, a) {
  if (e.wrappers_ = null, t || (t = r ? [r] : []), e.messageId_ = r ? String(r) : void 0, e.arrayIndexOffset_ = 0 === r ? -1 : 0, e.array = t, jspb.Message.initPivotAndExtensionObject_(e, o), e.convertedPrimitiveFields_ = {}, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (e.repeatedFields = n), n) for (t = 0; t < n.length; t++) (r = n[t]) < e.pivot_ ? (r = jspb.Message.getIndex_(e, r), e.array[r] = e.array[r] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(e), e.extensionObject_[r] = e.extensionObject_[r] || jspb.Message.EMPTY_LIST_SENTINEL_);
  if (a && a.length) for (t = 0; t < a.length; t++) jspb.Message.computeOneofCase(e, a[t]);
}, jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [], jspb.Message.isArray_ = function (e) {
  return jspb.Message.ASSUME_LOCAL_ARRAYS ? e instanceof Array : Array.isArray(e);
}, jspb.Message.isExtensionObject_ = function (e) {
  return !(null === e || "object" != typeof e || jspb.Message.isArray_(e) || jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array);
}, jspb.Message.initPivotAndExtensionObject_ = function (e, t) {
  var r = e.array.length,
    o = -1;
  if (r && (o = r - 1, r = e.array[o], jspb.Message.isExtensionObject_(r))) return e.pivot_ = jspb.Message.getFieldNumber_(e, o), void (e.extensionObject_ = r);
  -1 < t ? (e.pivot_ = Math.max(t, jspb.Message.getFieldNumber_(e, o + 1)), e.extensionObject_ = null) : e.pivot_ = Number.MAX_VALUE;
}, jspb.Message.maybeInitEmptyExtensionObject_ = function (e) {
  var t = jspb.Message.getIndex_(e, e.pivot_);
  e.array[t] || (e.extensionObject_ = e.array[t] = {});
}, jspb.Message.toObjectList = function (e, t, r) {
  for (var o = [], n = 0; n < e.length; n++) o[n] = t.call(e[n], r, e[n]);
  return o;
}, jspb.Message.toObjectExtension = function (e, t, r, o, n) {
  for (var a in r) {
    var i = r[a],
      s = o.call(e, i);
    if (null != s) {
      for (var u in i.fieldName) if (i.fieldName.hasOwnProperty(u)) break;
      t[u] = i.toObjectFn ? i.isRepeated ? jspb.Message.toObjectList(s, i.toObjectFn, n) : i.toObjectFn(n, s) : s;
    }
  }
}, jspb.Message.serializeBinaryExtensions = function (e, t, r, o) {
  for (var n in r) {
    var a = r[n],
      i = a.fieldInfo;
    if (!a.binaryWriterFn) throw Error("Message extension present that was generated without binary serialization support");
    var s = o.call(e, i);
    if (null != s) if (i.isMessageType()) {
      if (!a.binaryMessageSerializeFn) throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
      a.binaryWriterFn.call(t, i.fieldIndex, s, a.binaryMessageSerializeFn);
    } else a.binaryWriterFn.call(t, i.fieldIndex, s);
  }
}, jspb.Message.readBinaryExtension = function (e, t, r, o, n) {
  var a = r[t.getFieldNumber()];
  if (a) {
    if (r = a.fieldInfo, !a.binaryReaderFn) throw Error("Deserializing extension whose generated code does not support binary format");
    if (r.isMessageType()) {
      var i = new r.ctor();
      a.binaryReaderFn.call(t, i, a.binaryMessageDeserializeFn);
    } else i = a.binaryReaderFn.call(t);
    r.isRepeated && !a.isPacked ? (t = o.call(e, r)) ? t.push(i) : n.call(e, r, [i]) : n.call(e, r, i);
  } else t.skipField();
}, jspb.Message.getField = function (e, t) {
  if (t < e.pivot_) {
    t = jspb.Message.getIndex_(e, t);
    var r = e.array[t];
    return r === jspb.Message.EMPTY_LIST_SENTINEL_ ? e.array[t] = [] : r;
  }
  if (e.extensionObject_) return (r = e.extensionObject_[t]) === jspb.Message.EMPTY_LIST_SENTINEL_ ? e.extensionObject_[t] = [] : r;
}, jspb.Message.getRepeatedField = function (e, t) {
  return jspb.Message.getField(e, t);
}, jspb.Message.getOptionalFloatingPointField = function (e, t) {
  return null == (e = jspb.Message.getField(e, t)) ? e : +e;
}, jspb.Message.getBooleanField = function (e, t) {
  return null == (e = jspb.Message.getField(e, t)) ? e : !!e;
}, jspb.Message.getRepeatedFloatingPointField = function (e, t) {
  var r = jspb.Message.getRepeatedField(e, t);
  if (e.convertedPrimitiveFields_ || (e.convertedPrimitiveFields_ = {}), !e.convertedPrimitiveFields_[t]) {
    for (var o = 0; o < r.length; o++) r[o] = +r[o];
    e.convertedPrimitiveFields_[t] = !0;
  }
  return r;
}, jspb.Message.getRepeatedBooleanField = function (e, t) {
  var r = jspb.Message.getRepeatedField(e, t);
  if (e.convertedPrimitiveFields_ || (e.convertedPrimitiveFields_ = {}), !e.convertedPrimitiveFields_[t]) {
    for (var o = 0; o < r.length; o++) r[o] = !!r[o];
    e.convertedPrimitiveFields_[t] = !0;
  }
  return r;
}, jspb.Message.bytesAsB64 = function (e) {
  return null == e || "string" == typeof e ? e : jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array ? goog.crypt.base64.encodeByteArray(e) : (goog.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(e)), null);
}, jspb.Message.bytesAsU8 = function (e) {
  return null == e || e instanceof Uint8Array ? e : "string" == typeof e ? goog.crypt.base64.decodeStringToUint8Array(e) : (goog.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(e)), null);
}, jspb.Message.bytesListAsB64 = function (e) {
  return jspb.Message.assertConsistentTypes_(e), e.length && "string" != typeof e[0] ? goog.array.map(e, jspb.Message.bytesAsB64) : e;
}, jspb.Message.bytesListAsU8 = function (e) {
  return jspb.Message.assertConsistentTypes_(e), !e.length || e[0] instanceof Uint8Array ? e : goog.array.map(e, jspb.Message.bytesAsU8);
}, jspb.Message.assertConsistentTypes_ = function (e) {
  if (goog.DEBUG && e && 1 < e.length) {
    var t = goog.typeOf(e[0]);
    goog.array.forEach(e, function (e) {
      goog.typeOf(e) != t && goog.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(e) + " expected " + t);
    });
  }
}, jspb.Message.getFieldWithDefault = function (e, t, r) {
  return null == (e = jspb.Message.getField(e, t)) ? r : e;
}, jspb.Message.getBooleanFieldWithDefault = function (e, t, r) {
  return null == (e = jspb.Message.getBooleanField(e, t)) ? r : e;
}, jspb.Message.getFloatingPointFieldWithDefault = function (e, t, r) {
  return null == (e = jspb.Message.getOptionalFloatingPointField(e, t)) ? r : e;
}, jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault, jspb.Message.getMapField = function (e, t, r, o) {
  if (e.wrappers_ || (e.wrappers_ = {}), t in e.wrappers_) return e.wrappers_[t];
  var n = jspb.Message.getField(e, t);
  if (!n) {
    if (r) return;
    n = [], jspb.Message.setField(e, t, n);
  }
  return e.wrappers_[t] = new jspb.Map(n, o);
}, jspb.Message.setField = function (e, t, r) {
  return goog.asserts.assertInstanceof(e, jspb.Message), t < e.pivot_ ? e.array[jspb.Message.getIndex_(e, t)] = r : (jspb.Message.maybeInitEmptyExtensionObject_(e), e.extensionObject_[t] = r), e;
}, jspb.Message.setProto3IntField = function (e, t, r) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, r, 0);
}, jspb.Message.setProto3FloatField = function (e, t, r) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, r, 0);
}, jspb.Message.setProto3BooleanField = function (e, t, r) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, r, !1);
}, jspb.Message.setProto3StringField = function (e, t, r) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, r, "");
}, jspb.Message.setProto3BytesField = function (e, t, r) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, r, "");
}, jspb.Message.setProto3EnumField = function (e, t, r) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, r, 0);
}, jspb.Message.setProto3StringIntField = function (e, t, r) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, r, "0");
}, jspb.Message.setFieldIgnoringDefault_ = function (e, t, r, o) {
  return goog.asserts.assertInstanceof(e, jspb.Message), r !== o ? jspb.Message.setField(e, t, r) : t < e.pivot_ ? e.array[jspb.Message.getIndex_(e, t)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(e), delete e.extensionObject_[t]), e;
}, jspb.Message.addToRepeatedField = function (e, t, r, o) {
  return goog.asserts.assertInstanceof(e, jspb.Message), t = jspb.Message.getRepeatedField(e, t), null != o ? t.splice(o, 0, r) : t.push(r), e;
}, jspb.Message.setOneofField = function (e, t, r, o) {
  return goog.asserts.assertInstanceof(e, jspb.Message), (r = jspb.Message.computeOneofCase(e, r)) && r !== t && void 0 !== o && (e.wrappers_ && r in e.wrappers_ && (e.wrappers_[r] = void 0), jspb.Message.setField(e, r, void 0)), jspb.Message.setField(e, t, o);
}, jspb.Message.computeOneofCase = function (e, t) {
  for (var r, o, n = 0; n < t.length; n++) {
    var a = t[n],
      i = jspb.Message.getField(e, a);
    null != i && (r = a, o = i, jspb.Message.setField(e, a, void 0));
  }
  return r ? (jspb.Message.setField(e, r, o), r) : 0;
}, jspb.Message.getWrapperField = function (e, t, r, o) {
  if (e.wrappers_ || (e.wrappers_ = {}), !e.wrappers_[r]) {
    var n = jspb.Message.getField(e, r);
    (o || n) && (e.wrappers_[r] = new t(n));
  }
  return e.wrappers_[r];
}, jspb.Message.getRepeatedWrapperField = function (e, t, r) {
  return jspb.Message.wrapRepeatedField_(e, t, r), (t = e.wrappers_[r]) == jspb.Message.EMPTY_LIST_SENTINEL_ && (t = e.wrappers_[r] = []), t;
}, jspb.Message.wrapRepeatedField_ = function (e, t, r) {
  if (e.wrappers_ || (e.wrappers_ = {}), !e.wrappers_[r]) {
    for (var o = jspb.Message.getRepeatedField(e, r), n = [], a = 0; a < o.length; a++) n[a] = new t(o[a]);
    e.wrappers_[r] = n;
  }
}, jspb.Message.setWrapperField = function (e, t, r) {
  goog.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {});
  var o = r ? r.toArray() : r;
  return e.wrappers_[t] = r, jspb.Message.setField(e, t, o);
}, jspb.Message.setOneofWrapperField = function (e, t, r, o) {
  goog.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {});
  var n = o ? o.toArray() : o;
  return e.wrappers_[t] = o, jspb.Message.setOneofField(e, t, r, n);
}, jspb.Message.setRepeatedWrapperField = function (e, t, r) {
  goog.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {}), r = r || [];
  for (var o = [], n = 0; n < r.length; n++) o[n] = r[n].toArray();
  return e.wrappers_[t] = r, jspb.Message.setField(e, t, o);
}, jspb.Message.addToRepeatedWrapperField = function (e, t, r, o, n) {
  jspb.Message.wrapRepeatedField_(e, o, t);
  var a = e.wrappers_[t];
  return a || (a = e.wrappers_[t] = []), r = r || new o(), e = jspb.Message.getRepeatedField(e, t), null != n ? (a.splice(n, 0, r), e.splice(n, 0, r.toArray())) : (a.push(r), e.push(r.toArray())), r;
}, jspb.Message.toMap = function (e, t, r, o) {
  for (var n = {}, a = 0; a < e.length; a++) n[t.call(e[a])] = r ? r.call(e[a], o, e[a]) : e[a];
  return n;
}, jspb.Message.prototype.syncMapFields_ = function () {
  if (this.wrappers_) for (var e in this.wrappers_) {
    var t = this.wrappers_[e];
    if (Array.isArray(t)) for (var r = 0; r < t.length; r++) t[r] && t[r].toArray();else t && t.toArray();
  }
}, jspb.Message.prototype.toArray = function () {
  return this.syncMapFields_(), this.array;
}, jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function () {
  return this.syncMapFields_(), this.array.toString();
}), jspb.Message.prototype.getExtension = function (e) {
  if (this.extensionObject_) {
    this.wrappers_ || (this.wrappers_ = {});
    var t = e.fieldIndex;
    if (e.isRepeated) {
      if (e.isMessageType()) return this.wrappers_[t] || (this.wrappers_[t] = goog.array.map(this.extensionObject_[t] || [], function (t) {
        return new e.ctor(t);
      })), this.wrappers_[t];
    } else if (e.isMessageType()) return !this.wrappers_[t] && this.extensionObject_[t] && (this.wrappers_[t] = new e.ctor(this.extensionObject_[t])), this.wrappers_[t];
    return this.extensionObject_[t];
  }
}, jspb.Message.prototype.setExtension = function (e, t) {
  this.wrappers_ || (this.wrappers_ = {}), jspb.Message.maybeInitEmptyExtensionObject_(this);
  var r = e.fieldIndex;
  return e.isRepeated ? (t = t || [], e.isMessageType() ? (this.wrappers_[r] = t, this.extensionObject_[r] = goog.array.map(t, function (e) {
    return e.toArray();
  })) : this.extensionObject_[r] = t) : e.isMessageType() ? (this.wrappers_[r] = t, this.extensionObject_[r] = t ? t.toArray() : t) : this.extensionObject_[r] = t, this;
}, jspb.Message.difference = function (e, t) {
  if (!(e instanceof t.constructor)) throw Error("Messages have different types.");
  var r = e.toArray();
  t = t.toArray();
  var o = [],
    n = 0,
    a = r.length > t.length ? r.length : t.length;
  for (e.getJsPbMessageId() && (o[0] = e.getJsPbMessageId(), n = 1); n < a; n++) jspb.Message.compareFields(r[n], t[n]) || (o[n] = t[n]);
  return new e.constructor(o);
}, jspb.Message.equals = function (e, t) {
  return e == t || !(!e || !t) && e instanceof t.constructor && jspb.Message.compareFields(e.toArray(), t.toArray());
}, jspb.Message.compareExtensions = function (e, t) {
  e = e || {}, t = t || {};
  var r,
    o = {};
  for (r in e) o[r] = 0;
  for (r in t) o[r] = 0;
  for (r in o) if (!jspb.Message.compareFields(e[r], t[r])) return !1;
  return !0;
}, jspb.Message.compareFields = function (e, t) {
  if (e == t) return !0;
  if (!goog.isObject(e) || !goog.isObject(t)) return !!("number" == typeof e && isNaN(e) || "number" == typeof t && isNaN(t)) && String(e) == String(t);
  if (e.constructor != t.constructor) return !1;
  if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e.constructor === Uint8Array) {
    if (e.length != t.length) return !1;
    for (var r = 0; r < e.length; r++) if (e[r] != t[r]) return !1;
    return !0;
  }
  if (e.constructor === Array) {
    var o = void 0,
      n = void 0,
      a = Math.max(e.length, t.length);
    for (r = 0; r < a; r++) {
      var i = e[r],
        s = t[r];
      if (i && i.constructor == Object && (goog.asserts.assert(void 0 === o), goog.asserts.assert(r === e.length - 1), o = i, i = void 0), s && s.constructor == Object && (goog.asserts.assert(void 0 === n), goog.asserts.assert(r === t.length - 1), n = s, s = void 0), !jspb.Message.compareFields(i, s)) return !1;
    }
    return !o && !n || (o = o || {}, n = n || {}, jspb.Message.compareExtensions(o, n));
  }
  if (e.constructor === Object) return jspb.Message.compareExtensions(e, t);
  throw Error("Invalid type in JSPB array");
}, jspb.Message.prototype.cloneMessage = function () {
  return jspb.Message.cloneMessage(this);
}, jspb.Message.prototype.clone = function () {
  return jspb.Message.cloneMessage(this);
}, jspb.Message.clone = function (e) {
  return jspb.Message.cloneMessage(e);
}, jspb.Message.cloneMessage = function (e) {
  return new e.constructor(jspb.Message.clone_(e.toArray()));
}, jspb.Message.copyInto = function (e, t) {
  goog.asserts.assertInstanceof(e, jspb.Message), goog.asserts.assertInstanceof(t, jspb.Message), goog.asserts.assert(e.constructor == t.constructor, "Copy source and target message should have the same type."), e = jspb.Message.clone(e);
  for (var r = t.toArray(), o = e.toArray(), n = r.length = 0; n < o.length; n++) r[n] = o[n];
  t.wrappers_ = e.wrappers_, t.extensionObject_ = e.extensionObject_;
}, jspb.Message.clone_ = function (e) {
  if (Array.isArray(e)) {
    for (var t = Array(e.length), r = 0; r < e.length; r++) {
      var o = e[r];
      null != o && (t[r] = "object" == typeof o ? jspb.Message.clone_(goog.asserts.assert(o)) : o);
    }
    return t;
  }
  if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array) return new Uint8Array(e);
  for (r in t = {}, e) null != (o = e[r]) && (t[r] = "object" == typeof o ? jspb.Message.clone_(goog.asserts.assert(o)) : o);
  return t;
}, jspb.Message.registerMessageType = function (e, t) {
  t.messageId = e;
}, jspb.Message.messageSetExtensions = {}, jspb.Message.messageSetExtensionsBinary = {}, jspb.arith = {}, jspb.arith.UInt64 = function (e, t) {
  this.lo = e, this.hi = t;
}, jspb.arith.UInt64.prototype.cmp = function (e) {
  return this.hi < e.hi || this.hi == e.hi && this.lo < e.lo ? -1 : this.hi == e.hi && this.lo == e.lo ? 0 : 1;
}, jspb.arith.UInt64.prototype.rightShift = function () {
  return new jspb.arith.UInt64((this.lo >>> 1 | (1 & this.hi) << 31) >>> 0, this.hi >>> 1 >>> 0);
}, jspb.arith.UInt64.prototype.leftShift = function () {
  return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
}, jspb.arith.UInt64.prototype.msb = function () {
  return !!(2147483648 & this.hi);
}, jspb.arith.UInt64.prototype.lsb = function () {
  return !!(1 & this.lo);
}, jspb.arith.UInt64.prototype.zero = function () {
  return 0 == this.lo && 0 == this.hi;
}, jspb.arith.UInt64.prototype.add = function (e) {
  return new jspb.arith.UInt64((this.lo + e.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e.lo ? 1 : 0) >>> 0);
}, jspb.arith.UInt64.prototype.sub = function (e) {
  return new jspb.arith.UInt64((this.lo - e.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e.hi & 4294967295) >>> 0) - (0 > this.lo - e.lo ? 1 : 0) >>> 0);
}, jspb.arith.UInt64.mul32x32 = function (e, t) {
  var r = 65535 & e,
    o = 65535 & t,
    n = t >>> 16;
  for (t = r * o + 65536 * (r * n & 65535) + 65536 * ((e >>>= 16) * o & 65535), r = e * n + (r * n >>> 16) + (e * o >>> 16); 4294967296 <= t;) t -= 4294967296, r += 1;
  return new jspb.arith.UInt64(t >>> 0, r >>> 0);
}, jspb.arith.UInt64.prototype.mul = function (e) {
  var t = jspb.arith.UInt64.mul32x32(this.lo, e);
  return (e = jspb.arith.UInt64.mul32x32(this.hi, e)).hi = e.lo, e.lo = 0, t.add(e);
}, jspb.arith.UInt64.prototype.div = function (e) {
  if (0 == e) return [];
  var t = new jspb.arith.UInt64(0, 0),
    r = new jspb.arith.UInt64(this.lo, this.hi);
  e = new jspb.arith.UInt64(e, 0);
  for (var o = new jspb.arith.UInt64(1, 0); !e.msb();) e = e.leftShift(), o = o.leftShift();
  for (; !o.zero();) 0 >= e.cmp(r) && (t = t.add(o), r = r.sub(e)), e = e.rightShift(), o = o.rightShift();
  return [t, r];
}, jspb.arith.UInt64.prototype.toString = function () {
  for (var e = "", t = this; !t.zero();) {
    var r = (t = t.div(10))[0];
    e = t[1].lo + e, t = r;
  }
  return "" == e && (e = "0"), e;
}, jspb.arith.UInt64.fromString = function (e) {
  for (var t = new jspb.arith.UInt64(0, 0), r = new jspb.arith.UInt64(0, 0), o = 0; o < e.length; o++) {
    if ("0" > e[o] || "9" < e[o]) return null;
    var n = parseInt(e[o], 10);
    r.lo = n, t = t.mul(10).add(r);
  }
  return t;
}, jspb.arith.UInt64.prototype.clone = function () {
  return new jspb.arith.UInt64(this.lo, this.hi);
}, jspb.arith.Int64 = function (e, t) {
  this.lo = e, this.hi = t;
}, jspb.arith.Int64.prototype.add = function (e) {
  return new jspb.arith.Int64((this.lo + e.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e.lo ? 1 : 0) >>> 0);
}, jspb.arith.Int64.prototype.sub = function (e) {
  return new jspb.arith.Int64((this.lo - e.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e.hi & 4294967295) >>> 0) - (0 > this.lo - e.lo ? 1 : 0) >>> 0);
}, jspb.arith.Int64.prototype.clone = function () {
  return new jspb.arith.Int64(this.lo, this.hi);
}, jspb.arith.Int64.prototype.toString = function () {
  var e = 0 != (2147483648 & this.hi),
    t = new jspb.arith.UInt64(this.lo, this.hi);
  return e && (t = new jspb.arith.UInt64(0, 0).sub(t)), (e ? "-" : "") + t.toString();
}, jspb.arith.Int64.fromString = function (e) {
  var t = 0 < e.length && "-" == e[0];
  return t && (e = e.substring(1)), null === (e = jspb.arith.UInt64.fromString(e)) ? null : (t && (e = new jspb.arith.UInt64(0, 0).sub(e)), new jspb.arith.Int64(e.lo, e.hi));
}, jspb.BinaryEncoder = function () {
  this.buffer_ = [];
}, jspb.BinaryEncoder.prototype.length = function () {
  return this.buffer_.length;
}, jspb.BinaryEncoder.prototype.end = function () {
  var e = this.buffer_;
  return this.buffer_ = [], e;
}, jspb.BinaryEncoder.prototype.writeSplitVarint64 = function (e, t) {
  for (goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(t == Math.floor(t)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32); 0 < t || 127 < e;) this.buffer_.push(127 & e | 128), e = (e >>> 7 | t << 25) >>> 0, t >>>= 7;
  this.buffer_.push(e);
}, jspb.BinaryEncoder.prototype.writeSplitFixed64 = function (e, t) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(t == Math.floor(t)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeUint32(e), this.writeUint32(t);
}, jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function (e) {
  for (goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32); 127 < e;) this.buffer_.push(127 & e | 128), e >>>= 7;
  this.buffer_.push(e);
}, jspb.BinaryEncoder.prototype.writeSignedVarint32 = function (e) {
  if (goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), 0 <= e) this.writeUnsignedVarint32(e);else {
    for (var t = 0; 9 > t; t++) this.buffer_.push(127 & e | 128), e >>= 7;
    this.buffer_.push(1);
  }
}, jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitInt64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeSignedVarint64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.writeUnsignedVarint32((e << 1 ^ e >> 31) >>> 0);
}, jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitZigzag64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function (e) {
  this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(e));
}, jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function (e) {
  var t = this;
  jspb.utils.splitHash64(e), jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function (e, r) {
    t.writeSplitVarint64(e >>> 0, r >>> 0);
  });
}, jspb.BinaryEncoder.prototype.writeUint8 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && 256 > e), this.buffer_.push(e >>> 0 & 255);
}, jspb.BinaryEncoder.prototype.writeUint16 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && 65536 > e), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255);
}, jspb.BinaryEncoder.prototype.writeUint32 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255), this.buffer_.push(e >>> 16 & 255), this.buffer_.push(e >>> 24 & 255);
}, jspb.BinaryEncoder.prototype.writeUint64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitUint64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeInt8 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(-128 <= e && 128 > e), this.buffer_.push(e >>> 0 & 255);
}, jspb.BinaryEncoder.prototype.writeInt16 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(-32768 <= e && 32768 > e), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255);
}, jspb.BinaryEncoder.prototype.writeInt32 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255), this.buffer_.push(e >>> 16 & 255), this.buffer_.push(e >>> 24 & 255);
}, jspb.BinaryEncoder.prototype.writeInt64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeInt64String = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(+e >= -jspb.BinaryConstants.TWO_TO_63 && +e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e)), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeFloat = function (e) {
  goog.asserts.assert(1 / 0 === e || -1 / 0 === e || isNaN(e) || e >= -jspb.BinaryConstants.FLOAT32_MAX && e <= jspb.BinaryConstants.FLOAT32_MAX), jspb.utils.splitFloat32(e), this.writeUint32(jspb.utils.split64Low);
}, jspb.BinaryEncoder.prototype.writeDouble = function (e) {
  goog.asserts.assert(1 / 0 === e || -1 / 0 === e || isNaN(e) || e >= -jspb.BinaryConstants.FLOAT64_MAX && e <= jspb.BinaryConstants.FLOAT64_MAX), jspb.utils.splitFloat64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeBool = function (e) {
  goog.asserts.assert("boolean" == typeof e || "number" == typeof e), this.buffer_.push(e ? 1 : 0);
}, jspb.BinaryEncoder.prototype.writeEnum = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32(e);
}, jspb.BinaryEncoder.prototype.writeBytes = function (e) {
  this.buffer_.push.apply(this.buffer_, e);
}, jspb.BinaryEncoder.prototype.writeVarintHash64 = function (e) {
  jspb.utils.splitHash64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeFixedHash64 = function (e) {
  jspb.utils.splitHash64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeString = function (e) {
  for (var t = this.buffer_.length, r = 0; r < e.length; r++) {
    var o = e.charCodeAt(r);
    if (128 > o) this.buffer_.push(o);else if (2048 > o) this.buffer_.push(o >> 6 | 192), this.buffer_.push(63 & o | 128);else if (65536 > o) if (55296 <= o && 56319 >= o && r + 1 < e.length) {
      var n = e.charCodeAt(r + 1);
      56320 <= n && 57343 >= n && (o = 1024 * (o - 55296) + n - 56320 + 65536, this.buffer_.push(o >> 18 | 240), this.buffer_.push(o >> 12 & 63 | 128), this.buffer_.push(o >> 6 & 63 | 128), this.buffer_.push(63 & o | 128), r++);
    } else this.buffer_.push(o >> 12 | 224), this.buffer_.push(o >> 6 & 63 | 128), this.buffer_.push(63 & o | 128);
  }
  return this.buffer_.length - t;
}, jspb.BinaryWriter = function () {
  this.blocks_ = [], this.totalLength_ = 0, this.encoder_ = new jspb.BinaryEncoder(), this.bookmarks_ = [];
}, jspb.BinaryWriter.prototype.appendUint8Array_ = function (e) {
  var t = this.encoder_.end();
  this.blocks_.push(t), this.blocks_.push(e), this.totalLength_ += t.length + e.length;
}, jspb.BinaryWriter.prototype.beginDelimited_ = function (e) {
  return this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), e = this.encoder_.end(), this.blocks_.push(e), this.totalLength_ += e.length, e.push(this.totalLength_), e;
}, jspb.BinaryWriter.prototype.endDelimited_ = function (e) {
  var t = e.pop();
  for (t = this.totalLength_ + this.encoder_.length() - t, goog.asserts.assert(0 <= t); 127 < t;) e.push(127 & t | 128), t >>>= 7, this.totalLength_++;
  e.push(t), this.totalLength_++;
}, jspb.BinaryWriter.prototype.writeSerializedMessage = function (e, t, r) {
  this.appendUint8Array_(e.subarray(t, r));
}, jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function (e, t, r) {
  null != e && null != t && null != r && this.writeSerializedMessage(e, t, r);
}, jspb.BinaryWriter.prototype.reset = function () {
  this.blocks_ = [], this.encoder_.end(), this.totalLength_ = 0, this.bookmarks_ = [];
}, jspb.BinaryWriter.prototype.getResultBuffer = function () {
  goog.asserts.assert(0 == this.bookmarks_.length);
  for (var e = new Uint8Array(this.totalLength_ + this.encoder_.length()), t = this.blocks_, r = t.length, o = 0, n = 0; n < r; n++) {
    var a = t[n];
    e.set(a, o), o += a.length;
  }
  return t = this.encoder_.end(), e.set(t, o), o += t.length, goog.asserts.assert(o == e.length), this.blocks_ = [e], e;
}, jspb.BinaryWriter.prototype.getResultBase64String = function (e) {
  return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), e);
}, jspb.BinaryWriter.prototype.beginSubMessage = function (e) {
  this.bookmarks_.push(this.beginDelimited_(e));
}, jspb.BinaryWriter.prototype.endSubMessage = function () {
  goog.asserts.assert(0 <= this.bookmarks_.length), this.endDelimited_(this.bookmarks_.pop());
}, jspb.BinaryWriter.prototype.writeFieldHeader_ = function (e, t) {
  goog.asserts.assert(1 <= e && e == Math.floor(e)), this.encoder_.writeUnsignedVarint32(8 * e + t);
}, jspb.BinaryWriter.prototype.writeAny = function (e, t, r) {
  var o = jspb.BinaryConstants.FieldType;
  switch (e) {
    case o.DOUBLE:
      this.writeDouble(t, r);
      break;
    case o.FLOAT:
      this.writeFloat(t, r);
      break;
    case o.INT64:
      this.writeInt64(t, r);
      break;
    case o.UINT64:
      this.writeUint64(t, r);
      break;
    case o.INT32:
      this.writeInt32(t, r);
      break;
    case o.FIXED64:
      this.writeFixed64(t, r);
      break;
    case o.FIXED32:
      this.writeFixed32(t, r);
      break;
    case o.BOOL:
      this.writeBool(t, r);
      break;
    case o.STRING:
      this.writeString(t, r);
      break;
    case o.GROUP:
      goog.asserts.fail("Group field type not supported in writeAny()");
      break;
    case o.MESSAGE:
      goog.asserts.fail("Message field type not supported in writeAny()");
      break;
    case o.BYTES:
      this.writeBytes(t, r);
      break;
    case o.UINT32:
      this.writeUint32(t, r);
      break;
    case o.ENUM:
      this.writeEnum(t, r);
      break;
    case o.SFIXED32:
      this.writeSfixed32(t, r);
      break;
    case o.SFIXED64:
      this.writeSfixed64(t, r);
      break;
    case o.SINT32:
      this.writeSint32(t, r);
      break;
    case o.SINT64:
      this.writeSint64(t, r);
      break;
    case o.FHASH64:
      this.writeFixedHash64(t, r);
      break;
    case o.VHASH64:
      this.writeVarintHash64(t, r);
      break;
    default:
      goog.asserts.fail("Invalid field type in writeAny()");
  }
}, jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(t));
}, jspb.BinaryWriter.prototype.writeSignedVarint32_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(t));
}, jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(t));
}, jspb.BinaryWriter.prototype.writeSignedVarint64_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(t));
}, jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(t));
}, jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(t));
}, jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(t));
}, jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(t));
}, jspb.BinaryWriter.prototype.writeInt32 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeInt32String = function (e, t) {
  null != t && (t = parseInt(t, 10), goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeInt64 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_63 && t < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(e, t));
}, jspb.BinaryWriter.prototype.writeInt64String = function (e, t) {
  null != t && (t = jspb.arith.Int64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t.lo, t.hi));
}, jspb.BinaryWriter.prototype.writeUint32 = function (e, t) {
  null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeUint32String = function (e, t) {
  null != t && (t = parseInt(t, 10), goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeUint64 = function (e, t) {
  null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(e, t));
}, jspb.BinaryWriter.prototype.writeUint64String = function (e, t) {
  null != t && (t = jspb.arith.UInt64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t.lo, t.hi));
}, jspb.BinaryWriter.prototype.writeSint32 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeSint64 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_63 && t < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(e, t));
}, jspb.BinaryWriter.prototype.writeSintHash64 = function (e, t) {
  null != t && this.writeZigzagVarintHash64_(e, t);
}, jspb.BinaryWriter.prototype.writeSint64String = function (e, t) {
  null != t && this.writeZigzagVarint64String_(e, t);
}, jspb.BinaryWriter.prototype.writeFixed32 = function (e, t) {
  null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(t));
}, jspb.BinaryWriter.prototype.writeFixed64 = function (e, t) {
  null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(t));
}, jspb.BinaryWriter.prototype.writeFixed64String = function (e, t) {
  null != t && (t = jspb.arith.UInt64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t.lo, t.hi));
}, jspb.BinaryWriter.prototype.writeSfixed32 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(t));
}, jspb.BinaryWriter.prototype.writeSfixed64 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_63 && t < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(t));
}, jspb.BinaryWriter.prototype.writeSfixed64String = function (e, t) {
  null != t && (t = jspb.arith.Int64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t.lo, t.hi));
}, jspb.BinaryWriter.prototype.writeFloat = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(t));
}, jspb.BinaryWriter.prototype.writeDouble = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(t));
}, jspb.BinaryWriter.prototype.writeBool = function (e, t) {
  null != t && (goog.asserts.assert("boolean" == typeof t || "number" == typeof t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(t));
}, jspb.BinaryWriter.prototype.writeEnum = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(t));
}, jspb.BinaryWriter.prototype.writeString = function (e, t) {
  null != t && (e = this.beginDelimited_(e), this.encoder_.writeString(t), this.endDelimited_(e));
}, jspb.BinaryWriter.prototype.writeBytes = function (e, t) {
  null != t && (t = jspb.utils.byteSourceToUint8Array(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(t.length), this.appendUint8Array_(t));
}, jspb.BinaryWriter.prototype.writeMessage = function (e, t, r) {
  null != t && (e = this.beginDelimited_(e), r(t, this), this.endDelimited_(e));
}, jspb.BinaryWriter.prototype.writeMessageSet = function (e, t, r) {
  null != t && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(e), e = this.beginDelimited_(3), r(t, this), this.endDelimited_(e), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
}, jspb.BinaryWriter.prototype.writeGroup = function (e, t, r) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.START_GROUP), r(t, this), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.END_GROUP));
}, jspb.BinaryWriter.prototype.writeFixedHash64 = function (e, t) {
  null != t && (goog.asserts.assert(8 == t.length), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(t));
}, jspb.BinaryWriter.prototype.writeVarintHash64 = function (e, t) {
  null != t && (goog.asserts.assert(8 == t.length), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(t));
}, jspb.BinaryWriter.prototype.writeSplitFixed64 = function (e, t, r) {
  this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t, r);
}, jspb.BinaryWriter.prototype.writeSplitVarint64 = function (e, t, r) {
  this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t, r);
}, jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function (e, t, r) {
  this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT);
  var o = this.encoder_;
  jspb.utils.toZigzag64(t, r, function (e, t) {
    o.writeSplitVarint64(e >>> 0, t >>> 0);
  });
}, jspb.BinaryWriter.prototype.writeRepeatedInt32 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeSignedVarint32_(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedInt32String = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeInt32String(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedInt64 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeSignedVarint64_(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function (e, t, r, o) {
  if (null != t) for (var n = 0; n < t.length; n++) this.writeSplitFixed64(e, r(t[n]), o(t[n]));
}, jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function (e, t, r, o) {
  if (null != t) for (var n = 0; n < t.length; n++) this.writeSplitVarint64(e, r(t[n]), o(t[n]));
}, jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function (e, t, r, o) {
  if (null != t) for (var n = 0; n < t.length; n++) this.writeSplitZigzagVarint64(e, r(t[n]), o(t[n]));
}, jspb.BinaryWriter.prototype.writeRepeatedInt64String = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeInt64String(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedUint32 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeUnsignedVarint32_(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedUint32String = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeUint32String(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedUint64 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeUnsignedVarint64_(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedUint64String = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeUint64String(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedSint32 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeZigzagVarint32_(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedSint64 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeZigzagVarint64_(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedSint64String = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeZigzagVarint64String_(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeZigzagVarintHash64_(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeFixed32(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeFixed64(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeFixed64String(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeSfixed32(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeSfixed64(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeSfixed64String(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedFloat = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeFloat(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedDouble = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeDouble(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedBool = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeBool(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedEnum = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeEnum(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedString = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeString(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedBytes = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeBytes(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedMessage = function (e, t, r) {
  if (null != t) for (var o = 0; o < t.length; o++) {
    var n = this.beginDelimited_(e);
    r(t[o], this), this.endDelimited_(n);
  }
}, jspb.BinaryWriter.prototype.writeRepeatedGroup = function (e, t, r) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.START_GROUP), r(t[o], this), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.END_GROUP);
}, jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeFixedHash64(e, t[r]);
}, jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function (e, t) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeVarintHash64(e, t[r]);
}, jspb.BinaryWriter.prototype.writePackedInt32 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeSignedVarint32(t[r]);
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedInt32String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeSignedVarint32(parseInt(t[r], 10));
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedInt64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeSignedVarint64(t[r]);
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function (e, t, r, o) {
  if (null != t) {
    e = this.beginDelimited_(e);
    for (var n = 0; n < t.length; n++) this.encoder_.writeSplitFixed64(r(t[n]), o(t[n]));
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function (e, t, r, o) {
  if (null != t) {
    e = this.beginDelimited_(e);
    for (var n = 0; n < t.length; n++) this.encoder_.writeSplitVarint64(r(t[n]), o(t[n]));
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function (e, t, r, o) {
  if (null != t) {
    e = this.beginDelimited_(e);
    for (var n = this.encoder_, a = 0; a < t.length; a++) jspb.utils.toZigzag64(r(t[a]), o(t[a]), function (e, t) {
      n.writeSplitVarint64(e >>> 0, t >>> 0);
    });
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedInt64String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) {
      var o = jspb.arith.Int64.fromString(t[r]);
      this.encoder_.writeSplitVarint64(o.lo, o.hi);
    }
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedUint32 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeUnsignedVarint32(t[r]);
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedUint32String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeUnsignedVarint32(parseInt(t[r], 10));
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedUint64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeUnsignedVarint64(t[r]);
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedUint64String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) {
      var o = jspb.arith.UInt64.fromString(t[r]);
      this.encoder_.writeSplitVarint64(o.lo, o.hi);
    }
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSint32 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeZigzagVarint32(t[r]);
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSint64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeZigzagVarint64(t[r]);
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSint64String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(t[r]));
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSintHash64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeZigzagVarintHash64(t[r]);
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedFixed32 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t.length), e = 0; e < t.length; e++) this.encoder_.writeUint32(t[e]);
}, jspb.BinaryWriter.prototype.writePackedFixed64 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeUint64(t[e]);
}, jspb.BinaryWriter.prototype.writePackedFixed64String = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) {
    var r = jspb.arith.UInt64.fromString(t[e]);
    this.encoder_.writeSplitFixed64(r.lo, r.hi);
  }
}, jspb.BinaryWriter.prototype.writePackedSfixed32 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t.length), e = 0; e < t.length; e++) this.encoder_.writeInt32(t[e]);
}, jspb.BinaryWriter.prototype.writePackedSfixed64 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeInt64(t[e]);
}, jspb.BinaryWriter.prototype.writePackedSfixed64String = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeInt64String(t[e]);
}, jspb.BinaryWriter.prototype.writePackedFloat = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t.length), e = 0; e < t.length; e++) this.encoder_.writeFloat(t[e]);
}, jspb.BinaryWriter.prototype.writePackedDouble = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeDouble(t[e]);
}, jspb.BinaryWriter.prototype.writePackedBool = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(t.length), e = 0; e < t.length; e++) this.encoder_.writeBool(t[e]);
}, jspb.BinaryWriter.prototype.writePackedEnum = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeEnum(t[r]);
    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedFixedHash64 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeFixedHash64(t[e]);
}, jspb.BinaryWriter.prototype.writePackedVarintHash64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);
    for (var r = 0; r < t.length; r++) this.encoder_.writeVarintHash64(t[r]);
    this.endDelimited_(e);
  }
}, jspb.Export = {};
var _Map = jspb.Map,
  Message = jspb.Message,
  BinaryReader = jspb.BinaryReader,
  BinaryWriter = jspb.BinaryWriter,
  ExtensionFieldInfo = jspb.ExtensionFieldInfo,
  ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo,
  exportSymbol = goog.exportSymbol,
  inherits = goog.inherits,
  object = {
    extend: goog.object.extend
  },
  typeOf = goog.typeOf,
  googleProtobuf = {
    Map: _Map,
    Message: Message,
    BinaryReader: BinaryReader,
    BinaryWriter: BinaryWriter,
    ExtensionFieldInfo: ExtensionFieldInfo,
    ExtensionFieldBinaryInfo: ExtensionFieldBinaryInfo,
    exportSymbol: exportSymbol,
    inherits: inherits,
    object: object,
    typeOf: typeOf
  },
  threads_pb = createCommonjsModule(function (e, t) {
    var r = googleProtobuf,
      o = Function("return this")();
    r.exportSymbol("proto.threads.pb.CollectionConfig", null, o), r.exportSymbol("proto.threads.pb.CreateReply", null, o), r.exportSymbol("proto.threads.pb.CreateRequest", null, o), r.exportSymbol("proto.threads.pb.DeleteCollectionReply", null, o), r.exportSymbol("proto.threads.pb.DeleteCollectionRequest", null, o), r.exportSymbol("proto.threads.pb.DeleteDBReply", null, o), r.exportSymbol("proto.threads.pb.DeleteDBRequest", null, o), r.exportSymbol("proto.threads.pb.DeleteReply", null, o), r.exportSymbol("proto.threads.pb.DeleteRequest", null, o), r.exportSymbol("proto.threads.pb.DiscardReply", null, o), r.exportSymbol("proto.threads.pb.DiscardRequest", null, o), r.exportSymbol("proto.threads.pb.FindByIDReply", null, o), r.exportSymbol("proto.threads.pb.FindByIDRequest", null, o), r.exportSymbol("proto.threads.pb.FindReply", null, o), r.exportSymbol("proto.threads.pb.FindRequest", null, o), r.exportSymbol("proto.threads.pb.GetCollectionIndexesReply", null, o), r.exportSymbol("proto.threads.pb.GetCollectionIndexesRequest", null, o), r.exportSymbol("proto.threads.pb.GetCollectionInfoReply", null, o), r.exportSymbol("proto.threads.pb.GetCollectionInfoRequest", null, o), r.exportSymbol("proto.threads.pb.GetDBInfoReply", null, o), r.exportSymbol("proto.threads.pb.GetDBInfoRequest", null, o), r.exportSymbol("proto.threads.pb.GetTokenReply", null, o), r.exportSymbol("proto.threads.pb.GetTokenReply.PayloadCase", null, o), r.exportSymbol("proto.threads.pb.GetTokenRequest", null, o), r.exportSymbol("proto.threads.pb.GetTokenRequest.PayloadCase", null, o), r.exportSymbol("proto.threads.pb.HasReply", null, o), r.exportSymbol("proto.threads.pb.HasRequest", null, o), r.exportSymbol("proto.threads.pb.Index", null, o), r.exportSymbol("proto.threads.pb.ListCollectionsReply", null, o), r.exportSymbol("proto.threads.pb.ListCollectionsRequest", null, o), r.exportSymbol("proto.threads.pb.ListDBsReply", null, o), r.exportSymbol("proto.threads.pb.ListDBsReply.DB", null, o), r.exportSymbol("proto.threads.pb.ListDBsRequest", null, o), r.exportSymbol("proto.threads.pb.ListenReply", null, o), r.exportSymbol("proto.threads.pb.ListenReply.Action", null, o), r.exportSymbol("proto.threads.pb.ListenRequest", null, o), r.exportSymbol("proto.threads.pb.ListenRequest.Filter", null, o), r.exportSymbol("proto.threads.pb.ListenRequest.Filter.Action", null, o), r.exportSymbol("proto.threads.pb.NewCollectionReply", null, o), r.exportSymbol("proto.threads.pb.NewCollectionRequest", null, o), r.exportSymbol("proto.threads.pb.NewDBFromAddrRequest", null, o), r.exportSymbol("proto.threads.pb.NewDBReply", null, o), r.exportSymbol("proto.threads.pb.NewDBRequest", null, o), r.exportSymbol("proto.threads.pb.ReadTransactionReply", null, o), r.exportSymbol("proto.threads.pb.ReadTransactionReply.OptionCase", null, o), r.exportSymbol("proto.threads.pb.ReadTransactionRequest", null, o), r.exportSymbol("proto.threads.pb.ReadTransactionRequest.OptionCase", null, o), r.exportSymbol("proto.threads.pb.SaveReply", null, o), r.exportSymbol("proto.threads.pb.SaveRequest", null, o), r.exportSymbol("proto.threads.pb.StartTransactionRequest", null, o), r.exportSymbol("proto.threads.pb.UpdateCollectionReply", null, o), r.exportSymbol("proto.threads.pb.UpdateCollectionRequest", null, o), r.exportSymbol("proto.threads.pb.VerifyReply", null, o), r.exportSymbol("proto.threads.pb.VerifyRequest", null, o), r.exportSymbol("proto.threads.pb.WriteTransactionReply", null, o), r.exportSymbol("proto.threads.pb.WriteTransactionReply.OptionCase", null, o), r.exportSymbol("proto.threads.pb.WriteTransactionRequest", null, o), r.exportSymbol("proto.threads.pb.WriteTransactionRequest.OptionCase", null, o), proto.threads.pb.GetTokenRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, proto.threads.pb.GetTokenRequest.oneofGroups_);
    }, r.inherits(proto.threads.pb.GetTokenRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.GetTokenRequest.displayName = "proto.threads.pb.GetTokenRequest"), proto.threads.pb.GetTokenReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, proto.threads.pb.GetTokenReply.oneofGroups_);
    }, r.inherits(proto.threads.pb.GetTokenReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.GetTokenReply.displayName = "proto.threads.pb.GetTokenReply"), proto.threads.pb.NewDBRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.NewDBRequest.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.NewDBRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.NewDBRequest.displayName = "proto.threads.pb.NewDBRequest"), proto.threads.pb.NewDBFromAddrRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.NewDBFromAddrRequest.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.NewDBFromAddrRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.NewDBFromAddrRequest.displayName = "proto.threads.pb.NewDBFromAddrRequest"), proto.threads.pb.CollectionConfig = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.CollectionConfig.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.CollectionConfig, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.CollectionConfig.displayName = "proto.threads.pb.CollectionConfig"), proto.threads.pb.Index = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.Index, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.Index.displayName = "proto.threads.pb.Index"), proto.threads.pb.NewDBReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.NewDBReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.NewDBReply.displayName = "proto.threads.pb.NewDBReply"), proto.threads.pb.ListDBsRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.ListDBsRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ListDBsRequest.displayName = "proto.threads.pb.ListDBsRequest"), proto.threads.pb.ListDBsReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.ListDBsReply.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.ListDBsReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ListDBsReply.displayName = "proto.threads.pb.ListDBsReply"), proto.threads.pb.ListDBsReply.DB = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.ListDBsReply.DB, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ListDBsReply.DB.displayName = "proto.threads.pb.ListDBsReply.DB"), proto.threads.pb.GetDBInfoRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.GetDBInfoRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.GetDBInfoRequest.displayName = "proto.threads.pb.GetDBInfoRequest"), proto.threads.pb.GetDBInfoReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.GetDBInfoReply.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.GetDBInfoReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.GetDBInfoReply.displayName = "proto.threads.pb.GetDBInfoReply"), proto.threads.pb.DeleteDBRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.DeleteDBRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.DeleteDBRequest.displayName = "proto.threads.pb.DeleteDBRequest"), proto.threads.pb.DeleteDBReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.DeleteDBReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.DeleteDBReply.displayName = "proto.threads.pb.DeleteDBReply"), proto.threads.pb.NewCollectionRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.NewCollectionRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.NewCollectionRequest.displayName = "proto.threads.pb.NewCollectionRequest"), proto.threads.pb.NewCollectionReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.NewCollectionReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.NewCollectionReply.displayName = "proto.threads.pb.NewCollectionReply"), proto.threads.pb.UpdateCollectionRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.UpdateCollectionRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.UpdateCollectionRequest.displayName = "proto.threads.pb.UpdateCollectionRequest"), proto.threads.pb.UpdateCollectionReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.UpdateCollectionReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.UpdateCollectionReply.displayName = "proto.threads.pb.UpdateCollectionReply"), proto.threads.pb.DeleteCollectionRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.DeleteCollectionRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.DeleteCollectionRequest.displayName = "proto.threads.pb.DeleteCollectionRequest"), proto.threads.pb.DeleteCollectionReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.DeleteCollectionReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.DeleteCollectionReply.displayName = "proto.threads.pb.DeleteCollectionReply"), proto.threads.pb.GetCollectionInfoRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.GetCollectionInfoRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.GetCollectionInfoRequest.displayName = "proto.threads.pb.GetCollectionInfoRequest"), proto.threads.pb.GetCollectionInfoReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.GetCollectionInfoReply.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.GetCollectionInfoReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.GetCollectionInfoReply.displayName = "proto.threads.pb.GetCollectionInfoReply"), proto.threads.pb.GetCollectionIndexesRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.GetCollectionIndexesRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.GetCollectionIndexesRequest.displayName = "proto.threads.pb.GetCollectionIndexesRequest"), proto.threads.pb.GetCollectionIndexesReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.GetCollectionIndexesReply.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.GetCollectionIndexesReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.GetCollectionIndexesReply.displayName = "proto.threads.pb.GetCollectionIndexesReply"), proto.threads.pb.ListCollectionsRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.ListCollectionsRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ListCollectionsRequest.displayName = "proto.threads.pb.ListCollectionsRequest"), proto.threads.pb.ListCollectionsReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.ListCollectionsReply.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.ListCollectionsReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ListCollectionsReply.displayName = "proto.threads.pb.ListCollectionsReply"), proto.threads.pb.CreateRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.CreateRequest.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.CreateRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.CreateRequest.displayName = "proto.threads.pb.CreateRequest"), proto.threads.pb.CreateReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.CreateReply.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.CreateReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.CreateReply.displayName = "proto.threads.pb.CreateReply"), proto.threads.pb.VerifyRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.VerifyRequest.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.VerifyRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.VerifyRequest.displayName = "proto.threads.pb.VerifyRequest"), proto.threads.pb.VerifyReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.VerifyReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.VerifyReply.displayName = "proto.threads.pb.VerifyReply"), proto.threads.pb.SaveRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.SaveRequest.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.SaveRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.SaveRequest.displayName = "proto.threads.pb.SaveRequest"), proto.threads.pb.SaveReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.SaveReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.SaveReply.displayName = "proto.threads.pb.SaveReply"), proto.threads.pb.DeleteRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.DeleteRequest.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.DeleteRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.DeleteRequest.displayName = "proto.threads.pb.DeleteRequest"), proto.threads.pb.DeleteReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.DeleteReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.DeleteReply.displayName = "proto.threads.pb.DeleteReply"), proto.threads.pb.HasRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.HasRequest.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.HasRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.HasRequest.displayName = "proto.threads.pb.HasRequest"), proto.threads.pb.HasReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.HasReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.HasReply.displayName = "proto.threads.pb.HasReply"), proto.threads.pb.FindRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.FindRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.FindRequest.displayName = "proto.threads.pb.FindRequest"), proto.threads.pb.FindReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.FindReply.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.FindReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.FindReply.displayName = "proto.threads.pb.FindReply"), proto.threads.pb.FindByIDRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.FindByIDRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.FindByIDRequest.displayName = "proto.threads.pb.FindByIDRequest"), proto.threads.pb.FindByIDReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.FindByIDReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.FindByIDReply.displayName = "proto.threads.pb.FindByIDReply"), proto.threads.pb.DiscardRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.DiscardRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.DiscardRequest.displayName = "proto.threads.pb.DiscardRequest"), proto.threads.pb.DiscardReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.DiscardReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.DiscardReply.displayName = "proto.threads.pb.DiscardReply"), proto.threads.pb.StartTransactionRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.StartTransactionRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.StartTransactionRequest.displayName = "proto.threads.pb.StartTransactionRequest"), proto.threads.pb.ReadTransactionRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, proto.threads.pb.ReadTransactionRequest.oneofGroups_);
    }, r.inherits(proto.threads.pb.ReadTransactionRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ReadTransactionRequest.displayName = "proto.threads.pb.ReadTransactionRequest"), proto.threads.pb.ReadTransactionReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, proto.threads.pb.ReadTransactionReply.oneofGroups_);
    }, r.inherits(proto.threads.pb.ReadTransactionReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ReadTransactionReply.displayName = "proto.threads.pb.ReadTransactionReply"), proto.threads.pb.WriteTransactionRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, proto.threads.pb.WriteTransactionRequest.oneofGroups_);
    }, r.inherits(proto.threads.pb.WriteTransactionRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.WriteTransactionRequest.displayName = "proto.threads.pb.WriteTransactionRequest"), proto.threads.pb.WriteTransactionReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, proto.threads.pb.WriteTransactionReply.oneofGroups_);
    }, r.inherits(proto.threads.pb.WriteTransactionReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.WriteTransactionReply.displayName = "proto.threads.pb.WriteTransactionReply"), proto.threads.pb.ListenRequest = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, proto.threads.pb.ListenRequest.repeatedFields_, null);
    }, r.inherits(proto.threads.pb.ListenRequest, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ListenRequest.displayName = "proto.threads.pb.ListenRequest"), proto.threads.pb.ListenRequest.Filter = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.ListenRequest.Filter, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ListenRequest.Filter.displayName = "proto.threads.pb.ListenRequest.Filter"), proto.threads.pb.ListenReply = function (e) {
      googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
    }, r.inherits(proto.threads.pb.ListenReply, googleProtobuf.Message), r.DEBUG && !COMPILED && (proto.threads.pb.ListenReply.displayName = "proto.threads.pb.ListenReply"), proto.threads.pb.GetTokenRequest.oneofGroups_ = [[1, 2]], proto.threads.pb.GetTokenRequest.PayloadCase = {
      PAYLOAD_NOT_SET: 0,
      KEY: 1,
      SIGNATURE: 2
    }, proto.threads.pb.GetTokenRequest.prototype.getPayloadCase = function () {
      return googleProtobuf.Message.computeOneofCase(this, proto.threads.pb.GetTokenRequest.oneofGroups_[0]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.GetTokenRequest.prototype.toObject = function (e) {
      return proto.threads.pb.GetTokenRequest.toObject(e, this);
    }, proto.threads.pb.GetTokenRequest.toObject = function (e, t) {
      var r = {
        key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
        signature: t.getSignature_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.GetTokenRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.GetTokenRequest();
      return proto.threads.pb.GetTokenRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.GetTokenRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.setKey(r);
            break;
          case 2:
            r = t.readBytes();
            e.setSignature(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.GetTokenRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.GetTokenRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.GetTokenRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      null != (r = googleProtobuf.Message.getField(e, 1)) && t.writeString(1, r), null != (r = googleProtobuf.Message.getField(e, 2)) && t.writeBytes(2, r);
    }, proto.threads.pb.GetTokenRequest.prototype.getKey = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.GetTokenRequest.prototype.setKey = function (e) {
      return googleProtobuf.Message.setOneofField(this, 1, proto.threads.pb.GetTokenRequest.oneofGroups_[0], e);
    }, proto.threads.pb.GetTokenRequest.prototype.clearKey = function () {
      return googleProtobuf.Message.setOneofField(this, 1, proto.threads.pb.GetTokenRequest.oneofGroups_[0], void 0);
    }, proto.threads.pb.GetTokenRequest.prototype.hasKey = function () {
      return null != googleProtobuf.Message.getField(this, 1);
    }, proto.threads.pb.GetTokenRequest.prototype.getSignature = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.GetTokenRequest.prototype.getSignature_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getSignature());
    }, proto.threads.pb.GetTokenRequest.prototype.getSignature_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getSignature());
    }, proto.threads.pb.GetTokenRequest.prototype.setSignature = function (e) {
      return googleProtobuf.Message.setOneofField(this, 2, proto.threads.pb.GetTokenRequest.oneofGroups_[0], e);
    }, proto.threads.pb.GetTokenRequest.prototype.clearSignature = function () {
      return googleProtobuf.Message.setOneofField(this, 2, proto.threads.pb.GetTokenRequest.oneofGroups_[0], void 0);
    }, proto.threads.pb.GetTokenRequest.prototype.hasSignature = function () {
      return null != googleProtobuf.Message.getField(this, 2);
    }, proto.threads.pb.GetTokenReply.oneofGroups_ = [[1, 2]], proto.threads.pb.GetTokenReply.PayloadCase = {
      PAYLOAD_NOT_SET: 0,
      CHALLENGE: 1,
      TOKEN: 2
    }, proto.threads.pb.GetTokenReply.prototype.getPayloadCase = function () {
      return googleProtobuf.Message.computeOneofCase(this, proto.threads.pb.GetTokenReply.oneofGroups_[0]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.GetTokenReply.prototype.toObject = function (e) {
      return proto.threads.pb.GetTokenReply.toObject(e, this);
    }, proto.threads.pb.GetTokenReply.toObject = function (e, t) {
      var r = {
        challenge: t.getChallenge_asB64(),
        token: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.GetTokenReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.GetTokenReply();
      return proto.threads.pb.GetTokenReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.GetTokenReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setChallenge(r);
            break;
          case 2:
            r = t.readString();
            e.setToken(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.GetTokenReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.GetTokenReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.GetTokenReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      null != (r = googleProtobuf.Message.getField(e, 1)) && t.writeBytes(1, r), null != (r = googleProtobuf.Message.getField(e, 2)) && t.writeString(2, r);
    }, proto.threads.pb.GetTokenReply.prototype.getChallenge = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.GetTokenReply.prototype.getChallenge_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getChallenge());
    }, proto.threads.pb.GetTokenReply.prototype.getChallenge_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getChallenge());
    }, proto.threads.pb.GetTokenReply.prototype.setChallenge = function (e) {
      return googleProtobuf.Message.setOneofField(this, 1, proto.threads.pb.GetTokenReply.oneofGroups_[0], e);
    }, proto.threads.pb.GetTokenReply.prototype.clearChallenge = function () {
      return googleProtobuf.Message.setOneofField(this, 1, proto.threads.pb.GetTokenReply.oneofGroups_[0], void 0);
    }, proto.threads.pb.GetTokenReply.prototype.hasChallenge = function () {
      return null != googleProtobuf.Message.getField(this, 1);
    }, proto.threads.pb.GetTokenReply.prototype.getToken = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.GetTokenReply.prototype.setToken = function (e) {
      return googleProtobuf.Message.setOneofField(this, 2, proto.threads.pb.GetTokenReply.oneofGroups_[0], e);
    }, proto.threads.pb.GetTokenReply.prototype.clearToken = function () {
      return googleProtobuf.Message.setOneofField(this, 2, proto.threads.pb.GetTokenReply.oneofGroups_[0], void 0);
    }, proto.threads.pb.GetTokenReply.prototype.hasToken = function () {
      return null != googleProtobuf.Message.getField(this, 2);
    }, proto.threads.pb.NewDBRequest.repeatedFields_ = [2], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.NewDBRequest.prototype.toObject = function (e) {
      return proto.threads.pb.NewDBRequest.toObject(e, this);
    }, proto.threads.pb.NewDBRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        key: t.getKey_asB64(),
        logkey: t.getLogkey_asB64(),
        name: googleProtobuf.Message.getFieldWithDefault(t, 3, ""),
        collectionsList: googleProtobuf.Message.toObjectList(t.getCollectionsList(), proto.threads.pb.CollectionConfig.toObject, e),
        block: googleProtobuf.Message.getBooleanFieldWithDefault(t, 5, !1)
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.NewDBRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.NewDBRequest();
      return proto.threads.pb.NewDBRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.NewDBRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 6:
            r = t.readBytes();
            e.setKey(r);
            break;
          case 7:
            r = t.readBytes();
            e.setLogkey(r);
            break;
          case 3:
            r = t.readString();
            e.setName(r);
            break;
          case 2:
            r = new proto.threads.pb.CollectionConfig();
            t.readMessage(r, proto.threads.pb.CollectionConfig.deserializeBinaryFromReader), e.addCollections(r);
            break;
          case 5:
            r = t.readBool();
            e.setBlock(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.NewDBRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.NewDBRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.NewDBRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getKey_asU8()).length > 0 && t.writeBytes(6, r), (r = e.getLogkey_asU8()).length > 0 && t.writeBytes(7, r), (r = e.getName()).length > 0 && t.writeString(3, r), (r = e.getCollectionsList()).length > 0 && t.writeRepeatedMessage(2, r, proto.threads.pb.CollectionConfig.serializeBinaryToWriter), (r = e.getBlock()) && t.writeBool(5, r);
    }, proto.threads.pb.NewDBRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.NewDBRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.NewDBRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.NewDBRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.NewDBRequest.prototype.getKey = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 6, "");
    }, proto.threads.pb.NewDBRequest.prototype.getKey_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getKey());
    }, proto.threads.pb.NewDBRequest.prototype.getKey_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getKey());
    }, proto.threads.pb.NewDBRequest.prototype.setKey = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 6, e);
    }, proto.threads.pb.NewDBRequest.prototype.getLogkey = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 7, "");
    }, proto.threads.pb.NewDBRequest.prototype.getLogkey_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getLogkey());
    }, proto.threads.pb.NewDBRequest.prototype.getLogkey_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getLogkey());
    }, proto.threads.pb.NewDBRequest.prototype.setLogkey = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 7, e);
    }, proto.threads.pb.NewDBRequest.prototype.getName = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
    }, proto.threads.pb.NewDBRequest.prototype.setName = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 3, e);
    }, proto.threads.pb.NewDBRequest.prototype.getCollectionsList = function () {
      return googleProtobuf.Message.getRepeatedWrapperField(this, proto.threads.pb.CollectionConfig, 2);
    }, proto.threads.pb.NewDBRequest.prototype.setCollectionsList = function (e) {
      return googleProtobuf.Message.setRepeatedWrapperField(this, 2, e);
    }, proto.threads.pb.NewDBRequest.prototype.addCollections = function (e, t) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, e, proto.threads.pb.CollectionConfig, t);
    }, proto.threads.pb.NewDBRequest.prototype.clearCollectionsList = function () {
      return this.setCollectionsList([]);
    }, proto.threads.pb.NewDBRequest.prototype.getBlock = function () {
      return googleProtobuf.Message.getBooleanFieldWithDefault(this, 5, !1);
    }, proto.threads.pb.NewDBRequest.prototype.setBlock = function (e) {
      return googleProtobuf.Message.setProto3BooleanField(this, 5, e);
    }, proto.threads.pb.NewDBFromAddrRequest.repeatedFields_ = [3], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.NewDBFromAddrRequest.prototype.toObject = function (e) {
      return proto.threads.pb.NewDBFromAddrRequest.toObject(e, this);
    }, proto.threads.pb.NewDBFromAddrRequest.toObject = function (e, t) {
      var r = {
        addr: t.getAddr_asB64(),
        key: t.getKey_asB64(),
        logkey: t.getLogkey_asB64(),
        name: googleProtobuf.Message.getFieldWithDefault(t, 4, ""),
        collectionsList: googleProtobuf.Message.toObjectList(t.getCollectionsList(), proto.threads.pb.CollectionConfig.toObject, e),
        block: googleProtobuf.Message.getBooleanFieldWithDefault(t, 5, !1),
        threadkey: t.getThreadkey_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.NewDBFromAddrRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.NewDBFromAddrRequest();
      return proto.threads.pb.NewDBFromAddrRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.NewDBFromAddrRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setAddr(r);
            break;
          case 2:
            r = t.readBytes();
            e.setKey(r);
            break;
          case 7:
            r = t.readBytes();
            e.setLogkey(r);
            break;
          case 4:
            r = t.readString();
            e.setName(r);
            break;
          case 3:
            r = new proto.threads.pb.CollectionConfig();
            t.readMessage(r, proto.threads.pb.CollectionConfig.deserializeBinaryFromReader), e.addCollections(r);
            break;
          case 5:
            r = t.readBool();
            e.setBlock(r);
            break;
          case 6:
            r = t.readBytes();
            e.setThreadkey(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.NewDBFromAddrRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.NewDBFromAddrRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getAddr_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getKey_asU8()).length > 0 && t.writeBytes(2, r), (r = e.getLogkey_asU8()).length > 0 && t.writeBytes(7, r), (r = e.getName()).length > 0 && t.writeString(4, r), (r = e.getCollectionsList()).length > 0 && t.writeRepeatedMessage(3, r, proto.threads.pb.CollectionConfig.serializeBinaryToWriter), (r = e.getBlock()) && t.writeBool(5, r), (r = e.getThreadkey_asU8()).length > 0 && t.writeBytes(6, r);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getAddr = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getAddr_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getAddr());
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getAddr_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getAddr());
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.setAddr = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getKey = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getKey_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getKey());
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getKey_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getKey());
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.setKey = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 2, e);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getLogkey = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 7, "");
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getLogkey_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getLogkey());
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getLogkey_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getLogkey());
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.setLogkey = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 7, e);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getName = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 4, "");
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.setName = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 4, e);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getCollectionsList = function () {
      return googleProtobuf.Message.getRepeatedWrapperField(this, proto.threads.pb.CollectionConfig, 3);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.setCollectionsList = function (e) {
      return googleProtobuf.Message.setRepeatedWrapperField(this, 3, e);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.addCollections = function (e, t) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 3, e, proto.threads.pb.CollectionConfig, t);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.clearCollectionsList = function () {
      return this.setCollectionsList([]);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getBlock = function () {
      return googleProtobuf.Message.getBooleanFieldWithDefault(this, 5, !1);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.setBlock = function (e) {
      return googleProtobuf.Message.setProto3BooleanField(this, 5, e);
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getThreadkey = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 6, "");
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getThreadkey_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getThreadkey());
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.getThreadkey_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getThreadkey());
    }, proto.threads.pb.NewDBFromAddrRequest.prototype.setThreadkey = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 6, e);
    }, proto.threads.pb.CollectionConfig.repeatedFields_ = [3], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.CollectionConfig.prototype.toObject = function (e) {
      return proto.threads.pb.CollectionConfig.toObject(e, this);
    }, proto.threads.pb.CollectionConfig.toObject = function (e, t) {
      var r = {
        name: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
        schema: t.getSchema_asB64(),
        indexesList: googleProtobuf.Message.toObjectList(t.getIndexesList(), proto.threads.pb.Index.toObject, e),
        writevalidator: googleProtobuf.Message.getFieldWithDefault(t, 4, ""),
        readfilter: googleProtobuf.Message.getFieldWithDefault(t, 5, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.CollectionConfig.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.CollectionConfig();
      return proto.threads.pb.CollectionConfig.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.CollectionConfig.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.setName(r);
            break;
          case 2:
            r = t.readBytes();
            e.setSchema(r);
            break;
          case 3:
            r = new proto.threads.pb.Index();
            t.readMessage(r, proto.threads.pb.Index.deserializeBinaryFromReader), e.addIndexes(r);
            break;
          case 4:
            r = t.readString();
            e.setWritevalidator(r);
            break;
          case 5:
            r = t.readString();
            e.setReadfilter(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.CollectionConfig.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.CollectionConfig.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.CollectionConfig.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getName()).length > 0 && t.writeString(1, r), (r = e.getSchema_asU8()).length > 0 && t.writeBytes(2, r), (r = e.getIndexesList()).length > 0 && t.writeRepeatedMessage(3, r, proto.threads.pb.Index.serializeBinaryToWriter), (r = e.getWritevalidator()).length > 0 && t.writeString(4, r), (r = e.getReadfilter()).length > 0 && t.writeString(5, r);
    }, proto.threads.pb.CollectionConfig.prototype.getName = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.CollectionConfig.prototype.setName = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 1, e);
    }, proto.threads.pb.CollectionConfig.prototype.getSchema = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.CollectionConfig.prototype.getSchema_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getSchema());
    }, proto.threads.pb.CollectionConfig.prototype.getSchema_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getSchema());
    }, proto.threads.pb.CollectionConfig.prototype.setSchema = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 2, e);
    }, proto.threads.pb.CollectionConfig.prototype.getIndexesList = function () {
      return googleProtobuf.Message.getRepeatedWrapperField(this, proto.threads.pb.Index, 3);
    }, proto.threads.pb.CollectionConfig.prototype.setIndexesList = function (e) {
      return googleProtobuf.Message.setRepeatedWrapperField(this, 3, e);
    }, proto.threads.pb.CollectionConfig.prototype.addIndexes = function (e, t) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 3, e, proto.threads.pb.Index, t);
    }, proto.threads.pb.CollectionConfig.prototype.clearIndexesList = function () {
      return this.setIndexesList([]);
    }, proto.threads.pb.CollectionConfig.prototype.getWritevalidator = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 4, "");
    }, proto.threads.pb.CollectionConfig.prototype.setWritevalidator = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 4, e);
    }, proto.threads.pb.CollectionConfig.prototype.getReadfilter = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 5, "");
    }, proto.threads.pb.CollectionConfig.prototype.setReadfilter = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 5, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.Index.prototype.toObject = function (e) {
      return proto.threads.pb.Index.toObject(e, this);
    }, proto.threads.pb.Index.toObject = function (e, t) {
      var r = {
        path: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
        unique: googleProtobuf.Message.getBooleanFieldWithDefault(t, 2, !1)
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.Index.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.Index();
      return proto.threads.pb.Index.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.Index.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.setPath(r);
            break;
          case 2:
            r = t.readBool();
            e.setUnique(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.Index.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.Index.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.Index.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getPath()).length > 0 && t.writeString(1, r), (r = e.getUnique()) && t.writeBool(2, r);
    }, proto.threads.pb.Index.prototype.getPath = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.Index.prototype.setPath = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 1, e);
    }, proto.threads.pb.Index.prototype.getUnique = function () {
      return googleProtobuf.Message.getBooleanFieldWithDefault(this, 2, !1);
    }, proto.threads.pb.Index.prototype.setUnique = function (e) {
      return googleProtobuf.Message.setProto3BooleanField(this, 2, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.NewDBReply.prototype.toObject = function (e) {
      return proto.threads.pb.NewDBReply.toObject(e, this);
    }, proto.threads.pb.NewDBReply.toObject = function (e, t) {
      var r = {};
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.NewDBReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.NewDBReply();
      return proto.threads.pb.NewDBReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.NewDBReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        t.getFieldNumber();
        t.skipField();
      }
      return e;
    }, proto.threads.pb.NewDBReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.NewDBReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.NewDBReply.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ListDBsRequest.prototype.toObject = function (e) {
      return proto.threads.pb.ListDBsRequest.toObject(e, this);
    }, proto.threads.pb.ListDBsRequest.toObject = function (e, t) {
      var r = {};
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.ListDBsRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ListDBsRequest();
      return proto.threads.pb.ListDBsRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ListDBsRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        t.getFieldNumber();
        t.skipField();
      }
      return e;
    }, proto.threads.pb.ListDBsRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ListDBsRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ListDBsRequest.serializeBinaryToWriter = function (e, t) {}, proto.threads.pb.ListDBsReply.repeatedFields_ = [1], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ListDBsReply.prototype.toObject = function (e) {
      return proto.threads.pb.ListDBsReply.toObject(e, this);
    }, proto.threads.pb.ListDBsReply.toObject = function (e, t) {
      var r = {
        dbsList: googleProtobuf.Message.toObjectList(t.getDbsList(), proto.threads.pb.ListDBsReply.DB.toObject, e)
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.ListDBsReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ListDBsReply();
      return proto.threads.pb.ListDBsReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ListDBsReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = new proto.threads.pb.ListDBsReply.DB();
            t.readMessage(r, proto.threads.pb.ListDBsReply.DB.deserializeBinaryFromReader), e.addDbs(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.ListDBsReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ListDBsReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ListDBsReply.serializeBinaryToWriter = function (e, t) {
      var r;
      (r = e.getDbsList()).length > 0 && t.writeRepeatedMessage(1, r, proto.threads.pb.ListDBsReply.DB.serializeBinaryToWriter);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ListDBsReply.DB.prototype.toObject = function (e) {
      return proto.threads.pb.ListDBsReply.DB.toObject(e, this);
    }, proto.threads.pb.ListDBsReply.DB.toObject = function (e, t) {
      var r,
        o = {
          dbid: t.getDbid_asB64(),
          info: (r = t.getInfo()) && proto.threads.pb.GetDBInfoReply.toObject(e, r)
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.ListDBsReply.DB.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ListDBsReply.DB();
      return proto.threads.pb.ListDBsReply.DB.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ListDBsReply.DB.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = new proto.threads.pb.GetDBInfoReply();
            t.readMessage(r, proto.threads.pb.GetDBInfoReply.deserializeBinaryFromReader), e.setInfo(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.ListDBsReply.DB.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ListDBsReply.DB.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ListDBsReply.DB.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), null != (r = e.getInfo()) && t.writeMessage(2, r, proto.threads.pb.GetDBInfoReply.serializeBinaryToWriter);
    }, proto.threads.pb.ListDBsReply.DB.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.ListDBsReply.DB.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.ListDBsReply.DB.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.ListDBsReply.DB.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.ListDBsReply.DB.prototype.getInfo = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.GetDBInfoReply, 2);
    }, proto.threads.pb.ListDBsReply.DB.prototype.setInfo = function (e) {
      return googleProtobuf.Message.setWrapperField(this, 2, e);
    }, proto.threads.pb.ListDBsReply.DB.prototype.clearInfo = function () {
      return this.setInfo(void 0);
    }, proto.threads.pb.ListDBsReply.DB.prototype.hasInfo = function () {
      return null != googleProtobuf.Message.getField(this, 2);
    }, proto.threads.pb.ListDBsReply.prototype.getDbsList = function () {
      return googleProtobuf.Message.getRepeatedWrapperField(this, proto.threads.pb.ListDBsReply.DB, 1);
    }, proto.threads.pb.ListDBsReply.prototype.setDbsList = function (e) {
      return googleProtobuf.Message.setRepeatedWrapperField(this, 1, e);
    }, proto.threads.pb.ListDBsReply.prototype.addDbs = function (e, t) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, e, proto.threads.pb.ListDBsReply.DB, t);
    }, proto.threads.pb.ListDBsReply.prototype.clearDbsList = function () {
      return this.setDbsList([]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.GetDBInfoRequest.prototype.toObject = function (e) {
      return proto.threads.pb.GetDBInfoRequest.toObject(e, this);
    }, proto.threads.pb.GetDBInfoRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.GetDBInfoRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.GetDBInfoRequest();
      return proto.threads.pb.GetDBInfoRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.GetDBInfoRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.GetDBInfoRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.GetDBInfoRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.GetDBInfoRequest.serializeBinaryToWriter = function (e, t) {
      var r;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r);
    }, proto.threads.pb.GetDBInfoRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.GetDBInfoRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.GetDBInfoRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.GetDBInfoRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.GetDBInfoReply.repeatedFields_ = [1], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.GetDBInfoReply.prototype.toObject = function (e) {
      return proto.threads.pb.GetDBInfoReply.toObject(e, this);
    }, proto.threads.pb.GetDBInfoReply.toObject = function (e, t) {
      var r = {
        addrsList: t.getAddrsList_asB64(),
        key: t.getKey_asB64(),
        name: googleProtobuf.Message.getFieldWithDefault(t, 3, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.GetDBInfoReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.GetDBInfoReply();
      return proto.threads.pb.GetDBInfoReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.GetDBInfoReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.addAddrs(r);
            break;
          case 2:
            r = t.readBytes();
            e.setKey(r);
            break;
          case 3:
            r = t.readString();
            e.setName(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.GetDBInfoReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.GetDBInfoReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.GetDBInfoReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getAddrsList_asU8()).length > 0 && t.writeRepeatedBytes(1, r), (r = e.getKey_asU8()).length > 0 && t.writeBytes(2, r), (r = e.getName()).length > 0 && t.writeString(3, r);
    }, proto.threads.pb.GetDBInfoReply.prototype.getAddrsList = function () {
      return googleProtobuf.Message.getRepeatedField(this, 1);
    }, proto.threads.pb.GetDBInfoReply.prototype.getAddrsList_asB64 = function () {
      return googleProtobuf.Message.bytesListAsB64(this.getAddrsList());
    }, proto.threads.pb.GetDBInfoReply.prototype.getAddrsList_asU8 = function () {
      return googleProtobuf.Message.bytesListAsU8(this.getAddrsList());
    }, proto.threads.pb.GetDBInfoReply.prototype.setAddrsList = function (e) {
      return googleProtobuf.Message.setField(this, 1, e || []);
    }, proto.threads.pb.GetDBInfoReply.prototype.addAddrs = function (e, t) {
      return googleProtobuf.Message.addToRepeatedField(this, 1, e, t);
    }, proto.threads.pb.GetDBInfoReply.prototype.clearAddrsList = function () {
      return this.setAddrsList([]);
    }, proto.threads.pb.GetDBInfoReply.prototype.getKey = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.GetDBInfoReply.prototype.getKey_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getKey());
    }, proto.threads.pb.GetDBInfoReply.prototype.getKey_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getKey());
    }, proto.threads.pb.GetDBInfoReply.prototype.setKey = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 2, e);
    }, proto.threads.pb.GetDBInfoReply.prototype.getName = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
    }, proto.threads.pb.GetDBInfoReply.prototype.setName = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 3, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.DeleteDBRequest.prototype.toObject = function (e) {
      return proto.threads.pb.DeleteDBRequest.toObject(e, this);
    }, proto.threads.pb.DeleteDBRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.DeleteDBRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.DeleteDBRequest();
      return proto.threads.pb.DeleteDBRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.DeleteDBRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.DeleteDBRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.DeleteDBRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.DeleteDBRequest.serializeBinaryToWriter = function (e, t) {
      var r;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r);
    }, proto.threads.pb.DeleteDBRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.DeleteDBRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.DeleteDBRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.DeleteDBRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.DeleteDBReply.prototype.toObject = function (e) {
      return proto.threads.pb.DeleteDBReply.toObject(e, this);
    }, proto.threads.pb.DeleteDBReply.toObject = function (e, t) {
      var r = {};
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.DeleteDBReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.DeleteDBReply();
      return proto.threads.pb.DeleteDBReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.DeleteDBReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        t.getFieldNumber();
        t.skipField();
      }
      return e;
    }, proto.threads.pb.DeleteDBReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.DeleteDBReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.DeleteDBReply.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.NewCollectionRequest.prototype.toObject = function (e) {
      return proto.threads.pb.NewCollectionRequest.toObject(e, this);
    }, proto.threads.pb.NewCollectionRequest.toObject = function (e, t) {
      var r,
        o = {
          dbid: t.getDbid_asB64(),
          config: (r = t.getConfig()) && proto.threads.pb.CollectionConfig.toObject(e, r)
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.NewCollectionRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.NewCollectionRequest();
      return proto.threads.pb.NewCollectionRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.NewCollectionRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = new proto.threads.pb.CollectionConfig();
            t.readMessage(r, proto.threads.pb.CollectionConfig.deserializeBinaryFromReader), e.setConfig(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.NewCollectionRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.NewCollectionRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.NewCollectionRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), null != (r = e.getConfig()) && t.writeMessage(2, r, proto.threads.pb.CollectionConfig.serializeBinaryToWriter);
    }, proto.threads.pb.NewCollectionRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.NewCollectionRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.NewCollectionRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.NewCollectionRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.NewCollectionRequest.prototype.getConfig = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.CollectionConfig, 2);
    }, proto.threads.pb.NewCollectionRequest.prototype.setConfig = function (e) {
      return googleProtobuf.Message.setWrapperField(this, 2, e);
    }, proto.threads.pb.NewCollectionRequest.prototype.clearConfig = function () {
      return this.setConfig(void 0);
    }, proto.threads.pb.NewCollectionRequest.prototype.hasConfig = function () {
      return null != googleProtobuf.Message.getField(this, 2);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.NewCollectionReply.prototype.toObject = function (e) {
      return proto.threads.pb.NewCollectionReply.toObject(e, this);
    }, proto.threads.pb.NewCollectionReply.toObject = function (e, t) {
      var r = {};
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.NewCollectionReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.NewCollectionReply();
      return proto.threads.pb.NewCollectionReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.NewCollectionReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        t.getFieldNumber();
        t.skipField();
      }
      return e;
    }, proto.threads.pb.NewCollectionReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.NewCollectionReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.NewCollectionReply.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.UpdateCollectionRequest.prototype.toObject = function (e) {
      return proto.threads.pb.UpdateCollectionRequest.toObject(e, this);
    }, proto.threads.pb.UpdateCollectionRequest.toObject = function (e, t) {
      var r,
        o = {
          dbid: t.getDbid_asB64(),
          config: (r = t.getConfig()) && proto.threads.pb.CollectionConfig.toObject(e, r)
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.UpdateCollectionRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.UpdateCollectionRequest();
      return proto.threads.pb.UpdateCollectionRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.UpdateCollectionRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = new proto.threads.pb.CollectionConfig();
            t.readMessage(r, proto.threads.pb.CollectionConfig.deserializeBinaryFromReader), e.setConfig(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.UpdateCollectionRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.UpdateCollectionRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.UpdateCollectionRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), null != (r = e.getConfig()) && t.writeMessage(2, r, proto.threads.pb.CollectionConfig.serializeBinaryToWriter);
    }, proto.threads.pb.UpdateCollectionRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.UpdateCollectionRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.UpdateCollectionRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.UpdateCollectionRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.UpdateCollectionRequest.prototype.getConfig = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.CollectionConfig, 2);
    }, proto.threads.pb.UpdateCollectionRequest.prototype.setConfig = function (e) {
      return googleProtobuf.Message.setWrapperField(this, 2, e);
    }, proto.threads.pb.UpdateCollectionRequest.prototype.clearConfig = function () {
      return this.setConfig(void 0);
    }, proto.threads.pb.UpdateCollectionRequest.prototype.hasConfig = function () {
      return null != googleProtobuf.Message.getField(this, 2);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.UpdateCollectionReply.prototype.toObject = function (e) {
      return proto.threads.pb.UpdateCollectionReply.toObject(e, this);
    }, proto.threads.pb.UpdateCollectionReply.toObject = function (e, t) {
      var r = {};
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.UpdateCollectionReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.UpdateCollectionReply();
      return proto.threads.pb.UpdateCollectionReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.UpdateCollectionReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        t.getFieldNumber();
        t.skipField();
      }
      return e;
    }, proto.threads.pb.UpdateCollectionReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.UpdateCollectionReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.UpdateCollectionReply.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.DeleteCollectionRequest.prototype.toObject = function (e) {
      return proto.threads.pb.DeleteCollectionRequest.toObject(e, this);
    }, proto.threads.pb.DeleteCollectionRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        name: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.DeleteCollectionRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.DeleteCollectionRequest();
      return proto.threads.pb.DeleteCollectionRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.DeleteCollectionRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setName(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.DeleteCollectionRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.DeleteCollectionRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.DeleteCollectionRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getName()).length > 0 && t.writeString(2, r);
    }, proto.threads.pb.DeleteCollectionRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.DeleteCollectionRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.DeleteCollectionRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.DeleteCollectionRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.DeleteCollectionRequest.prototype.getName = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.DeleteCollectionRequest.prototype.setName = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.DeleteCollectionReply.prototype.toObject = function (e) {
      return proto.threads.pb.DeleteCollectionReply.toObject(e, this);
    }, proto.threads.pb.DeleteCollectionReply.toObject = function (e, t) {
      var r = {};
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.DeleteCollectionReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.DeleteCollectionReply();
      return proto.threads.pb.DeleteCollectionReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.DeleteCollectionReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        t.getFieldNumber();
        t.skipField();
      }
      return e;
    }, proto.threads.pb.DeleteCollectionReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.DeleteCollectionReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.DeleteCollectionReply.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.GetCollectionInfoRequest.prototype.toObject = function (e) {
      return proto.threads.pb.GetCollectionInfoRequest.toObject(e, this);
    }, proto.threads.pb.GetCollectionInfoRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        name: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.GetCollectionInfoRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.GetCollectionInfoRequest();
      return proto.threads.pb.GetCollectionInfoRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.GetCollectionInfoRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setName(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.GetCollectionInfoRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.GetCollectionInfoRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.GetCollectionInfoRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getName()).length > 0 && t.writeString(2, r);
    }, proto.threads.pb.GetCollectionInfoRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.GetCollectionInfoRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.GetCollectionInfoRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.GetCollectionInfoRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.GetCollectionInfoRequest.prototype.getName = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.GetCollectionInfoRequest.prototype.setName = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.GetCollectionInfoReply.repeatedFields_ = [3], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.GetCollectionInfoReply.prototype.toObject = function (e) {
      return proto.threads.pb.GetCollectionInfoReply.toObject(e, this);
    }, proto.threads.pb.GetCollectionInfoReply.toObject = function (e, t) {
      var r = {
        name: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
        schema: t.getSchema_asB64(),
        indexesList: googleProtobuf.Message.toObjectList(t.getIndexesList(), proto.threads.pb.Index.toObject, e),
        writevalidator: googleProtobuf.Message.getFieldWithDefault(t, 4, ""),
        readfilter: googleProtobuf.Message.getFieldWithDefault(t, 5, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.GetCollectionInfoReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.GetCollectionInfoReply();
      return proto.threads.pb.GetCollectionInfoReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.GetCollectionInfoReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.setName(r);
            break;
          case 2:
            r = t.readBytes();
            e.setSchema(r);
            break;
          case 3:
            r = new proto.threads.pb.Index();
            t.readMessage(r, proto.threads.pb.Index.deserializeBinaryFromReader), e.addIndexes(r);
            break;
          case 4:
            r = t.readString();
            e.setWritevalidator(r);
            break;
          case 5:
            r = t.readString();
            e.setReadfilter(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.GetCollectionInfoReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.GetCollectionInfoReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.GetCollectionInfoReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getName()).length > 0 && t.writeString(1, r), (r = e.getSchema_asU8()).length > 0 && t.writeBytes(2, r), (r = e.getIndexesList()).length > 0 && t.writeRepeatedMessage(3, r, proto.threads.pb.Index.serializeBinaryToWriter), (r = e.getWritevalidator()).length > 0 && t.writeString(4, r), (r = e.getReadfilter()).length > 0 && t.writeString(5, r);
    }, proto.threads.pb.GetCollectionInfoReply.prototype.getName = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.GetCollectionInfoReply.prototype.setName = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 1, e);
    }, proto.threads.pb.GetCollectionInfoReply.prototype.getSchema = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.GetCollectionInfoReply.prototype.getSchema_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getSchema());
    }, proto.threads.pb.GetCollectionInfoReply.prototype.getSchema_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getSchema());
    }, proto.threads.pb.GetCollectionInfoReply.prototype.setSchema = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 2, e);
    }, proto.threads.pb.GetCollectionInfoReply.prototype.getIndexesList = function () {
      return googleProtobuf.Message.getRepeatedWrapperField(this, proto.threads.pb.Index, 3);
    }, proto.threads.pb.GetCollectionInfoReply.prototype.setIndexesList = function (e) {
      return googleProtobuf.Message.setRepeatedWrapperField(this, 3, e);
    }, proto.threads.pb.GetCollectionInfoReply.prototype.addIndexes = function (e, t) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 3, e, proto.threads.pb.Index, t);
    }, proto.threads.pb.GetCollectionInfoReply.prototype.clearIndexesList = function () {
      return this.setIndexesList([]);
    }, proto.threads.pb.GetCollectionInfoReply.prototype.getWritevalidator = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 4, "");
    }, proto.threads.pb.GetCollectionInfoReply.prototype.setWritevalidator = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 4, e);
    }, proto.threads.pb.GetCollectionInfoReply.prototype.getReadfilter = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 5, "");
    }, proto.threads.pb.GetCollectionInfoReply.prototype.setReadfilter = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 5, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.GetCollectionIndexesRequest.prototype.toObject = function (e) {
      return proto.threads.pb.GetCollectionIndexesRequest.toObject(e, this);
    }, proto.threads.pb.GetCollectionIndexesRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        name: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.GetCollectionIndexesRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.GetCollectionIndexesRequest();
      return proto.threads.pb.GetCollectionIndexesRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.GetCollectionIndexesRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setName(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.GetCollectionIndexesRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.GetCollectionIndexesRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.GetCollectionIndexesRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getName()).length > 0 && t.writeString(2, r);
    }, proto.threads.pb.GetCollectionIndexesRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.GetCollectionIndexesRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.GetCollectionIndexesRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.GetCollectionIndexesRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.GetCollectionIndexesRequest.prototype.getName = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.GetCollectionIndexesRequest.prototype.setName = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.GetCollectionIndexesReply.repeatedFields_ = [1], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.GetCollectionIndexesReply.prototype.toObject = function (e) {
      return proto.threads.pb.GetCollectionIndexesReply.toObject(e, this);
    }, proto.threads.pb.GetCollectionIndexesReply.toObject = function (e, t) {
      var r = {
        indexesList: googleProtobuf.Message.toObjectList(t.getIndexesList(), proto.threads.pb.Index.toObject, e)
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.GetCollectionIndexesReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.GetCollectionIndexesReply();
      return proto.threads.pb.GetCollectionIndexesReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.GetCollectionIndexesReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = new proto.threads.pb.Index();
            t.readMessage(r, proto.threads.pb.Index.deserializeBinaryFromReader), e.addIndexes(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.GetCollectionIndexesReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.GetCollectionIndexesReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.GetCollectionIndexesReply.serializeBinaryToWriter = function (e, t) {
      var r;
      (r = e.getIndexesList()).length > 0 && t.writeRepeatedMessage(1, r, proto.threads.pb.Index.serializeBinaryToWriter);
    }, proto.threads.pb.GetCollectionIndexesReply.prototype.getIndexesList = function () {
      return googleProtobuf.Message.getRepeatedWrapperField(this, proto.threads.pb.Index, 1);
    }, proto.threads.pb.GetCollectionIndexesReply.prototype.setIndexesList = function (e) {
      return googleProtobuf.Message.setRepeatedWrapperField(this, 1, e);
    }, proto.threads.pb.GetCollectionIndexesReply.prototype.addIndexes = function (e, t) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, e, proto.threads.pb.Index, t);
    }, proto.threads.pb.GetCollectionIndexesReply.prototype.clearIndexesList = function () {
      return this.setIndexesList([]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ListCollectionsRequest.prototype.toObject = function (e) {
      return proto.threads.pb.ListCollectionsRequest.toObject(e, this);
    }, proto.threads.pb.ListCollectionsRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.ListCollectionsRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ListCollectionsRequest();
      return proto.threads.pb.ListCollectionsRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ListCollectionsRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.ListCollectionsRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ListCollectionsRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ListCollectionsRequest.serializeBinaryToWriter = function (e, t) {
      var r;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r);
    }, proto.threads.pb.ListCollectionsRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.ListCollectionsRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.ListCollectionsRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.ListCollectionsRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.ListCollectionsReply.repeatedFields_ = [1], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ListCollectionsReply.prototype.toObject = function (e) {
      return proto.threads.pb.ListCollectionsReply.toObject(e, this);
    }, proto.threads.pb.ListCollectionsReply.toObject = function (e, t) {
      var r = {
        collectionsList: googleProtobuf.Message.toObjectList(t.getCollectionsList(), proto.threads.pb.GetCollectionInfoReply.toObject, e)
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.ListCollectionsReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ListCollectionsReply();
      return proto.threads.pb.ListCollectionsReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ListCollectionsReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = new proto.threads.pb.GetCollectionInfoReply();
            t.readMessage(r, proto.threads.pb.GetCollectionInfoReply.deserializeBinaryFromReader), e.addCollections(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.ListCollectionsReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ListCollectionsReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ListCollectionsReply.serializeBinaryToWriter = function (e, t) {
      var r;
      (r = e.getCollectionsList()).length > 0 && t.writeRepeatedMessage(1, r, proto.threads.pb.GetCollectionInfoReply.serializeBinaryToWriter);
    }, proto.threads.pb.ListCollectionsReply.prototype.getCollectionsList = function () {
      return googleProtobuf.Message.getRepeatedWrapperField(this, proto.threads.pb.GetCollectionInfoReply, 1);
    }, proto.threads.pb.ListCollectionsReply.prototype.setCollectionsList = function (e) {
      return googleProtobuf.Message.setRepeatedWrapperField(this, 1, e);
    }, proto.threads.pb.ListCollectionsReply.prototype.addCollections = function (e, t) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, e, proto.threads.pb.GetCollectionInfoReply, t);
    }, proto.threads.pb.ListCollectionsReply.prototype.clearCollectionsList = function () {
      return this.setCollectionsList([]);
    }, proto.threads.pb.CreateRequest.repeatedFields_ = [3], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.CreateRequest.prototype.toObject = function (e) {
      return proto.threads.pb.CreateRequest.toObject(e, this);
    }, proto.threads.pb.CreateRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        collectionname: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
        instancesList: t.getInstancesList_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.CreateRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.CreateRequest();
      return proto.threads.pb.CreateRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.CreateRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setCollectionname(r);
            break;
          case 3:
            r = t.readBytes();
            e.addInstances(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.CreateRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.CreateRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.CreateRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getCollectionname()).length > 0 && t.writeString(2, r), (r = e.getInstancesList_asU8()).length > 0 && t.writeRepeatedBytes(3, r);
    }, proto.threads.pb.CreateRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.CreateRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.CreateRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.CreateRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.CreateRequest.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.CreateRequest.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.CreateRequest.prototype.getInstancesList = function () {
      return googleProtobuf.Message.getRepeatedField(this, 3);
    }, proto.threads.pb.CreateRequest.prototype.getInstancesList_asB64 = function () {
      return googleProtobuf.Message.bytesListAsB64(this.getInstancesList());
    }, proto.threads.pb.CreateRequest.prototype.getInstancesList_asU8 = function () {
      return googleProtobuf.Message.bytesListAsU8(this.getInstancesList());
    }, proto.threads.pb.CreateRequest.prototype.setInstancesList = function (e) {
      return googleProtobuf.Message.setField(this, 3, e || []);
    }, proto.threads.pb.CreateRequest.prototype.addInstances = function (e, t) {
      return googleProtobuf.Message.addToRepeatedField(this, 3, e, t);
    }, proto.threads.pb.CreateRequest.prototype.clearInstancesList = function () {
      return this.setInstancesList([]);
    }, proto.threads.pb.CreateReply.repeatedFields_ = [1], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.CreateReply.prototype.toObject = function (e) {
      return proto.threads.pb.CreateReply.toObject(e, this);
    }, proto.threads.pb.CreateReply.toObject = function (e, t) {
      var r,
        o = {
          instanceidsList: null == (r = googleProtobuf.Message.getRepeatedField(t, 1)) ? void 0 : r,
          transactionerror: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.CreateReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.CreateReply();
      return proto.threads.pb.CreateReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.CreateReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.addInstanceids(r);
            break;
          case 2:
            r = t.readString();
            e.setTransactionerror(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.CreateReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.CreateReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.CreateReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getInstanceidsList()).length > 0 && t.writeRepeatedString(1, r), (r = e.getTransactionerror()).length > 0 && t.writeString(2, r);
    }, proto.threads.pb.CreateReply.prototype.getInstanceidsList = function () {
      return googleProtobuf.Message.getRepeatedField(this, 1);
    }, proto.threads.pb.CreateReply.prototype.setInstanceidsList = function (e) {
      return googleProtobuf.Message.setField(this, 1, e || []);
    }, proto.threads.pb.CreateReply.prototype.addInstanceids = function (e, t) {
      return googleProtobuf.Message.addToRepeatedField(this, 1, e, t);
    }, proto.threads.pb.CreateReply.prototype.clearInstanceidsList = function () {
      return this.setInstanceidsList([]);
    }, proto.threads.pb.CreateReply.prototype.getTransactionerror = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.CreateReply.prototype.setTransactionerror = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.VerifyRequest.repeatedFields_ = [3], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.VerifyRequest.prototype.toObject = function (e) {
      return proto.threads.pb.VerifyRequest.toObject(e, this);
    }, proto.threads.pb.VerifyRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        collectionname: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
        instancesList: t.getInstancesList_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.VerifyRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.VerifyRequest();
      return proto.threads.pb.VerifyRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.VerifyRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setCollectionname(r);
            break;
          case 3:
            r = t.readBytes();
            e.addInstances(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.VerifyRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.VerifyRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.VerifyRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getCollectionname()).length > 0 && t.writeString(2, r), (r = e.getInstancesList_asU8()).length > 0 && t.writeRepeatedBytes(3, r);
    }, proto.threads.pb.VerifyRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.VerifyRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.VerifyRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.VerifyRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.VerifyRequest.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.VerifyRequest.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.VerifyRequest.prototype.getInstancesList = function () {
      return googleProtobuf.Message.getRepeatedField(this, 3);
    }, proto.threads.pb.VerifyRequest.prototype.getInstancesList_asB64 = function () {
      return googleProtobuf.Message.bytesListAsB64(this.getInstancesList());
    }, proto.threads.pb.VerifyRequest.prototype.getInstancesList_asU8 = function () {
      return googleProtobuf.Message.bytesListAsU8(this.getInstancesList());
    }, proto.threads.pb.VerifyRequest.prototype.setInstancesList = function (e) {
      return googleProtobuf.Message.setField(this, 3, e || []);
    }, proto.threads.pb.VerifyRequest.prototype.addInstances = function (e, t) {
      return googleProtobuf.Message.addToRepeatedField(this, 3, e, t);
    }, proto.threads.pb.VerifyRequest.prototype.clearInstancesList = function () {
      return this.setInstancesList([]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.VerifyReply.prototype.toObject = function (e) {
      return proto.threads.pb.VerifyReply.toObject(e, this);
    }, proto.threads.pb.VerifyReply.toObject = function (e, t) {
      var r = {
        transactionerror: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.VerifyReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.VerifyReply();
      return proto.threads.pb.VerifyReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.VerifyReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.setTransactionerror(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.VerifyReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.VerifyReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.VerifyReply.serializeBinaryToWriter = function (e, t) {
      var r;
      (r = e.getTransactionerror()).length > 0 && t.writeString(1, r);
    }, proto.threads.pb.VerifyReply.prototype.getTransactionerror = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.VerifyReply.prototype.setTransactionerror = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 1, e);
    }, proto.threads.pb.SaveRequest.repeatedFields_ = [3], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.SaveRequest.prototype.toObject = function (e) {
      return proto.threads.pb.SaveRequest.toObject(e, this);
    }, proto.threads.pb.SaveRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        collectionname: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
        instancesList: t.getInstancesList_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.SaveRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.SaveRequest();
      return proto.threads.pb.SaveRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.SaveRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setCollectionname(r);
            break;
          case 3:
            r = t.readBytes();
            e.addInstances(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.SaveRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.SaveRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.SaveRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getCollectionname()).length > 0 && t.writeString(2, r), (r = e.getInstancesList_asU8()).length > 0 && t.writeRepeatedBytes(3, r);
    }, proto.threads.pb.SaveRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.SaveRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.SaveRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.SaveRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.SaveRequest.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.SaveRequest.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.SaveRequest.prototype.getInstancesList = function () {
      return googleProtobuf.Message.getRepeatedField(this, 3);
    }, proto.threads.pb.SaveRequest.prototype.getInstancesList_asB64 = function () {
      return googleProtobuf.Message.bytesListAsB64(this.getInstancesList());
    }, proto.threads.pb.SaveRequest.prototype.getInstancesList_asU8 = function () {
      return googleProtobuf.Message.bytesListAsU8(this.getInstancesList());
    }, proto.threads.pb.SaveRequest.prototype.setInstancesList = function (e) {
      return googleProtobuf.Message.setField(this, 3, e || []);
    }, proto.threads.pb.SaveRequest.prototype.addInstances = function (e, t) {
      return googleProtobuf.Message.addToRepeatedField(this, 3, e, t);
    }, proto.threads.pb.SaveRequest.prototype.clearInstancesList = function () {
      return this.setInstancesList([]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.SaveReply.prototype.toObject = function (e) {
      return proto.threads.pb.SaveReply.toObject(e, this);
    }, proto.threads.pb.SaveReply.toObject = function (e, t) {
      var r = {
        transactionerror: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.SaveReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.SaveReply();
      return proto.threads.pb.SaveReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.SaveReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.setTransactionerror(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.SaveReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.SaveReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.SaveReply.serializeBinaryToWriter = function (e, t) {
      var r;
      (r = e.getTransactionerror()).length > 0 && t.writeString(1, r);
    }, proto.threads.pb.SaveReply.prototype.getTransactionerror = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.SaveReply.prototype.setTransactionerror = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 1, e);
    }, proto.threads.pb.DeleteRequest.repeatedFields_ = [3], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.DeleteRequest.prototype.toObject = function (e) {
      return proto.threads.pb.DeleteRequest.toObject(e, this);
    }, proto.threads.pb.DeleteRequest.toObject = function (e, t) {
      var r,
        o = {
          dbid: t.getDbid_asB64(),
          collectionname: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
          instanceidsList: null == (r = googleProtobuf.Message.getRepeatedField(t, 3)) ? void 0 : r
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.DeleteRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.DeleteRequest();
      return proto.threads.pb.DeleteRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.DeleteRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setCollectionname(r);
            break;
          case 3:
            r = t.readString();
            e.addInstanceids(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.DeleteRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.DeleteRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.DeleteRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getCollectionname()).length > 0 && t.writeString(2, r), (r = e.getInstanceidsList()).length > 0 && t.writeRepeatedString(3, r);
    }, proto.threads.pb.DeleteRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.DeleteRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.DeleteRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.DeleteRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.DeleteRequest.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.DeleteRequest.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.DeleteRequest.prototype.getInstanceidsList = function () {
      return googleProtobuf.Message.getRepeatedField(this, 3);
    }, proto.threads.pb.DeleteRequest.prototype.setInstanceidsList = function (e) {
      return googleProtobuf.Message.setField(this, 3, e || []);
    }, proto.threads.pb.DeleteRequest.prototype.addInstanceids = function (e, t) {
      return googleProtobuf.Message.addToRepeatedField(this, 3, e, t);
    }, proto.threads.pb.DeleteRequest.prototype.clearInstanceidsList = function () {
      return this.setInstanceidsList([]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.DeleteReply.prototype.toObject = function (e) {
      return proto.threads.pb.DeleteReply.toObject(e, this);
    }, proto.threads.pb.DeleteReply.toObject = function (e, t) {
      var r = {
        transactionerror: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.DeleteReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.DeleteReply();
      return proto.threads.pb.DeleteReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.DeleteReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.setTransactionerror(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.DeleteReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.DeleteReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.DeleteReply.serializeBinaryToWriter = function (e, t) {
      var r;
      (r = e.getTransactionerror()).length > 0 && t.writeString(1, r);
    }, proto.threads.pb.DeleteReply.prototype.getTransactionerror = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.DeleteReply.prototype.setTransactionerror = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 1, e);
    }, proto.threads.pb.HasRequest.repeatedFields_ = [3], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.HasRequest.prototype.toObject = function (e) {
      return proto.threads.pb.HasRequest.toObject(e, this);
    }, proto.threads.pb.HasRequest.toObject = function (e, t) {
      var r,
        o = {
          dbid: t.getDbid_asB64(),
          collectionname: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
          instanceidsList: null == (r = googleProtobuf.Message.getRepeatedField(t, 3)) ? void 0 : r
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.HasRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.HasRequest();
      return proto.threads.pb.HasRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.HasRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setCollectionname(r);
            break;
          case 3:
            r = t.readString();
            e.addInstanceids(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.HasRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.HasRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.HasRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getCollectionname()).length > 0 && t.writeString(2, r), (r = e.getInstanceidsList()).length > 0 && t.writeRepeatedString(3, r);
    }, proto.threads.pb.HasRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.HasRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.HasRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.HasRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.HasRequest.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.HasRequest.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.HasRequest.prototype.getInstanceidsList = function () {
      return googleProtobuf.Message.getRepeatedField(this, 3);
    }, proto.threads.pb.HasRequest.prototype.setInstanceidsList = function (e) {
      return googleProtobuf.Message.setField(this, 3, e || []);
    }, proto.threads.pb.HasRequest.prototype.addInstanceids = function (e, t) {
      return googleProtobuf.Message.addToRepeatedField(this, 3, e, t);
    }, proto.threads.pb.HasRequest.prototype.clearInstanceidsList = function () {
      return this.setInstanceidsList([]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.HasReply.prototype.toObject = function (e) {
      return proto.threads.pb.HasReply.toObject(e, this);
    }, proto.threads.pb.HasReply.toObject = function (e, t) {
      var r = {
        exists: googleProtobuf.Message.getBooleanFieldWithDefault(t, 1, !1),
        transactionerror: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.HasReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.HasReply();
      return proto.threads.pb.HasReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.HasReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBool();
            e.setExists(r);
            break;
          case 2:
            r = t.readString();
            e.setTransactionerror(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.HasReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.HasReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.HasReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getExists()) && t.writeBool(1, r), (r = e.getTransactionerror()).length > 0 && t.writeString(2, r);
    }, proto.threads.pb.HasReply.prototype.getExists = function () {
      return googleProtobuf.Message.getBooleanFieldWithDefault(this, 1, !1);
    }, proto.threads.pb.HasReply.prototype.setExists = function (e) {
      return googleProtobuf.Message.setProto3BooleanField(this, 1, e);
    }, proto.threads.pb.HasReply.prototype.getTransactionerror = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.HasReply.prototype.setTransactionerror = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.FindRequest.prototype.toObject = function (e) {
      return proto.threads.pb.FindRequest.toObject(e, this);
    }, proto.threads.pb.FindRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        collectionname: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
        queryjson: t.getQueryjson_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.FindRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.FindRequest();
      return proto.threads.pb.FindRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.FindRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setCollectionname(r);
            break;
          case 3:
            r = t.readBytes();
            e.setQueryjson(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.FindRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.FindRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.FindRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getCollectionname()).length > 0 && t.writeString(2, r), (r = e.getQueryjson_asU8()).length > 0 && t.writeBytes(3, r);
    }, proto.threads.pb.FindRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.FindRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.FindRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.FindRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.FindRequest.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.FindRequest.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.FindRequest.prototype.getQueryjson = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
    }, proto.threads.pb.FindRequest.prototype.getQueryjson_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getQueryjson());
    }, proto.threads.pb.FindRequest.prototype.getQueryjson_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getQueryjson());
    }, proto.threads.pb.FindRequest.prototype.setQueryjson = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 3, e);
    }, proto.threads.pb.FindReply.repeatedFields_ = [1], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.FindReply.prototype.toObject = function (e) {
      return proto.threads.pb.FindReply.toObject(e, this);
    }, proto.threads.pb.FindReply.toObject = function (e, t) {
      var r = {
        instancesList: t.getInstancesList_asB64(),
        transactionerror: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.FindReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.FindReply();
      return proto.threads.pb.FindReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.FindReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.addInstances(r);
            break;
          case 2:
            r = t.readString();
            e.setTransactionerror(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.FindReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.FindReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.FindReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getInstancesList_asU8()).length > 0 && t.writeRepeatedBytes(1, r), (r = e.getTransactionerror()).length > 0 && t.writeString(2, r);
    }, proto.threads.pb.FindReply.prototype.getInstancesList = function () {
      return googleProtobuf.Message.getRepeatedField(this, 1);
    }, proto.threads.pb.FindReply.prototype.getInstancesList_asB64 = function () {
      return googleProtobuf.Message.bytesListAsB64(this.getInstancesList());
    }, proto.threads.pb.FindReply.prototype.getInstancesList_asU8 = function () {
      return googleProtobuf.Message.bytesListAsU8(this.getInstancesList());
    }, proto.threads.pb.FindReply.prototype.setInstancesList = function (e) {
      return googleProtobuf.Message.setField(this, 1, e || []);
    }, proto.threads.pb.FindReply.prototype.addInstances = function (e, t) {
      return googleProtobuf.Message.addToRepeatedField(this, 1, e, t);
    }, proto.threads.pb.FindReply.prototype.clearInstancesList = function () {
      return this.setInstancesList([]);
    }, proto.threads.pb.FindReply.prototype.getTransactionerror = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.FindReply.prototype.setTransactionerror = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.FindByIDRequest.prototype.toObject = function (e) {
      return proto.threads.pb.FindByIDRequest.toObject(e, this);
    }, proto.threads.pb.FindByIDRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        collectionname: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
        instanceid: googleProtobuf.Message.getFieldWithDefault(t, 3, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.FindByIDRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.FindByIDRequest();
      return proto.threads.pb.FindByIDRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.FindByIDRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setCollectionname(r);
            break;
          case 3:
            r = t.readString();
            e.setInstanceid(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.FindByIDRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.FindByIDRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.FindByIDRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getCollectionname()).length > 0 && t.writeString(2, r), (r = e.getInstanceid()).length > 0 && t.writeString(3, r);
    }, proto.threads.pb.FindByIDRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.FindByIDRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.FindByIDRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.FindByIDRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.FindByIDRequest.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.FindByIDRequest.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.FindByIDRequest.prototype.getInstanceid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
    }, proto.threads.pb.FindByIDRequest.prototype.setInstanceid = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 3, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.FindByIDReply.prototype.toObject = function (e) {
      return proto.threads.pb.FindByIDReply.toObject(e, this);
    }, proto.threads.pb.FindByIDReply.toObject = function (e, t) {
      var r = {
        instance: t.getInstance_asB64(),
        transactionerror: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.FindByIDReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.FindByIDReply();
      return proto.threads.pb.FindByIDReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.FindByIDReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setInstance(r);
            break;
          case 2:
            r = t.readString();
            e.setTransactionerror(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.FindByIDReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.FindByIDReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.FindByIDReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getInstance_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getTransactionerror()).length > 0 && t.writeString(2, r);
    }, proto.threads.pb.FindByIDReply.prototype.getInstance = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.FindByIDReply.prototype.getInstance_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getInstance());
    }, proto.threads.pb.FindByIDReply.prototype.getInstance_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getInstance());
    }, proto.threads.pb.FindByIDReply.prototype.setInstance = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.FindByIDReply.prototype.getTransactionerror = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.FindByIDReply.prototype.setTransactionerror = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.DiscardRequest.prototype.toObject = function (e) {
      return proto.threads.pb.DiscardRequest.toObject(e, this);
    }, proto.threads.pb.DiscardRequest.toObject = function (e, t) {
      var r = {};
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.DiscardRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.DiscardRequest();
      return proto.threads.pb.DiscardRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.DiscardRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        t.getFieldNumber();
        t.skipField();
      }
      return e;
    }, proto.threads.pb.DiscardRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.DiscardRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.DiscardRequest.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.DiscardReply.prototype.toObject = function (e) {
      return proto.threads.pb.DiscardReply.toObject(e, this);
    }, proto.threads.pb.DiscardReply.toObject = function (e, t) {
      var r = {};
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.DiscardReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.DiscardReply();
      return proto.threads.pb.DiscardReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.DiscardReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        t.getFieldNumber();
        t.skipField();
      }
      return e;
    }, proto.threads.pb.DiscardReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.DiscardReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.DiscardReply.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.StartTransactionRequest.prototype.toObject = function (e) {
      return proto.threads.pb.StartTransactionRequest.toObject(e, this);
    }, proto.threads.pb.StartTransactionRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        collectionname: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.StartTransactionRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.StartTransactionRequest();
      return proto.threads.pb.StartTransactionRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.StartTransactionRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = t.readString();
            e.setCollectionname(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.StartTransactionRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.StartTransactionRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.StartTransactionRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getCollectionname()).length > 0 && t.writeString(2, r);
    }, proto.threads.pb.StartTransactionRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.StartTransactionRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.StartTransactionRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.StartTransactionRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.StartTransactionRequest.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.StartTransactionRequest.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.ReadTransactionRequest.oneofGroups_ = [[1, 2, 3, 4]], proto.threads.pb.ReadTransactionRequest.OptionCase = {
      OPTION_NOT_SET: 0,
      STARTTRANSACTIONREQUEST: 1,
      HASREQUEST: 2,
      FINDREQUEST: 3,
      FINDBYIDREQUEST: 4
    }, proto.threads.pb.ReadTransactionRequest.prototype.getOptionCase = function () {
      return googleProtobuf.Message.computeOneofCase(this, proto.threads.pb.ReadTransactionRequest.oneofGroups_[0]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ReadTransactionRequest.prototype.toObject = function (e) {
      return proto.threads.pb.ReadTransactionRequest.toObject(e, this);
    }, proto.threads.pb.ReadTransactionRequest.toObject = function (e, t) {
      var r,
        o = {
          starttransactionrequest: (r = t.getStarttransactionrequest()) && proto.threads.pb.StartTransactionRequest.toObject(e, r),
          hasrequest: (r = t.getHasrequest()) && proto.threads.pb.HasRequest.toObject(e, r),
          findrequest: (r = t.getFindrequest()) && proto.threads.pb.FindRequest.toObject(e, r),
          findbyidrequest: (r = t.getFindbyidrequest()) && proto.threads.pb.FindByIDRequest.toObject(e, r)
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.ReadTransactionRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ReadTransactionRequest();
      return proto.threads.pb.ReadTransactionRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ReadTransactionRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = new proto.threads.pb.StartTransactionRequest();
            t.readMessage(r, proto.threads.pb.StartTransactionRequest.deserializeBinaryFromReader), e.setStarttransactionrequest(r);
            break;
          case 2:
            r = new proto.threads.pb.HasRequest();
            t.readMessage(r, proto.threads.pb.HasRequest.deserializeBinaryFromReader), e.setHasrequest(r);
            break;
          case 3:
            r = new proto.threads.pb.FindRequest();
            t.readMessage(r, proto.threads.pb.FindRequest.deserializeBinaryFromReader), e.setFindrequest(r);
            break;
          case 4:
            r = new proto.threads.pb.FindByIDRequest();
            t.readMessage(r, proto.threads.pb.FindByIDRequest.deserializeBinaryFromReader), e.setFindbyidrequest(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.ReadTransactionRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ReadTransactionRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ReadTransactionRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      null != (r = e.getStarttransactionrequest()) && t.writeMessage(1, r, proto.threads.pb.StartTransactionRequest.serializeBinaryToWriter), null != (r = e.getHasrequest()) && t.writeMessage(2, r, proto.threads.pb.HasRequest.serializeBinaryToWriter), null != (r = e.getFindrequest()) && t.writeMessage(3, r, proto.threads.pb.FindRequest.serializeBinaryToWriter), null != (r = e.getFindbyidrequest()) && t.writeMessage(4, r, proto.threads.pb.FindByIDRequest.serializeBinaryToWriter);
    }, proto.threads.pb.ReadTransactionRequest.prototype.getStarttransactionrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.StartTransactionRequest, 1);
    }, proto.threads.pb.ReadTransactionRequest.prototype.setStarttransactionrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 1, proto.threads.pb.ReadTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.ReadTransactionRequest.prototype.clearStarttransactionrequest = function () {
      return this.setStarttransactionrequest(void 0);
    }, proto.threads.pb.ReadTransactionRequest.prototype.hasStarttransactionrequest = function () {
      return null != googleProtobuf.Message.getField(this, 1);
    }, proto.threads.pb.ReadTransactionRequest.prototype.getHasrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.HasRequest, 2);
    }, proto.threads.pb.ReadTransactionRequest.prototype.setHasrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 2, proto.threads.pb.ReadTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.ReadTransactionRequest.prototype.clearHasrequest = function () {
      return this.setHasrequest(void 0);
    }, proto.threads.pb.ReadTransactionRequest.prototype.hasHasrequest = function () {
      return null != googleProtobuf.Message.getField(this, 2);
    }, proto.threads.pb.ReadTransactionRequest.prototype.getFindrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.FindRequest, 3);
    }, proto.threads.pb.ReadTransactionRequest.prototype.setFindrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 3, proto.threads.pb.ReadTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.ReadTransactionRequest.prototype.clearFindrequest = function () {
      return this.setFindrequest(void 0);
    }, proto.threads.pb.ReadTransactionRequest.prototype.hasFindrequest = function () {
      return null != googleProtobuf.Message.getField(this, 3);
    }, proto.threads.pb.ReadTransactionRequest.prototype.getFindbyidrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.FindByIDRequest, 4);
    }, proto.threads.pb.ReadTransactionRequest.prototype.setFindbyidrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 4, proto.threads.pb.ReadTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.ReadTransactionRequest.prototype.clearFindbyidrequest = function () {
      return this.setFindbyidrequest(void 0);
    }, proto.threads.pb.ReadTransactionRequest.prototype.hasFindbyidrequest = function () {
      return null != googleProtobuf.Message.getField(this, 4);
    }, proto.threads.pb.ReadTransactionReply.oneofGroups_ = [[1, 2, 3]], proto.threads.pb.ReadTransactionReply.OptionCase = {
      OPTION_NOT_SET: 0,
      HASREPLY: 1,
      FINDREPLY: 2,
      FINDBYIDREPLY: 3
    }, proto.threads.pb.ReadTransactionReply.prototype.getOptionCase = function () {
      return googleProtobuf.Message.computeOneofCase(this, proto.threads.pb.ReadTransactionReply.oneofGroups_[0]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ReadTransactionReply.prototype.toObject = function (e) {
      return proto.threads.pb.ReadTransactionReply.toObject(e, this);
    }, proto.threads.pb.ReadTransactionReply.toObject = function (e, t) {
      var r,
        o = {
          hasreply: (r = t.getHasreply()) && proto.threads.pb.HasReply.toObject(e, r),
          findreply: (r = t.getFindreply()) && proto.threads.pb.FindReply.toObject(e, r),
          findbyidreply: (r = t.getFindbyidreply()) && proto.threads.pb.FindByIDReply.toObject(e, r)
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.ReadTransactionReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ReadTransactionReply();
      return proto.threads.pb.ReadTransactionReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ReadTransactionReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = new proto.threads.pb.HasReply();
            t.readMessage(r, proto.threads.pb.HasReply.deserializeBinaryFromReader), e.setHasreply(r);
            break;
          case 2:
            r = new proto.threads.pb.FindReply();
            t.readMessage(r, proto.threads.pb.FindReply.deserializeBinaryFromReader), e.setFindreply(r);
            break;
          case 3:
            r = new proto.threads.pb.FindByIDReply();
            t.readMessage(r, proto.threads.pb.FindByIDReply.deserializeBinaryFromReader), e.setFindbyidreply(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.ReadTransactionReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ReadTransactionReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ReadTransactionReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      null != (r = e.getHasreply()) && t.writeMessage(1, r, proto.threads.pb.HasReply.serializeBinaryToWriter), null != (r = e.getFindreply()) && t.writeMessage(2, r, proto.threads.pb.FindReply.serializeBinaryToWriter), null != (r = e.getFindbyidreply()) && t.writeMessage(3, r, proto.threads.pb.FindByIDReply.serializeBinaryToWriter);
    }, proto.threads.pb.ReadTransactionReply.prototype.getHasreply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.HasReply, 1);
    }, proto.threads.pb.ReadTransactionReply.prototype.setHasreply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 1, proto.threads.pb.ReadTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.ReadTransactionReply.prototype.clearHasreply = function () {
      return this.setHasreply(void 0);
    }, proto.threads.pb.ReadTransactionReply.prototype.hasHasreply = function () {
      return null != googleProtobuf.Message.getField(this, 1);
    }, proto.threads.pb.ReadTransactionReply.prototype.getFindreply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.FindReply, 2);
    }, proto.threads.pb.ReadTransactionReply.prototype.setFindreply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 2, proto.threads.pb.ReadTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.ReadTransactionReply.prototype.clearFindreply = function () {
      return this.setFindreply(void 0);
    }, proto.threads.pb.ReadTransactionReply.prototype.hasFindreply = function () {
      return null != googleProtobuf.Message.getField(this, 2);
    }, proto.threads.pb.ReadTransactionReply.prototype.getFindbyidreply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.FindByIDReply, 3);
    }, proto.threads.pb.ReadTransactionReply.prototype.setFindbyidreply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 3, proto.threads.pb.ReadTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.ReadTransactionReply.prototype.clearFindbyidreply = function () {
      return this.setFindbyidreply(void 0);
    }, proto.threads.pb.ReadTransactionReply.prototype.hasFindbyidreply = function () {
      return null != googleProtobuf.Message.getField(this, 3);
    }, proto.threads.pb.WriteTransactionRequest.oneofGroups_ = [[1, 2, 8, 3, 4, 5, 6, 7, 9]], proto.threads.pb.WriteTransactionRequest.OptionCase = {
      OPTION_NOT_SET: 0,
      STARTTRANSACTIONREQUEST: 1,
      CREATEREQUEST: 2,
      VERIFYREQUEST: 8,
      SAVEREQUEST: 3,
      DELETEREQUEST: 4,
      HASREQUEST: 5,
      FINDREQUEST: 6,
      FINDBYIDREQUEST: 7,
      DISCARDREQUEST: 9
    }, proto.threads.pb.WriteTransactionRequest.prototype.getOptionCase = function () {
      return googleProtobuf.Message.computeOneofCase(this, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.WriteTransactionRequest.prototype.toObject = function (e) {
      return proto.threads.pb.WriteTransactionRequest.toObject(e, this);
    }, proto.threads.pb.WriteTransactionRequest.toObject = function (e, t) {
      var r,
        o = {
          starttransactionrequest: (r = t.getStarttransactionrequest()) && proto.threads.pb.StartTransactionRequest.toObject(e, r),
          createrequest: (r = t.getCreaterequest()) && proto.threads.pb.CreateRequest.toObject(e, r),
          verifyrequest: (r = t.getVerifyrequest()) && proto.threads.pb.VerifyRequest.toObject(e, r),
          saverequest: (r = t.getSaverequest()) && proto.threads.pb.SaveRequest.toObject(e, r),
          deleterequest: (r = t.getDeleterequest()) && proto.threads.pb.DeleteRequest.toObject(e, r),
          hasrequest: (r = t.getHasrequest()) && proto.threads.pb.HasRequest.toObject(e, r),
          findrequest: (r = t.getFindrequest()) && proto.threads.pb.FindRequest.toObject(e, r),
          findbyidrequest: (r = t.getFindbyidrequest()) && proto.threads.pb.FindByIDRequest.toObject(e, r),
          discardrequest: (r = t.getDiscardrequest()) && proto.threads.pb.DiscardRequest.toObject(e, r)
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.WriteTransactionRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.WriteTransactionRequest();
      return proto.threads.pb.WriteTransactionRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.WriteTransactionRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = new proto.threads.pb.StartTransactionRequest();
            t.readMessage(r, proto.threads.pb.StartTransactionRequest.deserializeBinaryFromReader), e.setStarttransactionrequest(r);
            break;
          case 2:
            r = new proto.threads.pb.CreateRequest();
            t.readMessage(r, proto.threads.pb.CreateRequest.deserializeBinaryFromReader), e.setCreaterequest(r);
            break;
          case 8:
            r = new proto.threads.pb.VerifyRequest();
            t.readMessage(r, proto.threads.pb.VerifyRequest.deserializeBinaryFromReader), e.setVerifyrequest(r);
            break;
          case 3:
            r = new proto.threads.pb.SaveRequest();
            t.readMessage(r, proto.threads.pb.SaveRequest.deserializeBinaryFromReader), e.setSaverequest(r);
            break;
          case 4:
            r = new proto.threads.pb.DeleteRequest();
            t.readMessage(r, proto.threads.pb.DeleteRequest.deserializeBinaryFromReader), e.setDeleterequest(r);
            break;
          case 5:
            r = new proto.threads.pb.HasRequest();
            t.readMessage(r, proto.threads.pb.HasRequest.deserializeBinaryFromReader), e.setHasrequest(r);
            break;
          case 6:
            r = new proto.threads.pb.FindRequest();
            t.readMessage(r, proto.threads.pb.FindRequest.deserializeBinaryFromReader), e.setFindrequest(r);
            break;
          case 7:
            r = new proto.threads.pb.FindByIDRequest();
            t.readMessage(r, proto.threads.pb.FindByIDRequest.deserializeBinaryFromReader), e.setFindbyidrequest(r);
            break;
          case 9:
            r = new proto.threads.pb.DiscardRequest();
            t.readMessage(r, proto.threads.pb.DiscardRequest.deserializeBinaryFromReader), e.setDiscardrequest(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.WriteTransactionRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.WriteTransactionRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.WriteTransactionRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      null != (r = e.getStarttransactionrequest()) && t.writeMessage(1, r, proto.threads.pb.StartTransactionRequest.serializeBinaryToWriter), null != (r = e.getCreaterequest()) && t.writeMessage(2, r, proto.threads.pb.CreateRequest.serializeBinaryToWriter), null != (r = e.getVerifyrequest()) && t.writeMessage(8, r, proto.threads.pb.VerifyRequest.serializeBinaryToWriter), null != (r = e.getSaverequest()) && t.writeMessage(3, r, proto.threads.pb.SaveRequest.serializeBinaryToWriter), null != (r = e.getDeleterequest()) && t.writeMessage(4, r, proto.threads.pb.DeleteRequest.serializeBinaryToWriter), null != (r = e.getHasrequest()) && t.writeMessage(5, r, proto.threads.pb.HasRequest.serializeBinaryToWriter), null != (r = e.getFindrequest()) && t.writeMessage(6, r, proto.threads.pb.FindRequest.serializeBinaryToWriter), null != (r = e.getFindbyidrequest()) && t.writeMessage(7, r, proto.threads.pb.FindByIDRequest.serializeBinaryToWriter), null != (r = e.getDiscardrequest()) && t.writeMessage(9, r, proto.threads.pb.DiscardRequest.serializeBinaryToWriter);
    }, proto.threads.pb.WriteTransactionRequest.prototype.getStarttransactionrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.StartTransactionRequest, 1);
    }, proto.threads.pb.WriteTransactionRequest.prototype.setStarttransactionrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 1, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionRequest.prototype.clearStarttransactionrequest = function () {
      return this.setStarttransactionrequest(void 0);
    }, proto.threads.pb.WriteTransactionRequest.prototype.hasStarttransactionrequest = function () {
      return null != googleProtobuf.Message.getField(this, 1);
    }, proto.threads.pb.WriteTransactionRequest.prototype.getCreaterequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.CreateRequest, 2);
    }, proto.threads.pb.WriteTransactionRequest.prototype.setCreaterequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 2, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionRequest.prototype.clearCreaterequest = function () {
      return this.setCreaterequest(void 0);
    }, proto.threads.pb.WriteTransactionRequest.prototype.hasCreaterequest = function () {
      return null != googleProtobuf.Message.getField(this, 2);
    }, proto.threads.pb.WriteTransactionRequest.prototype.getVerifyrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.VerifyRequest, 8);
    }, proto.threads.pb.WriteTransactionRequest.prototype.setVerifyrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 8, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionRequest.prototype.clearVerifyrequest = function () {
      return this.setVerifyrequest(void 0);
    }, proto.threads.pb.WriteTransactionRequest.prototype.hasVerifyrequest = function () {
      return null != googleProtobuf.Message.getField(this, 8);
    }, proto.threads.pb.WriteTransactionRequest.prototype.getSaverequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.SaveRequest, 3);
    }, proto.threads.pb.WriteTransactionRequest.prototype.setSaverequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 3, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionRequest.prototype.clearSaverequest = function () {
      return this.setSaverequest(void 0);
    }, proto.threads.pb.WriteTransactionRequest.prototype.hasSaverequest = function () {
      return null != googleProtobuf.Message.getField(this, 3);
    }, proto.threads.pb.WriteTransactionRequest.prototype.getDeleterequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.DeleteRequest, 4);
    }, proto.threads.pb.WriteTransactionRequest.prototype.setDeleterequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 4, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionRequest.prototype.clearDeleterequest = function () {
      return this.setDeleterequest(void 0);
    }, proto.threads.pb.WriteTransactionRequest.prototype.hasDeleterequest = function () {
      return null != googleProtobuf.Message.getField(this, 4);
    };
    proto.threads.pb.WriteTransactionRequest.prototype.getHasrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.HasRequest, 5);
    }, proto.threads.pb.WriteTransactionRequest.prototype.setHasrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 5, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionRequest.prototype.clearHasrequest = function () {
      return this.setHasrequest(void 0);
    }, proto.threads.pb.WriteTransactionRequest.prototype.hasHasrequest = function () {
      return null != googleProtobuf.Message.getField(this, 5);
    }, proto.threads.pb.WriteTransactionRequest.prototype.getFindrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.FindRequest, 6);
    }, proto.threads.pb.WriteTransactionRequest.prototype.setFindrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 6, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionRequest.prototype.clearFindrequest = function () {
      return this.setFindrequest(void 0);
    }, proto.threads.pb.WriteTransactionRequest.prototype.hasFindrequest = function () {
      return null != googleProtobuf.Message.getField(this, 6);
    }, proto.threads.pb.WriteTransactionRequest.prototype.getFindbyidrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.FindByIDRequest, 7);
    }, proto.threads.pb.WriteTransactionRequest.prototype.setFindbyidrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 7, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionRequest.prototype.clearFindbyidrequest = function () {
      return this.setFindbyidrequest(void 0);
    }, proto.threads.pb.WriteTransactionRequest.prototype.hasFindbyidrequest = function () {
      return null != googleProtobuf.Message.getField(this, 7);
    }, proto.threads.pb.WriteTransactionRequest.prototype.getDiscardrequest = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.DiscardRequest, 9);
    }, proto.threads.pb.WriteTransactionRequest.prototype.setDiscardrequest = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 9, proto.threads.pb.WriteTransactionRequest.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionRequest.prototype.clearDiscardrequest = function () {
      return this.setDiscardrequest(void 0);
    }, proto.threads.pb.WriteTransactionRequest.prototype.hasDiscardrequest = function () {
      return null != googleProtobuf.Message.getField(this, 9);
    }, proto.threads.pb.WriteTransactionReply.oneofGroups_ = [[1, 7, 2, 3, 4, 5, 6, 8]], proto.threads.pb.WriteTransactionReply.OptionCase = {
      OPTION_NOT_SET: 0,
      CREATEREPLY: 1,
      VERIFYREPLY: 7,
      SAVEREPLY: 2,
      DELETEREPLY: 3,
      HASREPLY: 4,
      FINDREPLY: 5,
      FINDBYIDREPLY: 6,
      DISCARDREPLY: 8
    }, proto.threads.pb.WriteTransactionReply.prototype.getOptionCase = function () {
      return googleProtobuf.Message.computeOneofCase(this, proto.threads.pb.WriteTransactionReply.oneofGroups_[0]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.WriteTransactionReply.prototype.toObject = function (e) {
      return proto.threads.pb.WriteTransactionReply.toObject(e, this);
    }, proto.threads.pb.WriteTransactionReply.toObject = function (e, t) {
      var r,
        o = {
          createreply: (r = t.getCreatereply()) && proto.threads.pb.CreateReply.toObject(e, r),
          verifyreply: (r = t.getVerifyreply()) && proto.threads.pb.VerifyReply.toObject(e, r),
          savereply: (r = t.getSavereply()) && proto.threads.pb.SaveReply.toObject(e, r),
          deletereply: (r = t.getDeletereply()) && proto.threads.pb.DeleteReply.toObject(e, r),
          hasreply: (r = t.getHasreply()) && proto.threads.pb.HasReply.toObject(e, r),
          findreply: (r = t.getFindreply()) && proto.threads.pb.FindReply.toObject(e, r),
          findbyidreply: (r = t.getFindbyidreply()) && proto.threads.pb.FindByIDReply.toObject(e, r),
          discardreply: (r = t.getDiscardreply()) && proto.threads.pb.DiscardReply.toObject(e, r)
        };
      return e && (o.$jspbMessageInstance = t), o;
    }), proto.threads.pb.WriteTransactionReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.WriteTransactionReply();
      return proto.threads.pb.WriteTransactionReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.WriteTransactionReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = new proto.threads.pb.CreateReply();
            t.readMessage(r, proto.threads.pb.CreateReply.deserializeBinaryFromReader), e.setCreatereply(r);
            break;
          case 7:
            r = new proto.threads.pb.VerifyReply();
            t.readMessage(r, proto.threads.pb.VerifyReply.deserializeBinaryFromReader), e.setVerifyreply(r);
            break;
          case 2:
            r = new proto.threads.pb.SaveReply();
            t.readMessage(r, proto.threads.pb.SaveReply.deserializeBinaryFromReader), e.setSavereply(r);
            break;
          case 3:
            r = new proto.threads.pb.DeleteReply();
            t.readMessage(r, proto.threads.pb.DeleteReply.deserializeBinaryFromReader), e.setDeletereply(r);
            break;
          case 4:
            r = new proto.threads.pb.HasReply();
            t.readMessage(r, proto.threads.pb.HasReply.deserializeBinaryFromReader), e.setHasreply(r);
            break;
          case 5:
            r = new proto.threads.pb.FindReply();
            t.readMessage(r, proto.threads.pb.FindReply.deserializeBinaryFromReader), e.setFindreply(r);
            break;
          case 6:
            r = new proto.threads.pb.FindByIDReply();
            t.readMessage(r, proto.threads.pb.FindByIDReply.deserializeBinaryFromReader), e.setFindbyidreply(r);
            break;
          case 8:
            r = new proto.threads.pb.DiscardReply();
            t.readMessage(r, proto.threads.pb.DiscardReply.deserializeBinaryFromReader), e.setDiscardreply(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.WriteTransactionReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.WriteTransactionReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.WriteTransactionReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      null != (r = e.getCreatereply()) && t.writeMessage(1, r, proto.threads.pb.CreateReply.serializeBinaryToWriter), null != (r = e.getVerifyreply()) && t.writeMessage(7, r, proto.threads.pb.VerifyReply.serializeBinaryToWriter), null != (r = e.getSavereply()) && t.writeMessage(2, r, proto.threads.pb.SaveReply.serializeBinaryToWriter), null != (r = e.getDeletereply()) && t.writeMessage(3, r, proto.threads.pb.DeleteReply.serializeBinaryToWriter), null != (r = e.getHasreply()) && t.writeMessage(4, r, proto.threads.pb.HasReply.serializeBinaryToWriter), null != (r = e.getFindreply()) && t.writeMessage(5, r, proto.threads.pb.FindReply.serializeBinaryToWriter), null != (r = e.getFindbyidreply()) && t.writeMessage(6, r, proto.threads.pb.FindByIDReply.serializeBinaryToWriter), null != (r = e.getDiscardreply()) && t.writeMessage(8, r, proto.threads.pb.DiscardReply.serializeBinaryToWriter);
    }, proto.threads.pb.WriteTransactionReply.prototype.getCreatereply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.CreateReply, 1);
    }, proto.threads.pb.WriteTransactionReply.prototype.setCreatereply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 1, proto.threads.pb.WriteTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionReply.prototype.clearCreatereply = function () {
      return this.setCreatereply(void 0);
    }, proto.threads.pb.WriteTransactionReply.prototype.hasCreatereply = function () {
      return null != googleProtobuf.Message.getField(this, 1);
    }, proto.threads.pb.WriteTransactionReply.prototype.getVerifyreply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.VerifyReply, 7);
    }, proto.threads.pb.WriteTransactionReply.prototype.setVerifyreply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 7, proto.threads.pb.WriteTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionReply.prototype.clearVerifyreply = function () {
      return this.setVerifyreply(void 0);
    }, proto.threads.pb.WriteTransactionReply.prototype.hasVerifyreply = function () {
      return null != googleProtobuf.Message.getField(this, 7);
    }, proto.threads.pb.WriteTransactionReply.prototype.getSavereply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.SaveReply, 2);
    }, proto.threads.pb.WriteTransactionReply.prototype.setSavereply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 2, proto.threads.pb.WriteTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionReply.prototype.clearSavereply = function () {
      return this.setSavereply(void 0);
    }, proto.threads.pb.WriteTransactionReply.prototype.hasSavereply = function () {
      return null != googleProtobuf.Message.getField(this, 2);
    }, proto.threads.pb.WriteTransactionReply.prototype.getDeletereply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.DeleteReply, 3);
    }, proto.threads.pb.WriteTransactionReply.prototype.setDeletereply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 3, proto.threads.pb.WriteTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionReply.prototype.clearDeletereply = function () {
      return this.setDeletereply(void 0);
    }, proto.threads.pb.WriteTransactionReply.prototype.hasDeletereply = function () {
      return null != googleProtobuf.Message.getField(this, 3);
    }, proto.threads.pb.WriteTransactionReply.prototype.getHasreply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.HasReply, 4);
    }, proto.threads.pb.WriteTransactionReply.prototype.setHasreply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 4, proto.threads.pb.WriteTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionReply.prototype.clearHasreply = function () {
      return this.setHasreply(void 0);
    }, proto.threads.pb.WriteTransactionReply.prototype.hasHasreply = function () {
      return null != googleProtobuf.Message.getField(this, 4);
    }, proto.threads.pb.WriteTransactionReply.prototype.getFindreply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.FindReply, 5);
    }, proto.threads.pb.WriteTransactionReply.prototype.setFindreply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 5, proto.threads.pb.WriteTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionReply.prototype.clearFindreply = function () {
      return this.setFindreply(void 0);
    }, proto.threads.pb.WriteTransactionReply.prototype.hasFindreply = function () {
      return null != googleProtobuf.Message.getField(this, 5);
    }, proto.threads.pb.WriteTransactionReply.prototype.getFindbyidreply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.FindByIDReply, 6);
    }, proto.threads.pb.WriteTransactionReply.prototype.setFindbyidreply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 6, proto.threads.pb.WriteTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionReply.prototype.clearFindbyidreply = function () {
      return this.setFindbyidreply(void 0);
    }, proto.threads.pb.WriteTransactionReply.prototype.hasFindbyidreply = function () {
      return null != googleProtobuf.Message.getField(this, 6);
    }, proto.threads.pb.WriteTransactionReply.prototype.getDiscardreply = function () {
      return googleProtobuf.Message.getWrapperField(this, proto.threads.pb.DiscardReply, 8);
    }, proto.threads.pb.WriteTransactionReply.prototype.setDiscardreply = function (e) {
      return googleProtobuf.Message.setOneofWrapperField(this, 8, proto.threads.pb.WriteTransactionReply.oneofGroups_[0], e);
    }, proto.threads.pb.WriteTransactionReply.prototype.clearDiscardreply = function () {
      return this.setDiscardreply(void 0);
    }, proto.threads.pb.WriteTransactionReply.prototype.hasDiscardreply = function () {
      return null != googleProtobuf.Message.getField(this, 8);
    }, proto.threads.pb.ListenRequest.repeatedFields_ = [2], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ListenRequest.prototype.toObject = function (e) {
      return proto.threads.pb.ListenRequest.toObject(e, this);
    }, proto.threads.pb.ListenRequest.toObject = function (e, t) {
      var r = {
        dbid: t.getDbid_asB64(),
        filtersList: googleProtobuf.Message.toObjectList(t.getFiltersList(), proto.threads.pb.ListenRequest.Filter.toObject, e)
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.ListenRequest.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ListenRequest();
      return proto.threads.pb.ListenRequest.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ListenRequest.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readBytes();
            e.setDbid(r);
            break;
          case 2:
            r = new proto.threads.pb.ListenRequest.Filter();
            t.readMessage(r, proto.threads.pb.ListenRequest.Filter.deserializeBinaryFromReader), e.addFilters(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.ListenRequest.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ListenRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ListenRequest.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getDbid_asU8()).length > 0 && t.writeBytes(1, r), (r = e.getFiltersList()).length > 0 && t.writeRepeatedMessage(2, r, proto.threads.pb.ListenRequest.Filter.serializeBinaryToWriter);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ListenRequest.Filter.prototype.toObject = function (e) {
      return proto.threads.pb.ListenRequest.Filter.toObject(e, this);
    }, proto.threads.pb.ListenRequest.Filter.toObject = function (e, t) {
      var r = {
        collectionname: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
        instanceid: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
        action: googleProtobuf.Message.getFieldWithDefault(t, 3, 0)
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.ListenRequest.Filter.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ListenRequest.Filter();
      return proto.threads.pb.ListenRequest.Filter.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ListenRequest.Filter.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.setCollectionname(r);
            break;
          case 2:
            r = t.readString();
            e.setInstanceid(r);
            break;
          case 3:
            r = t.readEnum();
            e.setAction(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.ListenRequest.Filter.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ListenRequest.Filter.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ListenRequest.Filter.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getCollectionname()).length > 0 && t.writeString(1, r), (r = e.getInstanceid()).length > 0 && t.writeString(2, r), 0 !== (r = e.getAction()) && t.writeEnum(3, r);
    }, proto.threads.pb.ListenRequest.Filter.Action = {
      ALL: 0,
      CREATE: 1,
      SAVE: 2,
      DELETE: 3
    }, proto.threads.pb.ListenRequest.Filter.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.ListenRequest.Filter.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 1, e);
    }, proto.threads.pb.ListenRequest.Filter.prototype.getInstanceid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.ListenRequest.Filter.prototype.setInstanceid = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.ListenRequest.Filter.prototype.getAction = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 3, 0);
    }, proto.threads.pb.ListenRequest.Filter.prototype.setAction = function (e) {
      return googleProtobuf.Message.setProto3EnumField(this, 3, e);
    }, proto.threads.pb.ListenRequest.prototype.getDbid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.ListenRequest.prototype.getDbid_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getDbid());
    }, proto.threads.pb.ListenRequest.prototype.getDbid_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getDbid());
    }, proto.threads.pb.ListenRequest.prototype.setDbid = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 1, e);
    }, proto.threads.pb.ListenRequest.prototype.getFiltersList = function () {
      return googleProtobuf.Message.getRepeatedWrapperField(this, proto.threads.pb.ListenRequest.Filter, 2);
    }, proto.threads.pb.ListenRequest.prototype.setFiltersList = function (e) {
      return googleProtobuf.Message.setRepeatedWrapperField(this, 2, e);
    }, proto.threads.pb.ListenRequest.prototype.addFilters = function (e, t) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, e, proto.threads.pb.ListenRequest.Filter, t);
    }, proto.threads.pb.ListenRequest.prototype.clearFiltersList = function () {
      return this.setFiltersList([]);
    }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.threads.pb.ListenReply.prototype.toObject = function (e) {
      return proto.threads.pb.ListenReply.toObject(e, this);
    }, proto.threads.pb.ListenReply.toObject = function (e, t) {
      var r = {
        collectionname: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
        instanceid: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
        action: googleProtobuf.Message.getFieldWithDefault(t, 3, 0),
        instance: t.getInstance_asB64()
      };
      return e && (r.$jspbMessageInstance = t), r;
    }), proto.threads.pb.ListenReply.deserializeBinary = function (e) {
      var t = new googleProtobuf.BinaryReader(e),
        r = new proto.threads.pb.ListenReply();
      return proto.threads.pb.ListenReply.deserializeBinaryFromReader(r, t);
    }, proto.threads.pb.ListenReply.deserializeBinaryFromReader = function (e, t) {
      for (; t.nextField() && !t.isEndGroup();) {
        switch (t.getFieldNumber()) {
          case 1:
            var r = t.readString();
            e.setCollectionname(r);
            break;
          case 2:
            r = t.readString();
            e.setInstanceid(r);
            break;
          case 3:
            r = t.readEnum();
            e.setAction(r);
            break;
          case 4:
            r = t.readBytes();
            e.setInstance(r);
            break;
          default:
            t.skipField();
        }
      }
      return e;
    }, proto.threads.pb.ListenReply.prototype.serializeBinary = function () {
      var e = new googleProtobuf.BinaryWriter();
      return proto.threads.pb.ListenReply.serializeBinaryToWriter(this, e), e.getResultBuffer();
    }, proto.threads.pb.ListenReply.serializeBinaryToWriter = function (e, t) {
      var r = void 0;
      (r = e.getCollectionname()).length > 0 && t.writeString(1, r), (r = e.getInstanceid()).length > 0 && t.writeString(2, r), 0 !== (r = e.getAction()) && t.writeEnum(3, r), (r = e.getInstance_asU8()).length > 0 && t.writeBytes(4, r);
    }, proto.threads.pb.ListenReply.Action = {
      CREATE: 0,
      SAVE: 1,
      DELETE: 2
    }, proto.threads.pb.ListenReply.prototype.getCollectionname = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
    }, proto.threads.pb.ListenReply.prototype.setCollectionname = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 1, e);
    }, proto.threads.pb.ListenReply.prototype.getInstanceid = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
    }, proto.threads.pb.ListenReply.prototype.setInstanceid = function (e) {
      return googleProtobuf.Message.setProto3StringField(this, 2, e);
    }, proto.threads.pb.ListenReply.prototype.getAction = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 3, 0);
    }, proto.threads.pb.ListenReply.prototype.setAction = function (e) {
      return googleProtobuf.Message.setProto3EnumField(this, 3, e);
    }, proto.threads.pb.ListenReply.prototype.getInstance = function () {
      return googleProtobuf.Message.getFieldWithDefault(this, 4, "");
    }, proto.threads.pb.ListenReply.prototype.getInstance_asB64 = function () {
      return googleProtobuf.Message.bytesAsB64(this.getInstance());
    }, proto.threads.pb.ListenReply.prototype.getInstance_asU8 = function () {
      return googleProtobuf.Message.bytesAsU8(this.getInstance());
    }, proto.threads.pb.ListenReply.prototype.setInstance = function (e) {
      return googleProtobuf.Message.setProto3BytesField(this, 4, e);
    }, r.object.extend(t, proto.threads.pb);
  }),
  grpcWebClient_umd$1 = createCommonjsModule(function (e, t) {
    e.exports = function (e) {
      var t = {};
      function r(o) {
        if (t[o]) return t[o].exports;
        var n = t[o] = {
          i: o,
          l: !1,
          exports: {}
        };
        return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
      }
      return r.m = e, r.c = t, r.d = function (e, t, o) {
        r.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: o
        });
      }, r.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, r.t = function (e, t) {
        if (1 & t && (e = r(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var o = Object.create(null);
        if (r.r(o), Object.defineProperty(o, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var n in e) r.d(o, n, function (t) {
          return e[t];
        }.bind(null, n));
        return o;
      }, r.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return r.d(t, "a", t), t;
      }, r.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, r.p = "", r(r.s = 10);
    }([function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = r(3);
      t.Metadata = o.BrowserHeaders;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.debug = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        console.debug ? console.debug.apply(null, e) : console.log.apply(null, e);
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = r(0),
        n = r(8),
        a = r(9),
        i = r(1),
        s = r(4),
        u = r(14);
      t.client = function (e, t) {
        return new l(e, t);
      };
      var l = function () {
        function e(e, t) {
          this.started = !1, this.sentFirstMessage = !1, this.completed = !1, this.closed = !1, this.finishedSending = !1, this.onHeadersCallbacks = [], this.onMessageCallbacks = [], this.onEndCallbacks = [], this.parser = new n.ChunkParser(), this.methodDefinition = e, this.props = t, this.createTransport();
        }
        return e.prototype.createTransport = function () {
          var e = this.props.host + "/" + this.methodDefinition.service.serviceName + "/" + this.methodDefinition.methodName,
            t = {
              methodDefinition: this.methodDefinition,
              debug: this.props.debug || !1,
              url: e,
              onHeaders: this.onTransportHeaders.bind(this),
              onChunk: this.onTransportChunk.bind(this),
              onEnd: this.onTransportEnd.bind(this)
            };
          this.props.transport ? this.transport = this.props.transport(t) : this.transport = s.makeDefaultTransport(t);
        }, e.prototype.onTransportHeaders = function (e, t) {
          if (this.props.debug && i.debug("onHeaders", e, t), this.closed) this.props.debug && i.debug("grpc.onHeaders received after request was closed - ignoring");else if (0 === t) ;else {
            this.responseHeaders = e, this.props.debug && i.debug("onHeaders.responseHeaders", JSON.stringify(this.responseHeaders, null, 2));
            var r = c(e);
            this.props.debug && i.debug("onHeaders.gRPCStatus", r);
            var o = r && r >= 0 ? r : a.httpStatusToCode(t);
            this.props.debug && i.debug("onHeaders.code", o);
            var n = e.get("grpc-message") || [];
            if (this.props.debug && i.debug("onHeaders.gRPCMessage", n), this.rawOnHeaders(e), o !== a.Code.OK) {
              var s = this.decodeGRPCStatus(n[0]);
              this.rawOnError(o, s, e);
            }
          }
        }, e.prototype.onTransportChunk = function (e) {
          var t = this;
          if (this.closed) this.props.debug && i.debug("grpc.onChunk received after request was closed - ignoring");else {
            var r = [];
            try {
              r = this.parser.parse(e);
            } catch (e) {
              return this.props.debug && i.debug("onChunk.parsing error", e, e.message), void this.rawOnError(a.Code.Internal, "parsing error: " + e.message);
            }
            r.forEach(function (e) {
              if (e.chunkType === n.ChunkType.MESSAGE) {
                var r = t.methodDefinition.responseType.deserializeBinary(e.data);
                t.rawOnMessage(r);
              } else e.chunkType === n.ChunkType.TRAILERS && (t.responseHeaders ? (t.responseTrailers = new o.Metadata(e.trailers), t.props.debug && i.debug("onChunk.trailers", t.responseTrailers)) : (t.responseHeaders = new o.Metadata(e.trailers), t.rawOnHeaders(t.responseHeaders)));
            });
          }
        }, e.prototype.onTransportEnd = function () {
          if (this.props.debug && i.debug("grpc.onEnd"), this.closed) this.props.debug && i.debug("grpc.onEnd received after request was closed - ignoring");else if (void 0 !== this.responseTrailers) {
            var e = c(this.responseTrailers);
            if (null !== e) {
              var t = this.responseTrailers.get("grpc-message"),
                r = this.decodeGRPCStatus(t[0]);
              this.rawOnEnd(e, r, this.responseTrailers);
            } else this.rawOnError(a.Code.Internal, "Response closed without grpc-status (Trailers provided)");
          } else {
            if (void 0 === this.responseHeaders) return void this.rawOnError(a.Code.Unknown, "Response closed without headers");
            var o = c(this.responseHeaders),
              n = this.responseHeaders.get("grpc-message");
            if (this.props.debug && i.debug("grpc.headers only response ", o, n), null === o) return void this.rawOnEnd(a.Code.Unknown, "Response closed without grpc-status (Headers only)", this.responseHeaders);
            var s = this.decodeGRPCStatus(n[0]);
            this.rawOnEnd(o, s, this.responseHeaders);
          }
        }, e.prototype.decodeGRPCStatus = function (e) {
          if (!e) return "";
          try {
            return decodeURIComponent(e);
          } catch (t) {
            return e;
          }
        }, e.prototype.rawOnEnd = function (e, t, r) {
          var o = this;
          this.props.debug && i.debug("rawOnEnd", e, t, r), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (n) {
            if (!o.closed) try {
              n(e, t, r);
            } catch (e) {
              setTimeout(function () {
                throw e;
              });
            }
          }));
        }, e.prototype.rawOnHeaders = function (e) {
          this.props.debug && i.debug("rawOnHeaders", e), this.completed || this.onHeadersCallbacks.forEach(function (t) {
            try {
              t(e);
            } catch (e) {
              setTimeout(function () {
                throw e;
              });
            }
          });
        }, e.prototype.rawOnError = function (e, t, r) {
          var n = this;
          void 0 === r && (r = new o.Metadata()), this.props.debug && i.debug("rawOnError", e, t), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (o) {
            if (!n.closed) try {
              o(e, t, r);
            } catch (e) {
              setTimeout(function () {
                throw e;
              });
            }
          }));
        }, e.prototype.rawOnMessage = function (e) {
          var t = this;
          this.props.debug && i.debug("rawOnMessage", e.toObject()), this.completed || this.closed || this.onMessageCallbacks.forEach(function (r) {
            if (!t.closed) try {
              r(e);
            } catch (e) {
              setTimeout(function () {
                throw e;
              });
            }
          });
        }, e.prototype.onHeaders = function (e) {
          this.onHeadersCallbacks.push(e);
        }, e.prototype.onMessage = function (e) {
          this.onMessageCallbacks.push(e);
        }, e.prototype.onEnd = function (e) {
          this.onEndCallbacks.push(e);
        }, e.prototype.start = function (e) {
          if (this.started) throw new Error("Client already started - cannot .start()");
          this.started = !0;
          var t = new o.Metadata(e || {});
          t.set("content-type", "application/grpc-web+proto"), t.set("x-grpc-web", "1"), this.transport.start(t);
        }, e.prototype.send = function (e) {
          if (!this.started) throw new Error("Client not started - .start() must be called before .send()");
          if (this.closed) throw new Error("Client already closed - cannot .send()");
          if (this.finishedSending) throw new Error("Client already finished sending - cannot .send()");
          if (!this.methodDefinition.requestStream && this.sentFirstMessage) throw new Error("Message already sent for non-client-streaming method - cannot .send()");
          this.sentFirstMessage = !0;
          var t = u.frameRequest(e);
          this.transport.sendMessage(t);
        }, e.prototype.finishSend = function () {
          if (!this.started) throw new Error("Client not started - .finishSend() must be called before .close()");
          if (this.closed) throw new Error("Client already closed - cannot .send()");
          if (this.finishedSending) throw new Error("Client already finished sending - cannot .finishSend()");
          this.finishedSending = !0, this.transport.finishSend();
        }, e.prototype.close = function () {
          if (!this.started) throw new Error("Client not started - .start() must be called before .close()");
          if (this.closed) throw new Error("Client already closed - cannot .close()");
          this.closed = !0, this.props.debug && i.debug("request.abort aborting request"), this.transport.cancel();
        }, e;
      }();
      function c(e) {
        var t = e.get("grpc-status") || [];
        if (t.length > 0) try {
          var r = t[0];
          return parseInt(r, 10);
        } catch (e) {
          return null;
        }
        return null;
      }
    }, function (e, t, r) {
      var o;
      o = function o() {
        return function (e) {
          var t = {};
          function r(o) {
            if (t[o]) return t[o].exports;
            var n = t[o] = {
              i: o,
              l: !1,
              exports: {}
            };
            return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
          }
          return r.m = e, r.c = t, r.i = function (e) {
            return e;
          }, r.d = function (e, t, o) {
            r.o(e, t) || Object.defineProperty(e, t, {
              configurable: !1,
              enumerable: !0,
              get: o
            });
          }, r.n = function (e) {
            var t = e && e.__esModule ? function () {
              return e.default;
            } : function () {
              return e;
            };
            return r.d(t, "a", t), t;
          }, r.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }, r.p = "", r(r.s = 1);
        }([function (e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          });
          var o = r(3),
            n = function () {
              function e(e, t) {
                void 0 === e && (e = {}), void 0 === t && (t = {
                  splitValues: !1
                });
                var r,
                  n = this;
                this.headersMap = {}, e && ("undefined" != typeof Headers && e instanceof Headers ? o.getHeaderKeys(e).forEach(function (r) {
                  o.getHeaderValues(e, r).forEach(function (e) {
                    t.splitValues ? n.append(r, o.splitHeaderValue(e)) : n.append(r, e);
                  });
                }) : "object" == typeof (r = e) && "object" == typeof r.headersMap && "function" == typeof r.forEach ? e.forEach(function (e, t) {
                  n.append(e, t);
                }) : "undefined" != typeof Map && e instanceof Map ? e.forEach(function (e, t) {
                  n.append(t, e);
                }) : "string" == typeof e ? this.appendFromString(e) : "object" == typeof e && Object.getOwnPropertyNames(e).forEach(function (t) {
                  var r = e[t];
                  Array.isArray(r) ? r.forEach(function (e) {
                    n.append(t, e);
                  }) : n.append(t, r);
                }));
              }
              return e.prototype.appendFromString = function (e) {
                for (var t = e.split("\r\n"), r = 0; r < t.length; r++) {
                  var o = t[r],
                    n = o.indexOf(":");
                  if (n > 0) {
                    var a = o.substring(0, n).trim(),
                      i = o.substring(n + 1).trim();
                    this.append(a, i);
                  }
                }
              }, e.prototype.delete = function (e, t) {
                var r = o.normalizeName(e);
                if (void 0 === t) delete this.headersMap[r];else {
                  var n = this.headersMap[r];
                  if (n) {
                    var a = n.indexOf(t);
                    a >= 0 && n.splice(a, 1), 0 === n.length && delete this.headersMap[r];
                  }
                }
              }, e.prototype.append = function (e, t) {
                var r = this,
                  n = o.normalizeName(e);
                Array.isArray(this.headersMap[n]) || (this.headersMap[n] = []), Array.isArray(t) ? t.forEach(function (e) {
                  r.headersMap[n].push(o.normalizeValue(e));
                }) : this.headersMap[n].push(o.normalizeValue(t));
              }, e.prototype.set = function (e, t) {
                var r = o.normalizeName(e);
                if (Array.isArray(t)) {
                  var n = [];
                  t.forEach(function (e) {
                    n.push(o.normalizeValue(e));
                  }), this.headersMap[r] = n;
                } else this.headersMap[r] = [o.normalizeValue(t)];
              }, e.prototype.has = function (e, t) {
                var r = this.headersMap[o.normalizeName(e)];
                if (!Array.isArray(r)) return !1;
                if (void 0 !== t) {
                  var n = o.normalizeValue(t);
                  return r.indexOf(n) >= 0;
                }
                return !0;
              }, e.prototype.get = function (e) {
                var t = this.headersMap[o.normalizeName(e)];
                return void 0 !== t ? t.concat() : [];
              }, e.prototype.forEach = function (e) {
                var t = this;
                Object.getOwnPropertyNames(this.headersMap).forEach(function (r) {
                  e(r, t.headersMap[r]);
                }, this);
              }, e.prototype.toHeaders = function () {
                if ("undefined" != typeof Headers) {
                  var e = new Headers();
                  return this.forEach(function (t, r) {
                    r.forEach(function (r) {
                      e.append(t, r);
                    });
                  }), e;
                }
                throw new Error("Headers class is not defined");
              }, e;
            }();
          t.BrowserHeaders = n;
        }, function (e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          });
          var o = r(0);
          t.BrowserHeaders = o.BrowserHeaders;
        }, function (e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.iterateHeaders = function (e, t) {
            for (var r = e[Symbol.iterator](), o = r.next(); !o.done;) t(o.value[0]), o = r.next();
          }, t.iterateHeadersKeys = function (e, t) {
            for (var r = e.keys(), o = r.next(); !o.done;) t(o.value), o = r.next();
          };
        }, function (e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          });
          var o = r(2);
          function n(e) {
            return e;
          }
          t.normalizeName = function (e) {
            if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
            return e.toLowerCase();
          }, t.normalizeValue = function (e) {
            return "string" != typeof e && (e = String(e)), e;
          }, t.getHeaderValues = function (e, t) {
            var r = n(e);
            if (r instanceof Headers && r.getAll) return r.getAll(t);
            var o = r.get(t);
            return o && "string" == typeof o ? [o] : o;
          }, t.getHeaderKeys = function (e) {
            var t = n(e),
              r = {},
              a = [];
            return t.keys ? o.iterateHeadersKeys(t, function (e) {
              r[e] || (r[e] = !0, a.push(e));
            }) : t.forEach ? t.forEach(function (e, t) {
              r[t] || (r[t] = !0, a.push(t));
            }) : o.iterateHeaders(t, function (e) {
              var t = e[0];
              r[t] || (r[t] = !0, a.push(t));
            }), a;
          }, t.splitHeaderValue = function (e) {
            var t = [];
            return e.split(", ").forEach(function (e) {
              e.split(",").forEach(function (e) {
                t.push(e);
              });
            }), t;
          };
        }]);
      }, e.exports = o();
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = r(5),
        n = function n(e) {
          return o.CrossBrowserHttpTransport({
            withCredentials: !1
          })(e);
        };
      t.setDefaultTransportFactory = function (e) {
        n = e;
      }, t.makeDefaultTransport = function (e) {
        return n(e);
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = r(6),
        n = r(7);
      t.CrossBrowserHttpTransport = function (e) {
        if (o.detectFetchSupport()) {
          var t = {
            credentials: e.withCredentials ? "include" : "same-origin"
          };
          return o.FetchReadableStreamTransport(t);
        }
        return n.XhrTransport({
          withCredentials: e.withCredentials
        });
      };
    }, function (e, t, r) {
      var o = this && this.__assign || function () {
        return (o = Object.assign || function (e) {
          for (var t, r = 1, o = arguments.length; r < o; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          return e;
        }).apply(this, arguments);
      };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var n = r(0),
        a = r(1);
      t.FetchReadableStreamTransport = function (e) {
        return function (t) {
          return function (e, t) {
            return e.debug && a.debug("fetchRequest", e), new i(e, t);
          }(t, e);
        };
      };
      var i = function () {
        function e(e, t) {
          this.cancelled = !1, this.controller = self.AbortController && new AbortController(), this.options = e, this.init = t;
        }
        return e.prototype.pump = function (e, t) {
          var r = this;
          if (this.reader = e, this.cancelled) return this.options.debug && a.debug("Fetch.pump.cancel at first pump"), void this.reader.cancel();
          this.reader.read().then(function (e) {
            if (e.done) return r.options.onEnd(), t;
            r.options.onChunk(e.value), r.pump(r.reader, t);
          }).catch(function (e) {
            r.cancelled ? r.options.debug && a.debug("Fetch.catch - request cancelled") : (r.cancelled = !0, r.options.debug && a.debug("Fetch.catch", e.message), r.options.onEnd(e));
          });
        }, e.prototype.send = function (e) {
          var t = this;
          fetch(this.options.url, o({}, this.init, {
            headers: this.metadata.toHeaders(),
            method: "POST",
            body: e,
            signal: this.controller && this.controller.signal
          })).then(function (e) {
            if (t.options.debug && a.debug("Fetch.response", e), t.options.onHeaders(new n.Metadata(e.headers), e.status), !e.body) return e;
            t.pump(e.body.getReader(), e);
          }).catch(function (e) {
            t.cancelled ? t.options.debug && a.debug("Fetch.catch - request cancelled") : (t.cancelled = !0, t.options.debug && a.debug("Fetch.catch", e.message), t.options.onEnd(e));
          });
        }, e.prototype.sendMessage = function (e) {
          this.send(e);
        }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
          this.metadata = e;
        }, e.prototype.cancel = function () {
          this.cancelled ? this.options.debug && a.debug("Fetch.abort.cancel already cancelled") : (this.cancelled = !0, this.reader ? (this.options.debug && a.debug("Fetch.abort.cancel"), this.reader.cancel()) : this.options.debug && a.debug("Fetch.abort.cancel before reader"), this.controller && this.controller.abort());
        }, e;
      }();
      t.detectFetchSupport = function () {
        return "undefined" != typeof Response && Response.prototype.hasOwnProperty("body") && "function" == typeof Headers;
      };
    }, function (e, t, r) {
      var _o3,
        n = this && this.__extends || (_o3 = function o(e, t) {
          return (_o3 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
          })(e, t);
        }, function (e, t) {
          function r() {
            this.constructor = e;
          }
          _o3(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
        });
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var a = r(0),
        i = r(1),
        s = r(11);
      t.XhrTransport = function (e) {
        return function (t) {
          if (s.detectMozXHRSupport()) return new l(t, e);
          if (s.detectXHROverrideMimeTypeSupport()) return new u(t, e);
          throw new Error("This environment's XHR implementation cannot support binary transfer.");
        };
      };
      var u = function () {
        function e(e, t) {
          this.options = e, this.init = t;
        }
        return e.prototype.onProgressEvent = function () {
          this.options.debug && i.debug("XHR.onProgressEvent.length: ", this.xhr.response.length);
          var e = this.xhr.response.substr(this.index);
          this.index = this.xhr.response.length;
          var t = p(e);
          this.options.onChunk(t);
        }, e.prototype.onLoadEvent = function () {
          this.options.debug && i.debug("XHR.onLoadEvent"), this.options.onEnd();
        }, e.prototype.onStateChange = function () {
          this.options.debug && i.debug("XHR.onStateChange", this.xhr.readyState), this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && this.options.onHeaders(new a.Metadata(this.xhr.getAllResponseHeaders()), this.xhr.status);
        }, e.prototype.sendMessage = function (e) {
          this.xhr.send(e);
        }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
          var t = this;
          this.metadata = e;
          var r = new XMLHttpRequest();
          this.xhr = r, r.open("POST", this.options.url), this.configureXhr(), this.metadata.forEach(function (e, t) {
            r.setRequestHeader(e, t.join(", "));
          }), r.withCredentials = Boolean(this.init.withCredentials), r.addEventListener("readystatechange", this.onStateChange.bind(this)), r.addEventListener("progress", this.onProgressEvent.bind(this)), r.addEventListener("loadend", this.onLoadEvent.bind(this)), r.addEventListener("error", function (e) {
            t.options.debug && i.debug("XHR.error", e), t.options.onEnd(e.error);
          });
        }, e.prototype.configureXhr = function () {
          this.xhr.responseType = "text", this.xhr.overrideMimeType("text/plain; charset=x-user-defined");
        }, e.prototype.cancel = function () {
          this.options.debug && i.debug("XHR.abort"), this.xhr.abort();
        }, e;
      }();
      t.XHR = u;
      var l = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return n(t, e), t.prototype.configureXhr = function () {
          this.options.debug && i.debug("MozXHR.configureXhr: setting responseType to 'moz-chunked-arraybuffer'"), this.xhr.responseType = "moz-chunked-arraybuffer";
        }, t.prototype.onProgressEvent = function () {
          var e = this.xhr.response;
          this.options.debug && i.debug("MozXHR.onProgressEvent: ", new Uint8Array(e)), this.options.onChunk(new Uint8Array(e));
        }, t;
      }(u);
      function c(e, t) {
        var r = e.charCodeAt(t);
        if (r >= 55296 && r <= 56319) {
          var o = e.charCodeAt(t + 1);
          o >= 56320 && o <= 57343 && (r = 65536 + (r - 55296 << 10) + (o - 56320));
        }
        return r;
      }
      function p(e) {
        for (var t = new Uint8Array(e.length), r = 0, o = 0; o < e.length; o++) {
          var n = String.prototype.codePointAt ? e.codePointAt(o) : c(e, o);
          t[r++] = 255 & n;
        }
        return t;
      }
      t.MozChunkedArrayBufferXHR = l, t.stringToArrayBuffer = p;
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o,
        n = r(0),
        a = function a(e) {
          return 9 === e || 10 === e || 13 === e;
        };
      function i(e) {
        return a(e) || e >= 32 && e <= 126;
      }
      function s(e) {
        for (var t = 0; t !== e.length; ++t) if (!i(e[t])) throw new Error("Metadata is not valid (printable) ASCII");
        return String.fromCharCode.apply(String, Array.prototype.slice.call(e));
      }
      function u(e) {
        return 128 == (128 & e.getUint8(0));
      }
      function l(e) {
        return e.getUint32(1, !1);
      }
      function c(e, t, r) {
        return e.byteLength - t >= r;
      }
      function p(e, t, r) {
        if (e.slice) return e.slice(t, r);
        var o = e.length;
        void 0 !== r && (o = r);
        for (var n = new Uint8Array(o - t), a = 0, i = t; i < o; i++) n[a++] = e[i];
        return n;
      }
      t.decodeASCII = s, t.encodeASCII = function (e) {
        for (var t = new Uint8Array(e.length), r = 0; r !== e.length; ++r) {
          var o = e.charCodeAt(r);
          if (!i(o)) throw new Error("Metadata contains invalid ASCII");
          t[r] = o;
        }
        return t;
      }, function (e) {
        e[e.MESSAGE = 1] = "MESSAGE", e[e.TRAILERS = 2] = "TRAILERS";
      }(o = t.ChunkType || (t.ChunkType = {}));
      var g = function () {
        function e() {
          this.buffer = null, this.position = 0;
        }
        return e.prototype.parse = function (e, t) {
          if (0 === e.length && t) return [];
          var r,
            a = [];
          if (null == this.buffer) this.buffer = e, this.position = 0;else if (this.position === this.buffer.byteLength) this.buffer = e, this.position = 0;else {
            var i = this.buffer.byteLength - this.position,
              g = new Uint8Array(i + e.byteLength),
              d = p(this.buffer, this.position);
            g.set(d, 0);
            var f = new Uint8Array(e);
            g.set(f, i), this.buffer = g, this.position = 0;
          }
          for (;;) {
            if (!c(this.buffer, this.position, 5)) return a;
            var h = p(this.buffer, this.position, this.position + 5),
              y = new DataView(h.buffer, h.byteOffset, h.byteLength),
              b = l(y);
            if (!c(this.buffer, this.position, 5 + b)) return a;
            var m = p(this.buffer, this.position + 5, this.position + 5 + b);
            if (this.position += 5 + b, u(y)) return a.push({
              chunkType: o.TRAILERS,
              trailers: (r = m, new n.Metadata(s(r)))
            }), a;
            a.push({
              chunkType: o.MESSAGE,
              data: m
            });
          }
        }, e;
      }();
      t.ChunkParser = g;
    }, function (e, t, r) {
      var o;
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e[e.OK = 0] = "OK", e[e.Canceled = 1] = "Canceled", e[e.Unknown = 2] = "Unknown", e[e.InvalidArgument = 3] = "InvalidArgument", e[e.DeadlineExceeded = 4] = "DeadlineExceeded", e[e.NotFound = 5] = "NotFound", e[e.AlreadyExists = 6] = "AlreadyExists", e[e.PermissionDenied = 7] = "PermissionDenied", e[e.ResourceExhausted = 8] = "ResourceExhausted", e[e.FailedPrecondition = 9] = "FailedPrecondition", e[e.Aborted = 10] = "Aborted", e[e.OutOfRange = 11] = "OutOfRange", e[e.Unimplemented = 12] = "Unimplemented", e[e.Internal = 13] = "Internal", e[e.Unavailable = 14] = "Unavailable", e[e.DataLoss = 15] = "DataLoss", e[e.Unauthenticated = 16] = "Unauthenticated";
      }(o = t.Code || (t.Code = {})), t.httpStatusToCode = function (e) {
        switch (e) {
          case 0:
            return o.Internal;
          case 200:
            return o.OK;
          case 400:
            return o.InvalidArgument;
          case 401:
            return o.Unauthenticated;
          case 403:
            return o.PermissionDenied;
          case 404:
            return o.NotFound;
          case 409:
            return o.Aborted;
          case 412:
            return o.FailedPrecondition;
          case 429:
            return o.ResourceExhausted;
          case 499:
            return o.Canceled;
          case 500:
            return o.Unknown;
          case 501:
            return o.Unimplemented;
          case 503:
            return o.Unavailable;
          case 504:
            return o.DeadlineExceeded;
          default:
            return o.Unknown;
        }
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = r(3),
        n = r(4),
        a = r(6),
        i = r(12),
        s = r(7),
        u = r(5),
        l = r(9),
        c = r(13),
        p = r(15),
        g = r(2);
      !function (e) {
        e.setDefaultTransport = n.setDefaultTransportFactory, e.CrossBrowserHttpTransport = u.CrossBrowserHttpTransport, e.FetchReadableStreamTransport = a.FetchReadableStreamTransport, e.XhrTransport = s.XhrTransport, e.WebsocketTransport = i.WebsocketTransport, e.Code = l.Code, e.Metadata = o.BrowserHeaders, e.client = function (e, t) {
          return g.client(e, t);
        }, e.invoke = c.invoke, e.unary = p.unary;
      }(t.grpc || (t.grpc = {}));
    }, function (e, t, r) {
      var o;
      function n() {
        if (void 0 !== o) return o;
        if (XMLHttpRequest) {
          o = new XMLHttpRequest();
          try {
            o.open("GET", "https://localhost");
          } catch (e) {}
        }
        return o;
      }
      function a(e) {
        var t = n();
        if (!t) return !1;
        try {
          return t.responseType = e, t.responseType === e;
        } catch (e) {}
        return !1;
      }
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.xhrSupportsResponseType = a, t.detectMozXHRSupport = function () {
        return "undefined" != typeof XMLHttpRequest && a("moz-chunked-arraybuffer");
      }, t.detectXHROverrideMimeTypeSupport = function () {
        return "undefined" != typeof XMLHttpRequest && XMLHttpRequest.prototype.hasOwnProperty("overrideMimeType");
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o,
        n = r(1),
        a = r(8);
      !function (e) {
        e[e.FINISH_SEND = 1] = "FINISH_SEND";
      }(o || (o = {}));
      var i = new Uint8Array([1]);
      t.WebsocketTransport = function () {
        return function (e) {
          return function (e) {
            e.debug && n.debug("websocketRequest", e);
            var t,
              r = function (e) {
                if ("https://" === e.substr(0, 8)) return "wss://" + e.substr(8);
                if ("http://" === e.substr(0, 7)) return "ws://" + e.substr(7);
                throw new Error("Websocket transport constructed with non-https:// or http:// host.");
              }(e.url),
              s = [];
            function u(e) {
              if (e === o.FINISH_SEND) t.send(i);else {
                var r = e,
                  n = new Int8Array(r.byteLength + 1);
                n.set(new Uint8Array([0])), n.set(r, 1), t.send(n);
              }
            }
            return {
              sendMessage: function sendMessage(e) {
                t && t.readyState !== t.CONNECTING ? u(e) : s.push(e);
              },
              finishSend: function finishSend() {
                t && t.readyState !== t.CONNECTING ? u(o.FINISH_SEND) : s.push(o.FINISH_SEND);
              },
              start: function start(o) {
                (t = new WebSocket(r, ["grpc-websockets"])).binaryType = "arraybuffer", t.onopen = function () {
                  var r;
                  e.debug && n.debug("websocketRequest.onopen"), t.send((r = "", o.forEach(function (e, t) {
                    r += e + ": " + t.join(", ") + "\r\n";
                  }), a.encodeASCII(r))), s.forEach(function (e) {
                    u(e);
                  });
                }, t.onclose = function (t) {
                  e.debug && n.debug("websocketRequest.onclose", t), e.onEnd();
                }, t.onerror = function (t) {
                  e.debug && n.debug("websocketRequest.onerror", t);
                }, t.onmessage = function (t) {
                  e.onChunk(new Uint8Array(t.data));
                };
              },
              cancel: function cancel() {
                e.debug && n.debug("websocket.abort"), t.close();
              }
            };
          }(e);
        };
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = r(2);
      t.invoke = function (e, t) {
        if (e.requestStream) throw new Error(".invoke cannot be used with client-streaming methods. Use .client instead.");
        var r = o.client(e, {
          host: t.host,
          transport: t.transport,
          debug: t.debug
        });
        return t.onHeaders && r.onHeaders(t.onHeaders), t.onMessage && r.onMessage(t.onMessage), t.onEnd && r.onEnd(t.onEnd), r.start(t.metadata), r.send(t.request), r.finishSend(), {
          close: function close() {
            r.close();
          }
        };
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.frameRequest = function (e) {
        var t = e.serializeBinary(),
          r = new ArrayBuffer(t.byteLength + 5);
        return new DataView(r, 1, 4).setUint32(0, t.length, !1), new Uint8Array(r, 5).set(t), new Uint8Array(r);
      };
    }, function (e, t, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = r(0),
        n = r(2);
      t.unary = function (e, t) {
        if (e.responseStream) throw new Error(".unary cannot be used with server-streaming methods. Use .invoke or .client instead.");
        if (e.requestStream) throw new Error(".unary cannot be used with client-streaming methods. Use .client instead.");
        var r = null,
          a = null,
          i = n.client(e, {
            host: t.host,
            transport: t.transport,
            debug: t.debug
          });
        return i.onHeaders(function (e) {
          r = e;
        }), i.onMessage(function (e) {
          a = e;
        }), i.onEnd(function (e, n, i) {
          t.onEnd({
            status: e,
            statusMessage: n,
            headers: r || new o.Metadata(),
            message: a,
            trailers: i
          });
        }), i.start(t.metadata), i.send(t.request), i.finishSend(), {
          close: function close() {
            i.close();
          }
        };
      };
    }]);
  }),
  grpc = grpcWebClient_umd$1.grpc,
  API = function () {
    function e() {}
    return e.serviceName = "threads.pb.API", e;
  }();
function APIClient(e, t) {
  this.serviceHost = e, this.options = t || {};
}
API.GetToken = {
  methodName: "GetToken",
  service: API,
  requestStream: !0,
  responseStream: !0,
  requestType: threads_pb.GetTokenRequest,
  responseType: threads_pb.GetTokenReply
}, API.NewDB = {
  methodName: "NewDB",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.NewDBRequest,
  responseType: threads_pb.NewDBReply
}, API.NewDBFromAddr = {
  methodName: "NewDBFromAddr",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.NewDBFromAddrRequest,
  responseType: threads_pb.NewDBReply
}, API.ListDBs = {
  methodName: "ListDBs",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.ListDBsRequest,
  responseType: threads_pb.ListDBsReply
}, API.GetDBInfo = {
  methodName: "GetDBInfo",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.GetDBInfoRequest,
  responseType: threads_pb.GetDBInfoReply
}, API.DeleteDB = {
  methodName: "DeleteDB",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.DeleteDBRequest,
  responseType: threads_pb.DeleteDBReply
}, API.NewCollection = {
  methodName: "NewCollection",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.NewCollectionRequest,
  responseType: threads_pb.NewCollectionReply
}, API.UpdateCollection = {
  methodName: "UpdateCollection",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.UpdateCollectionRequest,
  responseType: threads_pb.UpdateCollectionReply
}, API.DeleteCollection = {
  methodName: "DeleteCollection",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.DeleteCollectionRequest,
  responseType: threads_pb.DeleteCollectionReply
}, API.GetCollectionInfo = {
  methodName: "GetCollectionInfo",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.GetCollectionInfoRequest,
  responseType: threads_pb.GetCollectionInfoReply
}, API.GetCollectionIndexes = {
  methodName: "GetCollectionIndexes",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.GetCollectionIndexesRequest,
  responseType: threads_pb.GetCollectionIndexesReply
}, API.ListCollections = {
  methodName: "ListCollections",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.ListCollectionsRequest,
  responseType: threads_pb.ListCollectionsReply
}, API.Create = {
  methodName: "Create",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.CreateRequest,
  responseType: threads_pb.CreateReply
}, API.Verify = {
  methodName: "Verify",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.VerifyRequest,
  responseType: threads_pb.VerifyReply
}, API.Save = {
  methodName: "Save",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.SaveRequest,
  responseType: threads_pb.SaveReply
}, API.Delete = {
  methodName: "Delete",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.DeleteRequest,
  responseType: threads_pb.DeleteReply
}, API.Has = {
  methodName: "Has",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.HasRequest,
  responseType: threads_pb.HasReply
}, API.Find = {
  methodName: "Find",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.FindRequest,
  responseType: threads_pb.FindReply
}, API.FindByID = {
  methodName: "FindByID",
  service: API,
  requestStream: !1,
  responseStream: !1,
  requestType: threads_pb.FindByIDRequest,
  responseType: threads_pb.FindByIDReply
}, API.ReadTransaction = {
  methodName: "ReadTransaction",
  service: API,
  requestStream: !0,
  responseStream: !0,
  requestType: threads_pb.ReadTransactionRequest,
  responseType: threads_pb.ReadTransactionReply
}, API.WriteTransaction = {
  methodName: "WriteTransaction",
  service: API,
  requestStream: !0,
  responseStream: !0,
  requestType: threads_pb.WriteTransactionRequest,
  responseType: threads_pb.WriteTransactionReply
}, API.Listen = {
  methodName: "Listen",
  service: API,
  requestStream: !1,
  responseStream: !0,
  requestType: threads_pb.ListenRequest,
  responseType: threads_pb.ListenReply
}, APIClient.prototype.getToken = function (e) {
  var t = {
      data: [],
      end: [],
      status: []
    },
    r = grpc.client(API.GetToken, {
      host: this.serviceHost,
      metadata: e,
      transport: this.options.transport
    });
  return r.onEnd(function (e, r, o) {
    t.status.forEach(function (t) {
      t({
        code: e,
        details: r,
        metadata: o
      });
    }), t.end.forEach(function (t) {
      t({
        code: e,
        details: r,
        metadata: o
      });
    }), t = null;
  }), r.onMessage(function (e) {
    t.data.forEach(function (t) {
      t(e);
    });
  }), r.start(e), {
    on: function on(e, r) {
      return t[e].push(r), this;
    },
    write: function write(e) {
      return r.send(e), this;
    },
    end: function end() {
      r.finishSend();
    },
    cancel: function cancel() {
      t = null, r.close();
    }
  };
}, APIClient.prototype.newDB = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.NewDB, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.newDBFromAddr = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.NewDBFromAddr, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.listDBs = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.ListDBs, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.getDBInfo = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.GetDBInfo, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.deleteDB = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.DeleteDB, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.newCollection = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.NewCollection, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.updateCollection = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.UpdateCollection, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.deleteCollection = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.DeleteCollection, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.getCollectionInfo = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.GetCollectionInfo, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.getCollectionIndexes = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.GetCollectionIndexes, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.listCollections = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.ListCollections, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.create = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.Create, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.verify = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.Verify, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.save = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.Save, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.delete = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.Delete, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.has = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.Has, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.find = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.Find, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.findByID = function (e, t, r) {
  2 === arguments.length && (r = arguments[1]);
  var o = grpc.unary(API.FindByID, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (r) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, r(t, null);
      } else r(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      r = null, o.close();
    }
  };
}, APIClient.prototype.readTransaction = function (e) {
  var t = {
      data: [],
      end: [],
      status: []
    },
    r = grpc.client(API.ReadTransaction, {
      host: this.serviceHost,
      metadata: e,
      transport: this.options.transport
    });
  return r.onEnd(function (e, r, o) {
    t.status.forEach(function (t) {
      t({
        code: e,
        details: r,
        metadata: o
      });
    }), t.end.forEach(function (t) {
      t({
        code: e,
        details: r,
        metadata: o
      });
    }), t = null;
  }), r.onMessage(function (e) {
    t.data.forEach(function (t) {
      t(e);
    });
  }), r.start(e), {
    on: function on(e, r) {
      return t[e].push(r), this;
    },
    write: function write(e) {
      return r.send(e), this;
    },
    end: function end() {
      r.finishSend();
    },
    cancel: function cancel() {
      t = null, r.close();
    }
  };
}, APIClient.prototype.writeTransaction = function (e) {
  var t = {
      data: [],
      end: [],
      status: []
    },
    r = grpc.client(API.WriteTransaction, {
      host: this.serviceHost,
      metadata: e,
      transport: this.options.transport
    });
  return r.onEnd(function (e, r, o) {
    t.status.forEach(function (t) {
      t({
        code: e,
        details: r,
        metadata: o
      });
    }), t.end.forEach(function (t) {
      t({
        code: e,
        details: r,
        metadata: o
      });
    }), t = null;
  }), r.onMessage(function (e) {
    t.data.forEach(function (t) {
      t(e);
    });
  }), r.start(e), {
    on: function on(e, r) {
      return t[e].push(r), this;
    },
    write: function write(e) {
      return r.send(e), this;
    },
    end: function end() {
      r.finishSend();
    },
    cancel: function cancel() {
      t = null, r.close();
    }
  };
}, APIClient.prototype.listen = function (e, t) {
  var r = {
      data: [],
      end: [],
      status: []
    },
    o = grpc.invoke(API.Listen, {
      request: e,
      host: this.serviceHost,
      metadata: t,
      transport: this.options.transport,
      debug: this.options.debug,
      onMessage: function onMessage(e) {
        r.data.forEach(function (t) {
          t(e);
        });
      },
      onEnd: function onEnd(e, t, o) {
        r.status.forEach(function (r) {
          r({
            code: e,
            details: t,
            metadata: o
          });
        }), r.end.forEach(function (r) {
          r({
            code: e,
            details: t,
            metadata: o
          });
        }), r = null;
      }
    });
  return {
    on: function on(e, t) {
      return r[e].push(t), this;
    },
    cancel: function cancel() {
      r = null, o.close();
    }
  };
};
var APIClient_1 = APIClient;
var defaults = {
  serviceHost: defaultHost,
  transport: a(),
  debug: !1,
  metadata: new grpcWebClient_umd.grpc.Metadata()
};
function createClient() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = Object.assign(Object.assign({}, defaults), e);
  return new APIClient_1(t.serviceHost, {
    transport: t.transport,
    debug: t.debug
  });
}
function createDbClient() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  var r = {};
  null === (t = e.metadata) || void 0 === t || t.forEach(function (e, t) {
    return r[e] = t;
  });
  var o = Object.keys(r).length > 0 ? Context.fromJSON(r, e.serviceHost) : new Context(e.serviceHost);
  return new Client(o);
}
function getToken(e, t) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var _this = this;
    var r;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          r = Object.assign(Object.assign({}, defaults), t);
          return _context8.abrupt("return", getTokenChallenge(e.public.toString(), function (t) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
              return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    return _context7.abrupt("return", e.sign(t));
                  case 1:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            }));
          }, r));
        case 2:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
}
function getTokenChallenge(e, t, r) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var _this2 = this;
    var o, n;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          o = Object.assign(Object.assign({}, defaults), r), n = createClient(o).getToken(o.metadata);
          return _context10.abrupt("return", new Promise(function (r, o) {
            var a = "";
            n.on("data", function (e) {
              return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                var _r5, _o4, _a5;
                return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      if (!e.hasChallenge()) {
                        _context9.next = 9;
                        break;
                      }
                      _r5 = e.getChallenge_asU8();
                      _context9.next = 4;
                      return t(_r5);
                    case 4:
                      _o4 = _context9.sent;
                      _a5 = new threads_pb.GetTokenRequest();
                      _a5.setSignature(_o4), n.write(_a5);
                      _context9.next = 10;
                      break;
                    case 9:
                      e.hasToken() && (a = e.getToken(), n.end());
                    case 10:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }));
            }), n.on("end", function (e) {
              (null == e ? void 0 : e.code) === grpcWebClient_umd.grpc.Code.OK ? r(a) : o(new Error(null == e ? void 0 : e.details));
            });
            var i = new threads_pb.GetTokenRequest();
            i.setKey(e), n.write(i);
          }));
        case 2:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
}
function newDB(e, t, r, o) {
  var n;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var a, i, s, u, _iterator, _step, _e4, _t6, _r6, _iterator2, _step2, _t7, _e5;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          a = Object.assign(Object.assign({}, defaults), o), i = createClient(a), s = new threads_pb.NewDBRequest();
          s.setDbid(t.toBytes()), s.setName(e);
          u = [];
          _iterator = _createForOfIteratorHelper(r);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _e4 = _step.value;
              _t6 = new threads_pb.CollectionConfig();
              _t6.setName(_e4.name), _t6.setSchema(_e4.schema);
              _r6 = [];
              _iterator2 = _createForOfIteratorHelper(null !== (n = _e4.indexes) && void 0 !== n ? n : []);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _t7 = _step2.value;
                  _e5 = new threads_pb.Index();
                  _e5.setPath(_t7.path), _e5.setUnique(_t7.unique), _r6.push(_e5);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _t6.setIndexesList(_r6), u.push(_t6);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return _context11.abrupt("return", (s.setCollectionsList(u), new Promise(function (e, r) {
            var o;
            i.newDB(s, null !== (o = a.metadata) && void 0 !== o ? o : new grpcWebClient_umd.grpc.Metadata(), function (o, n) {
              o && r(new Error(o.message));
              var a = Boolean(null == n ? void 0 : n.toObject()),
                i = t.toString();
              a ? e(i) : r(new Error("Unable to create thread with id = ".concat(i)));
            });
          })));
        case 6:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
}
var Errors = {
    ThreadIDError: new Error("Missing/invalid thread id"),
    MissingDbError: new Error("Missing remote db/thread"),
    NoRemoteError: new Error("No remote service host specified"),
    RemoteError: new Error("Remote operation failed"),
    ChangeError: new Error("Unable to process db change(s)"),
    LocalChangesError: new Error("Unpushed local changes"),
    ThreadExists: new Error("Remote db/thread already exists")
  },
  ThreadIDName = "thread-id",
  encoder = new TextEncoder(),
  decoder = new TextDecoder();
var Remote = /*#__PURE__*/function () {
  function Remote(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaults;
    _classCallCheck(this, Remote);
    var r;
    this.storage = e;
    var o = t.id,
      n = t.token,
      a = __rest(t, ["id", "token"]);
    this.config = Object.assign({
      metadata: new grpcWebClient_umd.grpc.Metadata()
    }, a), n && (null === (r = this.config.metadata) || void 0 === r || r.set("authorization", "bearer ".concat(n))), this.id = o;
  }
  _createClass(Remote, [{
    key: "setUserAuth",
    value: function setUserAuth(e) {
      var t;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var r, o, n;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              r = "object" == typeof e ? Context.fromUserAuth(e, this.config.serviceHost) : Context.fromUserAuthCallback(e, this.config.serviceHost), o = {};
              null === (t = this.config.metadata) || void 0 === t || t.forEach(function (e, t) {
                return o[e] = t;
              });
              _context12.next = 4;
              return Context.fromJSON(Object.assign(Object.assign({}, o), r.toJSON())).toMetadata();
            case 4:
              n = _context12.sent;
              return _context12.abrupt("return", (this.config.metadata = n, this));
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "setKeyInfo",
    value: function setKeyInfo(e) {
      var t;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var r, o, n;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return new Context(this.config.serviceHost).withKeyInfo(e);
            case 2:
              r = _context13.sent;
              o = {};
              null === (t = this.config.metadata) || void 0 === t || t.forEach(function (e, t) {
                return o[e] = t;
              });
              _context13.next = 7;
              return Context.fromJSON(Object.assign(Object.assign({}, o), r.toJSON())).toMetadata();
            case 7:
              n = _context13.sent;
              return _context13.abrupt("return", (this.config.metadata = n, this));
            case 9:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "set",
    value: function set(e) {
      var t = e.id,
        r = __rest(e, ["id"]);
      return this.config = Object.assign(Object.assign({}, this.config), r), this.id = null != t ? t : this.id, this;
    }
  }, {
    key: "get",
    value: function get() {
      var e = this.id,
        t = this.config;
      return Object.assign({
        id: e
      }, t);
    }
  }, {
    key: "info",
    value: function info() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var e;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!(void 0 === this.id)) {
                _context14.next = 2;
                break;
              }
              throw Errors.ThreadIDError;
            case 2:
              e = ThreadID.fromString(this.id);
              return _context14.abrupt("return", createDbClient(this.config).getDBInfo(e));
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "authorize",
    value: function authorize(e, t) {
      var r;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var o;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (this.config.serviceHost) {
                _context15.next = 2;
                break;
              }
              throw Errors.NoRemoteError;
            case 2:
              o = "";
              if (!("string" == typeof e)) {
                _context15.next = 11;
                break;
              }
              if (!(void 0 === t)) {
                _context15.next = 6;
                break;
              }
              throw new Error("Callback required for public key challenge");
            case 6:
              _context15.next = 8;
              return getTokenChallenge(e, t, this.config);
            case 8:
              o = _context15.sent;
              _context15.next = 14;
              break;
            case 11:
              _context15.next = 13;
              return getToken(e, this.config);
            case 13:
              o = _context15.sent;
            case 14:
              return _context15.abrupt("return", (null === (r = this.config.metadata) || void 0 === r || r.set("authorization", "bearer ".concat(o)), o));
            case 15:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.id;
      var t;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this3 = this;
        var r, o, _ref3, _e6, n, a, _t8, _e7, _iterator3, _step3, _t9;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (this.config.serviceHost) {
                _context17.next = 2;
                break;
              }
              throw Errors.NoRemoteError;
            case 2:
              r = this.storage.table(MetaTableName);
              o = ThreadID.fromRandom();
              if (!(void 0 !== e)) {
                _context17.next = 8;
                break;
              }
              o = "string" == typeof e ? ThreadID.fromString(e) : e;
              _context17.next = 22;
              break;
            case 8:
              _context17.next = 10;
              return r.get(ThreadIDName);
            case 10:
              _context17.t1 = t = _context17.sent;
              _context17.t0 = null !== _context17.t1;
              if (!_context17.t0) {
                _context17.next = 14;
                break;
              }
              _context17.t0 = void 0 !== t;
            case 14:
              if (!_context17.t0) {
                _context17.next = 18;
                break;
              }
              _context17.t2 = t;
              _context17.next = 19;
              break;
            case 18:
              _context17.t2 = {};
            case 19:
              _ref3 = _context17.t2;
              _e6 = _ref3.value;
              void 0 !== _e6 && (o = ThreadID.fromString(_e6));
            case 22:
              _context17.next = 24;
              return Promise.all(this.storage.tables.filter(function (e) {
                return !e.name.startsWith("_");
              }).map(function (e) {
                return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        _context16.t0 = e.name;
                        _context16.t1 = encoder;
                        _context16.t2 = JSON;
                        _context16.next = 5;
                        return e.getSchema();
                      case 5:
                        _context16.t3 = _context16.sent;
                        _context16.t4 = _context16.t2.stringify.call(_context16.t2, _context16.t3);
                        _context16.t5 = _context16.t1.encode.call(_context16.t1, _context16.t4);
                        _context16.t6 = [];
                        return _context16.abrupt("return", {
                          name: _context16.t0,
                          schema: _context16.t5,
                          indexesList: _context16.t6,
                          writevalidator: "",
                          readfilter: ""
                        });
                      case 10:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
              }));
            case 24:
              n = _context17.sent;
              a = "";
              _context17.prev = 26;
              _context17.next = 29;
              return newDB(this.storage.name, o, n, this.config);
            case 29:
              a = _context17.sent;
              _context17.next = 64;
              break;
            case 32:
              _context17.prev = 32;
              _context17.t3 = _context17["catch"](26);
              _t8 = _context17.t3.toString();
              if (!(!_t8.includes("db already exists") && !_t8.includes("multiple write errors"))) {
                _context17.next = 37;
                break;
              }
              throw _context17.t3;
            case 37:
              a = o.toString();
              _e7 = createDbClient(this.config);
              _iterator3 = _createForOfIteratorHelper(n);
              _context17.prev = 40;
              _iterator3.s();
            case 42:
              if ((_step3 = _iterator3.n()).done) {
                _context17.next = 56;
                break;
              }
              _t9 = _step3.value;
              _t9.schema = JSON.parse(decoder.decode(_t9.schema));
              _context17.prev = 45;
              _context17.next = 48;
              return _e7.newCollection(o, _t9);
            case 48:
              _context17.next = 54;
              break;
            case 50:
              _context17.prev = 50;
              _context17.t4 = _context17["catch"](45);
              if (_context17.t4.message.includes("collection already registered")) {
                _context17.next = 54;
                break;
              }
              throw _context17.t4;
            case 54:
              _context17.next = 42;
              break;
            case 56:
              _context17.next = 61;
              break;
            case 58:
              _context17.prev = 58;
              _context17.t5 = _context17["catch"](40);
              _iterator3.e(_context17.t5);
            case 61:
              _context17.prev = 61;
              _iterator3.f();
              return _context17.finish(61);
            case 64:
              if (a) {
                _context17.next = 66;
                break;
              }
              throw Errors.RemoteError;
            case 66:
              this.set({
                id: a
              });
              _context17.next = 69;
              return r.put({
                key: ThreadIDName,
                value: a
              });
            case 69:
              return _context17.abrupt("return", a);
            case 70:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this, [[26, 32], [40, 58, 61, 64], [45, 50]]);
      }));
    }
  }, {
    key: "push",
    value: function push() {
      for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        e[_key6] = arguments[_key6];
      }
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var t, r, o, _i2, _e8, _n4, _e9, _a6, _r7, _i3, _iterator4, _step4, _e10;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              if (this.config.serviceHost) {
                _context18.next = 2;
                break;
              }
              throw Errors.NoRemoteError;
            case 2:
              if (!(void 0 === this.id)) {
                _context18.next = 4;
                break;
              }
              throw Errors.ThreadIDError;
            case 4:
              t = ThreadID.fromString(this.id), r = this.storage.table(ChangeTableName), o = createDbClient(this.config);
              _i2 = 0, _e8 = e;
            case 6:
              if (!(_i2 < _e8.length)) {
                _context18.next = 93;
                break;
              }
              _n4 = _e8[_i2];
              this.storage.table(_n4);
              _e9 = r.where("name").equals(_n4);
              _context18.next = 12;
              return _e9.count();
            case 12:
              _context18.t0 = _context18.sent;
              if (!(_context18.t0 < 1)) {
                _context18.next = 15;
                break;
              }
              return _context18.abrupt("return");
            case 15:
              _a6 = void 0;
              _context18.prev = 16;
              _context18.next = 19;
              return _e9.toArray();
            case 19:
              _r7 = _context18.sent;
              _i3 = 0;
              _iterator4 = _createForOfIteratorHelper(_r7);
              _context18.prev = 22;
              _iterator4.s();
            case 24:
              if ((_step4 = _iterator4.n()).done) {
                _context18.next = 64;
                break;
              }
              _e10 = _step4.value;
              _a6 = o.writeTransaction(t, _n4);
              _context18.next = 29;
              return _a6.start();
            case 29:
              _context18.t1 = _e10.type;
              _context18.next = _context18.t1 === "put" ? 32 : _context18.t1 === "add" ? 41 : _context18.t1 === "delete" ? 50 : 59;
              break;
            case 32:
              _context18.prev = 32;
              _context18.next = 35;
              return _a6.save([_e10.after]);
            case 35:
              return _context18.abrupt("break", 59);
            case 38:
              _context18.prev = 38;
              _context18.t2 = _context18["catch"](32);
              throw _context18.t2;
            case 41:
              _context18.prev = 41;
              _context18.next = 44;
              return _a6.create([_e10.after]);
            case 44:
              return _context18.abrupt("break", 59);
            case 47:
              _context18.prev = 47;
              _context18.t3 = _context18["catch"](41);
              throw _context18.t3;
            case 50:
              _context18.prev = 50;
              _context18.next = 53;
              return _a6.delete([_e10.key]);
            case 53:
              return _context18.abrupt("break", 59);
            case 56:
              _context18.prev = 56;
              _context18.t4 = _context18["catch"](50);
              throw _context18.t4;
            case 59:
              _context18.next = 61;
              return _a6.end();
            case 61:
              _i3++;
            case 62:
              _context18.next = 24;
              break;
            case 64:
              _context18.next = 69;
              break;
            case 66:
              _context18.prev = 66;
              _context18.t5 = _context18["catch"](22);
              _iterator4.e(_context18.t5);
            case 69:
              _context18.prev = 69;
              _iterator4.f();
              return _context18.finish(69);
            case 72:
              _context18.t6 = _i3;
              _context18.next = 75;
              return _e9.delete();
            case 75:
              _context18.t7 = _context18.sent;
              if (!(_context18.t6 !== _context18.t7)) {
                _context18.next = 78;
                break;
              }
              throw Errors.ChangeError;
            case 78:
              _context18.next = 90;
              break;
            case 80:
              _context18.prev = 80;
              _context18.t8 = _context18["catch"](16);
              _context18.prev = 82;
              _context18.next = 85;
              return null == _a6 ? void 0 : _a6.discard();
            case 85:
              _context18.next = 89;
              break;
            case 87:
              _context18.prev = 87;
              _context18.t9 = _context18["catch"](82);
            case 89:
              throw _context18.t8;
            case 90:
              _i2++;
              _context18.next = 6;
              break;
            case 93:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this, [[16, 80], [22, 66, 69, 72], [32, 38], [41, 47], [50, 56], [82, 87]]);
      }));
    }
  }, {
    key: "createStash",
    value: function createStash() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var e, t, r;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              e = this.storage.table(ChangeTableName);
              _context19.next = 3;
              return e.count();
            case 3:
              if (_context19.sent) {
                _context19.next = 5;
                break;
              }
              return _context19.abrupt("return");
            case 5:
              t = this.storage.table(StashTableName);
              _context19.next = 8;
              return e.toArray();
            case 8:
              r = _context19.sent;
              _context19.next = 11;
              return t.bulkPut(r);
            case 11:
              return _context19.abrupt("return", e.clear());
            case 12:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "clearStash",
    value: function clearStash() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", this.storage.table(StashTableName).clear());
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "applyStash",
    value: function applyStash() {
      for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        e[_key7] = arguments[_key7];
      }
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var _this4 = this;
        var _loop, _i4, _e11;
        return _regeneratorRuntime().wrap(function _callee22$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var t;
                return _regeneratorRuntime().wrap(function _loop$(_context22) {
                  while (1) switch (_context22.prev = _context22.next) {
                    case 0:
                      t = _e11[_i4];
                      _context22.next = 3;
                      return _this4.storage.transaction("rw", [t, StashTableName], function (e) {
                        return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
                          var r, o, n, a, _iterator5, _step5, _e12, _t10;
                          return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                            while (1) switch (_context21.prev = _context21.next) {
                              case 0:
                                o = e.table(StashTableName), n = e.table(t), a = o.where("name").equals(t);
                                _context21.next = 3;
                                return a.count();
                              case 3:
                                _context21.t0 = _context21.sent;
                                if (_context21.t0 < 1) {
                                  _context21.next = 45;
                                  break;
                                }
                                _context21.t1 = _createForOfIteratorHelper;
                                _context21.next = 8;
                                return a.toArray();
                              case 8:
                                _context21.t2 = _context21.sent;
                                _iterator5 = (0, _context21.t1)(_context21.t2);
                                _context21.prev = 10;
                                _iterator5.s();
                              case 12:
                                if ((_step5 = _iterator5.n()).done) {
                                  _context21.next = 35;
                                  break;
                                }
                                _e12 = _step5.value;
                                if (!("delete" === _e12.type)) {
                                  _context21.next = 18;
                                  break;
                                }
                                n.delete(_e12.key);
                                _context21.next = 33;
                                break;
                              case 18:
                                _context21.next = 20;
                                return n.get(_e12.key);
                              case 20:
                                _context21.t4 = r = _context21.sent;
                                _context21.t3 = null !== _context21.t4;
                                if (!_context21.t3) {
                                  _context21.next = 24;
                                  break;
                                }
                                _context21.t3 = void 0 !== r;
                              case 24:
                                if (!_context21.t3) {
                                  _context21.next = 28;
                                  break;
                                }
                                _context21.t5 = r;
                                _context21.next = 29;
                                break;
                              case 28:
                                _context21.t5 = {};
                              case 29:
                                _t10 = _context21.t5;
                                jsonpatch.applyPatch(_t10, _e12.ops, !1, !0);
                                _context21.next = 33;
                                return n.put(_t10);
                              case 33:
                                _context21.next = 12;
                                break;
                              case 35:
                                _context21.next = 40;
                                break;
                              case 37:
                                _context21.prev = 37;
                                _context21.t6 = _context21["catch"](10);
                                _iterator5.e(_context21.t6);
                              case 40:
                                _context21.prev = 40;
                                _iterator5.f();
                                return _context21.finish(40);
                              case 43:
                                _context21.next = 45;
                                return a.delete();
                              case 45:
                              case "end":
                                return _context21.stop();
                            }
                          }, _callee21, null, [[10, 37, 40, 43]]);
                        }));
                      });
                    case 3:
                    case "end":
                      return _context22.stop();
                  }
                }, _loop);
              });
              _i4 = 0, _e11 = e;
            case 2:
              if (!(_i4 < _e11.length)) {
                _context23.next = 7;
                break;
              }
              return _context23.delegateYield(_loop(), "t0", 4);
            case 4:
              _i4++;
              _context23.next = 2;
              break;
            case 7:
            case "end":
              return _context23.stop();
          }
        }, _callee22);
      }));
    }
  }, {
    key: "pull",
    value: function pull() {
      for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        e[_key8] = arguments[_key8];
      }
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var _this5 = this;
        var t, r, o, _loop2, _i5, _e13, n, a;
        return _regeneratorRuntime().wrap(function _callee23$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (this.config.serviceHost) {
                _context25.next = 2;
                break;
              }
              throw Errors.NoRemoteError;
            case 2:
              if (!(void 0 === this.id)) {
                _context25.next = 4;
                break;
              }
              throw Errors.ThreadIDError;
            case 4:
              t = ThreadID.fromString(this.id), r = this.storage.table(ChangeTableName);
              _context25.next = 7;
              return r.count();
            case 7:
              if (!_context25.sent) {
                _context25.next = 9;
                break;
              }
              throw Errors.LocalChangesError;
            case 9:
              o = createDbClient(this.config);
              _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                var r, e, n, a;
                return _regeneratorRuntime().wrap(function _loop2$(_context24) {
                  while (1) switch (_context24.prev = _context24.next) {
                    case 0:
                      r = _e13[_i5];
                      _context24.next = 3;
                      return o.find(t, r, {});
                    case 3:
                      e = _context24.sent;
                      n = _this5.storage.table(r);
                      _context24.next = 7;
                      return n.bulkPut(e, {
                        allKeys: !0
                      });
                    case 7:
                      a = _context24.sent;
                      _context24.next = 10;
                      return n.filter(function (e) {
                        return !a.includes(e._id);
                      }).delete();
                    case 10:
                    case "end":
                      return _context24.stop();
                  }
                }, _loop2);
              });
              _i5 = 0, _e13 = e;
            case 12:
              if (!(_i5 < _e13.length)) {
                _context25.next = 17;
                break;
              }
              return _context25.delegateYield(_loop2(), "t0", 14);
            case 14:
              _i5++;
              _context25.next = 12;
              break;
            case 17:
              n = this.storage.table(ChangeTableName);
              _context25.next = 20;
              return n.filter(function (e) {
                return e.ops.length > 0 && !function (e) {
                  var _e14 = _slicedToArray(e, 1),
                    t = _e14[0];
                  return "add" === t.op && "/_mod" == t.path;
                }(e.ops);
              }).toArray();
            case 20:
              a = _context25.sent;
              _context25.next = 23;
              return n.clear();
            case 23:
              return _context25.abrupt("return", a.map(function (e) {
                return e.key;
              }));
            case 24:
            case "end":
              return _context25.stop();
          }
        }, _callee23, this);
      }));
    }
  }]);
  return Remote;
}();
/*! indexeddbshim - v6.6.0 - 8/22/2020 */
!function () {
  function e(t) {
    return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(t);
  }
  function t(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function r(e, t) {
    for (var r = 0; r < t.length; r++) {
      var o = t[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  function o(e, t) {
    for (var r in t) (a = t[r]).configurable = a.enumerable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, r, a);
    if (Object.getOwnPropertySymbols) for (var o = Object.getOwnPropertySymbols(t), n = 0; n < o.length; n++) {
      var a,
        i = o[n];
      (a = t[i]).configurable = a.enumerable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, i, a);
    }
    return e;
  }
  function n(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  function a(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      t && (o = o.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, o);
    }
    return r;
  }
  function i(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? a(Object(r), !0).forEach(function (t) {
        n(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  function s(e, t) {
    return (s = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function u() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }
  function l(e, t, r) {
    return (l = u() ? Reflect.construct : function (e, t, r) {
      var o = [null];
      o.push.apply(o, t);
      var n = new (Function.bind.apply(e, o))();
      return r && s(n, r.prototype), n;
    }).apply(null, arguments);
  }
  function c(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var r = [],
          o = !0,
          n = !1,
          a = void 0;
        try {
          for (var i, s = e[Symbol.iterator](); !(o = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
        } catch (e) {
          n = !0, a = e;
        } finally {
          try {
            o || null == s.return || s.return();
          } finally {
            if (n) throw a;
          }
        }
        return r;
      }
    }(e, t) || g(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function p(e) {
    return function (e) {
      if (Array.isArray(e)) return d(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || g(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function g(e, t) {
    if (e) {
      if ("string" == typeof e) return d(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? d(e, t) : void 0;
    }
  }
  function d(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, o = new Array(t); r < t; r++) o[r] = e[r];
    return o;
  }
  function f(e, t) {
    var r;
    if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
      if (Array.isArray(e) || (r = g(e)) || t && e && "number" == typeof e.length) {
        r && (e = r);
        var o = 0,
          n = function n() {};
        return {
          s: n,
          n: function n() {
            return o >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[o++]
            };
          },
          e: function e(_e15) {
            throw _e15;
          },
          f: n
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var a,
      i = !0,
      s = !1;
    return {
      s: function s() {
        r = e[Symbol.iterator]();
      },
      n: function n() {
        var e = r.next();
        return i = e.done, e;
      },
      e: function e(_e16) {
        s = !0, a = _e16;
      },
      f: function f() {
        try {
          i || null == r.return || r.return();
        } finally {
          if (s) throw a;
        }
      }
    };
  }
  var h = void 0 !== y ? y : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {},
    y = void 0 !== h ? h : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};
  function b(e) {
    return (b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  var m = 0,
    _ = 1,
    v = 2,
    E = 3,
    S = "undefined" == typeof DOMException ? function (e, t) {
      var r = new Error(e);
      return r.name = t, r;
    } : DOMException,
    R = new WeakMap(),
    w = new WeakMap(),
    T = function T(e) {
      this[Symbol.toStringTag] = "Event", this.toString = function () {
        return "[object Event]";
      };
      var t = Array.prototype.slice.call(arguments),
        r = t[1],
        o = t[2];
      if (!arguments.length) throw new TypeError("Failed to construct 'Event': 1 argument required, but only 0 present.");
      o = o || {};
      var n = {};
      "composed" in (r = r || {}) && (n.composed = r.composed), R.set(this, o), w.set(this, n), this.initEvent(e, r.bubbles, r.cancelable), Object.defineProperties(this, ["target", "currentTarget", "eventPhase", "defaultPrevented"].reduce(function (e, t) {
        return e[t] = {
          get: function get() {
            return void 0 !== n[t] ? n[t] : t in o ? o[t] : "eventPhase" === t ? 0 : "defaultPrevented" !== t && null;
          }
        }, e;
      }, {}));
      var a = ["type", "bubbles", "cancelable", "isTrusted", "timeStamp", "initEvent", "composedPath", "composed"];
      "[object CustomEvent]" === this.toString() && a.push("detail", "initCustomEvent"), Object.defineProperties(this, a.reduce(function (e, t) {
        return e[t] = {
          get: function get() {
            return t in n ? n[t] : t in o ? o[t] : !["bubbles", "cancelable", "composed"].includes(t) && void 0;
          }
        }, e;
      }, {}));
    };
  T.prototype.preventDefault = function () {
    if (!(this instanceof T)) throw new TypeError("Illegal invocation");
    var e = R.get(this),
      t = w.get(this);
    this.cancelable && !t._passive && (t.defaultPrevented = !0, "function" == typeof e.preventDefault && e.preventDefault());
  }, T.prototype.stopImmediatePropagation = function () {
    w.get(this)._stopImmediatePropagation = !0;
  }, T.prototype.stopPropagation = function () {
    w.get(this)._stopPropagation = !0;
  }, T.prototype.initEvent = function (e, t, r) {
    var o = w.get(this);
    o._dispatched || (o.type = e, void 0 !== t && (o.bubbles = t), void 0 !== r && (o.cancelable = r));
  }, ["type", "target", "currentTarget"].forEach(function (e) {
    Object.defineProperty(T.prototype, e, {
      enumerable: !0,
      configurable: !0,
      get: function get() {
        throw new TypeError("Illegal invocation");
      }
    });
  }), ["eventPhase", "defaultPrevented", "bubbles", "cancelable", "timeStamp"].forEach(function (e) {
    Object.defineProperty(T.prototype, e, {
      enumerable: !0,
      configurable: !0,
      get: function get() {
        throw new TypeError("Illegal invocation");
      }
    });
  }), ["NONE", "CAPTURING_PHASE", "AT_TARGET", "BUBBLING_PHASE"].forEach(function (e, t) {
    Object.defineProperty(T, e, {
      enumerable: !0,
      writable: !1,
      value: t
    }), Object.defineProperty(T.prototype, e, {
      writable: !1,
      value: t
    });
  }), T[Symbol.toStringTag] = "Function", T.prototype[Symbol.toStringTag] = "EventPrototype", Object.defineProperty(T, "prototype", {
    writable: !1
  });
  var P = function P(e) {
    var t = Array.prototype.slice.call(arguments),
      r = t[1],
      o = t[2];
    T.call(this, e, r, o), this[Symbol.toStringTag] = "CustomEvent", this.toString = function () {
      return "[object CustomEvent]";
    }, r = r || {}, this.initCustomEvent(e, r.bubbles, r.cancelable, "detail" in r ? r.detail : null);
  };
  function A(e, t, r) {
    var o = e[t];
    void 0 === o && (e[t] = o = []), r = "boolean" == typeof r ? {
      capture: r
    } : r || {};
    var n = JSON.stringify(r);
    return {
      listenersByTypeOptions: o.filter(function (e) {
        return n === JSON.stringify(e.options);
      }),
      options: r,
      listenersByType: o
    };
  }
  Object.defineProperty(P.prototype, "constructor", {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: P
  }), P.prototype.initCustomEvent = function (e, t, r, o) {
    if (!(this instanceof P)) throw new TypeError("Illegal invocation");
    var n = w.get(this);
    P.call(this, e, {
      bubbles: t,
      cancelable: r,
      detail: o
    }, arguments[4]), n._dispatched || (void 0 !== o && (n.detail = o), Object.defineProperty(this, "detail", {
      get: function get() {
        return n.detail;
      }
    }));
  }, P[Symbol.toStringTag] = "Function", P.prototype[Symbol.toStringTag] = "CustomEventPrototype", Object.defineProperty(P.prototype, "detail", {
    enumerable: !0,
    configurable: !0,
    get: function get() {
      throw new TypeError("Illegal invocation");
    }
  }), Object.defineProperty(P, "prototype", {
    writable: !1
  });
  var D = {
    addListener: function addListener(e, t, r, o) {
      var n = A(e, r, o),
        a = n.listenersByTypeOptions;
      o = n.options;
      var i = n.listenersByType;
      a.some(function (e) {
        return e.listener === t;
      }) || i.push({
        listener: t,
        options: o
      });
    },
    removeListener: function removeListener(e, t, r, o) {
      var n = A(e, r, o),
        a = n.listenersByType,
        i = JSON.stringify(n.options);
      a.some(function (o, n) {
        return o.listener === t && i === JSON.stringify(o.options) && (a.splice(n, 1), a.length || delete e[r], !0);
      });
    },
    hasListener: function hasListener(e, t, r, o) {
      return A(e, r, o).listenersByTypeOptions.some(function (e) {
        return e.listener === t;
      });
    }
  };
  function O() {
    throw new TypeError("Illegal constructor");
  }
  Object.assign(O.prototype, ["Early", "", "Late", "Default"].reduce(function (e, t) {
    return ["add", "remove", "has"].forEach(function (r) {
      e[r + t + "EventListener"] = function (e, o) {
        var n = arguments[2];
        if (arguments.length < 2) throw new TypeError("2 or more arguments required");
        if ("string" != typeof e) throw new S("UNSPECIFIED_EVENT_TYPE_ERR", "UNSPECIFIED_EVENT_TYPE_ERR");
        try {
          o.handleEvent && o.handleEvent.bind && (o = o.handleEvent.bind(o));
        } catch (e) {
          console.log("Uncaught `handleEvent` error", e);
        }
        var a = "_" + t.toLowerCase() + ("" === t ? "l" : "L") + "isteners";
        return this[a] || Object.defineProperty(this, a, {
          value: {}
        }), D[r + "Listener"](this[a], o, e, n);
      };
    }), e;
  }, {})), Object.assign(O.prototype, {
    __setOptions: function __setOptions(e) {
      e = e || {}, this._defaultSync = e.defaultSync, this._extraProperties = e.extraProperties || [], e.legacyOutputDidListenersThrowFlag && (this._legacyOutputDidListenersThrowCheck = !0, this._extraProperties.push("__legacyOutputDidListenersThrowError"));
    },
    dispatchEvent: function dispatchEvent(e) {
      return this._dispatchEvent(e, !0);
    },
    _dispatchEvent: function _dispatchEvent(e, t) {
      var r = this;
      ["early", "", "late", "default"].forEach(function (e) {
        var t = "_" + e + ("" === e ? "l" : "L") + "isteners";
        r[t] || Object.defineProperty(r, t, {
          value: {}
        });
      });
      var o,
        n = w.get(e);
      if (n && t && n._dispatched) throw new S("The object is in an invalid state.", "InvalidStateError");
      n ? o = e : (o = function (e) {
        var t = e.bubbles,
          r = e.cancelable,
          o = e.detail,
          n = e.type;
        return "detail" in e ? new P(n, {
          bubbles: t,
          cancelable: r,
          detail: o
        }, e) : new T(n, {
          bubbles: t,
          cancelable: r
        }, e);
      }(e), (n = w.get(o))._dispatched = !0, this._extraProperties.forEach(function (t) {
        t in e && (o[t] = e[t]);
      }));
      var a = o.type;
      function i() {
        n.eventPhase = m, n.currentTarget = null, delete n._children;
      }
      function s() {
        n._stopImmediatePropagation = void 0, n._stopPropagation = void 0, o.defaultPrevented && n.cancelable || (n.eventPhase = v, o.target.invokeCurrentListeners(o.target._defaultListeners, o, a)), i();
      }
      var u = function u() {
        return n._stopImmediatePropagation = void 0, n._stopPropagation = void 0, r._defaultSync ? s() : setTimeout(s, 0), n.eventPhase = v, n._stopPropagation || (n._stopImmediatePropagation = void 0, n._stopPropagation = void 0, o.target.invokeCurrentListeners(o.target._lateListeners, o, a)), i(), !o.defaultPrevented;
      };
      switch (t && (n.target = this), o.eventPhase) {
        default:
        case m:
          if (n.eventPhase = v, this.invokeCurrentListeners(this._earlyListeners, o, a), !this.__getParent) return n.eventPhase = v, this._dispatchEvent(o, !1);
          for (var l = this, c = this; l.__getParent && null !== (l = l.__getParent());) n._children || (n._children = []), n._children.push(c), c = l;
          return c._defaultSync = this._defaultSync, n.eventPhase = _, c._dispatchEvent(o, !1);
        case _:
          if (n._stopPropagation) return u();
          this.invokeCurrentListeners(this._listeners, o, a);
          var p = n._children && n._children.length && n._children.pop();
          return p && p !== o.target || (n.eventPhase = v), p && (p._defaultSync = this._defaultSync), (p || this)._dispatchEvent(o, !1);
        case v:
          return n._stopPropagation ? u() : (this.invokeCurrentListeners(this._listeners, o, a, !0), n.bubbles ? (n.eventPhase = E, this._dispatchEvent(o, !1)) : u());
        case E:
          if (n._stopPropagation) return u();
          var g = this.__getParent && this.__getParent();
          return g ? (g.invokeCurrentListeners(g._listeners, o, a, !0), g._defaultSync = this._defaultSync, g._dispatchEvent(o, !1)) : u();
      }
    },
    invokeCurrentListeners: function invokeCurrentListeners(e, t, r, o) {
      var n = this,
        a = w.get(t);
      a.currentTarget = this;
      var i = A(e, r, {}).listenersByType.concat(),
        s = i.length ? 1 : 0;
      return i.some(function (e, i) {
        var u = o ? n["on" + r] : null;
        if (a._stopImmediatePropagation) return !0;
        i === s && "function" == typeof u && n.tryCatch(t, function () {
          !1 === u.call(t.currentTarget, t) && t.preventDefault();
        });
        var l = e.options,
          c = l.once,
          p = l.passive,
          g = l.capture;
        if (a._passive = p, g && t.target !== t.currentTarget && t.eventPhase === _ || t.eventPhase === v || !g && t.target !== t.currentTarget && t.eventPhase === E) {
          var d = e.listener;
          n.tryCatch(t, function () {
            d.call(t.currentTarget, t);
          }), c && n.removeEventListener(r, d, l);
        }
        return !1;
      }), this.tryCatch(t, function () {
        var e = o ? n["on" + r] : null;
        "function" == typeof e && i.length < 2 && !1 === e.call(t.currentTarget, t) && t.preventDefault();
      }), !t.defaultPrevented;
    },
    tryCatch: function tryCatch(e, t) {
      try {
        t();
      } catch (t) {
        this.triggerErrorEvent(t, e);
      }
    },
    triggerErrorEvent: function triggerErrorEvent(e, t) {
      var r,
        o = e;
      "string" == typeof e && (o = new Error("Uncaught exception: " + e));
      var n = !1;
      "undefined" == typeof window || "undefined" == typeof ErrorEvent || window && "object" === ("undefined" == typeof window ? "undefined" : b(window)) && !window.dispatchEvent ? (n = !0, r = function r() {
        setTimeout(function () {
          throw o;
        });
      }) : r = function r() {
        var t = new ErrorEvent("error", {
          error: e,
          message: o.message || "",
          filename: o.fileName || "",
          lineno: o.lineNumber || 0,
          colno: o.columnNumber || 0
        });
        window.dispatchEvent(t);
      }, n && this._legacyOutputDidListenersThrowCheck || r(), this._legacyOutputDidListenersThrowCheck && (t.__legacyOutputDidListenersThrowError = o);
    }
  }), O.prototype[Symbol.toStringTag] = "EventTargetPrototype", Object.defineProperty(O, "prototype", {
    writable: !1
  });
  var I = O,
    C = {
      createInstance: function createInstance(e) {
        function t() {
          this.__setOptions(e);
        }
        return t.prototype = I.prototype, new t();
      }
    };
  O.ShimEvent = T, O.ShimCustomEvent = P, O.ShimDOMException = S, O.ShimEventTarget = O, O.EventTargetFactory = C;
  var B = {},
    F = {};
  ["DEBUG", "cacheDatabaseInstances", "autoName", "fullIDLSupport", "checkOrigin", "cursorPreloadPackSize", "UnicodeIDStart", "UnicodeIDContinue", "registerSCA", "avoidAutoShim", "win", "DEFAULT_DB_SIZE", "useSQLiteIndexes", "fs", "addNonIDBGlobals", "replaceNonIDBGlobals", "escapeDatabaseName", "unescapeDatabaseName", "databaseCharacterEscapeList", "databaseNameLengthLimit", "escapeNFDForDatabaseNames", "addSQLiteExtension", ["memoryDatabase", function (e) {
    if (!/^(?::memory:|file::memory:(\?(?:[\0-"\$-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?(#(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?)?$/.test(e)) throw new TypeError('`memoryDatabase` must be the empty string, ":memory:", or a "file::memory:[?queryString][#hash] URL".');
  }], "deleteDatabaseFiles", "databaseBasePath", "sysDatabaseBasePath", "sqlBusyTimeout", "sqlTrace", "sqlProfile"].forEach(function (e) {
    var t;
    if (Array.isArray(e)) {
      var r = c(e, 2);
      e = r[0], t = r[1];
    }
    Object.defineProperty(F, e, {
      get: function get() {
        return B[e];
      },
      set: function set(r) {
        t && t(r), B[e] = r;
      }
    });
  });
  var j = /[\xC0-\xC5\xC7-\xCF\xD1-\xD6\xD9-\xDD\xE0-\xE5\xE7-\xEF\xF1-\xF6\xF9-\xFD\xFF-\u010F\u0112-\u0125\u0128-\u0130\u0134-\u0137\u0139-\u013E\u0143-\u0148\u014C-\u0151\u0154-\u0165\u0168-\u017E\u01A0\u01A1\u01AF\u01B0\u01CD-\u01DC\u01DE-\u01E3\u01E6-\u01F0\u01F4\u01F5\u01F8-\u021B\u021E\u021F\u0226-\u0233\u0344\u0385\u0386\u0388-\u038A\u038C\u038E-\u0390\u03AA-\u03B0\u03CA-\u03CE\u03D3\u03D4\u0400\u0401\u0403\u0407\u040C-\u040E\u0419\u0439\u0450\u0451\u0453\u0457\u045C-\u045E\u0476\u0477\u04C1\u04C2\u04D0-\u04D3\u04D6\u04D7\u04DA-\u04DF\u04E2-\u04E7\u04EA-\u04F5\u04F8\u04F9\u0622-\u0626\u06C0\u06C2\u06D3\u0929\u0931\u0934\u0958-\u095F\u09CB\u09CC\u09DC\u09DD\u09DF\u0A33\u0A36\u0A59-\u0A5B\u0A5E\u0B48\u0B4B\u0B4C\u0B5C\u0B5D\u0B94\u0BCA-\u0BCC\u0C48\u0CC0\u0CC7\u0CC8\u0CCA\u0CCB\u0D4A-\u0D4C\u0DDA\u0DDC-\u0DDE\u0F43\u0F4D\u0F52\u0F57\u0F5C\u0F69\u0F73\u0F75\u0F76\u0F78\u0F81\u0F93\u0F9D\u0FA2\u0FA7\u0FAC\u0FB9\u1026\u1B06\u1B08\u1B0A\u1B0C\u1B0E\u1B12\u1B3B\u1B3D\u1B40\u1B41\u1B43\u1E00-\u1E99\u1E9B\u1EA0-\u1EF9\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FC1-\u1FC4\u1FC6-\u1FD3\u1FD6-\u1FDB\u1FDD-\u1FEE\u1FF2-\u1FF4\u1FF6-\u1FFC\u212B\u219A\u219B\u21AE\u21CD-\u21CF\u2204\u2209\u220C\u2224\u2226\u2241\u2244\u2247\u2249\u2260\u2262\u226D-\u2271\u2274\u2275\u2278\u2279\u2280\u2281\u2284\u2285\u2288\u2289\u22AC-\u22AF\u22E0-\u22E3\u22EA-\u22ED\u2ADC\u304C\u304E\u3050\u3052\u3054\u3056\u3058\u305A\u305C\u305E\u3060\u3062\u3065\u3067\u3069\u3070\u3071\u3073\u3074\u3076\u3077\u3079\u307A\u307C\u307D\u3094\u309E\u30AC\u30AE\u30B0\u30B2\u30B4\u30B6\u30B8\u30BA\u30BC\u30BE\u30C0\u30C2\u30C5\u30C7\u30C9\u30D0\u30D1\u30D3\u30D4\u30D6\u30D7\u30D9\u30DA\u30DC\u30DD\u30F4\u30F7-\u30FA\u30FE\uAC00-\uD7A3\uFB1D\uFB1F\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFB4E]|\uD804[\uDC9A\uDC9C\uDCAB\uDD2E\uDD2F\uDF4B\uDF4C]|\uD805[\uDCBB\uDCBC\uDCBE\uDDBA\uDDBB]|\uD834[\uDD5E-\uDD64\uDDBB-\uDDC0]/;
  function N(e) {
    return e.replace(/((?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])))(?!(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))|(^|(?:[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))((?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/g, function (e, t, r, o) {
      return t ? "^2" + se(t.charCodeAt().toString(16), 4, "0") : (r || "") + "^3" + se(o.charCodeAt().toString(16), 4, "0");
    });
  }
  function M(e) {
    return "_" + N(e.replace(/\^/g, "^^").replace(/\0/g, "^0").replace(/([A-Z])/g, "^$1"));
  }
  function x(e) {
    return N(e.replace(/\^/g, "^^").replace(/\0/g, "^0"));
  }
  function L(e) {
    return function (e) {
      return e.replace(/(\^+)3(d[0-9a-f]{3})/g, function (e, t, r) {
        return t.length % 2 ? t.slice(1) + String.fromCharCode(Number.parseInt(r, 16)) : e;
      }).replace(/(\^+)2(d[0-9a-f]{3})/g, function (e, t, r) {
        return t.length % 2 ? t.slice(1) + String.fromCharCode(Number.parseInt(r, 16)) : e;
      });
    }(e).replace(/(\^+)0/g, function (e, t) {
      return t.length % 2 ? t.slice(1) + "\0" : e;
    }).replace(/\^\^/g, "^");
  }
  function U(e) {
    return e.replace(/"/g, '""');
  }
  function k(e) {
    return '"' + U(e) + '"';
  }
  function q(e) {
    if (F.escapeDatabaseName) return F.escapeDatabaseName(x(e));
    if (e = "D" + M(e), !1 !== F.escapeNFDForDatabaseNames && (e = e.replace(new RegExp(j.source, "gu"), function (e) {
      return "^4" + se(e.codePointAt().toString(16), 6, "0");
    })), !1 !== F.databaseCharacterEscapeList && (e = e.replace(F.databaseCharacterEscapeList ? new RegExp(F.databaseCharacterEscapeList, "gu") : /[\0-\x1F"\*\/:<>\?\\\|\x7F]/g, function (e) {
      return "^1" + se(e.charCodeAt().toString(16), 2, "0");
    })), !1 !== F.databaseNameLengthLimit && e.length >= (F.databaseNameLengthLimit || 254) - (!1 !== F.addSQLiteExtension ? 7 : 0)) throw new Error("Unexpectedly long database name supplied; length limit required for Node compatibility; passed length: " + e.length + "; length limit setting: " + (F.databaseNameLengthLimit || 254) + ".");
    return e + (!1 !== F.addSQLiteExtension ? ".sqlite" : "");
  }
  function W(e) {
    return k("S" + M(e));
  }
  function H(e) {
    return k("I" + M(e));
  }
  function G(e) {
    return "I" + M(e);
  }
  function V(e) {
    return U(e).replace(/\^/g, "^^");
  }
  function z(e, t) {
    return t[Symbol.hasInstance](e);
  }
  function K(t) {
    return t && "object" === e(t);
  }
  function $(e) {
    return K(e) && "function" == typeof e[Symbol.iterator];
  }
  function Y(e, t) {
    t.forEach(function (t) {
      var r,
        n,
        a = (r = {}, (n = {})[t] = n[t] || {}, n[t].get = function () {
          throw new TypeError("Illegal invocation");
        }, n[t] = n[t] || {}, n[t].set = function (e) {
          throw new TypeError("Illegal invocation");
        }, o(r, n), r),
        i = Object.getOwnPropertyDescriptor(a, t);
      Object.defineProperty(e, t, i);
    });
  }
  function Q(e, t) {
    t.forEach(function (t) {
      var r,
        n,
        a = (r = {}, (n = {})[t] = n[t] || {}, n[t].get = function () {
          throw new TypeError("Illegal invocation");
        }, o(r, n), r),
        i = Object.getOwnPropertyDescriptor(a, t);
      Object.defineProperty(e, t, i);
    });
  }
  function X(e, t) {
    (t = "string" == typeof t ? [t] : t).forEach(function (t) {
      var r,
        n,
        a = (r = {}, (n = {})[t] = n[t] || {}, n[t].get = function () {
          return e["__" + t];
        }, n[t] = n[t] || {}, n[t].set = function (r) {
          e["__" + t] = r;
        }, o(r, n), r),
        i = Object.getOwnPropertyDescriptor(a, t);
      Object.defineProperty(e, t, i);
    }), t.forEach(function (t) {
      e[t] = null;
    });
  }
  function J(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
    (t = "string" == typeof t ? [t] : t).forEach(function (t) {
      var n, a, i;
      r && t in r ? n = r[t] : (Object.defineProperty(e, "__" + t, {
        enumerable: !1,
        configurable: !1,
        writable: !0
      }), a = {}, (i = {})[t] = i[t] || {}, i[t].get = function () {
        return this["__" + t];
      }, o(a, i), n = a);
      var s = Object.getOwnPropertyDescriptor(n, t);
      Object.defineProperty(e, t, s);
    });
  }
  function Z(e) {
    var t = F.UnicodeIDStart || "[$A-Z_a-z]",
      r = F.UnicodeIDContinue || "[$0-9A-Z_a-z]";
    return new RegExp("^(?:" + t + "|[$_])(?:" + r + "|[$_‌‍])*$", "u").test(e);
  }
  function ee(e) {
    return "string" == typeof e && ("" === e || Z(e) || e.split(".").every(function (e) {
      return Z(e);
    }));
  }
  function te(e) {
    return ee(e) || Array.isArray(e) && e.length && p(e).every(function (e) {
      return ee(e);
    });
  }
  function re(e, t) {
    var r, o;
    switch (e = Math.floor(Number(e)), t) {
      case "unsigned long long":
        r = 9007199254740991, o = 0;
        break;
      case "unsigned long":
        r = 4294967295, o = 0;
        break;
      default:
        throw new Error("Unrecognized type supplied to enforceRange");
    }
    if (!Number.isFinite(e) || e > r || e < o) throw new TypeError("Invalid range: " + e);
    return e;
  }
  function oe(e, t) {
    return null === e && t ? "" : ne(e);
  }
  function ne(e) {
    return "" + e;
  }
  function ae(e) {
    return $(e) ? p(e).map(function (e) {
      return ne(e);
    }) : ne(e);
  }
  function ie(e) {
    return null == e;
  }
  function se(e, t, r) {
    return new Array(t - String(e).length + 1).join(r) + e;
  }
  function ue(e, t, r) {
    var o = new T(e, r);
    return o.debug = t, o;
  }
  function le(e) {
    T.call(this, e), this[Symbol.toStringTag] = "IDBVersionChangeEvent", this.toString = function () {
      return "[object IDBVersionChangeEvent]";
    }, this.__eventInitDict = arguments[1] || {};
  }
  function ce(e, t) {
    return new DOMException.prototype.constructor(t, e || "DOMException");
  }
  Object.defineProperty(T, Symbol.hasInstance, {
    value: function value(e) {
      return K(e) && "target" in e && "boolean" == typeof e.bubbles;
    }
  }), le.prototype = Object.create(T.prototype), le.prototype[Symbol.toStringTag] = "IDBVersionChangeEventPrototype", ["oldVersion", "newVersion"].forEach(function (e) {
    var t,
      r,
      n = (t = {}, (r = {})[e] = r[e] || {}, r[e].get = function () {
        if (!(this instanceof le)) throw new TypeError("Illegal invocation");
        return this.__eventInitDict && this.__eventInitDict[e] || ("oldVersion" === e ? 0 : null);
      }, o(t, r), t),
      a = Object.getOwnPropertyDescriptor(n, e);
    Object.defineProperty(le.prototype, e, a);
  }), Object.defineProperty(le, Symbol.hasInstance, {
    value: function value(e) {
      return K(e) && "oldVersion" in e && "boolean" == typeof e.defaultPrevented;
    }
  }), Object.defineProperty(le.prototype, "constructor", {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: le
  }), Object.defineProperty(le, "prototype", {
    writable: !1
  });
  var pe = {
      IndexSizeError: 1,
      HierarchyRequestError: 3,
      WrongDocumentError: 4,
      InvalidCharacterError: 5,
      NoModificationAllowedError: 7,
      NotFoundError: 8,
      NotSupportedError: 9,
      InUseAttributeError: 10,
      InvalidStateError: 11,
      SyntaxError: 12,
      InvalidModificationError: 13,
      NamespaceError: 14,
      InvalidAccessError: 15,
      TypeMismatchError: 17,
      SecurityError: 18,
      NetworkError: 19,
      AbortError: 20,
      URLMismatchError: 21,
      QuotaExceededError: 22,
      TimeoutError: 23,
      InvalidNodeTypeError: 24,
      DataCloneError: 25,
      EncodingError: 0,
      NotReadableError: 0,
      UnknownError: 0,
      ConstraintError: 0,
      DataError: 0,
      TransactionInactiveError: 0,
      ReadOnlyError: 0,
      VersionError: 0,
      OperationError: 0,
      NotAllowedError: 0
    },
    ge = {
      INDEX_SIZE_ERR: 1,
      DOMSTRING_SIZE_ERR: 2,
      HIERARCHY_REQUEST_ERR: 3,
      WRONG_DOCUMENT_ERR: 4,
      INVALID_CHARACTER_ERR: 5,
      NO_DATA_ALLOWED_ERR: 6,
      NO_MODIFICATION_ALLOWED_ERR: 7,
      NOT_FOUND_ERR: 8,
      NOT_SUPPORTED_ERR: 9,
      INUSE_ATTRIBUTE_ERR: 10,
      INVALID_STATE_ERR: 11,
      SYNTAX_ERR: 12,
      INVALID_MODIFICATION_ERR: 13,
      NAMESPACE_ERR: 14,
      INVALID_ACCESS_ERR: 15,
      VALIDATION_ERR: 16,
      TYPE_MISMATCH_ERR: 17,
      SECURITY_ERR: 18,
      NETWORK_ERR: 19,
      ABORT_ERR: 20,
      URL_MISMATCH_ERR: 21,
      QUOTA_EXCEEDED_ERR: 22,
      TIMEOUT_ERR: 23,
      INVALID_NODE_TYPE_ERR: 24,
      DATA_CLONE_ERR: 25
    },
    de = function () {
      function e(e, t) {
        this[Symbol.toStringTag] = "DOMException", this._code = t in pe ? pe[t] : ge[t] || 0, this._name = t || "Error", this._message = void 0 === e ? "" : "" + e, Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          writable: !0,
          value: this._code
        }), void 0 !== t && Object.defineProperty(this, "name", {
          configurable: !0,
          enumerable: !0,
          writable: !0,
          value: this._name
        }), void 0 !== e && Object.defineProperty(this, "message", {
          configurable: !0,
          enumerable: !1,
          writable: !0,
          value: this._message
        });
      }
      var t = function t() {};
      return t.prototype = Object.create(Error.prototype), ["name", "message"].forEach(function (r) {
        Object.defineProperty(t.prototype, r, {
          enumerable: !0,
          get: function get() {
            if (!(this instanceof e || this instanceof t || this instanceof Error)) throw new TypeError("Illegal invocation");
            return this["_" + r];
          }
        });
      }), Object.defineProperty(t.prototype, "code", {
        configurable: !0,
        enumerable: !0,
        get: function get() {
          throw new TypeError("Illegal invocation");
        }
      }), e.prototype = new t(), e.prototype[Symbol.toStringTag] = "DOMExceptionPrototype", Object.defineProperty(e, "prototype", {
        writable: !1
      }), Object.keys(pe).forEach(function (t) {
        Object.defineProperty(e.prototype, t, {
          enumerable: !0,
          configurable: !1,
          value: pe[t]
        }), Object.defineProperty(e, t, {
          enumerable: !0,
          configurable: !1,
          value: pe[t]
        });
      }), Object.keys(ge).forEach(function (t) {
        Object.defineProperty(e.prototype, t, {
          enumerable: !0,
          configurable: !1,
          value: ge[t]
        }), Object.defineProperty(e, t, {
          enumerable: !0,
          configurable: !1,
          value: ge[t]
        });
      }), Object.defineProperty(e.prototype, "constructor", {
        writable: !0,
        configurable: !0,
        enumerable: !1,
        value: e
      }), e;
    }();
  function fe(e, t, r) {
    if (F.DEBUG) {
      r && r.message && (r = r.message);
      var o = "function" == typeof console.error ? "error" : "log";
      console[o](e + ": " + t + ". " + (r || "")), console.trace && console.trace();
    }
  }
  function he(t) {
    return t && "object" === e(t) && "string" == typeof t.name;
  }
  function ye(e) {
    var t;
    if (e) {
      if (1 === e.length) return e[0];
      var r,
        o = f(e);
      try {
        for (o.s(); !(r = o.n()).done;) {
          var n = r.value;
          if (he(n)) return n;
          n && "string" == typeof n.message && (t = n);
        }
      } catch (t) {
        o.e(t);
      } finally {
        o.f();
      }
    }
    return t;
  }
  function be(e) {
    var t, r;
    switch (e.code) {
      case 4:
        t = "QuotaExceededError", r = "The operation failed because there was not enough remaining storage space, or the storage quota was reached and the user declined to give more space to the database.";
        break;
      default:
        t = "UnknownError", r = "The operation failed for reasons unrelated to the database itself and not covered by any other errors.";
    }
    r += " (" + e.message + ")--(" + e.code + ")";
    var o = ve(t, r);
    return o.sqlError = e, o;
  }
  var me,
    _e = !1;
  try {
    he(me = ce("test name", "test message")) && "test name" === me.name && "test message" === me.message && (_e = !0);
  } catch (e) {}
  var ve = _e ? function (e, t, r) {
      return fe(e, t, r), ce(e, t);
    } : function (e, t, r) {
      return fe(e, t, r), function (e, t) {
        return new de(t, e);
      }(e, t);
    },
    Ee = _e ? DOMException : de,
    Se = ["onsuccess", "onerror"],
    Re = ["source", "transaction", "readyState"],
    we = ["result", "error"];
  function Te() {
    throw new TypeError("Illegal constructor");
  }
  Te.__super = function () {
    this[Symbol.toStringTag] = "IDBRequest", this.__setOptions({
      legacyOutputDidListenersThrowFlag: !0
    }), we.forEach(function (e) {
      Object.defineProperty(this, "__" + e, {
        enumerable: !1,
        configurable: !1,
        writable: !0
      }), Object.defineProperty(this, e, {
        enumerable: !0,
        configurable: !0,
        get: function get() {
          if (!this.__done) throw ve("InvalidStateError", "Can't get " + e + "; the request is still pending.");
          return this["__" + e];
        }
      });
    }, this), J(this, Re, {
      readyState: {
        get readyState() {
          return this.__done ? "done" : "pending";
        }
      }
    }), X(this, Se), this.__result = void 0, this.__error = this.__source = this.__transaction = null, this.__done = !1;
  }, Te.__createInstance = function () {
    return new Te.__super();
  }, Te.prototype = C.createInstance({
    extraProperties: ["debug"]
  }), Te.prototype[Symbol.toStringTag] = "IDBRequestPrototype", Te.prototype.__getParent = function () {
    return "[object IDBOpenDBRequest]" === this.toString() ? null : this.__transaction;
  }, Q(Te.prototype, Re), Q(Te.prototype, we), Y(Te.prototype, Se), Object.defineProperty(Te.prototype, "constructor", {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: Te
  }), Te.__super.prototype = Te.prototype, Object.defineProperty(Te, "prototype", {
    writable: !1
  });
  var Pe = ["onblocked", "onupgradeneeded"];
  function Ae() {
    throw new TypeError("Illegal constructor");
  }
  Ae.prototype = Object.create(Te.prototype), Object.defineProperty(Ae.prototype, "constructor", {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: Ae
  });
  var De = Ae;
  function Oe(e) {
    return e && "function" == typeof e.then;
  }
  function Ie(e, t) {
    e.then(null, t);
  }
  function Ce(e) {
    var t = this;
    function r(e, r) {
      t.v = e, t.s = r, t.c[r].forEach(function (t) {
        t(e);
      }), t.c[r].length && (t.c = null);
    }
    function o(e) {
      t.c && (Oe(e) ? Ie(e.then(o), o) : r(e, 1));
    }
    t.v = 0, t.s = 2, t.c = [[], []];
    try {
      e(function e(n) {
        t.c && (Oe(n) ? Ie(n.then(e), o) : r(n, 0));
      }, o);
    } catch (e) {
      o(e);
    }
  }
  Ae.__createInstance = function () {
    function e() {
      Te.__super.call(this), this[Symbol.toStringTag] = "IDBOpenDBRequest", this.__setOptions({
        legacyOutputDidListenersThrowFlag: !0,
        extraProperties: ["oldVersion", "newVersion", "debug"]
      }), X(this, Pe);
    }
    return e.prototype = De.prototype, new e();
  }, Y(Ae.prototype, Pe), Ae.prototype[Symbol.toStringTag] = "IDBOpenDBRequestPrototype", Object.defineProperty(Ae, "prototype", {
    writable: !1
  });
  var Be = Ce.prototype;
  Be.then = function (e, t) {
    var r = this;
    return new Ce(function (o, n) {
      var a = "function" == typeof t ? t : n;
      function i() {
        try {
          o(e ? e(r.v) : r.v);
        } catch (e) {
          a(e);
        }
      }
      0 === r.s ? i() : 1 === r.s ? a(r.v) : (r.c[0].push(i), r.c[1].push(a));
    });
  }, Be.catch = function (e) {
    var t = this;
    return new Ce(function (r, o) {
      function n() {
        try {
          r(e(t.v));
        } catch (e) {
          o(e);
        }
      }
      1 === t.s ? n() : 0 === t.s ? r(t.v) : (t.c[1].push(n), t.c[0].push(r));
    });
  }, Ce.all = function (e) {
    return new Ce(function (t, r, o) {
      o = e.length;
      var n = [];
      o ? e.forEach(function (a, i) {
        Oe(a) ? Ie(a.then(function (e) {
          n[i] = e, --o || t(n);
        }), r) : (n[i] = a, --o || t(e));
      }) : t(n);
    });
  }, Ce.race = function (e) {
    var t = !1;
    return new Ce(function (r, o) {
      e.some(function (e, n) {
        if (!Oe(e)) return r(e), t = !0, !0;
        Ie(e.then(function (e) {
          t || (r(e), t = !0);
        }), o);
      });
    });
  }, Ce.resolve = function (e) {
    return new Ce(function (t, r) {
      t(e);
    });
  }, Ce.reject = function (e) {
    return new Ce(function (t, r) {
      r(e);
    });
  };
  var Fe = Ce;
  function je(t, r) {
    var o = it(t),
      n = it(r),
      a = o > n ? 1 : o === n ? 0 : -1;
    if (F.DEBUG) {
      var i = st(o),
        s = st(n);
      "object" === e(t) && (t = JSON.stringify(t), i = JSON.stringify(i)), "object" === e(r) && (r = JSON.stringify(r), s = JSON.stringify(s)), i !== t && console.warn(t + " was incorrectly encoded as " + i), s !== r && console.warn(r + " was incorrectly encoded as " + s);
    }
    return a;
  }
  var Ne = {
      invalid: 100,
      number: 200,
      date: 300,
      string: 400,
      binary: 500,
      array: 600
    },
    Me = Object.keys(Ne);
  Me.forEach(function (e) {
    Ne[e] = String.fromCharCode(Ne[e]);
  });
  var xe = Me.reduce(function (e, t) {
      return e[Ne[t]] = t, e;
    }, {}),
    Le = ["negativeInfinity", "bigNegative", "smallNegative", "smallPositive", "bigPositive", "positiveInfinity"],
    Ue = {
      invalid: {
        encode: function encode(e) {
          return Ne.invalid + "-";
        },
        decode: function decode(e) {}
      },
      number: {
        encode: function encode(e) {
          var t,
            r,
            o,
            n = e === Number.MIN_VALUE ? "0." + "0".repeat(214) + "2" : Math.abs(e).toString(32),
            a = n.indexOf("."),
            i = (n = -1 !== a ? n.replace(".", "") : n).search(/(?:[\0-\/1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/);
          return n = n.slice(i), Number.isFinite(Number(e)) ? e < 0 ? e > -1 ? (t = Le.indexOf("smallNegative"), r = ke(i), o = We(qe(n))) : (t = Le.indexOf("bigNegative"), r = We(ke(-1 !== a ? a : n.length)), o = We(qe(n))) : e < 1 ? (t = Le.indexOf("smallPositive"), r = We(ke(i)), o = qe(n)) : (t = Le.indexOf("bigPositive"), r = ke(-1 !== a ? a : n.length), o = qe(n)) : (r = Ve(2), o = Ve(11), t = Le.indexOf(e > 0 ? "positiveInfinity" : "negativeInfinity")), Ne.number + "-" + t + r + o;
        },
        decode: function decode(e) {
          var t = Number(e.slice(2, 3)),
            r = e.slice(3, 5),
            o = e.slice(5, 16);
          switch (Le[t]) {
            case "negativeInfinity":
              return -1 / 0;
            case "positiveInfinity":
              return 1 / 0;
            case "bigPositive":
              return He(o, r);
            case "smallPositive":
              return He(o, r = ze(We(r)));
            case "smallNegative":
              return r = ze(r), -He(o = We(o), r);
            case "bigNegative":
              return r = We(r), -He(o = We(o), r);
            default:
              throw new Error("Invalid number.");
          }
        }
      },
      string: {
        encode: function encode(e, t) {
          return t && (e = e.replace(/((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/g, "-$1") + " "), Ne.string + "-" + e;
        },
        decode: function decode(e, t) {
          return e = e.slice(2), t && (e = e.slice(0, -1).replace(/\x2D((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/g, "$1")), e;
        }
      },
      array: {
        encode: function encode(e) {
          var t,
            r = [],
            o = f(e.entries());
          try {
            for (o.s(); !(t = o.n()).done;) {
              var n = c(t.value, 2),
                a = n[0],
                i = it(n[1], !0);
              r[a] = i;
            }
          } catch (e) {
            o.e(e);
          } finally {
            o.f();
          }
          return r.push(Ne.invalid + "-"), Ne.array + "-" + JSON.stringify(r);
        },
        decode: function decode(e) {
          var t = JSON.parse(e.slice(2));
          t.pop();
          for (var r = 0; r < t.length; r++) {
            var o = st(t[r], !0);
            t[r] = o;
          }
          return t;
        }
      },
      date: {
        encode: function encode(e) {
          return Ne.date + "-" + e.toJSON();
        },
        decode: function decode(e) {
          return new Date(e.slice(2));
        }
      },
      binary: {
        encode: function encode(e) {
          return Ne.binary + "-" + (e.byteLength ? p(Ye(e)).map(function (e) {
            return se(e, 3, "0");
          }) : "");
        },
        decode: function decode(e) {
          var t = e.slice(2),
            r = t.length ? t.split(",").map(function (e) {
              return Number.parseInt(e);
            }) : [],
            o = new ArrayBuffer(r.length);
          return new Uint8Array(o).set(r), o;
        }
      }
    };
  function ke(e) {
    return 1 === (e = e.toString(32)).length ? "0" + e : e;
  }
  function qe(e) {
    return (e + Ve(11)).slice(0, 11);
  }
  function We(e) {
    var t,
      r = "",
      o = f(e);
    try {
      for (o.s(); !(t = o.n()).done;) {
        var n = t.value;
        r += (31 - Number.parseInt(n, 32)).toString(32);
      }
    } catch (e) {
      o.e(e);
    } finally {
      o.f();
    }
    return r;
  }
  function He(e, t) {
    if ((t = Number.parseInt(t, 32)) < 0) return Ge(Number.parseInt(e, 32) * Math.pow(32, t - 10));
    if (t < 11) {
      var r = e.slice(0, t);
      r = Number.parseInt(r, 32);
      var o = e.slice(t);
      return Ge(r + (o = Number.parseInt(o, 32) * Math.pow(32, t - 11)));
    }
    var n = e + Ve(t - 11);
    return Number.parseInt(n, 32);
  }
  function Ge(e, t) {
    return t = t || 16, Number.parseFloat(e.toPrecision(t));
  }
  function Ve(e) {
    return "0".repeat(e);
  }
  function ze(e) {
    return "-" + e;
  }
  function Ke(t) {
    if (Array.isArray(t)) return "array";
    if (K(r = t) && "function" == typeof r.getDate) return "date";
    var r;
    if (function (e) {
      return K(e) && "number" == typeof e.byteLength && ("function" == typeof e.slice || "function" == typeof e.getFloat64);
    }(t)) return "binary";
    var o = e(t);
    return ["string", "number"].includes(o) ? o : "invalid";
  }
  function $e(e, t) {
    return Qe(e, t, !1, !0);
  }
  function Ye(e) {
    var t = 0,
      r = 0;
    if (ArrayBuffer.isView(e)) {
      if (void 0 === e.buffer) throw new TypeError("Could not copy the bytes held by a buffer source as the buffer was undefined.");
      t = e.byteOffset, r = e.byteLength;
    } else r = e.byteLength;
    return new Uint8Array(e.buffer || e, t, r);
  }
  function Qe(t, r, o, n) {
    if ((r = r || []).includes(t)) return {
      type: "array",
      invalid: !0,
      message: "An array key cannot be circular"
    };
    var a = Ke(t),
      i = {
        type: a,
        value: t
      };
    switch (a) {
      case "number":
        return Number.isNaN(t) ? {
          type: "NaN",
          invalid: !0
        } : i;
      case "string":
        return i;
      case "binary":
        return {
          type: "binary",
          value: Ye(t)
        };
      case "array":
        var s = t.length;
        r.push(t);
        for (var u = [], l = 0; l < s; l++) {
          if (!o && !Object.prototype.hasOwnProperty.call(t, l)) return {
            type: a,
            invalid: !0,
            message: "Does not have own index property"
          };
          try {
            var c = function () {
              var e = Qe(t[l], r, !1, n);
              if (e.invalid) return o ? "continue" : {
                v: {
                  type: a,
                  invalid: !0,
                  message: "Bad array entry value-to-key conversion"
                }
              };
              (!o || !n && u.every(function (t) {
                return 0 !== je(t, e.value);
              }) || n && u.every(function (t) {
                return 0 !== je(t, e);
              })) && u.push(n ? e : e.value);
            }();
            if ("continue" === c) continue;
            if ("object" === e(c)) return c.v;
          } catch (e) {
            if (!o) throw e;
          }
        }
        return {
          type: a,
          value: u
        };
      case "date":
        return Number.isNaN(t.getTime()) ? {
          type: a,
          invalid: !0,
          message: "Not a valid date"
        } : n ? {
          type: a,
          value: t.getTime()
        } : {
          type: a,
          value: new Date(t.getTime())
        };
      case "invalid":
      default:
        var p = null === t ? "null" : e(t);
        return {
          type: p,
          invalid: !0,
          message: "Not a valid key; type " + p
        };
    }
  }
  function Xe(e, t) {
    return Qe(e, null, !0, t);
  }
  function Je(e, t) {
    var r = $e(e, t);
    if (r.invalid) throw ve("DataError", r.message || "Not a valid key; type: " + r.type);
    return r;
  }
  function Ze(e, t, r, o) {
    var n = et(e, t);
    return n.failure ? n : r ? Xe(n.value, o) : Qe(n.value, null, !1, o);
  }
  function et(e, t, r, o) {
    if (Array.isArray(t)) {
      var n = [];
      return t.some(function (t) {
        var r = et(e, t);
        return !!r.failure || (n.push(r.value), !1);
      }) ? {
        failure: !0
      } : {
        value: n
      };
    }
    return "" === t ? {
      value: e
    } : t.split(".").some(function (t, r) {
      if ("length" !== t || "string" != typeof e && !Array.isArray(e)) {
        if (K(o = e) && "number" == typeof o.size && "function" == typeof o.slice && !("lastModified" in o)) switch (t) {
          case "size":
          case "type":
            e = e[t];
        } else {
          if (!function (e) {
            return K(e) && "string" == typeof e.name && "function" == typeof e.slice && "lastModified" in e;
          }(e)) return !K(e) || !Object.prototype.hasOwnProperty.call(e, t) || void 0 === (e = e[t]);
          switch (t) {
            case "name":
            case "lastModified":
              e = e[t];
              break;
            case "lastModifiedDate":
              e = new Date(e.lastModified);
          }
        }
      } else e = e.length;
      var o;
      return !1;
    }) ? {
      failure: !0
    } : {
      value: e
    };
  }
  function tt(e, t, r) {
    var o = r.split("."),
      n = o.pop();
    o.forEach(function (t) {
      Object.prototype.hasOwnProperty.call(e, t) || (e[t] = {}), e = e[t];
    }), e[n] = t;
  }
  function rt(e, t) {
    var r = t.split(".");
    r.pop();
    var o,
      n = f(r);
    try {
      for (n.s(); !(o = n.n()).done;) {
        var a = o.value;
        if (!K(e)) return !1;
        if (!Object.prototype.hasOwnProperty.call(e, a)) return !0;
        e = e[a];
      }
    } catch (e) {
      n.e(e);
    } finally {
      n.f();
    }
    return K(e);
  }
  function ot(e, t, r) {
    var o = void 0 === t.lower,
      n = void 0 === t.upper,
      a = it(e, !0),
      i = r ? t.__lowerCached : it(t.lower, !0),
      s = r ? t.__upperCached : it(t.upper, !0);
    return void 0 !== t.lower && (t.lowerOpen && a > i && (o = !0), !t.lowerOpen && a >= i && (o = !0)), void 0 !== t.upper && (t.upperOpen && a < s && (n = !0), !t.upperOpen && a <= s && (n = !0)), o && n;
  }
  function nt(e, t) {
    return "array" === xe[t.slice(0, 1)] ? t.indexOf(e) > 1 : t === e;
  }
  function at(e, t) {
    var r = [];
    if (Array.isArray(e)) {
      var o,
        n = f(e);
      try {
        for (n.s(); !(o = n.n()).done;) {
          var a = o.value;
          if (Array.isArray(a)) {
            if (t && t.lower === t.upper) continue;
            if (1 !== a.length) {
              at(a, t).length > 0 && r.push(a);
              continue;
            }
            a = a[0];
          }
          (ie(t) || ot(a, t, !0)) && r.push(a);
        }
      } catch (e) {
        n.e(e);
      } finally {
        n.f();
      }
    } else (ie(t) || ot(e, t, !0)) && r.push(e);
    return r;
  }
  function it(e, t) {
    return void 0 === e ? null : Ue[Ke(e)].encode(e, t);
  }
  function st(e, t) {
    if ("string" == typeof e) return Ue[xe[e.slice(0, 1)]].decode(e, t);
  }
  function ut(e, t) {
    return st(it(e, t), t);
  }
  var lt = 9007199254740992;
  function ct(e, t, r, o) {
    e.executeSql('SELECT "currNum" FROM __sys__ WHERE "name" = ?', [x(t.__currentName)], function (e, t) {
      1 !== t.rows.length ? r(1) : r(t.rows.item(0).currNum);
    }, function (e, t) {
      o(ve("DataError", "Could not get the auto increment value for key", t));
    });
  }
  function pt(e, t, r, o, n) {
    var a = 'UPDATE __sys__ SET "currNum" = ? WHERE "name" = ?',
      i = [r, x(t.__currentName)];
    F.DEBUG && console.log(a, i), e.executeSql(a, i, function (e, t) {
      o(r);
    }, function (e, t) {
      n(ve("UnknownError", "Could not set the auto increment value for key", t));
    });
  }
  function gt(e, t, r, o, n) {
    return pt(e, t, r = r === lt ? r + 2 : r + 1, o, n);
  }
  function dt(e, t, r, o) {
    ct(e, t, function (n) {
      n > lt ? r("failure") : gt(e, t, n, function () {
        r(null, n, n);
      }, o);
    }, o);
  }
  function ft(e, t, r, o, n) {
    "number" != typeof r || r < 1 ? o() : ct(e, t, function (a) {
      var i = Math.floor(Math.min(r, lt));
      i >= a ? gt(e, t, i, function () {
        o(a);
      }, n) : o();
    }, n);
  }
  var ht = Object.freeze({
    __proto__: null,
    encode: it,
    decode: st,
    roundTrip: ut,
    convertKeyToValue: function e(t) {
      var r = t.type,
        o = t.value;
      switch (r) {
        case "number":
        case "string":
          return o;
        case "array":
          for (var n = [], a = o.length, i = 0; i < a;) {
            var s = e(o[i]);
            n[i] = s, i++;
          }
          return n;
        case "date":
          return new Date(o);
        case "binary":
          var u = o.length,
            l = new ArrayBuffer(u);
          return new Uint8Array(l, o.byteOffset || 0, o.byteLength).set(o), l;
        case "invalid":
        default:
          throw new Error("Bad key");
      }
    },
    convertValueToKeyValueDecoded: Qe,
    convertValueToMultiEntryKeyDecoded: Xe,
    convertValueToKey: $e,
    convertValueToMultiEntryKey: function convertValueToMultiEntryKey(e) {
      return Qe(e, null, !0, !0);
    },
    convertValueToKeyRethrowingAndIfInvalid: Je,
    extractKeyFromValueUsingKeyPath: function extractKeyFromValueUsingKeyPath(e, t, r) {
      return Ze(e, t, r, !0);
    },
    evaluateKeyPathOnValue: function evaluateKeyPathOnValue(e, t, r) {
      return et(e, t);
    },
    extractKeyValueDecodedFromValueUsingKeyPath: Ze,
    injectKeyIntoValueUsingKeyPath: tt,
    checkKeyCouldBeInjectedIntoValue: rt,
    isMultiEntryMatch: nt,
    isKeyInRange: ot,
    findMultiEntryMatches: at,
    assignCurrentNumber: pt,
    generateKeyForStore: dt,
    possiblyUpdateKeyGenerator: ft
  });
  function yt() {
    throw new TypeError("Illegal constructor");
  }
  var bt,
    mt = yt;
  function _t(e, t, r, o, n, a) {
    if (e && (void 0 !== e.lower || void 0 !== e.upper)) {
      var i, s;
      n && r.push("AND");
      var u = void 0 !== e.lower,
        l = void 0 !== e.upper;
      if (u && (i = a ? e.__lowerCached : it(e.lower)), l && (s = a ? e.__upperCached : it(e.upper)), u) {
        if (o.push(x(i)), l && i === s && !e.lowerOpen && !e.upperOpen) return void r.push(t, "=", "?");
        r.push(t, e.lowerOpen ? ">" : ">=", "?");
      }
      u && l && r.push("AND"), l && (r.push(t, e.upperOpen ? "<" : "<=", "?"), o.push(x(s)));
    }
  }
  function vt(e, t) {
    if (z(e, yt)) return "[object IDBKeyRange]" !== e.toString() ? yt.__createInstance(e.lower, e.upper, e.lowerOpen, e.upperOpen) : e;
    if (!ie(e)) return Je(e), yt.only(e);
    if (t) throw ve("DataError", "No key or range was specified");
  }
  yt.__createInstance = function (e, t, r, o) {
    function n() {
      if (this[Symbol.toStringTag] = "IDBKeyRange", void 0 === e && void 0 === t) throw ve("DataError", "Both arguments to the key range method cannot be undefined");
      var n, a;
      if (void 0 !== e && (n = ut(e), Je(e)), void 0 !== t && (a = ut(t), Je(t)), void 0 !== e && void 0 !== t && e !== t && it(e) > it(t)) throw ve("DataError", "`lower` must not be greater than `upper` argument in `bound()` call.");
      this.__lower = n, this.__upper = a, this.__lowerOpen = Boolean(r), this.__upperOpen = Boolean(o);
    }
    return n.prototype = mt.prototype, new n();
  }, yt.prototype.includes = function (e) {
    if (!K(this) || "boolean" != typeof this.__lowerOpen) throw new TypeError("Illegal invocation");
    if (!arguments.length) throw new TypeError("IDBKeyRange.includes requires a key argument");
    return Je(e), ot(e, this);
  }, yt.only = function (e) {
    if (!arguments.length) throw new TypeError("IDBKeyRange.only requires a value argument");
    return yt.__createInstance(e, e, !1, !1);
  }, yt.lowerBound = function (e) {
    if (!arguments.length) throw new TypeError("IDBKeyRange.lowerBound requires a value argument");
    return yt.__createInstance(e, void 0, arguments[1], !0);
  }, yt.upperBound = function (e) {
    if (!arguments.length) throw new TypeError("IDBKeyRange.upperBound requires a value argument");
    return yt.__createInstance(void 0, e, !0, arguments[1]);
  }, yt.bound = function (e, t) {
    if (arguments.length <= 1) throw new TypeError("IDBKeyRange.bound requires lower and upper arguments");
    return yt.__createInstance(e, t, arguments[2], arguments[3]);
  }, yt.prototype[Symbol.toStringTag] = "IDBKeyRangePrototype", ["lower", "upper", "lowerOpen", "upperOpen"].forEach(function (e) {
    var t, r;
    Object.defineProperty(yt.prototype, "__" + e, {
      enumerable: !1,
      configurable: !1,
      writable: !0
    });
    var n = (t = {}, (r = {})[e] = r[e] || {}, r[e].get = function () {
        if (!K(this) || "boolean" != typeof this.__lowerOpen) throw new TypeError("Illegal invocation");
        return this["__" + e];
      }, o(t, r), t),
      a = Object.getOwnPropertyDescriptor(n, e);
    Object.defineProperty(yt.prototype, e, a);
  }), Object.defineProperty(yt, Symbol.hasInstance, {
    value: function value(e) {
      return K(e) && "upper" in e && "boolean" == typeof e.lowerOpen;
    }
  }), Object.defineProperty(yt, "prototype", {
    writable: !1
  });
  var Et = !1,
    St = {
      test: !0
    };
  if (Object.defineProperty) try {
    Object.defineProperty(St, "test", {
      enumerable: !1
    }), St.test && (Et = !0);
  } catch (e) {}
  var Rt = function Rt() {
    throw new TypeError("Illegal constructor");
  };
  Rt.prototype = (n(bt = {
    constructor: Rt,
    contains: function contains(e) {
      if (!arguments.length) throw new TypeError("DOMStringList.contains must be supplied a value");
      return this._items.includes(e);
    },
    item: function item(e) {
      if (!arguments.length) throw new TypeError("DOMStringList.item must be supplied a value");
      return e < 0 || e >= this.length || !Number.isInteger(e) ? null : this._items[e];
    },
    clone: function clone() {
      var e = Rt.__createInstance();
      return e._items = this._items.slice(), e._length = this.length, e.addIndexes(), e;
    },
    addIndexes: function addIndexes() {
      for (var e = 0; e < this._items.length; e++) this[e] = this._items[e];
    },
    sortList: function sortList() {
      return this._items.sort(), this.addIndexes(), this._items;
    },
    forEach: function forEach(e, t) {
      this._items.forEach(e, t);
    },
    map: function map(e, t) {
      return this._items.map(e, t);
    },
    indexOf: function indexOf(e) {
      return this._items.indexOf(e);
    },
    push: function push(e) {
      this._items.push(e), this._length++, this.sortList();
    },
    splice: function splice() {
      var e;
      for (var t in (e = this._items).splice.apply(e, arguments), this._length = this._items.length, this) t === String(Number.parseInt(t)) && delete this[t];
      this.sortList();
    }
  }, Symbol.toStringTag, "DOMStringListPrototype"), n(bt, Symbol.iterator, _regeneratorRuntime().mark(function e() {
    var t;
    return _regeneratorRuntime().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          t = 0;
        case 1:
          if (!(t < this._items.length)) {
            e.next = 6;
            break;
          }
          return e.next = 4, this._items[t++];
        case 4:
          e.next = 1;
          break;
        case 6:
        case "end":
          return e.stop();
      }
    }, e, this);
  })), bt), Object.defineProperty(Rt, Symbol.hasInstance, {
    value: function value(e) {
      return "DOMStringListPrototype" === {}.toString.call(e);
    }
  });
  var wt = Rt;
  Object.defineProperty(Rt, "__createInstance", {
    value: function value() {
      var e = function e() {
        this.toString = function () {
          return "[object DOMStringList]";
        }, Object.defineProperty(this, "length", {
          enumerable: !0,
          get: function get() {
            return this._length;
          }
        }), this._items = [], this._length = 0;
      };
      return e.prototype = wt.prototype, new e();
    }
  }), Et && (Object.defineProperty(Rt, "prototype", {
    writable: !1
  }), ["addIndexes", "sortList", "forEach", "map", "indexOf", "push", "splice", "constructor", "__createInstance"].forEach(function (e) {
    Object.defineProperty(Rt.prototype, e, {
      enumerable: !1
    });
  }), Object.defineProperty(Rt.prototype, "length", {
    configurable: !0,
    enumerable: !0,
    get: function get() {
      throw new TypeError("Illegal invocation");
    }
  }), ["_items", "_length"].forEach(function (e) {
    Object.defineProperty(Rt.prototype, e, {
      enumerable: !1,
      writable: !0
    });
  }));
  var Tt = 0,
    Pt = ["onabort", "oncomplete", "onerror"],
    At = ["objectStoreNames", "mode", "db", "error"];
  function Dt() {
    throw new TypeError("Illegal constructor");
  }
  var Ot = Dt;
  Dt.__createInstance = function (e, t, r) {
    function o() {
      var o = this,
        n = this;
      n[Symbol.toStringTag] = "IDBTransaction", J(n, At), n.__id = ++Tt, n.__active = !0, n.__running = !1, n.__errored = !1, n.__requests = [], n.__objectStoreNames = t, n.__mode = r, n.__db = e, n.__error = null, n.__setOptions({
        legacyOutputDidListenersThrowFlag: !0
      }), At.forEach(function (e) {
        Object.defineProperty(o, e, {
          configurable: !0
        });
      }), X(this, Pt), n.__storeHandles = {}, setTimeout(function () {
        n.__executeRequests();
      }, 0);
    }
    return o.prototype = Ot.prototype, new o();
  }, Dt.prototype = C.createInstance({
    defaultSync: !0,
    extraProperties: ["complete"]
  }), Dt.prototype.__transFinishedCb = function (e, t) {
    t(Boolean(e));
  }, Dt.prototype.__executeRequests = function () {
    var e = this;
    e.__running ? F.DEBUG && console.log("Looks like the request set is already running", e.mode) : (e.__running = !0, e.db.__db["readonly" === e.mode ? "readTransaction" : "transaction"](function (t) {
      e.__tx = t;
      var r = null,
        o = -1;
      function n(t, o) {
        if (!e.__errored && !e.__requestsFinished && (o && (r.req = o), !r.req.__done)) {
          r.req.__done = !0, r.req.__result = t, r.req.__error = null, e.__active = !0;
          var n = ue("success");
          if (r.req.dispatchEvent(n), n.__legacyOutputDidListenersThrowError) return fe("Error", "An error occurred in a success handler attached to request chain", n.__legacyOutputDidListenersThrowError), void e.__abortTransaction(ve("AbortError", "A request was aborted (in user handler after success)."));
          i();
        }
      }
      function a() {
        if (!(e.__errored || e.__requestsFinished || r.req && r.req.__done)) {
          for (var t = arguments.length, o = new Array(t), n = 0; n < t; n++) o[n] = arguments[n];
          var a = ye(o);
          if (r.req) {
            r.req.__done = !0, r.req.__error = a, r.req.__result = void 0, r.req.addLateEventListener("error", function (e) {
              e.cancelable && e.defaultPrevented && !e.__legacyOutputDidListenersThrowError && i();
            }), r.req.addDefaultEventListener("error", function () {
              e.__abortTransaction(r.req.__error);
            }), e.__active = !0;
            var s = ue("error", a, {
              bubbles: !0,
              cancelable: !0
            });
            r.req.dispatchEvent(s), s.__legacyOutputDidListenersThrowError && (fe("Error", "An error occurred in an error handler attached to request chain", s.__legacyOutputDidListenersThrowError), s.preventDefault(), e.__abortTransaction(ve("AbortError", "A request was aborted (in user handler after error).")));
          } else e.__abortTransaction(a);
        }
      }
      function i() {
        if (!e.__errored && !e.__requestsFinished) if (++o >= e.__requests.length) e.__requests = [], e.__active && function () {
          function t() {
            e.__completed = !0, F.DEBUG && console.log("Transaction completed");
            var t = ue("complete");
            try {
              e.__internal = !0, e.dispatchEvent(t), e.__internal = !1, e.dispatchEvent(ue("__complete"));
            } catch (t) {
              throw e.__internal = !1, e.__errored = !0, t;
            } finally {
              e.__storeHandles = {};
            }
          }
          if (e.__active = !1, e.__requestsFinished = !0, "readwrite" === e.mode) return e.__transactionFinished ? void t() : void (e.__transactionEndCallback = t);
          if ("readonly" !== e.mode) {
            var r = ue("__beforecomplete");
            r.complete = t, e.dispatchEvent(r);
          } else t();
        }();else try {
          if (!(r = e.__requests[o]).req) return void r.op(t, r.args, i, a);
          if (r.req.__done) return;
          r.op(t, r.args, n, a, i);
        } catch (e) {
          a(e);
        }
      }
      i();
    }, function (t) {
      if (!0 !== t) {
        var r = be(t);
        e.__abortTransaction(r);
      }
    }, function () {
      e.__transFinishedCb === Dt.prototype.__transFinishedCb && (e.__transactionEndCallback || e.__requestsFinished ? e.__transactionEndCallback && !e.__completed && e.__transFinishedCb(e.__errored, e.__transactionEndCallback) : e.__transactionFinished = !0);
    }, function (t, r, o, n, a) {
      return !(!t.readOnly && !r && (e.__transFinishedCb = function (e, t) {
        e ? n(e, t) : a(t);
      }, e.__transactionEndCallback && !e.__completed && e.__transFinishedCb(e.__errored, e.__transactionEndCallback), 1));
    }));
  }, Dt.prototype.__createRequest = function (e) {
    var t = Te.__createInstance();
    return t.__source = void 0 !== e ? e : this.db, t.__transaction = this, t;
  }, Dt.prototype.__addToTransactionQueue = function (e, t, r) {
    var o = this.__createRequest(r);
    return this.__pushToQueue(o, e, t), o;
  }, Dt.prototype.__addNonRequestToTransactionQueue = function (e, t, r) {
    this.__pushToQueue(null, e, t);
  }, Dt.prototype.__pushToQueue = function (e, t, r) {
    this.__assertActive(), this.__requests.push({
      op: t,
      args: r,
      req: e
    });
  }, Dt.prototype.__assertActive = function () {
    if (!this.__active) throw ve("TransactionInactiveError", "A request was placed against a transaction which is currently not active, or which is finished");
  }, Dt.prototype.__assertWritable = function () {
    if ("readonly" === this.mode) throw ve("ReadOnlyError", "The transaction is read only");
  }, Dt.prototype.__assertVersionChange = function () {
    Dt.__assertVersionChange(this);
  }, Dt.prototype.objectStore = function (e) {
    var t = this;
    if (!(t instanceof Dt)) throw new TypeError("Illegal invocation");
    if (0 === arguments.length) throw new TypeError("No object store name was specified");
    if (Dt.__assertNotFinished(t), -1 === t.__objectStoreNames.indexOf(e)) throw ve("NotFoundError", e + " is not participating in this transaction");
    var r = t.db.__objectStores[e];
    if (!r) throw ve("NotFoundError", e + " does not exist in " + t.db.name);
    return (!t.__storeHandles[e] || t.__storeHandles[e].__pendingDelete || t.__storeHandles[e].__deleted) && (t.__storeHandles[e] = qr.__clone(r, t)), t.__storeHandles[e];
  }, Dt.prototype.__abortTransaction = function (e) {
    var t = this;
    function r(r, o) {
      r ? o && "number" == typeof o.code ? F.DEBUG && console.log("Rollback erred; feature is probably not supported as per WebSQL", t) : F.DEBUG && console.log("Rollback succeeded", t) : F.DEBUG && console.log("Rollback not possible due to missing transaction", t), t.dispatchEvent(ue("__preabort")), t.__requests.filter(function (e, t, r) {
        return e.req && !e.req.__done && [t, -1].includes(r.map(function (e) {
          return e.req;
        }).lastIndexOf(e.req));
      }).reduce(function (e, t) {
        return e.then(function () {
          t.req.__done = !0, t.req.__result = void 0, t.req.__error = ve("AbortError", "A request was aborted (an unfinished request).");
          var e = ue("error", t.req.__error, {
            bubbles: !0,
            cancelable: !0
          });
          return new Fe(function (r) {
            setTimeout(function () {
              t.req.dispatchEvent(e), r();
            });
          });
        });
      }, Fe.resolve()).then(function () {
        var r = ue("abort", e, {
          bubbles: !0,
          cancelable: !1
        });
        setTimeout(function () {
          t.__abortFinished = !0, t.dispatchEvent(r), t.__storeHandles = {}, t.dispatchEvent(ue("__abort"));
        });
      }).catch(function (e) {
        throw console.log("Abort error"), e;
      });
    }
    fe("Error", "An error occurred in a transaction", e), t.__errored || (t.__errored = !0, "versionchange" === t.mode && (t.db.__version = t.db.__oldVersion, t.db.__objectStoreNames = t.db.__oldObjectStoreNames, t.__objectStoreNames = t.db.__oldObjectStoreNames, Object.values(t.db.__objectStores).concat(Object.values(t.__storeHandles)).forEach(function (e) {
      "__pendingName" in e && t.db.__oldObjectStoreNames.indexOf(e.__pendingName) > -1 && (e.__name = e.__originalName), e.__indexNames = e.__oldIndexNames, delete e.__pendingDelete, Object.values(e.__indexes).concat(Object.values(e.__indexHandles)).forEach(function (t) {
        "__pendingName" in t && e.__oldIndexNames.indexOf(t.__pendingName) > -1 && (t.__name = t.__originalName), delete t.__pendingDelete;
      });
    })), t.__active = !1, null !== e && (t.__error = e), t.__requestsFinished && setTimeout(function () {
      throw e;
    }, 0), t.__transFinishedCb(!0, function (e) {
      if (e && t.__tx) {
        if ("readwrite" === t.mode) return t.__transactionFinished ? void r() : void (t.__transactionEndCallback = r);
        try {
          t.__tx.executeSql("ROLLBACK", [], r, r);
        } catch (e) {
          r();
        }
      } else r(null, {
        code: 0
      });
    }));
  }, Dt.prototype.abort = function () {
    var e = this;
    if (!(e instanceof Dt)) throw new TypeError("Illegal invocation");
    F.DEBUG && console.log("The transaction was aborted", e), Dt.__assertNotFinished(e), e.__abortTransaction(null);
  }, Dt.prototype[Symbol.toStringTag] = "IDBTransactionPrototype", Dt.__assertVersionChange = function (e) {
    if (!e || "versionchange" !== e.mode) throw ve("InvalidStateError", "Not a version transaction");
  }, Dt.__assertNotVersionChange = function (e) {
    if (e && "versionchange" === e.mode) throw ve("InvalidStateError", "Cannot be called during a version transaction");
  }, Dt.__assertNotFinished = function (e) {
    if (!e || e.__completed || e.__abortFinished || e.__errored) throw ve("InvalidStateError", "Transaction finished by commit or abort");
  }, Dt.__assertNotFinishedObjectStoreMethod = function (e) {
    try {
      Dt.__assertNotFinished(e);
    } catch (t) {
      if (e && !e.__completed && !e.__abortFinished) throw ve("TransactionInactiveError", "A request was placed against a transaction which is currently not active, or which is finished");
      throw t;
    }
  }, Dt.__assertActive = function (e) {
    if (!e || !e.__active) throw ve("TransactionInactiveError", "A request was placed against a transaction which is currently not active, or which is finished");
  }, Dt.prototype.__getParent = function () {
    return this.db;
  }, Y(Dt.prototype, Pt), Q(Dt.prototype, At), Object.defineProperty(Dt.prototype, "constructor", {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: Dt
  }), Object.defineProperty(Dt, "prototype", {
    writable: !1
  });
  for (var It, Ct, Bt = (function (t, r) {
      t.exports = function () {
        function t(r) {
          return (t = "function" == typeof Symbol && "symbol" === e(Symbol.iterator) ? function (t) {
            return e(t);
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : e(t);
          })(r);
        }
        function r(e, t, r, o, n, a, i) {
          try {
            var s = e[a](i),
              u = s.value;
          } catch (e) {
            return void r(e);
          }
          s.done ? t(u) : Promise.resolve(u).then(o, n);
        }
        function o(e) {
          return function () {
            var t = this,
              o = arguments;
            return new Promise(function (n, a) {
              var i = e.apply(t, o);
              function s(e) {
                r(i, n, a, s, u, "next", e);
              }
              function u(e) {
                r(i, n, a, s, u, "throw", e);
              }
              s(void 0);
            });
          };
        }
        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          for (var r = 0; r < t.length; r++) {
            var o = t[r];
            o.enumerable = o.enumerable || !1, o.configurable = !0, ("value" in o) && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }
        function i(e, t, r) {
          return t && a(e.prototype, t), r && a(e, r), e;
        }
        function s(e, t, r) {
          return (t in e) ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = r, e;
        }
        function u(e, t) {
          var r = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            t && (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, o);
          }
          return r;
        }
        function l(e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? u(Object(r), !0).forEach(function (t) {
              s(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }
          return e;
        }
        function c(e, t) {
          return d(e) || h(e, t) || b();
        }
        function p(e) {
          return g(e) || f(e) || y();
        }
        function g(e) {
          if (Array.isArray(e)) {
            for (var t = 0, r = new Array(e.length); t < e.length; t++) r[t] = e[t];
            return r;
          }
        }
        function d(e) {
          if (Array.isArray(e)) return e;
        }
        function f(e) {
          if ((Symbol.iterator in Object(e)) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }
        function h(e, t) {
          if ((Symbol.iterator in Object(e)) || "[object Arguments]" === Object.prototype.toString.call(e)) {
            var r = [],
              o = !0,
              n = !1,
              a = void 0;
            try {
              for (var i, s = e[Symbol.iterator](); !(o = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
            } catch (e) {
              n = !0, a = e;
            } finally {
              try {
                o || null == s.return || s.return();
              } finally {
                if (n) throw a;
              }
            }
            return r;
          }
        }
        function y() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }
        function b() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
        var m = function e(t) {
          n(this, e), this.p = new Promise(t);
        };
        m.__typeson__type__ = "TypesonPromise", "undefined" != typeof Symbol && (m.prototype[Symbol.toStringTag] = "TypesonPromise"), m.prototype.then = function (e, t) {
          var r = this;
          return new m(function (o, n) {
            r.p.then(function (t) {
              o(e ? e(t) : t);
            }).catch(function (e) {
              return t ? t(e) : Promise.reject(e);
            }).then(o, n);
          });
        }, m.prototype.catch = function (e) {
          return this.then(null, e);
        }, m.resolve = function (e) {
          return new m(function (t) {
            t(e);
          });
        }, m.reject = function (e) {
          return new m(function (t, r) {
            r(e);
          });
        }, ["all", "race"].forEach(function (e) {
          m[e] = function (t) {
            return new m(function (r, o) {
              Promise[e](t.map(function (e) {
                return e && e.constructor && "TypesonPromise" === e.constructor.__typeson__type__ ? e.p : e;
              })).then(r, o);
            });
          };
        });
        var _ = {}.toString,
          v = {}.hasOwnProperty,
          E = Object.getPrototypeOf,
          S = v.toString;
        function R(e, t) {
          return D(e) && "function" == typeof e.then && (!t || "function" == typeof e.catch);
        }
        function w(e) {
          return _.call(e).slice(8, -1);
        }
        function T(e, r) {
          if (!e || "object" !== t(e)) return !1;
          var o = E(e);
          if (!o) return null === r;
          var n = v.call(o, "constructor") && o.constructor;
          return "function" != typeof n ? null === r : r === n || null !== r && S.call(n) === S.call(r) || "function" == typeof r && "string" == typeof n.__typeson__type__ && n.__typeson__type__ === r.__typeson__type__;
        }
        function P(e) {
          return !(!e || "Object" !== w(e)) && (!E(e) || T(e, Object));
        }
        function A(e) {
          if (!e || "Object" !== w(e)) return !1;
          var t = E(e);
          return !t || T(e, Object) || A(t);
        }
        function D(e) {
          return e && "object" === t(e);
        }
        function O(e) {
          return e.replace(/~/g, "~0").replace(/\./g, "~1");
        }
        function I(e) {
          return e.replace(/~1/g, ".").replace(/~0/g, "~");
        }
        function C(e, t) {
          if ("" === t) return e;
          var r = t.indexOf(".");
          if (r > -1) {
            var o = e[I(t.slice(0, r))];
            return void 0 === o ? void 0 : C(o, t.slice(r + 1));
          }
          return e[I(t)];
        }
        function B(e, t, r) {
          if ("" === t) return r;
          var o = t.indexOf(".");
          return o > -1 ? B(e[I(t.slice(0, o))], t.slice(o + 1), r) : (e[I(t)] = r, e);
        }
        function F(e) {
          return null === e ? "null" : Array.isArray(e) ? "array" : t(e);
        }
        var j = Object.keys,
          N = Array.isArray,
          M = {}.hasOwnProperty,
          x = ["type", "replaced", "iterateIn", "iterateUnsetNumeric"];
        function L(e, t) {
          if ("" === e.keypath) return -1;
          var r = e.keypath.match(/\./g) || 0,
            o = t.keypath.match(/\./g) || 0;
          return r && (r = r.length), o && (o = o.length), r > o ? -1 : r < o ? 1 : e.keypath < t.keypath ? -1 : e.keypath > t.keypath;
        }
        var U = function () {
            function e(t) {
              n(this, e), this.options = t, this.plainObjectReplacers = [], this.nonplainObjectReplacers = [], this.revivers = {}, this.types = {};
            }
            return i(e, [{
              key: "stringify",
              value: function value(e, t, r, o) {
                o = l({}, this.options, {}, o, {
                  stringification: !0
                });
                var n = this.encapsulate(e, null, o);
                return N(n) ? JSON.stringify(n[0], t, r) : n.then(function (e) {
                  return JSON.stringify(e, t, r);
                });
              }
            }, {
              key: "stringifySync",
              value: function value(e, t, r, o) {
                return this.stringify(e, t, r, l({
                  throwOnBadSyncType: !0
                }, o, {
                  sync: !0
                }));
              }
            }, {
              key: "stringifyAsync",
              value: function value(e, t, r, o) {
                return this.stringify(e, t, r, l({
                  throwOnBadSyncType: !0
                }, o, {
                  sync: !1
                }));
              }
            }, {
              key: "parse",
              value: function value(e, t, r) {
                return r = l({}, this.options, {}, r, {
                  parse: !0
                }), this.revive(JSON.parse(e, t), r);
              }
            }, {
              key: "parseSync",
              value: function value(e, t, r) {
                return this.parse(e, t, l({
                  throwOnBadSyncType: !0
                }, r, {
                  sync: !0
                }));
              }
            }, {
              key: "parseAsync",
              value: function value(e, t, r) {
                return this.parse(e, t, l({
                  throwOnBadSyncType: !0
                }, r, {
                  sync: !1
                }));
              }
            }, {
              key: "specialTypeNames",
              value: function value(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                return r.returnTypeNames = !0, this.encapsulate(e, t, r);
              }
            }, {
              key: "rootTypeName",
              value: function value(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                return r.iterateNone = !0, this.encapsulate(e, t, r);
              }
            }, {
              key: "encapsulate",
              value: function value(r, n, a) {
                var i = (a = l({
                    sync: !0
                  }, this.options, {}, a)).sync,
                  s = this,
                  u = {},
                  g = [],
                  d = [],
                  f = [],
                  h = !("cyclic" in a) || a.cyclic,
                  y = a.encapsulateObserver,
                  b = R("", r, h, n || {}, f);
                function _(t) {
                  var r = Object.values(u);
                  if (a.iterateNone) return r.length ? r[0] : e.getJSONType(t);
                  if (r.length) {
                    if (a.returnTypeNames) return p(new Set(r));
                    t && P(t) && !M.call(t, "$types") ? t.$types = u : t = {
                      $: t,
                      $types: {
                        $: u
                      }
                    };
                  } else D(t) && M.call(t, "$types") && (t = {
                    $: t,
                    $types: !0
                  });
                  return !a.returnTypeNames && t;
                }
                function v(e, t) {
                  return E.apply(this, arguments);
                }
                function E() {
                  return (E = o(_regeneratorRuntime().mark(function e(t, r) {
                    var n;
                    return _regeneratorRuntime().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          return e.next = 2, Promise.all(r.map(function (e) {
                            return e[1].p;
                          }));
                        case 2:
                          return n = e.sent, e.next = 5, Promise.all(n.map(function () {
                            var e = o(_regeneratorRuntime().mark(function e(o) {
                              var n, a, i, s, u, l, p, g, d, f, h, y, b, _;
                              return _regeneratorRuntime().wrap(function (e) {
                                for (;;) switch (e.prev = e.next) {
                                  case 0:
                                    if (n = [], a = r.splice(0, 1), i = c(a, 1), s = i[0], u = c(s, 7), l = u[0], p = u[2], g = u[3], d = u[4], f = u[5], h = u[6], y = R(l, o, p, g, n, !0, h), b = T(y, m), !l || !b) {
                                      e.next = 11;
                                      break;
                                    }
                                    return e.next = 8, y.p;
                                  case 8:
                                    return _ = e.sent, d[f] = _, e.abrupt("return", v(t, n));
                                  case 11:
                                    return l ? d[f] = y : t = b ? y.p : y, e.abrupt("return", v(t, n));
                                  case 13:
                                  case "end":
                                    return e.stop();
                                }
                              }, e);
                            }));
                            return function (t) {
                              return e.apply(this, arguments);
                            };
                          }()));
                        case 5:
                          return e.abrupt("return", t);
                        case 6:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }))).apply(this, arguments);
                }
                function S(e, t, r) {
                  Object.assign(e, t);
                  var o = x.map(function (t) {
                    var r = e[t];
                    return delete e[t], r;
                  });
                  r(), x.forEach(function (t, r) {
                    e[t] = o[r];
                  });
                }
                function R(r, o, n, i, l, c, p) {
                  var f,
                    h = {},
                    b = t(o),
                    _ = y ? function (t) {
                      var a = p || i.type || e.getJSONType(o);
                      y(Object.assign(t || h, {
                        keypath: r,
                        value: o,
                        cyclic: n,
                        stateObj: i,
                        promisesData: l,
                        resolvingTypesonPromise: c,
                        awaitingTypesonPromise: T(o, m)
                      }, {
                        type: a
                      }));
                    } : null;
                  if (["string", "boolean", "number", "undefined"].includes(b)) return void 0 === o || "number" === b && (isNaN(o) || o === -1 / 0 || o === 1 / 0) ? (f = i.replaced ? o : w(r, o, i, l, !1, c, _)) !== o && (h = {
                    replaced: f
                  }) : f = o, _ && _(), f;
                  if (null === o) return _ && _(), o;
                  if (n && !i.iterateIn && !i.iterateUnsetNumeric && o && "object" === t(o)) {
                    var v = g.indexOf(o);
                    if (!(v < 0)) return u[r] = "#", _ && _({
                      cyclicKeypath: d[v]
                    }), "#" + d[v];
                    !0 === n && (g.push(o), d.push(r));
                  }
                  var E,
                    A = P(o),
                    D = N(o),
                    I = (A || D) && (!s.plainObjectReplacers.length || i.replaced) || i.iterateIn ? o : w(r, o, i, l, A || D, null, _);
                  if (I !== o ? (f = I, h = {
                    replaced: I
                  }) : "" === r && T(o, m) ? (l.push([r, o, n, i, void 0, void 0, i.type]), f = o) : D && "object" !== i.iterateIn || "array" === i.iterateIn ? (E = new Array(o.length), h = {
                    clone: E
                  }) : (["function", "symbol"].includes(t(o)) || ("toJSON" in o) || T(o, m) || T(o, Promise) || T(o, ArrayBuffer)) && !A && "object" !== i.iterateIn ? f = o : (E = {}, i.addLength && (E.length = o.length), h = {
                    clone: E
                  }), _ && _(), a.iterateNone) return E || f;
                  if (!E) return f;
                  if (i.iterateIn) {
                    var C = function C(e) {
                      var t = {
                        ownKeys: M.call(o, e)
                      };
                      S(i, t, function () {
                        var t = r + (r ? "." : "") + O(e),
                          a = R(t, o[e], Boolean(n), i, l, c);
                        T(a, m) ? l.push([t, a, Boolean(n), i, E, e, i.type]) : void 0 !== a && (E[e] = a);
                      });
                    };
                    for (var B in o) C(B);
                    _ && _({
                      endIterateIn: !0,
                      end: !0
                    });
                  } else j(o).forEach(function (e) {
                    var t = r + (r ? "." : "") + O(e);
                    S(i, {
                      ownKeys: !0
                    }, function () {
                      var r = R(t, o[e], Boolean(n), i, l, c);
                      T(r, m) ? l.push([t, r, Boolean(n), i, E, e, i.type]) : void 0 !== r && (E[e] = r);
                    });
                  }), _ && _({
                    endIterateOwn: !0,
                    end: !0
                  });
                  if (i.iterateUnsetNumeric) {
                    for (var F = o.length, x = function x(e) {
                        if (!(e in o)) {
                          var t = r + (r ? "." : "") + e;
                          S(i, {
                            ownKeys: !1
                          }, function () {
                            var r = R(t, void 0, Boolean(n), i, l, c);
                            T(r, m) ? l.push([t, r, Boolean(n), i, E, e, i.type]) : void 0 !== r && (E[e] = r);
                          });
                        }
                      }, L = 0; L < F; L++) x(L);
                    _ && _({
                      endIterateUnsetNumeric: !0,
                      end: !0
                    });
                  }
                  return E;
                }
                function w(e, t, r, o, n, a, l) {
                  for (var c = n ? s.plainObjectReplacers : s.nonplainObjectReplacers, p = c.length; p--;) {
                    var g = c[p];
                    if (g.test(t, r)) {
                      var d = g.type;
                      if (s.revivers[d]) {
                        var f = u[e];
                        u[e] = f ? [d].concat(f) : d;
                      }
                      return Object.assign(r, {
                        type: d,
                        replaced: !0
                      }), !i && g.replaceAsync || g.replace ? (l && l({
                        replacing: !0
                      }), R(e, g[i || !g.replaceAsync ? "replace" : "replaceAsync"](t, r), h && "readonly", r, o, a, d)) : (l && l({
                        typeDetected: !0
                      }), R(e, t, h && "readonly", r, o, a, d));
                    }
                  }
                  return t;
                }
                return f.length ? i && a.throwOnBadSyncType ? function () {
                  throw new TypeError("Sync method requested but async result obtained");
                }() : Promise.resolve(v(b, f)).then(_) : !i && a.throwOnBadSyncType ? function () {
                  throw new TypeError("Async method requested but sync result obtained");
                }() : a.stringification && i ? [_(b)] : i ? _(b) : Promise.resolve(_(b));
              }
            }, {
              key: "encapsulateSync",
              value: function value(e, t, r) {
                return this.encapsulate(e, t, l({
                  throwOnBadSyncType: !0
                }, r, {
                  sync: !0
                }));
              }
            }, {
              key: "encapsulateAsync",
              value: function value(e, t, r) {
                return this.encapsulate(e, t, l({
                  throwOnBadSyncType: !0
                }, r, {
                  sync: !1
                }));
              }
            }, {
              key: "revive",
              value: function value(e, t) {
                var r = e && e.$types;
                if (!r) return e;
                if (!0 === r) return e.$;
                var o = (t = l({
                    sync: !0
                  }, this.options, {}, t)).sync,
                  n = [],
                  a = {},
                  i = !0;
                r.$ && P(r.$) && (e = e.$, r = r.$, i = !1);
                var s = this;
                function u(e, t) {
                  var r = c(s.revivers[e] || [], 1)[0];
                  if (!r) throw new Error("Unregistered type: " + e);
                  return o && !("revive" in r) ? t : r[o && r.revive ? "revive" : !o && r.reviveAsync ? "reviveAsync" : "revive"](t, a);
                }
                function p() {
                  var t = [];
                  if (Object.entries(r).forEach(function (e) {
                    var o = c(e, 2),
                      n = o[0],
                      a = o[1];
                    "#" !== a && [].concat(a).forEach(function (e) {
                      c(s.revivers[e] || [null, {}], 2)[1].plain && (t.push({
                        keypath: n,
                        type: e
                      }), delete r[n]);
                    });
                  }), t.length) return t.sort(L).reduce(function t(r, o) {
                    var n = o.keypath,
                      a = o.type;
                    if (R(r)) return r.then(function (e) {
                      return t(e, {
                        keypath: n,
                        type: a
                      });
                    });
                    var i = C(e, n);
                    if (T(i = u(a, i), m)) return i.then(function (t) {
                      var r = B(e, n, t);
                      r === t && (e = r);
                    });
                    var s = B(e, n, i);
                    s === i && (e = s);
                  }, void 0);
                }
                var g = [];
                function d(e, t, o, a, s) {
                  if (!i || "$types" !== e) {
                    var l = r[e],
                      p = N(t);
                    if (p || P(t)) {
                      var f = p ? new Array(t.length) : {};
                      for (j(t).forEach(function (r) {
                        var n = d(e + (e ? "." : "") + O(r), t[r], o || f, f, r),
                          a = function a(e) {
                            return T(e, k) ? f[r] = void 0 : void 0 !== e && (f[r] = e), e;
                          };
                        T(n, m) ? g.push(n.then(function (e) {
                          return a(e);
                        })) : a(n);
                      }), t = f; n.length;) {
                        var h = c(n[0], 4),
                          y = h[0],
                          b = h[1],
                          _ = h[2],
                          v = h[3],
                          E = C(y, b);
                        if (void 0 === E) break;
                        _[v] = E, n.splice(0, 1);
                      }
                    }
                    if (!l) return t;
                    if ("#" === l) {
                      var S = C(o, t.slice(1));
                      return void 0 === S && n.push([o, t.slice(1), a, s]), S;
                    }
                    return [].concat(l).reduce(function e(t, r) {
                      return T(t, m) ? t.then(function (t) {
                        return e(t, r);
                      }) : u(r, t);
                    }, t);
                  }
                }
                function f(e) {
                  return T(e, k) ? void 0 : e;
                }
                var h,
                  y = p();
                return T(y, m) ? h = y.then(function () {
                  return e;
                }) : (h = d("", e, null), g.length && (h = m.resolve(h).then(function (e) {
                  return m.all([e].concat(g));
                }).then(function (e) {
                  return c(e, 1)[0];
                }))), R(h) ? o && t.throwOnBadSyncType ? function () {
                  throw new TypeError("Sync method requested but async result obtained");
                }() : T(h, m) ? h.p.then(f) : h : !o && t.throwOnBadSyncType ? function () {
                  throw new TypeError("Async method requested but sync result obtained");
                }() : o ? f(h) : Promise.resolve(f(h));
              }
            }, {
              key: "reviveSync",
              value: function value(e, t) {
                return this.revive(e, l({
                  throwOnBadSyncType: !0
                }, t, {
                  sync: !0
                }));
              }
            }, {
              key: "reviveAsync",
              value: function value(e, t) {
                return this.revive(e, l({
                  throwOnBadSyncType: !0
                }, t, {
                  sync: !1
                }));
              }
            }, {
              key: "register",
              value: function value(t, r) {
                return r = r || {}, [].concat(t).forEach(function t(o) {
                  var n = this;
                  if (N(o)) return o.map(function (e) {
                    return t.call(n, e);
                  });
                  o && j(o).forEach(function (t) {
                    if ("#" === t) throw new TypeError("# cannot be used as a type name as it is reserved for cyclic objects");
                    if (e.JSON_TYPES.includes(t)) throw new TypeError("Plain JSON object types are reserved as type names");
                    var n = o[t],
                      a = n && n.testPlainObjects ? this.plainObjectReplacers : this.nonplainObjectReplacers,
                      i = a.filter(function (e) {
                        return e.type === t;
                      });
                    if (i.length && (a.splice(a.indexOf(i[0]), 1), delete this.revivers[t], delete this.types[t]), "function" == typeof n) {
                      var s = n;
                      n = {
                        test: function test(e) {
                          return e && e.constructor === s;
                        },
                        replace: function replace(e) {
                          return l({}, e);
                        },
                        revive: function revive(e) {
                          return Object.assign(Object.create(s.prototype), e);
                        }
                      };
                    } else if (N(n)) {
                      var u = c(n, 3);
                      n = {
                        test: u[0],
                        replace: u[1],
                        revive: u[2]
                      };
                    }
                    if (n && n.test) {
                      var p = {
                        type: t,
                        test: n.test.bind(n)
                      };
                      n.replace && (p.replace = n.replace.bind(n)), n.replaceAsync && (p.replaceAsync = n.replaceAsync.bind(n));
                      var g = "number" == typeof r.fallback ? r.fallback : r.fallback ? 0 : 1 / 0;
                      if (n.testPlainObjects ? this.plainObjectReplacers.splice(g, 0, p) : this.nonplainObjectReplacers.splice(g, 0, p), n.revive || n.reviveAsync) {
                        var d = {};
                        n.revive && (d.revive = n.revive.bind(n)), n.reviveAsync && (d.reviveAsync = n.reviveAsync.bind(n)), this.revivers[t] = [d, {
                          plain: n.testPlainObjects
                        }];
                      }
                      this.types[t] = n;
                    }
                  }, this);
                }, this), this;
              }
            }]), e;
          }(),
          k = function e() {
            n(this, e);
          };
        return k.__typeson__type__ = "TypesonUndefined", U.Undefined = k, U.Promise = m, U.isThenable = R, U.toStringTag = w, U.hasConstructorOf = T, U.isObject = D, U.isPlainObject = P, U.isUserObject = A, U.escapeKeyPathComponent = O, U.unescapeKeyPathComponent = I, U.getByKeyPath = C, U.getJSONType = F, U.JSON_TYPES = ["null", "boolean", "number", "string", "array", "object"], U;
      }();
    }(Ct = {
      path: It,
      exports: {},
      require: function require(e, t) {
        return function () {
          throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == t && Ct.path);
      }
    }, Ct.exports), Ct.exports), Ft = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", jt = new Uint8Array(256), Nt = 0; Nt < Ft.length; Nt++) jt[Ft.charCodeAt(Nt)] = Nt;
  var Mt = function Mt(e, t, r) {
      null == r && (r = e.byteLength);
      for (var o = new Uint8Array(e, t || 0, r), n = o.length, a = "", i = 0; i < n; i += 3) a += Ft[o[i] >> 2], a += Ft[(3 & o[i]) << 4 | o[i + 1] >> 4], a += Ft[(15 & o[i + 1]) << 2 | o[i + 2] >> 6], a += Ft[63 & o[i + 2]];
      return n % 3 == 2 ? a = a.slice(0, -1) + "=" : n % 3 == 1 && (a = a.slice(0, -2) + "=="), a;
    },
    xt = function xt(e) {
      var t,
        r,
        o,
        n,
        a = e.length,
        i = .75 * e.length,
        s = 0;
      "=" === e[e.length - 1] && (i--, "=" === e[e.length - 2] && i--);
      for (var u = new ArrayBuffer(i), l = new Uint8Array(u), c = 0; c < a; c += 4) t = jt[e.charCodeAt(c)], r = jt[e.charCodeAt(c + 1)], o = jt[e.charCodeAt(c + 2)], n = jt[e.charCodeAt(c + 3)], l[s++] = t << 2 | r >> 4, l[s++] = (15 & r) << 4 | o >> 2, l[s++] = (3 & o) << 6 | 63 & n;
      return u;
    },
    Lt = {
      arraybuffer: {
        test: function test(e) {
          return "ArrayBuffer" === Bt.toStringTag(e);
        },
        replace: function replace(e, t) {
          t.buffers || (t.buffers = []);
          var r = t.buffers.indexOf(e);
          return r > -1 ? {
            index: r
          } : (t.buffers.push(e), Mt(e));
        },
        revive: function revive(t, r) {
          if (r.buffers || (r.buffers = []), "object" === e(t)) return r.buffers[t.index];
          var o = xt(t);
          return r.buffers.push(o), o;
        }
      }
    },
    Ut = {
      bigintObject: {
        test: function test(t) {
          return "object" === e(t) && Bt.hasConstructorOf(t, BigInt);
        },
        replace: function replace(e) {
          return String(e);
        },
        revive: function revive(e) {
          return new Object(BigInt(e));
        }
      }
    },
    kt = {
      bigint: {
        test: function test(e) {
          return "bigint" == typeof e;
        },
        replace: function replace(e) {
          return String(e);
        },
        revive: function revive(e) {
          return BigInt(e);
        }
      }
    };
  function qt(e) {
    for (var t = new Uint8Array(e.length), r = 0; r < e.length; r++) t[r] = e.charCodeAt(r);
    return t.buffer;
  }
  var Wt = {
    blob: {
      test: function test(e) {
        return "Blob" === Bt.toStringTag(e);
      },
      replace: function replace(e) {
        var t = new XMLHttpRequest();
        if (t.overrideMimeType("text/plain; charset=x-user-defined"), t.open("GET", URL.createObjectURL(e), !1), t.send(), 200 !== t.status && 0 !== t.status) throw new Error("Bad Blob access: " + t.status);
        return {
          type: e.type,
          stringContents: t.responseText
        };
      },
      revive: function revive(e) {
        var t = e.type,
          r = e.stringContents;
        return new Blob([qt(r)], {
          type: t
        });
      },
      replaceAsync: function replaceAsync(e) {
        return new Bt.Promise(function (t, r) {
          var o = new FileReader();
          o.addEventListener("load", function () {
            t({
              type: e.type,
              stringContents: o.result
            });
          }), o.addEventListener("error", function () {
            r(o.error);
          }), o.readAsBinaryString(e);
        });
      }
    }
  };
  function Ht() {
    var e = new Date().getTime() + ("undefined" != typeof performance && "function" == typeof performance.now ? performance.now() : 0);
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
      var r = (e + 16 * Math.random()) % 16 | 0;
      return e = Math.floor(e / 16), ("x" === t ? r : 3 & r | 8).toString(16);
    });
  }
  var Gt = {},
    Vt = {
      cloneable: {
        test: function test(t) {
          return t && "object" === e(t) && "function" == typeof t[Symbol.for("cloneEncapsulate")];
        },
        replace: function replace(e) {
          var t = e[Symbol.for("cloneEncapsulate")](),
            r = Ht();
          return Gt[r] = e, {
            uuid: r,
            encapsulated: t
          };
        },
        revive: function revive(e) {
          var t = e.uuid,
            r = e.encapsulated;
          return Gt[t][Symbol.for("cloneRevive")](r);
        }
      }
    },
    zt = {
      cryptokey: {
        test: function test(e) {
          return "CryptoKey" === Bt.toStringTag(e) && e.extractable;
        },
        replaceAsync: function replaceAsync(e) {
          return new Bt.Promise(function (t, r) {
            crypto.subtle.exportKey("jwk", e).catch(function (e) {
              r(e);
            }).then(function (r) {
              t({
                jwk: r,
                algorithm: e.algorithm,
                usages: e.usages
              });
            });
          });
        },
        revive: function revive(e) {
          var t = e.jwk,
            r = e.algorithm,
            o = e.usages;
          return crypto.subtle.importKey("jwk", t, r, !0, o);
        }
      }
    },
    Kt = {
      dataview: {
        test: function test(e) {
          return "DataView" === Bt.toStringTag(e);
        },
        replace: function replace(e, t) {
          var r = e.buffer,
            o = e.byteOffset,
            n = e.byteLength;
          t.buffers || (t.buffers = []);
          var a = t.buffers.indexOf(r);
          return a > -1 ? {
            index: a,
            byteOffset: o,
            byteLength: n
          } : (t.buffers.push(r), {
            encoded: Mt(r),
            byteOffset: o,
            byteLength: n
          });
        },
        revive: function revive(e, t) {
          t.buffers || (t.buffers = []);
          var r,
            o = e.byteOffset,
            n = e.byteLength,
            a = e.encoded,
            i = e.index;
          return "index" in e ? r = t.buffers[i] : (r = xt(a), t.buffers.push(r)), new DataView(r, o, n);
        }
      }
    },
    $t = {
      date: {
        test: function test(e) {
          return "Date" === Bt.toStringTag(e);
        },
        replace: function replace(e) {
          var t = e.getTime();
          return Number.isNaN(t) ? "NaN" : t;
        },
        revive: function revive(e) {
          return "NaN" === e ? new Date(Number.NaN) : new Date(e);
        }
      }
    },
    Yt = {
      error: {
        test: function test(e) {
          return "Error" === Bt.toStringTag(e);
        },
        replace: function replace(e) {
          return {
            name: e.name,
            message: e.message
          };
        },
        revive: function revive(e) {
          var t = e.name,
            r = e.message,
            o = new Error(r);
          return o.name = t, o;
        }
      }
    },
    Qt = "undefined" == typeof self ? y : self,
    Xt = {};
  ["TypeError", "RangeError", "SyntaxError", "ReferenceError", "EvalError", "URIError", "InternalError"].forEach(function (e) {
    var t = Qt[e];
    t && (Xt[e.toLowerCase()] = {
      test: function test(e) {
        return Bt.hasConstructorOf(e, t);
      },
      replace: function replace(e) {
        return e.message;
      },
      revive: function revive(e) {
        return new t(e);
      }
    });
  });
  var Jt = {
      file: {
        test: function test(e) {
          return "File" === Bt.toStringTag(e);
        },
        replace: function replace(e) {
          var t = new XMLHttpRequest();
          if (t.overrideMimeType("text/plain; charset=x-user-defined"), t.open("GET", URL.createObjectURL(e), !1), t.send(), 200 !== t.status && 0 !== t.status) throw new Error("Bad File access: " + t.status);
          return {
            type: e.type,
            stringContents: t.responseText,
            name: e.name,
            lastModified: e.lastModified
          };
        },
        revive: function revive(e) {
          var t = e.name,
            r = e.type,
            o = e.stringContents,
            n = e.lastModified;
          return new File([qt(o)], t, {
            type: r,
            lastModified: n
          });
        },
        replaceAsync: function replaceAsync(e) {
          return new Bt.Promise(function (t, r) {
            var o = new FileReader();
            o.addEventListener("load", function () {
              t({
                type: e.type,
                stringContents: o.result,
                name: e.name,
                lastModified: e.lastModified
              });
            }), o.addEventListener("error", function () {
              r(o.error);
            }), o.readAsBinaryString(e);
          });
        }
      }
    },
    Zt = {
      file: Jt.file,
      filelist: {
        test: function test(e) {
          return "FileList" === Bt.toStringTag(e);
        },
        replace: function replace(e) {
          for (var t = [], r = 0; r < e.length; r++) t[r] = e.item(r);
          return t;
        },
        revive: function revive(e) {
          return new (function () {
            function e() {
              t(this, e), this._files = arguments[0], this.length = this._files.length;
            }
            var o, n;
            return o = e, (n = [{
              key: "item",
              value: function value(e) {
                return this._files[e];
              }
            }, {
              key: Symbol.toStringTag,
              get: function get() {
                return "FileList";
              }
            }]) && r(o.prototype, n), e;
          }())(e);
        }
      }
    },
    er = {
      imagebitmap: {
        test: function test(e) {
          return "ImageBitmap" === Bt.toStringTag(e) || e && e.dataset && "ImageBitmap" === e.dataset.toStringTag;
        },
        replace: function replace(e) {
          var t = document.createElement("canvas");
          return t.getContext("2d").drawImage(e, 0, 0), t.toDataURL();
        },
        revive: function revive(e) {
          var t = document.createElement("canvas"),
            r = t.getContext("2d"),
            o = document.createElement("img");
          return o.addEventListener("load", function () {
            r.drawImage(o, 0, 0);
          }), o.src = e, t;
        },
        reviveAsync: function reviveAsync(e) {
          var t = document.createElement("canvas"),
            r = t.getContext("2d"),
            o = document.createElement("img");
          return o.addEventListener("load", function () {
            r.drawImage(o, 0, 0);
          }), o.src = e, createImageBitmap(t);
        }
      }
    },
    tr = {
      imagedata: {
        test: function test(e) {
          return "ImageData" === Bt.toStringTag(e);
        },
        replace: function replace(e) {
          return {
            array: p(e.data),
            width: e.width,
            height: e.height
          };
        },
        revive: function revive(e) {
          return new ImageData(new Uint8ClampedArray(e.array), e.width, e.height);
        }
      }
    },
    rr = {
      infinity: {
        test: function test(e) {
          return e === 1 / 0;
        },
        replace: function replace(e) {
          return "Infinity";
        },
        revive: function revive(e) {
          return 1 / 0;
        }
      }
    },
    or = {
      IntlCollator: {
        test: function test(e) {
          return Bt.hasConstructorOf(e, Intl.Collator);
        },
        replace: function replace(e) {
          return e.resolvedOptions();
        },
        revive: function revive(e) {
          return new Intl.Collator(e.locale, e);
        }
      },
      IntlDateTimeFormat: {
        test: function test(e) {
          return Bt.hasConstructorOf(e, Intl.DateTimeFormat);
        },
        replace: function replace(e) {
          return e.resolvedOptions();
        },
        revive: function revive(e) {
          return new Intl.DateTimeFormat(e.locale, e);
        }
      },
      IntlNumberFormat: {
        test: function test(e) {
          return Bt.hasConstructorOf(e, Intl.NumberFormat);
        },
        replace: function replace(e) {
          return e.resolvedOptions();
        },
        revive: function revive(e) {
          return new Intl.NumberFormat(e.locale, e);
        }
      }
    },
    nr = {
      map: {
        test: function test(e) {
          return "Map" === Bt.toStringTag(e);
        },
        replace: function replace(e) {
          return p(e.entries());
        },
        revive: function revive(e) {
          return new Map(e);
        }
      }
    },
    ar = {
      nan: {
        test: function test(e) {
          return Number.isNaN(e);
        },
        replace: function replace(e) {
          return "NaN";
        },
        revive: function revive(e) {
          return Number.NaN;
        }
      }
    },
    ir = {
      negativeInfinity: {
        test: function test(e) {
          return e === -1 / 0;
        },
        replace: function replace(e) {
          return "-Infinity";
        },
        revive: function revive(e) {
          return -1 / 0;
        }
      }
    },
    sr = {
      nonbuiltinIgnore: {
        test: function test(t) {
          return t && "object" === e(t) && !Array.isArray(t) && !["Object", "Boolean", "Number", "String", "Error", "RegExp", "Math", "Date", "Map", "Set", "JSON", "ArrayBuffer", "SharedArrayBuffer", "DataView", "Int8Array", "Uint8Array", "Uint8ClampedArray", "Int16Array", "Uint16Array", "Int32Array", "Uint32Array", "Float32Array", "Float64Array", "Promise", "String Iterator", "Array Iterator", "Map Iterator", "Set Iterator", "WeakMap", "WeakSet", "Atomics", "Module"].includes(Bt.toStringTag(t));
        },
        replace: function replace(e) {}
      }
    },
    ur = {
      StringObject: {
        test: function test(t) {
          return "String" === Bt.toStringTag(t) && "object" === e(t);
        },
        replace: function replace(e) {
          return String(e);
        },
        revive: function revive(e) {
          return new String(e);
        }
      },
      BooleanObject: {
        test: function test(t) {
          return "Boolean" === Bt.toStringTag(t) && "object" === e(t);
        },
        replace: function replace(e) {
          return Boolean(e);
        },
        revive: function revive(e) {
          return new Boolean(e);
        }
      },
      NumberObject: {
        test: function test(t) {
          return "Number" === Bt.toStringTag(t) && "object" === e(t);
        },
        replace: function replace(e) {
          return Number(e);
        },
        revive: function revive(e) {
          return new Number(e);
        }
      }
    },
    lr = {
      regexp: {
        test: function test(e) {
          return "RegExp" === Bt.toStringTag(e);
        },
        replace: function replace(e) {
          return {
            source: e.source,
            flags: (e.global ? "g" : "") + (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.sticky ? "y" : "") + (e.unicode ? "u" : "")
          };
        },
        revive: function revive(e) {
          var t = e.source,
            r = e.flags;
          return new RegExp(t, r);
        }
      }
    },
    cr = {},
    pr = {
      resurrectable: {
        test: function test(t) {
          return t && !Array.isArray(t) && ["object", "function", "symbol"].includes(e(t));
        },
        replace: function replace(e) {
          var t = Ht();
          return cr[t] = e, t;
        },
        revive: function revive(e) {
          return cr[e];
        }
      }
    },
    gr = {
      set: {
        test: function test(e) {
          return "Set" === Bt.toStringTag(e);
        },
        replace: function replace(e) {
          return p(e.values());
        },
        revive: function revive(e) {
          return new Set(e);
        }
      }
    },
    dr = "undefined" == typeof self ? y : self,
    fr = {};
  ["Int8Array", "Uint8Array", "Uint8ClampedArray", "Int16Array", "Uint16Array", "Int32Array", "Uint32Array", "Float32Array", "Float64Array"].forEach(function (e) {
    var t = e,
      r = dr[e];
    r && (fr[e.toLowerCase()] = {
      test: function test(e) {
        return Bt.toStringTag(e) === t;
      },
      replace: function replace(e) {
        return (0 === e.byteOffset && e.byteLength === e.buffer.byteLength ? e : e.slice(0)).buffer;
      },
      revive: function revive(e) {
        return "ArrayBuffer" === Bt.toStringTag(e) ? new r(e) : e;
      }
    });
  });
  var hr = "undefined" == typeof self ? y : self,
    yr = {};
  ["Int8Array", "Uint8Array", "Uint8ClampedArray", "Int16Array", "Uint16Array", "Int32Array", "Uint32Array", "Float32Array", "Float64Array"].forEach(function (e) {
    var t = e,
      r = hr[t];
    r && (yr[e.toLowerCase()] = {
      test: function test(e) {
        return Bt.toStringTag(e) === t;
      },
      replace: function replace(e, t) {
        var r = e.buffer,
          o = e.byteOffset,
          n = e.length;
        t.buffers || (t.buffers = []);
        var a = t.buffers.indexOf(r);
        return a > -1 ? {
          index: a,
          byteOffset: o,
          length: n
        } : (t.buffers.push(r), {
          encoded: Mt(r),
          byteOffset: o,
          length: n
        });
      },
      revive: function revive(e, t) {
        t.buffers || (t.buffers = []);
        var o,
          n = e.byteOffset,
          a = e.length,
          i = e.encoded,
          s = e.index;
        return "index" in e ? o = t.buffers[s] : (o = xt(i), t.buffers.push(o)), new r(o, n, a);
      }
    });
  });
  var br = {
      undef: {
        test: function test(e, t) {
          return void 0 === e && (t.ownKeys || !("ownKeys" in t));
        },
        replace: function replace(e) {
          return 0;
        },
        revive: function revive(e) {
          return new Bt.Undefined();
        }
      }
    },
    mr = {
      userObject: {
        test: function test(e, t) {
          return Bt.isUserObject(e);
        },
        replace: function replace(e) {
          return i({}, e);
        },
        revive: function revive(e) {
          return e;
        }
      }
    },
    _r = [{
      arrayNonindexKeys: {
        testPlainObjects: !0,
        test: function test(e, t) {
          return !!Array.isArray(e) && (Object.keys(e).some(function (e) {
            return String(Number.parseInt(e)) !== e;
          }) && (t.iterateIn = "object", t.addLength = !0), !0);
        },
        replace: function replace(e, t) {
          return t.iterateUnsetNumeric = !0, e;
        },
        revive: function revive(e) {
          if (Array.isArray(e)) return e;
          var t = [];
          return Object.keys(e).forEach(function (r) {
            var o = e[r];
            t[r] = o;
          }), t;
        }
      }
    }, {
      sparseUndefined: {
        test: function test(e, t) {
          return void 0 === e && !1 === t.ownKeys;
        },
        replace: function replace(e) {
          return 0;
        },
        revive: function revive(e) {}
      }
    }],
    vr = [ar, rr, ir],
    Er = [br, _r, ur, vr, $t, Yt, Xt, lr].concat("function" == typeof Map ? nr : [], "function" == typeof Set ? gr : [], "function" == typeof ArrayBuffer ? Lt : [], "function" == typeof Uint8Array ? yr : [], "function" == typeof DataView ? Kt : [], "undefined" != typeof Intl ? or : [], "undefined" != typeof BigInt ? [kt, Ut] : []),
    Sr = [Yt, Xt],
    Rr = [Er, {
      arraybuffer: null
    }, fr],
    wr = [{
      sparseArrays: {
        testPlainObjects: !0,
        test: function test(e) {
          return Array.isArray(e);
        },
        replace: function replace(e, t) {
          return t.iterateUnsetNumeric = !0, e;
        }
      }
    }, {
      sparseUndefined: {
        test: function test(e, t) {
          return void 0 === e && !1 === t.ownKeys;
        },
        replace: function replace(e) {
          return 0;
        },
        revive: function revive(e) {}
      }
    }],
    Tr = [mr, br, _r, ur, vr, $t, lr, tr, er, Jt, Zt, Wt].concat("function" == typeof Map ? nr : [], "function" == typeof Set ? gr : [], "function" == typeof ArrayBuffer ? Lt : [], "function" == typeof Uint8Array ? yr : [], "function" == typeof DataView ? Kt : [], "undefined" != typeof Intl ? or : [], "undefined" != typeof crypto ? zt : [], "undefined" != typeof BigInt ? [kt, Ut] : []),
    Pr = Tr.concat({
      checkDataCloneException: {
        test: function test(t) {
          var r = {}.toString.call(t).slice(8, -1);
          if (["symbol", "function"].includes(e(t)) || ["Arguments", "Module", "Error", "Promise", "WeakMap", "WeakSet", "Event", "MessageChannel"].includes(r) || t && "object" === e(t) && "number" == typeof t.nodeType && "function" == typeof t.insertBefore) throw new DOMException("The object cannot be cloned.", "DataCloneError");
          return !1;
        }
      }
    }),
    Ar = [wr, br],
    Dr = [Er];
  Bt.types = {
    arraybuffer: Lt,
    bigintObject: Ut,
    bigint: kt,
    blob: Wt,
    cloneable: Vt,
    cryptokey: zt,
    dataview: Kt,
    date: $t,
    error: Yt,
    errors: Xt,
    file: Jt,
    filelist: Zt,
    imagebitmap: er,
    imagedata: tr,
    infinity: rr,
    intlTypes: or,
    map: nr,
    nan: ar,
    negativeInfinity: ir,
    nonbuiltinIgnore: sr,
    primitiveObjects: ur,
    regexp: lr,
    resurrectable: pr,
    set: gr,
    typedArraysSocketio: fr,
    typedArrays: yr,
    undef: br,
    userObject: mr
  }, Bt.presets = {
    arrayNonindexKeys: _r,
    builtin: Er,
    postmessage: Sr,
    socketio: Rr,
    sparseUndefined: wr,
    specialNumbers: vr,
    structuredCloningThrowing: Pr,
    structuredCloning: Tr,
    undef: Ar,
    universal: Dr
  };
  var Or = new Bt().register(Bt.presets.structuredCloningThrowing);
  function Ir(e) {
    Or = new Bt().register(e(Bt.presets.structuredCloningThrowing));
  }
  function Cr(e, t) {
    var r;
    try {
      r = Or.stringifySync(e);
    } catch (e) {
      if (Bt.hasConstructorOf(e, ReferenceError) || Bt.hasConstructorOf(e, Ee)) throw ve("DataCloneError", "The object cannot be cloned.");
      throw e;
    }
    return t && t(r), r;
  }
  function Br(e) {
    return Or.parse(e);
  }
  function Fr(e) {
    return Br(Cr(e));
  }
  var jr = Object.freeze({
      __proto__: null,
      encode: Cr,
      decode: Br,
      clone: Fr,
      register: Ir
    }),
    Nr = ["objectStore", "keyPath", "multiEntry", "unique"];
  function Mr() {
    throw new TypeError("Illegal constructor");
  }
  var xr = Mr;
  function Lr(e, t, r, o, n, a, i, s, u, l, c, p, g) {
    t && (e = 1), e && s.push("LIMIT", e);
    var d = "count" === a;
    F.DEBUG && console.log("Trying to fetch data for Index", s.join(" "), u), l.executeSql(s.join(" "), u, function (e, s) {
      var u = [],
        l = 0,
        c = d ? function () {} : "key" === a ? function (e) {
          return st(L(e.key));
        } : function (e) {
          return Br(L(e.value));
        };
      if (r.multiEntry) for (var g = G(r.name), f = it(n, r.multiEntry), h = function h(e) {
          var r = s.rows.item(e),
            a = st(r[g]),
            p = void 0;
          if (o && (i && n.some(function (e) {
            return a.includes(e);
          }) || nt(f, r[g])) ? (l++, p = r) : o || i || void 0 !== a && (l += Array.isArray(a) ? a.length : 1, p = r), p && (u.push(c(p)), t)) return "break";
        }, y = 0; y < s.rows.length && "break" !== h(y); y++);else {
        for (var b = 0; b < s.rows.length; b++) {
          var m = s.rows.item(b);
          m && u.push(c(m));
        }
        l = u.length;
      }
      p(d ? l : 0 === l ? t ? void 0 : [] : t ? u[0] : u);
    }, g);
  }
  function Ur(e, t, r, o, n) {
    var a = e || !ie(r),
      i = ["SELECT", k("count" === o ? "key" : o) + (t.multiEntry ? ", " + H(t.name) : ""), "FROM", W(t.objectStore.__currentName), "WHERE", H(t.name), "NOT NULL"],
      s = [];
    return a && (n ? (i.push("AND ("), r.forEach(function (e, r) {
      r > 0 && i.push("OR"), i.push(H(t.name), "LIKE ? ESCAPE '^' "), s.push("%" + V(it(e, t.multiEntry)) + "%");
    }), i.push(")")) : t.multiEntry ? (i.push("AND", H(t.name), "LIKE ? ESCAPE '^'"), s.push("%" + V(it(r, t.multiEntry)) + "%")) : _t(vt(r, e), H(t.name), i, s, !0, !1)), [e, t, a, r, o, n, i, s];
  }
  Mr.__createInstance = function (e, t) {
    function r() {
      var r = this;
      r[Symbol.toStringTag] = "IDBIndex", J(r, Nr), r.__objectStore = e, r.__name = r.__originalName = t.columnName, r.__keyPath = Array.isArray(t.keyPath) ? t.keyPath.slice() : t.keyPath;
      var o = t.optionalParams;
      r.__multiEntry = Boolean(o && o.multiEntry), r.__unique = Boolean(o && o.unique), r.__deleted = Boolean(t.__deleted), r.__objectStore.__cursors = t.cursors || [], Object.defineProperty(r, "__currentName", {
        get: function get() {
          return "__pendingName" in r ? r.__pendingName : r.name;
        }
      }), Object.defineProperty(r, "name", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
          return this.__name;
        },
        set: function set(t) {
          var r = this;
          t = oe(t);
          var o = r.name;
          if (Dt.__assertVersionChange(r.objectStore.transaction), Dt.__assertActive(r.objectStore.transaction), xr.__invalidStateIfDeleted(r), qr.__invalidStateIfDeleted(r), t !== o) {
            if (r.objectStore.__indexes[t] && !r.objectStore.__indexes[t].__deleted && !r.objectStore.__indexes[t].__pendingDelete) throw ve("ConstraintError", 'Index "' + t + '" already exists on ' + r.objectStore.__currentName);
            r.__name = t;
            var n = r.objectStore;
            delete n.__indexes[o], n.__indexes[t] = r, n.indexNames.splice(n.indexNames.indexOf(o), 1, t);
            var a = n.transaction.__storeHandles[n.name],
              i = a.__indexHandles[o];
            i.__name = t, a.__indexHandles[t] = i, r.__pendingName = o;
            var s = [["key", "BLOB " + (n.autoIncrement ? "UNIQUE, inc INTEGER PRIMARY KEY AUTOINCREMENT" : "PRIMARY KEY")], ["value", "BLOB"]].concat(p(n.indexNames).filter(function (e) {
              return e !== t;
            }).map(function (e) {
              return [H(e), "BLOB"];
            }));
            r.__renameIndex(n, o, t, s, function (t, r) {
              xr.__updateIndexList(e, t, function (e) {
                delete a.__pendingName, r(e);
              });
            });
          }
        }
      });
    }
    return r.prototype = xr.prototype, new r();
  }, Mr.__invalidStateIfDeleted = function (e, t) {
    if (e.__deleted || e.__pendingDelete || e.__pendingCreate && e.objectStore.transaction && e.objectStore.transaction.__errored) throw ve("InvalidStateError", t || "This index has been deleted");
  }, Mr.__clone = function (e, t) {
    var r = Mr.__createInstance(t, {
      columnName: e.name,
      keyPath: e.keyPath,
      optionalParams: {
        multiEntry: e.multiEntry,
        unique: e.unique
      }
    });
    return ["__pendingCreate", "__pendingDelete", "__deleted", "__originalName", "__recreated"].forEach(function (t) {
      r[t] = e[t];
    }), r;
  }, Mr.__createIndex = function (e, t) {
    var r = t.name,
      o = e.__currentName,
      n = e.__indexes[r];
    t.__pendingCreate = !0, e.indexNames.push(r), e.__indexes[r] = t;
    var a = e.__indexHandles[r];
    (!a || t.__pendingDelete || t.__deleted || a.__pendingDelete || a.__deleted) && (a = e.__indexHandles[r] = Mr.__clone(t, e)), e.transaction.__addNonRequestToTransactionQueue(function (i, s, u, l) {
      var c = n && (n.__deleted || n.__recreated),
        p = {};
      function g(e, t) {
        l(ve("UnknownError", 'Could not create index "' + r + '"' + t.code + "::" + t.message, t));
      }
      function d(n) {
        Mr.__updateIndexList(e, n, function () {
          n.executeSql('SELECT "key", "value" FROM ' + W(o), [], function (n, i) {
            F.DEBUG && console.log("Adding existing " + o + " records to the " + r + " index"), function s(c) {
              if (c < i.rows.length) try {
                var d = Ze(Br(L(i.rows.item(c).value)), t.keyPath, t.multiEntry);
                if (d.invalid || d.failure) throw new Error("Go to catch; ignore bad indexKey");
                if (d = it(d.value, t.multiEntry), t.unique) {
                  if (p[d]) return p = {}, void l(ve("ConstraintError", "Duplicate values already exist within the store"));
                  p[d] = !0;
                }
                n.executeSql("UPDATE " + W(o) + " SET " + H(r) + ' = ? WHERE "key" = ?', [x(d), i.rows.item(c).key], function (e, t) {
                  s(c + 1);
                }, g);
              } catch (e) {
                s(c + 1);
              } else delete t.__pendingCreate, delete a.__pendingCreate, t.__deleted && (delete t.__deleted, delete a.__deleted, t.__recreated = !0, a.__recreated = !0), p = {}, u(e);
            }(0);
          }, g);
        }, g);
      }
      var f = W(o),
        h = H(t.name);
      if (c) d(i);else {
        var y = ["ALTER TABLE", f, "ADD", h, "BLOB"].join(" ");
        F.DEBUG && console.log(y), i.executeSql(y, [], function (e) {
          F.useSQLiteIndexes ? e.executeSql('CREATE INDEX IF NOT EXISTS "' + f.slice(1, -1) + "^5" + h.slice(1, -1) + '" ON ' + f + "(" + h + ")", [], d, g) : d(e);
        }, g);
      }
    }, void 0, e);
  }, Mr.__deleteIndex = function (e, t) {
    t.__pendingDelete = !0;
    var r = e.__indexHandles[t.name];
    r && (r.__pendingDelete = !0), e.indexNames.splice(e.indexNames.indexOf(t.name), 1), e.transaction.__addNonRequestToTransactionQueue(function (o, n, a, i) {
      function s(e, r) {
        i(ve("UnknownError", 'Could not delete index "' + t.name + '"', r));
      }
      function u() {
        Mr.__updateIndexList(e, o, function (e) {
          delete t.__pendingDelete, delete t.__recreated, t.__deleted = !0, r && (r.__deleted = !0, delete r.__pendingDelete), a(e);
        }, s);
      }
      F.useSQLiteIndexes ? o.executeSql("DROP INDEX IF EXISTS " + k(W(e.name).slice(1, -1) + "^5" + H(t.name).slice(1, -1)), [], u, s) : u();
    }, void 0, e);
  }, Mr.__updateIndexList = function (e, t, r, o) {
    for (var n = {}, a = 0; a < e.indexNames.length; a++) {
      var i = e.__indexes[e.indexNames[a]];
      n[i.name] = {
        columnName: i.name,
        keyPath: i.keyPath,
        optionalParams: {
          unique: i.unique,
          multiEntry: i.multiEntry
        },
        deleted: Boolean(i.deleted)
      };
    }
    F.DEBUG && console.log("Updating the index list for " + e.__currentName, n), t.executeSql('UPDATE __sys__ SET "indexList" = ? WHERE "name" = ?', [JSON.stringify(n), x(e.__currentName)], function () {
      r(e);
    }, o);
  }, Mr.prototype.__fetchIndexData = function (e, t, r, o) {
    var n = this;
    if (void 0 !== o && (o = re(o, "unsigned long")), Mr.__invalidStateIfDeleted(n), qr.__invalidStateIfDeleted(n.objectStore), n.objectStore.__deleted) throw ve("InvalidStateError", "This index's object store has been deleted");
    if (Dt.__assertActive(n.objectStore.transaction), r && ie(e)) throw ve("DataError", "No key or range was specified");
    var a = Ur(r, n, e, t, !1);
    return n.objectStore.transaction.__addToTransactionQueue(function () {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
      Lr.apply(void 0, [o].concat(p(a), t));
    }, void 0, n);
  }, Mr.prototype.openCursor = function () {
    var e = this,
      t = Array.prototype.slice.call(arguments),
      r = t[0],
      o = t[1],
      n = So.__createInstance(r, o, e.objectStore, e, G(e.name), "value");
    return e.__objectStore.__cursors.push(n), n.__request;
  }, Mr.prototype.openKeyCursor = function () {
    var e = this,
      t = Array.prototype.slice.call(arguments),
      r = t[0],
      o = t[1],
      n = _o.__createInstance(r, o, e.objectStore, e, G(e.name), "key");
    return e.__objectStore.__cursors.push(n), n.__request;
  }, Mr.prototype.get = function (e) {
    if (!arguments.length) throw new TypeError("A parameter was missing for `IDBIndex.get`.");
    return this.__fetchIndexData(e, "value", !0);
  }, Mr.prototype.getKey = function (e) {
    if (!arguments.length) throw new TypeError("A parameter was missing for `IDBIndex.getKey`.");
    return this.__fetchIndexData(e, "key", !0);
  }, Mr.prototype.getAll = function () {
    var e = Array.prototype.slice.call(arguments),
      t = e[0],
      r = e[1];
    return this.__fetchIndexData(t, "value", !1, r);
  }, Mr.prototype.getAllKeys = function () {
    var e = Array.prototype.slice.call(arguments),
      t = e[0],
      r = e[1];
    return this.__fetchIndexData(t, "key", !1, r);
  }, Mr.prototype.count = function () {
    var e = this,
      t = arguments[0];
    return z(t, yt) ? So.__createInstance(t, "next", e.objectStore, e, G(e.name), "value", !0).__request : e.__fetchIndexData(t, "count", !1);
  }, Mr.prototype.__renameIndex = function (e, t, r) {
    var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [],
      n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
      a = "BLOB",
      i = e.__currentName,
      s = W(i),
      u = H(r),
      l = k("tmp_" + W(i).slice(1, -1)),
      c = o.map(function (e) {
        return e[0];
      }),
      p = o.map(function (e) {
        return e.join(" ");
      }),
      g = p.length ? p.join(", ") + ", " : "",
      d = c.length ? c.join(", ") + ", " : "";
    e.transaction.__addNonRequestToTransactionQueue(function (e, r, o, i) {
      function p(e, t) {
        i(t);
      }
      function f() {
        n ? n(e, o) : o();
      }
      var h = "CREATE TABLE " + l + "(" + g + u + " " + a + ")";
      F.DEBUG && console.log(h), e.executeSql(h, [], function () {
        var r = "INSERT INTO " + l + "(" + d + u + ") SELECT " + d + H(t) + " FROM " + s;
        F.DEBUG && console.log(r), e.executeSql(r, [], function () {
          var t = "DROP TABLE " + s;
          F.DEBUG && console.log(t), e.executeSql(t, [], function () {
            var t = "ALTER TABLE " + l + " RENAME TO " + s;
            F.DEBUG && console.log(t), e.executeSql(t, [], function (e, t) {
              if (F.useSQLiteIndexes) {
                var r = c.slice(2).map(function (t) {
                  return new Fe(function (r, o) {
                    var n = "CREATE INDEX " + k(s.slice(1, -1) + "^5" + t.slice(1, -1)) + " ON " + s + "(" + t + ")";
                    F.DEBUG && console.log(n), e.executeSql(n, [], r, function (e, t) {
                      o(t);
                    });
                  });
                });
                r.push(new Fe(function (t, r) {
                  var o = k("sk_" + s.slice(1, -1)),
                    n = "DROP INDEX IF EXISTS " + o;
                  F.DEBUG && console.log(n), e.executeSql(n, [], function () {
                    var n = "CREATE INDEX " + o + " ON " + s + '("key")';
                    F.DEBUG && console.log(n), e.executeSql(n, [], t, function (e, t) {
                      r(t);
                    });
                  }, function (e, t) {
                    r(t);
                  });
                })), Fe.all(r).then(f, i).catch(function (e) {
                  throw console.log("Index rename error"), e;
                });
              } else f();
            }, p);
          }, p);
        }, p);
      }, p);
    });
  }, Object.defineProperty(Mr, Symbol.hasInstance, {
    value: function value(e) {
      return K(e) && "function" == typeof e.openCursor && "boolean" == typeof e.multiEntry;
    }
  }), Q(Mr.prototype, Nr), Y(Mr.prototype, ["name"]), Mr.prototype[Symbol.toStringTag] = "IDBIndexPrototype", Object.defineProperty(Mr, "prototype", {
    writable: !1
  });
  var kr = ["keyPath", "indexNames", "transaction", "autoIncrement"];
  function qr() {
    throw new TypeError("Illegal constructor");
  }
  var Wr = qr;
  function Hr(e, t) {
    for (var r = 0, o = e.length - 1; o >= 0; o--) {
      var n = e[o];
      "." === n ? e.splice(o, 1) : ".." === n ? (e.splice(o, 1), r++) : r && (e.splice(o, 1), r--);
    }
    if (t) for (; r--; r) e.unshift("..");
    return e;
  }
  qr.__createInstance = function (e, t) {
    function r() {
      var r = this;
      r[Symbol.toStringTag] = "IDBObjectStore", J(this, kr), r.__name = r.__originalName = e.name, r.__keyPath = Array.isArray(e.keyPath) ? e.keyPath.slice() : e.keyPath, r.__transaction = t, r.__idbdb = e.idbdb, r.__cursors = e.cursors || [], r.__autoIncrement = Boolean(e.autoInc), r.__indexes = {}, r.__indexHandles = {}, r.__indexNames = Rt.__createInstance();
      var o,
        n,
        a = e.indexList;
      for (var i in a) if (o = a, n = i, {}.hasOwnProperty.call(o, n)) {
        var s = Mr.__createInstance(r, a[i]);
        r.__indexes[s.name] = s, s.__deleted || r.indexNames.push(s.name);
      }
      r.__oldIndexNames = r.indexNames.clone(), Object.defineProperty(this, "__currentName", {
        get: function get() {
          return "__pendingName" in this ? this.__pendingName : this.name;
        }
      }), Object.defineProperty(this, "name", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
          return this.__name;
        },
        set: function set(e) {
          var t = this;
          e = oe(e);
          var r = t.name;
          if (Wr.__invalidStateIfDeleted(t), Dt.__assertVersionChange(t.transaction), Dt.__assertActive(t.transaction), r !== e) {
            if (t.__idbdb.__objectStores[e] && !t.__idbdb.__objectStores[e].__pendingDelete) throw ve("ConstraintError", 'Object store "' + e + '" already exists in ' + t.__idbdb.name);
            t.__name = e;
            var o = t.__idbdb.__objectStores[r];
            o.__name = e, t.__idbdb.__objectStores[e] = o, delete t.__idbdb.__objectStores[r], t.__idbdb.objectStoreNames.splice(t.__idbdb.objectStoreNames.indexOf(r), 1, e);
            var n = t.transaction.__storeHandles[r];
            n.__name = e, t.transaction.__storeHandles[e] = n, t.__pendingName = r;
            var a = 'UPDATE __sys__ SET "name" = ? WHERE "name" = ?',
              i = [x(e), x(r)];
            F.DEBUG && console.log(a, i), t.transaction.__addNonRequestToTransactionQueue(function (o, n, s, u) {
              o.executeSql(a, i, function (o, n) {
                var a = "ALTER TABLE " + W(r) + " RENAME TO " + W(e);
                F.DEBUG && console.log(a), o.executeSql(a, [], function (e, r) {
                  delete t.__pendingName, s();
                });
              }, function (e, t) {
                u(t);
              });
            });
          }
        }
      });
    }
    return r.prototype = Wr.prototype, new r();
  }, qr.__clone = function (e, t) {
    var r = qr.__createInstance({
      name: e.__currentName,
      keyPath: Array.isArray(e.keyPath) ? e.keyPath.slice() : e.keyPath,
      autoInc: e.autoIncrement,
      indexList: {},
      idbdb: e.__idbdb,
      cursors: e.__cursors
    }, t);
    return ["__indexes", "__indexNames", "__oldIndexNames", "__deleted", "__pendingDelete", "__pendingCreate", "__originalName"].forEach(function (t) {
      r[t] = e[t];
    }), r;
  }, qr.__invalidStateIfDeleted = function (e, t) {
    if (e.__deleted || e.__pendingDelete || e.__pendingCreate && e.transaction && e.transaction.__errored) throw ve("InvalidStateError", t || "This store has been deleted");
  }, qr.__createObjectStore = function (e, t) {
    var r = t.__currentName;
    t.__pendingCreate = !0, e.__objectStores[r] = t, e.objectStoreNames.push(r);
    var o = e.__versionTransaction,
      n = o.__storeHandles;
    return (!n[r] || n[r].__pendingDelete || n[r].__deleted) && (n[r] = qr.__clone(t, o)), o.__addNonRequestToTransactionQueue(function (e, o, n, a) {
      function i(e, t) {
        F.DEBUG && console.log(t), a(ve("UnknownError", 'Could not create object store "' + r + '"', t));
      }
      var s = W(r),
        u = ["CREATE TABLE", s, "(key BLOB", t.autoIncrement ? "UNIQUE, inc INTEGER PRIMARY KEY AUTOINCREMENT" : "PRIMARY KEY", ", value BLOB)"].join(" ");
      F.DEBUG && console.log(u), e.executeSql(u, [], function (e, o) {
        function a() {
          var o = JSON.stringify(t.keyPath);
          e.executeSql("INSERT INTO __sys__ VALUES (?,?,?,?,?)", [x(r), o, Number(t.autoIncrement), "{}", 1], function () {
            delete t.__pendingCreate, delete t.__deleted, n(t);
          }, i);
        }
        F.useSQLiteIndexes ? e.executeSql("CREATE INDEX IF NOT EXISTS " + k("sk_" + s.slice(1, -1)) + " ON " + s + '("key")', [], a, i) : a();
      }, i);
    }), n[r];
  }, qr.__deleteObjectStore = function (e, t) {
    t.__pendingDelete = !0, t.__indexNames = Rt.__createInstance(), e.objectStoreNames.splice(e.objectStoreNames.indexOf(t.__currentName), 1);
    var r = e.__versionTransaction.__storeHandles[t.__currentName];
    r && (r.__indexNames = Rt.__createInstance(), r.__pendingDelete = !0), e.__versionTransaction.__addNonRequestToTransactionQueue(function (e, o, n, a) {
      function i(e, t) {
        F.DEBUG && console.log(t), a(ve("UnknownError", "Could not delete ObjectStore", t));
      }
      e.executeSql('SELECT "name" FROM __sys__ WHERE "name" = ?', [x(t.__currentName)], function (e, o) {
        o.rows.length > 0 && e.executeSql("DROP TABLE " + W(t.__currentName), [], function () {
          e.executeSql('DELETE FROM __sys__ WHERE "name" = ?', [x(t.__currentName)], function () {
            delete t.__pendingDelete, t.__deleted = !0, r && (delete r.__pendingDelete, r.__deleted = !0), n();
          }, i);
        }, i);
      });
    });
  }, qr.prototype.__validateKeyAndValueAndCloneValue = function (e, t, r) {
    var o = this;
    if (null !== o.keyPath) {
      if (void 0 !== t) throw ve("DataError", "The object store uses in-line keys and the key parameter was provided", o);
      var n = Fr(e);
      if ((t = Ze(n, o.keyPath)).invalid) throw ve("DataError", "KeyPath was specified, but key was invalid.");
      if (t.failure) {
        if (!r) {
          if (!o.autoIncrement) throw ve("DataError", "Could not evaluate a key from keyPath and there is no key generator");
          if (!rt(n, o.keyPath)) throw ve("DataError", "A key could not be injected into a value");
          return [void 0, n];
        }
        throw ve("DataError", "Could not evaluate a key from keyPath");
      }
      return [t.value, n];
    }
    if (void 0 === t) {
      if (!o.autoIncrement) throw ve("DataError", "The object store uses out-of-line keys and has no key generator and the key parameter was not provided.", o);
      t = void 0;
    } else Je(t);
    return [t, Fr(e)];
  }, qr.prototype.__deriveKey = function (e, t, r, o, n) {
    var a = this;
    function i(e) {
      Cr(r, function (t) {
        t = Br(t), o(t, e);
      });
    }
    a.autoIncrement ? void 0 === r ? dt(e, a, function (e, r, i) {
      e ? n(ve("ConstraintError", "The key generator's current number has reached the maximum safe integer limit")) : (null !== a.keyPath && tt(t, r, a.keyPath), o(r, i));
    }, n) : ft(e, a, r, i, n) : i();
  }, qr.prototype.__insertData = function (e, t, r, o, n, a, i) {
    var s = this,
      u = {},
      l = Object.keys(s.__indexes).map(function (t) {
        return new Fe(function (o, n) {
          var a = s.__indexes[t];
          if (a.__pendingCreate || a.__deleted) o();else {
            var i;
            try {
              if ((i = Ze(r, a.keyPath, a.multiEntry)).invalid || i.failure) throw new Error("Go to catch");
            } catch (e) {
              return void o();
            }
            if (i = i.value, a.unique) {
              var l = a.multiEntry && Array.isArray(i),
                c = Ur(!0, a, i, "key", l);
              Lr.apply(void 0, [null].concat(p(c), [e, null, function (e) {
                if (void 0 === e) return g(a), void o();
                n(ve("ConstraintError", "Index already contains a record equal to " + (l ? "one of the subkeys of" : "") + "`indexKey`"));
              }, n]));
            } else g(a), o();
          }
          function g(e) {
            void 0 !== i && (u[e.__currentName] = it(i, e.multiEntry));
          }
        });
      });
    return Fe.all(l).then(function () {
      var r = ["INSERT INTO", W(s.__currentName), "("],
        n = [" VALUES ("],
        l = [];
      void 0 !== o && (r.push(k("key"), ","), n.push("?,"), l.push(x(it(o)))), Object.entries(u).forEach(function (e) {
        var t = c(e, 2),
          o = t[0],
          a = t[1];
        r.push(H(o) + ","), n.push("?,"), l.push(x(a));
      }), r.push(k("value") + " )"), n.push("?)"), l.push(x(t));
      var p = r.join(" ") + n.join(" ");
      F.DEBUG && console.log("SQL for adding", p, l), e.executeSql(p, l, function (e, t) {
        a(o);
      }, function (e, t) {
        i(ve("ConstraintError", t.message, t));
      });
    }).catch(function (t) {
      function r() {
        i(t);
      }
      "number" != typeof n ? r() : pt(e, s, n, r, r);
    });
  }, qr.prototype.add = function (e) {
    var t = this,
      r = arguments[1];
    if (!(t instanceof qr)) throw new TypeError("Illegal invocation");
    if (0 === arguments.length) throw new TypeError("No value was specified");
    qr.__invalidStateIfDeleted(t), Dt.__assertActive(t.transaction), t.transaction.__assertWritable();
    var o = t.transaction.__createRequest(t),
      n = c(t.__validateKeyAndValueAndCloneValue(e, r, !1), 2),
      a = n[0],
      i = n[1];
    return qr.__storingRecordObjectStore(o, t, !0, i, !0, a), o;
  }, qr.prototype.put = function (e) {
    var t = this,
      r = arguments[1];
    if (!(t instanceof qr)) throw new TypeError("Illegal invocation");
    if (0 === arguments.length) throw new TypeError("No value was specified");
    qr.__invalidStateIfDeleted(t), Dt.__assertActive(t.transaction), t.transaction.__assertWritable();
    var o = t.transaction.__createRequest(t),
      n = c(t.__validateKeyAndValueAndCloneValue(e, r, !1), 2),
      a = n[0],
      i = n[1];
    return qr.__storingRecordObjectStore(o, t, !0, i, !1, a), o;
  }, qr.prototype.__overwrite = function (e, t, r, o) {
    var n = "DELETE FROM " + W(this.__currentName) + ' WHERE "key" = ?',
      a = it(t);
    e.executeSql(n, [x(a)], function (e, o) {
      F.DEBUG && console.log("Did the row with the", t, "exist?", o.rowsAffected), r(e);
    }, function (e, t) {
      o(t);
    });
  }, qr.__storingRecordObjectStore = function (e, t, r, o, n) {
    var a = arguments[5];
    t.transaction.__pushToQueue(e, function (e, i, s, u) {
      t.__deriveKey(e, o, a, function (a, i) {
        Cr(o, function (l) {
          function c(e) {
            t.__insertData(e, l, o, a, i, function () {
              r && t.__cursors.forEach(function (e) {
                e.__invalidateCache();
              }), s.apply(void 0, arguments);
            }, u);
          }
          n ? c(e) : t.__overwrite(e, a, c, u);
        });
      }, u);
    });
  }, qr.prototype.__get = function (e, t, r, o) {
    var n = this;
    void 0 !== o && (o = re(o, "unsigned long")), qr.__invalidStateIfDeleted(n), Dt.__assertActive(n.transaction);
    var a = vt(e, !r),
      i = ["SELECT", k(t ? "key" : "value"), "FROM", W(n.__currentName)],
      s = [];
    if (void 0 !== a && (i.push("WHERE"), _t(a, k("key"), i, s)), r || (o = 1), o) {
      if (!Number.isFinite(o)) throw new TypeError("The count parameter must be a finite number");
      i.push("LIMIT", o);
    }
    return i = i.join(" "), n.transaction.__addToTransactionQueue(function (e, o, a, u) {
      F.DEBUG && console.log("Fetching", n.__currentName, s), e.executeSql(i, s, function (e, o) {
        var n;
        F.DEBUG && console.log("Fetched data", o);
        try {
          if (0 === o.rows.length) return void (r ? a([]) : a());
          if (n = [], t) for (var i = 0; i < o.rows.length; i++) n.push(st(L(o.rows.item(i).key), !1));else for (var s = 0; s < o.rows.length; s++) n.push(Br(L(o.rows.item(s).value)));
          r || (n = n[0]);
        } catch (e) {
          F.DEBUG && console.log(e);
        }
        a(n);
      }, function (e, t) {
        u(t);
      });
    }, void 0, n);
  }, qr.prototype.get = function (e) {
    if (!arguments.length) throw new TypeError("A parameter was missing for `IDBObjectStore.get`.");
    return this.__get(e);
  }, qr.prototype.getKey = function (e) {
    if (!arguments.length) throw new TypeError("A parameter was missing for `IDBObjectStore.getKey`.");
    return this.__get(e, !0);
  }, qr.prototype.getAll = function () {
    var e = Array.prototype.slice.call(arguments),
      t = e[0],
      r = e[1];
    return this.__get(t, !1, !0, r);
  }, qr.prototype.getAllKeys = function () {
    var e = Array.prototype.slice.call(arguments),
      t = e[0],
      r = e[1];
    return this.__get(t, !0, !0, r);
  }, qr.prototype.delete = function (e) {
    var t = this;
    if (!(this instanceof qr)) throw new TypeError("Illegal invocation");
    if (!arguments.length) throw new TypeError("A parameter was missing for `IDBObjectStore.delete`.");
    qr.__invalidStateIfDeleted(t), Dt.__assertActive(t.transaction), t.transaction.__assertWritable();
    var r = vt(e, !0),
      o = ["DELETE FROM", W(t.__currentName), "WHERE"],
      n = [];
    _t(r, k("key"), o, n);
    var a = o.join(" ");
    return t.transaction.__addToTransactionQueue(function (e, r, o, i) {
      F.DEBUG && console.log("Deleting", t.__currentName, n), e.executeSql(a, n, function (e, r) {
        F.DEBUG && console.log("Deleted from database", r.rowsAffected), t.__cursors.forEach(function (e) {
          e.__invalidateCache();
        }), o();
      }, function (e, t) {
        i(t);
      });
    }, void 0, t);
  }, qr.prototype.clear = function () {
    var e = this;
    if (!(this instanceof qr)) throw new TypeError("Illegal invocation");
    return qr.__invalidStateIfDeleted(e), Dt.__assertActive(e.transaction), e.transaction.__assertWritable(), e.transaction.__addToTransactionQueue(function (t, r, o, n) {
      t.executeSql("DELETE FROM " + W(e.__currentName), [], function (t, r) {
        F.DEBUG && console.log("Cleared all records from database", r.rowsAffected), e.__cursors.forEach(function (e) {
          e.__invalidateCache();
        }), o();
      }, function (e, t) {
        n(t);
      });
    }, void 0, e);
  }, qr.prototype.count = function () {
    var e = this,
      t = arguments[0];
    if (!(e instanceof qr)) throw new TypeError("Illegal invocation");
    return qr.__invalidStateIfDeleted(e), Dt.__assertActive(e.transaction), So.__createInstance(t, "next", e, e, "key", "value", !0).__request;
  }, qr.prototype.openCursor = function () {
    var e = this,
      t = Array.prototype.slice.call(arguments),
      r = t[0],
      o = t[1];
    if (!(e instanceof qr)) throw new TypeError("Illegal invocation");
    qr.__invalidStateIfDeleted(e);
    var n = So.__createInstance(r, o, e, e, "key", "value");
    return e.__cursors.push(n), n.__request;
  }, qr.prototype.openKeyCursor = function () {
    var e = this;
    if (!(e instanceof qr)) throw new TypeError("Illegal invocation");
    qr.__invalidStateIfDeleted(e);
    var t = Array.prototype.slice.call(arguments),
      r = t[0],
      o = t[1],
      n = _o.__createInstance(r, o, e, e, "key", "key");
    return e.__cursors.push(n), n.__request;
  }, qr.prototype.index = function (e) {
    var t = this;
    if (!(t instanceof qr)) throw new TypeError("Illegal invocation");
    if (0 === arguments.length) throw new TypeError("No index name was specified");
    qr.__invalidStateIfDeleted(t), Dt.__assertNotFinished(t.transaction);
    var r = t.__indexes[e];
    if (!r || r.__deleted) throw ve("NotFoundError", 'Index "' + e + '" does not exist on ' + t.__currentName);
    return (!t.__indexHandles[e] || t.__indexes[e].__pendingDelete || t.__indexes[e].__deleted) && (t.__indexHandles[e] = Mr.__clone(r, t)), t.__indexHandles[e];
  }, qr.prototype.createIndex = function (e, t) {
    var r = this,
      o = arguments[2];
    if (!(r instanceof qr)) throw new TypeError("Illegal invocation");
    if (e = String(e), 0 === arguments.length) throw new TypeError("No index name was specified");
    if (1 === arguments.length) throw new TypeError("No key path was specified");
    if (Dt.__assertVersionChange(r.transaction), qr.__invalidStateIfDeleted(r), Dt.__assertActive(r.transaction), r.__indexes[e] && !r.__indexes[e].__deleted && !r.__indexes[e].__pendingDelete) throw ve("ConstraintError", 'Index "' + e + '" already exists on ' + r.__currentName);
    if (!te(t = ae(t))) throw ve("SyntaxError", "A valid keyPath must be supplied");
    if (Array.isArray(t) && o && o.multiEntry) throw ve("InvalidAccessError", "The keyPath argument was an array and the multiEntry option is true.");
    o = o || {};
    var n = {
        columnName: e,
        keyPath: t,
        optionalParams: {
          unique: Boolean(o.unique),
          multiEntry: Boolean(o.multiEntry)
        }
      },
      a = Mr.__createInstance(r, n);
    return Mr.__createIndex(r, a), a;
  }, qr.prototype.deleteIndex = function (e) {
    var t = this;
    if (!(t instanceof qr)) throw new TypeError("Illegal invocation");
    if (0 === arguments.length) throw new TypeError("No index name was specified");
    Dt.__assertVersionChange(t.transaction), qr.__invalidStateIfDeleted(t), Dt.__assertActive(t.transaction);
    var r = t.__indexes[e];
    if (!r) throw ve("NotFoundError", 'Index "' + e + '" does not exist on ' + t.__currentName);
    Mr.__deleteIndex(t, r);
  }, Q(qr.prototype, kr), Y(qr.prototype, ["name"]), qr.prototype[Symbol.toStringTag] = "IDBObjectStorePrototype", Object.defineProperty(qr, "prototype", {
    writable: !1
  });
  var Gr = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,
    Vr = function Vr(e) {
      return Gr.exec(e).slice(1);
    };
  function zr() {
    for (var e = "", t = !1, r = arguments.length - 1; r >= -1 && !t; r--) {
      var o = r >= 0 ? arguments[r] : "/";
      if ("string" != typeof o) throw new TypeError("Arguments to path.resolve must be strings");
      o && (e = o + "/" + e, t = "/" === o.charAt(0));
    }
    return (t ? "/" : "") + (e = Hr(Qr(e.split("/"), function (e) {
      return !!e;
    }), !t).join("/")) || ".";
  }
  function Kr(e) {
    var t = $r(e),
      r = "/" === Xr(e, -1);
    return (e = Hr(Qr(e.split("/"), function (e) {
      return !!e;
    }), !t).join("/")) || t || (e = "."), e && r && (e += "/"), (t ? "/" : "") + e;
  }
  function $r(e) {
    return "/" === e.charAt(0);
  }
  var Yr = {
    extname: function extname(e) {
      return Vr(e)[3];
    },
    basename: function basename(e, t) {
      var r = Vr(e)[2];
      return t && r.substr(-1 * t.length) === t && (r = r.substr(0, r.length - t.length)), r;
    },
    dirname: function dirname(e) {
      var t = Vr(e),
        r = t[0],
        o = t[1];
      return r || o ? (o && (o = o.substr(0, o.length - 1)), r + o) : ".";
    },
    sep: "/",
    delimiter: ":",
    relative: function relative(e, t) {
      function r(e) {
        for (var t = 0; t < e.length && "" === e[t]; t++);
        for (var r = e.length - 1; r >= 0 && "" === e[r]; r--);
        return t > r ? [] : e.slice(t, r - t + 1);
      }
      e = zr(e).substr(1), t = zr(t).substr(1);
      for (var o = r(e.split("/")), n = r(t.split("/")), a = Math.min(o.length, n.length), i = a, s = 0; s < a; s++) if (o[s] !== n[s]) {
        i = s;
        break;
      }
      var u = [];
      for (s = i; s < o.length; s++) u.push("..");
      return (u = u.concat(n.slice(i))).join("/");
    },
    join: function join() {
      return Kr(Qr(Array.prototype.slice.call(arguments, 0), function (e, t) {
        if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
        return e;
      }).join("/"));
    },
    isAbsolute: $r,
    normalize: Kr,
    resolve: zr
  };
  function Qr(e, t) {
    if (e.filter) return e.filter(t);
    for (var r = [], o = 0; o < e.length; o++) t(e[o], o, e) && r.push(e[o]);
    return r;
  }
  var Xr = "b" === "ab".substr(-1) ? function (e, t, r) {
      return e.substr(t, r);
    } : function (e, t, r) {
      return t < 0 && (t = e.length + t), e.substr(t, r);
    },
    Jr = ["onabort", "onclose", "onerror", "onversionchange"],
    Zr = ["name", "version", "objectStoreNames"];
  function eo() {
    throw new TypeError("Illegal constructor");
  }
  var to,
    ro = eo;
  eo.__createInstance = function (e, t, r, o, n) {
    function a() {
      var a = this;
      this[Symbol.toStringTag] = "IDBDatabase", J(this, Zr), this.__db = e, this.__closePending = !1, this.__oldVersion = r, this.__version = o, this.__name = t, this.__upgradeTransaction = null, X(this, Jr), this.__setOptions({
        legacyOutputDidListenersThrowFlag: !0
      }), this.__transactions = [], this.__objectStores = {}, this.__objectStoreNames = Rt.__createInstance();
      for (var i = {}, s = function s(e) {
          var t = n.rows.item(e);
          i.name = t.name, i.keyPath = JSON.parse(t.keyPath), ["autoInc", "indexList"].forEach(function (e) {
            i[e] = JSON.parse(t[e]);
          }), i.idbdb = a;
          var r = qr.__createInstance(i);
          a.__objectStores[r.name] = r, a.objectStoreNames.push(r.name);
        }, u = 0; u < n.rows.length; u++) s(u);
      this.__oldObjectStoreNames = this.objectStoreNames.clone();
    }
    return a.prototype = ro.prototype, new a();
  }, eo.prototype = C.createInstance(), eo.prototype[Symbol.toStringTag] = "IDBDatabasePrototype", eo.prototype.createObjectStore = function (e) {
    var t = arguments[1];
    if (e = String(e), !(this instanceof eo)) throw new TypeError("Illegal invocation");
    if (0 === arguments.length) throw new TypeError("No object store name was specified");
    Dt.__assertVersionChange(this.__versionTransaction), this.throwIfUpgradeTransactionNull(), Dt.__assertActive(this.__versionTransaction);
    var r = (t = i({}, t)).keyPath;
    if (null !== (r = void 0 === r ? null : ae(r)) && !te(r)) throw ve("SyntaxError", "The keyPath argument contains an invalid key path.");
    if (this.__objectStores[e] && !this.__objectStores[e].__pendingDelete) throw ve("ConstraintError", 'Object store "' + e + '" already exists in ' + this.name);
    var o = t.autoIncrement;
    if (o && ("" === r || Array.isArray(r))) throw ve("InvalidAccessError", "With autoIncrement set, the keyPath argument must not be an array or empty string.");
    var n = {
        name: e,
        keyPath: r,
        autoInc: o,
        indexList: {},
        idbdb: this
      },
      a = qr.__createInstance(n, this.__versionTransaction);
    return qr.__createObjectStore(this, a);
  }, eo.prototype.deleteObjectStore = function (e) {
    if (!(this instanceof eo)) throw new TypeError("Illegal invocation");
    if (0 === arguments.length) throw new TypeError("No object store name was specified");
    Dt.__assertVersionChange(this.__versionTransaction), this.throwIfUpgradeTransactionNull(), Dt.__assertActive(this.__versionTransaction);
    var t = this.__objectStores[e];
    if (!t) throw ve("NotFoundError", 'Object store "' + e + '" does not exist in ' + this.name);
    qr.__deleteObjectStore(this, t);
  }, eo.prototype.close = function () {
    if (!(this instanceof eo)) throw new TypeError("Illegal invocation");
    this.__closePending = !0, this.__unblocking && this.__unblocking.check();
  }, eo.prototype.transaction = function (e) {
    var t = this;
    if (0 === arguments.length) throw new TypeError("You must supply a valid `storeNames` to `IDBDatabase.transaction`");
    var r = arguments[1];
    if (e = $(e) ? p(new Set(ae(e))).sort() : [oe(e)], r = r || "readonly", Dt.__assertNotVersionChange(this.__versionTransaction), this.__closePending) throw ve("InvalidStateError", "An attempt was made to start a new transaction on a database connection that is not open");
    var o = Rt.__createInstance();
    if (e.forEach(function (e) {
      if (!t.objectStoreNames.contains(e)) throw ve("NotFoundError", 'The "' + e + '" object store does not exist');
      o.push(e);
    }), 0 === e.length) throw ve("InvalidAccessError", "No valid object store names were specified");
    if ("readonly" !== r && "readwrite" !== r) throw new TypeError("Invalid transaction mode: " + r);
    var n = Dt.__createInstance(this, o, r);
    return this.__transactions.push(n), n;
  }, eo.prototype.throwIfUpgradeTransactionNull = function () {
    if (null === this.__upgradeTransaction) throw ve("InvalidStateError", "No upgrade transaction associated with database.");
  }, eo.prototype.__forceClose = function (e) {
    var t = this;
    t.close();
    var r = 0;
    t.__transactions.forEach(function (o) {
      o.on__abort = function () {
        if (++r === t.__transactions.length) {
          var e = ue("close");
          setTimeout(function () {
            t.dispatchEvent(e);
          });
        }
      }, o.__abortTransaction(ve("AbortError", "The connection was force-closed: " + (e || "")));
    });
  }, Y(eo.prototype, Jr), Q(eo.prototype, Zr), Object.defineProperty(eo.prototype, "constructor", {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: eo
  }), Object.defineProperty(eo, "prototype", {
    writable: !1
  });
  var oo = function oo() {
      return "object" === ("undefined" == typeof location ? "undefined" : e(location)) && location ? location.origin : "null";
    },
    no = function no() {
      return !1 !== F.checkOrigin && "null" === oo();
    },
    ao = {};
  function io(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : oo(),
      r = ao[t][e];
    if (r[0]) {
      var o = r[0],
        n = o.req,
        a = o.cb;
      n.addEventListener("success", i), n.addEventListener("error", i), a(n);
    }
    function i() {
      r.shift(), io(e, t);
    }
  }
  function so(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : oo(),
      o = arguments.length > 3 ? arguments[3] : void 0;
    ao[r][t] || (ao[r][t] = []), ao[r][t].push({
      req: e,
      cb: o
    }), 1 === ao[r][t].length && io(t, r);
  }
  function uo(e, t, r, o) {
    var n = function n(e) {
        return e.__closePending;
      },
      a = function a() {
        return e.every(function (e) {
          return n(e);
        });
      };
    return e.reduce(function (e, t) {
      return n(t) ? e : e.then(function () {
        if (!n(t)) {
          var e = new le("versionchange", {
            oldVersion: r,
            newVersion: o
          });
          return new Fe(function (r) {
            setTimeout(function () {
              t.dispatchEvent(e), r();
            });
          });
        }
      });
    }, Fe.resolve()).then(function () {
      if (!a()) return new Fe(function (i) {
        var s = {
            check: function check() {
              a() && i();
            }
          },
          u = new le("blocked", {
            oldVersion: r,
            newVersion: o
          });
        setTimeout(function () {
          t.dispatchEvent(u), a() ? i() : e.forEach(function (e) {
            n(e) || (e.__unblocking = s);
          });
        });
      });
    });
  }
  var lo,
    co = {},
    po = 0;
  function go(e) {
    return Object.keys(co[e]).map(function (e) {
      return Number(e);
    }).reduce(function (e, t) {
      return t > e ? t : e;
    }, 0);
  }
  function fo(e, t, r, o, n) {
    if ("string" == typeof F.memoryDatabase) {
      var a = co[t] ? function (e) {
        return co[e] && co[e][go(e)];
      }(t) : null;
      if (!a) return console.warn("Could not find a memory database instance to delete."), void o();
      var i = a._db && a._db._db;
      return i && i.close ? void i.close(function (e) {
        e ? console.warn("Error closing (destroying) memory database") : o();
      }) : void console.error("The `openDatabase` implementation does not have the expected `._db._db.close` method for closing the database");
    }
    to && !1 !== F.deleteDatabaseFiles ? to.unlink(Yr.join(F.databaseBasePath || "", r), function (e) {
      e && "ENOENT" !== e.code ? n({
        code: 0,
        message: "Error removing database file: " + r + " " + e
      }) : o();
    }) : e(Yr.join(F.databaseBasePath || "", r), 1, t, F.DEFAULT_DB_SIZE).transaction(function (e) {
      e.executeSql('SELECT "name" FROM __sys__', [], function (e, t) {
        var r = t.rows;
        !function t(a) {
          a >= r.length ? e.executeSql("DROP TABLE IF EXISTS __sys__", [], function () {
            o();
          }, n) : e.executeSql("DROP TABLE " + W(L(r.item(a).name)), [], function () {
            t(a + 1);
          }, function () {
            t(a + 1);
          });
        }(0);
      }, function (e) {
        o();
      });
    });
  }
  function ho(e, t, r) {
    function o(e, t) {
      t = be(t || e), F.DEBUG && console.log("Error in sysdb transaction - when creating dbVersions", t), r(t);
    }
    lo ? t() : (lo = e("string" == typeof F.memoryDatabase ? F.memoryDatabase : Yr.join("string" == typeof F.sysDatabaseBasePath ? F.sysDatabaseBasePath : F.databaseBasePath || "", "__sysdb__" + (!1 !== F.addSQLiteExtension ? ".sqlite" : "")), 1, "System Database", F.DEFAULT_DB_SIZE)).transaction(function (e) {
      e.executeSql("CREATE TABLE IF NOT EXISTS dbVersions (name BLOB, version INT);", [], function (e) {
        F.useSQLiteIndexes ? e.executeSql("CREATE INDEX IF NOT EXISTS dbvname ON dbVersions(name)", [], t, o) : t();
      }, o);
    }, o);
  }
  function yo() {
    throw new TypeError("Illegal constructor");
  }
  var bo = yo;
  yo.__createInstance = function () {
    function e() {
      this[Symbol.toStringTag] = "IDBFactory", this.__connections = {};
    }
    return e.prototype = bo.prototype, new e();
  }, yo.prototype.open = function (e) {
    var t = this;
    if (!(t instanceof yo)) throw new TypeError("Illegal invocation");
    var r = arguments[1];
    if (0 === arguments.length) throw new TypeError("Database name is required");
    if (void 0 !== r && 0 === (r = re(r, "unsigned long long"))) throw new TypeError("Version cannot be 0");
    if (no()) throw ve("SecurityError", "Cannot open an IndexedDB database from an opaque origin.");
    var o = Ae.__createInstance(),
      n = !1;
    F.autoName && "" === e && (e = "autoNamedDatabase_" + po++);
    var a,
      i = x(e = String(e)),
      s = "string" == typeof F.memoryDatabase,
      u = !1 !== F.cacheDatabaseInstances || s;
    try {
      a = q(e);
    } catch (e) {
      throw e;
    }
    function l(e, t) {
      if (!n) {
        t = t ? be(t) : e, n = !0;
        var r = ue("error", t, {
          bubbles: !0,
          cancelable: !0
        });
        o.__done = !0, o.__error = t, o.__result = void 0, o.dispatchEvent(r);
      }
    }
    function c(n, s, c) {
      n.executeSql('SELECT "name", "keyPath", "autoInc", "indexList" FROM __sys__', [], function (n, p) {
        function g() {
          o.__result = d, o.__done = !0;
        }
        var d = eo.__createInstance(s, e, c, r, p);
        if (t.__connections[e] || (t.__connections[e] = []), t.__connections[e].push(d), c < r) uo(t.__connections[e].slice(0, -1), o, c, r).then(function () {
          var n = function n(e, t, r) {
            if (t) try {
              e.executeSql("ROLLBACK", [], r, r);
            } catch (e) {
              lo.transaction(function (e) {
                function t(e) {
                  throw new Error("Unable to roll back upgrade transaction!" + (e || ""));
                }
                0 === c ? e.executeSql('DELETE FROM dbVersions WHERE "name" = ?', [i], function () {
                  r(t);
                }, t) : e.executeSql('UPDATE dbVersions SET "version" = ? WHERE "name" = ?', [c, i], r, t);
              });
            } else r();
          };
          lo.transaction(function (s) {
            function p() {
              var i = new le("upgradeneeded", {
                oldVersion: c,
                newVersion: r
              });
              o.__result = d, d.__upgradeTransaction = o.__transaction = o.__result.__versionTransaction = Dt.__createInstance(o.__result, o.__result.objectStoreNames, "versionchange"), o.__done = !0, o.transaction.__addNonRequestToTransactionQueue(function (e, t, r, n) {
                if (o.dispatchEvent(i), i.__legacyOutputDidListenersThrowError) return fe("Error", "An error occurred in an upgradeneeded handler attached to request chain", i.__legacyOutputDidListenersThrowError), void o.transaction.__abortTransaction(ve("AbortError", "A request was aborted."));
                r();
              }), o.transaction.on__beforecomplete = function (e) {
                d.__upgradeTransaction = null, o.__result.__versionTransaction = null, n(s, !1, function () {
                  o.transaction.__transFinishedCb(!1, function () {
                    e.complete(), o.__transaction = null;
                  });
                });
              }, o.transaction.on__preabort = function () {
                d.__upgradeTransaction = null, u && e in co && delete co[e][r];
              }, o.transaction.on__abort = function () {
                o.__transaction = null, o.__result = void 0, o.__done = !1, d.close(), setTimeout(function () {
                  var r = ve("AbortError", "The upgrade transaction was aborted.");
                  n(s, r, function (o) {
                    0 !== c ? l(r) : fo(t.__openDatabase, e, a, l.bind(null, r), o || l);
                  });
                });
              }, o.transaction.on__complete = function () {
                if (o.__result.__closePending) return o.__transaction = null, void l(ve("AbortError", "The connection has been closed."));
                g(), o.__transaction = null;
                var e = ue("success");
                o.dispatchEvent(e);
              };
            }
            0 === c ? s.executeSql("INSERT INTO dbVersions VALUES (?,?)", [i, r], p, l) : s.executeSql('UPDATE dbVersions SET "version" = ? WHERE "name" = ?', [r, i], p, l);
          }, l, null, function (e, t, r, o, a) {
            return !(!e.readOnly && !t && (n = function n(e, t, r) {
              t ? o(t, r) : a(r);
            }, 1));
          });
        }).catch(function (e) {
          throw console.log("Error within `triggerAnyVersionChangeAndBlockedEvents`"), e;
        });else {
          g();
          var f = ue("success");
          o.dispatchEvent(f);
        }
      }, l);
    }
    function p(o) {
      var n;
      if ((s || u) && e in co && co[e][r] ? n = co[e][r] : (n = t.__openDatabase(s ? F.memoryDatabase : Yr.join(F.databaseBasePath || "", a), 1, e, F.DEFAULT_DB_SIZE), u && (e in co || (co[e] = {}), co[e][r] = n)), void 0 === r && (r = o || 1), o > r) {
        var i = ve("VersionError", "An attempt was made to open a database using a lower version than the existing version.", r);
        u ? setTimeout(function () {
          l(i);
        }) : l(i);
      } else n.transaction(function (e) {
        e.executeSql("CREATE TABLE IF NOT EXISTS __sys__ (name BLOB, keyPath BLOB, autoInc BOOLEAN, indexList BLOB, currNum INTEGER)", [], function () {
          function t() {
            c(e, n, o);
          }
          F.createIndexes ? e.executeSql("CREATE INDEX IF NOT EXISTS sysname ON __sys__(name)", [], t, l) : t();
        }, l);
      }, l);
    }
    return so(o, e, void 0, function (r) {
      var o;
      u && (e in co || (co[e] = {}), o = go(e)), o ? p(o) : ho(t.__openDatabase, function () {
        lo.readTransaction(function (e) {
          e.executeSql('SELECT "version" FROM dbVersions WHERE "name" = ?', [i], function (e, t) {
            0 === t.rows.length ? p(0) : p(t.rows.item(0).version);
          }, l);
        }, l);
      }, l);
    }), o;
  }, yo.prototype.deleteDatabase = function (e) {
    var t = this;
    if (!(t instanceof yo)) throw new TypeError("Illegal invocation");
    if (0 === arguments.length) throw new TypeError("Database name is required");
    if (no()) throw ve("SecurityError", "Cannot delete an IndexedDB database from an opaque origin.");
    var r,
      o = x(e = String(e));
    try {
      r = q(e);
    } catch (e) {
      throw e;
    }
    var n = "string" == typeof F.memoryDatabase,
      a = !1 !== F.cacheDatabaseInstances || n,
      i = Ae.__createInstance(),
      s = !1,
      u = 0,
      l = function l(e, t) {
        t(e);
      };
    function c(e, t) {
      s || !0 === t || (t = be(t || e), l(!0, function () {
        i.__done = !0, i.__error = t, i.__result = void 0;
        var e = ue("error", t, {
          bubbles: !0,
          cancelable: !0
        });
        i.dispatchEvent(e), s = !0;
      }));
    }
    return so(i, e, void 0, function (n) {
      ho(t.__openDatabase, function () {
        function i() {
          n.__result = void 0, n.__done = !0;
          var e = new le("success", {
            oldVersion: u,
            newVersion: null
          });
          n.dispatchEvent(e);
        }
        function s() {
          l(!1, function () {
            a && e in co && delete co[e], delete t.__connections[e], i();
          });
        }
        lo.readTransaction(function (a) {
          a.executeSql('SELECT "version" FROM dbVersions WHERE "name" = ?', [o], function (a, p) {
            if (0 !== p.rows.length) {
              var g = p.rows.item(0);
              u = g.version, uo(t.__connections[e] || [], n, u, null).then(function () {
                lo.transaction(function (n) {
                  n.executeSql('DELETE FROM dbVersions WHERE "name" = ? ', [o], function () {
                    fo(t.__openDatabase, e, r, s, c);
                  }, c);
                }, c, null, function (e, t, r, o, n) {
                  return !(!e.readOnly && !t && (l = function l(e, t) {
                    e ? o(e, t) : n(t);
                  }, 1));
                });
              }, c);
            } else i();
          }, c);
        });
      }, c);
    }), i;
  }, yo.prototype.cmp = function (e, t) {
    if (!(this instanceof yo)) throw new TypeError("Illegal invocation");
    if (arguments.length < 2) throw new TypeError("You must provide two keys to be compared");
    return Je(e), Je(t), je(e, t);
  }, yo.prototype.databases = function () {
    var e = this,
      t = !1;
    return new Promise(function (r, o) {
      if (!(e instanceof yo)) throw new TypeError("Illegal invocation");
      if (no()) throw ve("SecurityError", "Cannot get IndexedDB database names from an opaque origin.");
      function n(e, r) {
        t || (r = r ? be(r) : e, t = !0, o(r));
      }
      ho(e.__openDatabase, function () {
        lo.readTransaction(function (e) {
          e.executeSql('SELECT "name", "version" FROM dbVersions', [], function (e, t) {
            for (var o = [], n = 0; n < t.rows.length; n++) {
              var a = t.rows.item(n),
                i = a.name,
                s = a.version;
              o.push({
                name: L(i),
                version: s
              });
            }
            r(o);
          }, n);
        }, n);
      }, n);
    });
  }, yo.prototype.__forceClose = function (e, t, r) {
    var o = this;
    function n(e) {
      e.__forceClose(r);
    }
    if (ie(e)) Object.values(o.__connections).forEach(function (e) {
      n(e);
    });else if (o.__connections[e]) {
      if (ie(t)) o.__connections[e].forEach(function (e) {
        n(e);
      });else {
        if (!Number.isInteger(t) || t < 0 || t > o.__connections[e].length - 1) throw new TypeError("If providing an argument, __forceClose must be called with a numeric index to indicate a specific connection to lose");
        n(o.__connections[e][t]);
      }
    } else console.log("No database connections with that name to force close");
  }, yo.prototype.__setConnectionQueueOrigin = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : oo();
    ao[e] = {};
  }, yo.prototype[Symbol.toStringTag] = "IDBFactoryPrototype", Object.defineProperty(yo, "prototype", {
    writable: !1
  });
  var mo = yo.__createInstance();
  function _o() {
    throw new TypeError("Illegal constructor");
  }
  var vo = _o;
  _o.__super = function (e, t, r, o, n, a, i) {
    this[Symbol.toStringTag] = "IDBCursor", J(this, ["key", "primaryKey", "request"]), qr.__invalidStateIfDeleted(r), this.__indexSource = z(o, Mr), this.__indexSource && Mr.__invalidStateIfDeleted(o), Dt.__assertActive(r.transaction);
    var s = vt(e);
    if (void 0 !== t && !["next", "prev", "nextunique", "prevunique"].includes(t)) throw new TypeError(t + "is not a valid cursor direction");
    Object.defineProperties(this, {
      source: {
        writable: !1,
        value: o
      },
      direction: {
        writable: !1,
        value: t || "next"
      }
    }), this.__key = void 0, this.__primaryKey = void 0, this.__store = r, this.__range = s, this.__request = Te.__createInstance(), this.__request.__source = o, this.__request.__transaction = this.__store.transaction, this.__keyColumnName = n, this.__valueColumnName = a, this.__keyOnly = "key" === a, this.__valueDecoder = this.__keyOnly ? ht : jr, this.__count = i, this.__prefetchedIndex = -1, this.__multiEntryIndex = !!this.__indexSource && o.multiEntry, this.__unique = this.direction.includes("unique"), this.__sqlDirection = ["prev", "prevunique"].includes(this.direction) ? "DESC" : "ASC", void 0 !== s && (s.__lowerCached = void 0 !== s.lower && it(s.lower, this.__multiEntryIndex), s.__upperCached = void 0 !== s.upper && it(s.upper, this.__multiEntryIndex)), this.__gotValue = !0, this.continue();
  }, _o.__createInstance = function () {
    var e = vo.__super;
    e.prototype = vo.prototype;
    for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) r[o] = arguments[o];
    return l(e, r);
  }, _o.prototype.__find = function () {
    this.__multiEntryIndex ? this.__findMultiEntry.apply(this, arguments) : this.__findBasic.apply(this, arguments);
  }, _o.prototype.__findBasic = function (e, t, r, o, n, a) {
    var i = void 0 !== a;
    a = a || 1;
    var s = this,
      u = k(s.__keyColumnName),
      l = k("key"),
      c = ["SELECT * FROM", W(s.__store.__currentName)],
      p = [];
    c.push("WHERE", u, "NOT NULL"), _t(s.__range, u, c, p, !0, !0);
    var g = s.__sqlDirection,
      d = "ASC" === g ? ">" : "<";
    void 0 !== t && (c.push("AND", l, d + "= ?"), p.push(it(t))), void 0 !== e ? (c.push("AND", u, d + "= ?"), p.push(it(e))) : i && void 0 !== s.__key && (c.push("AND", u, d + " ?"), p.push(it(s.__key))), s.__count || (c.push("ORDER BY", u, g), "key" !== s.__keyColumnName && (s.__unique ? "prevunique" === s.direction && c.push(",", l, "ASC") : c.push(",", l, g)), !s.__unique && s.__indexSource && c.push(",", k(s.__valueColumnName), g), c.push("LIMIT", a)), c = c.join(" "), F.DEBUG && console.log(c, p), r.executeSql(c, p, function (e, t) {
      s.__count ? o(void 0, t.rows.length, void 0) : t.rows.length > 1 ? (s.__prefetchedIndex = 0, s.__prefetchedData = t.rows, F.DEBUG && console.log("Preloaded " + s.__prefetchedData.length + " records for cursor"), s.__decode(t.rows.item(0), o)) : 1 === t.rows.length ? s.__decode(t.rows.item(0), o) : (F.DEBUG && console.log("Reached end of cursors"), o(void 0, void 0, void 0));
    }, function (e, t) {
      F.DEBUG && console.log("Could not execute Cursor.continue", c, p), n(t);
    });
  };
  var Eo = /\[/g;
  function So() {
    throw new TypeError("Illegal constructor");
  }
  _o.prototype.__findMultiEntry = function (e, t, r, o, n) {
    var a = this;
    if (a.__prefetchedData && a.__prefetchedData.length === a.__prefetchedIndex) return F.DEBUG && console.log("Reached end of multiEntry cursor"), void o(void 0, void 0, void 0);
    var i = k(a.__keyColumnName),
      s = ["SELECT * FROM", W(a.__store.__currentName)],
      u = [];
    s.push("WHERE", i, "NOT NULL"), a.__range && void 0 !== a.__range.lower && Array.isArray(a.__range.upper) && 0 === a.__range.upper.indexOf(a.__range.lower) && (s.push("AND", i, "LIKE ? ESCAPE '^'"), u.push("%" + V(a.__range.__lowerCached.slice(0, -1)) + "%"));
    var l = a.__sqlDirection,
      c = "ASC" === l ? ">" : "<",
      p = k("key");
    void 0 !== t && (s.push("AND", p, c + "= ?"), u.push(it(t))), void 0 !== e ? (s.push("AND", i, c + "= ?"), u.push(it(e))) : void 0 !== a.__key && (s.push("AND", i, c + " ?"), u.push(it(a.__key))), a.__count || (s.push("ORDER BY", i, l), a.__unique || "key" === a.__keyColumnName || s.push(",", k("key"), l), !a.__unique && a.__indexSource && s.push(",", k(a.__valueColumnName), l)), s = s.join(" "), F.DEBUG && console.log(s, u), r.executeSql(s, u, function (e, t) {
      if (t.rows.length > 0) {
        if (a.__count) {
          for (var r = 0, n = 0; n < t.rows.length; n++) r += at(st(t.rows.item(n)[a.__keyColumnName], !0), a.__range).length;
          return void o(void 0, r, void 0);
        }
        for (var i = [], s = 0; s < t.rows.length; s++) {
          var u,
            l = t.rows.item(s),
            c = f(at(st(l[a.__keyColumnName], !0), a.__range));
          try {
            for (c.s(); !(u = c.n()).done;) {
              var p = {
                matchingKey: it(u.value, !0),
                key: l.key
              };
              p[a.__keyColumnName] = l[a.__keyColumnName], p[a.__valueColumnName] = l[a.__valueColumnName], i.push(p);
            }
          } catch (e) {
            c.e(e);
          } finally {
            c.f();
          }
        }
        var g = 0 === a.direction.indexOf("prev");
        i.sort(function (e, t) {
          return e.matchingKey.replace(Eo, "z") < t.matchingKey.replace(Eo, "z") ? g ? 1 : -1 : e.matchingKey.replace(Eo, "z") > t.matchingKey.replace(Eo, "z") ? g ? -1 : 1 : e.key < t.key ? "prev" === a.direction ? 1 : -1 : e.key > t.key ? "prev" === a.direction ? -1 : 1 : 0;
        }), i.length > 1 ? (a.__prefetchedIndex = 0, a.__prefetchedData = {
          data: i,
          length: i.length,
          item: function item(e) {
            return this.data[e];
          }
        }, F.DEBUG && console.log("Preloaded " + a.__prefetchedData.length + " records for multiEntry cursor"), a.__decode(i[0], o)) : 1 === i.length ? (F.DEBUG && console.log("Reached end of multiEntry cursor"), a.__decode(i[0], o)) : (F.DEBUG && console.log("Reached end of multiEntry cursor"), o(void 0, void 0, void 0));
      } else F.DEBUG && console.log("Reached end of multiEntry cursor"), o(void 0, void 0, void 0);
    }, function (e, t) {
      F.DEBUG && console.log("Could not execute Cursor.continue", s, u), n(t);
    });
  }, _o.prototype.__onsuccess = function (e) {
    var t = this;
    return function (r, o, n) {
      t.__count ? e(o, t.__request) : (void 0 !== r && (t.__gotValue = !0), t.__key = void 0 === r ? null : r, t.__primaryKey = void 0 === n ? null : n, t.__value = void 0 === o ? null : o, e(void 0 === r ? null : t, t.__request));
    };
  }, _o.prototype.__decode = function (e, t) {
    var r = this;
    if (r.__multiEntryIndex && r.__unique) {
      if (r.__matchedKeys || (r.__matchedKeys = {}), r.__matchedKeys[e.matchingKey]) return void t(void 0, void 0, void 0);
      r.__matchedKeys[e.matchingKey] = !0;
    }
    var o = L(r.__multiEntryIndex ? e.matchingKey : e[r.__keyColumnName]),
      n = L(e[r.__valueColumnName]),
      a = L(e.key);
    t(st(o, r.__multiEntryIndex), r.__valueDecoder.decode(n), st(a), o);
  }, _o.prototype.__sourceOrEffectiveObjStoreDeleted = function () {
    qr.__invalidStateIfDeleted(this.__store, "The cursor's effective object store has been deleted"), this.__indexSource && Mr.__invalidStateIfDeleted(this.source, "The cursor's index source has been deleted");
  }, _o.prototype.__invalidateCache = function () {
    this.__prefetchedData = null;
  }, _o.prototype.__continue = function (e, t) {
    var r = this,
      o = void 0 !== r.__advanceCount;
    if (Dt.__assertActive(r.__store.transaction), r.__sourceOrEffectiveObjStoreDeleted(), !r.__gotValue && !t) throw ve("InvalidStateError", "The cursor is being iterated or has iterated past its end.");
    if (void 0 !== e) {
      Je(e);
      var n = je(e, r.key);
      if (0 === n || r.direction.includes("next") && -1 === n || r.direction.includes("prev") && 1 === n) throw ve("DataError", "Cannot " + (o ? "advance" : "continue") + " the cursor in an unexpected direction");
    }
    this.__continueFinish(e, void 0, o);
  }, _o.prototype.__continueFinish = function (e, t, r) {
    var o = this,
      n = o.__advanceCount || F.cursorPreloadPackSize || 100;
    o.__gotValue = !1, o.__request.__done = !1, o.__store.transaction.__pushToQueue(o.__request, function a(i, s, u, l, c) {
      function p(e, t, n) {
        if (r) {
          if (o.__advanceCount >= 2 && void 0 !== e) return o.__advanceCount--, o.__key = e, o.__continue(void 0, !0), void c();
          o.__advanceCount = void 0;
        }
        o.__onsuccess(u)(e, t, n);
      }
      o.__prefetchedData && (o.__prefetchedIndex++, o.__prefetchedIndex < o.__prefetchedData.length) ? o.__decode(o.__prefetchedData.item(o.__prefetchedIndex), function (r, n, c, g) {
        var d;
        o.__unique && !o.__multiEntryIndex && g === it(o.key, o.__multiEntryIndex) || !((d = void 0 === e || je(r, e)) > 0 || 0 === d && (o.__unique || void 0 === t || je(c, t) >= 0)) ? a(i, s, u, l) : p(r, n, c);
      }) : o.__find(e, t, i, p, function () {
        o.__advanceCount = void 0, l.apply(void 0, arguments);
      }, n);
    });
  }, _o.prototype.continue = function () {
    this.__continue(arguments[0]);
  }, _o.prototype.continuePrimaryKey = function (e, t) {
    var r = this;
    if (Dt.__assertActive(r.__store.transaction), r.__sourceOrEffectiveObjStoreDeleted(), !r.__indexSource) throw ve("InvalidAccessError", "`continuePrimaryKey` may only be called on an index source.");
    if (!["next", "prev"].includes(r.direction)) throw ve("InvalidAccessError", "`continuePrimaryKey` may not be called with unique cursors.");
    if (!r.__gotValue) throw ve("InvalidStateError", "The cursor is being iterated or has iterated past its end.");
    Je(e), Je(t);
    var o = je(e, r.key);
    if ("next" === r.direction && -1 === o || "prev" === r.direction && 1 === o) throw ve("DataError", "Cannot continue the cursor in an unexpected direction");
    function n() {
      r.__continueFinish(e, t, !1);
    }
    0 === o ? Cr(t, function (e) {
      Cr(r.primaryKey, function (t) {
        if (e === t || "next" === r.direction && e < t || "prev" === r.direction && e > t) throw ve("DataError", "Cannot continue the cursor in an unexpected direction");
        n();
      });
    }) : n();
  }, _o.prototype.advance = function (e) {
    var t = this;
    if (0 === (e = re(e, "unsigned long"))) throw new TypeError("Calling advance() with count argument 0");
    t.__gotValue && (t.__advanceCount = e), t.__continue();
  }, _o.prototype.update = function (e) {
    var t = this;
    if (!arguments.length) throw new TypeError("A value must be passed to update()");
    if (Dt.__assertActive(t.__store.transaction), t.__store.transaction.__assertWritable(), t.__sourceOrEffectiveObjStoreDeleted(), !t.__gotValue) throw ve("InvalidStateError", "The cursor is being iterated or has iterated past its end.");
    if (t.__keyOnly) throw ve("InvalidStateError", "This cursor method cannot be called when the key only flag has been set.");
    var r = t.__store.transaction.__createRequest(t),
      o = t.primaryKey;
    function n(e) {
      qr.__storingRecordObjectStore(r, t.__store, !1, e, !1, o);
    }
    if (null !== t.__store.keyPath) {
      var a = c(t.__store.__validateKeyAndValueAndCloneValue(e, void 0, !0), 2),
        i = a[0],
        s = a[1];
      if (0 !== je(t.primaryKey, i)) throw ve("DataError", "The key of the supplied value to `update` is not equal to the cursor's effective key");
      n(s);
    } else n(Fr(e));
    return r;
  }, _o.prototype.delete = function () {
    var e = this;
    if (Dt.__assertActive(e.__store.transaction), e.__store.transaction.__assertWritable(), e.__sourceOrEffectiveObjStoreDeleted(), !e.__gotValue) throw ve("InvalidStateError", "The cursor is being iterated or has iterated past its end.");
    if (e.__keyOnly) throw ve("InvalidStateError", "This cursor method cannot be called when the key only flag has been set.");
    return this.__store.transaction.__addToTransactionQueue(function (t, r, o, n) {
      e.__find(void 0, void 0, t, function (r, a, i) {
        var s = "DELETE FROM  " + W(e.__store.__currentName) + ' WHERE "key" = ?';
        F.DEBUG && console.log(s, r, i), t.executeSql(s, [x(it(i))], function (e, t) {
          1 === t.rowsAffected ? o(void 0) : n("No rows with key found" + r);
        }, function (e, t) {
          n(t);
        });
      }, n);
    }, void 0, e);
  }, _o.prototype[Symbol.toStringTag] = "IDBCursorPrototype", Q(_o.prototype, ["source", "direction", "key", "primaryKey", "request"]), Object.defineProperty(_o, "prototype", {
    writable: !1
  }), So.prototype = Object.create(_o.prototype), Object.defineProperty(So.prototype, "constructor", {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: So
  });
  var Ro = So;
  function wo(t, r) {
    if (t && "object" === e(t)) Object.entries(t).forEach(function (e) {
      var t = c(e, 2);
      wo(t[0], t[1]);
    });else {
      if (!(t in F)) throw new Error(t + " is not a valid configuration property");
      F[t] = r, "registerSCA" === t && "function" == typeof r && Ir(r);
    }
  }
  So.__createInstance = function () {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
    function o() {
      var e;
      (e = _o.__super).call.apply(e, [this].concat(t)), this[Symbol.toStringTag] = "IDBCursorWithValue", J(this, "value");
    }
    return o.prototype = Ro.prototype, new o();
  }, Q(So.prototype, ["value"]), So.prototype[Symbol.toStringTag] = "IDBCursorWithValuePrototype", Object.defineProperty(So, "prototype", {
    writable: !1
  }), F.win = "undefined" != typeof window ? window : self, function (e, t) {
    t && wo(t);
    var r = e || ("undefined" != typeof window ? window : "undefined" != typeof self ? self : void 0 !== y ? y : {});
    function n(e, t, n) {
      if (!n || !Object.defineProperty) try {
        r[e] = t;
      } catch (e) {
        console.log(e);
      }
      if (r[e] !== t && Object.defineProperty) try {
        var a = n || {};
        if ("get" in a) {
          var i,
            s,
            u = (i = {}, (s = {})[e] = s[e] || {}, s[e].get = function () {
              return n.get.call(this);
            }, o(i, s), i);
          a = Object.getOwnPropertyDescriptor(u, e);
        } else "value" in a || (a.value = t), "writable" in a || (a.writable = !0);
        Object.defineProperty(r, e, a);
      } catch (e) {}
      r[e] !== t && "undefined" != typeof console && console.warn && console.warn("Unable to shim " + e);
    }
    void 0 !== F.win.openDatabase && n("shimIndexedDB", mo, {
      enumerable: !1,
      configurable: !0
    }), r.shimIndexedDB ? (r.shimIndexedDB.__useShim = function () {
      function e() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        n(e + "DOMException", Ee), n(e + "DOMStringList", Rt, {
          enumerable: !1,
          configurable: !0,
          writable: !0,
          value: Rt
        }), n(e + "Event", T, {
          configurable: !0,
          writable: !0,
          value: T,
          enumerable: !1
        }), n(e + "CustomEvent", P, {
          configurable: !0,
          writable: !0,
          value: P,
          enumerable: !1
        }), n(e + "EventTarget", O, {
          configurable: !0,
          writable: !0,
          value: O,
          enumerable: !1
        });
      }
      var t,
        o = yo;
      void 0 !== F.win.openDatabase && (mo.__openDatabase = F.win.openDatabase.bind(F.win), n("indexedDB", mo, {
        enumerable: !0,
        configurable: !0,
        get: function get() {
          if (this !== r && !ie(this) && !this.shimNS) throw new TypeError("Illegal invocation");
          return mo;
        }
      }), [["IDBFactory", o], ["IDBDatabase", eo], ["IDBObjectStore", qr], ["IDBIndex", Mr], ["IDBTransaction", Dt], ["IDBCursor", _o], ["IDBCursorWithValue", So], ["IDBKeyRange", yt], ["IDBRequest", Te], ["IDBOpenDBRequest", Ae], ["IDBVersionChangeEvent", le]].forEach(function (e) {
        var t = c(e, 2);
        n(t[0], t[1], {
          enumerable: !1,
          configurable: !0
        });
      }), F.fs && (t = F.fs, to = t), F.fullIDLSupport && (Object.setPrototypeOf(r.IDBOpenDBRequest, r.IDBRequest), Object.setPrototypeOf(r.IDBCursorWithValue, r.IDBCursor), Object.setPrototypeOf(eo, O), Object.setPrototypeOf(Te, O), Object.setPrototypeOf(Dt, O), Object.setPrototypeOf(le, T), Object.setPrototypeOf(Ee, Error), Object.setPrototypeOf(Ee.prototype, Error.prototype), Object.setPrototypeOf(P, T), Object.setPrototypeOf(P.prototype, T.prototype)), r.indexedDB && !r.indexedDB.toString().includes("[native code]") && (F.addNonIDBGlobals && e("Shim"), F.replaceNonIDBGlobals && e()), r.shimIndexedDB.__setConnectionQueueOrigin());
    }, r.shimIndexedDB.__debug = function (e) {
      F.DEBUG = e;
    }, r.shimIndexedDB.__setConfig = wo, r.shimIndexedDB.__getConfig = function (e) {
      if (!(e in F)) throw new Error(e + " is not a valid configuration property");
      return F[e];
    }, r.shimIndexedDB.__setUnicodeIdentifiers = function (e) {
      wo({
        UnicodeIDStart: e.UnicodeIDStart,
        UnicodeIDContinue: e.UnicodeIDContinue
      });
    }) : (r.shimIndexedDB = {}, ["__useShim", "__debug", "__setConfig", "__getConfig", "__setUnicodeIdentifiers"].forEach(function (e) {
      r.shimIndexedDB[e] = function () {
        console.warn("This browser does not have WebSQL to shim.");
      };
    })), "indexedDB" in r || "undefined" == typeof window || (r.indexedDB = r.indexedDB || r.webkitIndexedDB || r.mozIndexedDB || r.oIndexedDB || r.msIndexedDB);
    var a = !1;
    "undefined" != typeof navigator && navigator.userAgent && (/Android (?:2|3|4\.[0-3])/.test(navigator.userAgent) && !navigator.userAgent.includes("Chrome") || (!navigator.userAgent.includes("Safari") || navigator.userAgent.includes("Chrome")) && /(iPad|iPhone|iPod)(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])* o[s\u017F] 9_/i.test(navigator.userAgent) && !window.MSStream) && (a = !0), F.DEFAULT_DB_SIZE || (F.DEFAULT_DB_SIZE = 1024 * ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome") ? 25 : 4) * 1024), F.avoidAutoShim || r.indexedDB && !a || void 0 === F.win.openDatabase ? (r.IDBDatabase = r.IDBDatabase || r.webkitIDBDatabase, r.IDBTransaction = r.IDBTransaction || r.webkitIDBTransaction || {}, r.IDBCursor = r.IDBCursor || r.webkitIDBCursor, r.IDBKeyRange = r.IDBKeyRange || r.webkitIDBKeyRange) : r.shimIndexedDB.__useShim();
  }();
}();
var indexeddbshim_min = {},
  only = function only(e, t) {
    return e = e || {}, "string" == typeof t && (t = t.split(/ +/)), t.reduce(function (t, r) {
      return null == e[r] || (t[r] = e[r]), t;
    }, {});
  },
  getOwnPropertySymbols = Object.getOwnPropertySymbols,
  hasOwnProperty$1 = Object.prototype.hasOwnProperty,
  propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function shouldUseNative() {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
    for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var o = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      o[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
  } catch (e) {
    return !1;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (e, t) {
    for (var r, o, n = toObject(e), a = 1; a < arguments.length; a++) {
      for (var i in r = Object(arguments[a])) hasOwnProperty$1.call(r, i) && (n[i] = r[i]);
      if (getOwnPropertySymbols) {
        o = getOwnPropertySymbols(r);
        for (var s = 0; s < o.length; s++) propIsEnumerable.call(r, o[s]) && (n[o[s]] = r[o[s]]);
      }
    }
    return n;
  },
  curry2_1 = curry2;
/*!
 * exports.
 */
function curry2(e, t) {
  var r = function r() {
    return arguments.length > 1 ? e.call(t, arguments[0], arguments[1]) : e.bind(t, arguments[0]);
  };
  return r.uncurry = function () {
    return e;
  }, r;
}
/*!
 * imports.
 */
/*!
 * exports.
 */
var arrayConcat = curry2_1(last);
function last(e, t) {
  return e.concat(t);
}
var valueComparator = function valueComparator(e, t, r) {
    return 1 === r ? e > t : e < t;
  },
  has = function has(e, t) {
    return e.hasOwnProperty(t);
  },
  isArrayField = function isArrayField(e, t) {
    var r = has(e, t),
      o = Array.isArray(e[t]);
    if (r && !o) throw new Error("You can't use array update operator on non-array field");
    return r;
  },
  isEmptyValue = function isEmptyValue(e) {
    return !("object" == typeof e && null !== e && e) || 0 === Object.keys(e).length;
  },
  isPlainValue = function isPlainValue(e) {
    var t = typeof e;
    return "number" === t || "string" === t || "boolean" === t;
  },
  arraySlice = function arraySlice(e, t) {
    return t >= 0 ? e.slice(0, t) : e.slice(t);
  },
  noop = function noop() {},
  require$$0 = getAugmentedNamespace(dexie),
  dexie$1 = require$$0,
  comparsionQueryOperatorsImpl = {
    $eq: function $eq(e, t) {
      return function (r) {
        return has(r, e) && r[e] === t;
      };
    },
    $gt: function $gt(e, t) {
      return function (r) {
        return has(r, e) && r[e] > t;
      };
    },
    $gte: function $gte(e, t) {
      return function (r) {
        return has(r, e) && r[e] >= t;
      };
    },
    $lt: function $lt(e, t) {
      return function (r) {
        return has(r, e) && r[e] < t;
      };
    },
    $lte: function $lte(e, t) {
      return function (r) {
        return has(r, e) && r[e] <= t;
      };
    },
    $ne: function $ne(e, t) {
      return function (r) {
        return has(r, e) && r[e] !== t;
      };
    },
    $in: function $in(e, t) {
      return function (r) {
        return has(r, e) && t.indexOf(r[e]) > -1;
      };
    },
    $nin: function $nin(e, t) {
      return function (r) {
        return has(r, e) && -1 === t.indexOf(r[e]);
      };
    },
    $exists: function $exists(e, t) {
      return function (r) {
        return has(r, e) === t;
      };
    },
    $all: function $all(e, t) {
      return function (r) {
        return has(r, e) && t.every(function (t) {
          return r[e].indexOf(t) > -1;
        });
      };
    },
    $size: function $size(e, t) {
      return function (r) {
        return has(r, e) && r[e].length === t;
      };
    },
    $elemMatch: function $elemMatch(e, t) {
      var r = getQueryValueMatchers(e, t);
      return function (t) {
        return has(t, e) && t[e].some(function (t) {
          var o = {};
          return o[e] = t, r.every(function (e) {
            return e(o);
          });
        });
      };
    },
    $not: function $not(e, t) {
      var r = getQueryValueMatchers(e, t);
      return function (t) {
        return !has(t, e) || r.every(function (e) {
          return !e(t);
        });
      };
    }
  },
  logicalQueryOperatorsImpl = {
    $and: function $and(e, t) {
      var r = t.map(getMatcherSets).reduce(arrayConcat);
      return function (e) {
        return r.every(function (t) {
          return t(e);
        });
      };
    },
    $or: function $or(e, t) {
      var r = t.map(getMatcherSets);
      return function (e) {
        return r.some(function (t) {
          return t.every(function (t) {
            return t(e);
          });
        });
      };
    },
    $nor: function $nor(e, t) {
      var r = this.$and(e, t);
      return function (e) {
        return !r(e);
      };
    }
  },
  updateOperatorsImpl = {
    $inc: function $inc(e, t) {
      return createUpdateIterator(t, function (e, r) {
        has(r, e) && (r[e] += t[e]);
      });
    },
    $mul: function $mul(e, t) {
      return createUpdateIterator(t, function (e, r) {
        has(r, e) && (r[e] *= t[e]);
      });
    },
    $rename: function $rename(e, t) {
      return createUpdateIterator(t, function (e, r) {
        var o = r[e];
        delete r[e], r[t[e]] = o;
      });
    },
    $set: function $set(e, t) {
      return createUpdateIterator(t, function (e, r) {
        r[e] = t[e];
      });
    },
    $unset: function $unset(e, t) {
      return createUpdateIterator(t, function (e, t) {
        delete t[e];
      });
    },
    $min: function $min(e, t) {
      return createUpdateIterator(t, function (e, r) {
        r[e] = Math.min(r[e], t[e]);
      });
    },
    $max: function $max(e, t) {
      return createUpdateIterator(t, function (e, r) {
        r[e] = Math.max(r[e], t[e]);
      });
    },
    $addToSet: function $addToSet(e, t) {
      return createUpdateIterator(t, function (e, r) {
        isArrayField(r, e) ? -1 === r[e].indexOf(t[e]) && r[e].push(t[e]) : r[e] = [t[e]];
      });
    },
    $pop: function $pop(e, t) {
      return createUpdateIterator(t, function (e, r) {
        isArrayField(r, e), 1 === t[e] ? r[e].pop() : -1 === t[e] && r[e].shift();
      });
    },
    $push: function $push(e, t) {
      return createUpdateIterator(t, function (e, r) {
        isArrayField(r, e) ? r[e].push(t[e]) : r[e] = [t[e]];
      });
    },
    $pullAll: function $pullAll(e, t) {
      return createUpdateIterator(t, function (e, r) {
        isArrayField(r, e);
        var o = t[e];
        r[e] = r[e].filter(function (e) {
          return -1 === o.indexOf(e);
        });
      });
    },
    $pull: function $pull(e, t) {
      return createUpdateIterator(t, function (e, r) {
        isArrayField(r, e);
        var o = t[e];
        if (isPlainValue(o)) r[e] = r[e].filter(function (e) {
          return e !== o;
        });else {
          var n = getQueryValueMatchers(e, o);
          r[e] = r[e].filter(function (t) {
            var r = {};
            return r[e] = t, !n.some(function (e) {
              return e(r);
            });
          });
        }
      });
    },
    $slice: function $slice(e, t) {
      return createUpdateIterator(t, function (e, r) {
        isArrayField(r, e);
        var o = t[e];
        if (isPlainValue(o)) r[e] = arraySlice(r[e], o);else {
          var n = Object.keys(o);
          r[e] = r[e].map(function (e) {
            return n.reduce(function (e, t) {
              return e[t] = arraySlice(e[t], o[t]), e;
            }, e);
          });
        }
      });
    },
    $sort: function $sort(e, t) {
      return createUpdateIterator(t, function (e, r) {
        isArrayField(r, e);
        var o = t[e];
        if (isPlainValue(o)) r[e] = r[e].sort(function (e, t) {
          return valueComparator(e, t, o);
        });else {
          var n = r[e].slice();
          r[e] = Object.keys(o).reduce(function (e, t) {
            var r = o[t];
            return n.sort(function (e, o) {
              var n = e[t],
                a = o[t];
              return valueComparator(n, a, r);
            });
          }, r[e]);
        }
      });
    }
  },
  operators = {
    query: Object.keys(comparsionQueryOperatorsImpl),
    queryLogical: Object.keys(logicalQueryOperatorsImpl),
    update: Object.keys(updateOperatorsImpl)
  },
  supportedUpdateOptions = ["upsert"],
  supportedUpsertOperators = ["$set", "$addToSet", "$push"],
  getMatcherSets = function getMatcherSets(e) {
    return Object.keys(e).map(function (t) {
      return getQueryValueMatchers(t, e[t]);
    }).reduce(arrayConcat);
  },
  getQueryValueMatchers = function getQueryValueMatchers(e, t) {
    return Object.keys(t).map(function (r) {
      return getOperatorImplementation({
        key: e,
        type: r,
        value: t[r]
      });
    });
  },
  createPlainPropertyMatcher = function createPlainPropertyMatcher(e, t) {
    var r = t || Object.keys(e);
    return function (t) {
      return r.every(function (r) {
        return has(t, r) && t[r] === e[r];
      });
    };
  },
  createPlainPropertyUpdater = function createPlainPropertyUpdater(e, t) {
    var r = t || Object.keys(e);
    return function (t) {
      r.forEach(function (r) {
        has(t, r) && (t[r] = e[r]);
      });
    };
  },
  createUpdateIterator = function createUpdateIterator(e, t) {
    var r = Object.keys(e);
    return function (e) {
      r.forEach(function (r) {
        t(r, e);
      });
    };
  },
  createObjectForUpsert = function createObjectForUpsert(e, t) {
    var r = Object.keys(e).filter(function (e) {
        var t = has(comparsionQueryOperatorsImpl, e),
          r = has(logicalQueryOperatorsImpl, e);
        return !(t || r);
      }),
      o = only(e, r),
      n = supportedUpsertOperators.reduce(function (e, r) {
        var o = t[r];
        return objectAssign(e, o);
      }, {});
    return objectAssign(o, n);
  },
  chooseIndex = function chooseIndex(e, t) {
    var r = -1,
      o = -1,
      n = -1;
    return t.indexedKeys.forEach(function (e, t) {
      e.unique ? r = t : "number" == typeof e.value ? o = t : e.plain && (n = t);
    }), r > -1 ? t.indexedKeys[r] : o > -1 ? t.indexedKeys[o] : t.indexedKeys[n];
  },
  getQueryOperatorsFilters = function getQueryOperatorsFilters(e) {
    return e.queryOperators.advanced.map(function (e) {
      return e.operators.map(function (t) {
        return getOperatorImplementation({
          type: t,
          key: e.key,
          value: e.value[t]
        });
      });
    }).reduce(arrayConcat);
  },
  getPropertyUpdaters = function getPropertyUpdaters(e) {
    return e.updateOperators.advanced.map(function (e) {
      return getOperatorImplementation({
        type: e.key,
        key: null,
        value: e.value
      });
    });
  },
  createAdvancedOperatorsMatcher = function createAdvancedOperatorsMatcher(e) {
    var t = getQueryOperatorsFilters(e);
    return function (e) {
      return t.every(function (t) {
        return t(e);
      });
    };
  },
  createAdvancedPropertyUpdater = function createAdvancedPropertyUpdater(e) {
    var t = getPropertyUpdaters(e);
    return function (e) {
      t.forEach(function (t) {
        t(e);
      });
    };
  },
  getPlainKeys = function getPlainKeys(e) {
    return e.queryOperators.plain.map(function (e) {
      return e.key;
    });
  },
  executionPlans = {
    primaryKey: function primaryKey(e, t, r) {
      var o = t.primaryKey.key,
        n = t.primaryKey.value,
        a = r.where(o).equals(n);
      if (t.queryOperators.plain.length > 0) {
        var i = createPlainPropertyMatcher(e, getPlainKeys(t));
        a.and(i);
      }
      if (t.queryOperators.advanced.length > 0) {
        var s = createAdvancedOperatorsMatcher(t);
        a.and(s);
      }
      return a;
    },
    indexedProp: function indexedProp(e, t, r) {
      var o,
        n = chooseIndex(e, t);
      if (o = n && n.plain ? r.where(n.key).equals(n.value) : r.toCollection(), t.queryOperators.plain.length > 0) {
        var a = createPlainPropertyMatcher(e, getPlainKeys(t));
        o.and(a);
      }
      if (t.queryOperators.advanced.length > 0) {
        var i = createAdvancedOperatorsMatcher(t);
        o.and(i);
      }
      return o;
    },
    fullScan: function fullScan(e, t, r) {
      var o = r.toCollection();
      if (t.queryOperators.plain.length > 0) {
        var n = createPlainPropertyMatcher(e, getPlainKeys(t));
        o.and(n);
      }
      if (t.queryOperators.advanced.length > 0) {
        var a = createAdvancedOperatorsMatcher(t);
        o.and(a);
      }
      return o;
    }
  },
  createCollectionUpdater = function createCollectionUpdater(e, t) {
    var r = t.updateOperators.plain.length > 0,
      o = t.updateOperators.advanced.length > 0;
    return r && o ? noop : r ? createPlainPropertyUpdater(e, t.keys) : o ? createAdvancedPropertyUpdater(t) : void 0;
  },
  createInsertResult = function createInsertResult(e, t) {
    return {
      insertedCount: 1,
      insertedId: t.id,
      ops: [t.item],
      result: {
        ok: 1,
        n: 1
      }
    };
  },
  createUpdateResult = function createUpdateResult(e, t) {
    var r = t && !0 === t.isUpsert,
      o = r ? 0 : e;
    return {
      result: {
        ok: 1,
        nModified: o
      },
      modifiedCount: o,
      upsertedCount: r ? 1 : 0,
      upsertedId: r ? t.id : null
    };
  },
  createDeleteResult = function createDeleteResult(e) {
    return {
      result: {
        ok: 1,
        n: e
      },
      deletedCount: e
    };
  },
  createUpsertModifier = function createUpsertModifier(e, t, r) {
    return new dexie$1.Promise(function (o) {
      return e.update(t, r).then(function (o) {
        if (0 === o.modifiedCount) {
          var n = createObjectForUpsert(t, r);
          return e.insert(n);
        }
        return dexie$1.Promise.resolve(o);
      }).then(function (e) {
        var t = e;
        return "number" == typeof e.insertedId && (t = createUpdateResult(1, {
          isUpsert: !0,
          id: e.insertedId
        })), o(t);
      });
    });
  },
  createPlainModifier = function createPlainModifier(e, t, r) {
    var o = analyseUpdates(r),
      n = createCollectionUpdater(r, o);
    return e.find(t).modify(n).then(function (e) {
      return createUpdateResult(e, null);
    });
  },
  getOperatorImplementation = function getOperatorImplementation(e) {
    var t;
    return operators.query.indexOf(e.type) > -1 ? t = comparsionQueryOperatorsImpl : operators.queryLogical.indexOf(e.type) > -1 ? t = logicalQueryOperatorsImpl : operators.update.indexOf(e.type) > -1 && (t = updateOperatorsImpl), t[e.type](e.key, e.value);
  },
  getOperators = function getOperators(e, t, r) {
    return t.reduce(r(e, t), {
      plain: [],
      advanced: []
    });
  },
  createQueryOperatorsReducer = function createQueryOperatorsReducer(e) {
    return function (t, r) {
      var o = e[r],
        n = isPlainValue(o),
        a = operators.queryLogical.indexOf(r) > -1;
      if (n) t.plain.push({
        key: r,
        value: o,
        plain: n
      });else if (a) {
        var i = {};
        i[r] = o, t.advanced.push({
          key: r,
          value: i,
          plain: n,
          operators: [r]
        });
      } else t.advanced.push({
        key: r,
        value: o,
        plain: n,
        operators: Object.keys(o).filter(function (e) {
          return operators.query.indexOf(e) > -1;
        })
      });
      return t;
    };
  },
  createUpdateOperatorsReducer = function createUpdateOperatorsReducer(e) {
    return function (t, r) {
      var o = e[r],
        n = isPlainValue(o);
      return n ? t.plain.push({
        key: r,
        value: o,
        plain: n
      }) : t.advanced.push({
        key: r,
        value: o,
        plain: n
      }), t;
    };
  },
  getQueryOperators = function getQueryOperators(e, t) {
    return getOperators(e, t, createQueryOperatorsReducer);
  },
  getUpdateOperators = function getUpdateOperators(e, t) {
    return getOperators(e, t, createUpdateOperatorsReducer);
  },
  getQueryPrimaryKey = function getQueryPrimaryKey(e, t) {
    var r = t.primKey.keyPath,
      o = e[r],
      n = typeof o;
    return "number" === n || "string" === n ? {
      key: r,
      value: o
    } : {
      key: !1
    };
  },
  getQueryIndexedKeys = function getQueryIndexedKeys(e, t, r) {
    return r.indexes.filter(function (e) {
      return t.indexOf(e.keyPath) > -1;
    }).map(function (t) {
      var r = t.keyPath;
      return {
        key: r,
        value: e[r],
        unique: t.unique,
        plain: isPlainValue(e[r])
      };
    });
  },
  analyseQuery = function analyseQuery(e, t) {
    var r = Object.keys(e);
    return {
      keys: r,
      queryOperators: getQueryOperators(e, r),
      primaryKey: getQueryPrimaryKey(e, t),
      indexedKeys: getQueryIndexedKeys(e, r, t)
    };
  },
  analyseUpdates = function analyseUpdates(e) {
    var t = Object.keys(e);
    return {
      keys: t,
      updateOperators: getUpdateOperators(e, t)
    };
  },
  analyseUpdateOptions = function analyseUpdateOptions(e) {
    return isEmptyValue(e) ? {} : only(e, supportedUpdateOptions);
  },
  chooseExecutuionPlan = function chooseExecutuionPlan(e, t) {
    var r,
      o = analyseQuery(e, t);
    return r = o.primaryKey.key ? "primaryKey" : o.indexedKeys.length > 0 ? "indexedProp" : "fullScan", {
      queryAnalysis: o,
      execute: executionPlans[r]
    };
  },
  performCollectionUpdate = function performCollectionUpdate(e, t, r, o) {
    return (!0 === o.upsert ? createUpsertModifier : createPlainModifier)(e, t, r);
  },
  performFind = function performFind(e, t) {
    if (isEmptyValue(t)) return e.toCollection();
    var r = chooseExecutuionPlan(t, e.schema);
    return r.execute(t, r.queryAnalysis, e);
  },
  performInsert = function performInsert(e, t) {
    var r = e.schema.primKey.keyPath;
    return e.add(t).then(function (e) {
      return only(t, Object.keys(t))[r] = e, createInsertResult(1, {
        item: t,
        id: e
      });
    });
  },
  performRemove = function performRemove(e, t) {
    return performFind(e, t).delete().then(createDeleteResult);
  },
  performDrop = function performDrop(e) {
    return e.toCollection().delete().then(createDeleteResult);
  };
dexie$1 = dexie$1.default || dexie$1, dexie$1.addons.push(function (e) {
  dexie$1.prototype.collection = function (t) {
    return e.table(t);
  }, e.Table.prototype.count = function (e) {
    return (isEmptyValue(e) ? this.toCollection() : performFind(this, e)).count();
  }, e.Table.prototype.find = function (e) {
    return performFind(this, e);
  }, e.Table.prototype.findOne = function (e) {
    return performFind(this, e).first();
  }, e.Table.prototype.insert = function (e) {
    return performInsert(this, e);
  }, e.Table.prototype.remove = function (e) {
    return performRemove(this, e);
  }, e.Table.prototype.drop = function () {
    return performDrop(this);
  }, (e.WriteableTable ? e.WriteableTable : e.Table).prototype.update = function (e, t, r) {
    var o = analyseUpdateOptions(r);
    return performCollectionUpdate(this, e, t, o);
  };
});
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
var uri_all = createCommonjsModule(function (e, t) {
    !function (e) {
      function t() {
        for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
        if (t.length > 1) {
          t[0] = t[0].slice(0, -1);
          for (var o = t.length - 1, n = 1; n < o; ++n) t[n] = t[n].slice(1, -1);
          return t[o] = t[o].slice(1), t.join("");
        }
        return t[0];
      }
      function r(e) {
        return "(?:" + e + ")";
      }
      function o(e) {
        return void 0 === e ? "undefined" : null === e ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
      }
      function n(e) {
        return e.toUpperCase();
      }
      function a(e) {
        return null != e ? e instanceof Array ? e : "number" != typeof e.length || e.split || e.setInterval || e.call ? [e] : Array.prototype.slice.call(e) : [];
      }
      function i(e, t) {
        var r = e;
        if (t) for (var o in t) r[o] = t[o];
        return r;
      }
      function s(e) {
        var o = "[A-Za-z]",
          n = "[0-9]",
          a = t(n, "[A-Fa-f]"),
          i = r(r("%[EFef]" + a + "%" + a + a + "%" + a + a) + "|" + r("%[89A-Fa-f]" + a + "%" + a + a) + "|" + r("%" + a + a)),
          s = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
          u = t("[\\:\\/\\?\\#\\[\\]\\@]", s),
          l = e ? "[\\uE000-\\uF8FF]" : "[]",
          c = t(o, n, "[\\-\\.\\_\\~]", e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]");
        r(o + t(o, n, "[\\+\\-\\.]") + "*"), r(r(i + "|" + t(c, s, "[\\:]")) + "*");
        var p = r(r("25[0-5]") + "|" + r("2[0-4]" + n) + "|" + r("1" + n + n) + "|" + r("0?[1-9]" + n) + "|0?0?" + n),
          g = r(p + "\\." + p + "\\." + p + "\\." + p),
          d = r(a + "{1,4}"),
          f = r(r(d + "\\:" + d) + "|" + g),
          h = r(r(d + "\\:") + "{6}" + f),
          y = r("\\:\\:" + r(d + "\\:") + "{5}" + f),
          b = r(r(d) + "?\\:\\:" + r(d + "\\:") + "{4}" + f),
          m = r(r(r(d + "\\:") + "{0,1}" + d) + "?\\:\\:" + r(d + "\\:") + "{3}" + f),
          _ = r(r(r(d + "\\:") + "{0,2}" + d) + "?\\:\\:" + r(d + "\\:") + "{2}" + f),
          v = r(r(r(d + "\\:") + "{0,3}" + d) + "?\\:\\:" + d + "\\:" + f),
          E = r(r(r(d + "\\:") + "{0,4}" + d) + "?\\:\\:" + f),
          S = r(r(r(d + "\\:") + "{0,5}" + d) + "?\\:\\:" + d),
          R = r(r(r(d + "\\:") + "{0,6}" + d) + "?\\:\\:"),
          w = r([h, y, b, m, _, v, E, S, R].join("|")),
          T = r(r(c + "|" + i) + "+");
        r("[vV]" + a + "+\\." + t(c, s, "[\\:]") + "+"), r(r(i + "|" + t(c, s)) + "*");
        var P = r(i + "|" + t(c, s, "[\\:\\@]"));
        return r(r(i + "|" + t(c, s, "[\\@]")) + "+"), r(r(P + "|" + t("[\\/\\?]", l)) + "*"), {
          NOT_SCHEME: new RegExp(t("[^]", o, n, "[\\+\\-\\.]"), "g"),
          NOT_USERINFO: new RegExp(t("[^\\%\\:]", c, s), "g"),
          NOT_HOST: new RegExp(t("[^\\%\\[\\]\\:]", c, s), "g"),
          NOT_PATH: new RegExp(t("[^\\%\\/\\:\\@]", c, s), "g"),
          NOT_PATH_NOSCHEME: new RegExp(t("[^\\%\\/\\@]", c, s), "g"),
          NOT_QUERY: new RegExp(t("[^\\%]", c, s, "[\\:\\@\\/\\?]", l), "g"),
          NOT_FRAGMENT: new RegExp(t("[^\\%]", c, s, "[\\:\\@\\/\\?]"), "g"),
          ESCAPE: new RegExp(t("[^]", c, s), "g"),
          UNRESERVED: new RegExp(c, "g"),
          OTHER_CHARS: new RegExp(t("[^\\%]", c, u), "g"),
          PCT_ENCODED: new RegExp(i, "g"),
          IPV4ADDRESS: new RegExp("^(" + g + ")$"),
          IPV6ADDRESS: new RegExp("^\\[?(" + w + ")" + r(r("\\%25|\\%(?!" + a + "{2})") + "(" + T + ")") + "?\\]?$")
        };
      }
      var u = s(!1),
        l = s(!0),
        c = function () {
          function e(e, t) {
            var r = [],
              o = !0,
              n = !1,
              a = void 0;
            try {
              for (var i, s = e[Symbol.iterator](); !(o = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
            } catch (e) {
              n = !0, a = e;
            } finally {
              try {
                !o && s.return && s.return();
              } finally {
                if (n) throw a;
              }
            }
            return r;
          }
          return function (t, r) {
            if (Array.isArray(t)) return t;
            if (Symbol.iterator in Object(t)) return e(t, r);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          };
        }(),
        p = function p(e) {
          if (Array.isArray(e)) {
            for (var t = 0, r = Array(e.length); t < e.length; t++) r[t] = e[t];
            return r;
          }
          return Array.from(e);
        },
        g = 2147483647,
        d = 36,
        f = 1,
        h = 26,
        y = 38,
        b = 700,
        m = 72,
        _ = 128,
        v = "-",
        E = /^xn--/,
        S = /[^\0-\x7E]/,
        R = /[\x2E\u3002\uFF0E\uFF61]/g,
        w = {
          overflow: "Overflow: input needs wider integers to process",
          "not-basic": "Illegal input >= 0x80 (not a basic code point)",
          "invalid-input": "Invalid input"
        },
        T = d - f,
        P = Math.floor,
        A = String.fromCharCode;
      function D(e) {
        throw new RangeError(w[e]);
      }
      function O(e, t) {
        for (var r = [], o = e.length; o--;) r[o] = t(e[o]);
        return r;
      }
      function I(e, t) {
        var r = e.split("@"),
          o = "";
        return r.length > 1 && (o = r[0] + "@", e = r[1]), o + O((e = e.replace(R, ".")).split("."), t).join(".");
      }
      function C(e) {
        for (var t = [], r = 0, o = e.length; r < o;) {
          var n = e.charCodeAt(r++);
          if (n >= 55296 && n <= 56319 && r < o) {
            var a = e.charCodeAt(r++);
            56320 == (64512 & a) ? t.push(((1023 & n) << 10) + (1023 & a) + 65536) : (t.push(n), r--);
          } else t.push(n);
        }
        return t;
      }
      var B = function B(e) {
          return e - 48 < 10 ? e - 22 : e - 65 < 26 ? e - 65 : e - 97 < 26 ? e - 97 : d;
        },
        F = function F(e, t) {
          return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
        },
        j = function j(e, t, r) {
          var o = 0;
          for (e = r ? P(e / b) : e >> 1, e += P(e / t); e > T * h >> 1; o += d) e = P(e / T);
          return P(o + (T + 1) * e / (e + y));
        },
        N = function N(e) {
          var t = [],
            r = e.length,
            o = 0,
            n = _,
            a = m,
            i = e.lastIndexOf(v);
          i < 0 && (i = 0);
          for (var s = 0; s < i; ++s) e.charCodeAt(s) >= 128 && D("not-basic"), t.push(e.charCodeAt(s));
          for (var u = i > 0 ? i + 1 : 0; u < r;) {
            for (var l = o, c = 1, p = d;; p += d) {
              u >= r && D("invalid-input");
              var y = B(e.charCodeAt(u++));
              (y >= d || y > P((g - o) / c)) && D("overflow"), o += y * c;
              var b = p <= a ? f : p >= a + h ? h : p - a;
              if (y < b) break;
              var E = d - b;
              c > P(g / E) && D("overflow"), c *= E;
            }
            var S = t.length + 1;
            a = j(o - l, S, 0 == l), P(o / S) > g - n && D("overflow"), n += P(o / S), o %= S, t.splice(o++, 0, n);
          }
          return String.fromCodePoint.apply(String, t);
        },
        M = function M(e) {
          var t = [],
            r = (e = C(e)).length,
            o = _,
            n = 0,
            a = m,
            i = !0,
            s = !1,
            u = void 0;
          try {
            for (var l, c = e[Symbol.iterator](); !(i = (l = c.next()).done); i = !0) {
              var p = l.value;
              p < 128 && t.push(A(p));
            }
          } catch (e) {
            s = !0, u = e;
          } finally {
            try {
              !i && c.return && c.return();
            } finally {
              if (s) throw u;
            }
          }
          var y = t.length,
            b = y;
          for (y && t.push(v); b < r;) {
            var E = g,
              S = !0,
              R = !1,
              w = void 0;
            try {
              for (var T, O = e[Symbol.iterator](); !(S = (T = O.next()).done); S = !0) {
                var I = T.value;
                I >= o && I < E && (E = I);
              }
            } catch (e) {
              R = !0, w = e;
            } finally {
              try {
                !S && O.return && O.return();
              } finally {
                if (R) throw w;
              }
            }
            var B = b + 1;
            E - o > P((g - n) / B) && D("overflow"), n += (E - o) * B, o = E;
            var N = !0,
              M = !1,
              x = void 0;
            try {
              for (var L, U = e[Symbol.iterator](); !(N = (L = U.next()).done); N = !0) {
                var k = L.value;
                if (k < o && ++n > g && D("overflow"), k == o) {
                  for (var q = n, W = d;; W += d) {
                    var H = W <= a ? f : W >= a + h ? h : W - a;
                    if (q < H) break;
                    var G = q - H,
                      V = d - H;
                    t.push(A(F(H + G % V, 0))), q = P(G / V);
                  }
                  t.push(A(F(q, 0))), a = j(n, B, b == y), n = 0, ++b;
                }
              }
            } catch (e) {
              M = !0, x = e;
            } finally {
              try {
                !N && U.return && U.return();
              } finally {
                if (M) throw x;
              }
            }
            ++n, ++o;
          }
          return t.join("");
        },
        x = function x(e) {
          return I(e, function (e) {
            return E.test(e) ? N(e.slice(4).toLowerCase()) : e;
          });
        },
        L = function L(e) {
          return I(e, function (e) {
            return S.test(e) ? "xn--" + M(e) : e;
          });
        },
        U = {
          version: "2.1.0",
          ucs2: {
            decode: C,
            encode: function encode(e) {
              return String.fromCodePoint.apply(String, p(e));
            }
          },
          decode: N,
          encode: M,
          toASCII: L,
          toUnicode: x
        },
        k = {};
      function q(e) {
        var t = e.charCodeAt(0);
        return t < 16 ? "%0" + t.toString(16).toUpperCase() : t < 128 ? "%" + t.toString(16).toUpperCase() : t < 2048 ? "%" + (t >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase() : "%" + (t >> 12 | 224).toString(16).toUpperCase() + "%" + (t >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase();
      }
      function W(e) {
        for (var t = "", r = 0, o = e.length; r < o;) {
          var n = parseInt(e.substr(r + 1, 2), 16);
          if (n < 128) t += String.fromCharCode(n), r += 3;else if (n >= 194 && n < 224) {
            if (o - r >= 6) {
              var a = parseInt(e.substr(r + 4, 2), 16);
              t += String.fromCharCode((31 & n) << 6 | 63 & a);
            } else t += e.substr(r, 6);
            r += 6;
          } else if (n >= 224) {
            if (o - r >= 9) {
              var i = parseInt(e.substr(r + 4, 2), 16),
                s = parseInt(e.substr(r + 7, 2), 16);
              t += String.fromCharCode((15 & n) << 12 | (63 & i) << 6 | 63 & s);
            } else t += e.substr(r, 9);
            r += 9;
          } else t += e.substr(r, 3), r += 3;
        }
        return t;
      }
      function H(e, t) {
        function r(e) {
          var r = W(e);
          return r.match(t.UNRESERVED) ? r : e;
        }
        return e.scheme && (e.scheme = String(e.scheme).replace(t.PCT_ENCODED, r).toLowerCase().replace(t.NOT_SCHEME, "")), void 0 !== e.userinfo && (e.userinfo = String(e.userinfo).replace(t.PCT_ENCODED, r).replace(t.NOT_USERINFO, q).replace(t.PCT_ENCODED, n)), void 0 !== e.host && (e.host = String(e.host).replace(t.PCT_ENCODED, r).toLowerCase().replace(t.NOT_HOST, q).replace(t.PCT_ENCODED, n)), void 0 !== e.path && (e.path = String(e.path).replace(t.PCT_ENCODED, r).replace(e.scheme ? t.NOT_PATH : t.NOT_PATH_NOSCHEME, q).replace(t.PCT_ENCODED, n)), void 0 !== e.query && (e.query = String(e.query).replace(t.PCT_ENCODED, r).replace(t.NOT_QUERY, q).replace(t.PCT_ENCODED, n)), void 0 !== e.fragment && (e.fragment = String(e.fragment).replace(t.PCT_ENCODED, r).replace(t.NOT_FRAGMENT, q).replace(t.PCT_ENCODED, n)), e;
      }
      function G(e) {
        return e.replace(/^0*(.*)/, "$1") || "0";
      }
      function V(e, t) {
        var r = e.match(t.IPV4ADDRESS) || [],
          o = c(r, 2)[1];
        return o ? o.split(".").map(G).join(".") : e;
      }
      function z(e, t) {
        var r = e.match(t.IPV6ADDRESS) || [],
          o = c(r, 3),
          n = o[1],
          a = o[2];
        if (n) {
          for (var i = n.toLowerCase().split("::").reverse(), s = c(i, 2), u = s[0], l = s[1], p = l ? l.split(":").map(G) : [], g = u.split(":").map(G), d = t.IPV4ADDRESS.test(g[g.length - 1]), f = d ? 7 : 8, h = g.length - f, y = Array(f), b = 0; b < f; ++b) y[b] = p[b] || g[h + b] || "";
          d && (y[f - 1] = V(y[f - 1], t));
          var m = y.reduce(function (e, t, r) {
              if (!t || "0" === t) {
                var o = e[e.length - 1];
                o && o.index + o.length === r ? o.length++ : e.push({
                  index: r,
                  length: 1
                });
              }
              return e;
            }, []).sort(function (e, t) {
              return t.length - e.length;
            })[0],
            _ = void 0;
          if (m && m.length > 1) {
            var v = y.slice(0, m.index),
              E = y.slice(m.index + m.length);
            _ = v.join(":") + "::" + E.join(":");
          } else _ = y.join(":");
          return a && (_ += "%" + a), _;
        }
        return e;
      }
      var K = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i,
        $ = void 0 === "".match(/(){0}/)[1];
      function Y(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = {},
          o = !1 !== t.iri ? l : u;
        "suffix" === t.reference && (e = (t.scheme ? t.scheme + ":" : "") + "//" + e);
        var n = e.match(K);
        if (n) {
          $ ? (r.scheme = n[1], r.userinfo = n[3], r.host = n[4], r.port = parseInt(n[5], 10), r.path = n[6] || "", r.query = n[7], r.fragment = n[8], isNaN(r.port) && (r.port = n[5])) : (r.scheme = n[1] || void 0, r.userinfo = -1 !== e.indexOf("@") ? n[3] : void 0, r.host = -1 !== e.indexOf("//") ? n[4] : void 0, r.port = parseInt(n[5], 10), r.path = n[6] || "", r.query = -1 !== e.indexOf("?") ? n[7] : void 0, r.fragment = -1 !== e.indexOf("#") ? n[8] : void 0, isNaN(r.port) && (r.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? n[4] : void 0)), r.host && (r.host = z(V(r.host, o), o)), void 0 !== r.scheme || void 0 !== r.userinfo || void 0 !== r.host || void 0 !== r.port || r.path || void 0 !== r.query ? void 0 === r.scheme ? r.reference = "relative" : void 0 === r.fragment ? r.reference = "absolute" : r.reference = "uri" : r.reference = "same-document", t.reference && "suffix" !== t.reference && t.reference !== r.reference && (r.error = r.error || "URI is not a " + t.reference + " reference.");
          var a = k[(t.scheme || r.scheme || "").toLowerCase()];
          if (t.unicodeSupport || a && a.unicodeSupport) H(r, o);else {
            if (r.host && (t.domainHost || a && a.domainHost)) try {
              r.host = U.toASCII(r.host.replace(o.PCT_ENCODED, W).toLowerCase());
            } catch (e) {
              r.error = r.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
            }
            H(r, u);
          }
          a && a.parse && a.parse(r, t);
        } else r.error = r.error || "URI can not be parsed.";
        return r;
      }
      function Q(e, t) {
        var r = !1 !== t.iri ? l : u,
          o = [];
        return void 0 !== e.userinfo && (o.push(e.userinfo), o.push("@")), void 0 !== e.host && o.push(z(V(String(e.host), r), r).replace(r.IPV6ADDRESS, function (e, t, r) {
          return "[" + t + (r ? "%25" + r : "") + "]";
        })), "number" != typeof e.port && "string" != typeof e.port || (o.push(":"), o.push(String(e.port))), o.length ? o.join("") : void 0;
      }
      var X = /^\.\.?\//,
        J = /^\/\.(\/|$)/,
        Z = /^\/\.\.(\/|$)/,
        ee = /^\/?(?:.|\n)*?(?=\/|$)/;
      function te(e) {
        for (var t = []; e.length;) if (e.match(X)) e = e.replace(X, "");else if (e.match(J)) e = e.replace(J, "/");else if (e.match(Z)) e = e.replace(Z, "/"), t.pop();else if ("." === e || ".." === e) e = "";else {
          var r = e.match(ee);
          if (!r) throw new Error("Unexpected dot segment condition");
          var o = r[0];
          e = e.slice(o.length), t.push(o);
        }
        return t.join("");
      }
      function re(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.iri ? l : u,
          o = [],
          n = k[(t.scheme || e.scheme || "").toLowerCase()];
        if (n && n.serialize && n.serialize(e, t), e.host) if (r.IPV6ADDRESS.test(e.host)) ;else if (t.domainHost || n && n.domainHost) try {
          e.host = t.iri ? U.toUnicode(e.host) : U.toASCII(e.host.replace(r.PCT_ENCODED, W).toLowerCase());
        } catch (r) {
          e.error = e.error || "Host's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + r;
        }
        H(e, r), "suffix" !== t.reference && e.scheme && (o.push(e.scheme), o.push(":"));
        var a = Q(e, t);
        if (void 0 !== a && ("suffix" !== t.reference && o.push("//"), o.push(a), e.path && "/" !== e.path.charAt(0) && o.push("/")), void 0 !== e.path) {
          var i = e.path;
          t.absolutePath || n && n.absolutePath || (i = te(i)), void 0 === a && (i = i.replace(/^\/\//, "/%2F")), o.push(i);
        }
        return void 0 !== e.query && (o.push("?"), o.push(e.query)), void 0 !== e.fragment && (o.push("#"), o.push(e.fragment)), o.join("");
      }
      function oe(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = {};
        return arguments[3] || (e = Y(re(e, r), r), t = Y(re(t, r), r)), !(r = r || {}).tolerant && t.scheme ? (o.scheme = t.scheme, o.userinfo = t.userinfo, o.host = t.host, o.port = t.port, o.path = te(t.path || ""), o.query = t.query) : (void 0 !== t.userinfo || void 0 !== t.host || void 0 !== t.port ? (o.userinfo = t.userinfo, o.host = t.host, o.port = t.port, o.path = te(t.path || ""), o.query = t.query) : (t.path ? ("/" === t.path.charAt(0) ? o.path = te(t.path) : (void 0 === e.userinfo && void 0 === e.host && void 0 === e.port || e.path ? e.path ? o.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path : o.path = t.path : o.path = "/" + t.path, o.path = te(o.path)), o.query = t.query) : (o.path = e.path, void 0 !== t.query ? o.query = t.query : o.query = e.query), o.userinfo = e.userinfo, o.host = e.host, o.port = e.port), o.scheme = e.scheme), o.fragment = t.fragment, o;
      }
      function ne(e, t, r) {
        var o = i({
          scheme: "null"
        }, r);
        return re(oe(Y(e, o), Y(t, o), o, !0), o);
      }
      function ae(e, t) {
        return "string" == typeof e ? e = re(Y(e, t), t) : "object" === o(e) && (e = Y(re(e, t), t)), e;
      }
      function ie(e, t, r) {
        return "string" == typeof e ? e = re(Y(e, r), r) : "object" === o(e) && (e = re(e, r)), "string" == typeof t ? t = re(Y(t, r), r) : "object" === o(t) && (t = re(t, r)), e === t;
      }
      function se(e, t) {
        return e && e.toString().replace(t && t.iri ? l.ESCAPE : u.ESCAPE, q);
      }
      function ue(e, t) {
        return e && e.toString().replace(t && t.iri ? l.PCT_ENCODED : u.PCT_ENCODED, W);
      }
      var le = {
          scheme: "http",
          domainHost: !0,
          parse: function parse(e, t) {
            return e.host || (e.error = e.error || "HTTP URIs must have a host."), e;
          },
          serialize: function serialize(e, t) {
            var r = "https" === String(e.scheme).toLowerCase();
            return e.port !== (r ? 443 : 80) && "" !== e.port || (e.port = void 0), e.path || (e.path = "/"), e;
          }
        },
        ce = {
          scheme: "https",
          domainHost: le.domainHost,
          parse: le.parse,
          serialize: le.serialize
        };
      function pe(e) {
        return "boolean" == typeof e.secure ? e.secure : "wss" === String(e.scheme).toLowerCase();
      }
      var ge = {
          scheme: "ws",
          domainHost: !0,
          parse: function parse(e, t) {
            var r = e;
            return r.secure = pe(r), r.resourceName = (r.path || "/") + (r.query ? "?" + r.query : ""), r.path = void 0, r.query = void 0, r;
          },
          serialize: function serialize(e, t) {
            if (e.port !== (pe(e) ? 443 : 80) && "" !== e.port || (e.port = void 0), "boolean" == typeof e.secure && (e.scheme = e.secure ? "wss" : "ws", e.secure = void 0), e.resourceName) {
              var r = e.resourceName.split("?"),
                o = c(r, 2),
                n = o[0],
                a = o[1];
              e.path = n && "/" !== n ? n : void 0, e.query = a, e.resourceName = void 0;
            }
            return e.fragment = void 0, e;
          }
        },
        de = {
          scheme: "wss",
          domainHost: ge.domainHost,
          parse: ge.parse,
          serialize: ge.serialize
        },
        fe = {},
        he = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]",
        ye = "[0-9A-Fa-f]",
        be = r(r("%[EFef]" + ye + "%" + ye + ye + "%" + ye + ye) + "|" + r("%[89A-Fa-f]" + ye + "%" + ye + ye) + "|" + r("%" + ye + ye)),
        me = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]",
        _e = t("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'),
        ve = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]",
        Ee = new RegExp(he, "g"),
        Se = new RegExp(be, "g"),
        Re = new RegExp(t("[^]", me, "[\\.]", '[\\"]', _e), "g"),
        we = new RegExp(t("[^]", he, ve), "g"),
        Te = we;
      function Pe(e) {
        var t = W(e);
        return t.match(Ee) ? t : e;
      }
      var Ae = {
          scheme: "mailto",
          parse: function parse(e, t) {
            var r = e,
              o = r.to = r.path ? r.path.split(",") : [];
            if (r.path = void 0, r.query) {
              for (var n = !1, a = {}, i = r.query.split("&"), s = 0, u = i.length; s < u; ++s) {
                var l = i[s].split("=");
                switch (l[0]) {
                  case "to":
                    for (var c = l[1].split(","), p = 0, g = c.length; p < g; ++p) o.push(c[p]);
                    break;
                  case "subject":
                    r.subject = ue(l[1], t);
                    break;
                  case "body":
                    r.body = ue(l[1], t);
                    break;
                  default:
                    n = !0, a[ue(l[0], t)] = ue(l[1], t);
                }
              }
              n && (r.headers = a);
            }
            r.query = void 0;
            for (var d = 0, f = o.length; d < f; ++d) {
              var h = o[d].split("@");
              if (h[0] = ue(h[0]), t.unicodeSupport) h[1] = ue(h[1], t).toLowerCase();else try {
                h[1] = U.toASCII(ue(h[1], t).toLowerCase());
              } catch (e) {
                r.error = r.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
              }
              o[d] = h.join("@");
            }
            return r;
          },
          serialize: function serialize(e, t) {
            var r = e,
              o = a(e.to);
            if (o) {
              for (var i = 0, s = o.length; i < s; ++i) {
                var u = String(o[i]),
                  l = u.lastIndexOf("@"),
                  c = u.slice(0, l).replace(Se, Pe).replace(Se, n).replace(Re, q),
                  p = u.slice(l + 1);
                try {
                  p = t.iri ? U.toUnicode(p) : U.toASCII(ue(p, t).toLowerCase());
                } catch (e) {
                  r.error = r.error || "Email address's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + e;
                }
                o[i] = c + "@" + p;
              }
              r.path = o.join(",");
            }
            var g = e.headers = e.headers || {};
            e.subject && (g.subject = e.subject), e.body && (g.body = e.body);
            var d = [];
            for (var f in g) g[f] !== fe[f] && d.push(f.replace(Se, Pe).replace(Se, n).replace(we, q) + "=" + g[f].replace(Se, Pe).replace(Se, n).replace(Te, q));
            return d.length && (r.query = d.join("&")), r;
          }
        },
        De = /^([^\:]+)\:(.*)/,
        Oe = {
          scheme: "urn",
          parse: function parse(e, t) {
            var r = e.path && e.path.match(De),
              o = e;
            if (r) {
              var n = t.scheme || o.scheme || "urn",
                a = r[1].toLowerCase(),
                i = r[2],
                s = n + ":" + (t.nid || a),
                u = k[s];
              o.nid = a, o.nss = i, o.path = void 0, u && (o = u.parse(o, t));
            } else o.error = o.error || "URN can not be parsed.";
            return o;
          },
          serialize: function serialize(e, t) {
            var r = t.scheme || e.scheme || "urn",
              o = e.nid,
              n = r + ":" + (t.nid || o),
              a = k[n];
            a && (e = a.serialize(e, t));
            var i = e,
              s = e.nss;
            return i.path = (o || t.nid) + ":" + s, i;
          }
        },
        Ie = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/,
        Ce = {
          scheme: "urn:uuid",
          parse: function parse(e, t) {
            var r = e;
            return r.uuid = r.nss, r.nss = void 0, t.tolerant || r.uuid && r.uuid.match(Ie) || (r.error = r.error || "UUID is not valid."), r;
          },
          serialize: function serialize(e, t) {
            var r = e;
            return r.nss = (e.uuid || "").toLowerCase(), r;
          }
        };
      k[le.scheme] = le, k[ce.scheme] = ce, k[ge.scheme] = ge, k[de.scheme] = de, k[Ae.scheme] = Ae, k[Oe.scheme] = Oe, k[Ce.scheme] = Ce, e.SCHEMES = k, e.pctEncChar = q, e.pctDecChars = W, e.parse = Y, e.removeDotSegments = te, e.serialize = re, e.resolveComponents = oe, e.resolve = ne, e.normalize = ae, e.equal = ie, e.escapeComponent = se, e.unescapeComponent = ue, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }(t);
  }),
  fastDeepEqual = function e(t, r) {
    if (t === r) return !0;
    if (t && r && "object" == typeof t && "object" == typeof r) {
      if (t.constructor !== r.constructor) return !1;
      var o, n, a;
      if (Array.isArray(t)) {
        if ((o = t.length) != r.length) return !1;
        for (n = o; 0 != n--;) if (!e(t[n], r[n])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
      if ((o = (a = Object.keys(t)).length) !== Object.keys(r).length) return !1;
      for (n = o; 0 != n--;) if (!Object.prototype.hasOwnProperty.call(r, a[n])) return !1;
      for (n = o; 0 != n--;) {
        var i = a[n];
        if (!e(t[i], r[i])) return !1;
      }
      return !0;
    }
    return t != t && r != r;
  },
  ucs2length = function ucs2length(e) {
    for (var t, r = 0, o = e.length, n = 0; n < o;) r++, (t = e.charCodeAt(n++)) >= 55296 && t <= 56319 && n < o && 56320 == (64512 & (t = e.charCodeAt(n))) && n++;
    return r;
  },
  util = {
    copy: copy,
    checkDataType: checkDataType,
    checkDataTypes: checkDataTypes,
    coerceToTypes: coerceToTypes,
    toHash: toHash,
    getProperty: getProperty,
    escapeQuotes: escapeQuotes,
    equal: fastDeepEqual,
    ucs2length: ucs2length,
    varOccurences: varOccurences,
    varReplace: varReplace,
    schemaHasRules: schemaHasRules,
    schemaHasRulesExcept: schemaHasRulesExcept,
    schemaUnknownRules: schemaUnknownRules,
    toQuotedString: toQuotedString,
    getPathExpr: getPathExpr,
    getPath: getPath,
    getData: getData,
    unescapeFragment: unescapeFragment,
    unescapeJsonPointer: unescapeJsonPointer,
    escapeFragment: escapeFragment,
    escapeJsonPointer: escapeJsonPointer
  };
function copy(e, t) {
  for (var r in t = t || {}, e) t[r] = e[r];
  return t;
}
function checkDataType(e, t, r, o) {
  var n = o ? " !== " : " === ",
    a = o ? " || " : " && ",
    i = o ? "!" : "",
    s = o ? "" : "!";
  switch (e) {
    case "null":
      return t + n + "null";
    case "array":
      return i + "Array.isArray(" + t + ")";
    case "object":
      return "(" + i + t + a + "typeof " + t + n + '"object"' + a + s + "Array.isArray(" + t + "))";
    case "integer":
      return "(typeof " + t + n + '"number"' + a + s + "(" + t + " % 1)" + a + t + n + t + (r ? a + i + "isFinite(" + t + ")" : "") + ")";
    case "number":
      return "(typeof " + t + n + '"' + e + '"' + (r ? a + i + "isFinite(" + t + ")" : "") + ")";
    default:
      return "typeof " + t + n + '"' + e + '"';
  }
}
function checkDataTypes(e, t, r) {
  switch (e.length) {
    case 1:
      return checkDataType(e[0], t, r, !0);
    default:
      var o = "",
        n = toHash(e);
      for (var a in n.array && n.object && (o = n.null ? "(" : "(!" + t + " || ", o += "typeof " + t + ' !== "object")', delete n.null, delete n.array, delete n.object), n.number && delete n.integer, n) o += (o ? " && " : "") + checkDataType(a, t, r, !0);
      return o;
  }
}
var COERCE_TO_TYPES = toHash(["string", "number", "integer", "boolean", "null"]);
function coerceToTypes(e, t) {
  if (Array.isArray(t)) {
    for (var r = [], o = 0; o < t.length; o++) {
      var n = t[o];
      (COERCE_TO_TYPES[n] || "array" === e && "array" === n) && (r[r.length] = n);
    }
    if (r.length) return r;
  } else {
    if (COERCE_TO_TYPES[t]) return [t];
    if ("array" === e && "array" === t) return ["array"];
  }
}
function toHash(e) {
  for (var t = {}, r = 0; r < e.length; r++) t[e[r]] = !0;
  return t;
}
var IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i,
  SINGLE_QUOTE = /'|\\/g;
function getProperty(e) {
  return "number" == typeof e ? "[" + e + "]" : IDENTIFIER.test(e) ? "." + e : "['" + escapeQuotes(e) + "']";
}
function escapeQuotes(e) {
  return e.replace(SINGLE_QUOTE, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
}
function varOccurences(e, t) {
  t += "[^0-9]";
  var r = e.match(new RegExp(t, "g"));
  return r ? r.length : 0;
}
function varReplace(e, t, r) {
  return t += "([^0-9])", r = r.replace(/\$/g, "$$$$"), e.replace(new RegExp(t, "g"), r + "$1");
}
function schemaHasRules(e, t) {
  if ("boolean" == typeof e) return !e;
  for (var r in e) if (t[r]) return !0;
}
function schemaHasRulesExcept(e, t, r) {
  if ("boolean" == typeof e) return !e && "not" != r;
  for (var o in e) if (o != r && t[o]) return !0;
}
function schemaUnknownRules(e, t) {
  if ("boolean" != typeof e) for (var r in e) if (!t[r]) return r;
}
function toQuotedString(e) {
  return "'" + escapeQuotes(e) + "'";
}
function getPathExpr(e, t, r, o) {
  return joinPaths(e, r ? "'/' + " + t + (o ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : o ? "'[' + " + t + " + ']'" : "'[\\'' + " + t + " + '\\']'");
}
function getPath(e, t, r) {
  return joinPaths(e, toQuotedString(r ? "/" + escapeJsonPointer(t) : getProperty(t)));
}
var JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/,
  RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData(e, t, r) {
  var o, n, a, i;
  if ("" === e) return "rootData";
  if ("/" == e[0]) {
    if (!JSON_POINTER.test(e)) throw new Error("Invalid JSON-pointer: " + e);
    n = e, a = "rootData";
  } else {
    if (!(i = e.match(RELATIVE_JSON_POINTER))) throw new Error("Invalid JSON-pointer: " + e);
    if (o = +i[1], "#" == (n = i[2])) {
      if (o >= t) throw new Error("Cannot access property/index " + o + " levels up, current level is " + t);
      return r[t - o];
    }
    if (o > t) throw new Error("Cannot access data " + o + " levels up, current level is " + t);
    if (a = "data" + (t - o || ""), !n) return a;
  }
  for (var s = a, u = n.split("/"), l = 0; l < u.length; l++) {
    var c = u[l];
    c && (s += " && " + (a += getProperty(unescapeJsonPointer(c))));
  }
  return s;
}
function joinPaths(e, t) {
  return '""' == e ? t : (e + " + " + t).replace(/([^\\])' \+ '/g, "$1");
}
function unescapeFragment(e) {
  return unescapeJsonPointer(decodeURIComponent(e));
}
function escapeFragment(e) {
  return encodeURIComponent(escapeJsonPointer(e));
}
function escapeJsonPointer(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function unescapeJsonPointer(e) {
  return e.replace(/~1/g, "/").replace(/~0/g, "~");
}
var schema_obj = SchemaObject;
function SchemaObject(e) {
  util.copy(e, this);
}
var jsonSchemaTraverse = createCommonjsModule(function (e) {
    var t = e.exports = function (e, t, o) {
      "function" == typeof t && (o = t, t = {}), r(t, "function" == typeof (o = t.cb || o) ? o : o.pre || function () {}, o.post || function () {}, e, "", e);
    };
    function r(e, o, n, a, i, s, u, l, c, p) {
      if (a && "object" == typeof a && !Array.isArray(a)) {
        for (var g in o(a, i, s, u, l, c, p), a) {
          var d = a[g];
          if (Array.isArray(d)) {
            if (g in t.arrayKeywords) for (var f = 0; f < d.length; f++) r(e, o, n, d[f], i + "/" + g + "/" + f, s, i, g, a, f);
          } else if (g in t.propsKeywords) {
            if (d && "object" == typeof d) for (var h in d) r(e, o, n, d[h], i + "/" + g + "/" + h.replace(/~/g, "~0").replace(/\//g, "~1"), s, i, g, a, h);
          } else (g in t.keywords || e.allKeys && !(g in t.skipKeywords)) && r(e, o, n, d, i + "/" + g, s, i, g, a);
        }
        n(a, i, s, u, l, c, p);
      }
    }
    t.keywords = {
      additionalItems: !0,
      items: !0,
      contains: !0,
      additionalProperties: !0,
      propertyNames: !0,
      not: !0
    }, t.arrayKeywords = {
      items: !0,
      allOf: !0,
      anyOf: !0,
      oneOf: !0
    }, t.propsKeywords = {
      definitions: !0,
      properties: !0,
      patternProperties: !0,
      dependencies: !0
    }, t.skipKeywords = {
      default: !0,
      enum: !0,
      const: !0,
      required: !0,
      maximum: !0,
      minimum: !0,
      exclusiveMaximum: !0,
      exclusiveMinimum: !0,
      multipleOf: !0,
      maxLength: !0,
      minLength: !0,
      pattern: !0,
      format: !0,
      maxItems: !0,
      minItems: !0,
      uniqueItems: !0,
      maxProperties: !0,
      minProperties: !0
    };
  }),
  resolve_1 = resolve;
function resolve(e, t, r) {
  var o = this._refs[r];
  if ("string" == typeof o) {
    if (!this._refs[o]) return resolve.call(this, e, t, o);
    o = this._refs[o];
  }
  if ((o = o || this._schemas[r]) instanceof schema_obj) return inlineRef(o.schema, this._opts.inlineRefs) ? o.schema : o.validate || this._compile(o);
  var n,
    a,
    i,
    s = resolveSchema.call(this, t, r);
  return s && (n = s.schema, t = s.root, i = s.baseId), n instanceof schema_obj ? a = n.validate || e.call(this, n.schema, t, void 0, i) : void 0 !== n && (a = inlineRef(n, this._opts.inlineRefs) ? n : e.call(this, n, t, void 0, i)), a;
}
function resolveSchema(e, t) {
  var r = uri_all.parse(t),
    o = _getFullPath(r),
    n = getFullPath(this._getId(e.schema));
  if (0 === Object.keys(e.schema).length || o !== n) {
    var a = normalizeId(o),
      i = this._refs[a];
    if ("string" == typeof i) return resolveRecursive.call(this, e, i, r);
    if (i instanceof schema_obj) i.validate || this._compile(i), e = i;else {
      if (!((i = this._schemas[a]) instanceof schema_obj)) return;
      if (i.validate || this._compile(i), a == normalizeId(t)) return {
        schema: i,
        root: e,
        baseId: n
      };
      e = i;
    }
    if (!e.schema) return;
    n = getFullPath(this._getId(e.schema));
  }
  return getJsonPointer.call(this, r, n, e.schema, e);
}
function resolveRecursive(e, t, r) {
  var o = resolveSchema.call(this, e, t);
  if (o) {
    var n = o.schema,
      a = o.baseId;
    e = o.root;
    var i = this._getId(n);
    return i && (a = resolveUrl(a, i)), getJsonPointer.call(this, r, a, n, e);
  }
}
resolve.normalizeId = normalizeId, resolve.fullPath = getFullPath, resolve.url = resolveUrl, resolve.ids = resolveIds, resolve.inlineRef = inlineRef, resolve.schema = resolveSchema;
var PREVENT_SCOPE_CHANGE = util.toHash(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
function getJsonPointer(e, t, r, o) {
  if (e.fragment = e.fragment || "", "/" == e.fragment.slice(0, 1)) {
    for (var n = e.fragment.split("/"), a = 1; a < n.length; a++) {
      var i = n[a];
      if (i) {
        if (void 0 === (r = r[i = util.unescapeFragment(i)])) break;
        var s;
        if (!PREVENT_SCOPE_CHANGE[i] && ((s = this._getId(r)) && (t = resolveUrl(t, s)), r.$ref)) {
          var u = resolveUrl(t, r.$ref),
            l = resolveSchema.call(this, o, u);
          l && (r = l.schema, o = l.root, t = l.baseId);
        }
      }
    }
    return void 0 !== r && r !== o.schema ? {
      schema: r,
      root: o,
      baseId: t
    } : void 0;
  }
}
var SIMPLE_INLINED = util.toHash(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum"]);
function inlineRef(e, t) {
  return !1 !== t && (void 0 === t || !0 === t ? checkNoRef(e) : t ? countKeys(e) <= t : void 0);
}
function checkNoRef(e) {
  var t;
  if (Array.isArray(e)) {
    for (var r = 0; r < e.length; r++) if ("object" == typeof (t = e[r]) && !checkNoRef(t)) return !1;
  } else for (var o in e) {
    if ("$ref" == o) return !1;
    if ("object" == typeof (t = e[o]) && !checkNoRef(t)) return !1;
  }
  return !0;
}
function countKeys(e) {
  var t,
    r = 0;
  if (Array.isArray(e)) {
    for (var o = 0; o < e.length; o++) if ("object" == typeof (t = e[o]) && (r += countKeys(t)), r == 1 / 0) return 1 / 0;
  } else for (var n in e) {
    if ("$ref" == n) return 1 / 0;
    if (SIMPLE_INLINED[n]) r++;else if ("object" == typeof (t = e[n]) && (r += countKeys(t) + 1), r == 1 / 0) return 1 / 0;
  }
  return r;
}
function getFullPath(e, t) {
  return !1 !== t && (e = normalizeId(e)), _getFullPath(uri_all.parse(e));
}
function _getFullPath(e) {
  return uri_all.serialize(e).split("#")[0] + "#";
}
var TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(e) {
  return e ? e.replace(TRAILING_SLASH_HASH, "") : "";
}
function resolveUrl(e, t) {
  return t = normalizeId(t), uri_all.resolve(e, t);
}
function resolveIds(e) {
  var t = normalizeId(this._getId(e)),
    r = {
      "": t
    },
    o = {
      "": getFullPath(t, !1)
    },
    n = {},
    a = this;
  return jsonSchemaTraverse(e, {
    allKeys: !0
  }, function (e, t, i, s, u, l, c) {
    if ("" !== t) {
      var p = a._getId(e),
        g = r[s],
        d = o[s] + "/" + u;
      if (void 0 !== c && (d += "/" + ("number" == typeof c ? c : util.escapeFragment(c))), "string" == typeof p) {
        p = g = normalizeId(g ? uri_all.resolve(g, p) : p);
        var f = a._refs[p];
        if ("string" == typeof f && (f = a._refs[f]), f && f.schema) {
          if (!fastDeepEqual(e, f.schema)) throw new Error('id "' + p + '" resolves to more than one schema');
        } else if (p != normalizeId(d)) if ("#" == p[0]) {
          if (n[p] && !fastDeepEqual(e, n[p])) throw new Error('id "' + p + '" resolves to more than one schema');
          n[p] = e;
        } else a._refs[p] = d;
      }
      r[t] = g, o[t] = d;
    }
  }), n;
}
var error_classes = {
  Validation: errorSubclass(ValidationError),
  MissingRef: errorSubclass(MissingRefError)
};
function ValidationError(e) {
  this.message = "validation failed", this.errors = e, this.ajv = this.validation = !0;
}
function MissingRefError(e, t, r) {
  this.message = r || MissingRefError.message(e, t), this.missingRef = resolve_1.url(e, t), this.missingSchema = resolve_1.normalizeId(resolve_1.fullPath(this.missingRef));
}
function errorSubclass(e) {
  return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
MissingRefError.message = function (e, t) {
  return "can't resolve reference " + t + " from id " + e;
};
var fastJsonStableStringify = function fastJsonStableStringify(e, t) {
    t || (t = {}), "function" == typeof t && (t = {
      cmp: t
    });
    var r,
      o = "boolean" == typeof t.cycles && t.cycles,
      n = t.cmp && (r = t.cmp, function (e) {
        return function (t, o) {
          var n = {
              key: t,
              value: e[t]
            },
            a = {
              key: o,
              value: e[o]
            };
          return r(n, a);
        };
      }),
      a = [];
    return function e(t) {
      if (t && t.toJSON && "function" == typeof t.toJSON && (t = t.toJSON()), void 0 !== t) {
        if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
        if ("object" != typeof t) return JSON.stringify(t);
        var r, i;
        if (Array.isArray(t)) {
          for (i = "[", r = 0; r < t.length; r++) r && (i += ","), i += e(t[r]) || "null";
          return i + "]";
        }
        if (null === t) return "null";
        if (-1 !== a.indexOf(t)) {
          if (o) return JSON.stringify("__cycle__");
          throw new TypeError("Converting circular structure to JSON");
        }
        var s = a.push(t) - 1,
          u = Object.keys(t).sort(n && n(t));
        for (i = "", r = 0; r < u.length; r++) {
          var l = u[r],
            c = e(t[l]);
          c && (i && (i += ","), i += JSON.stringify(l) + ":" + c);
        }
        return a.splice(s, 1), "{" + i + "}";
      }
    }(e);
  },
  validate$1 = function validate$1(e, t, r) {
    var o = "",
      n = !0 === e.schema.$async,
      a = e.util.schemaHasRulesExcept(e.schema, e.RULES.all, "$ref"),
      i = e.self._getId(e.schema);
    if (e.opts.strictKeywords) {
      var s = e.util.schemaUnknownRules(e.schema, e.RULES.keywords);
      if (s) {
        var u = "unknown keyword: " + s;
        if ("log" !== e.opts.strictKeywords) throw new Error(u);
        e.logger.warn(u);
      }
    }
    if (e.isTop && (o += " var validate = ", n && (e.async = !0, o += "async "), o += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", i && (e.opts.sourceCode || e.opts.processCode) && (o += " /*# sourceURL=" + i + " */ ")), "boolean" == typeof e.schema || !a && !e.schema.$ref) {
      t = "false schema";
      var l = e.level,
        c = e.dataLevel,
        p = e.schema[t],
        g = e.schemaPath + e.util.getProperty(t),
        d = e.errSchemaPath + "/" + t,
        f = !e.opts.allErrors,
        h = "data" + (c || ""),
        y = "valid" + l;
      if (!1 === e.schema) {
        e.isTop ? f = !0 : o += " var " + y + " = false; ", (Q = Q || []).push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: {} ", !1 !== e.opts.messages && (o += " , message: 'boolean schema is false' "), e.opts.verbose && (o += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), o += " } ") : o += " {} ";
        var b = o;
        o = Q.pop(), !e.compositeRule && f ? e.async ? o += " throw new ValidationError([" + b + "]); " : o += " validate.errors = [" + b + "]; return false; " : o += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      } else e.isTop ? o += n ? " return data; " : " validate.errors = null; return true; " : o += " var " + y + " = true; ";
      return e.isTop && (o += " }; return validate; "), o;
    }
    if (e.isTop) {
      var m = e.isTop;
      l = e.level = 0, c = e.dataLevel = 0, h = "data";
      if (e.rootId = e.resolve.fullPath(e.self._getId(e.root.schema)), e.baseId = e.baseId || e.rootId, delete e.isTop, e.dataPathArr = [""], void 0 !== e.schema.default && e.opts.useDefaults && e.opts.strictDefaults) {
        var _ = "default is ignored in the schema root";
        if ("log" !== e.opts.strictDefaults) throw new Error(_);
        e.logger.warn(_);
      }
      o += " var vErrors = null; ", o += " var errors = 0;     ", o += " if (rootData === undefined) rootData = data; ";
    } else {
      l = e.level, h = "data" + ((c = e.dataLevel) || "");
      if (i && (e.baseId = e.resolve.url(e.baseId, i)), n && !e.async) throw new Error("async schema in sync schema");
      o += " var errs_" + l + " = errors;";
    }
    y = "valid" + l, f = !e.opts.allErrors;
    var v = "",
      E = "",
      S = e.schema.type,
      R = Array.isArray(S);
    if (S && e.opts.nullable && !0 === e.schema.nullable && (R ? -1 == S.indexOf("null") && (S = S.concat("null")) : "null" != S && (S = [S, "null"], R = !0)), R && 1 == S.length && (S = S[0], R = !1), e.schema.$ref && a) {
      if ("fail" == e.opts.extendRefs) throw new Error('$ref: validation keywords used in schema at path "' + e.errSchemaPath + '" (see option extendRefs)');
      !0 !== e.opts.extendRefs && (a = !1, e.logger.warn('$ref: keywords ignored in schema at path "' + e.errSchemaPath + '"'));
    }
    if (e.schema.$comment && e.opts.$comment && (o += " " + e.RULES.all.$comment.code(e, "$comment")), S) {
      if (e.opts.coerceTypes) var w = e.util.coerceToTypes(e.opts.coerceTypes, S);
      var T = e.RULES.types[S];
      if (w || R || !0 === T || T && !X(T)) {
        g = e.schemaPath + ".type", d = e.errSchemaPath + "/type", g = e.schemaPath + ".type", d = e.errSchemaPath + "/type";
        var P = R ? "checkDataTypes" : "checkDataType";
        if (o += " if (" + e.util[P](S, h, e.opts.strictNumbers, !0) + ") { ", w) {
          var A = "dataType" + l,
            D = "coerced" + l;
          o += " var " + A + " = typeof " + h + "; var " + D + " = undefined; ", "array" == e.opts.coerceTypes && (o += " if (" + A + " == 'object' && Array.isArray(" + h + ") && " + h + ".length == 1) { " + h + " = " + h + "[0]; " + A + " = typeof " + h + "; if (" + e.util.checkDataType(e.schema.type, h, e.opts.strictNumbers) + ") " + D + " = " + h + "; } "), o += " if (" + D + " !== undefined) ; ";
          var O = w;
          if (O) for (var I, C = -1, B = O.length - 1; C < B;) "string" == (I = O[C += 1]) ? o += " else if (" + A + " == 'number' || " + A + " == 'boolean') " + D + " = '' + " + h + "; else if (" + h + " === null) " + D + " = ''; " : "number" == I || "integer" == I ? (o += " else if (" + A + " == 'boolean' || " + h + " === null || (" + A + " == 'string' && " + h + " && " + h + " == +" + h + " ", "integer" == I && (o += " && !(" + h + " % 1)"), o += ")) " + D + " = +" + h + "; ") : "boolean" == I ? o += " else if (" + h + " === 'false' || " + h + " === 0 || " + h + " === null) " + D + " = false; else if (" + h + " === 'true' || " + h + " === 1) " + D + " = true; " : "null" == I ? o += " else if (" + h + " === '' || " + h + " === 0 || " + h + " === false) " + D + " = null; " : "array" == e.opts.coerceTypes && "array" == I && (o += " else if (" + A + " == 'string' || " + A + " == 'number' || " + A + " == 'boolean' || " + h + " == null) " + D + " = [" + h + "]; ");
          o += " else {   ", (Q = Q || []).push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'type' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { type: '", o += R ? "" + S.join(",") : "" + S, o += "' } ", !1 !== e.opts.messages && (o += " , message: 'should be ", o += R ? "" + S.join(",") : "" + S, o += "' "), e.opts.verbose && (o += " , schema: validate.schema" + g + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), o += " } ") : o += " {} ";
          b = o;
          o = Q.pop(), !e.compositeRule && f ? e.async ? o += " throw new ValidationError([" + b + "]); " : o += " validate.errors = [" + b + "]; return false; " : o += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } if (" + D + " !== undefined) {  ";
          var F = c ? "data" + (c - 1 || "") : "parentData";
          o += " " + h + " = " + D + "; ", c || (o += "if (" + F + " !== undefined)"), o += " " + F + "[" + (c ? e.dataPathArr[c] : "parentDataProperty") + "] = " + D + "; } ";
        } else {
          (Q = Q || []).push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'type' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { type: '", o += R ? "" + S.join(",") : "" + S, o += "' } ", !1 !== e.opts.messages && (o += " , message: 'should be ", o += R ? "" + S.join(",") : "" + S, o += "' "), e.opts.verbose && (o += " , schema: validate.schema" + g + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), o += " } ") : o += " {} ";
          b = o;
          o = Q.pop(), !e.compositeRule && f ? e.async ? o += " throw new ValidationError([" + b + "]); " : o += " validate.errors = [" + b + "]; return false; " : o += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
        o += " } ";
      }
    }
    if (e.schema.$ref && !a) o += " " + e.RULES.all.$ref.code(e, "$ref") + " ", f && (o += " } if (errors === ", o += m ? "0" : "errs_" + l, o += ") { ", E += "}");else {
      var j = e.RULES;
      if (j) for (var N = -1, M = j.length - 1; N < M;) if (X(T = j[N += 1])) {
        if (T.type && (o += " if (" + e.util.checkDataType(T.type, h, e.opts.strictNumbers) + ") { "), e.opts.useDefaults) if ("object" == T.type && e.schema.properties) {
          p = e.schema.properties;
          var x = Object.keys(p);
          if (x) for (var L, U = -1, k = x.length - 1; U < k;) {
            if (void 0 !== (H = p[L = x[U += 1]]).default) {
              var q = h + e.util.getProperty(L);
              if (e.compositeRule) {
                if (e.opts.strictDefaults) {
                  _ = "default is ignored for: " + q;
                  if ("log" !== e.opts.strictDefaults) throw new Error(_);
                  e.logger.warn(_);
                }
              } else o += " if (" + q + " === undefined ", "empty" == e.opts.useDefaults && (o += " || " + q + " === null || " + q + " === '' "), o += " ) " + q + " = ", "shared" == e.opts.useDefaults ? o += " " + e.useDefault(H.default) + " " : o += " " + JSON.stringify(H.default) + " ", o += "; ";
            }
          }
        } else if ("array" == T.type && Array.isArray(e.schema.items)) {
          var W = e.schema.items;
          if (W) {
            C = -1;
            for (var H, G = W.length - 1; C < G;) if (void 0 !== (H = W[C += 1]).default) {
              q = h + "[" + C + "]";
              if (e.compositeRule) {
                if (e.opts.strictDefaults) {
                  _ = "default is ignored for: " + q;
                  if ("log" !== e.opts.strictDefaults) throw new Error(_);
                  e.logger.warn(_);
                }
              } else o += " if (" + q + " === undefined ", "empty" == e.opts.useDefaults && (o += " || " + q + " === null || " + q + " === '' "), o += " ) " + q + " = ", "shared" == e.opts.useDefaults ? o += " " + e.useDefault(H.default) + " " : o += " " + JSON.stringify(H.default) + " ", o += "; ";
            }
          }
        }
        var V = T.rules;
        if (V) for (var z, K = -1, $ = V.length - 1; K < $;) if (J(z = V[K += 1])) {
          var Y = z.code(e, z.keyword, T.type);
          Y && (o += " " + Y + " ", f && (v += "}"));
        }
        if (f && (o += " " + v + " ", v = ""), T.type && (o += " } ", S && S === T.type && !w)) {
          o += " else { ";
          var Q;
          g = e.schemaPath + ".type", d = e.errSchemaPath + "/type";
          (Q = Q || []).push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'type' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { type: '", o += R ? "" + S.join(",") : "" + S, o += "' } ", !1 !== e.opts.messages && (o += " , message: 'should be ", o += R ? "" + S.join(",") : "" + S, o += "' "), e.opts.verbose && (o += " , schema: validate.schema" + g + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), o += " } ") : o += " {} ";
          b = o;
          o = Q.pop(), !e.compositeRule && f ? e.async ? o += " throw new ValidationError([" + b + "]); " : o += " validate.errors = [" + b + "]; return false; " : o += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } ";
        }
        f && (o += " if (errors === ", o += m ? "0" : "errs_" + l, o += ") { ", E += "}");
      }
    }
    function X(e) {
      for (var t = e.rules, r = 0; r < t.length; r++) if (J(t[r])) return !0;
    }
    function J(t) {
      return void 0 !== e.schema[t.keyword] || t.implements && function (t) {
        for (var r = t.implements, o = 0; o < r.length; o++) if (void 0 !== e.schema[r[o]]) return !0;
      }(t);
    }
    return f && (o += " " + E + " "), m ? (n ? (o += " if (errors === 0) return data;           ", o += " else throw new ValidationError(vErrors); ") : (o += " validate.errors = vErrors; ", o += " return errors === 0;       "), o += " }; return validate;") : o += " var " + y + " = errors === errs_" + l + ";", o;
  },
  ucs2length$1 = util.ucs2length,
  ValidationError$1 = error_classes.Validation,
  compile_1 = compile;
function compile(e, t, r, o) {
  var n = this,
    a = this._opts,
    i = [void 0],
    s = {},
    u = [],
    l = {},
    c = [],
    p = {},
    g = [];
  t = t || {
    schema: e,
    refVal: i,
    refs: s
  };
  var d = checkCompiling.call(this, e, t, o),
    f = this._compilations[d.index];
  if (d.compiling) return f.callValidate = function e() {
    var t = f.validate,
      r = t.apply(this, arguments);
    return e.errors = t.errors, r;
  };
  var h = this._formats,
    y = this.RULES;
  try {
    var b = _(e, t, r, o);
    f.validate = b;
    var m = f.callValidate;
    return m && (m.schema = b.schema, m.errors = null, m.refs = b.refs, m.refVal = b.refVal, m.root = b.root, m.$async = b.$async, a.sourceCode && (m.source = b.source)), b;
  } finally {
    endCompiling.call(this, e, t, o);
  }
  function _(e, r, o, l) {
    var p = !r || r && r.schema == e;
    if (r.schema != t.schema) return compile.call(n, e, r, o, l);
    var d,
      f = !0 === e.$async,
      b = validate$1({
        isTop: !0,
        schema: e,
        isRoot: p,
        baseId: l,
        root: r,
        schemaPath: "",
        errSchemaPath: "#",
        errorPath: '""',
        MissingRefError: error_classes.MissingRef,
        RULES: y,
        validate: validate$1,
        util: util,
        resolve: resolve_1,
        resolveRef: v,
        usePattern: R,
        useDefault: w,
        useCustomRule: T,
        opts: a,
        formats: h,
        logger: n.logger,
        self: n
      });
    b = vars(i, refValCode) + vars(u, patternCode) + vars(c, defaultCode) + vars(g, customRuleCode) + b, a.processCode && (b = a.processCode(b, e));
    try {
      d = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", b)(n, y, h, t, i, c, g, fastDeepEqual, ucs2length$1, ValidationError$1), i[0] = d;
    } catch (e) {
      throw n.logger.error("Error compiling schema, function code:", b), e;
    }
    return d.schema = e, d.errors = null, d.refs = s, d.refVal = i, d.root = p ? d : r, f && (d.$async = !0), !0 === a.sourceCode && (d.source = {
      code: b,
      patterns: u,
      defaults: c
    }), d;
  }
  function v(e, o, u) {
    o = resolve_1.url(e, o);
    var l,
      c,
      p = s[o];
    if (void 0 !== p) return S(l = i[p], c = "refVal[" + p + "]");
    if (!u && t.refs) {
      var g = t.refs[o];
      if (void 0 !== g) return S(l = t.refVal[g], c = E(o, l));
    }
    c = E(o);
    var d = resolve_1.call(n, _, t, o);
    if (void 0 === d) {
      var f = r && r[o];
      f && (d = resolve_1.inlineRef(f, a.inlineRefs) ? f : compile.call(n, f, t, r, e));
    }
    if (void 0 !== d) return function (e, t) {
      var r = s[e];
      i[r] = t;
    }(o, d), S(d, c);
    !function (e) {
      delete s[e];
    }(o);
  }
  function E(e, t) {
    var r = i.length;
    return i[r] = t, s[e] = r, "refVal" + r;
  }
  function S(e, t) {
    return "object" == typeof e || "boolean" == typeof e ? {
      code: t,
      schema: e,
      inline: !0
    } : {
      code: t,
      $async: e && !!e.$async
    };
  }
  function R(e) {
    var t = l[e];
    return void 0 === t && (t = l[e] = u.length, u[t] = e), "pattern" + t;
  }
  function w(e) {
    switch (typeof e) {
      case "boolean":
      case "number":
        return "" + e;
      case "string":
        return util.toQuotedString(e);
      case "object":
        if (null === e) return "null";
        var t = fastJsonStableStringify(e),
          r = p[t];
        return void 0 === r && (r = p[t] = c.length, c[r] = e), "default" + r;
    }
  }
  function T(e, t, r, o) {
    if (!1 !== n._opts.validateSchema) {
      var i = e.definition.dependencies;
      if (i && !i.every(function (e) {
        return Object.prototype.hasOwnProperty.call(r, e);
      })) throw new Error("parent schema must have all required keywords: " + i.join(","));
      var s = e.definition.validateSchema;
      if (s) if (!s(t)) {
        var u = "keyword schema is invalid: " + n.errorsText(s.errors);
        if ("log" != n._opts.validateSchema) throw new Error(u);
        n.logger.error(u);
      }
    }
    var l,
      c = e.definition.compile,
      p = e.definition.inline,
      d = e.definition.macro;
    if (c) l = c.call(n, t, r, o);else if (d) l = d.call(n, t, r, o), !1 !== a.validateSchema && n.validateSchema(l, !0);else if (p) l = p.call(n, o, e.keyword, t, r);else if (!(l = e.definition.validate)) return;
    if (void 0 === l) throw new Error('custom keyword "' + e.keyword + '"failed to compile');
    var f = g.length;
    return g[f] = l, {
      code: "customRule" + f,
      validate: l
    };
  }
}
function checkCompiling(e, t, r) {
  var o = compIndex.call(this, e, t, r);
  return o >= 0 ? {
    index: o,
    compiling: !0
  } : (o = this._compilations.length, this._compilations[o] = {
    schema: e,
    root: t,
    baseId: r
  }, {
    index: o,
    compiling: !1
  });
}
function endCompiling(e, t, r) {
  var o = compIndex.call(this, e, t, r);
  o >= 0 && this._compilations.splice(o, 1);
}
function compIndex(e, t, r) {
  for (var o = 0; o < this._compilations.length; o++) {
    var n = this._compilations[o];
    if (n.schema == e && n.root == t && n.baseId == r) return o;
  }
  return -1;
}
function patternCode(e, t) {
  return "var pattern" + e + " = new RegExp(" + util.toQuotedString(t[e]) + ");";
}
function defaultCode(e) {
  return "var default" + e + " = defaults[" + e + "];";
}
function refValCode(e, t) {
  return void 0 === t[e] ? "" : "var refVal" + e + " = refVal[" + e + "];";
}
function customRuleCode(e) {
  return "var customRule" + e + " = customRules[" + e + "];";
}
function vars(e, t) {
  if (!e.length) return "";
  for (var r = "", o = 0; o < e.length; o++) r += t(o, e);
  return r;
}
var cache = createCommonjsModule(function (e) {
    var t = e.exports = function () {
      this._cache = {};
    };
    t.prototype.put = function (e, t) {
      this._cache[e] = t;
    }, t.prototype.get = function (e) {
      return this._cache[e];
    }, t.prototype.del = function (e) {
      delete this._cache[e];
    }, t.prototype.clear = function () {
      this._cache = {};
    };
  }),
  DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/,
  DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i,
  HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
  URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
  URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
  URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
  URL$1 = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i,
  UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
  JSON_POINTER$1 = /^(?:\/(?:[^~/]|~0|~1)*)*$/,
  JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
  RELATIVE_JSON_POINTER$1 = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
  formats_1 = formats;
function formats(e) {
  return e = "full" == e ? "full" : "fast", util.copy(formats[e]);
}
function isLeapYear(e) {
  return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
}
function date(e) {
  var t = e.match(DATE);
  if (!t) return !1;
  var r = +t[1],
    o = +t[2],
    n = +t[3];
  return o >= 1 && o <= 12 && n >= 1 && n <= (2 == o && isLeapYear(r) ? 29 : DAYS[o]);
}
function time(e, t) {
  var r = e.match(TIME);
  if (!r) return !1;
  var o = r[1],
    n = r[2],
    a = r[3],
    i = r[5];
  return (o <= 23 && n <= 59 && a <= 59 || 23 == o && 59 == n && 60 == a) && (!t || i);
}
formats.fast = {
  date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
  time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
  "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
  uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
  "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
  "uri-template": URITEMPLATE,
  url: URL$1,
  email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
  hostname: HOSTNAME,
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  uuid: UUID,
  "json-pointer": JSON_POINTER$1,
  "json-pointer-uri-fragment": JSON_POINTER_URI_FRAGMENT,
  "relative-json-pointer": RELATIVE_JSON_POINTER$1
}, formats.full = {
  date: date,
  time: time,
  "date-time": date_time,
  uri: uri,
  "uri-reference": URIREF,
  "uri-template": URITEMPLATE,
  url: URL$1,
  email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
  hostname: HOSTNAME,
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  uuid: UUID,
  "json-pointer": JSON_POINTER$1,
  "json-pointer-uri-fragment": JSON_POINTER_URI_FRAGMENT,
  "relative-json-pointer": RELATIVE_JSON_POINTER$1
};
var DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(e) {
  var t = e.split(DATE_TIME_SEPARATOR);
  return 2 == t.length && date(t[0]) && time(t[1], !0);
}
var NOT_URI_FRAGMENT = /\/|:/;
function uri(e) {
  return NOT_URI_FRAGMENT.test(e) && URI.test(e);
}
var Z_ANCHOR = /[^\\]\\Z/;
function regex(e) {
  if (Z_ANCHOR.test(e)) return !1;
  try {
    return new RegExp(e), !0;
  } catch (e) {
    return !1;
  }
}
var ref = function ref(e, t, r) {
    var o,
      n,
      a = " ",
      i = e.level,
      s = e.dataLevel,
      u = e.schema[t],
      l = e.errSchemaPath + "/" + t,
      c = !e.opts.allErrors,
      p = "data" + (s || ""),
      g = "valid" + i;
    if ("#" == u || "#/" == u) e.isRoot ? (o = e.async, n = "validate") : (o = !0 === e.root.schema.$async, n = "root.refVal[0]");else {
      var d = e.resolveRef(e.baseId, u, e.isRoot);
      if (void 0 === d) {
        var f = e.MissingRefError.message(e.baseId, u);
        if ("fail" == e.opts.missingRefs) {
          e.logger.error(f), (m = m || []).push(a), a = "", !1 !== e.createErrors ? (a += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { ref: '" + e.util.escapeQuotes(u) + "' } ", !1 !== e.opts.messages && (a += " , message: 'can\\'t resolve reference " + e.util.escapeQuotes(u) + "' "), e.opts.verbose && (a += " , schema: " + e.util.toQuotedString(u) + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), a += " } ") : a += " {} ";
          var h = a;
          a = m.pop(), !e.compositeRule && c ? e.async ? a += " throw new ValidationError([" + h + "]); " : a += " validate.errors = [" + h + "]; return false; " : a += " var err = " + h + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c && (a += " if (false) { ");
        } else {
          if ("ignore" != e.opts.missingRefs) throw new e.MissingRefError(e.baseId, u, f);
          e.logger.warn(f), c && (a += " if (true) { ");
        }
      } else if (d.inline) {
        var y = e.util.copy(e);
        y.level++;
        var b = "valid" + y.level;
        y.schema = d.schema, y.schemaPath = "", y.errSchemaPath = u, a += " " + e.validate(y).replace(/validate\.schema/g, d.code) + " ", c && (a += " if (" + b + ") { ");
      } else o = !0 === d.$async || e.async && !1 !== d.$async, n = d.code;
    }
    if (n) {
      var m;
      (m = m || []).push(a), a = "", e.opts.passContext ? a += " " + n + ".call(this, " : a += " " + n + "( ", a += " " + p + ", (dataPath || '')", '""' != e.errorPath && (a += " + " + e.errorPath);
      var _ = a += " , " + (s ? "data" + (s - 1 || "") : "parentData") + " , " + (s ? e.dataPathArr[s] : "parentDataProperty") + ", rootData)  ";
      if (a = m.pop(), o) {
        if (!e.async) throw new Error("async schema referenced by sync schema");
        c && (a += " var " + g + "; "), a += " try { await " + _ + "; ", c && (a += " " + g + " = true; "), a += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", c && (a += " " + g + " = false; "), a += " } ", c && (a += " if (" + g + ") { ");
      } else a += " if (!" + _ + ") { if (vErrors === null) vErrors = " + n + ".errors; else vErrors = vErrors.concat(" + n + ".errors); errors = vErrors.length; } ", c && (a += " else { ");
    }
    return a;
  },
  allOf = function allOf(e, t, r) {
    var o = " ",
      n = e.schema[t],
      a = e.schemaPath + e.util.getProperty(t),
      i = e.errSchemaPath + "/" + t,
      s = !e.opts.allErrors,
      u = e.util.copy(e),
      l = "";
    u.level++;
    var c = "valid" + u.level,
      p = u.baseId,
      g = !0,
      d = n;
    if (d) for (var f, h = -1, y = d.length - 1; h < y;) f = d[h += 1], (e.opts.strictKeywords ? "object" == typeof f && Object.keys(f).length > 0 || !1 === f : e.util.schemaHasRules(f, e.RULES.all)) && (g = !1, u.schema = f, u.schemaPath = a + "[" + h + "]", u.errSchemaPath = i + "/" + h, o += "  " + e.validate(u) + " ", u.baseId = p, s && (o += " if (" + c + ") { ", l += "}"));
    return s && (o += g ? " if (true) { " : " " + l.slice(0, -1) + " "), o;
  },
  anyOf = function anyOf(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "valid" + n,
      g = "errs__" + n,
      d = e.util.copy(e),
      f = "";
    d.level++;
    var h = "valid" + d.level;
    if (i.every(function (t) {
      return e.opts.strictKeywords ? "object" == typeof t && Object.keys(t).length > 0 || !1 === t : e.util.schemaHasRules(t, e.RULES.all);
    })) {
      var y = d.baseId;
      o += " var " + g + " = errors; var " + p + " = false;  ";
      var b = e.compositeRule;
      e.compositeRule = d.compositeRule = !0;
      var m = i;
      if (m) for (var _, v = -1, E = m.length - 1; v < E;) _ = m[v += 1], d.schema = _, d.schemaPath = s + "[" + v + "]", d.errSchemaPath = u + "/" + v, o += "  " + e.validate(d) + " ", d.baseId = y, o += " " + p + " = " + p + " || " + h + "; if (!" + p + ") { ", f += "}";
      e.compositeRule = d.compositeRule = b, o += " " + f + " if (!" + p + ") {   var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", !1 !== e.opts.messages && (o += " , message: 'should match some schema in anyOf' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && l && (e.async ? o += " throw new ValidationError(vErrors); " : o += " validate.errors = vErrors; return false; "), o += " } else {  errors = " + g + "; if (vErrors !== null) { if (" + g + ") vErrors.length = " + g + "; else vErrors = null; } ", e.opts.allErrors && (o += " } ");
    } else l && (o += " if (true) { ");
    return o;
  },
  comment = function comment(e, t, r) {
    var o = " ",
      n = e.schema[t],
      a = e.errSchemaPath + "/" + t;
    e.opts.allErrors;
    var i = e.util.toQuotedString(n);
    return !0 === e.opts.$comment ? o += " console.log(" + i + ");" : "function" == typeof e.opts.$comment && (o += " self._opts.$comment(" + i + ", " + e.util.toQuotedString(a) + ", validate.root.schema);"), o;
  },
  _const = function _const(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "valid" + n,
      g = e.opts.$data && i && i.$data;
    g && (o += " var schema" + n + " = " + e.util.getData(i.$data, a, e.dataPathArr) + "; "), g || (o += " var schema" + n + " = validate.schema" + s + ";"), o += "var " + p + " = equal(" + c + ", schema" + n + "); if (!" + p + ") {   ";
    var d = d || [];
    d.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'const' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { allowedValue: schema" + n + " } ", !1 !== e.opts.messages && (o += " , message: 'should be equal to constant' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
    var f = o;
    return o = d.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + f + "]); " : o += " validate.errors = [" + f + "]; return false; " : o += " var err = " + f + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " }", l && (o += " else { "), o;
  },
  contains = function contains(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "valid" + n,
      g = "errs__" + n,
      d = e.util.copy(e);
    d.level++;
    var f = "valid" + d.level,
      h = "i" + n,
      y = d.dataLevel = e.dataLevel + 1,
      b = "data" + y,
      m = e.baseId,
      _ = e.opts.strictKeywords ? "object" == typeof i && Object.keys(i).length > 0 || !1 === i : e.util.schemaHasRules(i, e.RULES.all);
    if (o += "var " + g + " = errors;var " + p + ";", _) {
      var v = e.compositeRule;
      e.compositeRule = d.compositeRule = !0, d.schema = i, d.schemaPath = s, d.errSchemaPath = u, o += " var " + f + " = false; for (var " + h + " = 0; " + h + " < " + c + ".length; " + h + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, h, e.opts.jsonPointers, !0);
      var E = c + "[" + h + "]";
      d.dataPathArr[y] = h;
      var S = e.validate(d);
      d.baseId = m, e.util.varOccurences(S, b) < 2 ? o += " " + e.util.varReplace(S, b, E) + " " : o += " var " + b + " = " + E + "; " + S + " ", o += " if (" + f + ") break; }  ", e.compositeRule = d.compositeRule = v, o += "  if (!" + f + ") {";
    } else o += " if (" + c + ".length == 0) {";
    var R = R || [];
    R.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", !1 !== e.opts.messages && (o += " , message: 'should contain a valid item' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
    var w = o;
    return o = R.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + w + "]); " : o += " validate.errors = [" + w + "]; return false; " : o += " var err = " + w + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } else { ", _ && (o += "  errors = " + g + "; if (vErrors !== null) { if (" + g + ") vErrors.length = " + g + "; else vErrors = null; } "), e.opts.allErrors && (o += " } "), o;
  },
  dependencies = function dependencies(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "errs__" + n,
      g = e.util.copy(e),
      d = "";
    g.level++;
    var f = "valid" + g.level,
      h = {},
      y = {},
      b = e.opts.ownProperties;
    for (E in i) if ("__proto__" != E) {
      var m = i[E],
        _ = Array.isArray(m) ? y : h;
      _[E] = m;
    }
    o += "var " + p + " = errors;";
    var v = e.errorPath;
    for (var E in o += "var missing" + n + ";", y) if ((_ = y[E]).length) {
      if (o += " if ( " + c + e.util.getProperty(E) + " !== undefined ", b && (o += " && Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(E) + "') "), l) {
        o += " && ( ";
        var S = _;
        if (S) for (var R = -1, w = S.length - 1; R < w;) {
          I = S[R += 1], R && (o += " || "), o += " ( ( " + (j = c + (F = e.util.getProperty(I))) + " === undefined ", b && (o += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(I) + "') "), o += ") && (missing" + n + " = " + e.util.toQuotedString(e.opts.jsonPointers ? I : F) + ") ) ";
        }
        o += ")) {  ";
        var T = "missing" + n,
          P = "' + " + T + " + '";
        e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(v, T, !0) : v + " + " + T);
        var A = A || [];
        A.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { property: '" + e.util.escapeQuotes(E) + "', missingProperty: '" + P + "', depsCount: " + _.length + ", deps: '" + e.util.escapeQuotes(1 == _.length ? _[0] : _.join(", ")) + "' } ", !1 !== e.opts.messages && (o += " , message: 'should have ", 1 == _.length ? o += "property " + e.util.escapeQuotes(_[0]) : o += "properties " + e.util.escapeQuotes(_.join(", ")), o += " when property " + e.util.escapeQuotes(E) + " is present' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
        var D = o;
        o = A.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + D + "]); " : o += " validate.errors = [" + D + "]; return false; " : o += " var err = " + D + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      } else {
        o += " ) { ";
        var O = _;
        if (O) for (var I, C = -1, B = O.length - 1; C < B;) {
          I = O[C += 1];
          var F = e.util.getProperty(I),
            j = (P = e.util.escapeQuotes(I), c + F);
          e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(v, I, e.opts.jsonPointers)), o += " if ( " + j + " === undefined ", b && (o += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(I) + "') "), o += ") {  var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { property: '" + e.util.escapeQuotes(E) + "', missingProperty: '" + P + "', depsCount: " + _.length + ", deps: '" + e.util.escapeQuotes(1 == _.length ? _[0] : _.join(", ")) + "' } ", !1 !== e.opts.messages && (o += " , message: 'should have ", 1 == _.length ? o += "property " + e.util.escapeQuotes(_[0]) : o += "properties " + e.util.escapeQuotes(_.join(", ")), o += " when property " + e.util.escapeQuotes(E) + " is present' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
        }
      }
      o += " }   ", l && (d += "}", o += " else { ");
    }
    e.errorPath = v;
    var N = g.baseId;
    for (var E in h) {
      m = h[E];
      (e.opts.strictKeywords ? "object" == typeof m && Object.keys(m).length > 0 || !1 === m : e.util.schemaHasRules(m, e.RULES.all)) && (o += " " + f + " = true; if ( " + c + e.util.getProperty(E) + " !== undefined ", b && (o += " && Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(E) + "') "), o += ") { ", g.schema = m, g.schemaPath = s + e.util.getProperty(E), g.errSchemaPath = u + "/" + e.util.escapeFragment(E), o += "  " + e.validate(g) + " ", g.baseId = N, o += " }  ", l && (o += " if (" + f + ") { ", d += "}"));
    }
    return l && (o += "   " + d + " if (" + p + " == errors) {"), o;
  },
  _enum = function _enum(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "valid" + n,
      g = e.opts.$data && i && i.$data;
    g && (o += " var schema" + n + " = " + e.util.getData(i.$data, a, e.dataPathArr) + "; ");
    var d = "i" + n,
      f = "schema" + n;
    g || (o += " var " + f + " = validate.schema" + s + ";"), o += "var " + p + ";", g && (o += " if (schema" + n + " === undefined) " + p + " = true; else if (!Array.isArray(schema" + n + ")) " + p + " = false; else {"), o += p + " = false;for (var " + d + "=0; " + d + "<" + f + ".length; " + d + "++) if (equal(" + c + ", " + f + "[" + d + "])) { " + p + " = true; break; }", g && (o += "  }  "), o += " if (!" + p + ") {   ";
    var h = h || [];
    h.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { allowedValues: schema" + n + " } ", !1 !== e.opts.messages && (o += " , message: 'should be equal to one of the allowed values' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
    var y = o;
    return o = h.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + y + "]); " : o += " validate.errors = [" + y + "]; return false; " : o += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " }", l && (o += " else { "), o;
  },
  format = function format(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || "");
    if (!1 === e.opts.format) return l && (o += " if (true) { "), o;
    var p,
      g = e.opts.$data && i && i.$data;
    g ? (o += " var schema" + n + " = " + e.util.getData(i.$data, a, e.dataPathArr) + "; ", p = "schema" + n) : p = i;
    var d = e.opts.unknownFormats,
      f = Array.isArray(d);
    if (g) {
      o += " var " + (h = "format" + n) + " = formats[" + p + "]; var " + (y = "isObject" + n) + " = typeof " + h + " == 'object' && !(" + h + " instanceof RegExp) && " + h + ".validate; var " + (b = "formatType" + n) + " = " + y + " && " + h + ".type || 'string'; if (" + y + ") { ", e.async && (o += " var async" + n + " = " + h + ".async; "), o += " " + h + " = " + h + ".validate; } if (  ", g && (o += " (" + p + " !== undefined && typeof " + p + " != 'string') || "), o += " (", "ignore" != d && (o += " (" + p + " && !" + h + " ", f && (o += " && self._opts.unknownFormats.indexOf(" + p + ") == -1 "), o += ") || "), o += " (" + h + " && " + b + " == '" + r + "' && !(typeof " + h + " == 'function' ? ", e.async ? o += " (async" + n + " ? await " + h + "(" + c + ") : " + h + "(" + c + ")) " : o += " " + h + "(" + c + ") ", o += " : " + h + ".test(" + c + "))))) {";
    } else {
      var h;
      if (!(h = e.formats[i])) {
        if ("ignore" == d) return e.logger.warn('unknown format "' + i + '" ignored in schema at path "' + e.errSchemaPath + '"'), l && (o += " if (true) { "), o;
        if (f && d.indexOf(i) >= 0) return l && (o += " if (true) { "), o;
        throw new Error('unknown format "' + i + '" is used in schema at path "' + e.errSchemaPath + '"');
      }
      var y,
        b = (y = "object" == typeof h && !(h instanceof RegExp) && h.validate) && h.type || "string";
      if (y) {
        var m = !0 === h.async;
        h = h.validate;
      }
      if (b != r) return l && (o += " if (true) { "), o;
      if (m) {
        if (!e.async) throw new Error("async format in sync schema");
        o += " if (!(await " + (_ = "formats" + e.util.getProperty(i) + ".validate") + "(" + c + "))) { ";
      } else {
        o += " if (! ";
        var _ = "formats" + e.util.getProperty(i);
        y && (_ += ".validate"), o += "function" == typeof h ? " " + _ + "(" + c + ") " : " " + _ + ".test(" + c + ") ", o += ") { ";
      }
    }
    var v = v || [];
    v.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'format' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { format:  ", o += g ? "" + p : "" + e.util.toQuotedString(i), o += "  } ", !1 !== e.opts.messages && (o += " , message: 'should match format \"", o += g ? "' + " + p + " + '" : "" + e.util.escapeQuotes(i), o += "\"' "), e.opts.verbose && (o += " , schema:  ", o += g ? "validate.schema" + s : "" + e.util.toQuotedString(i), o += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
    var E = o;
    return o = v.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + E + "]); " : o += " validate.errors = [" + E + "]; return false; " : o += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } ", l && (o += " else { "), o;
  },
  _if = function _if(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "valid" + n,
      g = "errs__" + n,
      d = e.util.copy(e);
    d.level++;
    var f = "valid" + d.level,
      h = e.schema.then,
      y = e.schema.else,
      b = void 0 !== h && (e.opts.strictKeywords ? "object" == typeof h && Object.keys(h).length > 0 || !1 === h : e.util.schemaHasRules(h, e.RULES.all)),
      m = void 0 !== y && (e.opts.strictKeywords ? "object" == typeof y && Object.keys(y).length > 0 || !1 === y : e.util.schemaHasRules(y, e.RULES.all)),
      _ = d.baseId;
    if (b || m) {
      var v;
      d.createErrors = !1, d.schema = i, d.schemaPath = s, d.errSchemaPath = u, o += " var " + g + " = errors; var " + p + " = true;  ";
      var E = e.compositeRule;
      e.compositeRule = d.compositeRule = !0, o += "  " + e.validate(d) + " ", d.baseId = _, d.createErrors = !0, o += "  errors = " + g + "; if (vErrors !== null) { if (" + g + ") vErrors.length = " + g + "; else vErrors = null; }  ", e.compositeRule = d.compositeRule = E, b ? (o += " if (" + f + ") {  ", d.schema = e.schema.then, d.schemaPath = e.schemaPath + ".then", d.errSchemaPath = e.errSchemaPath + "/then", o += "  " + e.validate(d) + " ", d.baseId = _, o += " " + p + " = " + f + "; ", b && m ? o += " var " + (v = "ifClause" + n) + " = 'then'; " : v = "'then'", o += " } ", m && (o += " else { ")) : o += " if (!" + f + ") { ", m && (d.schema = e.schema.else, d.schemaPath = e.schemaPath + ".else", d.errSchemaPath = e.errSchemaPath + "/else", o += "  " + e.validate(d) + " ", d.baseId = _, o += " " + p + " = " + f + "; ", b && m ? o += " var " + (v = "ifClause" + n) + " = 'else'; " : v = "'else'", o += " } "), o += " if (!" + p + ") {   var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'if' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { failingKeyword: " + v + " } ", !1 !== e.opts.messages && (o += " , message: 'should match \"' + " + v + " + '\" schema' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && l && (e.async ? o += " throw new ValidationError(vErrors); " : o += " validate.errors = vErrors; return false; "), o += " }   ", l && (o += " else { ");
    } else l && (o += " if (true) { ");
    return o;
  },
  items = function items(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "valid" + n,
      g = "errs__" + n,
      d = e.util.copy(e),
      f = "";
    d.level++;
    var h = "valid" + d.level,
      y = "i" + n,
      b = d.dataLevel = e.dataLevel + 1,
      m = "data" + b,
      _ = e.baseId;
    if (o += "var " + g + " = errors;var " + p + ";", Array.isArray(i)) {
      var v = e.schema.additionalItems;
      if (!1 === v) {
        o += " " + p + " = " + c + ".length <= " + i.length + "; ";
        var E = u;
        u = e.errSchemaPath + "/additionalItems", o += "  if (!" + p + ") {   ";
        var S = S || [];
        S.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { limit: " + i.length + " } ", !1 !== e.opts.messages && (o += " , message: 'should NOT have more than " + i.length + " items' "), e.opts.verbose && (o += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
        var R = o;
        o = S.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + R + "]); " : o += " validate.errors = [" + R + "]; return false; " : o += " var err = " + R + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } ", u = E, l && (f += "}", o += " else { ");
      }
      var w = i;
      if (w) for (var T, P = -1, A = w.length - 1; P < A;) if (T = w[P += 1], e.opts.strictKeywords ? "object" == typeof T && Object.keys(T).length > 0 || !1 === T : e.util.schemaHasRules(T, e.RULES.all)) {
        o += " " + h + " = true; if (" + c + ".length > " + P + ") { ";
        var D = c + "[" + P + "]";
        d.schema = T, d.schemaPath = s + "[" + P + "]", d.errSchemaPath = u + "/" + P, d.errorPath = e.util.getPathExpr(e.errorPath, P, e.opts.jsonPointers, !0), d.dataPathArr[b] = P;
        var O = e.validate(d);
        d.baseId = _, e.util.varOccurences(O, m) < 2 ? o += " " + e.util.varReplace(O, m, D) + " " : o += " var " + m + " = " + D + "; " + O + " ", o += " }  ", l && (o += " if (" + h + ") { ", f += "}");
      }
      if ("object" == typeof v && (e.opts.strictKeywords ? "object" == typeof v && Object.keys(v).length > 0 || !1 === v : e.util.schemaHasRules(v, e.RULES.all))) {
        d.schema = v, d.schemaPath = e.schemaPath + ".additionalItems", d.errSchemaPath = e.errSchemaPath + "/additionalItems", o += " " + h + " = true; if (" + c + ".length > " + i.length + ") {  for (var " + y + " = " + i.length + "; " + y + " < " + c + ".length; " + y + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, y, e.opts.jsonPointers, !0);
        D = c + "[" + y + "]";
        d.dataPathArr[b] = y;
        O = e.validate(d);
        d.baseId = _, e.util.varOccurences(O, m) < 2 ? o += " " + e.util.varReplace(O, m, D) + " " : o += " var " + m + " = " + D + "; " + O + " ", l && (o += " if (!" + h + ") break; "), o += " } }  ", l && (o += " if (" + h + ") { ", f += "}");
      }
    } else if (e.opts.strictKeywords ? "object" == typeof i && Object.keys(i).length > 0 || !1 === i : e.util.schemaHasRules(i, e.RULES.all)) {
      d.schema = i, d.schemaPath = s, d.errSchemaPath = u, o += "  for (var " + y + " = 0; " + y + " < " + c + ".length; " + y + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, y, e.opts.jsonPointers, !0);
      D = c + "[" + y + "]";
      d.dataPathArr[b] = y;
      O = e.validate(d);
      d.baseId = _, e.util.varOccurences(O, m) < 2 ? o += " " + e.util.varReplace(O, m, D) + " " : o += " var " + m + " = " + D + "; " + O + " ", l && (o += " if (!" + h + ") break; "), o += " }";
    }
    return l && (o += " " + f + " if (" + g + " == errors) {"), o;
  },
  _limit = function _limit(e, t, r) {
    var o,
      n = " ",
      a = e.level,
      i = e.dataLevel,
      s = e.schema[t],
      u = e.schemaPath + e.util.getProperty(t),
      l = e.errSchemaPath + "/" + t,
      c = !e.opts.allErrors,
      p = "data" + (i || ""),
      g = e.opts.$data && s && s.$data;
    g ? (n += " var schema" + a + " = " + e.util.getData(s.$data, i, e.dataPathArr) + "; ", o = "schema" + a) : o = s;
    var d = "maximum" == t,
      f = d ? "exclusiveMaximum" : "exclusiveMinimum",
      h = e.schema[f],
      y = e.opts.$data && h && h.$data,
      b = d ? "<" : ">",
      m = d ? ">" : "<",
      _ = void 0;
    if (!g && "number" != typeof s && void 0 !== s) throw new Error(t + " must be number");
    if (!y && void 0 !== h && "number" != typeof h && "boolean" != typeof h) throw new Error(f + " must be number or boolean");
    if (y) {
      var v = e.util.getData(h.$data, i, e.dataPathArr),
        E = "exclusive" + a,
        S = "exclType" + a,
        R = "exclIsNumber" + a,
        w = "' + " + (A = "op" + a) + " + '";
      n += " var schemaExcl" + a + " = " + v + "; ", n += " var " + E + "; var " + S + " = typeof " + (v = "schemaExcl" + a) + "; if (" + S + " != 'boolean' && " + S + " != 'undefined' && " + S + " != 'number') { ";
      var T;
      _ = f;
      (T = T || []).push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: '" + (_ || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: {} ", !1 !== e.opts.messages && (n += " , message: '" + f + " should be boolean' "), e.opts.verbose && (n += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), n += " } ") : n += " {} ";
      var P = n;
      n = T.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + P + "]); " : n += " validate.errors = [" + P + "]; return false; " : n += " var err = " + P + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else if ( ", g && (n += " (" + o + " !== undefined && typeof " + o + " != 'number') || "), n += " " + S + " == 'number' ? ( (" + E + " = " + o + " === undefined || " + v + " " + b + "= " + o + ") ? " + p + " " + m + "= " + v + " : " + p + " " + m + " " + o + " ) : ( (" + E + " = " + v + " === true) ? " + p + " " + m + "= " + o + " : " + p + " " + m + " " + o + " ) || " + p + " !== " + p + ") { var op" + a + " = " + E + " ? '" + b + "' : '" + b + "='; ", void 0 === s && (_ = f, l = e.errSchemaPath + "/" + f, o = v, g = y);
    } else {
      w = b;
      if ((R = "number" == typeof h) && g) {
        var A = "'" + w + "'";
        n += " if ( ", g && (n += " (" + o + " !== undefined && typeof " + o + " != 'number') || "), n += " ( " + o + " === undefined || " + h + " " + b + "= " + o + " ? " + p + " " + m + "= " + h + " : " + p + " " + m + " " + o + " ) || " + p + " !== " + p + ") { ";
      } else {
        R && void 0 === s ? (E = !0, _ = f, l = e.errSchemaPath + "/" + f, o = h, m += "=") : (R && (o = Math[d ? "min" : "max"](h, s)), h === (!R || o) ? (E = !0, _ = f, l = e.errSchemaPath + "/" + f, m += "=") : (E = !1, w += "="));
        A = "'" + w + "'";
        n += " if ( ", g && (n += " (" + o + " !== undefined && typeof " + o + " != 'number') || "), n += " " + p + " " + m + " " + o + " || " + p + " !== " + p + ") { ";
      }
    }
    _ = _ || t, (T = T || []).push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: '" + (_ || "_limit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { comparison: " + A + ", limit: " + o + ", exclusive: " + E + " } ", !1 !== e.opts.messages && (n += " , message: 'should be " + w + " ", n += g ? "' + " + o : o + "'"), e.opts.verbose && (n += " , schema:  ", n += g ? "validate.schema" + u : "" + s, n += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), n += " } ") : n += " {} ";
    P = n;
    return n = T.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + P + "]); " : n += " validate.errors = [" + P + "]; return false; " : n += " var err = " + P + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } ", c && (n += " else { "), n;
  },
  _limitItems = function _limitItems(e, t, r) {
    var o,
      n = " ",
      a = e.level,
      i = e.dataLevel,
      s = e.schema[t],
      u = e.schemaPath + e.util.getProperty(t),
      l = e.errSchemaPath + "/" + t,
      c = !e.opts.allErrors,
      p = "data" + (i || ""),
      g = e.opts.$data && s && s.$data;
    if (g ? (n += " var schema" + a + " = " + e.util.getData(s.$data, i, e.dataPathArr) + "; ", o = "schema" + a) : o = s, !g && "number" != typeof s) throw new Error(t + " must be number");
    n += "if ( ", g && (n += " (" + o + " !== undefined && typeof " + o + " != 'number') || "), n += " " + p + ".length " + ("maxItems" == t ? ">" : "<") + " " + o + ") { ";
    var d = t,
      f = f || [];
    f.push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: '" + (d || "_limitItems") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + o + " } ", !1 !== e.opts.messages && (n += " , message: 'should NOT have ", n += "maxItems" == t ? "more" : "fewer", n += " than ", n += g ? "' + " + o + " + '" : "" + s, n += " items' "), e.opts.verbose && (n += " , schema:  ", n += g ? "validate.schema" + u : "" + s, n += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), n += " } ") : n += " {} ";
    var h = n;
    return n = f.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + h + "]); " : n += " validate.errors = [" + h + "]; return false; " : n += " var err = " + h + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
  },
  _limitLength = function _limitLength(e, t, r) {
    var o,
      n = " ",
      a = e.level,
      i = e.dataLevel,
      s = e.schema[t],
      u = e.schemaPath + e.util.getProperty(t),
      l = e.errSchemaPath + "/" + t,
      c = !e.opts.allErrors,
      p = "data" + (i || ""),
      g = e.opts.$data && s && s.$data;
    if (g ? (n += " var schema" + a + " = " + e.util.getData(s.$data, i, e.dataPathArr) + "; ", o = "schema" + a) : o = s, !g && "number" != typeof s) throw new Error(t + " must be number");
    var d = "maxLength" == t ? ">" : "<";
    n += "if ( ", g && (n += " (" + o + " !== undefined && typeof " + o + " != 'number') || "), !1 === e.opts.unicode ? n += " " + p + ".length " : n += " ucs2length(" + p + ") ", n += " " + d + " " + o + ") { ";
    var f = t,
      h = h || [];
    h.push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: '" + (f || "_limitLength") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + o + " } ", !1 !== e.opts.messages && (n += " , message: 'should NOT be ", n += "maxLength" == t ? "longer" : "shorter", n += " than ", n += g ? "' + " + o + " + '" : "" + s, n += " characters' "), e.opts.verbose && (n += " , schema:  ", n += g ? "validate.schema" + u : "" + s, n += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), n += " } ") : n += " {} ";
    var y = n;
    return n = h.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + y + "]); " : n += " validate.errors = [" + y + "]; return false; " : n += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
  },
  _limitProperties = function _limitProperties(e, t, r) {
    var o,
      n = " ",
      a = e.level,
      i = e.dataLevel,
      s = e.schema[t],
      u = e.schemaPath + e.util.getProperty(t),
      l = e.errSchemaPath + "/" + t,
      c = !e.opts.allErrors,
      p = "data" + (i || ""),
      g = e.opts.$data && s && s.$data;
    if (g ? (n += " var schema" + a + " = " + e.util.getData(s.$data, i, e.dataPathArr) + "; ", o = "schema" + a) : o = s, !g && "number" != typeof s) throw new Error(t + " must be number");
    n += "if ( ", g && (n += " (" + o + " !== undefined && typeof " + o + " != 'number') || "), n += " Object.keys(" + p + ").length " + ("maxProperties" == t ? ">" : "<") + " " + o + ") { ";
    var d = t,
      f = f || [];
    f.push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: '" + (d || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + o + " } ", !1 !== e.opts.messages && (n += " , message: 'should NOT have ", n += "maxProperties" == t ? "more" : "fewer", n += " than ", n += g ? "' + " + o + " + '" : "" + s, n += " properties' "), e.opts.verbose && (n += " , schema:  ", n += g ? "validate.schema" + u : "" + s, n += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), n += " } ") : n += " {} ";
    var h = n;
    return n = f.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + h + "]); " : n += " validate.errors = [" + h + "]; return false; " : n += " var err = " + h + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
  },
  multipleOf = function multipleOf(e, t, r) {
    var o,
      n = " ",
      a = e.level,
      i = e.dataLevel,
      s = e.schema[t],
      u = e.schemaPath + e.util.getProperty(t),
      l = e.errSchemaPath + "/" + t,
      c = !e.opts.allErrors,
      p = "data" + (i || ""),
      g = e.opts.$data && s && s.$data;
    if (g ? (n += " var schema" + a + " = " + e.util.getData(s.$data, i, e.dataPathArr) + "; ", o = "schema" + a) : o = s, !g && "number" != typeof s) throw new Error(t + " must be number");
    n += "var division" + a + ";if (", g && (n += " " + o + " !== undefined && ( typeof " + o + " != 'number' || "), n += " (division" + a + " = " + p + " / " + o + ", ", e.opts.multipleOfPrecision ? n += " Math.abs(Math.round(division" + a + ") - division" + a + ") > 1e-" + e.opts.multipleOfPrecision + " " : n += " division" + a + " !== parseInt(division" + a + ") ", n += " ) ", g && (n += "  )  "), n += " ) {   ";
    var d = d || [];
    d.push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { multipleOf: " + o + " } ", !1 !== e.opts.messages && (n += " , message: 'should be multiple of ", n += g ? "' + " + o : o + "'"), e.opts.verbose && (n += " , schema:  ", n += g ? "validate.schema" + u : "" + s, n += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), n += " } ") : n += " {} ";
    var f = n;
    return n = d.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + f + "]); " : n += " validate.errors = [" + f + "]; return false; " : n += " var err = " + f + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
  },
  not = function not(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "errs__" + n,
      g = e.util.copy(e);
    g.level++;
    var d = "valid" + g.level;
    if (e.opts.strictKeywords ? "object" == typeof i && Object.keys(i).length > 0 || !1 === i : e.util.schemaHasRules(i, e.RULES.all)) {
      g.schema = i, g.schemaPath = s, g.errSchemaPath = u, o += " var " + p + " = errors;  ";
      var f,
        h = e.compositeRule;
      e.compositeRule = g.compositeRule = !0, g.createErrors = !1, g.opts.allErrors && (f = g.opts.allErrors, g.opts.allErrors = !1), o += " " + e.validate(g) + " ", g.createErrors = !0, f && (g.opts.allErrors = f), e.compositeRule = g.compositeRule = h, o += " if (" + d + ") {   ";
      var y = y || [];
      y.push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", !1 !== e.opts.messages && (o += " , message: 'should NOT be valid' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
      var b = o;
      o = y.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + b + "]); " : o += " validate.errors = [" + b + "]; return false; " : o += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } else {  errors = " + p + "; if (vErrors !== null) { if (" + p + ") vErrors.length = " + p + "; else vErrors = null; } ", e.opts.allErrors && (o += " } ");
    } else o += "  var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", !1 !== e.opts.messages && (o += " , message: 'should NOT be valid' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l && (o += " if (false) { ");
    return o;
  },
  oneOf = function oneOf(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "valid" + n,
      g = "errs__" + n,
      d = e.util.copy(e),
      f = "";
    d.level++;
    var h = "valid" + d.level,
      y = d.baseId,
      b = "prevValid" + n,
      m = "passingSchemas" + n;
    o += "var " + g + " = errors , " + b + " = false , " + p + " = false , " + m + " = null; ";
    var _ = e.compositeRule;
    e.compositeRule = d.compositeRule = !0;
    var v = i;
    if (v) for (var E, S = -1, R = v.length - 1; S < R;) E = v[S += 1], (e.opts.strictKeywords ? "object" == typeof E && Object.keys(E).length > 0 || !1 === E : e.util.schemaHasRules(E, e.RULES.all)) ? (d.schema = E, d.schemaPath = s + "[" + S + "]", d.errSchemaPath = u + "/" + S, o += "  " + e.validate(d) + " ", d.baseId = y) : o += " var " + h + " = true; ", S && (o += " if (" + h + " && " + b + ") { " + p + " = false; " + m + " = [" + m + ", " + S + "]; } else { ", f += "}"), o += " if (" + h + ") { " + p + " = " + b + " = true; " + m + " = " + S + "; }";
    return e.compositeRule = d.compositeRule = _, o += f + "if (!" + p + ") {   var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { passingSchemas: " + m + " } ", !1 !== e.opts.messages && (o += " , message: 'should match exactly one schema in oneOf' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && l && (e.async ? o += " throw new ValidationError(vErrors); " : o += " validate.errors = vErrors; return false; "), o += "} else {  errors = " + g + "; if (vErrors !== null) { if (" + g + ") vErrors.length = " + g + "; else vErrors = null; }", e.opts.allErrors && (o += " } "), o;
  },
  pattern = function pattern(e, t, r) {
    var o,
      n = " ",
      a = e.level,
      i = e.dataLevel,
      s = e.schema[t],
      u = e.schemaPath + e.util.getProperty(t),
      l = e.errSchemaPath + "/" + t,
      c = !e.opts.allErrors,
      p = "data" + (i || ""),
      g = e.opts.$data && s && s.$data;
    g ? (n += " var schema" + a + " = " + e.util.getData(s.$data, i, e.dataPathArr) + "; ", o = "schema" + a) : o = s, n += "if ( ", g && (n += " (" + o + " !== undefined && typeof " + o + " != 'string') || "), n += " !" + (g ? "(new RegExp(" + o + "))" : e.usePattern(s)) + ".test(" + p + ") ) {   ";
    var d = d || [];
    d.push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { pattern:  ", n += g ? "" + o : "" + e.util.toQuotedString(s), n += "  } ", !1 !== e.opts.messages && (n += " , message: 'should match pattern \"", n += g ? "' + " + o + " + '" : "" + e.util.escapeQuotes(s), n += "\"' "), e.opts.verbose && (n += " , schema:  ", n += g ? "validate.schema" + u : "" + e.util.toQuotedString(s), n += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), n += " } ") : n += " {} ";
    var f = n;
    return n = d.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + f + "]); " : n += " validate.errors = [" + f + "]; return false; " : n += " var err = " + f + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
  },
  properties = function properties(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "errs__" + n,
      g = e.util.copy(e),
      d = "";
    g.level++;
    var f = "valid" + g.level,
      h = "key" + n,
      y = "idx" + n,
      b = g.dataLevel = e.dataLevel + 1,
      m = "data" + b,
      _ = "dataProperties" + n,
      v = Object.keys(i || {}).filter(F),
      E = e.schema.patternProperties || {},
      S = Object.keys(E).filter(F),
      R = e.schema.additionalProperties,
      w = v.length || S.length,
      T = !1 === R,
      P = "object" == typeof R && Object.keys(R).length,
      A = e.opts.removeAdditional,
      D = T || P || A,
      O = e.opts.ownProperties,
      I = e.baseId,
      C = e.schema.required;
    if (C && (!e.opts.$data || !C.$data) && C.length < e.opts.loopRequired) var B = e.util.toHash(C);
    function F(e) {
      return "__proto__" !== e;
    }
    if (o += "var " + p + " = errors;var " + f + " = true;", O && (o += " var " + _ + " = undefined;"), D) {
      if (o += O ? " " + _ + " = " + _ + " || Object.keys(" + c + "); for (var " + y + "=0; " + y + "<" + _ + ".length; " + y + "++) { var " + h + " = " + _ + "[" + y + "]; " : " for (var " + h + " in " + c + ") { ", w) {
        if (o += " var isAdditional" + n + " = !(false ", v.length) if (v.length > 8) o += " || validate.schema" + s + ".hasOwnProperty(" + h + ") ";else {
          var j = v;
          if (j) for (var N = -1, M = j.length - 1; N < M;) Y = j[N += 1], o += " || " + h + " == " + e.util.toQuotedString(Y) + " ";
        }
        if (S.length) {
          var x = S;
          if (x) for (var L = -1, U = x.length - 1; L < U;) ae = x[L += 1], o += " || " + e.usePattern(ae) + ".test(" + h + ") ";
        }
        o += " ); if (isAdditional" + n + ") { ";
      }
      if ("all" == A) o += " delete " + c + "[" + h + "]; ";else {
        var k = e.errorPath,
          q = "' + " + h + " + '";
        if (e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(e.errorPath, h, e.opts.jsonPointers)), T) {
          if (A) o += " delete " + c + "[" + h + "]; ";else {
            o += " " + f + " = false; ";
            var W = u;
            u = e.errSchemaPath + "/additionalProperties", (re = re || []).push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { additionalProperty: '" + q + "' } ", !1 !== e.opts.messages && (o += " , message: '", e.opts._errorDataPathProperty ? o += "is an invalid additional property" : o += "should NOT have additional properties", o += "' "), e.opts.verbose && (o += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
            var H = o;
            o = re.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + H + "]); " : o += " validate.errors = [" + H + "]; return false; " : o += " var err = " + H + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", u = W, l && (o += " break; ");
          }
        } else if (P) if ("failing" == A) {
          o += " var " + p + " = errors;  ";
          var G = e.compositeRule;
          e.compositeRule = g.compositeRule = !0, g.schema = R, g.schemaPath = e.schemaPath + ".additionalProperties", g.errSchemaPath = e.errSchemaPath + "/additionalProperties", g.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, h, e.opts.jsonPointers);
          var V = c + "[" + h + "]";
          g.dataPathArr[b] = h;
          var z = e.validate(g);
          g.baseId = I, e.util.varOccurences(z, m) < 2 ? o += " " + e.util.varReplace(z, m, V) + " " : o += " var " + m + " = " + V + "; " + z + " ", o += " if (!" + f + ") { errors = " + p + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + c + "[" + h + "]; }  ", e.compositeRule = g.compositeRule = G;
        } else {
          g.schema = R, g.schemaPath = e.schemaPath + ".additionalProperties", g.errSchemaPath = e.errSchemaPath + "/additionalProperties", g.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, h, e.opts.jsonPointers);
          V = c + "[" + h + "]";
          g.dataPathArr[b] = h;
          z = e.validate(g);
          g.baseId = I, e.util.varOccurences(z, m) < 2 ? o += " " + e.util.varReplace(z, m, V) + " " : o += " var " + m + " = " + V + "; " + z + " ", l && (o += " if (!" + f + ") break; ");
        }
        e.errorPath = k;
      }
      w && (o += " } "), o += " }  ", l && (o += " if (" + f + ") { ", d += "}");
    }
    var K = e.opts.useDefaults && !e.compositeRule;
    if (v.length) {
      var $ = v;
      if ($) for (var Y, Q = -1, X = $.length - 1; Q < X;) {
        var J = i[Y = $[Q += 1]];
        if (e.opts.strictKeywords ? "object" == typeof J && Object.keys(J).length > 0 || !1 === J : e.util.schemaHasRules(J, e.RULES.all)) {
          var Z = e.util.getProperty(Y),
            ee = (V = c + Z, K && void 0 !== J.default);
          g.schema = J, g.schemaPath = s + Z, g.errSchemaPath = u + "/" + e.util.escapeFragment(Y), g.errorPath = e.util.getPath(e.errorPath, Y, e.opts.jsonPointers), g.dataPathArr[b] = e.util.toQuotedString(Y);
          z = e.validate(g);
          if (g.baseId = I, e.util.varOccurences(z, m) < 2) {
            z = e.util.varReplace(z, m, V);
            var te = V;
          } else {
            te = m;
            o += " var " + m + " = " + V + "; ";
          }
          if (ee) o += " " + z + " ";else {
            if (B && B[Y]) {
              o += " if ( " + te + " === undefined ", O && (o += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(Y) + "') "), o += ") { " + f + " = false; ";
              k = e.errorPath, W = u;
              var re,
                oe = e.util.escapeQuotes(Y);
              e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(k, Y, e.opts.jsonPointers)), u = e.errSchemaPath + "/required", (re = re || []).push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + oe + "' } ", !1 !== e.opts.messages && (o += " , message: '", e.opts._errorDataPathProperty ? o += "is a required property" : o += "should have required property \\'" + oe + "\\'", o += "' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
              H = o;
              o = re.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + H + "]); " : o += " validate.errors = [" + H + "]; return false; " : o += " var err = " + H + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", u = W, e.errorPath = k, o += " } else { ";
            } else l ? (o += " if ( " + te + " === undefined ", O && (o += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(Y) + "') "), o += ") { " + f + " = true; } else { ") : (o += " if (" + te + " !== undefined ", O && (o += " &&   Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(Y) + "') "), o += " ) { ");
            o += " " + z + " } ";
          }
        }
        l && (o += " if (" + f + ") { ", d += "}");
      }
    }
    if (S.length) {
      var ne = S;
      if (ne) for (var ae, ie = -1, se = ne.length - 1; ie < se;) {
        J = E[ae = ne[ie += 1]];
        if (e.opts.strictKeywords ? "object" == typeof J && Object.keys(J).length > 0 || !1 === J : e.util.schemaHasRules(J, e.RULES.all)) {
          g.schema = J, g.schemaPath = e.schemaPath + ".patternProperties" + e.util.getProperty(ae), g.errSchemaPath = e.errSchemaPath + "/patternProperties/" + e.util.escapeFragment(ae), o += O ? " " + _ + " = " + _ + " || Object.keys(" + c + "); for (var " + y + "=0; " + y + "<" + _ + ".length; " + y + "++) { var " + h + " = " + _ + "[" + y + "]; " : " for (var " + h + " in " + c + ") { ", o += " if (" + e.usePattern(ae) + ".test(" + h + ")) { ", g.errorPath = e.util.getPathExpr(e.errorPath, h, e.opts.jsonPointers);
          V = c + "[" + h + "]";
          g.dataPathArr[b] = h;
          z = e.validate(g);
          g.baseId = I, e.util.varOccurences(z, m) < 2 ? o += " " + e.util.varReplace(z, m, V) + " " : o += " var " + m + " = " + V + "; " + z + " ", l && (o += " if (!" + f + ") break; "), o += " } ", l && (o += " else " + f + " = true; "), o += " }  ", l && (o += " if (" + f + ") { ", d += "}");
        }
      }
    }
    return l && (o += " " + d + " if (" + p + " == errors) {"), o;
  },
  propertyNames = function propertyNames(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "errs__" + n,
      g = e.util.copy(e);
    g.level++;
    var d = "valid" + g.level;
    if (o += "var " + p + " = errors;", e.opts.strictKeywords ? "object" == typeof i && Object.keys(i).length > 0 || !1 === i : e.util.schemaHasRules(i, e.RULES.all)) {
      g.schema = i, g.schemaPath = s, g.errSchemaPath = u;
      var f = "key" + n,
        h = "idx" + n,
        y = "i" + n,
        b = "' + " + f + " + '",
        m = "data" + (g.dataLevel = e.dataLevel + 1),
        _ = "dataProperties" + n,
        v = e.opts.ownProperties,
        E = e.baseId;
      v && (o += " var " + _ + " = undefined; "), o += v ? " " + _ + " = " + _ + " || Object.keys(" + c + "); for (var " + h + "=0; " + h + "<" + _ + ".length; " + h + "++) { var " + f + " = " + _ + "[" + h + "]; " : " for (var " + f + " in " + c + ") { ", o += " var startErrs" + n + " = errors; ";
      var S = f,
        R = e.compositeRule;
      e.compositeRule = g.compositeRule = !0;
      var w = e.validate(g);
      g.baseId = E, e.util.varOccurences(w, m) < 2 ? o += " " + e.util.varReplace(w, m, S) + " " : o += " var " + m + " = " + S + "; " + w + " ", e.compositeRule = g.compositeRule = R, o += " if (!" + d + ") { for (var " + y + "=startErrs" + n + "; " + y + "<errors; " + y + "++) { vErrors[" + y + "].propertyName = " + f + "; }   var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { propertyName: '" + b + "' } ", !1 !== e.opts.messages && (o += " , message: 'property name \\'" + b + "\\' is invalid' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && l && (e.async ? o += " throw new ValidationError(vErrors); " : o += " validate.errors = vErrors; return false; "), l && (o += " break; "), o += " } }";
    }
    return l && (o += "  if (" + p + " == errors) {"), o;
  },
  required = function required(e, t, r) {
    var o = " ",
      n = e.level,
      a = e.dataLevel,
      i = e.schema[t],
      s = e.schemaPath + e.util.getProperty(t),
      u = e.errSchemaPath + "/" + t,
      l = !e.opts.allErrors,
      c = "data" + (a || ""),
      p = "valid" + n,
      g = e.opts.$data && i && i.$data;
    g && (o += " var schema" + n + " = " + e.util.getData(i.$data, a, e.dataPathArr) + "; ");
    var d = "schema" + n;
    if (!g) if (i.length < e.opts.loopRequired && e.schema.properties && Object.keys(e.schema.properties).length) {
      var f = [],
        h = i;
      if (h) for (var y, b = -1, m = h.length - 1; b < m;) {
        y = h[b += 1];
        var _ = e.schema.properties[y];
        _ && (e.opts.strictKeywords ? "object" == typeof _ && Object.keys(_).length > 0 || !1 === _ : e.util.schemaHasRules(_, e.RULES.all)) || (f[f.length] = y);
      }
    } else f = i;
    if (g || f.length) {
      var v = e.errorPath,
        E = g || f.length >= e.opts.loopRequired,
        S = e.opts.ownProperties;
      if (l) {
        if (o += " var missing" + n + "; ", E) {
          g || (o += " var " + d + " = validate.schema" + s + "; ");
          var R = "' + " + (O = "schema" + n + "[" + (P = "i" + n) + "]") + " + '";
          e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(v, O, e.opts.jsonPointers)), o += " var " + p + " = true; ", g && (o += " if (schema" + n + " === undefined) " + p + " = true; else if (!Array.isArray(schema" + n + ")) " + p + " = false; else {"), o += " for (var " + P + " = 0; " + P + " < " + d + ".length; " + P + "++) { " + p + " = " + c + "[" + d + "[" + P + "]] !== undefined ", S && (o += " &&   Object.prototype.hasOwnProperty.call(" + c + ", " + d + "[" + P + "]) "), o += "; if (!" + p + ") break; } ", g && (o += "  }  "), o += "  if (!" + p + ") {   ", (D = D || []).push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + R + "' } ", !1 !== e.opts.messages && (o += " , message: '", e.opts._errorDataPathProperty ? o += "is a required property" : o += "should have required property \\'" + R + "\\'", o += "' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
          var w = o;
          o = D.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + w + "]); " : o += " validate.errors = [" + w + "]; return false; " : o += " var err = " + w + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } else { ";
        } else {
          o += " if ( ";
          var T = f;
          if (T) for (var P = -1, A = T.length - 1; P < A;) {
            C = T[P += 1], P && (o += " || "), o += " ( ( " + (N = c + (j = e.util.getProperty(C))) + " === undefined ", S && (o += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(C) + "') "), o += ") && (missing" + n + " = " + e.util.toQuotedString(e.opts.jsonPointers ? C : j) + ") ) ";
          }
          o += ") {  ";
          var D;
          R = "' + " + (O = "missing" + n) + " + '";
          e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(v, O, !0) : v + " + " + O), (D = D || []).push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + R + "' } ", !1 !== e.opts.messages && (o += " , message: '", e.opts._errorDataPathProperty ? o += "is a required property" : o += "should have required property \\'" + R + "\\'", o += "' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ";
          w = o;
          o = D.pop(), !e.compositeRule && l ? e.async ? o += " throw new ValidationError([" + w + "]); " : o += " validate.errors = [" + w + "]; return false; " : o += " var err = " + w + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } else { ";
        }
      } else if (E) {
        g || (o += " var " + d + " = validate.schema" + s + "; ");
        var O;
        R = "' + " + (O = "schema" + n + "[" + (P = "i" + n) + "]") + " + '";
        e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(v, O, e.opts.jsonPointers)), g && (o += " if (" + d + " && !Array.isArray(" + d + ")) {  var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + R + "' } ", !1 !== e.opts.messages && (o += " , message: '", e.opts._errorDataPathProperty ? o += "is a required property" : o += "should have required property \\'" + R + "\\'", o += "' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + d + " !== undefined) { "), o += " for (var " + P + " = 0; " + P + " < " + d + ".length; " + P + "++) { if (" + c + "[" + d + "[" + P + "]] === undefined ", S && (o += " || ! Object.prototype.hasOwnProperty.call(" + c + ", " + d + "[" + P + "]) "), o += ") {  var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + R + "' } ", !1 !== e.opts.messages && (o += " , message: '", e.opts._errorDataPathProperty ? o += "is a required property" : o += "should have required property \\'" + R + "\\'", o += "' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", g && (o += "  }  ");
      } else {
        var I = f;
        if (I) for (var C, B = -1, F = I.length - 1; B < F;) {
          C = I[B += 1];
          var j = e.util.getProperty(C),
            N = (R = e.util.escapeQuotes(C), c + j);
          e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(v, C, e.opts.jsonPointers)), o += " if ( " + N + " === undefined ", S && (o += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(C) + "') "), o += ") {  var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + R + "' } ", !1 !== e.opts.messages && (o += " , message: '", e.opts._errorDataPathProperty ? o += "is a required property" : o += "should have required property \\'" + R + "\\'", o += "' "), e.opts.verbose && (o += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
        }
      }
      e.errorPath = v;
    } else l && (o += " if (true) {");
    return o;
  },
  uniqueItems = function uniqueItems(e, t, r) {
    var o,
      n = " ",
      a = e.level,
      i = e.dataLevel,
      s = e.schema[t],
      u = e.schemaPath + e.util.getProperty(t),
      l = e.errSchemaPath + "/" + t,
      c = !e.opts.allErrors,
      p = "data" + (i || ""),
      g = "valid" + a,
      d = e.opts.$data && s && s.$data;
    if (d ? (n += " var schema" + a + " = " + e.util.getData(s.$data, i, e.dataPathArr) + "; ", o = "schema" + a) : o = s, (s || d) && !1 !== e.opts.uniqueItems) {
      d && (n += " var " + g + "; if (" + o + " === false || " + o + " === undefined) " + g + " = true; else if (typeof " + o + " != 'boolean') " + g + " = false; else { "), n += " var i = " + p + ".length , " + g + " = true , j; if (i > 1) { ";
      var f = e.schema.items && e.schema.items.type,
        h = Array.isArray(f);
      if (!f || "object" == f || "array" == f || h && (f.indexOf("object") >= 0 || f.indexOf("array") >= 0)) n += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + p + "[i], " + p + "[j])) { " + g + " = false; break outer; } } } ";else {
        n += " var itemIndices = {}, item; for (;i--;) { var item = " + p + "[i]; ";
        var y = "checkDataType" + (h ? "s" : "");
        n += " if (" + e.util[y](f, "item", e.opts.strictNumbers, !0) + ") continue; ", h && (n += " if (typeof item == 'string') item = '\"' + item; "), n += " if (typeof itemIndices[item] == 'number') { " + g + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
      }
      n += " } ", d && (n += "  }  "), n += " if (!" + g + ") {   ";
      var b = b || [];
      b.push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { i: i, j: j } ", !1 !== e.opts.messages && (n += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e.opts.verbose && (n += " , schema:  ", n += d ? "validate.schema" + u : "" + s, n += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), n += " } ") : n += " {} ";
      var m = n;
      n = b.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + m + "]); " : n += " validate.errors = [" + m + "]; return false; " : n += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } ", c && (n += " else { ");
    } else c && (n += " if (true) { ");
    return n;
  },
  dotjs = {
    $ref: ref,
    allOf: allOf,
    anyOf: anyOf,
    $comment: comment,
    const: _const,
    contains: contains,
    dependencies: dependencies,
    enum: _enum,
    format: format,
    if: _if,
    items: items,
    maximum: _limit,
    minimum: _limit,
    maxItems: _limitItems,
    minItems: _limitItems,
    maxLength: _limitLength,
    minLength: _limitLength,
    maxProperties: _limitProperties,
    minProperties: _limitProperties,
    multipleOf: multipleOf,
    not: not,
    oneOf: oneOf,
    pattern: pattern,
    properties: properties,
    propertyNames: propertyNames,
    required: required,
    uniqueItems: uniqueItems,
    validate: validate$1
  },
  toHash$1 = util.toHash,
  rules = function rules() {
    var e = [{
        type: "number",
        rules: [{
          maximum: ["exclusiveMaximum"]
        }, {
          minimum: ["exclusiveMinimum"]
        }, "multipleOf", "format"]
      }, {
        type: "string",
        rules: ["maxLength", "minLength", "pattern", "format"]
      }, {
        type: "array",
        rules: ["maxItems", "minItems", "items", "contains", "uniqueItems"]
      }, {
        type: "object",
        rules: ["maxProperties", "minProperties", "required", "dependencies", "propertyNames", {
          properties: ["additionalProperties", "patternProperties"]
        }]
      }, {
        rules: ["$ref", "const", "enum", "not", "anyOf", "oneOf", "allOf", "if"]
      }],
      t = ["type", "$comment"];
    return e.all = toHash$1(t), e.types = toHash$1(["number", "integer", "string", "array", "object", "boolean", "null"]), e.forEach(function (r) {
      r.rules = r.rules.map(function (r) {
        var o;
        if ("object" == typeof r) {
          var n = Object.keys(r)[0];
          o = r[n], r = n, o.forEach(function (r) {
            t.push(r), e.all[r] = !0;
          });
        }
        return t.push(r), e.all[r] = {
          keyword: r,
          code: dotjs[r],
          implements: o
        };
      }), e.all.$comment = {
        keyword: "$comment",
        code: dotjs.$comment
      }, r.type && (e.types[r.type] = r);
    }), e.keywords = toHash$1(t.concat(["$schema", "$id", "id", "$data", "$async", "title", "description", "default", "definitions", "examples", "readOnly", "writeOnly", "contentMediaType", "contentEncoding", "additionalItems", "then", "else"])), e.custom = {}, e;
  },
  KEYWORDS = ["multipleOf", "maximum", "exclusiveMaximum", "minimum", "exclusiveMinimum", "maxLength", "minLength", "pattern", "additionalItems", "maxItems", "minItems", "uniqueItems", "maxProperties", "minProperties", "required", "additionalProperties", "enum", "format", "const"],
  data = function data(e, t) {
    for (var r = 0; r < t.length; r++) {
      e = JSON.parse(JSON.stringify(e));
      var o,
        n = t[r].split("/"),
        a = e;
      for (o = 1; o < n.length; o++) a = a[n[o]];
      for (o = 0; o < KEYWORDS.length; o++) {
        var i = KEYWORDS[o],
          s = a[i];
        s && (a[i] = {
          anyOf: [s, {
            $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
          }]
        });
      }
    }
    return e;
  },
  MissingRefError$1 = error_classes.MissingRef,
  async = compileAsync;
function compileAsync(e, t, r) {
  var o = this;
  if ("function" != typeof this._opts.loadSchema) throw new Error("options.loadSchema should be a function");
  "function" == typeof t && (r = t, t = void 0);
  var n = a(e).then(function () {
    var r = o._addSchema(e, void 0, t);
    return r.validate || i(r);
  });
  return r && n.then(function (e) {
    r(null, e);
  }, r), n;
  function a(e) {
    var t = e.$schema;
    return t && !o.getSchema(t) ? compileAsync.call(o, {
      $ref: t
    }, !0) : Promise.resolve();
  }
  function i(e) {
    try {
      return o._compile(e);
    } catch (r) {
      if (r instanceof MissingRefError$1) return function (r) {
        var n = r.missingSchema;
        if (l(n)) throw new Error("Schema " + n + " is loaded but " + r.missingRef + " cannot be resolved");
        var s = o._loadingSchemas[n];
        s || (s = o._loadingSchemas[n] = o._opts.loadSchema(n)).then(u, u);
        return s.then(function (e) {
          if (!l(n)) return a(e).then(function () {
            l(n) || o.addSchema(e, n, void 0, t);
          });
        }).then(function () {
          return i(e);
        });
        function u() {
          delete o._loadingSchemas[n];
        }
        function l(e) {
          return o._refs[e] || o._schemas[e];
        }
      }(r);
      throw r;
    }
  }
}
var custom = function custom(e, t, r) {
    var o,
      n,
      a = " ",
      i = e.level,
      s = e.dataLevel,
      u = e.schema[t],
      l = e.schemaPath + e.util.getProperty(t),
      c = e.errSchemaPath + "/" + t,
      p = !e.opts.allErrors,
      g = "data" + (s || ""),
      d = "valid" + i,
      f = "errs__" + i,
      h = e.opts.$data && u && u.$data;
    h ? (a += " var schema" + i + " = " + e.util.getData(u.$data, s, e.dataPathArr) + "; ", n = "schema" + i) : n = u;
    var y,
      b,
      m,
      _,
      v,
      E = this,
      S = "definition" + i,
      R = E.definition,
      w = "";
    if (h && R.$data) {
      v = "keywordValidate" + i;
      var T = R.validateSchema;
      a += " var " + S + " = RULES.custom['" + t + "'].definition; var " + v + " = " + S + ".validate;";
    } else {
      if (!(_ = e.useCustomRule(E, u, e.schema, e))) return;
      n = "validate.schema" + l, v = _.code, y = R.compile, b = R.inline, m = R.macro;
    }
    var P = v + ".errors",
      A = "i" + i,
      D = "ruleErr" + i,
      O = R.async;
    if (O && !e.async) throw new Error("async keyword in sync schema");
    if (b || m || (a += P + " = null;"), a += "var " + f + " = errors;var " + d + ";", h && R.$data && (w += "}", a += " if (" + n + " === undefined) { " + d + " = true; } else { ", T && (w += "}", a += " " + d + " = " + S + ".validateSchema(" + n + "); if (" + d + ") { ")), b) R.statements ? a += " " + _.validate + " " : a += " " + d + " = " + _.validate + "; ";else if (m) {
      var I = e.util.copy(e);
      w = "";
      I.level++;
      var C = "valid" + I.level;
      I.schema = _.validate, I.schemaPath = "";
      var B = e.compositeRule;
      e.compositeRule = I.compositeRule = !0;
      var F = e.validate(I).replace(/validate\.schema/g, v);
      e.compositeRule = I.compositeRule = B, a += " " + F;
    } else {
      (x = x || []).push(a), a = "", a += "  " + v + ".call( ", e.opts.passContext ? a += "this" : a += "self", y || !1 === R.schema ? a += " , " + g + " " : a += " , " + n + " , " + g + " , validate.schema" + e.schemaPath + " ", a += " , (dataPath || '')", '""' != e.errorPath && (a += " + " + e.errorPath);
      var j = s ? "data" + (s - 1 || "") : "parentData",
        N = s ? e.dataPathArr[s] : "parentDataProperty",
        M = a += " , " + j + " , " + N + " , rootData )  ";
      a = x.pop(), !1 === R.errors ? (a += " " + d + " = ", O && (a += "await "), a += M + "; ") : a += O ? " var " + (P = "customErrors" + i) + " = null; try { " + d + " = await " + M + "; } catch (e) { " + d + " = false; if (e instanceof ValidationError) " + P + " = e.errors; else throw e; } " : " " + P + " = null; " + d + " = " + M + "; ";
    }
    if (R.modifying && (a += " if (" + j + ") " + g + " = " + j + "[" + N + "];"), a += "" + w, R.valid) p && (a += " if (true) { ");else {
      var x;
      a += " if ( ", void 0 === R.valid ? (a += " !", a += m ? "" + C : "" + d) : a += " " + !R.valid + " ", a += ") { ", o = E.keyword, (x = x || []).push(a), a = "", (x = x || []).push(a), a = "", !1 !== e.createErrors ? (a += " { keyword: '" + (o || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { keyword: '" + E.keyword + "' } ", !1 !== e.opts.messages && (a += " , message: 'should pass \"" + E.keyword + "\" keyword validation' "), e.opts.verbose && (a += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), a += " } ") : a += " {} ";
      var L = a;
      a = x.pop(), !e.compositeRule && p ? e.async ? a += " throw new ValidationError([" + L + "]); " : a += " validate.errors = [" + L + "]; return false; " : a += " var err = " + L + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      var U = a;
      a = x.pop(), b ? R.errors ? "full" != R.errors && (a += "  for (var " + A + "=" + f + "; " + A + "<errors; " + A + "++) { var " + D + " = vErrors[" + A + "]; if (" + D + ".dataPath === undefined) " + D + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + D + ".schemaPath === undefined) { " + D + '.schemaPath = "' + c + '"; } ', e.opts.verbose && (a += " " + D + ".schema = " + n + "; " + D + ".data = " + g + "; "), a += " } ") : !1 === R.errors ? a += " " + U + " " : (a += " if (" + f + " == errors) { " + U + " } else {  for (var " + A + "=" + f + "; " + A + "<errors; " + A + "++) { var " + D + " = vErrors[" + A + "]; if (" + D + ".dataPath === undefined) " + D + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + D + ".schemaPath === undefined) { " + D + '.schemaPath = "' + c + '"; } ', e.opts.verbose && (a += " " + D + ".schema = " + n + "; " + D + ".data = " + g + "; "), a += " } } ") : m ? (a += "   var err =   ", !1 !== e.createErrors ? (a += " { keyword: '" + (o || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { keyword: '" + E.keyword + "' } ", !1 !== e.opts.messages && (a += " , message: 'should pass \"" + E.keyword + "\" keyword validation' "), e.opts.verbose && (a += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), a += " } ") : a += " {} ", a += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && p && (e.async ? a += " throw new ValidationError(vErrors); " : a += " validate.errors = vErrors; return false; ")) : !1 === R.errors ? a += " " + U + " " : (a += " if (Array.isArray(" + P + ")) { if (vErrors === null) vErrors = " + P + "; else vErrors = vErrors.concat(" + P + "); errors = vErrors.length;  for (var " + A + "=" + f + "; " + A + "<errors; " + A + "++) { var " + D + " = vErrors[" + A + "]; if (" + D + ".dataPath === undefined) " + D + ".dataPath = (dataPath || '') + " + e.errorPath + ";  " + D + '.schemaPath = "' + c + '";  ', e.opts.verbose && (a += " " + D + ".schema = " + n + "; " + D + ".data = " + g + "; "), a += " } } else { " + U + " } "), a += " } ", p && (a += " else { ");
    }
    return a;
  },
  $schema = "http://json-schema.org/draft-07/schema#",
  $id = "http://json-schema.org/draft-07/schema#",
  title = "Core schema meta-schema",
  definitions = {
    schemaArray: {
      type: "array",
      minItems: 1,
      items: {
        $ref: "#"
      }
    },
    nonNegativeInteger: {
      type: "integer",
      minimum: 0
    },
    nonNegativeIntegerDefault0: {
      allOf: [{
        $ref: "#/definitions/nonNegativeInteger"
      }, {
        default: 0
      }]
    },
    simpleTypes: {
      enum: ["array", "boolean", "integer", "null", "number", "object", "string"]
    },
    stringArray: {
      type: "array",
      items: {
        type: "string"
      },
      uniqueItems: !0,
      default: []
    }
  },
  type = ["object", "boolean"],
  properties$1 = {
    $id: {
      type: "string",
      format: "uri-reference"
    },
    $schema: {
      type: "string",
      format: "uri"
    },
    $ref: {
      type: "string",
      format: "uri-reference"
    },
    $comment: {
      type: "string"
    },
    title: {
      type: "string"
    },
    description: {
      type: "string"
    },
    default: !0,
    readOnly: {
      type: "boolean",
      default: !1
    },
    examples: {
      type: "array",
      items: !0
    },
    multipleOf: {
      type: "number",
      exclusiveMinimum: 0
    },
    maximum: {
      type: "number"
    },
    exclusiveMaximum: {
      type: "number"
    },
    minimum: {
      type: "number"
    },
    exclusiveMinimum: {
      type: "number"
    },
    maxLength: {
      $ref: "#/definitions/nonNegativeInteger"
    },
    minLength: {
      $ref: "#/definitions/nonNegativeIntegerDefault0"
    },
    pattern: {
      type: "string",
      format: "regex"
    },
    additionalItems: {
      $ref: "#"
    },
    items: {
      anyOf: [{
        $ref: "#"
      }, {
        $ref: "#/definitions/schemaArray"
      }],
      default: !0
    },
    maxItems: {
      $ref: "#/definitions/nonNegativeInteger"
    },
    minItems: {
      $ref: "#/definitions/nonNegativeIntegerDefault0"
    },
    uniqueItems: {
      type: "boolean",
      default: !1
    },
    contains: {
      $ref: "#"
    },
    maxProperties: {
      $ref: "#/definitions/nonNegativeInteger"
    },
    minProperties: {
      $ref: "#/definitions/nonNegativeIntegerDefault0"
    },
    required: {
      $ref: "#/definitions/stringArray"
    },
    additionalProperties: {
      $ref: "#"
    },
    definitions: {
      type: "object",
      additionalProperties: {
        $ref: "#"
      },
      default: {}
    },
    properties: {
      type: "object",
      additionalProperties: {
        $ref: "#"
      },
      default: {}
    },
    patternProperties: {
      type: "object",
      additionalProperties: {
        $ref: "#"
      },
      propertyNames: {
        format: "regex"
      },
      default: {}
    },
    dependencies: {
      type: "object",
      additionalProperties: {
        anyOf: [{
          $ref: "#"
        }, {
          $ref: "#/definitions/stringArray"
        }]
      }
    },
    propertyNames: {
      $ref: "#"
    },
    const: !0,
    enum: {
      type: "array",
      items: !0,
      minItems: 1,
      uniqueItems: !0
    },
    type: {
      anyOf: [{
        $ref: "#/definitions/simpleTypes"
      }, {
        type: "array",
        items: {
          $ref: "#/definitions/simpleTypes"
        },
        minItems: 1,
        uniqueItems: !0
      }]
    },
    format: {
      type: "string"
    },
    contentMediaType: {
      type: "string"
    },
    contentEncoding: {
      type: "string"
    },
    if: {
      $ref: "#"
    },
    then: {
      $ref: "#"
    },
    else: {
      $ref: "#"
    },
    allOf: {
      $ref: "#/definitions/schemaArray"
    },
    anyOf: {
      $ref: "#/definitions/schemaArray"
    },
    oneOf: {
      $ref: "#/definitions/schemaArray"
    },
    not: {
      $ref: "#"
    }
  },
  require$$2 = {
    $schema: $schema,
    $id: $id,
    title: title,
    definitions: definitions,
    type: type,
    properties: properties$1,
    default: !0
  },
  definition_schema = {
    $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
    definitions: {
      simpleTypes: require$$2.definitions.simpleTypes
    },
    type: "object",
    dependencies: {
      schema: ["validate"],
      $data: ["validate"],
      statements: ["inline"],
      valid: {
        not: {
          required: ["macro"]
        }
      }
    },
    properties: {
      type: require$$2.properties.type,
      schema: {
        type: "boolean"
      },
      statements: {
        type: "boolean"
      },
      dependencies: {
        type: "array",
        items: {
          type: "string"
        }
      },
      metaSchema: {
        type: "object"
      },
      modifying: {
        type: "boolean"
      },
      valid: {
        type: "boolean"
      },
      $data: {
        type: "boolean"
      },
      async: {
        type: "boolean"
      },
      errors: {
        anyOf: [{
          type: "boolean"
        }, {
          const: "full"
        }]
      }
    }
  },
  IDENTIFIER$1 = /^[a-z_$][a-z0-9_$-]*$/i,
  keyword = {
    add: addKeyword,
    get: getKeyword,
    remove: removeKeyword,
    validate: validateKeyword
  };
function addKeyword(e, t) {
  var r = this.RULES;
  if (r.keywords[e]) throw new Error("Keyword " + e + " is already defined");
  if (!IDENTIFIER$1.test(e)) throw new Error("Keyword " + e + " is not a valid identifier");
  if (t) {
    this.validateKeyword(t, !0);
    var o = t.type;
    if (Array.isArray(o)) for (var n = 0; n < o.length; n++) i(e, o[n], t);else i(e, o, t);
    var a = t.metaSchema;
    a && (t.$data && this._opts.$data && (a = {
      anyOf: [a, {
        $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
      }]
    }), t.validateSchema = this.compile(a, !0));
  }
  function i(e, t, o) {
    for (var n, a = 0; a < r.length; a++) {
      var i = r[a];
      if (i.type == t) {
        n = i;
        break;
      }
    }
    n || (n = {
      type: t,
      rules: []
    }, r.push(n));
    var s = {
      keyword: e,
      definition: o,
      custom: !0,
      code: custom,
      implements: o.implements
    };
    n.rules.push(s), r.custom[e] = s;
  }
  return r.keywords[e] = r.all[e] = !0, this;
}
function getKeyword(e) {
  var t = this.RULES.custom[e];
  return t ? t.definition : this.RULES.keywords[e] || !1;
}
function removeKeyword(e) {
  var t = this.RULES;
  delete t.keywords[e], delete t.all[e], delete t.custom[e];
  for (var r = 0; r < t.length; r++) for (var o = t[r].rules, n = 0; n < o.length; n++) if (o[n].keyword == e) {
    o.splice(n, 1);
    break;
  }
  return this;
}
function validateKeyword(e, t) {
  validateKeyword.errors = null;
  var r = this._validateKeyword = this._validateKeyword || this.compile(definition_schema, !0);
  if (r(e)) return !0;
  if (validateKeyword.errors = r.errors, t) throw new Error("custom keyword definition is invalid: " + this.errorsText(r.errors));
  return !1;
}
var $schema$1 = "http://json-schema.org/draft-07/schema#",
  $id$1 = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
  description = "Meta-schema for $data reference (JSON Schema extension proposal)",
  type$1 = "object",
  required$1 = ["$data"],
  properties$2 = {
    $data: {
      type: "string",
      anyOf: [{
        format: "relative-json-pointer"
      }, {
        format: "json-pointer"
      }]
    }
  },
  additionalProperties = !1,
  require$$1 = {
    $schema: $schema$1,
    $id: $id$1,
    description: description,
    type: type$1,
    required: required$1,
    properties: properties$2,
    additionalProperties: additionalProperties
  },
  ajv = Ajv;
Ajv.prototype.validate = validate$2, Ajv.prototype.compile = compile$1, Ajv.prototype.addSchema = addSchema, Ajv.prototype.addMetaSchema = addMetaSchema, Ajv.prototype.validateSchema = validateSchema, Ajv.prototype.getSchema = getSchema, Ajv.prototype.removeSchema = removeSchema, Ajv.prototype.addFormat = addFormat, Ajv.prototype.errorsText = errorsText, Ajv.prototype._addSchema = _addSchema, Ajv.prototype._compile = _compile, Ajv.prototype.compileAsync = async, Ajv.prototype.addKeyword = keyword.add, Ajv.prototype.getKeyword = keyword.get, Ajv.prototype.removeKeyword = keyword.remove, Ajv.prototype.validateKeyword = keyword.validate, Ajv.ValidationError = error_classes.Validation, Ajv.MissingRefError = error_classes.MissingRef, Ajv.$dataMetaSchema = data;
var META_SCHEMA_ID = "http://json-schema.org/draft-07/schema",
  META_IGNORE_OPTIONS = ["removeAdditional", "useDefaults", "coerceTypes", "strictDefaults"],
  META_SUPPORT_DATA = ["/properties"];
function Ajv(e) {
  if (!(this instanceof Ajv)) return new Ajv(e);
  e = this._opts = util.copy(e) || {}, setLogger(this), this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = formats_1(e.format), this._cache = e.cache || new cache(), this._loadingSchemas = {}, this._compilations = [], this.RULES = rules(), this._getId = chooseGetId(e), e.loopRequired = e.loopRequired || 1 / 0, "property" == e.errorDataPath && (e._errorDataPathProperty = !0), void 0 === e.serialize && (e.serialize = fastJsonStableStringify), this._metaOpts = getMetaSchemaOptions(this), e.formats && addInitialFormats(this), e.keywords && addInitialKeywords(this), addDefaultMetaSchema(this), "object" == typeof e.meta && this.addMetaSchema(e.meta), e.nullable && this.addKeyword("nullable", {
    metaSchema: {
      type: "boolean"
    }
  }), addInitialSchemas(this);
}
function validate$2(e, t) {
  var r;
  if ("string" == typeof e) {
    if (!(r = this.getSchema(e))) throw new Error('no schema with key or ref "' + e + '"');
  } else {
    var o = this._addSchema(e);
    r = o.validate || this._compile(o);
  }
  var n = r(t);
  return !0 !== r.$async && (this.errors = r.errors), n;
}
function compile$1(e, t) {
  var r = this._addSchema(e, void 0, t);
  return r.validate || this._compile(r);
}
function addSchema(e, t, r, o) {
  if (Array.isArray(e)) {
    for (var n = 0; n < e.length; n++) this.addSchema(e[n], void 0, r, o);
    return this;
  }
  var a = this._getId(e);
  if (void 0 !== a && "string" != typeof a) throw new Error("schema id must be string");
  return checkUnique(this, t = resolve_1.normalizeId(t || a)), this._schemas[t] = this._addSchema(e, r, o, !0), this;
}
function addMetaSchema(e, t, r) {
  return this.addSchema(e, t, r, !0), this;
}
function validateSchema(e, t) {
  var r = e.$schema;
  if (void 0 !== r && "string" != typeof r) throw new Error("$schema must be a string");
  if (!(r = r || this._opts.defaultMeta || defaultMeta(this))) return this.logger.warn("meta-schema not available"), this.errors = null, !0;
  var o = this.validate(r, e);
  if (!o && t) {
    var n = "schema is invalid: " + this.errorsText();
    if ("log" != this._opts.validateSchema) throw new Error(n);
    this.logger.error(n);
  }
  return o;
}
function defaultMeta(e) {
  var t = e._opts.meta;
  return e._opts.defaultMeta = "object" == typeof t ? e._getId(t) || t : e.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : void 0, e._opts.defaultMeta;
}
function getSchema(e) {
  var t = _getSchemaObj(this, e);
  switch (typeof t) {
    case "object":
      return t.validate || this._compile(t);
    case "string":
      return this.getSchema(t);
    case "undefined":
      return _getSchemaFragment(this, e);
  }
}
function _getSchemaFragment(e, t) {
  var r = resolve_1.schema.call(e, {
    schema: {}
  }, t);
  if (r) {
    var o = r.schema,
      n = r.root,
      a = r.baseId,
      i = compile_1.call(e, o, n, void 0, a);
    return e._fragments[t] = new schema_obj({
      ref: t,
      fragment: !0,
      schema: o,
      root: n,
      baseId: a,
      validate: i
    }), i;
  }
}
function _getSchemaObj(e, t) {
  return t = resolve_1.normalizeId(t), e._schemas[t] || e._refs[t] || e._fragments[t];
}
function removeSchema(e) {
  if (e instanceof RegExp) return _removeAllSchemas(this, this._schemas, e), _removeAllSchemas(this, this._refs, e), this;
  switch (typeof e) {
    case "undefined":
      return _removeAllSchemas(this, this._schemas), _removeAllSchemas(this, this._refs), this._cache.clear(), this;
    case "string":
      var t = _getSchemaObj(this, e);
      return t && this._cache.del(t.cacheKey), delete this._schemas[e], delete this._refs[e], this;
    case "object":
      var r = this._opts.serialize,
        o = r ? r(e) : e;
      this._cache.del(o);
      var n = this._getId(e);
      n && (n = resolve_1.normalizeId(n), delete this._schemas[n], delete this._refs[n]);
  }
  return this;
}
function _removeAllSchemas(e, t, r) {
  for (var o in t) {
    var n = t[o];
    n.meta || r && !r.test(o) || (e._cache.del(n.cacheKey), delete t[o]);
  }
}
function _addSchema(e, t, r, o) {
  if ("object" != typeof e && "boolean" != typeof e) throw new Error("schema should be object or boolean");
  var n = this._opts.serialize,
    a = n ? n(e) : e,
    i = this._cache.get(a);
  if (i) return i;
  o = o || !1 !== this._opts.addUsedSchema;
  var s = resolve_1.normalizeId(this._getId(e));
  s && o && checkUnique(this, s);
  var u,
    l = !1 !== this._opts.validateSchema && !t;
  l && !(u = s && s == resolve_1.normalizeId(e.$schema)) && this.validateSchema(e, !0);
  var c = resolve_1.ids.call(this, e),
    p = new schema_obj({
      id: s,
      schema: e,
      localRefs: c,
      cacheKey: a,
      meta: r
    });
  return "#" != s[0] && o && (this._refs[s] = p), this._cache.put(a, p), l && u && this.validateSchema(e, !0), p;
}
function _compile(e, t) {
  if (e.compiling) return e.validate = n, n.schema = e.schema, n.errors = null, n.root = t || n, !0 === e.schema.$async && (n.$async = !0), n;
  var r, o;
  e.compiling = !0, e.meta && (r = this._opts, this._opts = this._metaOpts);
  try {
    o = compile_1.call(this, e.schema, t, e.localRefs);
  } catch (t) {
    throw delete e.validate, t;
  } finally {
    e.compiling = !1, e.meta && (this._opts = r);
  }
  return e.validate = o, e.refs = o.refs, e.refVal = o.refVal, e.root = o.root, o;
  function n() {
    var t = e.validate,
      r = t.apply(this, arguments);
    return n.errors = t.errors, r;
  }
}
function chooseGetId(e) {
  switch (e.schemaId) {
    case "auto":
      return _get$IdOrId;
    case "id":
      return _getId;
    default:
      return _get$Id;
  }
}
function _getId(e) {
  return e.$id && this.logger.warn("schema $id ignored", e.$id), e.id;
}
function _get$Id(e) {
  return e.id && this.logger.warn("schema id ignored", e.id), e.$id;
}
function _get$IdOrId(e) {
  if (e.$id && e.id && e.$id != e.id) throw new Error("schema $id is different from id");
  return e.$id || e.id;
}
function errorsText(e, t) {
  if (!(e = e || this.errors)) return "No errors";
  for (var r = void 0 === (t = t || {}).separator ? ", " : t.separator, o = void 0 === t.dataVar ? "data" : t.dataVar, n = "", a = 0; a < e.length; a++) {
    var i = e[a];
    i && (n += o + i.dataPath + " " + i.message + r);
  }
  return n.slice(0, -r.length);
}
function addFormat(e, t) {
  return "string" == typeof t && (t = new RegExp(t)), this._formats[e] = t, this;
}
function addDefaultMetaSchema(e) {
  var t;
  if (e._opts.$data && (t = require$$1, e.addMetaSchema(t, t.$id, !0)), !1 !== e._opts.meta) {
    var r = require$$2;
    e._opts.$data && (r = data(r, META_SUPPORT_DATA)), e.addMetaSchema(r, META_SCHEMA_ID, !0), e._refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
  }
}
function addInitialSchemas(e) {
  var t = e._opts.schemas;
  if (t) if (Array.isArray(t)) e.addSchema(t);else for (var r in t) e.addSchema(t[r], r);
}
function addInitialFormats(e) {
  for (var t in e._opts.formats) {
    var r = e._opts.formats[t];
    e.addFormat(t, r);
  }
}
function addInitialKeywords(e) {
  for (var t in e._opts.keywords) {
    var r = e._opts.keywords[t];
    e.addKeyword(t, r);
  }
}
function checkUnique(e, t) {
  if (e._schemas[t] || e._refs[t]) throw new Error('schema with key or id "' + t + '" already exists');
}
function getMetaSchemaOptions(e) {
  for (var t = util.copy(e._opts), r = 0; r < META_IGNORE_OPTIONS.length; r++) delete t[META_IGNORE_OPTIONS[r]];
  return t;
}
function setLogger(e) {
  var t = e._opts.logger;
  if (!1 === t) e.logger = {
    log: noop$1,
    warn: noop$1,
    error: noop$1
  };else {
    if (void 0 === t && (t = console), !("object" == typeof t && t.log && t.warn && t.error)) throw new Error("logger must implement log, warn and error methods");
    e.logger = t;
  }
}
function noop$1() {}
var SchemasTableName = "_schemas",
  defaultSchema = {
    properties: {
      _id: {
        type: "string"
      }
    }
  };
function createSchemaMiddleware(e) {
  return Object.assign(Object.assign({}, e), {
    table: function table(t) {
      var r = e.table(t);
      return t.startsWith("_") ? r : Object.assign(Object.assign({}, r), {
        mutate: function mutate(o) {
          var n;
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
            var a, i, s, _e17;
            return _regeneratorRuntime().wrap(function _callee24$(_context26) {
              while (1) switch (_context26.prev = _context26.next) {
                case 0:
                  _context26.next = 2;
                  return e.table(SchemasTableName).get({
                    key: t,
                    trans: o.trans
                  });
                case 2:
                  a = _context26.sent;
                  i = null !== (n = null == a ? void 0 : a.schema) && void 0 !== n ? n : defaultSchema;
                  s = new ajv({
                    useDefaults: !0
                  }).compile(i);
                  _context26.prev = 5;
                  switch (o.type) {
                    case "add":
                    case "put":
                      _e17 = Dexie.deepClone(o.values);
                      _e17.forEach(function (e) {
                        if (!1 === s(e) && s.errors) throw new ajv.ValidationError(s.errors);
                      }), o = Object.assign(Object.assign({}, o), {
                        values: _e17
                      });
                  }
                  _context26.next = 12;
                  break;
                case 9:
                  _context26.prev = 9;
                  _context26.t0 = _context26["catch"](5);
                  throw _context26.t0;
                case 12:
                  return _context26.abrupt("return", r.mutate(o));
                case 13:
                case "end":
                  return _context26.stop();
              }
            }, _callee24, null, [[5, 9]]);
          }));
        }
      });
    }
  });
}
var schemaMiddleware = {
  stack: "dbcore",
  name: "SchemaMiddleware",
  create: createSchemaMiddleware
};
function schemaAddon(e) {
  e.use(schemaMiddleware);
  var t = initOverrideCreateTransaction(e, SchemasTableName);
  e._createTransaction = Dexie.override(e._createTransaction, t);
  var r = initOverrideParseStoreSpec(_defineProperty({}, SchemasTableName, "&name"));
  e.Version.prototype._parseStoresSpec = Dexie.override(e.Version.prototype._parseStoresSpec, r), e.Table.prototype.setSchema = function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSchema;
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
      return _regeneratorRuntime().wrap(function _callee25$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            _context27.next = 2;
            return this.db.table(SchemasTableName).put({
              name: this.name,
              schema: e
            });
          case 2:
          case "end":
            return _context27.stop();
        }
      }, _callee25, this);
    }));
  }, e.Table.prototype.getSchema = function () {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
      var e, t;
      return _regeneratorRuntime().wrap(function _callee26$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            _context28.next = 2;
            return this.db.table(SchemasTableName).get({
              name: this.name
            });
          case 2:
            e = _context28.sent;
            t = null == e ? void 0 : e.schema;
            return _context28.abrupt("return", void 0 === t || 0 === Object.keys(t).length && t.constructor === Object ? defaultSchema : t);
          case 5:
          case "end":
            return _context28.stop();
        }
      }, _callee26, this);
    }));
  };
}
function createUlidMiddleware(e) {
  return Object.assign(Object.assign({}, e), {
    table: function table(t) {
      var r = e.table(t);
      return t.startsWith("_") ? r : Object.assign(Object.assign({}, r), {
        mutate: function mutate(e) {
          return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
            var _t11;
            return _regeneratorRuntime().wrap(function _callee27$(_context29) {
              while (1) switch (_context29.prev = _context29.next) {
                case 0:
                  switch (e.type) {
                    case "add":
                    case "put":
                      _t11 = r.schema.primaryKey;
                      "_id" === _t11.keyPath && _t11.autoIncrement && e.values.forEach(function (e) {
                        return e._id = e._id || ulid();
                      });
                  }
                  _context29.next = 3;
                  return r.mutate(e);
                case 3:
                  return _context29.abrupt("return", _context29.sent);
                case 4:
                case "end":
                  return _context29.stop();
              }
            }, _callee27);
          }));
        }
      });
    }
  });
}
var ulidMiddleware = {
  stack: "dbcore",
  name: "UlidMiddleware",
  create: createUlidMiddleware
};
var indexedDB, IDBKeyRange;
if (indexeddbshim_min instanceof Function) {
  var _e18 = indexeddbshim_min({}, {
    checkOrigin: !1
  });
  indexedDB = _e18.indexedDB, IDBKeyRange = _e18.IDBKeyRange;
}
function NewDexie(e) {
  var t = {
    addons: [].concat(_toConsumableArray(Dexie.addons), [changesAddon, schemaAddon])
  };
  indexedDB && (t.indexedDB = indexedDB), IDBKeyRange && (t.IDBKeyRange = IDBKeyRange);
  var r = new Dexie(e, t);
  return r.use(ulidMiddleware), r.on("versionchange", function () {
    return r.close(), r.open().then(function () {
      console.log("Database reloaded with updated version");
    }).catch(function (e) {
      throw console.log("Failed to reload database with updated version"), e;
    }), !1;
  }), r;
}
function nameFromKeyPath$1(e) {
  return "string" == typeof e ? e : e ? "[" + [].join.call(e, "+") + "]" : "";
}
function createIndexString(_ref4) {
  var e = _ref4.path,
    t = _ref4.unique,
    r = _ref4.multi,
    o = _ref4.auto;
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  return (t && !n ? "&" : "") + (r ? "*" : "") + (o ? "++" : "") + nameFromKeyPath$1(e);
}
var Database = /*#__PURE__*/function () {
  function Database(e) {
    var _this6 = this;
    _classCallCheck(this, Database);
    for (var _len9 = arguments.length, t = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
      t[_key9 - 1] = arguments[_key9];
    }
    this.collectionMap = new Map(), this.pendingSchemas = [], this.dexie = NewDexie(e), this.remote = new Remote(this.dexie), t.forEach(function (e) {
      return _this6.pendingSchemas.push(e);
    });
  }
  _createClass(Database, [{
    key: "id",
    get: function get() {
      return this.remote.id;
    }
  }, {
    key: "open",
    value: function open() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var _t12, _e19, _iterator6, _step6, _e20, _t13;
        return _regeneratorRuntime().wrap(function _callee28$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              if (this.dexie.isOpen()) {
                _context30.next = 27;
                break;
              }
              _t12 = [];
              if (this.pendingSchemas.length) {
                _e19 = this.pendingSchemas.map(function (e) {
                  var t;
                  var r = [{
                    path: "_id",
                    uuid: !1,
                    auto: !0
                  }].concat(_toConsumableArray(null !== (t = e.indexes) && void 0 !== t ? t : [])).map(function (e) {
                    return createIndexString(e);
                  }).join(",");
                  return [e.name, r];
                });
                _t12 = Object.fromEntries(_e19);
              }
              this.dexie.version(e).stores(_t12);
              _context30.next = 6;
              return this.dexie.open();
            case 6:
              _iterator6 = _createForOfIteratorHelper(this.pendingSchemas);
              _context30.prev = 7;
              _iterator6.s();
            case 9:
              if ((_step6 = _iterator6.n()).done) {
                _context30.next = 18;
                break;
              }
              _e20 = _step6.value;
              if (this.collectionMap.has(_e20.name)) {
                _context30.next = 16;
                break;
              }
              _t13 = this.dexie.table(_e20.name);
              _context30.next = 15;
              return _t13.setSchema(_e20.schema);
            case 15:
              this.collectionMap.set(_e20.name, new Collection(_t13));
            case 16:
              _context30.next = 9;
              break;
            case 18:
              _context30.next = 23;
              break;
            case 20:
              _context30.prev = 20;
              _context30.t0 = _context30["catch"](7);
              _iterator6.e(_context30.t0);
            case 23:
              _context30.prev = 23;
              _iterator6.f();
              return _context30.finish(23);
            case 26:
              this.pendingSchemas = [];
            case 27:
              return _context30.abrupt("return", this);
            case 28:
            case "end":
              return _context30.stop();
          }
        }, _callee28, this, [[7, 20, 23, 26]]);
      }));
    }
  }, {
    key: "close",
    value: function close() {
      return this.dexie.close();
    }
  }, {
    key: "delete",
    value: function _delete() {
      return this.dexie.delete();
    }
  }, {
    key: "verno",
    get: function get() {
      return this.dexie.verno;
    }
  }, {
    key: "collectionConfig",
    value: function collectionConfig(e) {
      return this.pendingSchemas.push(e), this;
    }
  }, {
    key: "collection",
    value: function collection(e) {
      var t = this.collectionMap.get(e);
      if (void 0 !== t) return t;
      var r = this.dexie.table(e);
      return t = new Collection(r), this.collectionMap.set(e, t), t;
    }
  }, {
    key: "collections",
    value: function collections() {
      var e = this.dexie.tables.filter(function (e) {
        return !e.name.startsWith("_");
      });
      var _iterator7 = _createForOfIteratorHelper(e),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _t14 = _step7.value;
          this.collectionMap.has(_t14.name) || this.collectionMap.set(_t14.name, new Collection(_t14));
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return this.collectionMap;
    }
  }]);
  return Database;
}();
export { Collection, Database, Remote };